/*!
 * ripe-commons-pluginus v0.9.12
 * (c) 2010-2021 Platforme
 * https://github.com/ripe-tech/ripe-commons-pluginus#readme
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["vue"], factory);
	else if(typeof exports === 'object')
		exports["RipeCommonsPluginus"] = factory(require("vue"));
	else
		root["RipeCommonsPluginus"] = factory(root["vue"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__15__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 253);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(257);


/***/ }),
/* 1 */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _capability__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _capability__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _plugin__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(161);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _plugin__WEBPACK_IMPORTED_MODULE_1__["a"]; });




/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(258);

var iterableToArrayLimit = __webpack_require__(259);

var unsupportedIterableToArray = __webpack_require__(165);

var nonIterableRest = __webpack_require__(260);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(255);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(20)["default"];

var assertThisInitialized = __webpack_require__(256);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(263);

var auth = __webpack_require__(264);

var base = __webpack_require__(16);

var compat = __webpack_require__(167);

var errors = __webpack_require__(265);

var interactable = __webpack_require__(266);

var logic = __webpack_require__(267);

var config = __webpack_require__(269);

var mobile = __webpack_require__(270);

var observable = __webpack_require__(168);

var ripe = __webpack_require__(27);

var struct = __webpack_require__(271);

var utils = __webpack_require__(272);

Object.assign(module.exports, api);
Object.assign(module.exports, auth);
Object.assign(module.exports, base);
Object.assign(module.exports, compat);
Object.assign(module.exports, errors);
Object.assign(module.exports, interactable);
Object.assign(module.exports, logic);
Object.assign(module.exports, config);
Object.assign(module.exports, mobile);
Object.assign(module.exports, observable);
Object.assign(module.exports, ripe);
Object.assign(module.exports, struct);
Object.assign(module.exports, utils);

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "installMixins", function() { return install; });
/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71);
/* harmony import */ var _logic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73);
/* harmony import */ var _device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "deviceMixin", function() { return _device__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(213);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "localeMixin", function() { return _locale__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "loggingMixin", function() { return _logging__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "logicMixin", function() { return _logic__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _modal__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(214);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "modalMixin", function() { return _modal__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _part__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(215);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "partMixin", function() { return _part__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "utilsMixin", function() { return _utils__WEBPACK_IMPORTED_MODULE_2__["a"]; });












var install = function install(Vue) {
  Vue.mixin(_logging__WEBPACK_IMPORTED_MODULE_0__[/* loggingMixin */ "a"]);
  Vue.mixin(_logic__WEBPACK_IMPORTED_MODULE_1__[/* logicMixin */ "a"]);
  Vue.mixin(_utils__WEBPACK_IMPORTED_MODULE_2__[/* utilsMixin */ "a"]);
};


/* harmony default export */ __webpack_exports__["default"] = (install);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var superPropBase = __webpack_require__(254);

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

/** @namespace */
// eslint-disable-next-line no-use-before-define,no-var
var ripe = typeof ripe === "undefined" ? {} : ripe;

if (true) {
  module.exports = {
    ripe: ripe
  };
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "A", function() { return _components__WEBPACK_IMPORTED_MODULE_0__; });
/* harmony import */ var _filters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "C", function() { return _filters__WEBPACK_IMPORTED_MODULE_1__; });
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "M", function() { return _mixins__WEBPACK_IMPORTED_MODULE_2__; });
/* harmony import */ var _plugins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "R", function() { return _plugins__WEBPACK_IMPORTED_MODULE_3__; });
/* harmony import */ var _plugin__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return _plugin__WEBPACK_IMPORTED_MODULE_4__; });
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Alert"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Ask"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Button"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["ButtonPlatforme"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["ComponentPlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Configurator"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Global"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Icon"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Image"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["InitialsImages"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["InitialsInputs"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Keyboard"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Loader"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Modal"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Personalization"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Pickers"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "s", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["RestrictionsAlert"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "t", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Size"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "u", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Tab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "v", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Tabs"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "w", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Thumbnail"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "x", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["Thumbnails"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "y", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["ThumbnailsGroups"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "G", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["install"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "P", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["personalizationForm"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "W", function() { return _components__WEBPACK_IMPORTED_MODULE_0__["sizeForm"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _filters__WEBPACK_IMPORTED_MODULE_1__["Money"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "S", function() { return _filters__WEBPACK_IMPORTED_MODULE_1__["readable"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "B", function() { return _mixins__WEBPACK_IMPORTED_MODULE_2__["deviceMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "H", function() { return _mixins__WEBPACK_IMPORTED_MODULE_2__["installMixins"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "I", function() { return _mixins__WEBPACK_IMPORTED_MODULE_2__["localeMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "K", function() { return _mixins__WEBPACK_IMPORTED_MODULE_2__["loggingMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "L", function() { return _mixins__WEBPACK_IMPORTED_MODULE_2__["logicMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "N", function() { return _mixins__WEBPACK_IMPORTED_MODULE_2__["modalMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "O", function() { return _mixins__WEBPACK_IMPORTED_MODULE_2__["partMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return _mixins__WEBPACK_IMPORTED_MODULE_2__["utilsMixin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _plugin__WEBPACK_IMPORTED_MODULE_4__["Plugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "E", function() { return _plugin__WEBPACK_IMPORTED_MODULE_4__["getPlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "F", function() { return _plugin__WEBPACK_IMPORTED_MODULE_4__["hasPlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "T", function() { return _plugin__WEBPACK_IMPORTED_MODULE_4__["registerPlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return _plugin__WEBPACK_IMPORTED_MODULE_4__["unregisterPlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "z", function() { return _plugins__WEBPACK_IMPORTED_MODULE_3__["busPlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "J", function() { return _plugins__WEBPACK_IMPORTED_MODULE_3__["localePlugin"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "U", function() { return _plugins__WEBPACK_IMPORTED_MODULE_3__["ripePlugin"]; });

/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(245);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "X", function() { return _store__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(246);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "D", function() { return _utils__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "V", function() { return _utils__WEBPACK_IMPORTED_MODULE_6__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ab", function() { return _utils__WEBPACK_IMPORTED_MODULE_6__["c"]; });















/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _data__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(158);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _data__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(159);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _device__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _logging__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(162);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _logging__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _logging__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _logging__WEBPACK_IMPORTED_MODULE_2__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _logging__WEBPACK_IMPORTED_MODULE_2__["d"]; });

/* harmony import */ var _ripe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(163);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _ripe__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _url_changer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(164);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _url_changer__WEBPACK_IMPORTED_MODULE_4__["a"]; });







/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(261);

var base = __webpack_require__(9);

var locales = __webpack_require__(169);

var plugins = __webpack_require__(289);

var visual = __webpack_require__(293);

Object.assign(module.exports, api);
Object.assign(module.exports, base);
Object.assign(module.exports, locales);
Object.assign(module.exports, plugins);
Object.assign(module.exports, visual);
module.exports.VERSION = base.ripe.VERSION;
module.exports.Ripe = base.ripe.Ripe;
module.exports.RipeBase = base.ripe.RipeBase;
module.exports.RipeAPI = base.ripe.RipeAPI;

/***/ }),
/* 20 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitialsImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InitialsInputs; });
/* harmony import */ var _personalization_form__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _personalization_form__WEBPACK_IMPORTED_MODULE_0__; });
/* harmony import */ var _size_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(184);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _size_form__WEBPACK_IMPORTED_MODULE_1__; });



var install = function install(Vue) {
  Vue.component("initials-images", _personalization_form__WEBPACK_IMPORTED_MODULE_0__["InitialsImages"]);
  Vue.component("initials-inputs", _personalization_form__WEBPACK_IMPORTED_MODULE_0__["InitialsInputs"]);
};

var InitialsImages = _personalization_form__WEBPACK_IMPORTED_MODULE_0__["InitialsImages"];
var InitialsInputs = _personalization_form__WEBPACK_IMPORTED_MODULE_0__["InitialsInputs"];

/* harmony default export */ __webpack_exports__["c"] = (install);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return registerPlugins; });
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18);
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24);
/* harmony import */ var _ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _abstract__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "k", function() { return _abstract__WEBPACK_IMPORTED_MODULE_3__["b"]; });

/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(189);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "j", function() { return _base__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _locale__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _locale__WEBPACK_IMPORTED_MODULE_1__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _locale__WEBPACK_IMPORTED_MODULE_1__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _locale__WEBPACK_IMPORTED_MODULE_1__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _locale__WEBPACK_IMPORTED_MODULE_1__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _ui__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _ui__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _util__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "l", function() { return _util__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "m", function() { return _util__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "n", function() { return _util__WEBPACK_IMPORTED_MODULE_0__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "o", function() { return _util__WEBPACK_IMPORTED_MODULE_0__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "p", function() { return _util__WEBPACK_IMPORTED_MODULE_0__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "q", function() { return _util__WEBPACK_IMPORTED_MODULE_0__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "r", function() { return _util__WEBPACK_IMPORTED_MODULE_0__["h"]; });









var registerPlugins = function registerPlugins(owner) {
  _locale__WEBPACK_IMPORTED_MODULE_1__[/* DomLocaleLoaderPlugin */ "a"].register(owner);
  _locale__WEBPACK_IMPORTED_MODULE_1__[/* FileLocaleLoaderPlugin */ "b"].register(owner);
  _locale__WEBPACK_IMPORTED_MODULE_1__[/* LocalePlugin */ "c"].register(owner);
  _locale__WEBPACK_IMPORTED_MODULE_1__[/* ModelLocaleLoaderPlugin */ "d"].register(owner);
  _locale__WEBPACK_IMPORTED_MODULE_1__[/* ModelLocaleResolverPlugin */ "e"].register(owner);
  _ui__WEBPACK_IMPORTED_MODULE_2__[/* BasePersonalizationPlugin */ "a"].register(owner);
  _ui__WEBPACK_IMPORTED_MODULE_2__[/* BaseSizePlugin */ "b"].register(owner);
  _util__WEBPACK_IMPORTED_MODULE_0__[/* DevicePlugin */ "a"].register(owner);
  _util__WEBPACK_IMPORTED_MODULE_0__[/* UrlChangerPlugin */ "c"].register(owner);
};

/***/ }),
/* 23 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(171);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _locale__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _dom_locale_loader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(172);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _dom_locale_loader__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _file_locale_loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(173);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _file_locale_loader__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _model_locale_loader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(174);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _model_locale_loader__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _model_locale_resolver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(175);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _model_locale_resolver__WEBPACK_IMPORTED_MODULE_4__["a"]; });







/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Pluginus 0.3.10.
 *
 * Copyright (c) 2008-2020 Hive Solutions Lda.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function (global, factory) {
   true ? factory(exports) :
  undefined;
}(this, (function (exports) { 'use strict';

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it;

    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function () {};

        return {
          s: F,
          n: function () {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function () {
        it = o[Symbol.iterator]();
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  var Capability = /*#__PURE__*/function () {
    function Capability(name, properties) {
      _classCallCheck(this, Capability);

      this.name = name;
      this.properties = properties || {};
    }

    _createClass(Capability, [{
      key: "getName",
      value: function getName() {
        return this.name;
      }
    }, {
      key: "getProperties",
      value: function getProperties() {
        return this.properties;
      }
    }], [{
      key: "new",
      value: function _new(name, properties) {
        return new this(name, properties);
      }
    }]);

    return Capability;
  }();

  var Mutex = /*#__PURE__*/function () {
    function Mutex() {
      _classCallCheck(this, Mutex);

      this.acquired = false;
      this.callbacks = [];
      this.promises = [];
    }

    _createClass(Mutex, [{
      key: "acquire",
      value: function () {
        var _acquire = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _this = this;

          var promise;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!this.acquired) {
                    _context.next = 7;
                    break;
                  }

                  promise = new Promise(function (resolve, reject) {
                    _this.callbacks.push([resolve, reject]);
                  });
                  this.promises.push(promise);
                  _context.next = 5;
                  return promise;

                case 5:
                  _context.next = 8;
                  break;

                case 7:
                  this.acquired = true;

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function acquire() {
          return _acquire.apply(this, arguments);
        }

        return acquire;
      }()
    }, {
      key: "release",
      value: function () {
        var _release = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _this2 = this;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(this.promises.length === 0)) {
                    _context2.next = 3;
                    break;
                  }

                  this.acquired = false;
                  return _context2.abrupt("return");

                case 3:
                  setTimeout(function () {
                    var resolve = _this2.callbacks.shift()[0];

                    _this2.promises.shift();

                    resolve();
                  });

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function release() {
          return _release.apply(this, arguments);
        }

        return release;
      }()
    }]);

    return Mutex;
  }();

  var Observable = /*#__PURE__*/function () {
    function Observable() {
      _classCallCheck(this, Observable);

      this.callbacks = {};
    }

    _createClass(Observable, [{
      key: "bind",
      value: function bind(event, callback) {
        var callbacks = this.callbacks[event] || [];
        callbacks.push(callback);
        this.callbacks[event] = callbacks;
        return callback;
      }
    }, {
      key: "unbind",
      value: function unbind(event, callback) {
        var callbacks = this.callbacks[event] || [];

        if (!callback) {
          delete this.callbacks[event];
          return;
        }

        var index = callbacks.indexOf(callback);

        if (index === -1) {
          return;
        }

        callbacks.splice(index, 1);
        this.callbacks[event] = callbacks;
      }
    }, {
      key: "trigger",
      value: function trigger(event) {
        var callbacks = this.callbacks[event] || [];
        var results = [];

        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        var _iterator = _createForOfIteratorHelper(callbacks),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var callback = _step.value;
            var result = callback.apply(this, args);

            if (result !== undefined && result !== null) {
              results.push(result);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        return Promise.all(results);
      }
    }]);

    return Observable;
  }();

  var version = "0.3.10";

  var PluginManager = /*#__PURE__*/function (_Observable) {
    _inherits(PluginManager, _Observable);

    var _super = _createSuper(PluginManager);

    function PluginManager(capabilities) {
      var _this;

      _classCallCheck(this, PluginManager);

      _this = _super.call(this);
      _this.version = version;
      _this.plugins = [];
      _this.pluginsName = {};
      _this.pluginsClass = {};
      _this.pluginsCapability = {};
      _this.capabilities = capabilities || ["start"];
      _this.stateMutex = new Mutex();
      return _this;
    }

    _createClass(PluginManager, [{
      key: "load",
      value: function () {
        var _load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var _iterator, _step, capability;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _iterator = _createForOfIteratorHelper(this.capabilities);
                  _context.prev = 1;

                  _iterator.s();

                case 3:
                  if ((_step = _iterator.n()).done) {
                    _context.next = 9;
                    break;
                  }

                  capability = _step.value;
                  _context.next = 7;
                  return this.getPluginsByCapability(capability, {
                    persist: false
                  });

                case 7:
                  _context.next = 3;
                  break;

                case 9:
                  _context.next = 14;
                  break;

                case 11:
                  _context.prev = 11;
                  _context.t0 = _context["catch"](1);

                  _iterator.e(_context.t0);

                case 14:
                  _context.prev = 14;

                  _iterator.f();

                  return _context.finish(14);

                case 17:
                  _context.next = 19;
                  return this.restoreState();

                case 19:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[1, 11, 14, 17]]);
        }));

        function load() {
          return _load.apply(this, arguments);
        }

        return load;
      }()
    }, {
      key: "unload",
      value: function () {
        var _unload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _iterator2, _step2, pluginInstance;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _iterator2 = _createForOfIteratorHelper(this.plugins);
                  _context2.prev = 1;

                  _iterator2.s();

                case 3:
                  if ((_step2 = _iterator2.n()).done) {
                    _context2.next = 11;
                    break;
                  }

                  pluginInstance = _step2.value;

                  if (pluginInstance.isLoaded()) {
                    _context2.next = 7;
                    break;
                  }

                  return _context2.abrupt("continue", 9);

                case 7:
                  _context2.next = 9;
                  return this.unloadPlugin(pluginInstance, false);

                case 9:
                  _context2.next = 3;
                  break;

                case 11:
                  _context2.next = 16;
                  break;

                case 13:
                  _context2.prev = 13;
                  _context2.t0 = _context2["catch"](1);

                  _iterator2.e(_context2.t0);

                case 16:
                  _context2.prev = 16;

                  _iterator2.f();

                  return _context2.finish(16);

                case 19:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[1, 13, 16, 19]]);
        }));

        function unload() {
          return _unload.apply(this, arguments);
        }

        return unload;
      }()
    }, {
      key: "registerPlugin",
      value: function registerPlugin(pluginClass) {
        // casts the plugin class with the proper case and
        // then creates the instance with the current manager
        // as the context argument to it
        var PluginClass = pluginClass;
        var pluginInstance = new PluginClass(this); // runs a simple "patch" operation for the plugin instances
        // that for some reason did not set the "mandatory" owner
        // field in the newly created instance

        if (pluginInstance.owner === undefined) pluginInstance.owner = this; // adds the newly crated plugin instance to the list
        // of plugins currently registered in the manager

        this.plugins.push(pluginInstance);
        this.pluginsName[pluginInstance.constructor.name] = pluginInstance;
        this.pluginsName[pluginInstance.getName()] = pluginInstance;
        this.pluginsClass[pluginClass] = pluginInstance; // iterates over the complete set of plugin's capabilities
        // to register it for all of its capabilities

        var _iterator3 = _createForOfIteratorHelper(pluginInstance.getCapabilities()),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var capability = _step3.value;
            var plugins = this.pluginsCapability[capability.name] || [];
            plugins.push(pluginInstance);
            this.pluginsCapability[capability.name] = plugins;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }, {
      key: "loadPlugin",
      value: function () {
        var _loadPlugin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(pluginInstance) {
          var persist,
              _args3 = arguments;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  persist = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;

                  if (!pluginInstance.isLoaded()) {
                    _context3.next = 3;
                    break;
                  }

                  return _context3.abrupt("return");

                case 3:
                  pluginInstance.ensureOwner();
                  _context3.next = 6;
                  return pluginInstance.triggerAll("before-load");

                case 6:
                  _context3.next = 8;
                  return pluginInstance.load();

                case 8:
                  _context3.next = 10;
                  return pluginInstance.triggerAll("loaded");

                case 10:
                  _context3.next = 12;
                  return pluginInstance.triggerAll("after-load");

                case 12:
                  if (persist) this.addState(pluginInstance.getName());

                case 13:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function loadPlugin(_x) {
          return _loadPlugin.apply(this, arguments);
        }

        return loadPlugin;
      }()
    }, {
      key: "unloadPlugin",
      value: function () {
        var _unloadPlugin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(pluginInstance) {
          var persist,
              _args4 = arguments;
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  persist = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : true;

                  if (pluginInstance.isLoaded()) {
                    _context4.next = 3;
                    break;
                  }

                  return _context4.abrupt("return");

                case 3:
                  pluginInstance.ensureOwner();
                  _context4.next = 6;
                  return pluginInstance.triggerAll("before-unload");

                case 6:
                  _context4.next = 8;
                  return pluginInstance.unload();

                case 8:
                  _context4.next = 10;
                  return pluginInstance.triggerAll("unloaded");

                case 10:
                  _context4.next = 12;
                  return pluginInstance.triggerAll("after-unload");

                case 12:
                  this.persistState();
                  if (persist) this.removeState(pluginInstance.getName());

                case 14:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function unloadPlugin(_x2) {
          return _unloadPlugin.apply(this, arguments);
        }

        return unloadPlugin;
      }()
    }, {
      key: "ensurePluginLoaded",
      value: function () {
        var _ensurePluginLoaded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(pluginInstance) {
          var persist,
              _args5 = arguments;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  persist = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;
                  _context5.next = 3;
                  return this.loadPlugin(pluginInstance, persist);

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function ensurePluginLoaded(_x3) {
          return _ensurePluginLoaded.apply(this, arguments);
        }

        return ensurePluginLoaded;
      }()
    }, {
      key: "ensurePluginsLoaded",
      value: function () {
        var _ensurePluginsLoaded = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(pluginInstances) {
          var persist,
              _iterator4,
              _step4,
              pluginInstance,
              _args6 = arguments;

          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  persist = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : true;
                  _iterator4 = _createForOfIteratorHelper(pluginInstances);
                  _context6.prev = 2;

                  _iterator4.s();

                case 4:
                  if ((_step4 = _iterator4.n()).done) {
                    _context6.next = 10;
                    break;
                  }

                  pluginInstance = _step4.value;
                  _context6.next = 8;
                  return this.ensurePluginLoaded(pluginInstance, persist);

                case 8:
                  _context6.next = 4;
                  break;

                case 10:
                  _context6.next = 15;
                  break;

                case 12:
                  _context6.prev = 12;
                  _context6.t0 = _context6["catch"](2);

                  _iterator4.e(_context6.t0);

                case 15:
                  _context6.prev = 15;

                  _iterator4.f();

                  return _context6.finish(15);

                case 18:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this, [[2, 12, 15, 18]]);
        }));

        function ensurePluginsLoaded(_x4) {
          return _ensurePluginsLoaded.apply(this, arguments);
        }

        return ensurePluginsLoaded;
      }()
    }, {
      key: "getPluginByName",
      value: function () {
        var _getPluginByName = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(name, options) {
          var load, persist, pluginInstance;
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  options = options || {};
                  load = options.load === undefined ? true : options.load;
                  persist = options.persist === undefined ? true : options.persist;
                  pluginInstance = this.pluginsName[name];

                  if (pluginInstance) {
                    _context7.next = 6;
                    break;
                  }

                  return _context7.abrupt("return", null);

                case 6:
                  if (!load) {
                    _context7.next = 9;
                    break;
                  }

                  _context7.next = 9;
                  return this.ensurePluginLoaded(pluginInstance, persist);

                case 9:
                  return _context7.abrupt("return", pluginInstance);

                case 10:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function getPluginByName(_x5, _x6) {
          return _getPluginByName.apply(this, arguments);
        }

        return getPluginByName;
      }()
    }, {
      key: "getPluginByCapability",
      value: function () {
        var _getPluginByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(name, options) {
          var pluginInstances;
          return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return this.getPluginsByCapability(name, options);

                case 2:
                  pluginInstances = _context8.sent;
                  return _context8.abrupt("return", pluginInstances.length ? pluginInstances[0] : null);

                case 4:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function getPluginByCapability(_x7, _x8) {
          return _getPluginByCapability.apply(this, arguments);
        }

        return getPluginByCapability;
      }()
    }, {
      key: "getPluginsByCapability",
      value: function () {
        var _getPluginsByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(capability, options) {
          var load, persist, pluginInstances;
          return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  options = options || {};
                  load = options.load === undefined ? true : options.load;
                  persist = options.persist === undefined ? true : options.persist;
                  pluginInstances = this.pluginsCapability[capability] || [];

                  if (!load) {
                    _context9.next = 7;
                    break;
                  }

                  _context9.next = 7;
                  return this.ensurePluginsLoaded(pluginInstances, persist);

                case 7:
                  return _context9.abrupt("return", pluginInstances);

                case 8:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));

        function getPluginsByCapability(_x9, _x10) {
          return _getPluginsByCapability.apply(this, arguments);
        }

        return getPluginsByCapability;
      }()
    }, {
      key: "bindLoadedByCapability",
      value: function () {
        var _bindLoadedByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(capability, callback) {
          var plugins, _iterator5, _step5, plugin;

          return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return this.getPluginsByCapability(capability, {
                    load: false
                  });

                case 2:
                  plugins = _context10.sent;
                  _iterator5 = _createForOfIteratorHelper(plugins);
                  _context10.prev = 4;

                  _iterator5.s();

                case 6:
                  if ((_step5 = _iterator5.n()).done) {
                    _context10.next = 14;
                    break;
                  }

                  plugin = _step5.value;

                  if (plugin.isLoaded()) {
                    _context10.next = 10;
                    break;
                  }

                  return _context10.abrupt("continue", 12);

                case 10:
                  _context10.next = 12;
                  return callback(plugin);

                case 12:
                  _context10.next = 6;
                  break;

                case 14:
                  _context10.next = 19;
                  break;

                case 16:
                  _context10.prev = 16;
                  _context10.t0 = _context10["catch"](4);

                  _iterator5.e(_context10.t0);

                case 19:
                  _context10.prev = 19;

                  _iterator5.f();

                  return _context10.finish(19);

                case 22:
                  this.bind("capability:".concat(capability, ":loaded"), callback);

                case 23:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this, [[4, 16, 19, 22]]);
        }));

        function bindLoadedByCapability(_x11, _x12) {
          return _bindLoadedByCapability.apply(this, arguments);
        }

        return bindLoadedByCapability;
      }()
    }, {
      key: "unbindLoadedByCapability",
      value: function () {
        var _unbindLoadedByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(capability, callback) {
          return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  this.unbind("capability:".concat(capability, ":loaded"), callback);

                case 1:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));

        function unbindLoadedByCapability(_x13, _x14) {
          return _unbindLoadedByCapability.apply(this, arguments);
        }

        return unbindLoadedByCapability;
      }()
    }, {
      key: "bindUnloadedByCapability",
      value: function () {
        var _bindUnloadedByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(capability, callback) {
          var plugins, _iterator6, _step6, plugin;

          return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.next = 2;
                  return this.getPluginsByCapability(capability, {
                    load: false
                  });

                case 2:
                  plugins = _context12.sent;
                  _iterator6 = _createForOfIteratorHelper(plugins);
                  _context12.prev = 4;

                  _iterator6.s();

                case 6:
                  if ((_step6 = _iterator6.n()).done) {
                    _context12.next = 14;
                    break;
                  }

                  plugin = _step6.value;

                  if (!plugin.isLoaded()) {
                    _context12.next = 10;
                    break;
                  }

                  return _context12.abrupt("continue", 12);

                case 10:
                  _context12.next = 12;
                  return callback(plugin);

                case 12:
                  _context12.next = 6;
                  break;

                case 14:
                  _context12.next = 19;
                  break;

                case 16:
                  _context12.prev = 16;
                  _context12.t0 = _context12["catch"](4);

                  _iterator6.e(_context12.t0);

                case 19:
                  _context12.prev = 19;

                  _iterator6.f();

                  return _context12.finish(19);

                case 22:
                  this.bind("capability:".concat(capability, ":unloaded"), callback);

                case 23:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, this, [[4, 16, 19, 22]]);
        }));

        function bindUnloadedByCapability(_x15, _x16) {
          return _bindUnloadedByCapability.apply(this, arguments);
        }

        return bindUnloadedByCapability;
      }()
    }, {
      key: "unbindUnloadedByCapability",
      value: function () {
        var _unbindUnloadedByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(capability, callback) {
          return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  this.unbind("capability:".concat(capability, ":unloaded"), callback);

                case 1:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));

        function unbindUnloadedByCapability(_x17, _x18) {
          return _unbindUnloadedByCapability.apply(this, arguments);
        }

        return unbindUnloadedByCapability;
      }()
    }, {
      key: "addState",
      value: function () {
        var _addState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(name) {
          var loadedNames;
          return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context14.next = 2;
                    break;
                  }

                  return _context14.abrupt("return");

                case 2:
                  _context14.next = 4;
                  return this.stateMutex.acquire();

                case 4:
                  _context14.prev = 4;
                  _context14.next = 7;
                  return this.getState();

                case 7:
                  loadedNames = _context14.sent;

                  if (!loadedNames.includes(name)) {
                    _context14.next = 10;
                    break;
                  }

                  return _context14.abrupt("return");

                case 10:
                  loadedNames.push(name);
                  localStorage.setItem("pluginus:loaded", JSON.stringify(loadedNames));

                case 12:
                  _context14.prev = 12;
                  _context14.next = 15;
                  return this.stateMutex.release();

                case 15:
                  return _context14.finish(12);

                case 16:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14, this, [[4,, 12, 16]]);
        }));

        function addState(_x19) {
          return _addState.apply(this, arguments);
        }

        return addState;
      }()
    }, {
      key: "removeState",
      value: function () {
        var _removeState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(name) {
          var loadedNames;
          return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context15.next = 2;
                    break;
                  }

                  return _context15.abrupt("return");

                case 2:
                  _context15.next = 4;
                  return this.stateMutex.acquire();

                case 4:
                  _context15.prev = 4;
                  _context15.next = 7;
                  return this.getState();

                case 7:
                  loadedNames = _context15.sent;

                  if (loadedNames.includes(name)) {
                    _context15.next = 10;
                    break;
                  }

                  return _context15.abrupt("return");

                case 10:
                  loadedNames = loadedNames.splice(loadedNames.indexOf(name));
                  localStorage.setItem("pluginus:loaded", JSON.stringify(loadedNames));

                case 12:
                  _context15.prev = 12;
                  _context15.next = 15;
                  return this.stateMutex.release();

                case 15:
                  return _context15.finish(12);

                case 16:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, this, [[4,, 12, 16]]);
        }));

        function removeState(_x20) {
          return _removeState.apply(this, arguments);
        }

        return removeState;
      }()
    }, {
      key: "persistState",
      value: function () {
        var _persistState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
          var loadedNames;
          return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context16.next = 2;
                    break;
                  }

                  return _context16.abrupt("return");

                case 2:
                  loadedNames = this.getLoadedPlugins().map(function (p) {
                    return p.getName();
                  });
                  localStorage.setItem("pluginus:loaded", JSON.stringify(loadedNames));

                case 4:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16, this);
        }));

        function persistState() {
          return _persistState.apply(this, arguments);
        }

        return persistState;
      }()
    }, {
      key: "restoreState",
      value: function () {
        var _restoreState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
          var loadedNames, _iterator7, _step7, loadedName;

          return regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context17.next = 2;
                    break;
                  }

                  return _context17.abrupt("return");

                case 2:
                  _context17.next = 4;
                  return this.getState();

                case 4:
                  loadedNames = _context17.sent;
                  _iterator7 = _createForOfIteratorHelper(loadedNames);
                  _context17.prev = 6;

                  _iterator7.s();

                case 8:
                  if ((_step7 = _iterator7.n()).done) {
                    _context17.next = 14;
                    break;
                  }

                  loadedName = _step7.value;
                  _context17.next = 12;
                  return this.getPluginByName(loadedName);

                case 12:
                  _context17.next = 8;
                  break;

                case 14:
                  _context17.next = 19;
                  break;

                case 16:
                  _context17.prev = 16;
                  _context17.t0 = _context17["catch"](6);

                  _iterator7.e(_context17.t0);

                case 19:
                  _context17.prev = 19;

                  _iterator7.f();

                  return _context17.finish(19);

                case 22:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17, this, [[6, 16, 19, 22]]);
        }));

        function restoreState() {
          return _restoreState.apply(this, arguments);
        }

        return restoreState;
      }()
    }, {
      key: "getState",
      value: function () {
        var _getState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
          var loadedNamesS;
          return regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
              switch (_context18.prev = _context18.next) {
                case 0:
                  if (!(typeof localStorage === "undefined")) {
                    _context18.next = 2;
                    break;
                  }

                  return _context18.abrupt("return", []);

                case 2:
                  loadedNamesS = localStorage.getItem("pluginus:loaded");

                  if (loadedNamesS) {
                    _context18.next = 5;
                    break;
                  }

                  return _context18.abrupt("return", []);

                case 5:
                  return _context18.abrupt("return", JSON.parse(loadedNamesS));

                case 6:
                case "end":
                  return _context18.stop();
              }
            }
          }, _callee18);
        }));

        function getState() {
          return _getState.apply(this, arguments);
        }

        return getState;
      }()
    }, {
      key: "getLoadedPlugins",
      value: function getLoadedPlugins() {
        return this.plugins.filter(function (p) {
          return p.isLoaded();
        });
      }
    }], [{
      key: "new",
      value: function _new(capabilities) {
        return new this(capabilities);
      }
    }]);

    return PluginManager;
  }(Observable);
  var manager = new PluginManager();
  var load = function load() {
    return manager.load();
  };
  var unload = function unload() {
    return manager.unload();
  };
  var reset = function reset() {
    return manager.unload();
  };

  var camelToUnderscore = function camelToUnderscore(value) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
    if (!value) return value;
    return value.replace(/\.?([A-Z])/g, function (x, y) {
      return separator + y.toLowerCase();
    }).replace(RegExp("^" + separator), "");
  };
  var normalizeName = function normalizeName(name) {
    var underscore = camelToUnderscore(name, "-");
    return underscore.replace(/-plugin$/, "");
  };

  var Plugin = /*#__PURE__*/function (_Observable) {
    _inherits(Plugin, _Observable);

    var _super = _createSuper(Plugin);

    function Plugin(owner) {
      var _this;

      _classCallCheck(this, Plugin);

      _this = _super.call(this);
      _this.name = normalizeName(_this.constructor.name);
      _this.version = "0.0.0";
      _this.description = null;
      _this.owner = owner;
      _this.loaded = false;
      _this.meta = {};
      return _this;
    }

    _createClass(Plugin, [{
      key: "load",
      value: function () {
        var _load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.ensureOwner();
                  this.loaded = true;

                case 2:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));

        function load() {
          return _load.apply(this, arguments);
        }

        return load;
      }()
    }, {
      key: "unload",
      value: function () {
        var _unload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  this.ensureOwner();
                  this.loaded = false;

                case 2:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function unload() {
          return _unload.apply(this, arguments);
        }

        return unload;
      }()
    }, {
      key: "getPluginByCapability",
      value: function () {
        var _getPluginByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(name) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  return _context3.abrupt("return", this.owner.getPluginByCapability(name));

                case 1:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function getPluginByCapability(_x) {
          return _getPluginByCapability.apply(this, arguments);
        }

        return getPluginByCapability;
      }()
    }, {
      key: "getPluginsByCapability",
      value: function () {
        var _getPluginsByCapability = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(name) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  return _context4.abrupt("return", this.owner.getPluginsByCapability(name));

                case 1:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function getPluginsByCapability(_x2) {
          return _getPluginsByCapability.apply(this, arguments);
        }

        return getPluginsByCapability;
      }()
    }, {
      key: "getName",
      value: function getName() {
        return this.name;
      }
    }, {
      key: "getVersion",
      value: function getVersion() {
        return this.version;
      }
    }, {
      key: "getDescription",
      value: function getDescription() {
        return this.description;
      }
    }, {
      key: "getCapabilities",
      value: function getCapabilities() {
        return [];
      }
    }, {
      key: "triggerAll",
      value: function () {
        var _triggerAll = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(event) {
          var _this$owner;

          var promise,
              promises,
              _len,
              args,
              _key,
              _iterator,
              _step,
              _this$owner2,
              capability,
              _args5 = arguments;

          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  promises = []; // makes sure that there's an owner assigned to the current instance
                  // otherwise issues would arise further on

                  this.ensureOwner(); // triggers the base plugin context events both under the plugins instance
                  // and the surrounding plugin manager (as expected)

                  for (_len = _args5.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = _args5[_key];
                  }

                  promise = this.trigger.apply(this, ["plugin:".concat(this.getName(), ":").concat(event)].concat(args));
                  promises.push(promise);
                  promise = (_this$owner = this.owner).trigger.apply(_this$owner, ["plugin:".concat(this.getName(), ":").concat(event), this].concat(args));
                  promises.push(promise); // iterates over the complete set of capabilities of the current
                  // plugin to trigger capability context events both under the current
                  // instance observable and the owner's observable

                  _iterator = _createForOfIteratorHelper(this.getCapabilities());

                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      capability = _step.value;
                      promise = this.trigger.apply(this, ["capability:".concat(capability.getName(), ":").concat(event)].concat(args));
                      promises.push(promise);
                      promise = (_this$owner2 = this.owner).trigger.apply(_this$owner2, ["capability:".concat(capability.getName(), ":").concat(event), this].concat(args));
                      promises.push(promise);
                    } // waits for the complete set of promises to be fulfilled so that all
                    // the async callbacks are executed (parallel execution)

                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }

                  _context5.next = 11;
                  return Promise.all(promises);

                case 11:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function triggerAll(_x3) {
          return _triggerAll.apply(this, arguments);
        }

        return triggerAll;
      }()
    }, {
      key: "ensureOwner",
      value: function ensureOwner() {
        if (!this.isOrphan()) return;
        throw new Error("Plugin instance '".concat(this.getName(), "' is orphan of manager"));
      }
    }, {
      key: "isLoaded",
      value: function isLoaded() {
        return this.loaded;
      }
    }, {
      key: "isOrphan",
      value: function isOrphan() {
        return this.owner === undefined || this.owner === null;
      }
    }], [{
      key: "new",
      value: function _new() {
        return new this();
      }
    }, {
      key: "register",
      value: function register(owner) {
        owner = owner || manager;

        if (!owner) {
          return;
        }

        owner.registerPlugin(this);
      }
    }, {
      key: "unregister",
      value: function unregister(owner) {
        owner = owner || manager;

        if (!owner) {
          return;
        }

        owner.unregisterPlugin(this);
      }
    }]);

    return Plugin;
  }(Observable);

  exports.Capability = Capability;
  exports.Mutex = Mutex;
  exports.Observable = Observable;
  exports.Plugin = Plugin;
  exports.PluginManager = PluginManager;
  exports.camelToUnderscore = camelToUnderscore;
  exports.load = load;
  exports.manager = manager;
  exports.normalizeName = normalizeName;
  exports.reset = reset;
  exports.unload = unload;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=pluginus.umd.js.map


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formInterface", function() { return formInterface; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialsImages", function() { return initialsImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "initialsInputs", function() { return initialsInputs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reference", function() { return reference; });
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Interface", function() { return _interface__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _initials_images_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(105);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InitialsImages", function() { return _initials_images_vue__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _initials_inputs_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(106);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InitialsInputs", function() { return _initials_inputs_vue__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _reference_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(107);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Reference", function() { return _reference_vue__WEBPACK_IMPORTED_MODULE_3__["a"]; });





var formInterface = _interface__WEBPACK_IMPORTED_MODULE_0__[/* Interface */ "a"];
var initialsImages = _initials_images_vue__WEBPACK_IMPORTED_MODULE_1__[/* InitialsImages */ "a"];
var initialsInputs = _initials_inputs_vue__WEBPACK_IMPORTED_MODULE_2__[/* InitialsInputs */ "a"];
var reference = _reference_vue__WEBPACK_IMPORTED_MODULE_3__[/* Reference */ "a"];


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var _slicedToArray = __webpack_require__(5);

var _typeof = __webpack_require__(20);

var _regeneratorRuntime = __webpack_require__(0);

var _asyncToGenerator = __webpack_require__(1);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16);

  __webpack_require__(168); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * The version of the RIPE SDK currently in load, should
 * be in sync with the package information.
 */


ripe.VERSION = "1.25.2";
/**
 * Object that contains global (static) information to be used by
 * the RIPE infrastructure (eg global identifier counter).
 */

ripe.ripeGlobals = {
  id: 0
};
/**
 * @class
 * @augments Observable
 * @classdesc Represents a customizable model.
 *
 * @param {String} brand The brand of the model.
 * @param {String} model The name of the model.
 * @param {Object} options An object with the options to configure the Ripe instance.
 */

ripe.Ripe = function (brand, model) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  ripe.Observable.call(this);
  ripe.Ripe.prototype.init.call(this, brand, model, options);
};

ripe.Ripe.prototype = ripe.build(ripe.Observable.prototype);
ripe.Ripe.prototype.constructor = ripe.Ripe;
/**
 * @ignore
 */

ripe.RipeBase = function (brand, model) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new ripe.Ripe(brand, model, options);
};
/**
 * Builds a new Ripe instance using the provided normalized configuration
 * structure as the basis for its configuration.
 *
 * @param {Object} structure The normalized configuration structure that is
 * going to be used in the initialization of the new Ripe instance.
 * @param {Boolean} safe If the safe object mode creation should be used.
 * @param {Object} options The extra options to be used in the initialization
 * process of the Ripe instance.
 */


ripe.Ripe.fromStructure = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(structure) {
    var safe,
        options,
        instance,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            safe = _args.length > 1 && _args[1] !== undefined ? _args[1] : true;
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            instance = new ripe.Ripe(options);
            _context.next = 5;
            return instance.setStructure(structure, safe);

          case 5:
            return _context.abrupt("return", instance);

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * The initializer of the class, to be called whenever the instance
 * is going to become active.
 *
 * Sets the various values for the Ripe instance taking into account
 * the provided configuration and defaulting values policy.
 */


ripe.Ripe.prototype.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
  var _this = this;

  var brand,
      model,
      options,
      init,
      _iterator,
      _step,
      plugin,
      diagPlugin,
      _args6 = arguments;

  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          brand = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : null;
          model = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : null;
          options = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
          // generates a new global identifier and adds the current
          // instance to the list og globally managed ones
          ripe.ripeGlobals.id++;
          this.id = ripe.ripeGlobals.id; // runs the defaulting operation so that it's possible to
          // provide only the first parameters as the options

          if (_typeof(brand) === "object" && brand !== null) {
            options = brand;
            brand = options.brand || null;
            model = options.model || null;
          } // determines if the init operation should be avoided (eg: for static usage)
          // if so the control flow is returned immediately (init prevented)


          init = options.init === undefined ? true : options.init;

          if (init) {
            _context6.next = 9;
            break;
          }

          return _context6.abrupt("return");

        case 9:
          // sets the various values in the instance taking into
          // account the default values
          this.initials = "";
          this.engraving = null;
          this.initialsExtra = {};
          this.ctx = {};
          this.children = this.children || [];
          this.plugins = this.plugins || [];
          this.history = [];
          this.historyPointer = -1;
          this.loadedConfig = null;
          this.choices = null;
          this.ready = false;
          this.configured = false;
          this.bundles = false;
          this.partCounter = 0;
          this.updateCounter = 0;
          this.initialsCounter = 0;
          this.updatePromise = null;
          this.cancelPromise = null;
          this.error = null; // extends the default options with the ones provided by the
          // developer upon this initializer call

          options = ripe.assign({
            options: false
          }, options);
          this.setOptions(options); // in case the guess URL mode is active then a remote call should be
          // performed in order to take decisions on the proper production URL

          if (!this.guessUrl) {
            _context6.next = 33;
            break;
          }

          _context6.next = 33;
          return this._guessUrl();

        case 33:
          // iterates over all the plugins present in the options (meant
          // to be registered) and adds them to the current instance
          _iterator = _createForOfIteratorHelper(options.plugins || []);

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              plugin = _step.value;
              this.addPlugin(plugin);
            } // if diagnostic headers have not been disabled then
            // registers the diag plugin to automatically add
            // diagnostic headers to every remote request

          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          if (this.useDiag) {
            diagPlugin = new ripe.Ripe.plugins.DiagPlugin();
            this.addPlugin(diagPlugin);
          } // registers for the config (finished) event so that the execution may
          // be able to notify the server side logic and change the current state
          // if that's required by the server side


          this.bind("config", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
            var result, ctxRequest;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    result = null;

                    if (this.remoteOnConfig) {
                      _context2.next = 3;
                      break;
                    }

                    return _context2.abrupt("return");

                  case 3:
                    ctxRequest = this.ctxRequest = (this.ctxRequest || 0) + 1;
                    _context2.prev = 4;
                    _context2.next = 7;
                    return this.onConfigP({
                      brand: this.brand,
                      model: this.model
                    });

                  case 7:
                    result = _context2.sent;
                    _context2.next = 17;
                    break;

                  case 10:
                    _context2.prev = 10;
                    _context2.t0 = _context2["catch"](4);

                    if (!(_context2.t0 instanceof ripe.RemoteError)) {
                      _context2.next = 16;
                      break;
                    }

                    return _context2.abrupt("return");

                  case 16:
                    throw _context2.t0;

                  case 17:
                    if (!(ctxRequest !== this.ctxRequest)) {
                      _context2.next = 19;
                      break;
                    }

                    return _context2.abrupt("return");

                  case 19:
                    this._handleCtx(result);

                  case 20:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this, [[4, 10]]);
          }))); // registers for the part (set) operation so that the execution may
          // be able to notify the server side logic and change the current state
          // if that's required by the server side

          this.bind("part", /*#__PURE__*/function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(name, value) {
              var result, ctxRequest;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      result = null;

                      if (this.remoteOnPart) {
                        _context3.next = 3;
                        break;
                      }

                      return _context3.abrupt("return");

                    case 3:
                      ctxRequest = this.ctxRequest = (this.ctxRequest || 0) + 1;
                      _context3.prev = 4;
                      _context3.next = 7;
                      return this.onPartP({
                        name: name,
                        value: value
                      });

                    case 7:
                      result = _context3.sent;
                      _context3.next = 17;
                      break;

                    case 10:
                      _context3.prev = 10;
                      _context3.t0 = _context3["catch"](4);

                      if (!(_context3.t0 instanceof ripe.RemoteError)) {
                        _context3.next = 16;
                        break;
                      }

                      return _context3.abrupt("return");

                    case 16:
                      throw _context3.t0;

                    case 17:
                      if (!(ctxRequest !== this.ctxRequest)) {
                        _context3.next = 19;
                        break;
                      }

                      return _context3.abrupt("return");

                    case 19:
                      this._handleCtx(result);

                    case 20:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee3, this, [[4, 10]]);
            }));

            return function (_x2, _x3) {
              return _ref4.apply(this, arguments);
            };
          }()); // registers for the initials (set) operation so that the execution may
          // be able to notify the server side logic and change the current state
          // if that's required by the server side

          this.bind("initials", /*#__PURE__*/function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(initials, engraving, params) {
              var result, ctxRequest;
              return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                while (1) {
                  switch (_context4.prev = _context4.next) {
                    case 0:
                      result = null;

                      if (this.remoteOnInitials) {
                        _context4.next = 3;
                        break;
                      }

                      return _context4.abrupt("return");

                    case 3:
                      if (!params.noRemote) {
                        _context4.next = 5;
                        break;
                      }

                      return _context4.abrupt("return");

                    case 5:
                      ctxRequest = this.ctxRequest = (this.ctxRequest || 0) + 1;
                      _context4.prev = 6;
                      _context4.next = 9;
                      return this.onInitialsP({
                        group: "main",
                        value: initials,
                        engraving: engraving
                      });

                    case 9:
                      result = _context4.sent;
                      _context4.next = 19;
                      break;

                    case 12:
                      _context4.prev = 12;
                      _context4.t0 = _context4["catch"](6);

                      if (!(_context4.t0 instanceof ripe.RemoteError)) {
                        _context4.next = 18;
                        break;
                      }

                      return _context4.abrupt("return");

                    case 18:
                      throw _context4.t0;

                    case 19:
                      if (!(ctxRequest !== this.ctxRequest)) {
                        _context4.next = 21;
                        break;
                      }

                      return _context4.abrupt("return");

                    case 21:
                      this._handleCtx(result);

                    case 22:
                    case "end":
                      return _context4.stop();
                  }
                }
              }, _callee4, this, [[6, 12]]);
            }));

            return function (_x4, _x5, _x6) {
              return _ref5.apply(this, arguments);
            };
          }()); // registers for the initials_extra (set) operation so that the execution may
          // be able to notify the server side logic and change the current state
          // if that's required by the server side

          this.bind("initials_extra", /*#__PURE__*/function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(initialsExtra, params, _ref6) {
              var previous, result, ctxRequest, _i, _Object$entries, _Object$entries$_i, key, value, previousValue;

              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      previous = _ref6.previous;
                      result = null;

                      if (this.remoteOnInitials) {
                        _context5.next = 4;
                        break;
                      }

                      return _context5.abrupt("return");

                    case 4:
                      if (!params.noRemote) {
                        _context5.next = 6;
                        break;
                      }

                      return _context5.abrupt("return");

                    case 6:
                      ctxRequest = this.ctxRequest = (this.ctxRequest || 0) + 1;
                      _i = 0, _Object$entries = Object.entries(initialsExtra);

                    case 8:
                      if (!(_i < _Object$entries.length)) {
                        _context5.next = 32;
                        break;
                      }

                      _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];
                      // in case the value of the initials extra group did not
                      // change when compared with the previous version then
                      // there's no need for `onInitials` execution
                      previousValue = previous && previous[key] ? previous[key] : {
                        initials: "",
                        engraving: null
                      };

                      if (!(value.initials === previousValue.initials && value.engraving === previousValue.engraving)) {
                        _context5.next = 13;
                        break;
                      }

                      return _context5.abrupt("continue", 29);

                    case 13:
                      _context5.prev = 13;
                      _context5.next = 16;
                      return this.onInitialsP({
                        group: key,
                        value: value.initials,
                        engraving: value.engraving
                      });

                    case 16:
                      result = _context5.sent;
                      _context5.next = 26;
                      break;

                    case 19:
                      _context5.prev = 19;
                      _context5.t0 = _context5["catch"](13);

                      if (!(_context5.t0 instanceof ripe.RemoteError)) {
                        _context5.next = 25;
                        break;
                      }

                      return _context5.abrupt("return");

                    case 25:
                      throw _context5.t0;

                    case 26:
                      if (!(ctxRequest !== this.ctxRequest)) {
                        _context5.next = 28;
                        break;
                      }

                      return _context5.abrupt("return");

                    case 28:
                      this._handleCtx(result);

                    case 29:
                      _i++;
                      _context5.next = 8;
                      break;

                    case 32:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5, this, [[13, 19]]);
            }));

            return function (_x7, _x8, _x9) {
              return _ref7.apply(this, arguments);
            };
          }()); // listens for the post parts event and saves the current configuration
          // for the undo operations (history control)

          this.bind("post_parts", function (parts, options) {
            // in case the current operation was an undo and redo one there's
            // nothing to be done (no history stack change)
            if (options && ["undo", "redo"].indexOf(options.action) !== -1) {
              return;
            } // pushes the current state of the configuration (parts) into
            // the history stack allowing undo and redo


            this._pushHistory();
          });
          _context6.prev = 41;
          _context6.next = 44;
          return this.config(brand, model, options);

        case 44:
          _context6.next = 50;
          break;

        case 46:
          _context6.prev = 46;
          _context6.t0 = _context6["catch"](41);

          // calls the error handler for the current handler to update the
          // internal items of the Ripe Instance
          this._errorHandler(_context6.t0); // returns the control flow immediately as the exception has been
          // properly handled for the current context


          return _context6.abrupt("return");

        case 50:
          // runs the initialization of the locale bundles, provided by the
          // remote handle, this is required for proper initialization
          if (this.useBundles) this._initBundles()["catch"](function (err) {
            return _this._errorHandler(err);
          });

        case 51:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, this, [[41, 46]]);
}));
/**
 * The deinitializer to be called when it should stop responding
 * to updates so that any necessary cleanup operations can be executed.
 */

ripe.Ripe.prototype.deinit = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
  var index, child, plugin;
  return _regeneratorRuntime.wrap(function _callee7$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          index = null;
          index = this.children.length - 1;

        case 2:
          if (!(index >= 0)) {
            _context7.next = 9;
            break;
          }

          child = this.children[index];
          _context7.next = 6;
          return this.unbindInteractable(child);

        case 6:
          index--;
          _context7.next = 2;
          break;

        case 9:
          for (index = this.plugins.length - 1; index >= 0; index--) {
            plugin = this.plugins[index];
            this.removePlugin(plugin);
          }

          ripe.Observable.prototype.deinit.call(this);

        case 11:
        case "end":
          return _context7.stop();
      }
    }
  }, _callee7, this);
}));
/**
 * Explicit entry point to the initial update.
 *
 * This method should be called before any significant RIPE operation
 * can be performed on the instance.
 *
 * @returns {Object} The current Ripe Instance (for pipelining).
 */

ripe.Ripe.prototype.load = function () {
  this.update(undefined, {
    reason: "load"
  });
  return this;
};
/**
 * Explicit entry point for the unloading of the Ripe Instance.
 *
 * Should be called for a clean exit of the instance.
 *
 * @returns {Object} The current Ripe Instance (for pipelining).
 */


ripe.Ripe.prototype.unload = function () {
  return this;
};
/**
 * Same as `load` but providing a promise oriented solution
 * ready to be "awaited".
 *
 * @returns {Object} The current Ripe Instance (for pipelining).
 */


ripe.Ripe.prototype.loadP = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
  return _regeneratorRuntime.wrap(function _callee8$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return this.update(undefined, {
            reason: "load"
          });

        case 2:
          return _context8.abrupt("return", this);

        case 3:
        case "end":
          return _context8.stop();
      }
    }
  }, _callee8, this);
}));
/**
 * Same as `unload` but providing a promise oriented solution
 * ready to be "awaited".
 *
 * @returns {Object} The current Ripe Instance (for pipelining).
 */

ripe.Ripe.prototype.unloadP = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          return _context9.abrupt("return", this);

        case 1:
        case "end":
          return _context9.stop();
      }
    }
  }, _callee9, this);
}));
/**
 * Sets the model to be customised by providing both the brand
 * and the model for the update.
 *
 * @param {String} brand The brand of the model.
 * @param {String} model The name of the model.
 * @param {Object} options An object with the options to configure the Ripe instance, such as:
 *  - 'parts' - The initial parts of the model.
 *  - 'initials' - The initial value for the initials of the model.
 *  - 'engraving' - The initial engraving value of the model.
 *  - 'initialsExtra' - The initial value for the initials extra.
 *  - 'country' - The country where the model will be sold.
 *  - 'currency' - The currency that should be used to calculate the price.
 *  - 'locale' - The locale to be used by default when localizing values.
 *  - 'flag' - A specific attribute of the model.
 *  - 'remoteCalls' - If the remote calls (eg: 'on_config') should be called in the middle of configuration.
 *  - 'useBundles' - If the bundles should be loaded during initial loading.
 *  - 'useDefaults' - If the default parts of the model should be used when no initials parts are set.
 *  - 'useCombinations' - If the combinations should be loaded as part of the initial RIPE loading.
 *  - 'usePrice' - If the price should be automatically retrieved whenever there is a customization change.
 *  - 'useDiag' - If the diagnostics module should be used.
 *  - 'safe' - If the call should 'await' for all the composing operations before returning or if instead
 * should allow operations to be performed in a parallel and detached manner.
 */

ripe.Ripe.prototype.config = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(brand, model) {
    var options,
        config,
        hasModel,
        message,
        hasParts,
        loadDefaults,
        parts,
        setInitialsPromise,
        setInitialsExtraPromise,
        remotePromise,
        updatePromise,
        _args10 = arguments;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            options = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : {};
            // unsets the configured flag so that all the sensitive
            // configuration related operation are disabled while
            // the config operation is being performed, this is
            // required because there's a lot of parallelism in the
            // execution workflow of the config and by setting this
            // flag some data race conditions are avoided
            this.configured = false; // cancels any pending operation on the child elements
            // so that no more operations are performed, any new
            // operation could ony be considered a wat of resources

            _context10.next = 4;
            return this.cancel();

          case 4:
            // sets the most structural values of this entity
            // that represent the configuration to be used
            this.brand = brand;
            this.model = model; // resets the history related values as the current
            // model has changed and no previous history is possible

            this.history = [];
            this.historyPointer = -1; // sets the new options using the current options
            // as default values and sets the update flag to
            // true if it is not set

            options = ripe.assign({}, this.options, {
              variant: null,
              version: null,
              dku: null,
              parts: {}
            }, options);
            this.setOptions(options); // in case there's a DKU defined for the current config then
            // an extra resolution step must occur, to be able to obtain
            // the configuration of the current customization

            if (!this.dku) {
              _context10.next = 20;
              break;
            }

            _context10.next = 13;
            return this.configDkuP(this.dku);

          case 13:
            config = _context10.sent;
            this.brand = config.brand;
            this.model = config.model;
            this.parts = config.parts === undefined ? this.parts : config.parts;
            this.initials = config.initials === undefined ? this.initials : config.initials;
            this.engraving = config.engraving === undefined ? this.engraving : config.engraving;
            this.initialsExtra = config.initials_extra === undefined && config.initialsExtra === undefined ? this.initialsExtra : config.initialsExtra || config.initials_extra;

          case 20:
            // determines if a valid model is currently defined for the ripe
            // instance, as this is going to change some logic behaviour
            hasModel = Boolean(this.brand && this.model); // in case no model is currently loaded it's time to return the
            // control flow as all of the structures are currently loaded

            if (!(hasModel === false)) {
              _context10.next = 25;
              break;
            }

            this.loadedConfig = null;

            if (this.ready === false) {
              this.ready = true;
              this.trigger("ready");
            }

            return _context10.abrupt("return");

          case 25:
            _context10.next = 27;
            return this.trigger("pre_config", brand, model, options);

          case 27:
            _context10.prev = 27;
            _context10.next = 30;
            return this.getConfigP();

          case 30:
            this.loadedConfig = _context10.sent;
            _context10.next = 38;
            break;

          case 33:
            _context10.prev = 33;
            _context10.t0 = _context10["catch"](27);
            // builds the base message taking into consideration if the
            // version has been explicity defined
            message = "Not possible to get configuration for '".concat(brand, "' and '").concat(model, "'");
            if (this.options.version) message += " version ".concat(this.options.version); // raises a new error indicating the real cause for the new
            // error being thrown under the current execution logic

            throw new ripe.OperationalError(message, _context10.t0);

          case 38:
            // creates a "new" choices from the provided configuration for the
            // model that has just been "loaded" and sets it as the new set of
            // choices for the configuration context
            this.setChoices(this._toChoices(this.loadedConfig)); // determines if the defaults for the selected model should
            // be loaded so that the parts structure is initially populated

            hasParts = this.parts && Object.keys(this.parts).length !== 0;
            loadDefaults = !hasParts && this.useDefaults && hasModel; // determines the proper initial parts for the model taking into account
            // if the defaults should be loaded

            parts = loadDefaults ? this.loadedConfig.defaults : this.parts; // updates the parts of the current instance so that the internals of it
            // reflect the newly loaded configuration, notice that we're not going to
            // wait until the update is finished (opportunistic)

            _context10.next = 44;
            return this.setParts(parts, true, {
              partEvents: false,
              runUpdate: false
            });

          case 44:
            if (!(options.initials && options.engraving)) {
              _context10.next = 49;
              break;
            }

            setInitialsPromise = this.setInitials(options.initials, options.engraving, false);

            if (!options.safe) {
              _context10.next = 49;
              break;
            }

            _context10.next = 49;
            return setInitialsPromise;

          case 49:
            if (!options.initialsExtra) {
              _context10.next = 54;
              break;
            }

            setInitialsExtraPromise = this.setInitialsExtra(options.initialsExtra, false);

            if (!options.safe) {
              _context10.next = 54;
              break;
            }

            _context10.next = 54;
            return setInitialsExtraPromise;

          case 54:
            _context10.next = 56;
            return this.trigger("config", this.loadedConfig, options);

          case 56:
            // determines if the ready flag is already set for the current instance
            // and if that's not the case updates it and triggers the ready event
            if (this.ready === false) {
              this.ready = true;
              this.trigger("ready");
            } // notifies that the config has changed and waits for listeners before
            // concluding the config operation


            _context10.next = 59;
            return this.trigger("post_config", this.loadedConfig, options);

          case 59:
            // sets the configured flag as valid, meaning that any configuration
            // related operation is considered safe from now on
            this.configured = true; // triggers the remote operations, that should be executed
            // only after the complete set of post confirm promises are met

            remotePromise = this.remote();

            if (!options.safe) {
              _context10.next = 64;
              break;
            }

            _context10.next = 64;
            return remotePromise;

          case 64:
            // runs the initial update operation, so that all the visuals and children
            // objects are properly updated according to the new configuration
            updatePromise = this.update(undefined, {
              noAwaitLayout: true,
              reason: "config"
            });

            if (!options.safe) {
              _context10.next = 68;
              break;
            }

            _context10.next = 68;
            return updatePromise;

          case 68:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, this, [[27, 33]]);
  }));

  return function (_x10, _x11) {
    return _ref11.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.Ripe.prototype.remote = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
  var loadCombinations;
  return _regeneratorRuntime.wrap(function _callee11$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          if (!(!this.brand || !this.model)) {
            _context11.next = 2;
            break;
          }

          return _context11.abrupt("return");

        case 2:
          // tries to determine if the combinations available should be
          // loaded for the current model and if that's the case start the
          // loading process for them, setting then the result in the instance
          loadCombinations = this.useCombinations;

          if (!loadCombinations) {
            _context11.next = 8;
            break;
          }

          _context11.next = 6;
          return this.getCombinationsP();

        case 6:
          this.combinations = _context11.sent;
          this.trigger("combinations", this.combinations);

        case 8:
        case "end":
          return _context11.stop();
      }
    }
  }, _callee11, this);
}));
/**
 * Retrieves the normalized structure that uniquely represents
 * the current configuration "situation".
 *
 * @param {Boolean} safe If the structure should be retrieved
 * using a safe approach (deep copy).
 * @returns The normalized map structure that represents the
 * current configuration "situation".
 */

ripe.Ripe.prototype.getStructure = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
  var safe,
      structure,
      _args12 = arguments;
  return _regeneratorRuntime.wrap(function _callee12$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          safe = _args12.length > 0 && _args12[0] !== undefined ? _args12[0] : true;
          structure = {};
          if (this.brand) structure.brand = this.brand;
          if (this.model) structure.model = this.model;
          if (this.variant) structure.variant = this.variant;
          if (this.version) structure.version = this.version;

          if (this.parts && Object.keys(this.parts).length > 0) {
            structure.parts = this.parts;
          }

          if (this.initials) structure.initials = this.initials;
          if (this.engraving) structure.engraving = this.engraving;

          if (this.initialsExtra && Object.keys(this.initialsExtra).length > 0) {
            structure.initials_extra = this.initialsExtra;
          }

          return _context12.abrupt("return", safe ? JSON.parse(JSON.stringify(structure)) : structure);

        case 11:
        case "end":
          return _context12.stop();
      }
    }
  }, _callee12, this);
}));
/**
 * Updates the current internal state of the Ripe instance with the
 * contents defined by the provided structure (snapshot).
 *
 * @param {Object} structure The object structure that represents the configuration
 * "situation" that is going to be set in the Ripe instance.
 * @param {Boolean} safe If the operation should be performed using a
 * safe strategy (deep copy in objects).
 */

ripe.Ripe.prototype.setStructure = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(structure) {
    var safe,
        options,
        brand,
        model,
        _args13 = arguments;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            safe = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : true;
            options = {};
            brand = structure.brand || null;
            model = structure.model || null;
            options.variant = structure.variant || null;
            options.version = structure.version || null;
            options.parts = structure.parts && (safe ? JSON.parse(JSON.stringify(structure.parts)) : structure.parts) || {};
            options.initials = structure.initials || "";
            options.engraving = structure.engraving || null;
            options.initialsExtra = structure.initials_extra && Object.keys(structure.initials_extra).length > 0 && (safe ? JSON.parse(JSON.stringify(structure.initials_extra)) : structure.initials_Extra) || {};
            _context13.next = 12;
            return this.config(brand, model, options);

          case 12:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function (_x12) {
    return _ref14.apply(this, arguments);
  };
}();
/**
 * Sets Ripe instance options according to the defaulting policy.
 *
 * @param {Object} options An object with the options to configure the Ripe instance, such as:
 *  - 'variant' - The variant of the model.
 *  - 'version' - The version of the model, obtained from the containing build.
 *  - 'dku' - The DKU (Dynamic Keeping Unit) to be used in the configuration (if any).
 *  - 'parts' - The initial parts of the model.
 *  - 'country' - The country where the model will be sold.
 *  - 'currency' - The currency that should be used to calculate the price.
 *  - 'locale' - The locale to be used by default when localizing values.
 *  - 'flag' - A specific attribute of the model.
 *  - 'format' - The format of the image that is going to be retrieved in case of image visual and interactive.
 *  - 'size' - The default size in pixels to be used by children for composition.
 *  - 'backgroundColor' - The background color in RGB format to be used for images.
 *  - 'guess' - If the optimistic guess mode should be used for config resolution (internal).
 *  - 'guessUrl' - If base production URL should be guessed using GeoIP information.
 *  - 'remoteCalls' - If the remote calls (eg: 'on_config') should be called in the middle of configuration.
 *  - 'useBundles' - If the bundles should be loaded during initial loading.
 *  - 'useDefaults' - If the default parts of the model should be used when no initials parts are set.
 *  - 'useCombinations' - If the combinations should be loaded as part of the initial RIPE loading.
 *  - 'usePrice' - If the price should be automatically retrieved whenever there is a customization change.
 *  - 'useDiag' - If the diagnostics module should be used.
 */


ripe.Ripe.prototype.setOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  this.options = options;
  this.variant = this.options.variant || null;
  this.version = this.options.version || null;
  this.dku = this.options.dku || null;
  this.url = this.options.url || "https://sandbox.platforme.com/api/";
  this.webUrl = this.options.webUrl || "https://sandbox.platforme.com/";
  this.params = this.options.params || {};
  this.headers = this.options.headers || {};
  this.parts = this.options.parts || {};
  this.country = this.options.country || null;
  this.currency = this.options.currency || null;
  this.locale = this.options.locale || null;
  this.flag = this.options.flag || null;
  this.format = this.options.format || null;
  this.formatBase = this.options.format || null;
  this.size = this.options.size || null;
  this.backgroundColor = this.options.backgroundColor || "";
  this.guess = this.options.guess === undefined ? undefined : this.options.guess;
  this.guessUrl = this.options.guessUrl === undefined ? undefined : this.options.guessUrl;
  this.remoteCalls = this.options.remoteCalls === undefined ? true : this.options.remoteCalls;
  this.remoteOnConfig = this.options.remoteOnConfig === undefined ? this.remoteCalls : this.options.remoteOnConfig;
  this.remoteOnPart = this.options.remoteOnPart === undefined ? this.remoteCalls : this.options.remoteOnPart;
  this.remoteOnInitials = this.options.remoteOnInitials === undefined ? this.remoteCalls : this.options.remoteOnInitials;
  this.noBundles = this.options.noBundles === undefined ? false : this.options.noBundles;
  this.useBundles = this.options.useBundles === undefined ? !this.noBundles : this.options.useBundles;
  this.noDefaults = this.options.noDefaults === undefined ? false : this.options.noDefaults;
  this.useDefaults = this.options.useDefaults === undefined ? !this.noDefaults : this.options.useDefaults;
  this.noCombinations = this.options.noCombinations === undefined ? false : this.options.noCombinations;
  this.useCombinations = this.options.useCombinations === undefined ? !this.noCombinations : this.options.useCombinations;
  this.noPrice = this.options.noPrice === undefined ? false : this.options.noPrice;
  this.usePrice = this.options.usePrice === undefined ? !this.noPrice : this.options.usePrice;
  this.noDiag = this.options.noDiag === undefined ? false : this.options.noDiag;
  this.useDiag = this.options.useDiag === undefined ? !this.noDiag : this.options.useDiag; // in case the requested format is the "dynamic" lossless one
  // tries to find the best lossless image format taking into account
  // the current browser environment

  if (this.format === "lossless") {
    this.format = this._supportsWebp() ? "webp" : "png";
  } // in case the lossful meta-format is defined defines the best possible
  // lossful format taking into account the environment


  if (this.format === "lossful") {
    this.format = "jpeg";
  } // runs the background color normalization process that removes
  // the typical cardinal character from the definition


  this.backgroundColor = this.backgroundColor.replace("#", "");
};
/**
 * Changes the material and color of the provided part.
 *
 * This operations is an expensive one and should be used carefully
 * to avoid unwanted resource usage.
 *
 * If many operations are meant to be used at the same time the `setParts`
 * parts method should be used instead, as it is better suited for bulk
 * based operations.
 *
 * @param {String} part The name of the part to be changed.
 * @param {String} material The material to change to.
 * @param {String} color The color to change to.
 * @param {Boolean} events If the parts events should be triggered (defaults to 'true').
 * @param {Object} options The options to be used in the set part operations (for internal use).
 */


ripe.Ripe.prototype.setPart = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(part, material, color) {
    var events,
        options,
        runUpdate,
        waitUpdate,
        promise,
        _args14 = arguments;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            events = _args14.length > 3 && _args14[3] !== undefined ? _args14[3] : true;
            options = _args14.length > 4 && _args14[4] !== undefined ? _args14[4] : {};
            runUpdate = options.runUpdate === undefined ? true : options.runUpdate;
            waitUpdate = options.waitUpdate === undefined ? true : options.waitUpdate;

            if (events) {
              _context14.next = 7;
              break;
            }

            _context14.next = 7;
            return this._setPart(part, material, color);

          case 7:
            _context14.next = 9;
            return this.trigger("pre_parts", this.parts, options);

          case 9:
            _context14.next = 11;
            return this._setPart(part, material, color);

          case 11:
            _context14.next = 13;
            return this.trigger("parts", this.parts, options);

          case 13:
            _context14.next = 15;
            return this.trigger("post_parts", this.parts, options);

          case 15:
            if (runUpdate) {
              _context14.next = 17;
              break;
            }

            return _context14.abrupt("return");

          case 17:
            // propagates the state change in the internal structures to the
            // children elements of this Ripe Instance
            promise = this.update(undefined, {
              reason: "set part"
            }); // in case the wait update options is valid (by default) then waits
            // until the update promise is fulfilled

            if (!waitUpdate) {
              _context14.next = 21;
              break;
            }

            _context14.next = 21;
            return promise;

          case 21:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function (_x13, _x14, _x15) {
    return _ref15.apply(this, arguments);
  };
}();
/**
 * Allows changing the customization of a set of parts in bulk.
 *
 * @param {Object} parts An Object or array with part, material, color triplets to be set.
 * @param {Boolean} events If the parts events should be triggered (defaults to 'true').
 * @param {Object} options An object with options to configure the operation (for internal use).
 */


ripe.Ripe.prototype.setParts = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(update) {
    var events,
        options,
        partEvents,
        runUpdate,
        waitUpdate,
        promise,
        _args15 = arguments;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            events = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : true;
            options = _args15.length > 2 && _args15[2] !== undefined ? _args15[2] : {};
            partEvents = options.partEvents === undefined ? true : options.partEvents;
            runUpdate = options.runUpdate === undefined ? true : options.runUpdate;
            waitUpdate = options.waitUpdate === undefined ? true : options.waitUpdate;

            if (_typeof(update) === "object" && !Array.isArray(update)) {
              update = this._partsList(update);
            }

            if (events) {
              _context15.next = 10;
              break;
            }

            _context15.next = 9;
            return this._setParts(update, partEvents);

          case 9:
            return _context15.abrupt("return");

          case 10:
            _context15.next = 12;
            return this.trigger("pre_parts", this.parts, options);

          case 12:
            _context15.next = 14;
            return this._setParts(update, partEvents);

          case 14:
            _context15.next = 16;
            return this.trigger("parts", this.parts, options);

          case 16:
            _context15.next = 18;
            return this.trigger("post_parts", this.parts, options);

          case 18:
            if (runUpdate) {
              _context15.next = 20;
              break;
            }

            return _context15.abrupt("return");

          case 20:
            // propagates the state change in the internal structures to the
            // children elements of this Ripe Instance
            promise = this.update(undefined, {
              reason: "set parts"
            }); // in case the wait update options is valid (by default) then waits
            // until the update promise is fulfilled

            if (!waitUpdate) {
              _context15.next = 24;
              break;
            }

            _context15.next = 24;
            return promise;

          case 24:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function (_x16) {
    return _ref16.apply(this, arguments);
  };
}();
/**
 * Changes the initials of the model, this is considered a simple
 * legacy oriented strategy as the `setInitialsExtra` method should
 * be used for more complex scenarios with multiple groups.
 *
 * @param {String} initials The initials value to be set.
 * @param {String} engraving The type of engraving to be set.
 * @param {Boolean} events If the events associated with the initials
 * change should be triggered.
 * @param {Boolean} override If the options value should be override meaning
 * that further config updates will have this new initials set.
 * @param {Object} params Extra parameters that control the behaviour of
 * the set initials operation.
 */


ripe.Ripe.prototype.setInitials = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(initials, engraving) {
    var events,
        override,
        params,
        result,
        id,
        state,
        _args16 = arguments;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            events = _args16.length > 2 && _args16[2] !== undefined ? _args16[2] : true;
            override = _args16.length > 3 && _args16[3] !== undefined ? _args16[3] : false;
            params = _args16.length > 4 && _args16[4] !== undefined ? _args16[4] : {};

            if (!(_typeof(initials) === "object")) {
              _context16.next = 9;
              break;
            }

            events = engraving === undefined ? true : engraving;
            _context16.next = 7;
            return this.setInitialsExtra(initials, events);

          case 7:
            result = _context16.sent;
            return _context16.abrupt("return", result);

          case 9:
            // generates a new initials counter that controls if the initials
            // state has changes (set initials), this way it's possible to
            // prevent out of order execution of update states
            this.initialsCounter += 1;
            id = this.initialsCounter; // triggers the event indicating the the start of the
            // the (set) initials operation (notifies listeners)

            _context16.next = 13;
            return this.trigger("pre_initials", {
              id: id
            });

          case 13:
            // sets the base instance fields for both the initials and the
            // engraving and updates the initials extra on the main group,
            // providing a compatibility layer between the initials and the
            // initials extra mode of working
            this.initials = initials || "";
            this.engraving = engraving || null;
            this.initialsExtra = {
              main: {
                initials: initials || "",
                engraving: engraving || null
              }
            };

            if (!(!this.initials && this.engraving)) {
              _context16.next = 18;
              break;
            }

            throw new Error("Engraving set without initials");

          case 18:
            // in case the override flag is set then the options fields
            // are also update with the new initials values
            if (override) {
              this.options.initials = this.initials;
              this.options.engraving = this.engraving;
              this.options.initialsExtra = this.initialsExtra;
            } // in case the events should not be triggered then returns
            // the control flow immediately, nothing remaining to be done


            if (events) {
              _context16.next = 21;
              break;
            }

            return _context16.abrupt("return", this);

          case 21:
            // creates a "snapshot" of the current initials state so that the
            // update may be performed over the currently defined set of initials
            state = this._getState(); // triggers the initials event notifying any listening
            // object about the changes

            _context16.next = 24;
            return this.trigger("initials", initials, engraving, params, {
              id: id
            });

          case 24:
            // runs the update operation so that all the listening
            // components can properly update their visuals, notice
            // that this execution is only performed in case this is
            // still the most up-to-date initials operation, avoiding
            // possible out-of-order execution of update operations
            if (id === this.initialsCounter) {
              this.update(state, {
                reason: "set initials"
              });
            } // triggers the event indicating the the end of the
            // the (set) initials operation (notifies listeners)


            _context16.next = 27;
            return this.trigger("post_initials", {
              id: id
            });

          case 27:
            return _context16.abrupt("return", this);

          case 28:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, this);
  }));

  return function (_x17, _x18) {
    return _ref17.apply(this, arguments);
  };
}();
/**
 * Changes the initials of the model using an object as the input which
 * allows setting the initials for multiple groups at the same time.
 *
 * @param {Object} initialsExtra Object that contains the values of the
 * initials and engraving for all the initial groups.
 * @param {Boolean} events If the events associated with the changing of
 * the initials (extra) should be triggered.
 * @param {Boolean} override If the options value should be override meaning
 * that further config updates will have this new initials extra set.
 * @param {Object} params Extra parameters that control the behaviour of
 * the set initials operation.
 */


ripe.Ripe.prototype.setInitialsExtra = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(initialsExtra) {
    var events,
        override,
        params,
        groups,
        isEmpty,
        mainGroup,
        mainInitials,
        id,
        previous,
        _i2,
        _Object$entries2,
        _Object$entries2$_i,
        key,
        value,
        state,
        _args17 = arguments;

    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            events = _args17.length > 1 && _args17[1] !== undefined ? _args17[1] : true;
            override = _args17.length > 2 && _args17[2] !== undefined ? _args17[2] : false;
            params = _args17.length > 3 && _args17[3] !== undefined ? _args17[3] : {};
            groups = Object.keys(initialsExtra);
            isEmpty = groups.length === 0;
            mainGroup = groups.includes("main") ? "main" : groups[0];
            mainInitials = initialsExtra[mainGroup]; // generates a new initials counter that controls if the initials
            // state has changes (set initials), this way it's possible to
            // prevent out of order execution of update states

            this.initialsCounter += 1;
            id = this.initialsCounter; // triggers the event indicating the the start of the
            // the (set) initials extra operation (notifies listeners)

            _context17.next = 11;
            return this.trigger("pre_initials_extra", {
              id: id
            });

          case 11:
            // "saves" the value of the previous initials extra structure
            // so that it can be passed latter as part of the event context
            previous = Object.assign({}, this.initialsExtra);

            if (isEmpty) {
              this.initials = "";
              this.engraving = null;
              this.initialsExtra = {};
            } else {
              this.initials = mainInitials.initials || "";
              this.engraving = mainInitials.engraving || null;
              this.initialsExtra = initialsExtra;
            }

            _i2 = 0, _Object$entries2 = Object.entries(this.initialsExtra);

          case 14:
            if (!(_i2 < _Object$entries2.length)) {
              _context17.next = 22;
              break;
            }

            _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2), key = _Object$entries2$_i[0], value = _Object$entries2$_i[1];

            if (value.initials && !value.engraving) {
              value.engraving = null;
            }

            if (!(!value.initials && value.engraving)) {
              _context17.next = 19;
              break;
            }

            throw new Error("Engraving set without initials for group ".concat(key));

          case 19:
            _i2++;
            _context17.next = 14;
            break;

          case 22:
            // in case the override flag is set then the options fields
            // are also update with the new initials values
            if (override) {
              this.options.initials = this.initials;
              this.options.engraving = this.engraving;
              this.options.initialsExtra = this.initialsExtra;
            }

            if (events) {
              _context17.next = 25;
              break;
            }

            return _context17.abrupt("return", this);

          case 25:
            // creates a "snapshot" of the current initials state so that the
            // update may be performed over the currently defined set of initials
            state = this._getState(); // triggers the initials extra event notifying any
            // listening object about the changes

            _context17.next = 28;
            return this.trigger("initials_extra", initialsExtra, params, {
              id: id,
              previous: previous
            });

          case 28:
            // runs the update operation so that all the listening
            // components can properly update their visuals, notice
            // that this execution is only performed in case this is
            // still the most up-to-date initials operation, avoiding
            // possible out-of-order execution of update operations
            if (id === this.initialsCounter) {
              this.update(state, {
                reason: "set initials extra"
              });
            } // triggers the event indicating the the end of the
            // the (set) initials extra operation (notifies listeners)


            _context17.next = 31;
            return this.trigger("post_initials_extra", {
              id: id
            });

          case 31:
            return _context17.abrupt("return", this);

          case 32:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, this);
  }));

  return function (_x19) {
    return _ref18.apply(this, arguments);
  };
}();
/**
 * Retrieves the value of the current base context defined in
 * the instance.
 *
 * @returns {Object} The base context currently set.
 */


ripe.Ripe.prototype.getCtx = function (ctx) {
  return this.ctx;
};
/**
 * Changes the current base context object (ctx) that is
 * going to be sent for (3D) build logic on crucial workflow
 * state changes.
 *
 * @param {Object} ctx The new base context to be used.
 */


ripe.Ripe.prototype.setCtx = function (ctx) {
  this.ctx = ctx;
};
/**
 * Returns the model's configuration loaded from the Platforme's system.
 * The config version loaded by this method is the one "cached" in the
 * instance, if there's any.
 *
 * @returns {Object} The model's configuration.
 */


ripe.Ripe.prototype.getLoadedConfig = function () {
  return this.loadedConfig;
};
/**
 * Returns the current state (eg: availability) for the parts materials
 * and colors associated with the current customization session.
 *
 * @returns {Object} The object that contains the state for every single
 * part, material, and color.
 */


ripe.Ripe.prototype.getChoices = function () {
  return this.choices;
};
/**
 * Updates the current internal state for parts material and colors, properly
 * notifying any "listener" about these changes.
 *
 * @param {Object} choices The object that contains the state for every single
 * part, material, and color.
 * @param {Boolean} events If the choices events should be triggered (defaults
 * to 'true').
 */


ripe.Ripe.prototype.setChoices = function (choices) {
  var events = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  // updates the internal object with the choices that are now
  // going to be set
  this.choices = choices; // in case no event triggering is required no the control flow
  // must return immediately

  if (!events) return; // triggers the choices event that should change the available
  // set of choices in the visual/UI assets

  this.trigger("choices", this.choices);
};
/**
 * Returns the model's available frames, in an object structure
 * that maps a certain face with the number of available frames
 * for such face.
 *
 * This function makes use of the loaded config in case there's
 * one, otherwise triggers the loading of the config.
 *
 * @returns {Object} The model's available frames.
 */


ripe.Ripe.prototype.getFrames = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(callback) {
    var config, frames, index, face, _i3, _Object$entries3, _Object$entries3$_i, _face, faceM;

    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            if (!this.options.frames) {
              _context18.next = 3;
              break;
            }

            if (callback) callback(this.options.frames);
            return _context18.abrupt("return", this.options.frames);

          case 3:
            if (!this.loadedConfig) {
              _context18.next = 7;
              break;
            }

            _context18.t0 = this.loadedConfig;
            _context18.next = 10;
            break;

          case 7:
            _context18.next = 9;
            return this.getConfigP();

          case 9:
            _context18.t0 = _context18.sent;

          case 10:
            config = _context18.t0;
            frames = {};

            for (index = 0; index < config.faces.length; index++) {
              face = config.faces[index];
              frames[face] = 1;
            } // ensures that the "legacy" side face has the a value
            // populated with the "legacy" frames field in case there's
            // none populated by the standard processing loop (above)
            // this only happens in case the side face is defined


            if (config.faces.indexOf("side") !== -1) {
              frames.side = config.frames;
            } // iterates over the complete set of faces to populate the frames
            // structure with the most up-to-date strategy using the faces map
            // that contains all the information about each face


            for (_i3 = 0, _Object$entries3 = Object.entries(config.faces_m); _i3 < _Object$entries3.length; _i3++) {
              _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2), _face = _Object$entries3$_i[0], faceM = _Object$entries3$_i[1];
              frames[_face] = faceM.frames;
            } // calls the callback with the resolved frame (unsafe) and returns
            // the frames map to the caller method


            if (callback) callback(frames);
            return _context18.abrupt("return", frames);

          case 17:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, this);
  }));

  return function (_x20) {
    return _ref19.apply(this, arguments);
  };
}();
/**
 * Updates the format setting for the current ripe instance, propagating
 * the change to any interested child.
 *
 * Optionally an update operation may be performed so that the format
 * changes are reflected in the user interface.
 *
 * @param {String} format The image format to be used in the ripe instance
 * (eg: png, webp, jpeg).
 * @param {Boolean} override If the options value should be override meaning
 * that further config updates will have this new format set.
 * @param {Boolean} update If an update operation should be perform asynchronous.
 */


ripe.Ripe.prototype.setFormat = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(format) {
    var override,
        update,
        _args19 = arguments;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            override = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : true;
            update = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : true;

            if (!(format === this.options.format)) {
              _context19.next = 4;
              break;
            }

            return _context19.abrupt("return");

          case 4:
            this.format = format;
            this.getChildren("Configurator").forEach(function (c) {
              c.format = format;
            });
            if (override) this.options.format = format;
            if (update) this.update(undefined, {
              reason: "set format"
            });
            this.trigger("settings");
            return _context19.abrupt("return", this);

          case 10:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, this);
  }));

  return function (_x21) {
    return _ref20.apply(this, arguments);
  };
}();
/**
 * Updates the size setting for the current ripe instance, propagating
 * the change to any interested child.
 *
 * Optionally an update operation may be performed so that the size
 * changes are reflected in the user interface.
 *
 * @param {String} size The size (in pixels) of the image to be used.
 * @param {Boolean} override If the options value should be override meaning
 * that further config updates will have this new format set.
 * @param {Boolean} update If an update operation should be perform asynchronous.
 */


ripe.Ripe.prototype.setSize = /*#__PURE__*/function () {
  var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(size) {
    var override,
        update,
        _args20 = arguments;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            override = _args20.length > 1 && _args20[1] !== undefined ? _args20[1] : true;
            update = _args20.length > 2 && _args20[2] !== undefined ? _args20[2] : true;

            if (!(size === this.options.size)) {
              _context20.next = 4;
              break;
            }

            return _context20.abrupt("return");

          case 4:
            this.size = size;
            this.getChildren("Configurator").forEach(function (c) {
              c.size = size;
            });
            if (override) this.options.size = size;
            if (update) this.update(undefined, {
              reason: "set size"
            });
            this.trigger("settings");
            return _context20.abrupt("return", this);

          case 10:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20, this);
  }));

  return function (_x22) {
    return _ref21.apply(this, arguments);
  };
}();
/**
 * Updates the background color setting for the current ripe instance,
 * propagating the change to any interested child.
 *
 * Optionally an update operation may be performed so that the background
 * background color changes are reflected in the user interface.
 *
 * @param {String} backgroundColor The background color in hexadecimal to be set.
 * @param {Boolean} override If the options value should be override meaning
 * that further config updates will have this new format set.
 * @param {Boolean} update If an update operation should be perform asynchronous.
 */


ripe.Ripe.prototype.setBackgroundColor = /*#__PURE__*/function () {
  var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(backgroundColor) {
    var override,
        update,
        _args21 = arguments;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            override = _args21.length > 1 && _args21[1] !== undefined ? _args21[1] : true;
            update = _args21.length > 2 && _args21[2] !== undefined ? _args21[2] : true;
            if (backgroundColor) backgroundColor = backgroundColor.replace("#", "");

            if (!(backgroundColor === this.options.backgroundColor)) {
              _context21.next = 5;
              break;
            }

            return _context21.abrupt("return");

          case 5:
            this.backgroundColor = backgroundColor;
            this.getChildren("Configurator").forEach(function (c) {
              c.backgroundColor = backgroundColor;
            });
            if (override) this.options.backgroundColor = backgroundColor;
            if (update) this.update(undefined, {
              reason: "set background color"
            });
            this.trigger("settings");
            return _context21.abrupt("return", this);

          case 11:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21, this);
  }));

  return function (_x23) {
    return _ref22.apply(this, arguments);
  };
}();
/**
 * Retrieves the complete set of child elements of this Ripe instance
 * that fulfill the provided type criteria.
 *
 * @param {String} type The type of child as a string to filter children.
 * @return {Array} The child elements that fill the provided type.
 */


ripe.Ripe.prototype.getChildren = function () {
  var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (type === null) return this.children;
  return this.children.filter(function (child) {
    return type === null || child.type.startsWith(type);
  });
};
/**
 * Binds an Image to this Ripe instance.
 *
 * @param {Image} element The Image to be used by the Ripe instance.
 * @param {Object} options An Object with options to configure the Image instance.
 * @returns {Image} The Image instance created.
 */


ripe.Ripe.prototype.bindImage = function (element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var image = new ripe.Image(this, element, options);
  return this.bindInteractable(image);
};
/**
 * Binds an Configurator to this Ripe instance.
 *
 * @param {Configurator} element The Configurator to be used by the Ripe instance.
 * @param {Object} options An Object with options to configure the Configurator instance.
 * @returns {Configurator} The Configurator instance created.
 */


ripe.Ripe.prototype.bindConfigurator = function (element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options = Object.assign({}, {
    format: this.format
  }, options);
  var config = new ripe.Configurator(this, element, options);
  return this.bindInteractable(config);
};
/**
 * Binds an Interactable to this Ripe instance.
 *
 * @param {Interactable} element The Interactable to be used by the Ripe instance.
 * @param {Object} options An Object with options to configure the Interactable instance.
 * @returns {Interactable} The Interactable instance created.
 */


ripe.Ripe.prototype.bindInteractable = function (element) {
  this.children.push(element);
  this.trigger("bound", element);
  return element;
};
/**
 * Unbinds ab Interactable from this Ripe instance.
 *
 * @param {Interactable} element The Interactable instance to be unbound.
 * @returns {Interactable} Returns the unbounded Interactable.
 */


ripe.Ripe.prototype.unbindInteractable = /*#__PURE__*/function () {
  var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(element) {
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return element.deinit();

          case 2:
            this.children.splice(this.children.indexOf(element), 1);
            this.trigger("unbound", element);

          case 4:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22, this);
  }));

  return function (_x24) {
    return _ref23.apply(this, arguments);
  };
}();
/**
 * Unbinds ab Image from this Ripe instance.
 *
 * @param {Image} element The Image instance to be unbound.
 * @returns {Image} Returns the unbounded Image.
 */


ripe.Ripe.prototype.unbindImage = ripe.Ripe.prototype.unbindInteractable;
/**
 * Unbinds ab Configurator from this Ripe instance.
 *
 * @param {Configurator} element The Image instance to be unbound.
 * @returns {Configurator} Returns the unbounded Configurator.
 */

ripe.Ripe.prototype.unbindConfigurator = ripe.Ripe.prototype.unbindInteractable;
/**
 * Selects a part of the model.
 * Triggers a 'selected_part' event with the part.
 *
 * @param {String} part The name of the part to be selected.
 * @param {Object} options An Object with options to configure the operation.
 */

ripe.Ripe.prototype.selectPart = function (part) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  this.trigger("selected_part", part);
};
/**
 * Deselects a part of the model.
 * Triggers a 'deselected_part' event with the part.
 *
 * @param {String} part The name of the part to be deselected.
 * @param {Object} options An Object with options to configure the operation.
 */


ripe.Ripe.prototype.deselectPart = function (part) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  this.trigger("deselected_part", part);
};
/**
 * Triggers the update of the children so that they represent the
 * current state of the model.
 *
 * This is considered the many state change operation and should be
 * called whenever a relevant internal state value is changed so that
 * the visuals are updated in accordance.
 *
 * @param {Object} state An Object with the current customization and
 * personalization, if not provided the current internal state of the
 * instance will be used instead.
 * @param {Object} options Set of update options that change the way
 * the update operation is going to be performed.
 * @param {Array} children The set of children that are going to be affected
 * by the updated operation, if not provided all of the currently registered
 * children in the instance will be used.
 * @return The result of the update operation, meaning that if any child
 * operation has been performed the result is true otherwise in case this is
 * a no-op from the "visual" point of view the result is false.
 */


ripe.Ripe.prototype.update = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
  var _this2 = this;

  var state,
      options,
      children,
      id,
      _update,
      result,
      _args24 = arguments;

  return _regeneratorRuntime.wrap(function _callee24$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          state = _args24.length > 0 && _args24[0] !== undefined ? _args24[0] : null;
          options = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : {};
          children = _args24.length > 2 && _args24[2] !== undefined ? _args24[2] : null;

          if (!(!options.force && (this.ready === false || this.configured === false))) {
            _context24.next = 5;
            break;
          }

          return _context24.abrupt("return", false);

        case 5:
          // tries to retrieve the state of the configuration for which an update
          // operation is going to be requested
          state = state || this._getState(); // defaults the children variable to the current set of registered
          // children, as expected by specification

          children = children || this.children; // increments the update counter, meaning that a new update operation
          // is going to be performed (and requires a proper unique identifier)

          this.updateCounter += 1;
          id = this.updateCounter;

          _update = /*#__PURE__*/function () {
            var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
              var promises, index, child, timestamp, results, result, canceled;
              return _regeneratorRuntime.wrap(function _callee23$(_context23) {
                while (1) {
                  switch (_context23.prev = _context23.next) {
                    case 0:
                      _context23.next = 2;
                      return _this2.trigger("pre_update", {
                        id: id,
                        state: state,
                        options: options
                      });

                    case 2:
                      promises = [];

                      for (index = 0; index < children.length; index++) {
                        child = children[index];
                        promises.push(child.update(state, options));
                      }

                      if (!_this2.ready) {
                        _context23.next = 7;
                        break;
                      }

                      _context23.next = 7;
                      return _this2.trigger("update", {
                        id: id,
                        state: state,
                        options: options
                      });

                    case 7:
                      // in case the use price flag is set then we should "automagically"
                      // retrieve the price for the currently changed configuration
                      if (_this2.ready && _this2.configured && _this2.usePrice) {
                        timestamp = Date.now();
                        _this2._priceTimestamp = timestamp;

                        _this2.getPriceP(state).then(function (value) {
                          if (_this2._priceTimestamp > timestamp) return;

                          _this2.trigger("price", value);
                        })["catch"](function (err) {
                          return _this2.trigger("price_error", err);
                        });
                      } // waits for all the promises "responsible" for the visual updating
                      // the children of the instance and then verifies if any of them was
                      // effectively updated (not cached), that is considered to be the
                      // result of the update operation as whole (indicates if this was an
                      // effective update operation or if otherwise was a cache match)


                      _context23.next = 10;
                      return Promise.all(promises);

                    case 10:
                      results = _context23.sent;
                      result = results.some(function (v) {
                        return v !== false;
                      });
                      canceled = results.some(function (v) {
                        return Boolean(v && v.canceled);
                      });
                      _context23.next = 15;
                      return _this2.trigger("post_update", {
                        id: id,
                        state: state,
                        options: options,
                        result: result,
                        canceled: canceled
                      });

                    case 15:
                      return _context23.abrupt("return", result);

                    case 16:
                    case "end":
                      return _context23.stop();
                  }
                }
              }, _callee23);
            }));

            return function _update() {
              return _ref25.apply(this, arguments);
            };
          }(); // runs the cancel operation, so that any pending update is canceled
          // without any possible visual changes and consuming the least resources
          // possible by any of the child elements


          _context24.next = 12;
          return this.cancel(options, children);

        case 12:
          if (!this.updatePromise) {
            _context24.next = 15;
            break;
          }

          _context24.next = 15;
          return this.updatePromise;

        case 15:
          this.updatePromise = null; // in case the current update operation is no longer the latest one then
          // there's no need to continue with the operation

          if (!(id !== this.updateCounter)) {
            _context24.next = 18;
            break;
          }

          return _context24.abrupt("return");

        case 18:
          _context24.prev = 18;
          this.updatePromise = _update();

          if (!options.noAwaitLayout) {
            _context24.next = 22;
            break;
          }

          return _context24.abrupt("return", true);

        case 22:
          _context24.next = 24;
          return this.updatePromise;

        case 24:
          result = _context24.sent;
          return _context24.abrupt("return", result);

        case 26:
          _context24.prev = 26;

          if (!options.noAwaitLayout) {
            this.updatePromise = null;
          }

          return _context24.finish(26);

        case 29:
        case "end":
          return _context24.stop();
      }
    }
  }, _callee24, this, [[18,, 26, 29]]);
}));
ripe.Ripe.prototype.cancel = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
  var _this3 = this;

  var options,
      children,
      _cancel,
      result,
      _args26 = arguments;

  return _regeneratorRuntime.wrap(function _callee26$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          options = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : {};
          children = _args26.length > 1 && _args26[1] !== undefined ? _args26[1] : null;
          // defaults the children variable to the current set of registered
          // children, as expected by specification
          children = children || this.children;

          _cancel = /*#__PURE__*/function () {
            var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
              var promises, index, child, results, result, canceled;
              return _regeneratorRuntime.wrap(function _callee25$(_context25) {
                while (1) {
                  switch (_context25.prev = _context25.next) {
                    case 0:
                      _context25.next = 2;
                      return _this3.trigger("pre_cancel", {
                        id: _this3.updateCounter
                      });

                    case 2:
                      promises = [];

                      for (index = 0; index < children.length; index++) {
                        child = children[index];
                        promises.push(child.cancel(options));
                      }

                      results = [];
                      _this3.cancelPromise = Promise.all(promises);
                      _context25.prev = 6;
                      _context25.next = 9;
                      return _this3.cancelPromise;

                    case 9:
                      results = _context25.sent;

                    case 10:
                      _context25.prev = 10;
                      _this3.cancelPromise = null;
                      return _context25.finish(10);

                    case 13:
                      result = results.some(function (v) {
                        return v !== false;
                      });
                      canceled = results.some(function (v) {
                        return Boolean(v && v.canceled);
                      }); // in case there's an update promise pending waits for it
                      // so that we're sure and safe that we can run a new one

                      if (!_this3.updatePromise) {
                        _context25.next = 18;
                        break;
                      }

                      _context25.next = 18;
                      return _this3.updatePromise;

                    case 18:
                      _context25.next = 20;
                      return _this3.trigger("post_cancel", {
                        id: _this3.updateCounter,
                        result: result,
                        canceled: canceled
                      });

                    case 20:
                      return _context25.abrupt("return", result);

                    case 21:
                    case "end":
                      return _context25.stop();
                  }
                }
              }, _callee25, null, [[6,, 10, 13]]);
            }));

            return function _cancel() {
              return _ref27.apply(this, arguments);
            };
          }();

          _context26.prev = 4;
          this.cancelPromise = _cancel();
          _context26.next = 8;
          return this.cancelPromise;

        case 8:
          result = _context26.sent;
          return _context26.abrupt("return", result);

        case 10:
          _context26.prev = 10;
          this.cancelPromise = null;
          return _context26.finish(10);

        case 13:
        case "end":
          return _context26.stop();
      }
    }
  }, _callee26, this, [[4,, 10, 13]]);
}));
/**
 * Reverses the last change to the parts. It is possible
 * to undo all the changes done from the initial state.
 */

ripe.Ripe.prototype.undo = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
  var parts;
  return _regeneratorRuntime.wrap(function _callee27$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          if (this.canUndo()) {
            _context27.next = 2;
            break;
          }

          return _context27.abrupt("return");

        case 2:
          this.historyPointer -= 1;
          parts = this.history[this.historyPointer];

          if (!parts) {
            _context27.next = 7;
            break;
          }

          _context27.next = 7;
          return this.setParts(parts, true, {
            action: "undo",
            partEvents: false
          });

        case 7:
        case "end":
          return _context27.stop();
      }
    }
  }, _callee27, this);
}));
/**
 * Executes the same operation as `undo` but goes all the way
 * to the bottom of the stack that controls the history.
 */

ripe.Ripe.prototype.undoAll = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
  var parts;
  return _regeneratorRuntime.wrap(function _callee28$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:
          if (this.canUndo()) {
            _context28.next = 2;
            break;
          }

          return _context28.abrupt("return");

        case 2:
          this.historyPointer = 0;
          parts = this.history[this.historyPointer];

          if (!parts) {
            _context28.next = 7;
            break;
          }

          _context28.next = 7;
          return this.setParts(parts, true, {
            action: "undo",
            partEvents: false
          });

        case 7:
        case "end":
          return _context28.stop();
      }
    }
  }, _callee28, this);
}));
/**
 * Reapplies the last change to the parts that was undone.
 * Notice that if there's a change when the history pointer
 * is in the middle of the stack the complete stack forward
 * is removed (history re-written).
 */

ripe.Ripe.prototype.redo = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
  var parts;
  return _regeneratorRuntime.wrap(function _callee29$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          if (this.canRedo()) {
            _context29.next = 2;
            break;
          }

          return _context29.abrupt("return");

        case 2:
          this.historyPointer += 1;
          parts = this.history[this.historyPointer];

          if (!parts) {
            _context29.next = 7;
            break;
          }

          _context29.next = 7;
          return this.setParts(parts, true, {
            action: "redo",
            partEvents: false
          });

        case 7:
        case "end":
          return _context29.stop();
      }
    }
  }, _callee29, this);
}));
/**
 * Executes the same operation as `redo` but goes all the way
 * to the top of the stack that controls the history.
 */

ripe.Ripe.prototype.redoAll = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
  var parts;
  return _regeneratorRuntime.wrap(function _callee30$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          if (this.canRedo()) {
            _context30.next = 2;
            break;
          }

          return _context30.abrupt("return");

        case 2:
          this.historyPointer = this.history.length - 1;
          parts = this.history[this.historyPointer];

          if (!parts) {
            _context30.next = 7;
            break;
          }

          _context30.next = 7;
          return this.setParts(parts, true, {
            action: "redo",
            partEvents: false
          });

        case 7:
        case "end":
          return _context30.stop();
      }
    }
  }, _callee30, this);
}));
/**
 * Indicates if there are part changes to undo.
 *
 * @returns {Boolean} If there are changes to reverse in the
 * current parts history stack.
 */

ripe.Ripe.prototype.canUndo = function () {
  return this.historyPointer > 0;
};
/**
 * Indicates if there are part changes to redo.
 *
 * @returns {Boolean} If there are changes to reapply pending
 * in the history stack.
 */


ripe.Ripe.prototype.canRedo = function () {
  return this.history.length - 1 > this.historyPointer;
};
/**
 * Returns a promise that is fulfilled once the Ripe Instance
 * is ready to be used.
 *
 * This can be used to actively wait for the initialization of
 * the Ripe Instance under an async environment.
 *
 * @returns {Promise} The promise to be fulfilled once the instance
 * is ready to be used.
 */


ripe.Ripe.prototype.isReady = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
  var _this4 = this;

  return _regeneratorRuntime.wrap(function _callee31$(_context31) {
    while (1) {
      switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return new Promise(function (resolve, reject) {
            if (_this4.ready) {
              resolve();
            } else if (_this4.error) {
              reject(_this4.error);
            } else {
              _this4.bind("ready", resolve);

              _this4.bind("error", reject);
            }
          });

        case 2:
        case "end":
          return _context31.stop();
      }
    }
  }, _callee31);
}));
/**
 * Returns a promise that is resolved once the remote locale bundles
 * are retrieved from their remote locations.
 *
 * This is relevant for situations where proper location is required
 * for a certain scenario (eg: sizes).
 *
 * @returns {Promise} The promise to be fulfilled on the base locale
 * bundles are loaded.
 */

ripe.Ripe.prototype.hasBundles = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
  var _this5 = this;

  return _regeneratorRuntime.wrap(function _callee32$(_context32) {
    while (1) {
      switch (_context32.prev = _context32.next) {
        case 0:
          _context32.next = 2;
          return new Promise(function (resolve, reject) {
            if (_this5.bundles) resolve();else _this5.bind("bundles", resolve);
          });

        case 2:
        case "end":
          return _context32.stop();
      }
    }
  }, _callee32);
}));
/**
 * Registers a plugin to this Ripe instance.
 *
 * @param {Plugin} plugin The plugin to be registered.
 */

ripe.Ripe.prototype.addPlugin = function (plugin) {
  plugin.register(this);
  this.plugins.push(plugin);
};
/**
 * Unregisters a plugin to this Ripe instance.
 *
 * @param {Plugin} plugin The plugin to be unregistered.
 */


ripe.Ripe.prototype.removePlugin = function (plugin) {
  plugin.unregister(this);
  this.plugins.splice(this.plugins.indexOf(plugin), 1);
};
/**
 * Normalizes the parts dictionary by taking into account optional parts
 * that should be set even for empty situations.
 *
 * @param {Object} parts The parts object that should be cloned and then
 * ensured to have the optional parts set.
 * @returns {Object} A copy of the provided parts with the optional parts
 * set even if not defined.
 */


ripe.Ripe.prototype.normalizeParts = function (parts) {
  if (!parts) return parts;
  var defaults = this.loadedConfig.defaults;

  var _parts = ripe.clone(parts);

  for (var part in defaults) {
    if (!defaults[part].optional) continue;
    if (_parts[part] !== undefined) continue;
    _parts[part] = {
      material: undefined,
      color: undefined
    };
  }

  return _parts;
};
/**
 * @ignore
 */


ripe.Ripe.prototype._guessUrl = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
  var result, country;
  return _regeneratorRuntime.wrap(function _callee33$(_context33) {
    while (1) {
      switch (_context33.prev = _context33.next) {
        case 0:
          _context33.next = 2;
          return this.geoResolveP();

        case 2:
          result = _context33.sent;
          country = result.country ? result.country.iso_code : null;
          _context33.t0 = country;
          _context33.next = _context33.t0 === "CN" ? 7 : 12;
          break;

        case 7:
          this.url = "https://app.cn.platforme.com:8444/api/";
          this.webUrl = "https://app.cn.platforme.com:8444/";
          this.options.url = this.url;
          this.options.webUrl = this.webUrl;
          return _context33.abrupt("break", 17);

        case 12:
          this.url = "https://app.platforme.com/api/";
          this.webUrl = "https://app.platforme.com/";
          this.options.url = this.url;
          this.options.webUrl = this.webUrl;
          return _context33.abrupt("break", 17);

        case 17:
        case "end":
          return _context33.stop();
      }
    }
  }, _callee33, this);
}));
/**
 * @ignore
 */

ripe.Ripe.prototype._initBundles = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
  var locale,
      defaultLocale,
      globalBundleP,
      sizesBundleP,
      _yield$Promise$all,
      _yield$Promise$all2,
      globalBundle,
      sizesBundle,
      _args34 = arguments;

  return _regeneratorRuntime.wrap(function _callee34$(_context34) {
    while (1) {
      switch (_context34.prev = _context34.next) {
        case 0:
          locale = _args34.length > 0 && _args34[0] !== undefined ? _args34[0] : null;
          defaultLocale = _args34.length > 1 && _args34[1] !== undefined ? _args34[1] : "en_us";
          locale = locale || this.locale || defaultLocale;
          globalBundleP = this.localeBundleP(locale, "scales");
          sizesBundleP = this.localeBundleP(locale, "sizes");
          _context34.next = 7;
          return Promise.all([globalBundleP, sizesBundleP]);

        case 7:
          _yield$Promise$all = _context34.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
          globalBundle = _yield$Promise$all2[0];
          sizesBundle = _yield$Promise$all2[1];
          this.addBundle(globalBundle, locale);
          this.addBundle(sizesBundle, locale);
          this.bundles = true;
          this.trigger("bundles");

        case 15:
        case "end":
          return _context34.stop();
      }
    }
  }, _callee34, this);
}));
/**
 * @ignore
 */

ripe.Ripe.prototype._getState = function () {
  var safe = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return safe ? JSON.parse(JSON.stringify(this._getState(false))) : {
    brand: this.brand,
    model: this.model,
    parts: this.parts,
    initials: this.initials,
    engraving: this.engraving,
    initialsExtra: this.initialsExtra
  };
};
/**
 * @ignore
 */


ripe.Ripe.prototype._setPart = /*#__PURE__*/function () {
  var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(part, material, color) {
    var _this6 = this;

    var events,
        force,
        partInfo,
        isRequired,
        remove,
        current,
        isSame,
        value,
        updatePart,
        _args35 = arguments;
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            events = _args35.length > 3 && _args35[3] !== undefined ? _args35[3] : true;
            force = _args35.length > 4 && _args35[4] !== undefined ? _args35[4] : false;

            if (this.loadedConfig) {
              _context35.next = 4;
              break;
            }

            throw Error("Model config is not loaded");

          case 4:
            // if the material or color are not set then this
            // is considered a removal operation and the part
            // is removed from the parts structure if it's
            // optional or an error is thrown if it's required
            partInfo = this.loadedConfig.defaults[part];
            isRequired = partInfo.optional !== true;
            remove = Boolean(material && color) === false;

            if (!(isRequired && remove)) {
              _context35.next = 9;
              break;
            }

            throw Error("Part '".concat(part, "' can't be removed"));

          case 9:
            // retrieves the current value structure for the part
            // that is going to be changed and determines if its value
            // is already the same as the new one to be set, this is
            // going to influence the triggering of events
            current = this.parts[part] || {};
            isSame = remove ? current.material === undefined && current.color === undefined : current.material === material && current.color === color; // in case the current value for the part is already the same
            // as the requested new one and the force flag is not set returns
            // immediately with the false flag indicating that no operation
            // has been performed

            if (!(!force && isSame)) {
              _context35.next = 13;
              break;
            }

            return _context35.abrupt("return", false);

          case 13:
            // increments the part "change" counter, so that it's possible
            // o track unique part change operations
            this.partCounter++; // updates the value object with the newly requested values, notice
            // than in case this is a removal a null value is set for both the
            // material and color keys

            value = {
              material: remove ? null : material,
              color: remove ? null : color
            }; // "builds" the inline closure function that handles the
            // changing of the parts structure according to the new
            // requested state (material and color)

            updatePart = function updatePart() {
              if (remove) {
                delete _this6.parts[part];
              } else {
                _this6.parts[part] = value;
              }
            }; // in case no events should be raised for the part change
            // operation then just updates the parts structure and then
            // returns the control flow immediately


            if (events) {
              _context35.next = 19;
              break;
            }

            updatePart();
            return _context35.abrupt("return", true);

          case 19:
            _context35.next = 21;
            return this.trigger("pre_part", part, value);

          case 21:
            updatePart();
            _context35.next = 24;
            return this.trigger("part", part, value);

          case 24:
            _context35.next = 26;
            return this.trigger("post_part", part, value);

          case 26:
            return _context35.abrupt("return", true);

          case 27:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35, this);
  }));

  return function (_x25, _x26, _x27) {
    return _ref36.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.Ripe.prototype._setParts = /*#__PURE__*/function () {
  var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(update) {
    var events,
        index,
        part,
        _args36 = arguments;
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            events = _args36.length > 1 && _args36[1] !== undefined ? _args36[1] : true;
            index = 0;

          case 2:
            if (!(index < update.length)) {
              _context36.next = 9;
              break;
            }

            part = update[index];
            _context36.next = 6;
            return this._setPart(part[0], part[1], part[2], events);

          case 6:
            index++;
            _context36.next = 2;
            break;

          case 9:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36, this);
  }));

  return function (_x28) {
    return _ref37.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.Ripe.prototype._partsList = function (parts) {
  parts = parts || this.parts;
  var partsList = [];

  for (var part in parts) {
    var _value = parts[part];
    partsList.push([part, _value.material, _value.color]);
  }

  return partsList;
};
/**
 * @ignore
 */


ripe.Ripe.prototype._pushHistory = function () {
  if (!this.parts || !Object.keys(this.parts).length) {
    return;
  }

  if (ripe.equal(this.parts, this.history[this.historyPointer])) {
    return;
  }

  var _parts = this.normalizeParts(this.parts);

  this.history = this.history.slice(0, this.historyPointer + 1);
  this.history.push(_parts);
  this.historyPointer = this.history.length - 1;
};
/**
 * The default fallback error handler to be used for
 * every single detached async context.
 *
 * @param {Error} error The error that is going to be
 * handled.
 */


ripe.Ripe.prototype._errorHandler = function (error) {
  // sets the error in the current instance and then triggers the
  // error event on the current instance (notification)
  this.ready = this.ready || false;
  this.error = error;
  this.trigger("error", error);
  console.error(error.message || error);
};
/**
 * Handles the changes in the provided resulting context (ctx)
 * changing the internal state and triggering relevant events.
 *
 * @param {Object} result The resulting ctx object that is going to
 * be used in the changing of the internal state.
 */


ripe.Ripe.prototype._handleCtx = function (result) {
  var _this7 = this;

  // handles some of the pre-conditions for the handling of the
  // "received context", so that all the required fields for
  // handling are properly populated before the execution logic
  if (result === undefined || result === null) return;
  if (result.parts === undefined || result.parts === null) return; // runs the defaulting of the message meaning that a sequence (array)
  // is always defined for proper logic handling

  result.messages = result.messages === undefined ? [] : result.messages; // run the reset operation on the parts object as it's going
  // to be re-created using the provided context parts definition

  Object.keys(this.parts).forEach(function (key) {
    return delete _this7.parts[key];
  });
  this.parts = Object.assign(this.parts, result.parts);

  if (result.initials && !ripe.equal(result.initials, this.initialsExtra)) {
    this.setInitialsExtra(result.initials, true, false, {
      noRemote: true
    });
  }

  if (result.choices && !ripe.equal(result.choices, this.choices)) {
    this.setChoices(result.choices);
  }

  var _iterator2 = _createForOfIteratorHelper(result.messages),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _step2$value = _slicedToArray(_step2.value, 2),
          name = _step2$value[0],
          _value2 = _step2$value[1];

      this.trigger("message", name, _value2);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
};
/**
 * Builds the choices structure that is going to control
 * the state for parts materials and colors under the current
 * customization session.
 *
 * @param {Object} loadedConfig The configuration structure that
 * has just been loaded.
 * @returns {Object} The state object that can be used to control
 * the state of parts, materials and colors.
 */


ripe.Ripe.prototype._toChoices = function (loadedConfig) {
  var choices = {};

  var _iterator3 = _createForOfIteratorHelper(loadedConfig.parts),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var part = _step3.value;
      if (loadedConfig.defaults[part.name].hidden) continue;
      if (loadedConfig.hidden && loadedConfig.hidden.includes(part.name)) continue;
      var materialsState = {};
      choices[part.name] = {
        available: true,
        materials: materialsState
      };

      var _iterator4 = _createForOfIteratorHelper(part.materials),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var material = _step4.value;
          var colorsState = {};
          materialsState[material.name] = {
            available: true,
            colors: colorsState
          };

          var _iterator5 = _createForOfIteratorHelper(material.colors),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var color = _step5.value;
              colorsState[color] = {
                available: true
              };
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return choices;
};

ripe.Ripe.prototype._supportsWebp = function () {
  var element = document.createElement("canvas");
  if (!(element.getContext && element.getContext("2d"))) return false;
  return element.toDataURL("image/webp").indexOf("data:image/webp") === 0;
}; // eslint-disable-next-line no-unused-vars,no-var


var Ripe = ripe.Ripe;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(295);

var iterableToArray = __webpack_require__(296);

var unsupportedIterableToArray = __webpack_require__(165);

var nonIterableSpread = __webpack_require__(297);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _base_personalization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(176);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _base_personalization__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _base_size__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _base_size__WEBPACK_IMPORTED_MODULE_1__["a"]; });




/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Interface; });
var notImplementedMessage = function notImplementedMessage(method) {
  return "Method " + method + " not implemented";
};

var Interface = {
  methods: {
    /**
     * Called just before the modal window containing the personalization
     * is shown.
     */
    show: function show() {},

    /**
     * Called just before the modal window containing the personalization
     * is hidden.
     */
    hide: function hide() {},

    /**
     * Should restore the internal state of the personalization
     * back to the original empty values.
     */
    reset: function reset() {
      throw notImplementedMessage("reset");
    },
    setState: function setState(state) {
      throw notImplementedMessage("setState");
    },
    getState: function getState() {
      throw notImplementedMessage("getState");
    },

    /**
     * Returns a string that is going to be used as a label representing
     * the current state of the personalization in the tab panel.
     */
    getTabMessage: function getTabMessage() {
      throw notImplementedMessage("getTabMessage");
    }
    /**
     * @events
     *
     * "changed" with the instance as parameter, should be called whenever
     * the state is changed
     */

  }
};
/* harmony default export */ __webpack_exports__["b"] = (Interface);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Interface; });
var notImplementedMessage = function notImplementedMessage(method) {
  return "Method " + method + " not implemented";
};

var Interface = {
  methods: {
    /**
     * Called just before the modal window containing the size form
     * is shown.
     */
    show: function show() {},

    /**
     * Called just before the modal window containing the size form
     * is hidden.
     */
    hide: function hide() {},

    /**
     * Should restore the internal state of the size form
     * back to the original empty values.
     */
    reset: function reset() {
      throw notImplementedMessage("reset");
    },
    setState: function setState(state) {
      throw notImplementedMessage("setState");
    },
    getState: function getState() {
      throw notImplementedMessage("getState");
    },

    /**
     * Returns a string that is going to be used as a label representing
     * the current state of the size to be shown to the user.
     */
    getSizeText: function getSizeText() {
      throw notImplementedMessage("getSizeText");
    }
    /**
     * @events
     *
     * "changed" with the instance as parameter, should be called whenever
     * the state is changed
     */

  }
};
/* harmony default export */ __webpack_exports__["b"] = (Interface);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _reference_vue_vue_type_template_id_e3301666_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(135);
/* harmony import */ var _reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _reference_vue_vue_type_style_index_0_id_e3301666_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(306);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _reference_vue_vue_type_template_id_e3301666_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _reference_vue_vue_type_template_id_e3301666_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "e3301666",
  null
  
)

/* harmony default export */ __webpack_exports__["b"] = (component.exports);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(299);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}

ripe.Ripe.plugins = ripe.Ripe.plugins || {};
/**
 * @class
 * @augments Observable
 * @classdesc Base class of a Ripe Plugin.
 */

ripe.Ripe.plugins.Plugin = function () {
  ripe.Observable.call(this);
};

ripe.Ripe.plugins.Plugin.prototype = ripe.build(ripe.Observable.prototype);
ripe.Ripe.plugins.Plugin.prototype.constructor = ripe.Ripe.plugins.Plugin;
/**
 * Registers this plugin to the provided Ripe instance.
 *
 * @param {Ripe} owner The Ripe instance to register to.
 */

ripe.Ripe.plugins.Plugin.prototype.register = function (owner) {
  this.owner = owner;
  ripe.Observable.prototype.init.call(this);
};
/**
 * Unregisters this plugin from its owner.
 *
 * @param {Ripe} owner The Ripe instance to unregister from.
 */


ripe.Ripe.plugins.Plugin.prototype.unregister = function (owner) {
  this.owner = null;
  ripe.Observable.prototype.deinit.call(this);
};

if (true) {
  module.exports = {
    ripe: ripe
  };
}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "install", function() { return install; });
/* harmony import */ var _atoms__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _forms__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
/* harmony import */ var _molecules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68);
/* harmony import */ var _organisms__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90);
/* harmony import */ var _logic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return _atoms__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _atoms__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonPlatforme", function() { return _atoms__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return _atoms__WEBPACK_IMPORTED_MODULE_0__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return _atoms__WEBPACK_IMPORTED_MODULE_0__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Loader", function() { return _atoms__WEBPACK_IMPORTED_MODULE_0__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return _atoms__WEBPACK_IMPORTED_MODULE_0__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InitialsImages", function() { return _forms__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InitialsInputs", function() { return _forms__WEBPACK_IMPORTED_MODULE_1__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "personalizationForm", function() { return _forms__WEBPACK_IMPORTED_MODULE_1__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sizeForm", function() { return _forms__WEBPACK_IMPORTED_MODULE_1__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ask", function() { return _molecules__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentPlugin", function() { return _molecules__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Keyboard", function() { return _molecules__WEBPACK_IMPORTED_MODULE_2__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return _molecules__WEBPACK_IMPORTED_MODULE_2__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RestrictionsAlert", function() { return _molecules__WEBPACK_IMPORTED_MODULE_2__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _molecules__WEBPACK_IMPORTED_MODULE_2__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return _molecules__WEBPACK_IMPORTED_MODULE_2__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Thumbnails", function() { return _molecules__WEBPACK_IMPORTED_MODULE_2__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ThumbnailsGroups", function() { return _molecules__WEBPACK_IMPORTED_MODULE_2__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Configurator", function() { return _organisms__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Personalization", function() { return _organisms__WEBPACK_IMPORTED_MODULE_3__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pickers", function() { return _organisms__WEBPACK_IMPORTED_MODULE_3__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Size", function() { return _organisms__WEBPACK_IMPORTED_MODULE_3__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Global", function() { return _logic__WEBPACK_IMPORTED_MODULE_4__["a"]; });






var install = function install(Vue) {
  Vue.use(_atoms__WEBPACK_IMPORTED_MODULE_0__[/* default */ "h"]);
  Vue.use(_forms__WEBPACK_IMPORTED_MODULE_1__[/* default */ "c"]);
  Vue.use(_molecules__WEBPACK_IMPORTED_MODULE_2__[/* default */ "j"]);
  Vue.use(_organisms__WEBPACK_IMPORTED_MODULE_3__[/* default */ "e"]);
  Vue.use(_logic__WEBPACK_IMPORTED_MODULE_4__[/* default */ "b"]);
};





/* harmony default export */ __webpack_exports__["default"] = (install);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(240);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Money", function() { return _money__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _readable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(241);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "readable", function() { return _readable__WEBPACK_IMPORTED_MODULE_1__["a"]; });




/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _bus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(242);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "busPlugin", function() { return _bus__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _locale__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(243);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "localePlugin", function() { return _locale__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _ripe__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(244);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ripePlugin", function() { return _ripe__WEBPACK_IMPORTED_MODULE_2__["a"]; });





/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Plugin", function() { return Plugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerPlugin", function() { return registerPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unregisterPlugin", function() { return unregisterPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlugin", function() { return getPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasPlugin", function() { return hasPlugin; });
var plugins = [];
var Plugin = function Plugin(name, version, options) {
  this.name = name;
  this.version = version;
  this.options = options;
};
var registerPlugin = function registerPlugin(plugin) {
  plugins.push(plugin);
};
var unregisterPlugin = function unregisterPlugin(plugin) {
  var index = plugins.indexOf(plugin);

  if (index === -1) {
    return;
  }

  plugins.splice(index, 1);
};
var getPlugin = function getPlugin(name, options) {
  return plugins.find(function (plugin) {
    return plugin.name === name;
  });
};
var hasPlugin = function hasPlugin(name) {
  return typeof plugins.find(function (plugin) {
    return plugin.name === name;
  }) !== "undefined";
};
/* harmony default export */ __webpack_exports__["default"] = ({
  Plugin: Plugin,
  registerPlugin: registerPlugin,
  unregisterPlugin: unregisterPlugin,
  getPlugin: getPlugin,
  hasPlugin: hasPlugin
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_base_personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_base_personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_base_personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BasePersonalization; });
/* harmony import */ var _vue_components_forms__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);

var BasePersonalization = {
  "extends": _vue_components_forms__WEBPACK_IMPORTED_MODULE_0__[/* personalizationForm */ "d"].Reference
};
/* harmony default export */ __webpack_exports__["b"] = (BasePersonalization);

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_images_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_images_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_images_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitialsImages; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);


function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var InitialsImages = {
  name: "initials-images",
  props: {
    groups: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    activeGroup: {
      type: String,
      "default": null
    },

    /**
     * If the images associated with the groups that are
     * currently "inactive" should be hidden from the
     * viewport instead of "just" being marked as not active.
     */
    hideInactive: {
      type: Boolean,
      "default": false
    },
    initialsBuilder: {
      type: Function,
      "default": null
    },
    imageHeight: {
      type: Number,
      "default": null
    },
    imageBorderRadius: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      loaded: {},
      initialsImages: []
    };
  },
  watch: {
    groups: function groups(value) {
      var _this = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.unbindImages();

              case 2:
                _context.next = 4;
                return _this.bindImages();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    initialsBuilder: function initialsBuilder(value) {
      var _this2 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.unbindImages();

              case 2:
                _context2.next = 4;
                return _this2.bindImages();

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function () {
    var _mounted = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee3() {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.bindImages();

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function mounted() {
      return _mounted.apply(this, arguments);
    }

    return mounted;
  }(),
  destroyed: function () {
    var _destroyed = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee4() {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.unbindImages();

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function destroyed() {
      return _destroyed.apply(this, arguments);
    }

    return destroyed;
  }(),
  methods: {
    bindImages: function bindImages() {
      var _arguments = arguments,
          _this3 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee5() {
        var update, initialsImages, _iterator, _step, initialsImage, image;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                update = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;
                _this3.loaded = {};
                _this3.initialsImages = [];
                initialsImages = _this3.$refs.initialsImages || [];
                _iterator = _createForOfIteratorHelper(initialsImages);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    initialsImage = _step.value;
                    image = _this3.$ripe.bindImage(initialsImage, {
                      showInitials: true,
                      initialsGroup: initialsImage.dataset.group,
                      initialsBuilder: _this3.initialsBuilder
                    });

                    _this3.initialsImages.push(image);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                if (!update) {
                  _context5.next = 9;
                  break;
                }

                _context5.next = 9;
                return _this3.$ripe.update();

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    unbindImages: function unbindImages() {
      var _arguments2 = arguments,
          _this4 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee7() {
        var update, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                update = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : false;
                _context7.next = 3;
                return Promise.all(_this4.initialsImages.map( /*#__PURE__*/function () {
                  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee6(image) {
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            return _context6.abrupt("return", _this4.$ripe.unbindImage(image));

                          case 1:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 3:
                result = _context7.sent;

                if (!update) {
                  _context7.next = 7;
                  break;
                }

                _context7.next = 7;
                return _this4.$ripe.update();

              case 7:
                return _context7.abrupt("return", result);

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    groupKey: function groupKey(group) {
      return [this.brand, this.model, group].join(":");
    },
    groupVisible: function groupVisible(group) {
      if (!this.hideInactive) return true;
      return group === this.activeGroup;
    },
    groupStyle: function groupStyle(group) {
      var base = {};
      if (this.imageHeight) base["max-height"] = "".concat(this.imageHeight, "px");
      if (this.imageBorderRadius) base["border-radius"] = "".concat(this.imageBorderRadius);
      return base;
    },
    groupClasses: function groupClasses(group) {
      var base = {
        active: group === this.activeGroup,
        selectable: this.groups.length > 1,
        loaded: this.loaded[group]
      };
      return base;
    },
    onClick: function onClick(group) {
      this.$emit("image-selected", group);
    },
    onLoaded: function onLoaded(group) {
      this.$set(this.loaded, group, true);
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (InitialsImages);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_inputs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_inputs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_inputs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InitialsInputs; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var InitialsInputs = {
  name: "initials-inputs",
  props: {
    groups: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    activeGroup: {
      type: String,
      "default": null
    },
    initialsText: {
      type: Function,
      "default": null
    },
    groupLabel: {
      type: Function,
      "default": function _default(group) {
        return this.locale("ripe_commons.".concat(this.brand, ".personalization.label.").concat(group));
      }
    }
  },
  methods: {
    inputSelected: function inputSelected(group) {
      this.$emit("input-selected", group);
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (InitialsInputs);

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reference; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _interface_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Reference = {
  name: "reference-personalization",
  mixins: [_interface_js__WEBPACK_IMPORTED_MODULE_4__[/* default */ "b"]],
  props: {
    /**
     * The sequence of property names for the properties that are
     * going to have their values used as part of the tab message
     * string construction process.
     */
    tabProperties: {
      type: Array,
      "default": function _default() {
        return ["font", "font_size", "style", "position", "color"];
      }
    }
  },
  data: function data() {
    return {
      /**
       * Dictionary that maps each initials group to objects that map each
       * of the property types with the selected value. This is a dictionary
       * based representation of the engraving.
       */
      propertiesData: {},

      /**
       * An object that maps for each group the value (text) of the initials.
       */
      initialsText: {},

      /**
       * The name of the groups that are currently available for personalization.
       */
      groups: [],

      /**
       * The height (in pixels) of the image that is going to be used to
       * display the personalization initials.
       */
      imageHeight: 300
    };
  },
  computed: {
    brand: function brand() {
      return this.$store.state.brand;
    },
    model: function model() {
      return this.$store.state.model;
    },
    configInitials: function configInitials() {
      return this.$store.state.config.initials;
    },
    configMeta: function configMeta() {
      return this.$store.state.config.meta || {};
    },

    /**
     * The radius of the border for the image that is going to be used in
     * the display of the initials.
     */
    imageBorderRadius: function imageBorderRadius() {
      if (!this.$store.state.hasInitialsRadius) return "0px";
      var initialsImage = this.configMeta.initials_image || {};
      return initialsImage.border_radius === undefined ? "50%" : initialsImage.border_radius;
    },
    state: function state() {
      return {
        initials: this.__getInitialsText(),
        engraving: this.propertiesToEngraving(),
        initialsExtra: this.__getInitials()
      };
    },
    valid: function valid() {
      return this.allPropertiesOrEmpty(this.groups, this.initialsText, this.propertiesData, this.properties());
    }
  },
  watch: {
    state: {
      handler: function handler() {
        this.$emit("changed", this);
      },
      deep: true
    },
    propertiesData: {
      handler: function handler() {
        this.$ripe.update();
      }
    },
    valid: {
      handler: function handler(value) {
        this.$emit("update:valid", value);
      },
      immediate: true
    }
  },
  created: function () {
    var _created = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee2() {
      var _this = this;

      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              this.onPostConfig = this.$bus.bind("post_config", /*#__PURE__*/function () {
                var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee(config, options) {
                  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return _this.refresh();

                        case 2:
                          // clean personalization when switching models
                          // as it may not be directly compatible
                          _this.reset();

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x, _x2) {
                  return _ref.apply(this, arguments);
                };
              }());
              this.onLocaleMapChanged = this.$bus.bind("locale_map_changed", function () {
                return _this.$forceUpdate();
              }); // runs the initial refresh operation to obtain the
              // model's target initials groups

              _context2.next = 4;
              return this.refresh();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  destroyed: function destroyed() {
    if (this.onLocaleMapChanged) this.$bus.unbind(this.onLocaleMapChanged);
    if (this.onPostConfig) this.$bus.unbind(this.onPostConfig);
  },
  methods: {
    reset: function reset() {
      var _this2 = this;

      this.propertiesData = {};
      this.groups.forEach(function (group) {
        _this2.propertiesData[group] = {};
      });
      this.initialsText = {};
    },
    setState: function setState(state) {
      this.reset();
      var initialsExtra = state.initialsExtra || {};

      for (var group in initialsExtra) {
        var initials = initialsExtra[group].initials || "";
        this.$set(this.initialsText, group, initials);
        var engraving = initialsExtra[group].engraving || "";
        this.$set(this.propertiesData, group, {});
        this.engravingToProperties(engraving, group);
      }
    },
    getState: function getState() {
      return this.state;
    },
    getTabMessage: function getTabMessage() {
      var _this3 = this;

      return Object.entries(this.initialsText).map(function (_ref2) {
        var _ref3 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_ref2, 2),
            group = _ref3[0],
            initials = _ref3[1];

        var text = [initials];

        _this3.tabProperties.forEach(function (propertyName) {
          var property = _this3.propertiesData[group][propertyName];
          if (!property) return; // if there is only one single option,
          // then don't include it in the tab message

          var availableProperties = _this3.properties()[propertyName] || [];
          if (availableProperties.length < 2) return;
          text.push(_this3.locale("properties.".concat(propertyName, ".").concat(property), _this3.readable(_this3.capitalize(property))));
        });

        return text.join(" ");
      }).join(" ");
    },
    refresh: function refresh() {
      var _this4 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee3() {
        var initialsImage;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // updates the preferred initials image display settings using the meta
                // information present in the model's configuration (if existent)
                initialsImage = _this4.configMeta.initials_image || {};
                _this4.imageHeight = initialsImage.height === undefined ? 300 : initialsImage.height;
                _context3.prev = 2;
                _context3.next = 5;
                return _this4.$ripe.runLogicP({
                  brand: _this4.brand,
                  model: _this4.model,
                  method: "groups"
                });

              case 5:
                _this4.groups = _context3.sent;
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](2);
                // gives a default group if builds does not support remote
                // business logic (for the groups "method")
                _this4.groups = ["main"];

              case 11:
                // when loading a model with a personalization already set (URL)
                // the `setState()` is called first, so the state of personalization
                // must be conserved
                _this4.groups.forEach(function (group) {
                  _this4.propertiesData[group] = _this4.propertiesData[group] ? _this4.propertiesData[group] : {};
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[2, 8]]);
      }))();
    },
    properties: function properties() {
      var _this5 = this;

      var properties = this.configInitials.properties.map(function (property) {
        return {
          value: property.name,
          label: _this5.locale("properties.".concat(property.type, ".").concat(property.name), _this5.readable(_this5.capitalize(property.name))),
          type: property.type
        };
      });
      var result = {};
      properties.forEach(function (property) {
        result[property.type] = result[property.type] || [];
        result[property.type].push(property);
      });
      return result;
    },
    propertiesToEngraving: function propertiesToEngraving() {
      var group = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      group = group || Object.keys(this.propertiesData)[0];
      if (!group) return "";
      return Object.entries(this.propertiesData[group]).filter(function (_ref4) {
        var _ref5 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_ref4, 2),
            type = _ref5[0],
            value = _ref5[1];

        return Boolean(value);
      }).map(function (_ref6) {
        var _ref7 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_ref6, 2),
            type = _ref7[0],
            value = _ref7[1];

        return "".concat(value, ":").concat(type);
      }).join(".");
    },
    engravingToProperties: function engravingToProperties(engraving, group) {
      var _this6 = this;

      var _this$$ripe$parseEngr = this.$ripe.parseEngraving(engraving),
          valuesM = _this$$ripe$parseEngr.valuesM;

      Object.entries(valuesM).forEach(function (_ref8) {
        var _ref9 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_ref8, 2),
            property = _ref9[0],
            value = _ref9[1];

        _this6.onValueUpdate(value, group, property);
      });
    },
    showGroupLabel: function showGroupLabel(group) {
      return this.groups.length > 1 && group !== "main";
    },
    onValueUpdate: function onValueUpdate(value, group, type) {
      var newProperties = _objectSpread({}, this.propertiesData);

      if (!newProperties[group]) newProperties[group] = {};
      newProperties[group][type] = value;
      this.propertiesData = newProperties;
    },

    /**
     * "Generic" initials builder function that uses the current properties
     * context to build a series of extra profiles.
     *
     * This function is compliant with the expected initials builder interface.
     *
     * @param {String} initials The value of the initials to compute the computed
     * initials object.
     * @param {String} engraving The value of the engraving to compute the computed
     * initials object.
     * @param {Element} element The DOM element to be used in the "calculus" of the
     * final initials object.
     * @returns {Object} The computed initials object containing both the final
     * initials string value and profile(s) sequence.
     */
    __initialsBuilder: function __initialsBuilder(initials, engraving, element) {
      var _this7 = this;

      // uses the provided element to obtain the selected group and obtains the
      // "base" personalization profiles for such group
      var group = element.getAttribute("data-group");

      var profiles = this.__getPersonalizationProfiles(group); // iterates over each of the properties for the groups and builds the base
      // profiles with the property value with the group suffix and the basic
      // profile with "just" the property value


      Object.entries(this.propertiesData[group]).forEach(function (_ref10) {
        var _ref11 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1___default()(_ref10, 2),
            type = _ref11[0],
            value = _ref11[1];

        if (_this7.groups.length > 1) profiles.push(value + ":" + group);
        profiles.push(value);
      });
      profiles.push(group);
      return {
        initials: initials,
        profile: profiles
      };
    },
    __getPersonalizationProfiles: function __getPersonalizationProfiles(group) {
      var alias = this.configInitials.$alias;
      if (!alias) return [];
      var position = this.propertiesData[group] && this.propertiesData[group].position;
      return [].concat(position && group ? alias["step::personalization:".concat(position, ":").concat(group)] : [], position ? alias["step::personalization:".concat(position)] : [], group ? alias["step::personalization:".concat(group)] : [], alias["step::personalization"]).filter(function (v) {
        return v !== undefined;
      });
    },
    __getInitials: function __getInitials() {
      var _initials = {};

      for (var name in this.initialsText) {
        var group = {
          initials: this.initialsText[name],
          engraving: this.propertiesToEngraving(name)
        };
        _initials[name] = group;
      }

      return _initials;
    },
    __getInitialsText: function __getInitialsText() {
      var group = Object.keys(this.initialsText).length > 0 ? Object.keys(this.initialsText)[0] : null;
      return group ? this.initialsText[group] : "";
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Reference);

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reference; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _interface_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31);


function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Reference = {
  name: "reference",
  mixins: [_interface_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "b"]],
  props: {
    referenceScale: {
      type: String,
      "default": "it"
    },

    /**
     * If a possible single option for the size should
     * be automatically selected, disabling the sizes modal
     * from being displayed.
     */
    autoSingle: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      sizes: {},
      sizeOptions: {},
      gender: "",
      scale: "",
      size: null,
      sizesLoaded: false,
      active: true
    };
  },
  computed: {
    state: function state() {
      return {
        scale: this.scale,
        gender: this.gender,
        size: this.size,
        visibleScale: this.scale,
        visibleSize: this.__convertSize(this.gender, this.scale, this.size)
      };
    },
    modelGenders: function modelGenders() {
      return Object.keys(this.sizeOptions);
    },
    allowApply: function allowApply() {
      return this.size && this.scale && this.gender;
    },
    visibleGender: function visibleGender() {
      return this.gender || this.modelGenders[0];
    },
    visibleScale: function visibleScale() {
      return this.scale || this.__getAvailableScales(this.visibleGender)[0];
    }
  },
  watch: {
    state: {
      handler: function handler() {
        this.$emit("changed", this);
      },
      deep: true
    },
    sizesLoaded: {
      handler: function handler(value) {
        var event = value ? "enable_size" : "disable_size";
        this.$bus.trigger(event);
      },
      immediate: true
    },
    gender: function gender(_gender) {
      var scales = this.__getAvailableScales(this.gender);

      if (scales.includes(this.scale) === false) {
        this.scale = "";
      }
    },
    active: {
      handler: function handler(value) {
        this.$emit("update:active", value);
      }
    }
  },
  created: function () {
    var _created = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.__getSizes({
                config: this.config,
                genders: this.$store.state.genders
              });

            case 2:
              this.sizes = _context.sent;

              this.__showSizes();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    reset: function reset() {
      this.setState({});
    },
    setState: function setState(state) {
      this.gender = state.gender;
      this.scale = state.scale;
      this.size = state.size;
    },
    getState: function getState() {
      return this.state;
    },
    getSizeText: function getSizeText() {
      if (!this.gender || !this.scale || !this.size) {
        return "";
      }

      var hasGenders = this.modelGenders && this.modelGenders.length > 1;

      var sizeText = this.__convertSize(this.gender, this.scale, this.size);

      var scaleText = this.locale("scales.".concat(this.scale)).toUpperCase();
      var genderText = hasGenders ? this.locale("ripe_commons.size." + this.gender + ".small").toUpperCase() : "";
      var separatorText = scaleText && genderText ? "/" : "";
      return "".concat(sizeText, " ").concat(scaleText).concat(separatorText).concat(genderText);
    },
    __getSizes: function __getSizes(options) {
      return new Promise(function (resolve, reject) {
        // obtains the current options configuration value and
        // in case there're no available sizes raises a rejection
        // for upper stream promise
        var config = options.config;

        if (!config.sizes) {
          reject(new Error("No sizes available for config"));
          return;
        } // iterates through the config size scales and retrieves
        // their sizes if the scale has been defined as available
        // (to be shown to the user has a selection option)


        var sizes = {};

        for (var key in config.sizes) {
          // splits the (full) scale into its (base) scale and gender
          // components to be used to set the complete in a canonical way
          // an example of such scale splitting would be the separation
          // of "std:clothing:female" into scale "std:clothing" and gender "female"
          var scale = key.substring(0, key.lastIndexOf(":"));
          var gender = key.substring(key.lastIndexOf(":") + 1, key.length); // updates the sizes map for the gender and scale according to
          // the provided (full) scale key value

          sizes[gender] = sizes[gender] || {};
          sizes[gender][scale] = config.sizes[key];
        }

        resolve(sizes);
      });
    },
    __showSizes: function __showSizes() {
      var _this = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee2() {
        var sizeOptions, sizeValues, scales, values, genders, gender, genderScales, scale, sizes, _iterator, _step, size, sizePromise, localePromise, isSingle;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sizeOptions = {};
                sizeValues = [];
                scales = [];
                values = [];
                genders = [];
                _this.sizesLoaded = false;

                for (gender in _this.sizes) {
                  genderScales = _this.sizes[gender];

                  for (scale in genderScales) {
                    sizes = genderScales[scale] || [];
                    _iterator = _createForOfIteratorHelper(sizes);

                    try {
                      for (_iterator.s(); !(_step = _iterator.n()).done;) {
                        size = _step.value;
                        scales.push(scale);
                        values.push(size);
                        genders.push(gender);
                        sizeValues.push({
                          scale: scale,
                          gender: gender,
                          size: size
                        });
                      }
                    } catch (err) {
                      _iterator.e(err);
                    } finally {
                      _iterator.f();
                    }
                  }
                }

                values.forEach(function (value, index) {
                  var size = sizeValues[index];
                  var genderSizes = sizeOptions[size.gender] || {};
                  var scaleSizes = genderSizes[size.scale] || {};
                  var scaleSize = scaleSizes[size.size] || {};
                  scaleSize["native"] = value;
                  scaleSizes[size.size] = scaleSize;
                  genderSizes[size.scale] = scaleSizes;
                  sizeOptions[size.gender] = genderSizes;
                });
                sizePromise = _this.$ripe.nativeToSizeBP(scales, values, genders).then(function (response) {
                  response.forEach(function (value, index) {
                    var size = sizeValues[index];
                    var genderSizes = sizeOptions[size.gender] || {};
                    var scaleSizes = genderSizes[size.scale] || {};
                    var scaleSize = scaleSizes[size.size] || {};
                    scaleSize.size = value.value;
                    scaleSizes[size.size] = scaleSize;
                    genderSizes[size.scale] = scaleSizes;
                    sizeOptions[size.gender] = genderSizes;
                  });
                });
                localePromise = _this.$ripe.nativeToLocaleBP(scales, values, genders).then(function (response) {
                  response.forEach(function (value, index) {
                    var size = sizeValues[index];
                    var genderSizes = sizeOptions[size.gender] || {};
                    var scaleSizes = genderSizes[size.scale] || {};
                    var scaleSize = scaleSizes[size.size] || {};
                    scaleSize.locale = value.value;
                    scaleSizes[size.size] = scaleSize;
                    genderSizes[size.scale] = scaleSizes;
                    sizeOptions[size.gender] = genderSizes;
                  });
                });
                _context2.next = 12;
                return Promise.all([sizePromise, localePromise]);

              case 12:
                // updates the complete set of available size options for
                // the current instance from the loaded ones
                _this.sizeOptions = sizeOptions; // if there is a single size option available for selection,
                // picks it automatically and marks the plugin as not active
                // since nothing can be changed (no modal is displayed)

                isSingle = scales.length === 1 && genders.length === 1 && values.length === 1;

                if (isSingle && _this.autoSingle) {
                  _this.__sizeSelected(genders[0], scales[0], values[0]);

                  _this.active = false;
                }

                _this.sizesLoaded = true;

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    __getAvailableScales: function __getAvailableScales(gender) {
      var sizes = this.sizeOptions[gender] || {};
      return Object.keys(sizes);
    },
    __sizeSelected: function __sizeSelected(gender, scale, size) {
      this.gender = gender;
      this.scale = scale;
      this.size = size;
    },
    __isSelected: function __isSelected(gender, scale, size) {
      return this.gender === gender && this.scale === scale && this.size === parseInt(size);
    },
    __convertSize: function __convertSize(gender, scale, size) {
      if (!(Object.keys(this.sizeOptions).length > 0 && gender && scale && size)) {
        return "";
      }

      var sizes = this.sizeOptions[gender][scale];
      var sizeM = sizes[String(size)];
      if (!sizeM) return "";
      return sizeM.locale;
    },
    __changeGender: function __changeGender(gender) {
      // updates the internal setting for the gender (effective change)
      this.gender = gender; // verifies if the size is already ready for selection (all values are set)
      // if not there's not remaining to be done

      var isReady = this.gender && this.scale && this.size;
      if (!isReady) return; // in case there's so size available for the scale in the new gender
      // then we must "reset" the size, avoiding possible errors

      var hasSize = Boolean(this.sizeOptions[this.gender][this.scale][String(this.size)]);
      if (!hasSize) this.size = null;
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Reference);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_multi_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_multi_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_multi_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReferenceMulti; });
/* harmony import */ var _reference_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32);
function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


var ReferenceMulti = {
  name: "reference-multi",
  "extends": _reference_vue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"],
  data: function data() {
    return {
      availableScales: ["it", "uk", "us", "jp", "ch"]
    };
  },
  methods: {
    __getSizes: function __getSizes(options) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        // unpacks the current model configuration to be used for
        // the size retrieval according to locales
        var config = options.config; // in case there are no sizes available for configuration
        // then raises an error as such situation is considered to
        // be an abnormal one

        if (!config.sizes) {
          reject(new Error("No sizes available for config"));
          return;
        } // iterates through the config size scales and retrieves
        // their sizes if the scale has been defined as available
        // (to be shown to the user has a selection option)


        var sizes = {};

        for (var key in config.sizes) {
          var scale = key.substring(0, key.lastIndexOf(":"));
          var gender = key.substring(key.lastIndexOf(":") + 1, key.length); // verifies if the current gender in iteration is allowed
          // within the set of allowed genders (in case one is defined)

          var isAllowed = options.genders ? options.genders.includes(gender) : true;
          if (!isAllowed) continue;
          sizes[gender] = sizes[gender] || {};
          sizes[gender][scale] = config.sizes[key];
        } // checks if any of the available scales has not been
        // defined and if not uses the sizes from the reference
        // scale for them


        for (var _gender in sizes) {
          var genderSizes = sizes[_gender];
          var scales = Object.keys(genderSizes);

          var _iterator = _createForOfIteratorHelper(_this.availableScales),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _key = _step.value;

              if (scales.includes(_key)) {
                continue;
              }

              var referenceSizes = genderSizes[_this.referenceScale];
              genderSizes[_key] = referenceSizes;
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          sizes[_gender] = genderSizes;
        }

        resolve(sizes);
      });
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (ReferenceMulti);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_base_size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_base_size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_base_size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseSize; });
/* harmony import */ var _vue_components_forms__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);

var BaseSize = {
  "extends": _vue_components_forms__WEBPACK_IMPORTED_MODULE_0__[/* sizeForm */ "e"].ReferenceMulti
};
/* harmony default export */ __webpack_exports__["b"] = (BaseSize);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _alert_alert_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(109);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _alert_alert_vue__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _button_button_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(110);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _button_button_vue__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _button_platforme_button_platforme_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(111);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _button_platforme_button_platforme_vue__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _icon_icon_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(112);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _icon_icon_vue__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _image_image_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(113);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _image_image_vue__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _loader_loader_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(114);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _loader_loader_vue__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _thumbnail_thumbnail_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(115);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _thumbnail_thumbnail_vue__WEBPACK_IMPORTED_MODULE_6__["a"]; });









var install = function install(Vue) {
  Vue.component("alert", _alert_alert_vue__WEBPACK_IMPORTED_MODULE_0__[/* Alert */ "a"]);
  Vue.component("button-ripe", _button_button_vue__WEBPACK_IMPORTED_MODULE_1__[/* Button */ "a"]);
  Vue.component("button-platforme", _button_platforme_button_platforme_vue__WEBPACK_IMPORTED_MODULE_2__[/* ButtonPlatforme */ "a"]);
  Vue.component("icon", _icon_icon_vue__WEBPACK_IMPORTED_MODULE_3__[/* Icon */ "a"]);
  Vue.component("image-ripe", _image_image_vue__WEBPACK_IMPORTED_MODULE_4__[/* Image */ "a"]);
  Vue.component("loader", _loader_loader_vue__WEBPACK_IMPORTED_MODULE_5__[/* Loader */ "a"]);
  Vue.component("thumbnail", _thumbnail_thumbnail_vue__WEBPACK_IMPORTED_MODULE_6__[/* Thumbnail */ "a"]);
};


/* harmony default export */ __webpack_exports__["h"] = (install);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Alert; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Alert = {
  name: "alert",
  props: {
    text: {
      type: String,
      "default": "hello world"
    },
    visible: {
      type: Boolean,
      "default": false
    },
    timeout: {
      type: Number,
      "default": 1000
    },
    topOffset: {
      type: Number,
      "default": 100
    },
    globalEvents: {
      type: Boolean,
      "default": true
    }
  },
  computed: {
    isVisible: function isVisible() {
      return this.visibleData;
    },
    style: function style() {
      var base = {};
      if (this.topOffset !== null) base.top = "".concat(this.topOffset, "px");
      return base;
    }
  },
  data: function data() {
    return {
      visibleData: this.visible,
      globalEventsData: this.globalEvents,
      textData: this.text,
      timeoutData: this.timeoutData,
      timer: null,
      key: true
    };
  },
  watch: {
    text: function text(value) {
      this.textData = value;
    },
    visible: function visible(value) {
      this.visibleData = value;
    },
    visibleData: function visibleData(value) {
      this.$emit("update:visible", value);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$bus.bind("alert", function (options) {
      return _this.show(options);
    });
    this.$bus.bind("hide-global", function () {
      if (!_this.globalEventsData) return;

      _this.hide();
    });
  },
  methods: {
    show: function show(options) {
      var _this2 = this;

      // unpacks the complete set of options for the new alert
      // that is going to be displayed
      var text = options.text,
          timeout = options.timeout,
          globalEvents = options.globalEvents,
          _options$reset = options.reset,
          reset = _options$reset === void 0 ? true : _options$reset; // updates the current local values taking into account
      // the provided set of options

      this.textData = text;
      this.timeoutData = timeout || this.timeout;
      this.globalEventsData = globalEvents || this.globalEvents; // sets the visible data value so that the current context
      // indicates that there's data available

      this.visibleData = true; // alternate the key to force the component
      // to be destroyed and mounted again

      if (reset) this.reset(); // ensures that the previously registered timeout
      // is cleared so that a new one can be created

      this.resetTimeout(); // creates the timeout that is going to be used to
      // hide and reset the current notification

      this.timer = setTimeout(function () {
        _this2.hide();

        _this2.reset();
      }, this.timeoutData);
    },
    hide: function hide() {
      if (!this.visibleData) return;
      this.visibleData = false;
    },
    reset: function reset() {
      this.key = !this.key;
    },
    resetTimeout: function resetTimeout() {
      if (!this.timer) return;
      clearTimeout(this.timer);
    },
    handleGlobal: function handleGlobal() {
      if (!this.globalEvents) return;
      if (this.visibleData) this.resetTimeout();
      this.hide();
    },
    onClick: function onClick() {
      this.hide();
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Alert);

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Button = {
  name: "button-ripe",
  props: {
    text: {
      type: String,
      "default": ""
    },
    design: {
      type: String,
      "default": null
    },
    alignment: {
      type: String,
      "default": null
    },
    active: {
      type: Boolean,
      "default": false
    },
    disabled: {
      type: Boolean,
      "default": false
    },
    loading: {
      type: Boolean,
      "default": false
    },
    loaderStyle: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    href: {
      type: String,
      "default": null
    },
    target: {
      type: String,
      "default": null
    }
  },
  computed: {
    alignmentStyle: function alignmentStyle() {
      if (this.alignment) return this.alignment;
      if (this.icon) return "right";
      return "center";
    },
    classes: function classes() {
      var base = {
        active: this.active,
        loading: this.loading,
        disabled: this.disabled
      };
      if (this.design) base["button-design-" + this.design] = this.design;

      if (this.alignmentStyle) {
        base["button-alignment-" + this.alignmentStyle] = this.alignmentStyle;
      }

      return base;
    }
  },
  methods: {
    onClick: function onClick(event) {
      if (this.disabled) return;

      if (this.href) {
        if (this.target) window.open(this.href, this.target);else document.location = this.href;
      }

      this.$emit("click", event);
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Button);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_platforme_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_platforme_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_button_platforme_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ButtonPlatforme; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var ButtonPlatforme = {
  name: "button-platforme",
  props: {
    normalText: {
      type: String,
      "default": "Sign in with Platforme ID"
    },
    loadingText: {
      type: String,
      "default": "Signing in Platforme ID..."
    },
    logo: {
      type: Boolean,
      "default": true
    },
    mode: {
      type: String,
      "default": "loading"
    },
    loaderStyle: {
      type: Object,
      "default": function _default() {
        return {
          "background-color": "$white"
        };
      }
    }
  },
  data: function data() {
    return {
      loading: false
    };
  },
  computed: {
    text: function text() {
      return this.loading ? this.loadingText : this.normalText;
    }
  },
  methods: {
    click: function click(event) {
      switch (this.mode) {
        case "loading":
          this.loading = true;
          break;
      }

      this.$emit("click", event);
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (ButtonPlatforme);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Icon = {
  name: "icon",
  props: {
    icon: {
      type: String | Object,
      required: true
    },
    color: {
      type: String,
      "default": null
    },
    fill: {
      type: String,
      "default": null
    },
    strokeWidth: {
      type: Number,
      "default": null
    },
    strokeLinecap: {
      type: String,
      "default": null
    },
    width: {
      type: Number,
      "default": null
    },
    height: {
      type: Number,
      "default": null
    },
    viewBox: {
      type: String,
      "default": null
    }
  },
  watch: {
    icon: function icon(value) {
      this.setAllSvgAttributes();
    },
    color: function color(value) {
      this.setSvgAttribute("stroke", value);
    },
    fill: function fill(value) {
      this.setSvgAttribute("fill", value);
    },
    strokeWidth: function strokeWidth(value) {
      this.setSvgAttribute("stroke-width", value);
    },
    strokeLinecap: function strokeLinecap(value) {
      this.setSvgAttribute("stroke-linecap", value);
    },
    width: function width(value) {
      this.setSvgAttribute("width", value);
    },
    height: function height(value) {
      this.setSvgAttribute("height", value);
    },
    viewBox: function viewBox(value) {
      this.setSvgAttribute("viewBox", value);
    }
  },
  computed: {
    svgFile: function svgFile() {
      try {
        var resource = this.icon;

        if (typeof this.icon === "string") {
          try {
            resource = __webpack_require__(318)("./".concat(this.icon, ".svg"));
          } catch (err) {
            resource = __webpack_require__(646)("./".concat(this.icon, ".svg"));
          }
        }

        return resource["default"];
      } catch (error) {
        this.logError("Error loading icon '".concat(this.icon, "'."), error);
      }
    }
  },
  methods: {
    onClick: function onClick(event) {
      this.$emit("click", event);
    },
    setSvgAttribute: function setSvgAttribute(attribute, value) {
      if (!this.$el.firstElementChild) return;
      if ([undefined, null].includes(value)) return;
      this.$el.firstElementChild.setAttribute(attribute, value);
    },
    setAllSvgAttributes: function setAllSvgAttributes() {
      var _this = this;

      var attrs = [{
        key: "stroke",
        value: this.color
      }, {
        key: "fill",
        value: this.fill
      }, {
        key: "stroke-width",
        value: this.strokeWidth
      }, {
        key: "stroke-linecap",
        value: this.strokeLinecap
      }, {
        key: "width",
        value: this.width
      }, {
        key: "height",
        value: this.height
      }, {
        key: "viewBox",
        value: this.viewBox
      }];
      this.$nextTick(function () {
        attrs.forEach(function (attr) {
          return _this.setSvgAttribute(attr.key, attr.value);
        });
      });
    }
  },
  mounted: function mounted() {
    this.setAllSvgAttributes();
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Icon);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_image_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_image_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_image_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Image = {
  name: "image-ripe",
  props: {
    src: {
      type: String,
      "default": null
    },
    srcError: {
      type: String,
      "default": null
    },
    alt: {
      type: String,
      "default": ""
    },
    width: {
      type: Number,
      "default": null
    },
    height: {
      type: Number,
      "default": null
    },
    maxWidth: {
      type: Number,
      "default": null
    },
    maxHeight: {
      type: Number,
      "default": null
    },
    fade: {
      type: Boolean,
      "default": true
    },
    hideError: {
      type: Boolean,
      "default": null
    }
  },
  data: function data() {
    return {
      srcData: this.src,
      loaded: false,
      errored: false
    };
  },
  watch: {
    src: function src(value) {
      this.srcData = value;
    }
  },
  computed: {
    hideErrorB: function hideErrorB() {
      if (this.hideError !== null && this.hideError !== undefined) {
        return this.hideError;
      }

      return !this.srcError;
    },
    style: function style() {
      var base = {};
      if (![undefined, null].includes(this.width)) base.width = this.width + "px";
      if (![undefined, null].includes(this.height)) base.height = this.height + "px";

      if (![undefined, null].includes(this.maxWidth)) {
        base["max-width"] = this.maxWidth + "px";
      }

      if (![undefined, null].includes(this.maxHeight)) {
        base["max-height"] = this.maxHeight + "px";
      }

      return base;
    },
    classes: function classes() {
      var base = {
        loaded: this.loaded,
        errored: this.errored,
        "no-fade": !this.fade,
        "hide-error": this.hideErrorB
      };
      return base;
    }
  },
  methods: {
    onLoad: function onLoad(event) {
      this.loaded = true;
      this.errored = false;
      this.$emit("load", event);
    },
    onClick: function onClick(event) {
      this.$emit("click", event);
    },
    onError: function onError(event) {
      this.loaded = false;
      this.errored = true;
      if (this.srcError) this.srcData = this.srcError;
      this.$emit("error", event);
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Image);

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(65);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Loader; });
/* harmony import */ var loaders_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(651);
/* harmony import */ var loaders_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(loaders_css__WEBPACK_IMPORTED_MODULE_0__);
//
//
//
//
//
//
//
//

var Loader = {
  name: "loader",
  props: {
    loader: {
      type: String,
      "default": "ball-pulse"
    },
    count: {
      type: Number,
      "default": 3
    },
    loaderStyle: {
      type: Object,
      "default": function _default() {
        return {
          "background-color": "#5d5d5d"
        };
      }
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Loader);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnail_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnail_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnail_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Thumbnail; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Thumbnail = {
  name: "thumbnail",
  props: {
    frame: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      "default": null
    },
    crop: {
      type: Boolean,
      "default": null
    }
  },
  data: function data() {
    return {
      image: null,
      loaded: false
    };
  },
  computed: {
    active: function active() {
      return this.frame === this.$store.state.currentFrame;
    }
  },
  methods: {
    showFrame: function showFrame() {
      this.$bus.trigger("show_frame", this.frame);
    },
    onLoaded: function onLoaded() {
      this.loaded = true;
    }
  },
  mounted: function mounted() {
    this.image = this.$ripe.bindImage(this.$refs.image, {
      frame: this.frame,
      size: this.size || undefined,
      crop: this.crop || undefined
    });
  },
  destroyed: function () {
    var _destroyed = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!this.image) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return this.$ripe.unbindImage(this.image);

            case 3:
              this.image = null;

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function destroyed() {
      return _destroyed.apply(this, arguments);
    }

    return destroyed;
  }()
};
/* harmony default export */ __webpack_exports__["b"] = (Thumbnail);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ask_ask_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(116);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _ask_ask_vue__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _component_plugin_component_plugin_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _component_plugin_component_plugin_vue__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _keyboard_keyboard_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(118);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _keyboard_keyboard_vue__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _modal_modal_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(119);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _modal_modal_vue__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var _restrictions_alert_restrictions_alert_vue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(120);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "e", function() { return _restrictions_alert_restrictions_alert_vue__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var _tabs_tab_vue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(121);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "f", function() { return _tabs_tab_vue__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var _tabs_tabs_vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(122);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "g", function() { return _tabs_tabs_vue__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony import */ var _thumbnails_thumbnails_vue__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(123);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "h", function() { return _thumbnails_thumbnails_vue__WEBPACK_IMPORTED_MODULE_7__["a"]; });

/* harmony import */ var _thumbnails_groups_thumbnails_groups_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(124);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "i", function() { return _thumbnails_groups_thumbnails_groups_vue__WEBPACK_IMPORTED_MODULE_8__["a"]; });











var install = function install(Vue) {
  Vue.component("ask", _ask_ask_vue__WEBPACK_IMPORTED_MODULE_0__[/* Ask */ "a"]);
  Vue.component("component-plugin", _component_plugin_component_plugin_vue__WEBPACK_IMPORTED_MODULE_1__[/* ComponentPlugin */ "a"]);
  Vue.component("keyboard", _keyboard_keyboard_vue__WEBPACK_IMPORTED_MODULE_2__[/* Keyboard */ "a"]);
  Vue.component("modal", _modal_modal_vue__WEBPACK_IMPORTED_MODULE_3__[/* Modal */ "a"]);
  Vue.component("restrictions-alert", _restrictions_alert_restrictions_alert_vue__WEBPACK_IMPORTED_MODULE_4__[/* RestrictionsAlert */ "a"]);
  Vue.component("tab", _tabs_tab_vue__WEBPACK_IMPORTED_MODULE_5__[/* Tab */ "a"]);
  Vue.component("tabs", _tabs_tabs_vue__WEBPACK_IMPORTED_MODULE_6__[/* Tabs */ "a"]);
  Vue.component("thumbnails", _thumbnails_thumbnails_vue__WEBPACK_IMPORTED_MODULE_7__[/* Thumbnails */ "a"]);
  Vue.component("thumbnails-groups", _thumbnails_groups_thumbnails_groups_vue__WEBPACK_IMPORTED_MODULE_8__[/* ThumbnailsGroups */ "a"]);
};


/* harmony default export */ __webpack_exports__["j"] = (install);

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ask_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ask_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_ask_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ask; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Ask = {
  name: "ask",
  mixins: [_mixins__WEBPACK_IMPORTED_MODULE_2__["modalMixin"]],
  props: {
    callback: {
      type: Function,
      "default": null
    },
    operation: {
      type: Function,
      "default": null
    },
    title: {
      type: String,
      "default": "Title"
    },
    message: {
      type: String,
      "default": "Message"
    },
    buttonConfirm: {
      type: String,
      "default": "Confirm"
    },
    buttonCancel: {
      type: String,
      "default": "Cancel"
    },
    global: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      callbackData: this.callback,
      operationData: this.operation,
      titleData: this.title,
      messageData: this.message,
      buttonConfirmData: this.buttonConfirm,
      buttonCancelData: this.buttonCancel,
      loading: false
    };
  },
  computed: {
    messageHtml: function messageHtml() {
      if (!this.messageData) return this.messageData;
      return this.messageData.replace(/\n/g, "<br/>");
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (this.global) {
      this.$bus.bind("ask", function (options) {
        _this.callbackData = options.callback || null;
        _this.operationData = options.operation || null;
        _this.titleData = options.title || "Title";
        _this.messageData = options.message || "Message";
        _this.buttonConfirmData = options.buttonConfirm === undefined ? "Confirm" : options.buttonConfirm;
        _this.buttonCancelData = options.buttonCancel === undefined ? "Cancel" : options.buttonCancel;

        _this.showModal();
      });
    }
  },
  methods: {
    onCancelClick: function onCancelClick() {
      var _this2 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.hideModal(false);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onConfirmClick: function onConfirmClick() {
      var _this3 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;
                _context2.prev = 1;

                if (!_this3.operationData) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 5;
                return _this3.operationData({
                  result: true
                });

              case 5:
                _context2.prev = 5;
                _this3.loading = false;

                _this3.hideModal(true);

                return _context2.finish(5);

              case 9:
                if (_this3.callbackData) {
                  _this3.callbackData({
                    result: true
                  });
                }

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1,, 5, 9]]);
      }))();
    },
    willHideModal: function willHideModal(result) {
      var _this4 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee3() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!result) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                if (_this4.callbackData) {
                  _this4.callbackData({
                    result: false
                  });
                }

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Ask);

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loggingMixin; });
/* harmony import */ var _js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22);

var loggingMixin = {
  methods: {
    logError: function logError() {
      _js__WEBPACK_IMPORTED_MODULE_0__[/* logError */ "p"].apply(void 0, arguments);
    },
    logInfo: function logInfo() {
      _js__WEBPACK_IMPORTED_MODULE_0__[/* logInfo */ "q"].apply(void 0, arguments);
    },
    logDebug: function logDebug() {
      _js__WEBPACK_IMPORTED_MODULE_0__[/* logDebug */ "o"].apply(void 0, arguments);
    }
  }
};

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logicMixin; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _js_util__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18);



var logicMixin = {
  inject: {
    manager: {
      "default": null
    }
  },
  computed: {
    config: function config() {
      return this.$store.state.config;
    },
    brand: function brand() {
      return this.$store.state.brand;
    },
    model: function model() {
      return this.$store.state.model;
    },
    modelVariant: function modelVariant() {
      return this.$store.state.variant;
    },
    modelVersion: function modelVersion() {
      return this.$store.state.version;
    },
    productId: function productId() {
      return this.$store.state.product_id;
    },
    flag: function flag() {
      return this.$store.state.flag;
    },
    description: function description() {
      return this.$store.state.description || this.modelNormalized;
    },
    customerIdInput: function customerIdInput() {
      return this.$store.state.customerIdInput;
    },
    initialsGroups: function initialsGroups() {
      return this.$store.state.initialsGroups;
    },
    initialsMinimumCharacters: function initialsMinimumCharacters() {
      return this.$store.state.initialsMinimumCharacters;
    },
    initialsMaximumCharacters: function initialsMaximumCharacters() {
      return this.$store.state.initialsMaximumCharacters;
    },
    initialsSupportedCharacters: function initialsSupportedCharacters() {
      return this.$store.state.initialsSupportedCharacters;
    },
    modelNormalized: function modelNormalized() {
      if (!this.model) return null;
      return this.model.split("_").map(function (v) {
        return v[0].toUpperCase() + v.slice(1);
      }).join(" ");
    },
    ripeUrl: function ripeUrl() {
      return this.$store.state.ripeUrl;
    },
    error: function error() {
      return this.$store.state.error;
    },
    errorMessage: function errorMessage() {
      return this.error && this.error.message ? this.error.message : null;
    },
    modelError: function modelError() {
      return this.error;
    },
    modelConfigured: function modelConfigured() {
      return Object.keys(this.config).length > 0;
    },
    modelLoaded: function modelLoaded() {
      return this.modelConfigured && Boolean(this.error) === false;
    }
  },
  mounted: function mounted() {
    this.$bus.bind("refresh", this.$forceUpdate);
  },
  methods: {
    /**
     * Resolves both the main initials and engraving taking into consideration
     * the provided initials extra as a fallback process.
     *
     * @param {Object} initialsExtra The dictionary structure associating
     * the multiple initials groups with their initials engraving values.
     * @param {String} initials The initials to be used as override if any.
     * @param {String} engraving The engraving to be used as override if any.
     * @returns {Object} The normalized initials and engraving values withing
     * an object resolved according to the provided initials extra (main group)
     * or the initials and engraving parameters.
     */
    initialsFromExtra: function initialsFromExtra(initialsExtra) {
      var initials = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var engraving = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      return Object(_js_util__WEBPACK_IMPORTED_MODULE_2__[/* initialsFromExtra */ "d"])(initialsExtra, initials, engraving);
    },

    /**
     * Checks if the initials are valid according to a naive implementation
     * where validation is done against the maximum, minimum and supported
     * characters that don't take into account the initials group or the
     * current ctx.
     *
     * This method should be used carefully to avoid erroneous validation
     * of the initials not compliant with generic logic implementation.
     *
     * @param {String} initials The initials string value to validate.
     * @return {Boolean} Whether the initials are valid according to the naive
     * value of maximum and minimum initials.
     */
    initialsWithinRange: function initialsWithinRange(initials) {
      var _this = this;

      if (initials === null || initials === undefined) return true;

      if (this.$store.state.initialsSupportedCharacters === undefined || this.$store.state.initialsSupportedCharacters === null || this.$store.state.initialsMinimumCharacters === undefined || this.$store.state.initialsMinimumCharacters === null || this.$store.state.initialsMaximumCharacters === undefined || this.$store.state.initialsMaximumCharacters === null) {
        return true;
      }

      if (initials.length > this.$store.state.initialsMaximumCharacters) return false;
      if (initials.length < this.$store.state.initialsMinimumCharacters) return false;
      return _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(initials).every(function (initial) {
        return _this.$store.state.initialsSupportedCharacters.includes(initial);
      });
    },

    /**
     * Checks if for every group either has everything set (initials and
     * all properties) or nothing, representing a simple validation process.
     *
     * This verification can be used to determine if the provided groups
     * of initials and properties are valid according to general build
     * based properties definition.
     *
     * @param {Array} groups The sequence with the names of the groups that
     * are going to be validated.
     * @param {Object} groupInitials Am object that maps a certain group
     * to the initials associated with that group.
     * @param {Object} groupProperties An object that maps a group name
     * into an object that associates a property name to a value.
     * @param {Number} properties The object that contains the definition of
     * the properties that are going to be validated, to be used in the
     * evaluation of the expected properties count. This map associates the
     * property name with a sequence of all of its possible values.
     * @return {Boolean} Whether every group either has everything set
     * (initials and all properties) or nothing.
     */
    allPropertiesOrEmpty: function allPropertiesOrEmpty() {
      var _this2 = this;

      var groups = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var groupInitials = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var groupProperties = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var properties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      // computes the expected number of properties as the length
      // of the properties dictionary
      var expectedPropertiesCount = Object.keys(properties).length; // consider groups valid whenever, for all groups, we either
      // have no initials (and no properties for engraving are set)
      // or we have initials and all expected properties are set

      return groups.every(function (group) {
        var initials = groupInitials[group];
        var hasInitials = Boolean(initials);
        var propertiesCount = Object.values(groupProperties[group] || {}).filter(function (v) {
          return v !== null && v !== undefined;
        }).length;
        return !hasInitials && propertiesCount === 0 || hasInitials && _this2.initialsWithinRange(initials) && propertiesCount === expectedPropertiesCount;
      });
    },

    /**
     * Checks if two 'parts' are equal, by using a deep comparison
     * analysis. Equality is defined as, they produce the same
     * result in a subset compare..
     *
     * @param {Object} first The first of the 'parts' being compared.
     * @param {Object} second The second of the 'parts' being compared.
     * @return {Boolean} Returns the result of the deep comparison.
     */
    equalParts: function equalParts(first, second) {
      if (!first && !second) return true;

      if (Boolean(first) !== Boolean(second)) {
        return false;
      }

      if (!this._subsetCompareParts(first, second)) {
        return false;
      }

      if (!this._subsetCompareParts(second, first)) {
        return false;
      }

      return true;
    },

    /**
     * Checks if two 'initialsExtra' are equal, by using a deep
     * comparison analysis. Equality is defined as, they produce
     * the same result after sanitization.
     *
     * @param {Object} first The first of the 'initialsExtra' being compared.
     * @param {Object} second The second of the 'initialsExtra' being compared.
     * @return {Boolean} Returns the result of the deep comparison.
     */
    equalInitialsExtra: function equalInitialsExtra(first, second) {
      if (Boolean(first) !== Boolean(second)) {
        return false;
      }

      var firstS = this.sanitizeInitialsExtra(first);
      var secondS = this.sanitizeInitialsExtra(second);

      if (!this._subsetCompareInitials(firstS, secondS)) {
        return false;
      }

      if (!this._subsetCompareInitials(secondS, firstS)) {
        return false;
      }

      return true;
    },
    diffInitialsExtra: function diffInitialsExtra(first, second) {
      return !this.equalInitialsExtra(first, second);
    },
    sanitizeInitials: function sanitizeInitials(initials, engraving) {
      return [initials || "", initials ? engraving || null : null];
    },
    sanitizeInitialsExtra: function sanitizeInitialsExtra(initialsExtra) {
      var minimize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var override = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var initialsExtraS = {};
      Object.entries(initialsExtra).forEach(function (_ref) {
        var _ref2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref, 2),
            group = _ref2[0],
            _ref2$ = _ref2[1],
            initials = _ref2$.initials,
            engraving = _ref2$.engraving;

        if (!initials && minimize) return;
        initialsExtraS[group] = {
          initials: initials || "",
          engraving: initials ? engraving || null : null
        };
      });

      if (override) {
        for (var _i = 0, _Object$keys = Object.keys(initialsExtra); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          delete initialsExtra[key];
        }

        initialsExtraS = Object.assign(initialsExtra, initialsExtraS);
      }

      return initialsExtraS;
    },

    /**
     * Checks whether the engraving is set when the initials are not.
     *
     * @param {String} initials The initials to validate.
     * @param {String} engraving The engraving to validate.
     * @param {Object} initialsExtra A map from groups to initials and engraving
     * to validate.
     * @returns {Boolean} If there is any group with engraving but no initials.
     */
    engravingWithoutInitials: function engravingWithoutInitials(initials, engraving) {
      var initialsExtra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return Boolean(engraving && !initials || Object.values(initialsExtra).find(function (group) {
        return group.engraving && !group.initials;
      }));
    },
    _subsetCompareParts: function _subsetCompareParts(base, reference) {
      for (var _i2 = 0, _Object$keys2 = Object.keys(base); _i2 < _Object$keys2.length; _i2++) {
        var name = _Object$keys2[_i2];
        // retrieves the part information for the current
        // name in iteration for both the base and the
        // reference set values (to be compared)
        var partB = base[name];
        var partR = reference[name]; // if for a certain base part the corresponding
        // part does not exist in the reference then the
        // reference is considered to be invalid

        if (!partR) {
          return false;
        } // in case either the initials or the engraving is
        // not matching then the subset is invalid


        if (partB.material !== partR.material || partB.color !== partR.color) {
          return false;
        }
      }

      return true;
    },
    _subsetCompareInitials: function _subsetCompareInitials(base, reference) {
      for (var _i3 = 0, _Object$keys3 = Object.keys(base); _i3 < _Object$keys3.length; _i3++) {
        var name = _Object$keys3[_i3];
        // retrieves the group information for the current
        // name in iteration for both the base and the
        // reference set values (to be compared)
        var groupB = base[name];
        var groupR = reference[name]; // if for a certain base group the corresponding
        // group does not exist in the reference then the
        // reference is considered to be invalid

        if (!groupR) {
          return false;
        } // in case either the initials or the engraving is
        // not matching then the subset is invalid


        if (groupB.initials !== groupR.initials || groupB.engraving !== groupR.engraving) {
          return false;
        }
      }

      return true;
    },

    /**
     * Default initials builder implementation that uses a series of
     * pref-defined heuristics that take into account: engraving, group and
     * properties.
     *
     * The results provided should be enough to handle most of the personalization
     * scenarios.
     *
     * @param {String} initials The string that contains the initials that are
     * going to be used in the building process.
     * @param {String} engraving The engraving string value to be used.
     * @param {HTMLElement} element The HTML element reference to the image that
     * is going to use the generated initials and profile object.
     * @returns {Object} An object that defined both `initials` and `profiles`
     * according to the provided parameters.
     */
    __initialsBuilder: function __initialsBuilder(initials, engraving, element) {
      var _this3 = this;

      // uses the provided element to obtain the selected group and obtains the
      // "base" personalization profiles for such group
      var group = element.getAttribute("data-group");
      var properties = engraving ? this.$ripe.parseEngraving(engraving, this.config.initials.properties).valuesM : {};

      var profiles = this.__buildPersonalizationProfiles(group, properties); // iterates over each of the properties for the groups and builds the base
      // profiles with the property value with the group suffix and the basic
      // profile with "just" the property value


      Object.entries(properties).forEach(function (_ref3) {
        var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, 2),
            type = _ref4[0],
            value = _ref4[1];

        _this3.initialsGroups.length > 1 && profiles.push(value + ":" + group);
        profiles.push(value);
      });
      profiles.push(group);
      return {
        initials: initials || "$empty",
        profile: profiles
      };
    },

    /**
     * Builds a series of "personalization oriented" profiles taking
     * into account a series of pre-defined heuristics that should be
     * applicable to most initials contexts and structures.
     *
     * These profiles are applicable under a series of best practices
     * and may not provide optimal results.
     *
     * @param {String} group The name of the group to obtain the profiles.
     * @param {Object} properties The properties object that should be
     * used as the basis for the building of the profiles.
     */
    __buildPersonalizationProfiles: function __buildPersonalizationProfiles(group, properties) {
      var alias = this.config.initials.$alias;
      if (!alias) return [];
      var position = properties.position;
      return [].concat(position && group ? alias["step::personalization:".concat(position, ":").concat(group)] : [], position ? alias["step::personalization:".concat(position)] : [], group ? alias["step::personalization:".concat(group)] : [], alias["step::personalization"]).filter(function (v) {
        return v !== undefined;
      });
    }
  }
};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utilsMixin; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22);



var utilsMixin = {
  methods: {
    capitalize: function capitalize(value) {
      if (!value) return "";
      return value[0].toUpperCase() + value.slice(1);
    },
    alert: function alert() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.$bus.trigger("alert", options);
    },
    ask: function ask() {
      var _arguments = arguments,
          _this = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
        var options, promise, _yield$promise, result;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
                promise = new Promise(function (resolve, reject) {
                  options.callback = resolve;

                  _this.$bus.trigger("ask", options);
                });
                _context.next = 4;
                return promise;

              case 4:
                _yield$promise = _context.sent;
                result = _yield$promise.result;
                return _context.abrupt("return", result);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    askError: function askError() {
      var _arguments2 = arguments,
          _this2 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee2() {
        var options, result;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = _arguments2.length > 0 && _arguments2[0] !== undefined ? _arguments2[0] : {};
                options = typeof options === "string" ? {
                  message: options
                } : options;
                options.title = options.title || "Error";
                options.message = options.message || options.error || "There was an error";
                options.buttonConfirm = options.buttonConfirm || "Confirm";
                options.buttonCancel = options.buttonCancel || null;
                _context2.next = 8;
                return _this2.ask(options);

              case 8:
                result = _context2.sent;
                return _context2.abrupt("return", result);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    readable: function readable(value) {
      return this.$options.filters.readable(value);
    },
    normalize: function normalize(value) {
      return Object(_js__WEBPACK_IMPORTED_MODULE_2__[/* normalize */ "r"])(value);
    },
    dateString: function dateString(timestamp) {
      var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
      var date = new Date(timestamp * 1000);
      var day = date.getDate() < 10 ? "0".concat(date.getDate()) : date.getDate();
      var month = date.getMonth() + 1;
      month = month < 10 ? "0".concat(month) : month;
      return day + separator + month + separator + date.getFullYear();
    },
    dateStringUTC: function dateStringUTC(timestamp) {
      var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
      var date = new Date(timestamp * 1000);
      var day = date.getUTCDate() < 10 ? "0".concat(date.getUTCDate()) : date.getUTCDate();
      var month = date.getUTCMonth() + 1;
      month = month < 10 ? "0".concat(month) : month;
      return day + separator + month + separator + date.getUTCFullYear();
    },
    timeString: function timeString(timestamp) {
      var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ":";
      var date = new Date(timestamp * 1000);
      var hours = date.getHours() < 10 ? "0".concat(date.getHours()) : date.getHours();
      var minutes = date.getMinutes() < 10 ? "0".concat(date.getMinutes()) : date.getMinutes();
      var seconds = date.getSeconds() < 10 ? "0".concat(date.getSeconds()) : date.getSeconds();
      return hours + separator + minutes + separator + seconds;
    },
    timeStringUTC: function timeStringUTC(timestamp) {
      var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ":";
      var date = new Date(timestamp * 1000);
      var hours = date.getUTCHours() < 10 ? "0".concat(date.getUTCHours()) : date.getUTCHours();
      var minutes = date.getUTCMinutes() < 10 ? "0".concat(date.getUTCMinutes()) : date.getUTCMinutes();
      var seconds = date.getUTCSeconds() < 10 ? "0".concat(date.getUTCSeconds()) : date.getUTCSeconds();
      return hours + separator + minutes + separator + seconds;
    }
  }
};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_component_plugin_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(75);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_component_plugin_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_component_plugin_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentPlugin; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);


//
//
//
//
//
//

/**
 * The abstract component plugin that is meant to receive a certain
 * dynamic component and abstract it under a Vue.js component.
 *
 * This provides a simple bridge between Pluginus and Vue.js.
 */
var ComponentPlugin = {
  name: "component-plugin",
  props: {
    name: {
      type: String,
      "default": null
    },
    capability: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      component: null
    };
  },
  computed: {
    componentGetter: function componentGetter() {
      var functionName = "getComponent";

      if (this.capability) {
        functionName += this.capitalize(this.capability);
      }

      return functionName;
    }
  },
  created: function () {
    var _created = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee() {
      var plugin;
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.getPlugin();

            case 2:
              plugin = _context.sent;

              if (plugin) {
                _context.next = 5;
                break;
              }

              throw new Error("Not plugin available for requested parameters");

            case 5:
              _context.next = 7;
              return plugin[this.componentGetter]();

            case 7:
              this.component = _context.sent;

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function created() {
      return _created.apply(this, arguments);
    }

    return created;
  }(),
  methods: {
    getPlugin: function getPlugin() {
      if (this.name) {
        return this.manager.getPluginByName(this.name);
      } else if (this.capability) {
        return this.manager.getPluginByCapability("component-" + this.capability);
      } else {
        return this.manager.getPluginByCapability("component");
      }
    },
    capitalize: function capitalize(value) {
      if (!value) {
        return "";
      }

      return value[0].toUpperCase() + value.slice(1);
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (ComponentPlugin);

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_keyboard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_keyboard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_keyboard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Keyboard; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Keyboard = {
  name: "keyboard",
  props: {
    /**
     * The sequence of arrays that define the multiple
     * lines of keys in a string or object fashion.
     */
    keys: {
      type: Array,
      required: true
    },

    /**
     * If the character based keys should be uppercased
     * in the visual part of the display, or if instead
     * they should be displayed as defined in the object
     * based structure.
     */
    uppercase: {
      type: Boolean,
      "default": true
    },

    /**
     * Single choice operation in which no buffer
     * is kept for the last set of values, allowing
     * for more complex operations like backspace.
     */
    singleChoice: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      activeKeys: []
    };
  },
  computed: {
    parsedKeys: function parsedKeys() {
      var _this = this;

      return this.keys.map(function (row) {
        return row.map(function (key) {
          return typeof key === "string" ? {
            type: "alphanumeric",
            name: _this.uppercase ? key.toUpperCase() : key,
            value: key
          } : key;
        });
      });
    }
  },
  methods: {
    keyPressed: function keyPressed(key) {
      var activeKeys = this.activeKeys.slice(0);
      var index = activeKeys.indexOf(key.name);

      if (index > -1) {
        activeKeys.splice(index, 1);
      } else if (this.singleChoice) {
        activeKeys = [key.name];
      } else {
        activeKeys.push(key.name);
      }

      this.activeKeys = activeKeys;
      this.$emit("key-pressed", key);
    },
    keyType: function keyType(key) {
      return key.type || "special";
    },
    keyImage: function keyImage(key) {
      return key.image || __webpack_require__(657)("./key-" + key.name + ".svg");
    },
    isActive: function isActive(key) {
      return this.activeKeys.includes(key.name);
    },
    reset: function reset(keys) {
      this.activeKeys = keys || [];
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Keyboard);

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Modal = {
  name: "modal",
  data: function data() {
    return {
      options: {
        name: "",
        visible: false,
        overlayLeave: true
      }
    };
  },
  computed: {
    name: function name() {
      return this.options.name;
    },
    visible: function visible() {
      return this.options.visible;
    },
    overlayLeave: function overlayLeave() {
      return this.options.overlayLeave;
    }
  },
  watch: {
    visible: function visible(value, previous) {
      var _this = this;

      if (!previous && value) {
        this.$nextTick(function () {
          _this.$refs.container.scrollTop = 0;
        });
      }
    }
  },
  methods: {
    hide: function hide(status) {
      this.$emit("hide", status);
    },
    keyPressed: function keyPressed(key) {
      this.$emit("key_pressed");
    },
    beforeEnter: function beforeEnter() {
      this.$emit("before_enter");
    },
    enter: function enter() {
      this.$emit("enter");
    },
    afterEnter: function afterEnter() {
      this.$emit("after_enter");
    },
    enterCancelled: function enterCancelled() {
      this.$emit("enter_cancelled");
    },
    beforeLeave: function beforeLeave() {
      this.$emit("before_leave");
    },
    leave: function leave() {
      this.$emit("leave");
    },
    afterLeave: function afterLeave() {
      this.$emit("after_leave");
    },
    leaveCancelled: function leaveCancelled() {
      this.$emit("leave_cancelled");
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Modal);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_restrictions_alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_restrictions_alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_restrictions_alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RestrictionsAlert; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var RestrictionsAlert = {
  name: "restrictions-alert",
  data: function data() {
    return {
      visible: false
    };
  },
  created: function created() {
    var _this = this;

    this.onRestrictions = this.$bus.bind("restrictions", function (changes, newPart) {
      _this.visible = changes.length > 0;
    });
    this.onUndo = this.$bus.bind("undo", function () {
      return _this.close();
    });
  },
  destroyed: function destroyed() {
    if (this.onUndo) this.$bus.unbind("undo", this.onUndo);
    if (this.onRestrictions) this.$bus.unbind("restrictions", this.onRestrictions);
  },
  methods: {
    undo: function undo() {
      this.$bus.trigger("undo");
    },
    close: function close() {
      this.visible = false;
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (RestrictionsAlert);

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tab; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Tab = {
  name: "tab",
  props: {
    tab: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    active: {
      type: Boolean,
      "default": true
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Tab);

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tabs; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var Tabs = {
  name: "tabs",
  props: {
    tabs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    initialTab: {
      type: String,
      "default": null
    }
  },
  data: function data() {
    return {
      activeTab: this.initialTab
    };
  },
  watch: {
    activeTab: function activeTab(tabId) {
      var tab = this.getTab(tabId);
      this.$emit("tab-selected", tab);
    }
  },
  methods: {
    getTab: function getTab(tabId) {
      return this.tabs.find(function (tab) {
        return tab.id === tabId;
      });
    },
    selectTab: function selectTab(tabId) {
      this.activeTab = tabId;
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Tabs);

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Thumbnails; });
//
//
//
//
//
//
//
//
//
//
//
//
//
var Thumbnails = {
  name: "thumbnails",
  props: {
    size: {
      type: Number,
      "default": null
    },
    crop: {
      type: Boolean,
      "default": null
    }
  },
  computed: {
    thumbnails: function thumbnails() {
      var _this = this;

      // filters the invalid thumbnails from the thumbnails list
      // a thumbnail is considered invalid if the associated frame
      // is not part of the base frames definition of the model
      return this.$store.getters.thumbnails.filter(function (t) {
        return _this.$store.state.config.faces && _this.$store.state.config.faces_m && _this.$store.state.config.faces.includes(t.face) && _this.$store.state.config.faces_m[t.face] && t.frame < _this.$store.state.config.faces_m[t.face].frames;
      });
    }
  },
  methods: {
    thumbnailKey: function thumbnailKey(thumbnail) {
      return "".concat(thumbnail.frame, ":").concat(thumbnail.name, ":").concat(thumbnail.face);
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Thumbnails);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_groups_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_groups_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_groups_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThumbnailsGroups; });
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var ThumbnailsGroups = {
  name: "thumbnails-groups",
  mixins: [_mixins__WEBPACK_IMPORTED_MODULE_0__["logicMixin"]],
  props: {
    activeGroup: {
      type: String,
      required: true
    },
    groups: {
      type: Array,
      required: true
    },
    size: {
      type: Number,
      "default": null
    },
    crop: {
      type: Boolean,
      "default": null
    }
  },
  data: function data() {
    return {
      activeGroupData: this.activeGroup
    };
  },
  computed: {
    brand: function brand() {
      return this.$store.state.brand;
    },
    model: function model() {
      return this.$store.state.model;
    },
    configInitials: function configInitials() {
      return this.$store.state.config.initials;
    }
  },
  watch: {
    activeGroup: function activeGroup(value) {
      this.activeGroupData = value;
    },
    activeGroupData: function activeGroupData(value) {
      this.$emit("update:active-group", value);
    }
  },
  methods: {
    onImageSelected: function onImageSelected(group) {
      this.activeGroupData = group;
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (ThumbnailsGroups);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _configurator_configurator_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(125);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _configurator_configurator_vue__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _personalization_personalization_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(126);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _personalization_personalization_vue__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _pickers_pickers_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(127);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _pickers_pickers_vue__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var _size_size_vue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(128);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _size_size_vue__WEBPACK_IMPORTED_MODULE_3__["a"]; });






var install = function install(Vue) {
  Vue.component("configurator", _configurator_configurator_vue__WEBPACK_IMPORTED_MODULE_0__[/* Configurator */ "a"]);
  Vue.component("personalization", _personalization_personalization_vue__WEBPACK_IMPORTED_MODULE_1__[/* Personalization */ "a"]);
  Vue.component("pickers", _pickers_pickers_vue__WEBPACK_IMPORTED_MODULE_2__[/* Pickers */ "a"]);
  Vue.component("size", _size_size_vue__WEBPACK_IMPORTED_MODULE_3__[/* Size */ "a"]);
};


/* harmony default export */ __webpack_exports__["e"] = (install);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_configurator_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_configurator_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_configurator_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Configurator; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ripe_sdk__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19);
/* harmony import */ var ripe_sdk__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(ripe_sdk__WEBPACK_IMPORTED_MODULE_3__);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * The component that contains the RIPE SDK's configurator, responsible
 * for forwarding its events to the Vue bus, as well the other way
 * around.
 */

var Configurator = {
  name: "configurator",
  props: {
    ripe: {
      type: Object,
      "default": null
    },
    ignoreBus: {
      type: Boolean,
      "default": false
    },

    /**
     * The options that are going to be used to configure the
     * configurator while initializing it.
     */
    options: {
      type: Object,
      "default": function _default() {
        return {
          animation: "cross",
          duration: 250,
          revolutionDuration: 500,
          configAnimate: false
        };
      }
    },

    /**
     * The name of the frame to be shown in the configurator using
     * the normalized frame format (eg: side-1).
     */
    frame: {
      type: String,
      "default": null
    },

    /**
     * The size of the configurator in pixels, this is going to be
     * applied to both the width and height (square format 1:1).
     */
    size: {
      type: Number,
      "default": null
    },

    /**
     * The time accepted for the holder to appear on the display
     * without any interaction of the user.
     */
    timeoutHolder: {
      type: Number,
      "default": 7500
    },

    /**
     * If the masks should be displayed while hovering the mouse
     * on top of the multiple model parts.
     */
    useMasks: {
      type: Boolean,
      "default": true
    },

    /**
     * Callback function to be called when a configurator related
     * error is thrown, for some operations (eg: while changing frame).
     */
    onError: {
      type: Function,
      "default": function _default(error) {
        throw error;
      }
    }
  },
  computed: {
    elementDisplayed: function elementDisplayed() {
      if (!this.configurator) {
        return false;
      }

      return getComputedStyle(this.configurator.element).display !== "none";
    },
    hideHolder: function hideHolder() {
      return this.singleFrameView || this.frameChanged || this.holderTimedOut;
    },
    mergedOptions: function mergedOptions() {
      return _objectSpread(_objectSpread({}, this.options), {}, {
        useMasks: this.useMasks
      });
    }
  },
  data: function data() {
    return {
      /**
       * Ripe instance used by the configurator. Defaults to the
       * global ripe instance when the prop ripe isn't set.
       */
      ripeInstance: this.ripe ? this.ripe : this.$ripe,

      /**
       * The frame that is currently being shown in the
       * configurator.
       */
      frameData: this.frame,

      /**
       * Flag that controls if the initial loading process for
       * the modal in the configurator is still running.
       */
      loading: false,

      /**
       * The reference to the possible loading error instance
       * triggered withing an malfunctioning configurator loading.
       */
      loadingError: null,

      /**
       * If the current view is a single frame one, meaning that
       * no "rotation" should be "applied" to it.
       */
      singleFrameView: true,

      /**
       * Listener flag that represents if a rotation have been made.
       */
      frameChanged: false,

      /**
       * Indicates whether the time accepted for the
       * holder to appear on the display has "timed-out".
       */
      holderTimedOut: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    setTimeout(function () {
      _this.holderTimedOut = true;
    }, this.timeoutHolder);
    this.configurator = this.ripeInstance.bindConfigurator(this.$refs.configurator, this.mergedOptions);
    this.configurator.bind("changed_frame", function (frame) {
      // sets the frame changed flag and then updates
      // the frame key to the new one (internal copy)
      _this.frameChanged = true;
      _this.frameData = frame; // updates the value of the single frame view
      // variable as the new view may have several frames
      // or just one and the variable value may change

      _this.singleFrameView = (_this.configurator.frames[_this.configurator.view] || 1) === 1; // only the visible instance of this component
      // should be sending events it's considered to
      // be the main/master one

      if (_this.elementDisplayed) {
        _this.$store.commit("currentFrame", frame);

        _this.$bus.trigger("changed_frame", _this.configurator, frame);
      }
    });
    this.configurator.bind("loaded", function () {
      var frame = "".concat(_this.configurator.view, "-").concat(_this.configurator.position);
      _this.frameData = frame;
      _this.loading = false;
      _this.singleFrameView = (_this.configurator.frames[_this.configurator.view] || 1) === 1;

      _this.$store.commit("currentFrame", frame);
    });
    this.configurator.bind("highlighted_part", function (part) {
      _this.$bus.trigger("highlighted_part", _this.configurator, part);
    });
    this.configurator.bind("lowlighted", function () {
      _this.$bus.trigger("lowlighted", _this.configurator);
    });
    this.$bus.bind("error", function (error) {
      if (_this.ignoreBus) return;
      if (!_this.loading) return;
      _this.loading = false;
      _this.loadingError = error;
    });
    this.$bus.bind("pre_config", function () {
      if (_this.ignoreBus) return;
      _this.loading = true;
    });
    this.$bus.bind("changed_frame", /*#__PURE__*/function () {
      var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee(configurator, frame) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.ignoreBus) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (!(_this.frameData === frame)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                if (!(!_this.configurator || !_this.configurator.ready)) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return _this.configurator.changeFrame(frame, {
                  type: null,
                  duration: null
                });

              case 9:
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](6);

                // calls the registered callback handler for the
                // error (default implementation is a simple re-throw)
                _this.onError(_context.t0);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 11]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    this.$bus.bind("show_frame", /*#__PURE__*/function () {
      var _ref2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee2(frame) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!_this.ignoreBus) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                _this.frameData = frame;

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3) {
        return _ref2.apply(this, arguments);
      };
    }());
    this.$bus.bind("highlight_part", function (part) {
      if (_this.ignoreBus) return;

      if (_this.configurator && _this.configurator.ready) {
        _this.configurator.highlight(part);
      }
    });
    this.$bus.bind("lowlight_part", function (part) {
      if (_this.ignoreBus) return;

      if (_this.configurator && _this.configurator.ready) {
        _this.configurator.lowlight(part);
      }
    });
    this.resize(this.size);
  },
  watch: {
    frame: function frame(value) {
      if (this.frameData === value) return;
      this.frameData = value;
    },
    frameData: function frameData(value, previous) {
      var _this2 = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee3() {
        var previousView, view, sameView, type, revolutionDuration, duration;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(!_this2.configurator || !_this2.configurator.ready)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                // extracts the view part of both the previous and the
                // current frame to be used for change view comparison
                previousView = previous ? ripe_sdk__WEBPACK_IMPORTED_MODULE_3__["ripe"].parseFrameKey(previous)[0] : "";
                view = ripe_sdk__WEBPACK_IMPORTED_MODULE_3__["ripe"].parseFrameKey(value)[0]; // calculates the parameters for the frame change taking
                // into account if the view (face) is going to change

                sameView = view === previousView;
                type = sameView ? false : _this2.options.animation;
                revolutionDuration = sameView ? _this2.options.revolutionDuration : null;
                duration = _this2.options.duration;
                _context3.prev = 8;
                _context3.next = 11;
                return _this2.configurator.changeFrame(value, {
                  type: type,
                  revolutionDuration: revolutionDuration,
                  duration: duration
                });

              case 11:
                _context3.next = 16;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3["catch"](8);

                // calls the registered callback handler for the
                // error (default implementation is a simple re-throw)
                _this2.onError(_context3.t0);

              case 16:
                // triggers the update frame event allow bi-directional
                // binding of the prop value frame
                _this2.$emit("update:frame", value);

              case 17:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[8, 13]]);
      }))();
    },
    size: function size(_size) {
      this.resize(_size);
    },
    useMasks: function useMasks() {
      if (!this.configurator) return;
      if (this.useMasks) this.configurator.enableMasks();else this.configurator.disableMasks();
    },
    loading: function loading(value) {
      this.$emit("update:loading", value);
    },
    options: function options(value) {
      this.configurator.updateOptions(value);
    }
  },
  methods: {
    /**
     * Re-sizes the configurator according to the current
     * available container size (defined by parent).
     */
    resize: function resize(size) {
      if (!size || !this.configurator) return;
      this.configurator.resize(size);
    }
  },
  destroyed: function () {
    var _destroyed = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee4() {
      return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!this.configurator) {
                _context4.next = 3;
                break;
              }

              _context4.next = 3;
              return this.ripeInstance.unbindConfigurator(this.configurator);

            case 3:
              this.configurator = null;

            case 4:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this);
    }));

    function destroyed() {
      return _destroyed.apply(this, arguments);
    }

    return destroyed;
  }()
};
/* harmony default export */ __webpack_exports__["b"] = (Configurator);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Personalization; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13);



function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Top level personalization component that encapsulated
 * both the button that will trigger the personalization
 * and the modal that allows personalization.
 *
 * The form that allows personalization is dynamic and is
 * controlled by the Pluginus system so that it may be
 * adapted to the current configuration context (for the
 * best possible experience for the model).
 */

var Personalization = {
  name: "personalization",
  mixins: [_mixins__WEBPACK_IMPORTED_MODULE_3__["modalMixin"]],
  props: {
    pedantic: {
      type: Boolean,
      "default": false
    }
  },
  data: function data() {
    return {
      hidden: true,
      enabled: false,
      form: null,
      tabMessage: "",
      buttonText: "",
      state: {},
      counter: 0,
      initialOptions: null,
      valid: true
    };
  },
  computed: {
    /**
     * The original personalization state from which the
     * user has entered the personalization modal.
     *
     * @returns {Object} The object containing the personalization
     * definition considered the original one.
     */
    originalState: function originalState() {
      return this.$store.state.personalization;
    },

    /**
     * If the current personalization modal is visible.
     *
     * @returns {Boolean} If the modal, is visible.
     */
    visible: function visible() {
      return this.$refs.modal.visible;
    },

    /**
     * The form's unique key that will identify this form
     * based on the current counter and model's identifier.
     *
     * @returns {String} The unique string for the current modal
     */
    formKey: function formKey() {
      return "".concat(this.brand, ".").concat(this.model, ".").concat(this.counter);
    },

    /**
     * If there's a valid personalization set under the current
     * store state.
     *
     * @returns {Boolean} If there's a valid personalization.
     */
    hasPersonalization: function hasPersonalization() {
      return this.$store.state.hasPersonalization;
    },
    buttonApplyClasses: function buttonApplyClasses() {
      return {
        disabled: !this.valid
      };
    }
  },
  watch: {
    enabled: function enabled(_enabled) {
      !_enabled && this.clear();
    },
    state: {
      handler: function handler(state, previousState) {
        if (this.diffInitialsExtra(state.initialsExtra, previousState.initialsExtra)) {
          this.$bus.trigger("initials_change", this.sanitizeInitialsExtra(state.initialsExtra));
        }
      },
      deep: true
    }
  },
  created: function created() {
    var _this = this;

    this.$bus.bind("enable_personalization", this.enablePersonalization);
    this.$bus.bind("disable_personalization", this.disablePersonalization);
    this.$bus.bind("open_personalization", this.showModal);
    this.$bus.bind("close_personalization", this.hideModal);
    this.$bus.bind("pre_config", function () {
      _this.enabled = false;
      _this.form = null;
      _this.valid = true;
    });
    this.$bus.bind("post_config", /*#__PURE__*/function () {
      var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.mark(function _callee(config, options) {
        var plugins, plugin, form;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_2___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!config || !_this.hasPersonalization)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return _this.manager.getPluginsByCapability("personalization");

              case 4:
                plugins = _context.sent.filter(function (plugin) {
                  if (plugin.isPersonalizationEligible) {
                    return plugin.isPersonalizationEligible(_this.brand, _this.model);
                  }

                  return (!plugin.meta.brand || plugin.meta.brand === _this.brand) && (!plugin.meta.models || plugin.meta.models.includes(_this.model));
                }).map(function (plugin) {
                  var value = 0;
                  if (plugin.meta.brand && plugin.meta.brand === _this.brand) value++;
                  if (plugin.meta.models && plugin.meta.models.includes(_this.model)) value++;
                  value += plugin.getPersonalizationPoints ? plugin.getPersonalizationPoints(_this.brand, _this.mode) : 0;
                  return [value, plugin];
                }).sort(function (a, b) {
                  return b[0] - a[0];
                }).map(function (v) {
                  return v[1];
                });

                if (plugins.length) {
                  _context.next = 10;
                  break;
                }

                _this.hidden = true;

                if (!_this.pedantic) {
                  _context.next = 9;
                  break;
                }

                throw Error("No personalization component found for ".concat(_this.brand));

              case 9:
                return _context.abrupt("return");

              case 10:
                // retrieves the first plugin (best candidate) and retrieves its
                // personalization component setting it as the form component for
                // this specific personalization scenario
                plugin = plugins[0];
                _context.next = 13;
                return plugin.getPersonalizationComponent();

              case 13:
                form = _context.sent;
                // increments the cache invalidation counter, internal hack to enable
                // proper computation of computed values
                _this.counter += 1; // sets the form for the current component, then removes the hidden flag
                // and enables the personalization (button for personalization)

                _this.form = form;
                _this.hidden = false;

                _this.enablePersonalization(); // copies the provided options from the post config as the initial options
                // for the initials, to be used for context based initials settings


                _this.initialOptions = Object.assign({}, options);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    this.$bus.bind("initials_extra", function (initialsExtra) {
      if (_this.diffInitialsExtra(initialsExtra, _this.state.initialsExtra)) {
        var _this$initialsFromExt = _this.initialsFromExtra(initialsExtra),
            initials = _this$initialsFromExt.initials,
            engraving = _this$initialsFromExt.engraving;

        _this.state.initials = initials;
        _this.state.engraving = engraving;
        _this.state.initialsExtra = initialsExtra;
        if (_this.$refs.form) _this.$refs.form.setState(_this.state);
      }
    });
  },
  mounted: function mounted() {
    this.updateButtonText();
  },
  methods: {
    apply: function apply() {
      this.$store.commit("personalization", this.state);
      this.$bus.trigger("personalization", this.state, this.tabMessage);
      this.hideModal();
    },
    clear: function clear() {
      this.form && this.$refs.form.reset();
    },
    modalBeforeEnter: function modalBeforeEnter() {
      this.$bus.trigger("open_personalization");
      this.$store.dispatch("refreshInitialsData");
      this.$refs.form.show();
    },
    modalBeforeLeave: function modalBeforeLeave() {
      this.$bus.trigger("close_personalization");
      this.$refs.form.hide();
    },
    modalHidden: function modalHidden() {
      this.originalState ? this.$refs.form.setState(this.originalState) : this.$refs.form.reset();
      this.updateButtonText();
    },
    enablePersonalization: function enablePersonalization() {
      this.enabled = true;
    },
    disablePersonalization: function disablePersonalization() {
      this.enabled = false;
    },
    formMounted: function formMounted() {
      var form = this.$refs.form;
      form.setState({
        initials: this.initialOptions.initials,
        engraving: this.initialOptions.engraving,
        initialsExtra: this.initialOptions.initialsExtra
      });
      this.personalizationChanged(form.getState(), form.getTabMessage());
    },
    formChanged: function formChanged(form) {
      this.personalizationChanged(form.getState(), form.getTabMessage());
    },
    personalizationChanged: function personalizationChanged() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var tabMessage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      // initializes the local variables with the default values
      // so that the default initials and engraving values are set
      var initials = state.initials || "";
      var engraving = state.engraving || null; // if the initials or the engraving don't give a "simple"
      // definition then tries to retrieve a valid value from
      // the initials extra definition

      if (!(initials && engraving) && state.initialsExtra) {
        var initialsSimple = this.initialsExtraToInitials(state.initialsExtra);
        initials = initialsSimple.initials;
        engraving = initialsSimple.engraving;
      } // updates the current state object with both initials, engraving
      // and the initials extra structure, either from the directly provided
      // state or from the conversion from the "simple" initials, notice
      // that both the initials and the initials extra are sanitized to avoid
      // corrupted data regarding initials and initials extra


      var _this$sanitizeInitial = this.sanitizeInitials(initials, engraving);

      var _this$sanitizeInitial2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_this$sanitizeInitial, 2);

      state.initials = _this$sanitizeInitial2[0];
      state.engraving = _this$sanitizeInitial2[1];
      state.initialsExtra = state.initialsExtra ? this.sanitizeInitialsExtra(state.initialsExtra, undefined, true) : this.initialsToInitialsExtra(initials, engraving); // updates both the current internal state taking into account if an event
      // should be triggered or not (using internal state values)

      this.state = state; // updates the message for the tab according to the provided value to be
      // able to show the most up-to-date values

      this.tabMessage = tabMessage; // in case there's no visibility of the personalization then applies the
      // changes and then runs the update of the button text

      if (!this.visible) this.apply();
      if (!this.visible) this.updateButtonText();
    },
    updateButtonText: function updateButtonText() {
      this.buttonText = this.tabMessage || "ripe_commons.personalization.add_initials";
    },
    initialsToInitialsExtra: function initialsToInitialsExtra(initials, engraving) {
      return {
        main: {
          initials: initials,
          engraving: engraving
        }
      };
    },
    initialsExtraToInitials: function initialsExtraToInitials(initialsExtra) {
      // checks if the initials groups are declared on the model
      // config and uses them to retrieve the initials value
      var configGroups = this.$store.state.config.initialsGroups;

      if (configGroups && configGroups.length) {
        var initials = "";
        var engraving = null; // tries to retrieve the values of the first valid
        // group, respecting the order of the declaration

        var _iterator = _createForOfIteratorHelper(configGroups),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var groupName = _step.value;
            var group = initialsExtra[groupName];

            if (!group) {
              continue;
            }

            if (group.initials.length) {
              initials = group.initials;
              engraving = group.engraving;
              break;
            }
          } // if all the groups are defined and have the same engraving
          // then concatenates the initials according to the order of the groups

        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        if (configGroups.every(function (group) {
          return initialsExtra[group] && initialsExtra[group].initials && initialsExtra[group].engraving === engraving;
        })) {
          initials = configGroups.map(function (group) {
            return initialsExtra[group].initials;
          }).join(" ");
        }

        if (initials && engraving) {
          return {
            initials: initials,
            engraving: engraving
          };
        }
      } // if the groups are not declared then checks if a group named
      // "main" is defined and returns its values


      var mainGroup = initialsExtra.main;

      if (mainGroup) {
        return mainGroup;
      } // sorts the group names alphabetically and returns the first
      // group with initials defined


      var keys = Object.keys(initialsExtra).sort();

      var _iterator2 = _createForOfIteratorHelper(keys),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var key = _step2.value;
          var _group = initialsExtra[key];

          if (_group.initials.length) {
            return _group;
          }
        } // if no group has valid initials then returns empty values

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return {
        initials: "",
        engraving: null
      };
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Personalization);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pickers_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pickers_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_pickers_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pickers; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);


function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Pickers = {
  name: "pickers",
  mixins: [_mixins__WEBPACK_IMPORTED_MODULE_1__["localeMixin"], _mixins__WEBPACK_IMPORTED_MODULE_1__["utilsMixin"]],
  props: {
    /**
     * Responsible for establishing if the app shows all colors or just
     * the colors of the selected material. 'False' will show all colors,
     * regardless of the material.
     */
    colorToggle: {
      type: Boolean,
      "default": false
    },
    enableScrollParts: {
      type: Boolean,
      "default": false
    },
    enableScrollMaterials: {
      type: Boolean,
      "default": false
    },
    enableScrollColors: {
      type: Boolean,
      "default": false
    },
    enableCenterParts: {
      type: Boolean,
      "default": false
    },
    enableCenterMaterials: {
      type: Boolean,
      "default": false
    },

    /**
     * Align strategy for the scroll left and right.
     */
    alignScroll: {
      type: String,
      "default": "left"
    },
    beforeButtonsParts: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    afterButtonsParts: {
      type: Array,
      "default": function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      activePart: null,
      activeMaterial: null,
      activeColor: null,
      multipleMaterials: false,
      loading: false,
      swatches: {},
      choices: {},

      /**
       * Whether the parts picker has a scroll.
       */
      scrollParts: false,

      /**
       * Whether the materials picker has a scroll.
       */
      scrollMaterial: false,

      /**
       * Whether the colors picker has a scroll.
       */
      scrollColor: false,

      /**
       * The currently aligned part, necessary to
       * maintain the scroll after a resize.
       */
      alignedPart: null,

      /**
       * The currently aligned material, necessary to
       * maintain the scroll after a resize.
       */
      alignedMaterial: null,

      /**
       * The currently aligned color, necessary to
       * maintain the scroll after a resize.
       */
      alignedColor: null
    };
  },
  computed: {
    parts: function parts() {
      return this.$store.getters.getParts();
    },
    options: function options() {
      return this.$store.state.options;
    },
    defaults: function defaults() {
      return this.$store.state.defaults;
    },
    filteredOptions: function filteredOptions() {
      var choices = {};

      for (var _i = 0, _Object$entries = Object.entries(this.choices); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_Object$entries[_i], 2),
            part = _Object$entries$_i[0],
            partValue = _Object$entries$_i[1];

        if (!partValue.available) continue;
        var materials = {};

        for (var _i2 = 0, _Object$entries2 = Object.entries(partValue.materials); _i2 < _Object$entries2.length; _i2++) {
          var _Object$entries2$_i = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_Object$entries2[_i2], 2),
              material = _Object$entries2$_i[0],
              materialValue = _Object$entries2$_i[1];

          if (!materialValue.available) continue;
          var colors = [];

          for (var _i3 = 0, _Object$entries3 = Object.entries(materialValue.colors); _i3 < _Object$entries3.length; _i3++) {
            var _Object$entries3$_i = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_Object$entries3[_i3], 2),
                color = _Object$entries3$_i[0],
                colorValue = _Object$entries3$_i[1];

            if (!colorValue.available) continue;
            colors.push(color);
          }

          if (Object.keys(colors).length === 0) continue;
          materials[material] = colors;
        }

        if (Object.keys(materials).length === 0) continue;
        choices[part] = materials;
      }

      return choices;
    },
    materialOptions: function materialOptions() {
      return this.activePart ? this.filteredOptions[this.activePart] || {} : {};
    },
    colorOptions: function colorOptions() {
      if (!this.activeMaterial) {
        return {};
      } else if (this.multipleMaterials === false || this.colorToggle === true) {
        return this.materialColors(this.activeMaterial);
      } else {
        return this.partColors(this.activePart);
      }
    },
    currentColor: function currentColor() {
      return this.parts[this.activePart] || {};
    },
    sync: function sync() {
      return this.$store.state.sync || {};
    }
  },
  watch: {
    parts: function parts() {
      // triggers the update of the swatch values according
      // to the newly set parts
      this.updateSwatches(); // scrolls to the selected color after updating the parts,
      // allowing centering of the selected color after choosing
      // a color of a different material than the previous one

      this.scrollColors(this.activeMaterial);
    },
    options: function options() {
      this.updateSwatches();
      var parts = Object.keys(this.options);
      this.activePart = parts[0];

      for (var _i4 = 0, _parts = parts; _i4 < _parts.length; _i4++) {
        var part = _parts[_i4];
        var materials = this.options[part];

        if (Object.keys(materials).length > 1) {
          this.multipleMaterials = true;
          return;
        }
      }

      this.multipleMaterials = false;
    },
    activePart: function activePart(part, oldPart) {
      if (!part) {
        return;
      }

      var current = this.parts[this.activePart];
      var materials = Object.keys(this.materialOptions);
      var materialSelected = current && current.material;
      var material = materialSelected ? current.material : materials[0];
      this.selectMaterial(material, false); // if the material stays the same, it updates the color
      // in case there is previously defined color

      if (current && current.material === this.activeMaterial) {
        this.activeColor = current.color;
      }
    },
    activeMaterial: function activeMaterial(material) {
      var current = this.parts[this.activePart];

      if (current && material === current.material) {
        this.activeColor = current.color;
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener("resize", function () {
      _this.updateScrollFlags();

      switch (_this.alignScroll) {
        case "left":
          // on window resize there is no need to realign
          // because the element is already correctly aligned
          break;

        case "center":
          _this.recenter();

          break;

        default:
          break;
      }
    });
    this.$store.watch(this.$store.getters.getParts, function (parts) {
      var current = parts[_this.activePart];

      if (current && (!_this.activeMaterial || _this.activeMaterial === current.material)) {
        _this.activeMaterial = current.material;
        _this.activeColor = current.color;
      }
    });
    this.$bus.bind("pre_config", function () {
      _this.loading = true;
      _this.activePart = null;
      _this.activeMaterial = null;
      _this.activeColor = null;

      _this.$forceUpdate();
    });
    this.$bus.bind("post_config", function () {
      _this.loading = false;
    });
    this.$bus.bind("locale_changed", function () {
      _this.$forceUpdate();
    });
    this.$bus.bind("locale_map_changed", function () {
      _this.$forceUpdate();
    });
    this.$bus.bind("choices", function (choices) {
      _this.choices = choices;

      _this.$forceUpdate();
    });
    this.$bus.bind("selected_part", function (part) {
      _this.activePart = part;
    });
    var colorsPicker = this.$refs.colorsPicker;
    colorsPicker.addEventListener("touchstart", function () {
      return colorsPicker.classList.add("drag");
    });
    colorsPicker.addEventListener("touchend", function () {
      return colorsPicker.classList.remove("drag");
    });
    colorsPicker.addEventListener("touchcancel", function () {
      return colorsPicker.classList.remove("drag");
    });
    var scrollElement = colorsPicker.querySelector("span");
    scrollElement.addEventListener("scroll", function () {
      if (colorsPicker.classList.contains("drag") === false) {
        return false;
      }

      var colorButtons = scrollElement.querySelectorAll(".button-color-option");
      var centerColor = null;
      var maxOffset = scrollElement.scrollWidth - scrollElement.clientWidth;
      var targetOffset = scrollElement.scrollLeft + scrollElement.clientWidth / 2;
      targetOffset = scrollElement.scrollLeft === 0 ? 0 : targetOffset;
      targetOffset = targetOffset >= maxOffset ? maxOffset : targetOffset;
      var offset = null;

      var _iterator = _createForOfIteratorHelper(colorButtons),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var color = _step.value;
          var colorOffset = Math.abs(targetOffset - color.offsetLeft);

          if (centerColor === null || colorOffset < offset) {
            centerColor = color;
            offset = colorOffset;
          } else if (colorOffset > offset) {
            break;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (centerColor === null) {
        return;
      }

      var material = centerColor.getAttribute("data-material");

      _this.selectMaterial(material, false);

      _this.scrollMaterials(material);
    }, false);
  },
  methods: {
    updateScrollFlags: function updateScrollFlags() {
      this.scrollParts = this.$refs.partsPicker && this.$refs.partsPicker.scrollWidth > this.$refs.partsPicker.clientWidth;
      this.scrollMaterial = this.$refs.materialsPicker && this.$refs.materialsPicker.scrollWidth > this.$refs.materialsPicker.clientWidth;
      this.scrollColor = this.$refs.colorsPicker && this.$refs.colorsPicker.scrollWidth > this.$refs.colorsPicker.clientWidth;
    },
    recenter: function recenter() {
      this.recenterPart();
      this.recenterMaterial();
      this.recenterColor();
    },
    recenterPart: function recenterPart() {
      if (!this.alignedPart) return;
      var partsPicker = this.$refs.partsPicker;
      var parts = partsPicker.querySelectorAll(".button-part");
      this.centerElement(partsPicker, parts, "part", this.alignedPart);
    },
    recenterMaterial: function recenterMaterial() {
      if (!this.alignedMaterial) return;
      var materialsPicker = this.$refs.materialsPicker;
      var materials = materialsPicker.querySelectorAll(".button-material");
      this.centerElement(materialsPicker, materials, "material", this.alignedMaterial);
    },
    recenterColor: function recenterColor() {
      if (!this.alignedColor) return;
      var colorsPicker = this.$refs.colorsPicker;
      var colors = colorsPicker.querySelectorAll(".button-color-option");
      this.centerElement(colorsPicker, colors, "color", this.alignedColor);
    },

    /**
     * Centers a given element in a container using scrolling.
     *
     * @param {Element} container The HTML element representing the container that
     * the elements are in.
     * @param {NodeList} elements An array representing the elements.
     * @param {String} valueLabel A string representing the components being "slided"
     * (parts, materials and colors).
     * @param {String} expectedValue A string representing the element that must in the
     * center of the container.
     */
    centerElement: function centerElement(container, elements, valueLabel, expectedValue) {
      var centerElementWidth = 0;

      var width = this._sumElementsWidth(elements, function (element, index, elementWidth, width) {
        // centers the selected element in the middle of the container
        if (element.dataset[valueLabel] === expectedValue) {
          centerElementWidth = elementWidth;
          return true;
        }

        return false;
      });

      var padding = parseFloat(getComputedStyle(container).paddingLeft);
      var scrollableElementWidth = container.clientWidth - padding;
      container.scrollLeft = width + centerElementWidth / 2 - scrollableElementWidth / 2 + padding / 2;
    },
    slideLeftParts: function slideLeftParts() {
      var partsPicker = this.$refs.partsPicker;
      var parts = partsPicker.querySelectorAll(".button-part");
      this.slideLeftStrategy(partsPicker, parts, "part");
    },
    slideLeftMaterials: function slideLeftMaterials() {
      var materialsPicker = this.$refs.materialsPicker;
      var materials = materialsPicker.querySelectorAll(".button-material");
      this.slideLeftStrategy(materialsPicker, materials, "material");
    },
    slideLeftColors: function slideLeftColors() {
      var colorsPicker = this.$refs.colorsPicker;
      var colors = colorsPicker.querySelectorAll(".button-color-option");
      this.slideLeftStrategy(colorsPicker, colors, "color");
    },

    /**
     * Based on the left sliding alignment strategy chosen, it calls the
     respective methods.
     *
     * @param {Element} container The HTML element representing the container that
     * the elements are in.
     * @param {NodeList} elements An array representing the elements.
     * @param {String} valueLabel A string representing the components being "slided"
     * (parts, materials and colors).
     */
    slideLeftStrategy: function slideLeftStrategy(container, elements, valueLabel) {
      switch (this.alignScroll) {
        case "left":
          this.slideLeft(container, elements);
          break;

        case "center":
          this.slideLeftCentered(container, elements, valueLabel);
          break;

        default:
          this.slideLeft(container, elements);
          break;
      }
    },

    /**
     * Scrolls in the left direction to show the next element that is
     * still not fully visible.
     *
     * @param {Element} container The HTML element representing the container
     * that the elements are in.
     * @param {NodeList} elements An array representing the elements.
     */
    slideLeft: function slideLeft(container, elements) {
      var scrollLeft = container.scrollLeft;
      var combinedWidth = 0;

      var _iterator2 = _createForOfIteratorHelper(elements),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _element = _step2.value;
          var style = getComputedStyle(_element);
          var marginLeft = parseFloat(style.marginLeft);
          var marginRight = parseFloat(style.marginRight);
          var elementWidth = _element.offsetWidth + marginLeft + marginRight;

          if (combinedWidth + elementWidth >= scrollLeft) {
            break;
          }

          combinedWidth += elementWidth;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      container.scrollLeft = combinedWidth;
    },

    /**
     * Scrolls in the left direction by centering the element in the middle.
     *
     * @param {Element} container The HTML element representing the container
     * that the elements are in.
     * @param {NodeList} elements An array representing the elements.
     * @param {String} valueLabel A string representing the components being
     * "slided" (parts, materials and colors).
     */
    slideLeftCentered: function slideLeftCentered(container, elements, valueLabel) {
      this.slideCentered(container, elements, valueLabel, false);
    },
    slideRightParts: function slideRightParts() {
      var partsPicker = this.$refs.partsPicker;
      var parts = partsPicker.querySelectorAll(".button-part");
      this.slideRightStrategy(partsPicker, parts, "part");
    },
    slideRightMaterials: function slideRightMaterials() {
      var materialsPicker = this.$refs.materialsPicker;
      var materials = materialsPicker.querySelectorAll(".button-material");
      this.slideRightStrategy(materialsPicker, materials, "material");
    },
    slideRightColors: function slideRightColors() {
      var colorsPicker = this.$refs.colorsPicker;
      var colors = colorsPicker.querySelectorAll(".button-color-option");
      this.slideRightStrategy(colorsPicker, colors, "color");
    },

    /**
     * Based on the right sliding alignment strategy chosen, it calls the
     * respective methods.
     *
     * @param {Element} container The HTML element representing the container
     * that the elements are in.
     * @param {NodeList} elements An array representing the elements.
     * @param {String} valueLabel A string representing the components being
     * "slided" (parts, materials and colors).
     */
    slideRightStrategy: function slideRightStrategy(container, elements, valueLabel) {
      switch (this.alignScroll) {
        case "left":
          this.slideRight(container, elements);
          break;

        case "center":
          this.slideRightCentered(container, elements, valueLabel);
          break;

        default:
          this.slideRight(container, elements);
          break;
      }
    },

    /**
     * Scrolls in the right direction to show the next element that is still not fully visible.
     *
     * @param {Element} container the HTML element representing the container that the elements are in
     * @param {NodeList} elements An array representing the elements.
     */
    slideRight: function slideRight(container, elements) {
      var scrollLeft = container.scrollLeft;
      var combinedWidth = 0;

      var _iterator3 = _createForOfIteratorHelper(elements),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var _element = _step3.value;
          var style = getComputedStyle(_element);
          var marginLeft = parseFloat(style.marginLeft);
          var marginRight = parseFloat(style.marginRight);
          var elementWidth = _element.offsetWidth + marginLeft + marginRight;

          if (combinedWidth + elementWidth > scrollLeft) {
            combinedWidth += elementWidth;
            break;
          }

          combinedWidth += elementWidth;
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      container.scrollLeft = combinedWidth;
    },

    /**
     * Scrolls in the right direction by centering the element in the middle.
     *
     * @param {Element} container The HTML element representing the container
     * that the elements are in.
     * @param {NodeList} elements An array representing the elements.
     * @param {String} valueLabel A string representing the components being
     * "slided" (parts, materials and colors).
     */
    slideRightCentered: function slideRightCentered(container, elements, valueLabel) {
      this.slideCentered(container, elements, valueLabel, true);
    },

    /**
     * Scrolls in the direction provided and centers the next element in
     * the middle of the container.
     *
     * @param {Element} container The HTML element representing the container
     * that the elements are in.
     * @param {NodeList} elements An array representing the elements.
     * @param {String} valueLabel A string representing the components being
     * slided (parts, materials and colors).
     * @param {Boolean} right A boolean representing if the sliding is
     * in the right or left direction.
     */
    slideCentered: function slideCentered(container, elements, valueLabel) {
      var _this2 = this;

      var right = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      // support for aligned slide in the colors container, which
      // has another container inside it
      var scrollableContainer = valueLabel === "color" ? container.querySelector("span") : container; // calculates the width of the container without the padding
      // allowing for precise calculations to center the elements

      var containerStyle = getComputedStyle(scrollableContainer);
      var paddingRight = parseFloat(containerStyle.paddingRight);
      var paddingLeft = parseFloat(containerStyle.paddingLeft);
      var containerWidth = container.offsetWidth - paddingRight - paddingLeft; // the container center calculation takes into account the
      // slide direction, where the left one will be made from
      // right to left by reversing the elements

      var containerCenter = null;

      if (right) {
        containerCenter = container.scrollLeft + containerWidth / 2;
      } else {
        var totalWidth = this._sumElementsWidth(elements, function () {
          return false;
        });

        containerCenter = totalWidth - (container.scrollLeft + containerWidth / 2);
      }

      var slide = 0;

      this._sumElementsWidth(elements, function (element, index, elementWidth, width) {
        // if the element middle is after the middle of the container by more or
        // equal than 1 pixel (to avoid catching the element that is already centered)
        // it is the next element, so its center will be positioned at the middle
        // of the container element
        var diff = width + elementWidth / 2 - containerCenter;
        if (diff < 1) return false;
        slide = diff;
        _this2["aligned".concat(_this2.capitalize(valueLabel))] = element.dataset[valueLabel];
        return true;
      }, !right);

      container.scrollLeft = right ? container.scrollLeft + slide : container.scrollLeft - slide;
    },
    configName: function configName(part) {
      return part.split("_").join(" ");
    },
    getColorSwatchURL: function getColorSwatchURL(material, color) {
      return this.$ripe._getSwatchURL({
        material: material,
        color: color
      });
    },
    getPartSwatchURL: function getPartSwatchURL(part) {
      var currentPart = this.parts[part] || {};
      return this.getColorSwatchURL(currentPart.material, currentPart.color);
    },
    colorSwatch: function colorSwatch(material, color) {
      return this.swatches["".concat(material, ":").concat(color)];
    },
    partSwatch: function partSwatch(part) {
      return this.swatches[part];
    },
    isOptional: function isOptional(part) {
      var defaultPart = this.defaults[part] || {};
      return Boolean(defaultPart.optional);
    },
    colorOptionText: function colorOptionText(colorOption) {
      var optional = this.isOptional(this.activePart);

      if (optional && (colorOption.material.startsWith("no_") || colorOption.color.startsWith("no_"))) {
        return this.localeModel(this.activePart, "no_" + this.activePart);
      }

      return this.localeModel(this.activePart, colorOption.material, colorOption.color);
    },
    selectedColor: function selectedColor() {
      var part = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      part = part || this.part;
      return this.parts[part];
    },
    isSelected: function isSelected(colorOption) {
      return !this.currentColor.color && colorOption.color.startsWith("no_") || this.currentColor.material === colorOption.material && this.currentColor.color === colorOption.color;
    },
    updateSwatches: function updateSwatches() {
      var swatches = {};

      for (var part in this.options) {
        swatches[part] = this.getPartSwatchURL(part);
        var materials = this.options[part];

        for (var material in materials) {
          var colors = materials[material];

          var _iterator4 = _createForOfIteratorHelper(colors),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var color = _step4.value;
              swatches["".concat(material, ":").concat(color)] = this.getColorSwatchURL(material, color);
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
        }
      }

      this.swatches = swatches;
    },
    selectPart: function selectPart(part) {
      var center = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      this.activePart = part;
      this.$bus.trigger("picker_part", part);
      this.$bus.trigger("highlight_part", part);
      this.onMaterialsChanged();
      this.onColorsChanged();
      if (center) this.centerParts();
    },
    selectSwatch: function selectSwatch() {
      var _this3 = this;

      var removeOptional = this.activeColor.startsWith("no_");
      var material = removeOptional ? null : this.activeMaterial;
      var color = removeOptional ? null : this.activeColor; // triggers both the action to change the part on the current model
      // and the action to run a lowlight on the part (hide mask)

      this.$bus.trigger("part_change", this.activePart, material, color);
      this.$bus.trigger("lowlight_part", this.activePart, material, color); // runs the update swatches operation so that they are properly updated
      // in according to the swatches selection

      this.updateSwatches();
      this.isOptional(this.activePart) && this.$nextTick(function () {
        return _this3.$forceUpdate();
      });
    },
    partColors: function partColors(part) {
      var colors = [];
      var partColors = this.filteredOptions[part];
      var isOptional = this.isOptional(part);

      for (var material in partColors) {
        var materialColors = partColors[material];
        var index = 0;

        var _iterator5 = _createForOfIteratorHelper(materialColors),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var color = _step5.value;
            colors.push({
              material: material,
              color: color,
              index: index
            });
            index++;
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }

        if (isOptional) {
          colors.push({
            material: "no_" + part,
            color: "no_" + part,
            index: index
          });
        }
      }

      return colors;
    },
    materialColors: function materialColors(material) {
      var colors = [];
      var index = 0;
      var materialColors = this.materialOptions[material] || [];

      var _iterator6 = _createForOfIteratorHelper(materialColors),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var color = _step6.value;
          colors.push({
            material: material,
            color: color,
            index: index
          });
          index++;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      if (this.isOptional(this.activePart)) {
        colors.push({
          material: material,
          color: "no_" + this.activePart,
          index: index
        });
      }

      return colors;
    },

    /**
     * Scrolls the current picker's materials container to the target
     * material defined as string, optionally using a smooth based transition.
     *
     * @param {String} material The name of the material to scroll to.
     * @param {Boolean} smooth If the transition should be performed
     * using a smooth strategy.
     */
    scrollMaterials: function scrollMaterials(material) {
      var smooth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (this.multipleMaterials === false || this.colorToggle === true) {
        return false;
      }

      var materialsPicker = this.$refs.materialsPicker;
      var materialButton = materialsPicker.querySelector('.button-material[data-material="' + material + '"]');
      materialsPicker.style.scrollBehavior = smooth ? null : "auto";
      materialsPicker.scrollLeft = materialButton ? materialButton.clientWidth / 2 + materialButton.offsetLeft - materialsPicker.clientWidth / 2 : 0;
      materialsPicker.style.scrollBehavior = smooth ? "auto" : null;
    },
    centerParts: function centerParts() {
      if (!this.enableCenterParts) return;
      var partsPicker = this.$refs.partsPicker;
      var parts = partsPicker.querySelectorAll(".button-part");
      this.alignedPart = this.activePart;
      this.centerElement(partsPicker, parts, "part", this.activePart);
    },
    centerMaterials: function centerMaterials() {
      if (!this.enableCenterMaterials) return;
      var materialsPicker = this.$refs.materialsPicker;
      var materials = materialsPicker.querySelectorAll(".button-material");
      this.alignedMaterial = this.activeMaterial;
      this.centerElement(materialsPicker, materials, "material", this.activeMaterial);
    },

    /**
     * Centers the active color inside its scrollable container.
     */
    centerActiveColor: function centerActiveColor() {
      var colorsPicker = this.$refs.colorsPicker;
      var scrollableElement = colorsPicker.querySelector("span");
      var part = this.parts[this.activePart];
      this.alignedColor = this.activeColor;
      if (!part) return;

      if (part.material !== this.activeMaterial) {
        colorsPicker.scrollLeft = 0;
        return;
      }

      var colors = colorsPicker.querySelectorAll(".button-color-option");
      var scrollActiveColor = 0;

      var _iterator7 = _createForOfIteratorHelper(colors),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _color = _step7.value;

          // ignores all elements being transitioned out
          if (_color.dataset.material !== this.activeMaterial) {
            continue;
          }

          var style = getComputedStyle(_color);
          var marginLeft = parseFloat(style.marginLeft);
          var marginRight = parseFloat(style.marginRight);

          if (_color.dataset.color === this.activeColor) {
            scrollActiveColor += (_color.offsetWidth + marginLeft + marginRight) / 2;
            break;
          } // offset width doesn't account for the margins, so we must sum them explicitly


          scrollActiveColor += _color.offsetWidth + marginLeft + marginRight;
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var padding = parseFloat(getComputedStyle(scrollableElement).paddingLeft);
      var scrollableElementWidth = colorsPicker.clientWidth - padding;
      colorsPicker.scrollLeft = scrollActiveColor - scrollableElementWidth / 2 + padding / 2;
    },

    /**
     * Scrolls the color's container to the defined material and optionally
     * a specific color.
     *
     * If a smooth transition should be ensured for the scroll operation.
     *
     * @param {String} material The name of the material to scroll to.
     * @param {String} color The name of the color to scroll to.
     * @param {Boolean} smooth If the smooth transition should be ensured.
     */
    scrollColors: function scrollColors(material, color) {
      var smooth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (this.multipleMaterials === false) {
        return false;
      }

      if (this.colorToggle) {
        this.centerActiveColor();
        return;
      } // gathers the reference to the proper colors picker and obtains
      // the references to the complete set of color elements


      var colorsPicker = this.$refs.colorsPicker;
      var colors = colorsPicker.querySelectorAll(".button-color-option"); // initializes the counter of pixels for the (new) scroll left position
      // to be applied to the scroll element

      var scrollLeft = 0; // searches the selected material, summing the offsets until the requested
      // material (and optionally color) is found

      var _iterator8 = _createForOfIteratorHelper(colors),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var _color = _step8.value;
          var style = getComputedStyle(_color);
          var marginLeft = parseFloat(style.marginLeft);
          var marginRight = parseFloat(style.marginRight);

          if (_color.dataset.material === material && (!color || _color.dataset.color === color)) {
            if (_color.dataset.index === "0") {
              scrollLeft += marginLeft;
            }

            break;
          } // offset width doesn't account for the margins, so we must sum them explicitly


          scrollLeft += _color.offsetWidth + marginLeft + marginRight;
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      var scrollElement = colorsPicker.querySelector("span");
      scrollElement.style.scrollBehavior = smooth === false ? "auto" : null;
      scrollElement.scrollLeft = scrollLeft;
      scrollElement.style.scrollBehavior = smooth === false ? null : "auto";
      return true;
    },
    selectMaterial: function selectMaterial(material) {
      var _this4 = this;

      var scroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var center = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      scroll = scroll === null ? this.multipleMaterials : scroll;
      var materialChanged = this.activeMaterial !== material;
      this.activeMaterial = material;

      if (scroll || center) {
        requestAnimationFrame(function () {
          if (center) _this4.centerMaterials();
          if (scroll) _this4.scrollMaterials(material); // scrolls the colors if material have changed and if
          // all the colors of all materials are shown (no color
          // toggle is currently in display)

          if (materialChanged && !_this4.colorToggle) {
            _this4.scrollColors(material);
          }
        });
      }
    },
    buttonPartsClasses: function buttonPartsClasses(button) {
      var base = {};
      if (button.disabled) base.disabled = button.disabled;
      if (button.id) base["button-part-".concat(button.id)] = button.id;
      return base;
    },
    onColorClick: function onColorClick(option) {
      if (this.isSelected(option)) return;
      this.selectMaterial(option.material);
      this.activeColor = option.color;
      this.selectSwatch();
    },
    onButtonPartClick: function onButtonPartClick(buttonEvent, event) {
      this.$emit(buttonEvent, event);
    },
    onMaterialsChanged: function onMaterialsChanged() {
      var _this5 = this;

      requestAnimationFrame(function () {
        _this5.scrollMaterials(_this5.activeMaterial, false);

        _this5.scrollColors(_this5.activeMaterial, null, false);

        _this5.updateScrollFlags();
      });
    },
    onColorsChanged: function onColorsChanged() {
      var _this6 = this;

      requestAnimationFrame(function () {
        _this6.scrollMaterials(_this6.activeMaterial, false);

        _this6.scrollColors(_this6.activeMaterial, null, false);

        _this6.updateScrollFlags();
      });
    },
    onColorsAnimationAfterEnter: function onColorsAnimationAfterEnter(element) {
      // update scroll flags after the last element in the list
      // enters the animation, so that the sizes of the components
      // are finalized and the dataset it set
      if (element.dataset.index < this.colorOptions.length - 1) return;
      this.updateScrollFlags(); // centers the existing active color after the last element
      // in the list enter the animation, so that the number of
      // elements is correct

      if (this.activeColor) this.scrollColors(this.activeMaterial, null, false);
    },

    /**
     * Finds the element closer to the center of the container depending
     * on the scrolling direction (left and right).
     *
     * @param {Element} container The HTML element representing the container
     * that the elements are in.
     * @param {NodeList} elements An array representing the elements.
     * @param {String} valueLabel A string representing the components being
     * "slided" (parts, materials and colors).
     * @param {String} scroll A string representing the scrolling directions
     * (left and right).
     */
    _findScrollCenterElement: function _findScrollCenterElement(container, elements, valueLabel, scroll) {
      // calculates the width of the container without the padding
      // allowing for precise calculations to center the elements
      var containerStyle = getComputedStyle(container);
      var paddingRight = parseFloat(containerStyle.paddingRight);
      var paddingLeft = parseFloat(containerStyle.paddingLeft);
      var containerWidth = container.offsetWidth - paddingRight - paddingLeft;
      var containerCenter = container.scrollLeft + containerWidth / 2; // iterates over the elements until it finds the element closer
      // to the center of the container on its left or right side

      var scrollElement = null;

      this._sumElementsWidth(elements, function (element, index, elementWidth, width) {
        if (width > containerCenter) {
          scrollElement = width === "left" ? element.dataset[valueLabel] : elements[index - 1].dataset[valueLabel];
          return true;
        }

        return false;
      });

      return scrollElement;
    },

    /**
     * Iterates over the elements while adding the elements width
     * and running an operation which marks a possible stopping point.
     *
     * @param {NodeList} elements An array representing the elements.
     * @param {Function} stop A function that decides the stopping point.
     */
    _sumElementsWidth: function _sumElementsWidth(elements, stop) {
      var reverse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var width = 0;

      if (reverse) {
        elements = Array.from(elements);
        elements = elements.reverse();
      } // iterates over the complete set of elements to compute the
      // amount of scroll required to be applied in the parent
      // container (sum of the complete with of elements)


      var _iterator9 = _createForOfIteratorHelper(elements.entries()),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _step9$value = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_step9.value, 2),
              index = _step9$value[0],
              _element = _step9$value[1];

          var style = getComputedStyle(_element);
          var marginLeft = parseFloat(style.marginLeft);
          var marginRight = parseFloat(style.marginRight);
          var elementWidth = _element.offsetWidth + marginLeft + marginRight;
          if (stop(_element, index, elementWidth, width)) return width; // increments the width value with the width of the component,
          // which is composed by both the offset width and the margins

          width += elementWidth;
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }

      return width;
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Pickers);

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Size; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Size = {
  name: "size",
  mixins: [_mixins__WEBPACK_IMPORTED_MODULE_2__["partMixin"], _mixins__WEBPACK_IMPORTED_MODULE_2__["modalMixin"]],
  data: function data() {
    return {
      enabled: false,
      form: null,
      sizeText: "",
      sizeTextState: "",
      state: {},
      counter: 0,
      closeCallback: null,
      active: true
    };
  },
  computed: {
    buttonText: function buttonText() {
      return this.sizeTextState ? (this.isMobileWidth() || this.isTabletWidth() ? "" : this.locale("ripe_commons.size.size") + " - ") + this.sizeTextState : this.locale("ripe_commons.size.select_size");
    },
    buttonEnabled: function buttonEnabled() {
      return this.enabled && this.active;
    },
    buttonClasses: function buttonClasses() {
      return {
        disabled: !this.buttonEnabled
      };
    },
    formKey: function formKey() {
      return this.brand + "." + this.model + "." + this.counter;
    },
    originalState: function originalState() {
      return this.$store.state.size;
    },
    allowApply: function allowApply() {
      return this.state.size && this.state.scale && this.state.gender;
    },
    visible: function visible() {
      return this.$refs.modal.visible;
    },
    hasSize: function hasSize() {
      return this.$store.state.hasSize;
    }
  },
  watch: {
    enabled: function enabled(_enabled) {
      !_enabled && this.clear();
    },
    modelError: function modelError(error) {
      this.enabled = !error;
    },
    active: {
      handler: function handler(value) {
        this.$store.commit("sizeActive", value);
      },
      immediate: true
    }
  },
  created: function created() {
    var _this = this;

    this.$bus.bind("enable_size", this.enableSize);
    this.$bus.bind("disable_size", this.disableSize);
    this.$bus.bind("open_size", function (callback) {
      var uid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // if this was the component instance that originated the
      // opening request, ignore it (only perform this validation
      // in case the UID has been explicitly requested)
      if (uid && uid === _this._uid) return;
      _this.closeCallback = callback;

      _this.showModal();
    });
    this.$bus.bind("close_size", function () {
      var uid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      // if this was the component instance that originated the
      // closing request, ignore it (only perform this validation
      // in case the UID has been explicitly requested)
      if (uid && uid === _this._uid) return; // the closing callback should only run when the modal is visible
      // not doing so would trigger the close callback multiple times for
      // the multiple available size models (if that's the case)

      if (!_this.visible) _this.closeCallback = null; // triggers the hide modal operation (part of the mixin definition)
      // that should call the associated pre-defined hooks

      _this.hideModal();
    });
    this.$bus.bind("pre_config", function () {
      _this.enabled = false;
      _this.active = true;
      _this.form = null;
    });
    this.$bus.bind("post_config", /*#__PURE__*/function () {
      var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee(config) {
        var plugins, plugin, form;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(!config || !_this.hasSize)) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                _context.next = 4;
                return _this.manager.getPluginsByCapability("size");

              case 4:
                plugins = _context.sent.filter(function (plugin) {
                  return !plugin.meta.brand || plugin.meta.brand === _this.brand;
                }).filter(function (plugin) {
                  return !plugin.meta.models || plugin.meta.models && plugin.meta.models.includes(_this.model);
                }).map(function (plugin) {
                  var value = 0;
                  value += plugin.meta.brand === _this.brand ? 1 : 0;
                  value += plugin.meta.models && plugin.meta.models.includes(_this.model) ? 1 : 0;
                  return [value, plugin];
                }).sort(function (a, b) {
                  return b[0] - a[0];
                }).map(function (v) {
                  return v[1];
                });
                plugin = plugins.length ? plugins[0] : null; // in case there's no valid size plugin available raises an error
                // indicating the issue with size loading

                if (plugin) {
                  _context.next = 8;
                  break;
                }

                throw new Error("No size component found for ".concat(_this.brand));

              case 8:
                _context.next = 10;
                return plugin.getSizeComponent();

              case 10:
                form = _context.sent;
                // increments the cache invalidation counter, internal hack to enable
                // proper computation of computed values
                _this.counter += 1; // sets the form for the current component, sets it as enable and hidden
                // by default (initial state)

                _this.form = form;

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  mounted: function mounted() {
    var _this2 = this;

    this.updateSizeText();
    this.$bus.bind("refresh", function () {
      _this2.updateSizeText();
    });
    this.$bus.bind("size", function (state) {
      if (_this2.state.size === state.size && _this2.state.scale === state.scale && _this2.state.gender === state.gender) {
        return;
      }

      _this2.state = state;

      _this2.$refs.form.setState(_this2.state);

      _this2.updateSizeText();
    });
  },
  methods: {
    apply: function apply() {
      this.$store.commit("size", this.state);
      this.$bus.trigger("size", this.state);
      this.hideModal();
    },
    clear: function clear() {
      if (this.form) this.$refs.form.reset();
    },
    modalBeforeEnter: function modalBeforeEnter() {
      this.$bus.trigger("open_size", this.closeCallback);
      this.$refs.form.show();
    },
    modalBeforeLeave: function modalBeforeLeave() {
      // restores the original state (state at the time of the modal
      // opening operation) to the modal so that the modal is restored
      this.originalState ? this.$refs.form.setState(this.originalState) : this.$refs.form.reset();
      this.updateSizeText(); // triggers the close size event and the hides the form of the
      // managed by the "external" plugin

      this.$bus.trigger("close_size", this._uid);
      this.$refs.form.hide();
    },
    modalHidden: function modalHidden() {
      // in case the allow apply flag is set and a close callback
      // exists calls it exactly one time
      if (this.allowApply && this.closeCallback) this.closeCallback();
      this.closeCallback = null;
    },
    enableSize: function enableSize() {
      if (!this.modelError) {
        this.enabled = true;
      }
    },
    disableSize: function disableSize() {
      this.enabled = false;
    },
    sizeChanged: function sizeChanged(form) {
      this.state = form.getState();
      this.sizeText = form.getSizeText();
      this.state.sizeText = this.sizeText;
      if (!this.visible) this.apply();
      if (!this.visible) this.updateSizeText();
    },
    updateSizeText: function updateSizeText() {
      this.sizeTextState = this.sizeText;
    }
  }
};
/* harmony default export */ __webpack_exports__["b"] = (Size);

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _global_global_vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(129);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _global_global_vue__WEBPACK_IMPORTED_MODULE_0__["a"]; });



var install = function install(Vue) {
  Vue.component("global", _global_global_vue__WEBPACK_IMPORTED_MODULE_0__[/* Global */ "a"]);
};


/* harmony default export */ __webpack_exports__["b"] = (install);

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_global_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(101);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_global_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

 /* harmony default export */ __webpack_exports__["b"] = (_node_modules_babel_loader_lib_index_js_ref_3_0_node_modules_vue_loader_lib_index_js_vue_loader_options_global_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"]); 

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Global; });
/* harmony import */ var _mixins__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
//
//
//
//
//
//
//
//
//

var Global = {
  name: "global",
  mixins: [_mixins__WEBPACK_IMPORTED_MODULE_0__["utilsMixin"]]
};
/* harmony default export */ __webpack_exports__["b"] = (Global);

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _base_size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _base_size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
var render, staticRenderFns




/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(
  _base_size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"],
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 103 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var _regeneratorRuntime = __webpack_require__(0);

var _asyncToGenerator = __webpack_require__(1);

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Object that contains global (static) information to be used by
 * the visuals infrastructure (eg global identifier counter).
 */


ripe.visualGlobals = {
  id: 0,
  instances: []
};
/**
 * @class
 * @augments Interactable
 * @classdesc The superclass for visual representations of a Ripe instance.
 *
 * @param {Ripe} owner The Ripe instance to be represented.
 * @param {Object} element The DOM element that should be updated.
 * @param {Object} options The options to be used to configure the Visual representation.
 */

ripe.Visual = function (owner, element, options) {
  this.element = element;
  this.elementEvents = {};
  this.type = this.type || "Visual";
  ripe.Interactable.call(this, owner, options);
};

ripe.Visual.prototype = ripe.build(ripe.Interactable.prototype);
ripe.Visual.prototype.constructor = ripe.Visual;
/**
 * The initializer which is called (by the owner)
 * whenever the Visual is going to become active.
 */

ripe.Visual.prototype.init = function () {
  ripe.Interactable.prototype.init.call(this);
  ripe.visualGlobals.id++;
  this.id = ripe.visualGlobals.id;
  ripe.visualGlobals.instances.push(this);
};
/**
 * The deinitializer to be called (by the owner) when
 * it should stop responding to updates so that any necessary
 * cleanup operations can be executed.
 */


ripe.Visual.prototype.deinit = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          this._removeElementHandlers();

          this.element = null;
          this.elementEvents = null;
          ripe.visualGlobals.instances.splice(ripe.visualGlobals.instances.indexOf(this), 1);
          ripe.Interactable.prototype.deinit.call(this);

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this);
}));
/**
 * Utility function that binds an event to the interactable
 * DOM element and keeps a reference to it to unbind it
 * when no longer needed.
 *
 * @param {String} event The name of the event for which an event
 * handler is going to be registered.
 * @param {Function} callback The callback function to called once
 * the event is triggered.
 *
 * @ignore
 */

ripe.Visual.prototype._addElementHandler = function (event, callback) {
  this.element.addEventListener(event, callback);
  var callbacks = this.elementEvents[event] || [];
  callbacks.push(callback);
  this.elementEvents[event] = callbacks;
};
/**
 * Unbinds all the events from the DOM element.
 *
 * @ignore
 */


ripe.Visual.prototype._removeElementHandlers = function () {
  for (var event in this.elementEvents) {
    var callbacks = this.elementEvents[event];

    for (var index = 0; index < callbacks.length; index++) {
      var callback = callbacks[index];
      this.element.removeEventListener(event, callback);
    }
  }

  this.elementEvents = {};
};

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _initials_images_vue_vue_type_template_id_ddfed566_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(132);
/* harmony import */ var _initials_images_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _initials_images_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _initials_images_vue_vue_type_style_index_0_id_ddfed566_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(300);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _initials_images_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _initials_images_vue_vue_type_template_id_ddfed566_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _initials_images_vue_vue_type_template_id_ddfed566_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "ddfed566",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _initials_inputs_vue_vue_type_template_id_54cc77a2_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(133);
/* harmony import */ var _initials_inputs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _initials_inputs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _initials_inputs_vue_vue_type_style_index_0_id_54cc77a2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(302);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _initials_inputs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _initials_inputs_vue_vue_type_template_id_54cc77a2_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _initials_inputs_vue_vue_type_template_id_54cc77a2_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "54cc77a2",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _reference_vue_vue_type_template_id_1fd4de22_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(134);
/* harmony import */ var _reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _reference_vue_vue_type_style_index_0_id_1fd4de22_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(304);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _reference_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _reference_vue_vue_type_template_id_1fd4de22_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _reference_vue_vue_type_template_id_1fd4de22_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "1fd4de22",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _reference_multi_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _reference_multi_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
var render, staticRenderFns




/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(
  _reference_multi_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"],
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _alert_vue_vue_type_template_id_1c850db3_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(136);
/* harmony import */ var _alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _alert_vue_vue_type_style_index_0_id_1c850db3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(311);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _alert_vue_vue_type_template_id_1c850db3_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _alert_vue_vue_type_template_id_1c850db3_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "1c850db3",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _button_vue_vue_type_template_id_b8a271f4_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(137);
/* harmony import */ var _button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _button_vue_vue_type_style_index_0_id_b8a271f4_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(313);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _button_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _button_vue_vue_type_template_id_b8a271f4_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _button_vue_vue_type_template_id_b8a271f4_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "b8a271f4",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _button_platforme_vue_vue_type_template_id_619fdb62_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(138);
/* harmony import */ var _button_platforme_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _button_platforme_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _button_platforme_vue_vue_type_style_index_0_id_619fdb62_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(316);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _button_platforme_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _button_platforme_vue_vue_type_template_id_619fdb62_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _button_platforme_vue_vue_type_template_id_619fdb62_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "619fdb62",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _icon_vue_vue_type_template_id_54c652ab_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(139);
/* harmony import */ var _icon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _icon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _icon_vue_vue_type_style_index_0_id_54c652ab_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(647);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _icon_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _icon_vue_vue_type_template_id_54c652ab_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _icon_vue_vue_type_template_id_54c652ab_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "54c652ab",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _image_vue_vue_type_template_id_6a1fe188_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(140);
/* harmony import */ var _image_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _image_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _image_vue_vue_type_style_index_0_id_6a1fe188_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(649);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _image_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _image_vue_vue_type_template_id_6a1fe188_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _image_vue_vue_type_template_id_6a1fe188_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "6a1fe188",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _loader_vue_vue_type_template_id_4ab0aa70_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(141);
/* harmony import */ var _loader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _loader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _loader_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _loader_vue_vue_type_template_id_4ab0aa70_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _loader_vue_vue_type_template_id_4ab0aa70_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "4ab0aa70",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _thumbnail_vue_vue_type_template_id_78a6a4ce_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(142);
/* harmony import */ var _thumbnail_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _thumbnail_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _thumbnail_vue_vue_type_style_index_0_id_78a6a4ce_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(653);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _thumbnail_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _thumbnail_vue_vue_type_template_id_78a6a4ce_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _thumbnail_vue_vue_type_template_id_78a6a4ce_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "78a6a4ce",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ask_vue_vue_type_template_id_619b262f_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(143);
/* harmony import */ var _ask_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _ask_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _ask_vue_vue_type_style_index_0_id_619b262f_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(655);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _ask_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _ask_vue_vue_type_template_id_619b262f_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _ask_vue_vue_type_template_id_619b262f_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "619b262f",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _component_plugin_vue_vue_type_template_id_558e8919___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(144);
/* harmony import */ var _component_plugin_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _component_plugin_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _component_plugin_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _component_plugin_vue_vue_type_template_id_558e8919___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _component_plugin_vue_vue_type_template_id_558e8919___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _keyboard_vue_vue_type_template_id_1f741d86_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(145);
/* harmony import */ var _keyboard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _keyboard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _keyboard_vue_vue_type_style_index_0_id_1f741d86_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(659);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _keyboard_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _keyboard_vue_vue_type_template_id_1f741d86_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _keyboard_vue_vue_type_template_id_1f741d86_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "1f741d86",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _modal_vue_vue_type_template_id_16085a82_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(146);
/* harmony import */ var _modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _modal_vue_vue_type_style_index_0_id_16085a82_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(662);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _modal_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _modal_vue_vue_type_template_id_16085a82_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _modal_vue_vue_type_template_id_16085a82_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "16085a82",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _restrictions_alert_vue_vue_type_template_id_42620411_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(147);
/* harmony import */ var _restrictions_alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _restrictions_alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _restrictions_alert_vue_vue_type_style_index_0_id_42620411_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(664);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _restrictions_alert_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _restrictions_alert_vue_vue_type_template_id_42620411_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _restrictions_alert_vue_vue_type_template_id_42620411_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "42620411",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tab_vue_vue_type_template_id_ff34e8b0_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(148);
/* harmony import */ var _tab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _tab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _tab_vue_vue_type_style_index_0_id_ff34e8b0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(666);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _tab_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _tab_vue_vue_type_template_id_ff34e8b0_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _tab_vue_vue_type_template_id_ff34e8b0_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "ff34e8b0",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _tabs_vue_vue_type_template_id_42df1f38_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(149);
/* harmony import */ var _tabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _tabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _tabs_vue_vue_type_style_index_0_id_42df1f38_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(668);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _tabs_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _tabs_vue_vue_type_template_id_42df1f38_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _tabs_vue_vue_type_template_id_42df1f38_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "42df1f38",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _thumbnails_vue_vue_type_template_id_4a2116e6___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(150);
/* harmony import */ var _thumbnails_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _thumbnails_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _thumbnails_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _thumbnails_vue_vue_type_template_id_4a2116e6___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _thumbnails_vue_vue_type_template_id_4a2116e6___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _thumbnails_groups_vue_vue_type_template_id_02de563a_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(151);
/* harmony import */ var _thumbnails_groups_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _thumbnails_groups_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _thumbnails_groups_vue_vue_type_style_index_0_id_02de563a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(670);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _thumbnails_groups_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _thumbnails_groups_vue_vue_type_template_id_02de563a_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _thumbnails_groups_vue_vue_type_template_id_02de563a_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "02de563a",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _configurator_vue_vue_type_template_id_3b4fbbc5_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(152);
/* harmony import */ var _configurator_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _configurator_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _configurator_vue_vue_type_style_index_0_id_3b4fbbc5_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(673);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _configurator_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _configurator_vue_vue_type_template_id_3b4fbbc5_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _configurator_vue_vue_type_template_id_3b4fbbc5_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "3b4fbbc5",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _personalization_vue_vue_type_template_id_776050ee_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(153);
/* harmony import */ var _personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _personalization_vue_vue_type_style_index_0_id_776050ee_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _personalization_vue_vue_type_template_id_776050ee_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _personalization_vue_vue_type_template_id_776050ee_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "776050ee",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _pickers_vue_vue_type_template_id_096292b2_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(154);
/* harmony import */ var _pickers_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _pickers_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _pickers_vue_vue_type_style_index_0_id_096292b2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(677);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _pickers_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _pickers_vue_vue_type_template_id_096292b2_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _pickers_vue_vue_type_template_id_096292b2_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "096292b2",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _size_vue_vue_type_template_id_0f4bb5a0_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(155);
/* harmony import */ var _size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _size_vue_vue_type_style_index_0_id_0f4bb5a0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(682);
/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2);






/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(
  _size_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _size_vue_vue_type_template_id_0f4bb5a0_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _size_vue_vue_type_template_id_0f4bb5a0_scoped_true___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  "0f4bb5a0",
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _global_vue_vue_type_template_id_7fff48f2___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(156);
/* harmony import */ var _global_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(100);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _global_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);





/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])(
  _global_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_1__[/* default */ "b"],
  _global_vue_vue_type_template_id_7fff48f2___WEBPACK_IMPORTED_MODULE_0__[/* render */ "a"],
  _global_vue_vue_type_template_id_7fff48f2___WEBPACK_IMPORTED_MODULE_0__[/* staticRenderFns */ "b"],
  false,
  null,
  null,
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 130 */
/***/ (function(module) {

module.exports = JSON.parse("{\"a\":\"ripe-commons-pluginus\",\"b\":\"0.9.12\"}");

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _base_personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _base_personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
var render, staticRenderFns




/* normalize component */

var component = Object(_node_modules_vue_loader_lib_runtime_componentNormalizer_js__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(
  _base_personalization_vue_vue_type_script_lang_js___WEBPACK_IMPORTED_MODULE_0__[/* default */ "b"],
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* unused harmony default export */ var _unused_webpack_default_export = (component.exports);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_images_vue_vue_type_template_id_ddfed566_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(178);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_images_vue_vue_type_template_id_ddfed566_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_images_vue_vue_type_template_id_ddfed566_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_inputs_vue_vue_type_template_id_54cc77a2_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(180);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_inputs_vue_vue_type_template_id_54cc77a2_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_inputs_vue_vue_type_template_id_54cc77a2_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_template_id_1fd4de22_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(182);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_template_id_1fd4de22_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_template_id_1fd4de22_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_template_id_e3301666_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(185);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_template_id_e3301666_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_template_id_e3301666_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_alert_vue_vue_type_template_id_1c850db3_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(191);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_alert_vue_vue_type_template_id_1c850db3_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_alert_vue_vue_type_template_id_1c850db3_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_template_id_b8a271f4_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(193);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_template_id_b8a271f4_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_template_id_b8a271f4_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_button_platforme_vue_vue_type_template_id_619fdb62_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(195);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_button_platforme_vue_vue_type_template_id_619fdb62_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_button_platforme_vue_vue_type_template_id_619fdb62_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_template_id_54c652ab_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(197);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_template_id_54c652ab_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_template_id_54c652ab_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_image_vue_vue_type_template_id_6a1fe188_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(206);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_image_vue_vue_type_template_id_6a1fe188_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_image_vue_vue_type_template_id_6a1fe188_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_template_id_4ab0aa70_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(208);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_template_id_4ab0aa70_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_loader_vue_vue_type_template_id_4ab0aa70_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnail_vue_vue_type_template_id_78a6a4ce_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(209);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnail_vue_vue_type_template_id_78a6a4ce_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnail_vue_vue_type_template_id_78a6a4ce_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ask_vue_vue_type_template_id_619b262f_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(211);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ask_vue_vue_type_template_id_619b262f_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_ask_vue_vue_type_template_id_619b262f_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_component_plugin_vue_vue_type_template_id_558e8919___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(217);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_component_plugin_vue_vue_type_template_id_558e8919___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_component_plugin_vue_vue_type_template_id_558e8919___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_keyboard_vue_vue_type_template_id_1f741d86_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(218);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_keyboard_vue_vue_type_template_id_1f741d86_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_keyboard_vue_vue_type_template_id_1f741d86_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_template_id_16085a82_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(220);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_template_id_16085a82_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_template_id_16085a82_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_restrictions_alert_vue_vue_type_template_id_42620411_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(222);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_restrictions_alert_vue_vue_type_template_id_42620411_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_restrictions_alert_vue_vue_type_template_id_42620411_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_tab_vue_vue_type_template_id_ff34e8b0_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(224);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_tab_vue_vue_type_template_id_ff34e8b0_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_tab_vue_vue_type_template_id_ff34e8b0_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_template_id_42df1f38_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(226);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_template_id_42df1f38_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_template_id_42df1f38_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_vue_vue_type_template_id_4a2116e6___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(228);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_vue_vue_type_template_id_4a2116e6___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_vue_vue_type_template_id_4a2116e6___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_groups_vue_vue_type_template_id_02de563a_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(229);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_groups_vue_vue_type_template_id_02de563a_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_groups_vue_vue_type_template_id_02de563a_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_configurator_vue_vue_type_template_id_3b4fbbc5_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(231);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_configurator_vue_vue_type_template_id_3b4fbbc5_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_configurator_vue_vue_type_template_id_3b4fbbc5_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_personalization_vue_vue_type_template_id_776050ee_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(233);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_personalization_vue_vue_type_template_id_776050ee_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_personalization_vue_vue_type_template_id_776050ee_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_pickers_vue_vue_type_template_id_096292b2_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(235);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_pickers_vue_vue_type_template_id_096292b2_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_pickers_vue_vue_type_template_id_096292b2_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_size_vue_vue_type_template_id_0f4bb5a0_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(237);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_size_vue_vue_type_template_id_0f4bb5a0_scoped_true___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_size_vue_vue_type_template_id_0f4bb5a0_scoped_true___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_global_vue_vue_type_template_id_7fff48f2___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(239);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_global_vue_vue_type_template_id_7fff48f2___WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _node_modules_vue_loader_lib_loaders_templateLoader_js_vue_loader_options_node_modules_vue_loader_lib_index_js_vue_loader_options_global_vue_vue_type_template_id_7fff48f2___WEBPACK_IMPORTED_MODULE_0__["b"]; });



/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* unused harmony export Store */
/* unused harmony export createLogger */
/* unused harmony export createNamespacedHelpers */
/* unused harmony export install */
/* unused harmony export mapActions */
/* unused harmony export mapGetters */
/* unused harmony export mapMutations */
/* unused harmony export mapState */
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((false)) {}

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((false)) {}
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((false)) {}

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((false)) {}
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((false)) {}

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((false)) {}
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((false)) {}
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    false
  ) {}
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((false)) {}
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((false)) {}
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((false)) {}
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((false)) {}
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((false)) {}
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {}

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((false)) {}

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((false)) {}

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && ("production" !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((false)) {}
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {}
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if (false) {}
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((false)) {}
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((false)) {}
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((false)) {}

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((false)) {}
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if (false) {}
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if (false) {}
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if (false) {}
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if (false) {}
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if (false) {}
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if (false) {}
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103)))

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalize; });
var normalize = function normalize(value) {
  return value.split("_").join(" ");
};
/* unused harmony default export */ var _unused_webpack_default_export = (normalize);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DevicePlugin; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var DevicePlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(DevicePlugin, _RipeCommonsPlugin);

  var _super = _createSuper(DevicePlugin);

  function DevicePlugin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, DevicePlugin);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(DevicePlugin, [{
    key: "load",
    value: function () {
      var _load = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(DevicePlugin.prototype), "load", this).call(this);

              case 2:
                this.init();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "unload",
    value: function () {
      var _unload = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(DevicePlugin.prototype), "unload", this).call(this);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function unload() {
        return _unload.apply(this, arguments);
      }

      return unload;
    }()
  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsCapability */ "a"]["new"]("helper")];
    }
  }, {
    key: "init",
    value: function init() {
      this.desktopClass = "desktop";
      this.tabletClass = "tablet";
      this.mobileClass = "mobile";
      this.TABLET_WIDTH = 768;
      this.MOBILE_WIDTH = 420;
      this.body = document.getElementsByTagName("body")[0];
      this.listen();
      this.updateClass();
    }
  }, {
    key: "setTabletWidth",
    value: function setTabletWidth(width) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.tabletWidth = width;
      if (update) this.updateClass();
    }
  }, {
    key: "setMobileWidth",
    value: function setMobileWidth(width) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.mobileWidth = width;
      if (update) this.updateClass();
    }
  }, {
    key: "listen",
    value: function listen() {
      var _this = this;

      window.addEventListener("resize", function () {
        return _this.updateClass();
      });
    }
  }, {
    key: "updateClass",
    value: function updateClass() {
      var width = window.innerWidth;
      this.body.classList.remove(this.desktopClass);
      this.body.classList.remove(this.tabletClass);
      this.body.classList.remove(this.mobileClass);
      var tabletWidth = this.tabletWidth || this.TABLET_WIDTH;
      var mobileWidth = this.mobileWidth || this.MOBILE_WIDTH;

      if (width > tabletWidth) {
        this.body.classList.add(this.desktopClass);
      } else if (width > mobileWidth) {
        this.body.classList.add(this.tabletClass);
      } else {
        this.body.classList.add(this.mobileClass);
      }
    }
  }]);

  return DevicePlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsPlugin */ "b"]);
DevicePlugin.register();

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RipeCommonsCapability; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pluginus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25);
/* harmony import */ var pluginus__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pluginus__WEBPACK_IMPORTED_MODULE_4__);





function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var RipeCommonsCapability = /*#__PURE__*/function (_Capability) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1___default()(RipeCommonsCapability, _Capability);

  var _super = _createSuper(RipeCommonsCapability);

  function RipeCommonsCapability() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RipeCommonsCapability);

    return _super.apply(this, arguments);
  }

  return RipeCommonsCapability;
}(pluginus__WEBPACK_IMPORTED_MODULE_4__["Capability"]);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RipeCommonsPlugin; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pluginus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25);
/* harmony import */ var pluginus__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pluginus__WEBPACK_IMPORTED_MODULE_4__);





function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


/**
 * Abstract class to be inherited from all the plugins
 * that are considered to be part of RIPE Commons.
 *
 * Should contain the abstract functionality within the
 * RIPE Commons functionality.
 */

var RipeCommonsPlugin = /*#__PURE__*/function (_Plugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_1___default()(RipeCommonsPlugin, _Plugin);

  var _super = _createSuper(RipeCommonsPlugin);

  function RipeCommonsPlugin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RipeCommonsPlugin);

    return _super.apply(this, arguments);
  }

  return RipeCommonsPlugin;
}(pluginus__WEBPACK_IMPORTED_MODULE_4__["Plugin"]);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SHOW_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return logError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return logInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return logDebug; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);

var SHOW_LEVEL = false;
var logError = function logError(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  console.error(_format(value, label, "ERROR"));
};
var logInfo = function logInfo(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  console.info(_format(value, label, "INFO"));
};
var logDebug = function logDebug(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  console.debug(_format(value, label, "DEBUG"));
};

var _format = function _format(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  switch (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(value)) {
    case "object":
      value = JSON.stringify(value);
      break;

    case "function":
      value = value();
      break;
  }

  label = label || "RIPE";
  return "".concat(SHOW_LEVEL && level ? "[" + level + "] " : "", "[").concat(label, "] ").concat(value);
};

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initialsFromExtra; });
/**
 * Resolves both the main initials and engraving taking into consideration
 * the provided initials extra as a fallback process.
 *
 * @param {Object} initialsExtra The dictionary structure associating
 * the multiple initials groups with their initials engraving values.
 * @param {String} initials The initials to be used as override if any.
 * @param {String} engraving The engraving to be used as override if any.
 * @returns {Object} The normalized initials and engraving values withing
 * an object resolved according to the provided initials extra (main group)
 * or the initials and engraving parameters.
 */
var initialsFromExtra = function initialsFromExtra(initialsExtra) {
  var initials = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
  var engraving = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
  initialsExtra = initialsExtra || {};
  var groups = Object.keys(initialsExtra);
  var mainGroup = groups.includes("main") || groups.length === 0 ? "main" : groups[0];
  var mainInitials = initialsExtra[mainGroup] || {};
  initials = initials === undefined ? mainInitials.initials : initials;
  engraving = engraving === undefined ? mainInitials.engraving : engraving;
  return {
    initials: initials || "",
    engraving: engraving || null
  };
};

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UrlChangerPlugin; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var ripe_sdk__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19);
/* harmony import */ var ripe_sdk__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(ripe_sdk__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4);









function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_6___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var UrlChangerPlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(UrlChangerPlugin, _RipeCommonsPlugin);

  var _super = _createSuper(UrlChangerPlugin);

  function UrlChangerPlugin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, UrlChangerPlugin);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(UrlChangerPlugin, [{
    key: "load",
    value: function () {
      var _load = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee() {
        var _this = this;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(UrlChangerPlugin.prototype), "load", this).call(this);

              case 2:
                this.model = null;
                this.locale = null;
                this.theme = null;
                this.onModelChanged = this.owner.bind("model_changed", function (model) {
                  return _this.updateQuery({
                    model: model
                  });
                });
                this.onLocaleChanged = this.owner.bind("locale_changed", function (locale) {
                  return _this.updateQuery({
                    locale: locale
                  });
                });
                this.onThemeChanged = this.owner.bind("theme_changed", function (theme) {
                  return _this.updateQuery({
                    theme: theme
                  });
                });
                this.onUpdateQuery = this.owner.bind("update_query", function () {
                  return _this.updateQuery();
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "unload",
    value: function () {
      var _unload = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_8___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.owner.unbind("update_query", this.onUpdateQuery);
                this.owner.unbind("locale_changed", this.onLocaleChanged);
                this.owner.unbind("theme_changed", this.onThemeChanged);
                this.owner.unbind("model_changed", this.onModelChanged);
                _context2.next = 6;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_7___default()(UrlChangerPlugin.prototype), "unload", this).call(this);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function unload() {
        return _unload.apply(this, arguments);
      }

      return unload;
    }()
  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_10__[/* RipeCommonsCapability */ "a"]["new"]("helper")];
    }
  }, {
    key: "updateQuery",
    value: function updateQuery() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$model = _ref.model,
          model = _ref$model === void 0 ? null : _ref$model,
          _ref$locale = _ref.locale,
          locale = _ref$locale === void 0 ? null : _ref$locale,
          _ref$theme = _ref.theme,
          theme = _ref$theme === void 0 ? null : _ref$theme;

      this.model = model || this.model;
      this.locale = locale || this.locale;
      this.theme = theme || this.theme; // validates that the current model structure contains
      // a valid object structure and the model name is set,
      // this avoids unnecessary URL updates

      if (!this.model) return;
      if (!this.model.model) return;

      var query = this._generateQuery(this.model, this.locale, this.theme, false);

      var href = query ? "?" + query : "";
      window.history.replaceState({}, null, href);
    }
  }, {
    key: "_generateQuery",
    value: function _generateQuery(model, locale, theme) {
      var decode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      // retrieves the current search query value and parses it,
      // then unpacks the parts for the current model to be used
      // in the part triplets generation
      var search = window.location.search;
      var query = new URLSearchParams(search);
      var parts = model.parts || {}; // a full query will be generated, so clear the parameters
      // that are exclusively used as entry points since they
      // aren't needed anymore and might be outdated with regards
      // to the current model configuration

      query["delete"]("dku");
      query["delete"]("product_id");
      if (model.brand) query.set("brand", model.brand);else query["delete"]("brand");
      if (model.model) query.set("model", model.model);else query["delete"]("model");
      if (model.variant) query.set("variant", model.variant);else query["delete"]("variant");
      if (model.version) query.set("version", model.version);else query["delete"]("version");
      if (model.flag) query.set("flag", model.flag);else query["delete"]("flag");
      if (locale) query.set("locale", locale);else query["delete"]("locale");
      if (theme && theme !== "default") query.set("theme", theme);else query["delete"]("theme");

      if (model.personalization) {
        if (model.personalization.initials) {
          query.set("initials", model.personalization.initials);
        } else {
          query["delete"]("initials");
        }

        if (model.personalization.engraving) {
          query.set("engraving", model.personalization.engraving);
        } else {
          query["delete"]("engraving");
        }

        query["delete"]("initials_extra");
        var initialsExtra = model.personalization.initialsExtra;

        if (initialsExtra) {
          for (var _i = 0, _Object$entries = Object.entries(initialsExtra); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_Object$entries[_i], 2),
                key = _Object$entries$_i[0],
                value = _Object$entries$_i[1];

            if (value.initials && !value.engraving) {
              value.engraving = null;
            }

            if (!value.initials && value.engraving) {
              delete initialsExtra[key];
            }
          }

          var strInitialsExtra = new ripe_sdk__WEBPACK_IMPORTED_MODULE_9__["Ripe"]({
            init: false
          })._generateExtraS(initialsExtra);

          var _iterator = _createForOfIteratorHelper(strInitialsExtra),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var extraS = _step.value;
              query.append("initials_extra", extraS);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      }

      query["delete"]("p");

      for (var part in parts) {
        var _value = parts[part];

        if (!_value.material || !_value.color) {
          continue;
        }

        var partQ = "".concat(part, ":").concat(_value.material, ":").concat(_value.color);
        query.append("p", partQ);
      }

      this.owner.trigger("generate_query", query);
      var queryS = query.toString();
      return decode ? decodeURIComponent(queryS) : queryS;
    }
  }]);

  return UrlChangerPlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_10__[/* RipeCommonsPlugin */ "b"]);
UrlChangerPlugin.register();

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(166);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 166 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Assigns a certain set of values in the provided object to the
 * first parameter of the call (target).
 *
 * @param {String} target The target of the assign operation meaning
 * the object to which the values will be assigned.
 *
 * @ignore
 */


ripe.assign = function (target) {
  if (typeof Object.assign === "function") {
    return Object.assign.apply(this, arguments);
  }

  if (target === null) {
    throw new TypeError("Cannot assign undefined or null object");
  }

  var to = Object(target);

  for (var index = 1; index < arguments.length; index++) {
    var nextSource = arguments[index];

    if (nextSource == null) {
      continue;
    }

    for (var nextKey in nextSource) {
      if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
        to[nextKey] = nextSource[nextKey];
      }
    }
  }

  return to;
};
/**
 * @ignore
 */


ripe.build = function () {
  var _arguments = Array.prototype.slice.call(arguments);

  _arguments.unshift({});

  return ripe.assign.apply(this, _arguments);
};

if ( true && (typeof window === "undefined" || typeof __webpack_require__ !== "undefined") && // eslint-disable-line camelcase
typeof XMLHttpRequest === "undefined" // eslint-disable-line no-use-before-define
) {
    // eslint-disable-next-line no-var
    var XMLHttpRequest = null;

    if (typeof window !== "undefined" && typeof window.XMLHttpRequest !== "undefined") {
      XMLHttpRequest = window.XMLHttpRequest;
    } else if (typeof global !== "undefined" && typeof global.XMLHttpRequest !== "undefined") {
      XMLHttpRequest = global.XMLHttpRequest;
    } else if ( // eslint-disable-next-line camelcase
    false) { var correctModuleName, mixedModuleName; }
  }

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative") && typeof fetch === "undefined" // eslint-disable-line no-use-before-define
) {
    // eslint-disable-next-line no-var
    var fetch = null;

    if (typeof window !== "undefined" && typeof window.fetch !== "undefined") {
      fetch = window.fetch;
    } else if (typeof global !== "undefined" && typeof global.fetch !== "undefined") {
      fetch = global.fetch;
    } else if ( // eslint-disable-next-line camelcase
    false) {}
  }

if (true) {
  module.exports = {
    XMLHttpRequest: XMLHttpRequest,
    fetch: fetch
  };
}
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103)))

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var _regeneratorRuntime = __webpack_require__(0);

var _asyncToGenerator = __webpack_require__(1);

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @class
 * @classdesc An object that emits events.
 * Listeners can bind to specific events and be notified when the event is triggered.
 */


ripe.Observable = function () {
  this.callbacks = {};
};
/**
 * The initializer of the class, called whenever this
 * observable starts its activity.
 */


ripe.Observable.prototype.init = function () {};
/**
 * The deinitializer of the class, called whenever this
 * observable ceases its activity.
 */


ripe.Observable.prototype.deinit = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          this.callbacks = null;

        case 1:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this);
}));
/**
 * Binds to an event by providing a block that will receive the event payload as a
 * parameter and return a Deferred that will be completed asynchronously.
 *
 * @param {String} event Name of the event to bind to.
 * @param {Function} callback Function to be executed when the event is triggered.
 * @returns {Function} Returns the provided callback, to be used when unbinding from the event.
 */

ripe.Observable.prototype.addCallback = function (event, callback) {
  var callbacks = this.callbacks[event] || [];
  callbacks.push(callback);
  this.callbacks[event] = callbacks;
  return callback;
};
/**
 * Unbinds the provided callback from an event.
 *
 * @param {String} event The name of the event.
 * @param {Function} callback The callback that was returned when the bind method was called.
 */


ripe.Observable.prototype.removeCallback = function (event, callback) {
  var callbacks = this.callbacks[event] || [];

  if (!callback) {
    delete this.callbacks[event];
    return;
  }

  var index = callbacks.indexOf(callback);

  if (index === -1) {
    return;
  }

  callbacks.splice(index, 1);
  this.callbacks[event] = callbacks;
};
/**
 * Triggers the event by calling all its bound callbacks with args as parameters.
 *
 * @param {String} event The name of the event to be triggered.
 * @param {Boolean} wait If the callback execution should wait for every single
 * execution before running the next one.
 * @returns {Promise} Returns a Promise of all results that will be completed
 * when all of the callbacks have finished processing the triggered event.
 */


ripe.Observable.prototype.runCallbacks = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(event) {
    var wait,
        _result,
        callbacks,
        results,
        _len,
        args,
        _key,
        index,
        callback,
        _result2,
        result,
        _args2 = arguments;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            wait = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;

            if (this.callbacks) {
              _context2.next = 6;
              break;
            }

            _context2.next = 4;
            return Promise.all([null]);

          case 4:
            _result = _context2.sent;
            return _context2.abrupt("return", _result);

          case 6:
            callbacks = this.callbacks[event] || [];
            results = [];

            for (_len = _args2.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
              args[_key - 2] = _args2[_key];
            }

            index = 0;

          case 10:
            if (!(index < callbacks.length)) {
              _context2.next = 24;
              break;
            }

            callback = callbacks[index];
            _result2 = callback.apply(this, args);

            if (!(_result2 === undefined || _result2 === null)) {
              _context2.next = 15;
              break;
            }

            return _context2.abrupt("continue", 21);

          case 15:
            if (!wait) {
              _context2.next = 20;
              break;
            }

            _context2.next = 18;
            return _result2;

          case 18:
            _context2.next = 21;
            break;

          case 20:
            results.push(_result2);

          case 21:
            index++;
            _context2.next = 10;
            break;

          case 24:
            _context2.next = 26;
            return Promise.all(results);

          case 26:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 28:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

ripe.Observable.prototype.runCallbacksWait = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(event) {
    var _len2,
        args,
        _key2,
        result,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            for (_len2 = _args3.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = _args3[_key2];
            }

            _context3.next = 3;
            return this.runCallbacks.apply(this, [event, true].concat(args));

          case 3:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}();

ripe.Observable.prototype.runCallbackNoWait = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(event) {
    var _len3,
        args,
        _key3,
        result,
        _args4 = arguments;

    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            for (_len3 = _args4.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
              args[_key3 - 1] = _args4[_key3];
            }

            _context4.next = 3;
            return this.runCallbacks.apply(this, [event, false].concat(args));

          case 3:
            result = _context4.sent;
            return _context4.abrupt("return", result);

          case 5:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, this);
  }));

  return function (_x3) {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * Alias to addCallback.
 */


ripe.Observable.prototype.bind = ripe.Observable.prototype.addCallback;
/**
 * Alias to removeCallback.
 */

ripe.Observable.prototype.unbind = ripe.Observable.prototype.removeCallback;
/**
 * Alias to runCallbackNoWait.
 */

ripe.Observable.prototype.trigger = ripe.Observable.prototype.runCallbackNoWait;
/**
 * Alias to runCallbacksWait.
 */

ripe.Observable.prototype.triggerWait = ripe.Observable.prototype.runCallbacksWait;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var base = __webpack_require__(268);

Object.assign(module.exports, base);

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var _toConsumableArray = __webpack_require__(28);

var _regeneratorRuntime = __webpack_require__(0);

var _asyncToGenerator = __webpack_require__(1);

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9);

  __webpack_require__(104); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @class
 * @classdesc Class that defines an interactive Configurator instance to be
 * used in connection with the main Ripe owner to provide an
 * interactive configuration experience inside a DOM.
 *
 * @param {Object} owner The owner (customizer instance) for
 * this configurator.
 * @param {Object} element The DOM element that is considered to
 * be the target for the configurator, it's going to have its own
 * inner HTML changed.
 * @param {Object} options The options to be used to configure the
 * configurator instance to be created.
 */


ripe.ConfiguratorPrc = function (owner, element, options) {
  this.type = this.type || "ConfiguratorPrc";
  ripe.Visual.call(this, owner, element, options);
};

ripe.ConfiguratorPrc.prototype = ripe.build(ripe.Visual.prototype);
ripe.ConfiguratorPrc.prototype.constructor = ripe.ConfiguratorPrc;
/**
 * The Configurator initializer, which is called whenever
 * the Configurator is going to become active.
 *
 * Sets the various values for the Configurator taking into
 * owner's default values.
 */

ripe.ConfiguratorPrc.prototype.init = function () {
  var _this = this;

  ripe.Visual.prototype.init.call(this);
  this.width = this.options.width || 1000;
  this.height = this.options.height || 1000;
  this.format = this.options.format || null;
  this.size = this.options.size || null;
  this.mutations = this.options.mutations || false;
  this.maxSize = this.options.maxSize || 1000;
  this.pixelRatio = this.options.pixelRatio || typeof window !== "undefined" && window.devicePixelRatio || 2;
  this.sensitivity = this.options.sensitivity || 40;
  this.verticalThreshold = this.options.verticalThreshold || 15;
  this.clickThreshold = this.options.clickThreshold || 0.015;
  this.duration = this.options.duration || 500;
  this.preloadDelay = this.options.preloadDelay || 150;
  this.maskOpacity = this.options.maskOpacity || 0.4;
  this.maskDuration = this.options.maskDuration || 150;
  this.noMasks = this.options.noMasks === undefined ? true : this.options.noMasks;
  this.useMasks = this.options.useMasks === undefined ? !this.noMasks : this.options.useMasks;
  this.view = this.options.view || "side";
  this.position = this.options.position || 0;
  this.configAnimate = this.options.configAnimate === undefined ? "cross" : this.options.configAnimate;
  this.viewAnimate = this.options.viewAnimate === undefined ? "cross" : this.options.viewAnimate;
  this.ready = false;
  this._finalize = null;
  this._observer = null;
  this._ownerBinds = {};
  this._pending = []; // registers for the selected part event on the owner
  // so that we can highlight the associated part

  this._ownerBinds.selected_part = this.owner.bind("selected_part", function (part) {
    return _this.highlight(part);
  }); // registers for the deselected part event on the owner
  // so that we can remove the highlight of the associated part

  this._ownerBinds.deselected_part = this.owner.bind("deselected_part", function (part) {
    return _this.lowlight();
  }); // creates a structure the store the last presented
  // position of each view, to be used when returning
  // to a view for better user experience

  this._lastFrame = {}; // creates the necessary DOM elements and runs
  // the initial layout update operation if the
  // owner has a model and brand set (is ready)

  this._initLayout();

  if (this.owner.brand && this.owner.model) {
    this._updateConfig();
  } // registers for the pre config to be able to set the configurator
  // into a not ready state (update operations blocked)


  this._ownerBinds.pre_config = this.owner.bind("pre_config", function () {
    _this.ready = false;
  }); // registers for the post config change request event to
  // be able to properly update the internal structures

  this._ownerBinds.post_config = this.owner.bind("post_config", function (config) {
    if (config) _this._updateConfig();
  });
};
/**
 * The Configurator deinitializer, to be called (by the owner) when
 * it should stop responding to updates so that any necessary
 * cleanup operations can be executed.
 */


ripe.ConfiguratorPrc.prototype.deinit = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var bind;
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return this.cancel();

        case 2:
          while (this.element.firstChild) {
            this.element.removeChild(this.element.firstChild);
          }

          for (bind in this._ownerBinds) {
            this.owner.unbind(bind, this._ownerBinds[bind]);
          }

          this._removeElementHandlers();

          if (this._observer) this._observer.disconnect();
          this._finalize = null;
          this._observer = null;
          ripe.Visual.prototype.deinit.call(this);

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this);
}));
/**
 * Updates configurator current options with the ones provided.
 *
 * @param {Object} options Set of optional parameters to adjust the Configurator, such as:
 * - 'sensitivity' - Rotation sensitivity to the user mouse drag action.
 * - 'duration' - The duration in milliseconds that the transition should take.
 * - 'useMasks' - Usage of masks in the current model, necessary for the part highlighting action.
 * - 'configAnimate' - The configurator animation style: 'simple' (fade in), 'cross' (crossfade) or 'null'.
 * @param {Boolean} update If an update operation should be executed after
 * the options updated operation has been performed.
 */

ripe.ConfiguratorPrc.prototype.updateOptions = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
    var update,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            update = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
            ripe.Visual.prototype.updateOptions.call(this, options);
            this.width = options.width === undefined ? this.width : options.width;
            this.height = options.height === undefined ? this.height : options.height;
            this.format = options.format === undefined ? this.format : options.format;
            this.size = options.size === undefined ? this.size : options.size;
            this.mutations = options.mutations === undefined ? this.mutations : options.mutations;
            this.maxSize = options.maxSize === undefined ? this.maxSize : this.maxSize;
            this.pixelRatio = options.pixelRation === undefined ? this.pixelRatio : options.pixelRatio;
            this.sensitivity = options.sensitivity === undefined ? this.sensitivity : options.sensitivity;
            this.verticalThreshold = options.verticalThreshold === undefined ? this.verticalThreshold : options.verticalThreshold;
            this.clickThreshold = options.clickThreshold === undefined ? this.clickThreshold : options.clickThreshold;
            this.duration = options.duration === undefined ? this.duration : options.duration;
            this.preloadDelay = options.preloadDelay === undefined ? this.preloadDelay : options.preloadDelay;
            this.maskOpacity = options.maskOpacity === undefined ? this.maskOpacity : options.maskOpacity;
            this.maskDuration = options.maskDuration === undefined ? this.maskDuration : options.maskDuration;
            this.noMasks = options.noMasks === undefined ? this.noMasks : options.noMasks;
            this.useMasks = options.useMasks === undefined ? this.useMasks : options.useMasks;
            this.configAnimate = options.configAnimate === undefined ? this.configAnimate : options.configAnimate;
            this.viewAnimate = options.viewAnimate === undefined ? this.viewAnimate : options.viewAnimate;

            if (!update) {
              _context2.next = 23;
              break;
            }

            _context2.next = 23;
            return this.update();

          case 23:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * This function is called (by the owner) whenever its state changes
 * so that the Configurator can update itself for the new state.
 *
 * This method is "protected" by unique signature validation in order
 * to avoid extra render and frame loading operations. Operations are
 * available to force the update operation even if the signature is the
 * same as the one previously set.
 *
 * @param {Object} state An object containing the new state of the owner.
 * @param {Object} options Set of optional parameters to adjust the Configurator update, such as:
 * - 'animate' - If it's to animate the update (defaults to 'false').
 * - 'duration' - The duration in milliseconds that the transition should take.
 * - 'callback' - The callback to be called at the end of the update.
 * - 'preload' - If it's to execute the pre-loading process.
 * - 'force' - If the updating operation should be forced (ignores signature).
 * @returns {Boolean} If an effective operation has been performed by the
 * update operation.
 */


ripe.ConfiguratorPrc.prototype.update = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(state) {
    var options,
        preloadPromise,
        view,
        position,
        force,
        duration,
        preload,
        previous,
        signature,
        changed,
        animate,
        unique,
        preloaded,
        mustPreload,
        result,
        success,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};

            if (!(this.ready === false)) {
              _context3.next = 4;
              break;
            }

            this.trigger("not_loaded");
            return _context3.abrupt("return", false);

          case 4:
            // allocates space for the possible promise that is going
            // to be responsible for the preloading of the frames, populating
            // the cache buffer for the complete set of frames associated with
            // the currently loaded model configuration
            preloadPromise = null;
            view = this.element.dataset.view;
            position = this.element.dataset.position;
            force = options.force || false;
            duration = options.duration;
            preload = options.preload; // checks if the parts drawed on the target have
            // changed and animates the transition if they did

            previous = this.signature || "";
            signature = this._buildSignature();
            changed = signature !== previous;
            animate = options.animate === undefined ? changed ? "simple" : false : options.animate;
            this.signature = signature; // if the parts and the position haven't changed
            // since the last frame load then ignores the
            // load request and returns immediately

            previous = this.unique;
            unique = "".concat(signature, "&view=").concat(String(view), "&position=").concat(String(position));

            if (!(previous === unique && !force)) {
              _context3.next = 20;
              break;
            }

            this.trigger("not_loaded");
            return _context3.abrupt("return", false);

          case 20:
            this.unique = unique; // removes the highlight support from the matched object as a new
            // frame is going to be "calculated" and rendered (not same mask)

            this.lowlight(); // runs the pre-loading process so that the remaining frames are
            // loaded for a smother experience when dragging the element,
            // note that this is only performed in case this is not a single
            // based update (not just the loading of the current position)
            // and the current signature has changed

            preloaded = this.element.classList.contains("preload");
            mustPreload = preload !== undefined ? preload : changed || !preloaded;
            if (mustPreload) preloadPromise = this._preload(this.options.useChain); // runs the load operation for the current frame, taking into
            // account the multiple requirements for such execution

            _context3.next = 27;
            return this._loadFrame(view, position, {
              draw: true,
              animate: animate,
              duration: duration
            });

          case 27:
            // initializes the result value with the default valid value
            // indicating that the operation was a success
            result = true; // in case the preload was requested then waits for the preload
            // operation of the frames to complete (wait on promise), keep
            // in mind that if the preload operation was requested this is
            // a "hard" flush on the underlying images buffer (most of the times
            // representing a change in the configuration)

            if (!preloadPromise) {
              _context3.next = 34;
              break;
            }

            _context3.next = 31;
            return preloadPromise;

          case 31:
            result = _context3.sent;
            _context3.next = 34;
            return this.flushPending(true);

          case 34:
            // verifies if the operation has been successful, it's considered
            // successful in case there's a result and the result is not marked
            // with the canceled flag (result of a cancel operation)
            success = result && !result.canceled;

            if (success) {
              // updates the signature of the loaded set of frames, so that for
              // instance the cancel operation can be properly controlled avoiding
              // the usage of extra resources and duplicated (cancel operations)
              this.signatureLoaded = signature; // after the update operation is finished the loaded event
              // should be triggered indicating the end of the visual
              // operations for the current configuration on the configurator

              this.trigger("loaded");
            } else {
              // unsets both the signature and the unique value because the update
              // operation has been marked as not successful so the visuals have
              // not been properly updated
              this.signature = null;
              this.unique = null;
            } // returns the resulting value indicating if the loading operation
            // as been triggered with success (effective operation)


            return _context3.abrupt("return", result);

          case 37:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * This function is called (by the owner) whenever the current operation
 * in the child should be canceled this way a Configurator is not updated.
 *
 * @param {Object} options Set of optional parameters to adjust the Configurator.
 * @returns {Boolean} If an effective operation has been performed or if
 * instead no cancel logic was executed.
 */


ripe.ConfiguratorPrc.prototype.cancel = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
  var options,
      _args4 = arguments;
  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          options = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};

          if (!(this._buildSignature() === this.signatureLoaded || "")) {
            _context4.next = 3;
            break;
          }

          return _context4.abrupt("return", false);

        case 3:
          if (this._finalize) this._finalize({
            canceled: true
          });
          return _context4.abrupt("return", true);

        case 5:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, this);
}));
/**
 * Resizes the configurator's DOM element to 'size' pixels.
 * This action is performed by setting both the attributes from
 * the HTML elements and the style.
 *
 * @param {Number} size The number of pixels to resize to.
 */

ripe.ConfiguratorPrc.prototype.resize = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(size) {
    var area, frontMask, back, mask;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            if (!(this.element === undefined)) {
              _context5.next = 2;
              break;
            }

            return _context5.abrupt("return");

          case 2:
            size = size || this.element.clientWidth;

            if (!(this.currentSize === size)) {
              _context5.next = 5;
              break;
            }

            return _context5.abrupt("return");

          case 5:
            area = this.element.querySelector(".area");
            frontMask = this.element.querySelector(".front-mask");
            back = this.element.querySelector(".back");
            mask = this.element.querySelector(".mask");
            area.width = size * this.pixelRatio;
            area.height = size * this.pixelRatio;
            area.style.width = size + "px";
            area.style.height = size + "px";
            frontMask.width = size;
            frontMask.height = size;
            frontMask.style.width = size + "px";
            frontMask.style.height = size + "px";
            frontMask.style.marginLeft = "-".concat(String(size), "px");
            back.width = size * this.pixelRatio;
            back.height = size * this.pixelRatio;
            back.style.width = size + "px";
            back.style.height = size + "px";
            back.style.marginLeft = "-".concat(String(size), "px");
            mask.width = size;
            mask.height = size;
            mask.style.width = size + "px";
            mask.style.height = size + "px";
            this.currentSize = size;
            _context5.next = 30;
            return this.update({}, {
              force: true
            });

          case 30:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function (_x3) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * Executes pending operations that were not performed so as
 * to not conflict with the tasks already being executed.
 *
 * The main reason for collision is the pre-loading operation
 * being executed (long duration operation).
 *
 * @param {Boolean} tail If only the last pending operation should
 * be flushed, meaning that the others are discarded.
 */


ripe.ConfiguratorPrc.prototype.flushPending = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
  var tail,
      pending,
      _pending$shift,
      operation,
      args,
      _args6 = arguments;

  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          tail = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : false;
          pending = tail && this._pending.length > 0 ? [this._pending[this._pending.length - 1]] : this._pending;
          this._pending = [];

        case 3:
          if (!(pending.length > 0)) {
            _context6.next = 14;
            break;
          }

          _pending$shift = pending.shift(), operation = _pending$shift.operation, args = _pending$shift.args;
          _context6.t0 = operation;
          _context6.next = _context6.t0 === "changeFrame" ? 8 : 11;
          break;

        case 8:
          _context6.next = 10;
          return this.changeFrame.apply(this, _toConsumableArray(args));

        case 10:
          return _context6.abrupt("break", 12);

        case 11:
          return _context6.abrupt("break", 12);

        case 12:
          _context6.next = 3;
          break;

        case 14:
        case "end":
          return _context6.stop();
      }
    }
  }, _callee6, this);
}));
/**
 * Displays a new frame, with an animation from the starting frame
 * proper animation should be performed.
 *
 * This function is meant to be executed using a recursive approach
 * and each run represents a "tick" of the animation operation.
 *
 * @param {Object} frame The new frame to display using the extended and canonical
 * format for the frame description (eg: side-3).
 * @param {Object} options Set of optional parameters to adjust the change frame, such as:
 * - 'type' - The animation style: 'simple' (fade in), 'cross' (crossfade) or 'null'
 * (without any style).
 * - 'duration' - The duration of the animation in milliseconds (defaults to 'null').
 * - 'stepDuration' - If defined the total duration of the animation is
 * calculated using the amount of steps times the number of steps, instead of
 * using the 'duration' field (defaults to 'null').
 * - 'revolutionDuration' - If defined the step duration is calculated by dividing
 * the revolution duration by the number of frames in the view (defaults to 'null').
 * - 'preventDrag' - If drag actions during an animated change of frames should be
 * ignored (defaults to 'true').
 * - 'safe' - If requested then the operation is only performed in case the configurator
 * is not in the an equivalent state (default to 'true').
 */

ripe.ConfiguratorPrc.prototype.changeFrame = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(frame) {
    var options,
        _frame,
        nextView,
        nextPosition,
        duration,
        stepDurationRef,
        revolutionDuration,
        type,
        preventDrag,
        safe,
        first,
        view,
        position,
        viewFrames,
        animate,
        stepDuration,
        stepPosition,
        reducedTime,
        stepCount,
        expected,
        delay,
        frameSkip,
        stepSize,
        nextStep,
        delta,
        goPositive,
        sleepTime,
        newFrame,
        _args7 = arguments;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
            // parses the requested frame value according to the pre-defined
            // standard (eg: side-3) and then unpacks it as view and position
            _frame = ripe.parseFrameKey(frame);
            nextView = _frame[0];
            nextPosition = parseInt(_frame[1]); // in case the next position value was not properly parsed (probably undefined)
            // then it's not possible to change frame (throws exception)

            if (!isNaN(nextPosition)) {
              _context7.next = 6;
              break;
            }

            throw new RangeError("Frame position is not defined");

          case 6:
            // unpacks the other options to the frame change defaulting their values
            // in case undefined values are found
            duration = options.duration === undefined ? null : options.duration;
            stepDurationRef = options.stepDuration === this.stepDuration ? null : options.stepDuration;
            revolutionDuration = options.revolutionDuration === undefined ? this.revolutionDuration : options.revolutionDuration;
            type = options.type === undefined ? null : options.type;
            preventDrag = options.preventDrag === undefined ? true : options.preventDrag;
            safe = options.safe === undefined ? true : options.safe;
            first = options.first === undefined ? true : options.first; // updates the animation start timestamp with the current timestamp in
            // case no start time is currently defined

            options._start = options._start === undefined ? new Date().getTime() : options._start;
            options._step = options._step === undefined ? 0 : options._step; // normalizes both the (current) view and position values

            view = this.element.dataset.view;
            position = parseInt(this.element.dataset.position); // tries to retrieve the amount of frames for the target view and
            // validates that the target view exists and that the target position
            // (frame) does not overflow the amount of frames in for the view

            viewFrames = this.frames[nextView];

            if (!(!viewFrames || nextPosition >= viewFrames)) {
              _context7.next = 20;
              break;
            }

            throw new RangeError("Frame " + frame + " is not supported");

          case 20:
            if (!(safe && this.element.classList.contains("preloading"))) {
              _context7.next = 23;
              break;
            }

            this._pending = [{
              operation: "changeFrame",
              args: [frame, options]
            }];
            return _context7.abrupt("return");

          case 23:
            if (!(safe && this.element.classList.contains("animating"))) {
              _context7.next = 25;
              break;
            }

            return _context7.abrupt("return");

          case 25:
            if (!(safe && this.element.dataset.view === nextView && position === nextPosition)) {
              _context7.next = 28;
              break;
            }

            this.element.classList.remove("no-drag", "animating");
            return _context7.abrupt("return");

          case 28:
            // removes any part highlight in case it is set
            // to replicate the behaviour of dragging the product
            this.lowlight(); // saves the position of the current view
            // so that it returns to the same position
            // when coming back to the same view

            this._lastFrame[view] = position;
            this.position = nextPosition;
            this.element.dataset.position = nextPosition; // if there is a new view and the product supports
            // it then animates the transition with a crossfade
            // and ignores all drag movements while it lasts

            animate = false;

            if (view !== nextView && viewFrames !== undefined) {
              this.view = nextView;
              this.element.dataset.view = nextView;
              this.element.dataset.frames = viewFrames;
              animate = type === null ? this.viewAnimate : type;
              duration = duration || this.duration;
            } // runs the defaulting values for the current step duration
            // and the next position that is going to be rendered


            stepDuration = null;
            stepPosition = nextPosition; // sets the initial time reduction to be applied for the frame
            // based animation (rotation), this value should be calculated
            // taking into account the delay in the overall animation

            reducedTime = 0; // in case any kind of duration was provided a timed animation
            // should be performed and as such a proper calculus should be
            // performed to determine the current step duration an the position
            // associated with the current step operation

            if (view === nextView && (duration || stepDurationRef || revolutionDuration)) {
              // ensures that no animation on a pre-frame render exists
              // the animation itself is going to be "managed" by the
              // the change frame tick logic
              animate = null; // calculates the number of steps as the shortest path
              // between the current and the next position, this should
              // choose the proper way for the "rotation"

              stepCount = view !== nextView ? 1 : Math.min(Math.abs(position - nextPosition), viewFrames - Math.abs(position - nextPosition));
              options._stepCount = options._stepCount === undefined ? stepCount : options._stepCount; // in case the (total) revolution time for the view is defined a
              // step timing based animation is calculated based on the total
              // number of frames for the view

              if (revolutionDuration && first) {
                // makes sure that we're able to find out the number of frames
                // for the next view from the current loaded model, only then
                // can the step duration be calculated, by dividing the total
                // duration of the revolution by the number of frames of the view
                if (viewFrames) {
                  stepDurationRef = parseInt(revolutionDuration / viewFrames);
                } // otherwise runs a fallback operation where the total duration
                // of the animation is the revolution time (sub optimal fallback)
                else {
                    duration = duration || revolutionDuration;
                  }
              } // in case the options contain the step duration (reference) field
              // then it's used to calculate the total duration of the animation
              // (step driven animation timing)


              if (stepDurationRef && first) {
                duration = stepDurationRef * stepCount;
              } // in case the end (target) timestamp is not yet defined then
              // updates the value with the target duration


              options._end = options._end === undefined ? options._start + duration : options._end; // determines the duration (in seconds) for each step taking
              // into account the complete duration and the number of steps

              stepDuration = duration / Math.abs(stepCount);
              options.duration = duration - stepDuration; // in case no step duration has been defined defines one as that's relevant
              // to be able to calculate expected time at this point in time and then
              // calculate the amount of time and frames to skip

              options._stepDuration = options._stepDuration === undefined ? stepDuration : options._stepDuration; // calculates the expected timestamp for the current position in
              // time and then the delay against it (for proper frame dropping)

              expected = options._start + options._step * options._stepDuration;
              delay = Math.max(new Date().getTime() - expected, 0); // calculates the number of frames that have to be skipped to re-catch
              // the animation back to the expect time-frame

              frameSkip = Math.floor(delay / stepDuration);
              reducedTime = delay % stepDuration;
              stepSize = frameSkip + 1; // calculates the delta in terms of steps taking into account
              // if any frame should be skipped in the animation

              nextStep = Math.min(options._stepCount, options._step + stepSize);
              delta = Math.min(stepSize, nextStep - options._step);
              options._step = nextStep; // checks if it should rotate in the positive or negative direction
              // according to the current view definition and then calculates the
              // next position taking into account that definition

              goPositive = (position + stepCount) % viewFrames === nextPosition;
              stepPosition = stepCount !== 0 ? goPositive ? position + delta : position - delta : position; // wrap around as needed (avoiding index overflow)

              stepPosition = stepPosition < 0 ? viewFrames + stepPosition : stepPosition;
              stepPosition = stepPosition % viewFrames; // updates the position according to the calculated one on
              // the dataset, the next update operation should trigger
              // the appropriate update on the visual resources

              this.position = stepPosition;
              this.element.dataset.position = stepPosition;
            } // sets the initial values for the start of the animation, allows
            // control of the current animation (and exclusive lock)


            this.element.classList.add("animating"); // if the prevent drag is set and there's an animation then
            // ignores drag movements until the animation is finished

            preventDrag = preventDrag && (animate || duration);
            if (preventDrag) this.element.classList.add("no-drag"); // calculates the amount of time that the current operation is
            // going to sleep to able to correctly address the animation sequence
            // (valid only for no animation scenarios, no cross fade) if this
            // sleep time is valid (greater than zero) tuns the async based
            // await operation for the amount of time

            sleepTime = animate ? 0 : stepDuration - reducedTime;

            if (!(sleepTime > 0)) {
              _context7.next = 45;
              break;
            }

            _context7.next = 45;
            return new Promise(function (resolve) {
              return setTimeout(function () {
                return resolve();
              }, sleepTime);
            });

          case 45:
            // computes the frame key (normalized) and then triggers an event
            // notifying any listener about the new frame that was set
            newFrame = ripe.getFrameKey(this.element.dataset.view, this.element.dataset.position);
            this.trigger("changed_frame", newFrame);
            _context7.prev = 47;
            _context7.next = 50;
            return this.update({}, {
              animate: animate,
              duration: animate ? duration : 0
            });

          case 50:
            _context7.next = 56;
            break;

          case 52:
            _context7.prev = 52;
            _context7.t0 = _context7["catch"](47);
            // removes the locking classes as the current operation has been
            // finished, effectively re-allowing: dragging and animated operations
            // and then re-throws the exception caused by update
            this.element.classList.remove("no-drag", "animating");
            throw _context7.t0;

          case 56:
            if (!(view === nextView && stepPosition === nextPosition)) {
              _context7.next = 59;
              break;
            }

            this.element.classList.remove("no-drag", "animating");
            return _context7.abrupt("return");

          case 59:
            // creates a new options instance that is going to be used in the
            // possible next tick of the operation
            options = Object.assign({}, options, {
              safe: false,
              first: false
            }); // runs the next tick operation to change the frame of the current
            // configurator to the next one (iteration cycle)

            _context7.next = 62;
            return this.changeFrame(frame, options);

          case 62:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this, [[47, 52]]);
  }));

  return function (_x4) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * Highlights a model's part, showing a dark mask on top of the such referred
 * part identifying its borders.
 *
 * @param {String} part The part of the model that should be highlighted.
 * @param {Object} options Set of optional parameters to adjust the highlighting.
 */


ripe.ConfiguratorPrc.prototype.highlight = function (part) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // in case the element is no longer available (possible due to async
  // nature of execution) returns the control flow immediately
  if (!this.element) return; // verifiers if masks are meant to be used for the current model
  // and if that's not the case returns immediately

  if (!this.useMasks) return; // captures the current context to be used by clojure callbacks

  var self = this; // determines the current position of the configurator so that
  // the proper mask URL may be created and properly loaded

  var view = this.element.dataset.view;
  var position = this.element.dataset.position;
  var frame = ripe.getFrameKey(view, position);
  var size = this.element.dataset.size || this.size;
  var width = size || this.element.dataset.width || this.width;
  var height = size || this.element.dataset.height || this.height;
  var maskOpacity = this.element.dataset.mask_opacity || this.maskOpacity;
  var maskDuration = this.element.dataset.mask_duration || this.maskDuration; // adds the highlight class to the current target configurator meaning
  // that the front mask is currently active and showing info

  this.element.classList.add("highlight"); // constructs the full URL of the mask image that is going to be
  // set for the current highlight operation (to be determined)

  var url = this.owner._getMaskURL({
    frame: frame,
    size: size,
    width: width,
    height: height,
    part: part
  }); // gathers the front mask element and the associated source URL
  // and in case it's the same as the one in request returns immediately
  // as the mask is considered to be already loaded


  var frontMask = this.element.querySelector(".front-mask");
  var src = frontMask.getAttribute("src");

  if (src === url) {
    self.trigger("highlighted_part", part);
    return;
  }

  if (this.frontMaskLoad) frontMask.removeEventListener("load", this.frontMaskLoad);
  if (this.frontMaskError) frontMask.removeEventListener("error", this.frontMaskError);
  frontMask.classList.remove("loaded");

  this.frontMaskLoad = function () {
    this.classList.add("loaded");
    self.trigger("highlighted_part", part);
  };

  this.frontMaskError = function () {
    this.setAttribute("src", "");
  };

  frontMask.addEventListener("load", this.frontMaskLoad);
  frontMask.addEventListener("error", this.frontMaskError);
  frontMask.setAttribute("src", url);
  ripe.cancelAnimation(frontMask);
  ripe.animateProperty(frontMask, "opacity", 0, maskOpacity, maskDuration, false);
};
/**
 * Removes the a highlighting of a model's part, meaning that no masks
 * are going to be presented on screen.
 *
 * @param {String} part The part to lowlight.
 * @param {Object} options Set of optional parameters to adjust the lowlighting.
 */


ripe.ConfiguratorPrc.prototype.lowlight = function (options) {
  // in case the element is no longer available (possible due to async
  // nature of execution) returns the control flow immediately
  if (!this.element) return; // verifies if masks are meant to be used for the current model
  // and if that's not the case returns immediately

  if (!this.useMasks) return; // retrieves the reference to the current front mask and removes
  // the highlight associated classes from it and the configurator

  var frontMask = this.element.querySelector(".front-mask");
  frontMask.classList.remove("highlight");
  this.element.classList.remove("highlight"); // triggers an event indicating that a lowlight operation has been
  // performed on the current configurator

  this.trigger("lowlighted");
};
/**
 * Changes the currently displayed frame in the current view to the
 * previous one according to pre-defined direction.
 */


ripe.ConfiguratorPrc.prototype.previousFrame = function () {
  var view = this.element.dataset.view;
  var position = parseInt(this.element.dataset.position || 0);
  var viewFrames = this.frames[view];
  var nextPosition = (position - 1) % viewFrames;
  nextPosition = nextPosition >= 0 ? nextPosition : viewFrames + nextPosition;
  var nextFrame = ripe.getFrameKey(view, nextPosition);
  this.changeFrame(nextFrame);
};
/**
 * Changes the currently displayed frame in the current view to the
 * next one according to pre-defined direction.
 */


ripe.ConfiguratorPrc.prototype.nextFrame = function () {
  var view = this.element.dataset.view;
  var position = parseInt(this.element.dataset.position || 0);
  var viewFrames = this.frames[view];
  var nextPosition = (position + 1) % viewFrames;
  nextPosition = nextPosition >= 0 ? nextPosition : viewFrames + nextPosition;
  var nextFrame = ripe.getFrameKey(view, nextPosition);
  this.changeFrame(nextFrame);
};
/**
 * Resizes the Configurator to the defined maximum size.
 *
 * @param {Object} options Set of optional parameters to adjust the resizing.
 */


ripe.ConfiguratorPrc.prototype.enterFullscreen = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(options) {
    var maxSize;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            if (!(this.element === undefined)) {
              _context8.next = 2;
              break;
            }

            return _context8.abrupt("return");

          case 2:
            this.element.classList.add("fullscreen");
            maxSize = this.element.dataset.max_size || this.maxSize;
            _context8.next = 6;
            return this.resize(maxSize);

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function (_x5) {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * Resizes the Configurator to the prior defined size.
 *
 * @param {Object} options Set of optional parameters to adjust the resizing.
 */


ripe.ConfiguratorPrc.prototype.leaveFullscreen = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(options) {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(this.element === undefined)) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return");

          case 2:
            this.element.classList.remove("fullscreen");
            _context9.next = 5;
            return this.resize();

          case 5:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, this);
  }));

  return function (_x6) {
    return _ref9.apply(this, arguments);
  };
}();
/**
 * Turns on (enables) the masks on selection/highlight.
 */


ripe.ConfiguratorPrc.prototype.enableMasks = function () {
  this.useMasks = true;
};
/**
 * Turns off (disables) the masks on selection/highlight.
 */


ripe.ConfiguratorPrc.prototype.disableMasks = function () {
  this.useMasks = false;
};
/**
 * Initializes the layout for the configurator element by
 * constructing all te child elements required for the proper
 * configurator functionality to work.
 *
 * From a DOM perspective this is a synchronous operation,
 * meaning that after its execution the configurator is ready
 * to be manipulated.
 *
 * @private
 */


ripe.ConfiguratorPrc.prototype._initLayout = function () {
  // in case the element is no longer available (possible due to async
  // nature of execution) returns the control flow immediately
  if (!this.element) return; // clears the elements children by iterating over them

  while (this.element.firstChild) {
    this.element.removeChild(this.element.firstChild);
  } // sets the element's style so that it supports two canvas
  // on top of each other so that double buffering can be used


  this.element.classList.add("configurator"); // creates the area canvas and adds it to the element

  var area = ripe.createElement("canvas", "area");
  var context = area.getContext("2d");
  context.globalCompositeOperation = "multiply";
  this.element.appendChild(area); // adds the front mask element to the element,
  // this will be used to highlight parts

  var frontMask = ripe.createElement("img", "front-mask");
  this.element.appendChild(frontMask); // creates the back canvas and adds it to the element,
  // placing it on top of the area canvas

  var back = ripe.createElement("canvas", "back");
  var backContext = back.getContext("2d");
  backContext.globalCompositeOperation = "multiply";
  this.element.appendChild(back); // creates the mask element that will de used to display
  // the mask on top of an highlighted or selected part

  var mask = ripe.createElement("canvas", "mask");
  this.element.appendChild(mask); // adds the framesBuffer placeholder element that will be used to
  // temporarily store the images of the product's frames

  var framesBuffer = ripe.createElement("div", "frames-buffer"); // creates a masksBuffer element that will be used to store the continuous
  // mask images to be used during highlight and select operation

  var masksBuffer = ripe.createElement("div", "masks-buffer"); // adds both buffer elements (frames and masks) to the base elements
  // they are going to be used as placeholders for the "img" elements
  // that are going to be loaded with the images

  this.element.appendChild(framesBuffer);
  this.element.appendChild(masksBuffer); // set the size of area, frontMask, back and mask

  this.resize(); // sets the initial view and position

  this.element.dataset.view = this.view;
  this.element.dataset.position = this.position; // register for all the necessary DOM events

  this._registerHandlers();
};
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._initPartsList = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
  var config, defaults;
  return _regeneratorRuntime.wrap(function _callee10$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          // creates a set of sorted parts to be used on the
          // highlight operation (considers only the default ones)
          this.partsList = [];

          if (!this.owner.loadedConfig) {
            _context10.next = 5;
            break;
          }

          _context10.t0 = this.owner.loadedConfig;
          _context10.next = 8;
          break;

        case 5:
          _context10.next = 7;
          return this.owner.getConfigP();

        case 7:
          _context10.t0 = _context10.sent;

        case 8:
          config = _context10.t0;
          defaults = config.defaults || {};
          this.hiddenParts = config.hidden || [];
          this.partsList = Object.keys(defaults);
          this.partsList.sort();

        case 13:
        case "end":
          return _context10.stop();
      }
    }
  }, _callee10, this);
}));
/**
 * @ignore
 */

ripe.ConfiguratorPrc.prototype._populateBuffers = function () {
  // in case the element is no longer available (possible due to async
  // nature of execution) returns the control flow immediately
  if (!this.element) return;
  var framesBuffer = this.element.getElementsByClassName("frames-buffer");
  var masksBuffer = this.element.getElementsByClassName("masks-buffer");
  var buffer = null;

  for (var index = 0; index < framesBuffer.length; index++) {
    buffer = framesBuffer[index];

    this._populateBuffer(buffer);
  }

  for (var _index2 = 0; _index2 < masksBuffer.length; _index2++) {
    buffer = masksBuffer[_index2];

    this._populateBuffer(buffer);
  }
};
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._populateBuffer = function (buffer) {
  while (buffer.firstChild) {
    buffer.removeChild(buffer.firstChild);
  } // creates two image elements for each frame and
  // appends them to the frames and masks buffers


  for (var view in this.frames) {
    var viewFrames = this.frames[view];

    for (var index = 0; index < viewFrames; index++) {
      var frameBuffer = ripe.createElement("img");
      frameBuffer.dataset.frame = ripe.getFrameKey(view, index);
      buffer.appendChild(frameBuffer);
    }
  }
};
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._updateConfig = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(animate) {
    var view, position, maxPosition, lastFrameViews, _i, _lastFrameViews, _view, _position, _maxPosition, viewFrames, frame;

    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            if (this.element) {
              _context11.next = 2;
              break;
            }

            return _context11.abrupt("return");

          case 2:
            // sets ready to false to temporarily block
            // update requests while the new config
            // is being loaded
            this.ready = false; // removes the highlight from any part

            this.lowlight(); // updates the parts list for the new product

            this._initPartsList(); // retrieves the new product frame object and sets it
            // under the current state, adapting then the internal
            // structures to accommodate the possible changes in the
            // frame structure


            _context11.next = 7;
            return this.owner.getFrames();

          case 7:
            this.frames = _context11.sent;

            // populates the buffers taking into account
            // the frames of the model
            this._populateBuffers(); // tries to keep the current view and position
            // if the new model supports it otherwise
            // changes to a supported frame


            view = this.element.dataset.view;
            position = parseInt(this.element.dataset.position);
            maxPosition = this.frames[view];

            if (!maxPosition) {
              view = Object.keys(this.frames)[0];
              position = 0;
            } else if (position >= maxPosition) {
              position = 0;
            } // checks the last viewed frames of each view
            // and deletes the ones not supported


            lastFrameViews = Object.keys(this._lastFrame);

            for (_i = 0, _lastFrameViews = lastFrameViews; _i < _lastFrameViews.length; _i++) {
              _view = _lastFrameViews[_i];
              _position = this._lastFrame[_view];
              _maxPosition = this.frames[_view];

              if (!_maxPosition || _position >= _maxPosition) {
                delete this._lastFrame[_view];
              }
            } // updates the instance values for the configurator view
            // and position so that they reflect the current visuals


            this.view = view;
            this.position = position; // updates the number of frames in the initial view
            // taking into account the requested frames data

            viewFrames = this.frames[view];
            this.element.dataset.frames = viewFrames; // updates the attributes related with both the view
            // and the position for the current model

            this.element.dataset.view = view;
            this.element.dataset.position = position; // marks the current configurator as ready and triggers
            // the associated ready event to any event listener

            this.ready = true;
            this.trigger("ready"); // adds the config visual class indicating that
            // a configuration already exists for the current
            // interactive configurator (meta-data)

            this.element.classList.add("ready"); // computes the frame key for the current frame to
            // be shown and triggers the changed frame event

            frame = ripe.getFrameKey(this.element.dataset.view, this.element.dataset.position);
            this.trigger("changed_frame", frame);

          case 26:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, this);
  }));

  return function (_x7) {
    return _ref11.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._loadFrame = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(view, position) {
    var _this2 = this;

    var options,
        frame,
        format,
        size,
        width,
        height,
        backgroundColor,
        draw,
        animate,
        duration,
        framesBuffer,
        masksBuffer,
        area,
        image,
        front,
        maskImage,
        url,
        isRedundant,
        isReady,
        imagePromise,
        _args13 = arguments;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            options = _args13.length > 2 && _args13[2] !== undefined ? _args13[2] : {};
            // triggers the initial frame event that indicates that a
            // new frame is going to be loaded into the img buffers
            this.trigger("pre_frame", {
              view: view,
              position: position,
              options: options
            }); // runs the defaulting operation on all of the parameters
            // sent to the load frame operation (defaulting)

            view = view || this.element.dataset.view || "side";
            position = position || this.element.dataset.position || 0;
            frame = ripe.getFrameKey(view, position);
            format = this.element.dataset.format || this.format;
            size = this.element.dataset.size || this.size;
            width = size || this.element.dataset.width || this.width;
            height = size || this.element.dataset.height || this.height;
            backgroundColor = this.element.dataset.background_color || this.backgroundColor;
            draw = options.draw === undefined || options.draw;
            animate = options.animate;
            duration = options.duration;
            framesBuffer = this.element.querySelector(".frames-buffer");
            masksBuffer = this.element.querySelector(".masks-buffer");
            area = this.element.querySelector(".area");
            image = framesBuffer.querySelector("img[data-frame='".concat(String(frame), "']"));
            front = area.querySelector("img[data-frame='".concat(String(frame), "']"));
            maskImage = masksBuffer.querySelector("img[data-frame='".concat(String(frame), "']"));
            image = image || front; // in case there's no images for the frames that are meant
            // to be loaded, then throws an error indicating that it's
            // not possible to load the requested frame

            if (!(image === null || maskImage === null)) {
              _context13.next = 22;
              break;
            }

            throw new RangeError("Frame " + frame + " is not supported");

          case 22:
            // triggers the async loading of the "master" mask for the current
            // frame, this should imply some level of cache usage
            this._loadMask(maskImage, view, position, options); // builds the URL that will be set on the image, notice that both
            // the full URL mode is avoided so that no extra parameters are
            // added to the image composition (not required)


            url = this.owner._getImageURL({
              frame: frame,
              format: format,
              size: size,
              width: width,
              height: height,
              background: backgroundColor,
              full: false
            }); // verifies if the loading of the current image
            // is considered redundant (already loaded or
            // loading) and avoids for performance reasons

            isRedundant = image.dataset.src === url;

            if (!isRedundant) {
              _context13.next = 34;
              break;
            }

            if (draw) {
              _context13.next = 28;
              break;
            }

            return _context13.abrupt("return");

          case 28:
            // check if the image on the buffer is already loaded
            // nad if that's the case draws the frame
            isReady = image.dataset.loaded === "true";

            if (!isReady) {
              _context13.next = 32;
              break;
            }

            _context13.next = 32;
            return this._drawFrame(image, animate, duration);

          case 32:
            // triggers the post frame event indicating the end
            // of the image preloading under cache match situation
            this.trigger("post_frame", {
              view: view,
              position: position,
              options: options,
              result: false
            }); // returns immediately there's nothing remaining to
            // be done as the image is already loaded

            return _context13.abrupt("return");

          case 34:
            // adds load callback to the image to draw the frame
            // when it is available from the "remote" source
            imagePromise = new Promise(function (resolve, reject) {
              image.onload = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
                return _regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        image.dataset.loaded = true;
                        image.dataset.src = url;

                        if (draw) {
                          _context12.next = 5;
                          break;
                        }

                        resolve();
                        return _context12.abrupt("return");

                      case 5:
                        _context12.prev = 5;
                        _context12.next = 8;
                        return _this2._drawFrame(image, animate, duration);

                      case 8:
                        _context12.next = 13;
                        break;

                      case 10:
                        _context12.prev = 10;
                        _context12.t0 = _context12["catch"](5);
                        reject(_context12.t0);

                      case 13:
                        resolve();

                      case 14:
                      case "end":
                        return _context12.stop();
                    }
                  }
                }, _callee12, null, [[5, 10]]);
              }));

              image.onerror = function () {
                reject(new Error("Problem loading image"));
              };
            }); // sets the src of the image to trigger the request
            // and sets loaded to false to indicate that the
            // image is not yet loading

            image.src = url;
            image.dataset.src = url;
            image.dataset.loaded = false; // waits until the image promise is resolved so that
            // we're sure everything is currently loaded

            _context13.next = 40;
            return imagePromise;

          case 40:
            // triggers the post frame event indicating that the
            // frame has been buffered into the img element with
            // no cache operation activated
            this.trigger("post_frame", {
              view: view,
              position: position,
              options: options,
              result: true
            });

          case 41:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, this);
  }));

  return function (_x8, _x9) {
    return _ref12.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._loadMask = function (maskImage, view, position, options) {
  var _this3 = this;

  // constructs the URL for the mask and then at the end of the
  // mask loading process runs the final update of the mask canvas
  // operation that will allow new highlight and selection operation
  // to be performed according to the new frame value
  var draw = options.draw === undefined || options.draw;
  var size = this.element.dataset.size || this.size;
  var width = size || this.element.dataset.width || this.width;
  var height = size || this.element.dataset.height || this.height;
  var frame = ripe.getFrameKey(view, position);

  var url = this.owner._getMaskURL({
    frame: frame,
    size: size,
    width: width,
    height: height
  });

  if (draw && maskImage.dataset.src === url) {
    setTimeout(function () {
      _this3._drawMask(maskImage);
    }, 150);
  } else {
    maskImage.onload = draw ? function () {
      setTimeout(function () {
        _this3._drawMask(maskImage);
      }, 150);
    } : null;

    maskImage.onerror = function () {
      maskImage.removeAttribute("src");
    };

    maskImage.crossOrigin = "anonymous";
    maskImage.dataset.src = url;
    maskImage.setAttribute("src", url);
  }
};
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._drawMask = function (maskImage) {
  // in case the element is no longer available (possible due to async
  // nature of execution) returns the control flow immediately
  if (!this.element) return;
  var mask = this.element.querySelector(".mask");
  var maskContext = mask.getContext("2d");
  maskContext.clearRect(0, 0, mask.width, mask.height);
  maskContext.drawImage(maskImage, 0, 0, mask.width, mask.height);
};
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._drawFrame = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(image, animate, duration) {
    var area, back, visible, current, target, context, promises;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (this.element) {
              _context14.next = 2;
              break;
            }

            return _context14.abrupt("return");

          case 2:
            area = this.element.querySelector(".area");
            back = this.element.querySelector(".back");
            visible = area.dataset.visible === "true";
            current = visible ? area : back;
            target = visible ? back : area;
            context = target.getContext("2d"); // retrieves the animation identifiers for both the current
            // canvas and the target one and cancels any previous animation
            // that might exist in such canvas (as a new one is coming)

            ripe.cancelAnimation(current);
            ripe.cancelAnimation(target); // clears the canvas context rectangle and then draws the image from
            // the buffer to the target canvas (back buffer operation)

            context.clearRect(0, 0, target.width, target.height);
            context.drawImage(image, 0, 0, target.width, target.height); // switches the visibility (meta information )of the target and the
            // current canvas elements (this is just logic information)

            target.dataset.visible = true;
            current.dataset.visible = false; // in case no animation is requested the z index and opacity switch
            // is immediate, this is consider a fast double buffer switch

            if (animate) {
              _context14.next = 20;
              break;
            }

            current.style.zIndex = 1;
            current.style.opacity = 0;
            target.style.zIndex = 1;
            target.style.opacity = 1;
            return _context14.abrupt("return");

          case 20:
            // "calculates" the duration for the animate operation taking into
            // account the passed parameter and the "kind" of animation, falling
            // back to the instance default if required
            duration = duration || (animate === "immediate" ? 0 : this.duration); // creates an array of promises that are going to be waiting for so that
            // the animation on the draw is considered finished

            promises = [];

            if (animate === "cross") {
              promises.push(ripe.animateProperty(current, "opacity", 1, 0, duration));
            }

            promises.push(ripe.animateProperty(target, "opacity", 0, 1, duration)); // waits for both animations to finish so that the final update on
            // the current settings can be performed (changing it's style)

            _context14.next = 26;
            return Promise.all(promises);

          case 26:
            // updates the style to its final state for both the current and the
            // target canvas elements
            current.style.opacity = 0;
            current.style.zIndex = 1;
            target.style.zIndex = 1;

          case 29:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function (_x10, _x11, _x12) {
    return _ref14.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._preload = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(useChain) {
    var _this4 = this;

    var view, position, index, work, _i2, _Object$keys, _view, viewFrames, _index, frame, result;

    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            // retrieves the current position of the configurator from its
            // data defaulting to the zero one (reference) in case no position
            // is currently defined in the configurator
            view = this.element.dataset.view || "side";
            position = parseInt(this.element.dataset.position) || 0;
            index = this.index || 0;
            index++;
            this.index = index;
            this.element.classList.add("preload"); // adds all the frames available for all the views to the
            // list of work to be performed on pre-loading

            work = [];
            _i2 = 0, _Object$keys = Object.keys(this.frames);

          case 8:
            if (!(_i2 < _Object$keys.length)) {
              _context17.next = 23;
              break;
            }

            _view = _Object$keys[_i2];
            viewFrames = this.frames[_view];
            _index = 0;

          case 12:
            if (!(_index < viewFrames)) {
              _context17.next = 20;
              break;
            }

            if (!(_index === position && view === _view)) {
              _context17.next = 15;
              break;
            }

            return _context17.abrupt("continue", 17);

          case 15:
            frame = ripe.getFrameKey(_view, _index);
            work.push(frame);

          case 17:
            _index++;
            _context17.next = 12;
            break;

          case 20:
            _i2++;
            _context17.next = 8;
            break;

          case 23:
            work.reverse(); // waits for the pre loading promise so that at the end of this
            // execution all the work required for loading is processed

            _context17.next = 26;
            return new Promise(function (resolve, reject) {
              _this4._finalize = function () {
                var result = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                // invalidates the work queue by setting its
                // length value to zero (clears array)
                work.length = 0; // removes the pending classes that indicate that
                // there's some kind of preloading happening

                _this4.element.classList.remove("preloading");

                _this4.element.classList.remove("no-drag"); // unsets the finalize clojure from the current instance
                // effectively disallowing further usage of it


                _this4._finalize = null; // finalizes the promise by resolving it with
                // the parameter that was just received (final result)

                resolve(result);
              };
              /**
               * Callback function to be called whenever a new frame is
               * pre-loaded (end of step), should be able to trigger the end
               * of the loading if it represents the last image loading operation.
               *
               * @param {DOMElement} element The reference to the element that is
               * considered to be the configurator.
               */


              var mark = function mark(element) {
                // in case the current index of operation (unique auto-increment
                // value) is no longer the current in process then ignores this
                // marking operation as it's considered outdated
                var _index = _this4.index;
                if (index !== _index) return;
                if (!_this4.element) return; // removes the preloading class from the image element
                // this is considered the default operation
                else element.classList.remove("preloading"); // retrieves all the images still preloading from the frames
                // buffer to determine if this was the final image loading

                var framesBuffer = _this4.element.querySelector(".frames-buffer");

                var pending = framesBuffer.querySelectorAll("img.preloading") || []; // if there are still images preloading then adds the preloading
                // class to the target element and prevents drag movements to
                // avoid flickering else and if there are no images preloading and no
                // frames yet to be preloaded then the preload is considered finished
                // so drag movements are allowed again and the loaded event is triggered

                if (pending.length > 0) {
                  _this4.element.classList.add("preloading");

                  _this4.element.classList.add("no-drag");
                } else if (work.length === 0) {
                  if (_this4._finalize) _this4._finalize();
                }
              };

              var render = /*#__PURE__*/function () {
                var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
                  var _index, frame, framesBuffer, reference, _frame, view, position, promise;

                  return _regeneratorRuntime.wrap(function _callee15$(_context15) {
                    while (1) {
                      switch (_context15.prev = _context15.next) {
                        case 0:
                          _index = _this4.index;

                          if (!(index !== _index)) {
                            _context15.next = 3;
                            break;
                          }

                          return _context15.abrupt("return");

                        case 3:
                          if (!(work.length === 0)) {
                            _context15.next = 5;
                            break;
                          }

                          return _context15.abrupt("return");

                        case 5:
                          // retrieves the next frame to be loaded
                          // and its corresponding image element
                          // and adds the preloading class to it
                          frame = work.pop();
                          framesBuffer = _this4.element.querySelector(".frames-buffer");
                          reference = framesBuffer.querySelector("img[data-frame='".concat(String(frame), "']"));
                          reference.classList.add("preloading"); // determines if a chain based loading should be used for the
                          // pre-loading process of the continuous image resources to be loaded

                          _frame = ripe.parseFrameKey(frame);
                          view = _frame[0];
                          position = _frame[1];
                          promise = _this4._loadFrame(view, position, {
                            draw: false
                          });
                          promise.then(function () {
                            return mark(reference);
                          });

                          if (!useChain) {
                            _context15.next = 17;
                            break;
                          }

                          _context15.next = 17;
                          return promise;

                        case 17:
                          _context15.next = 19;
                          return render();

                        case 19:
                        case "end":
                          return _context15.stop();
                      }
                    }
                  }, _callee15);
                }));

                return function render() {
                  return _ref16.apply(this, arguments);
                };
              }(); // adds the preloading flag and then prevents mouse drag
              // movements by setting proper classes


              _this4.element.classList.add("preloading");

              _this4.element.classList.add("no-drag");

              if (work.length > 0) {
                // schedule the timeout operation in order to trigger
                // the pre-loading of the remaining frames, the delay
                // is meant to provide some time buffer to the current
                // frame (higher priority) to be processes in the server
                // effectively allowing selective QoS (Quality of Service)
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
                  return _regeneratorRuntime.wrap(function _callee16$(_context16) {
                    while (1) {
                      switch (_context16.prev = _context16.next) {
                        case 0:
                          _context16.prev = 0;
                          _context16.next = 3;
                          return render();

                        case 3:
                          _context16.next = 8;
                          break;

                        case 5:
                          _context16.prev = 5;
                          _context16.t0 = _context16["catch"](0);
                          reject(_context16.t0);

                        case 8:
                        case "end":
                          return _context16.stop();
                      }
                    }
                  }, _callee16, null, [[0, 5]]);
                })), _this4.preloadDelay);
              } else {
                if (_this4._finalize) _this4._finalize();
              }
            });

          case 26:
            result = _context17.sent;
            return _context17.abrupt("return", result);

          case 28:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, this);
  }));

  return function (_x13) {
    return _ref15.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._registerHandlers = function () {
  // captures the current context to be used inside clojures
  var self = this; // retrieves the reference to the multiple elements that
  // are going to be used for event handler operations

  var area = this.element.querySelector(".area");
  var back = this.element.querySelector(".back"); // binds the mousedown event on the element to prepare
  // it for drag movements

  this._addElementHandler("mousedown", function (event) {
    var _element = this;

    _element.dataset.view = _element.dataset.view || "side";
    self.base = parseInt(_element.dataset.position) || 0;
    self.down = true;
    self.referenceX = event.pageX;
    self.referenceY = event.pageY;
    self.percent = 0;

    _element.classList.add("drag");
  }); // listens for mouseup events and if it occurs then
  // stops reacting to mouse move events has drag movements


  this._addElementHandler("mouseup", function (event) {
    var _element = this;

    self.down = false;
    self.previous = self.percent;
    self.percent = 0;

    _element.classList.remove("drag");
  }); // listens for mouse leave events and if it occurs then
  // stops reacting to mousemove events has drag movements


  this._addElementHandler("mouseleave", function (event) {
    var _element = this;

    self.down = false;
    self.previous = self.percent;
    self.percent = 0;

    _element.classList.remove("drag");
  }); // if a mouse move event is triggered while the mouse is
  // pressed down then updates the position of the drag element


  this._addElementHandler("mousemove", function (event) {
    if (!this.classList.contains("ready") || this.classList.contains("no-drag")) {
      return;
    }

    var down = self.down;
    self.mousePosX = event.pageX;
    self.mousePosY = event.pageY;
    if (down) self._parseDrag();
  });

  area.addEventListener("click", function (event) {
    // verifies if the previous drag operation (if any) has exceed
    // the minimum threshold to be considered drag (click avoided)
    if (Math.abs(self.previous) > self.clickThreshold) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      return;
    }

    var preloading = self.element.classList.contains("preloading");
    var animating = self.element.classList.contains("animating");

    if (preloading || animating) {
      return;
    }

    event = ripe.fixEvent(event);

    var index = self._getCanvasIndex(this, event.offsetX, event.offsetY);

    if (index === 0) {
      return;
    } // retrieves the reference to the part name by using the index
    // extracted from the masks image (typical strategy for retrieval)


    var part = self.partsList[index - 1];
    var isVisible = self.hiddenParts.indexOf(part) === -1;
    if (part && isVisible) self.owner.selectPart(part);
    event.stopPropagation();
  });
  area.addEventListener("mousemove", function (event) {
    var preloading = self.element.classList.contains("preloading");
    var animating = self.element.classList.contains("animating");

    if (preloading || animating) {
      return;
    }

    event = ripe.fixEvent(event); // tries to retrieve the layer/part index associated with current
    // mouse coordinates to better act in the mouse move operation, as
    // this may represent a possible highlight operation

    var index = self._getCanvasIndex(this, event.offsetX, event.offsetY); // in case the index that was found is the zero one this is a special
    // position and the associated operation is the removal of the highlight
    // also if the target is being dragged the highlight should be removed


    if (index === 0 || self.down === true) {
      self.lowlight();
      return;
    } // retrieves the reference to the part name by using the index
    // extracted from the masks image (typical strategy for retrieval)


    var part = self.partsList[index - 1];
    var isVisible = self.hiddenParts.indexOf(part) === -1;
    if (part && isVisible) self.highlight(part);else self.lowlight();
  });
  area.addEventListener("dragstart", function (event) {
    event.preventDefault();
  });
  area.addEventListener("dragend", function (event) {
    event.preventDefault();
  });
  back.addEventListener("click", function (event) {
    // verifies if the previous drag operation (if any) has exceed
    // the minimum threshold to be considered drag (click avoided)
    if (Math.abs(self.previous) > self.clickThreshold) {
      event.stopImmediatePropagation();
      event.stopPropagation();
      return;
    }

    var preloading = self.element.classList.contains("preloading");
    var animating = self.element.classList.contains("animating");

    if (preloading || animating) {
      return;
    }

    event = ripe.fixEvent(event);

    var index = self._getCanvasIndex(this, event.offsetX, event.offsetY);

    if (index === 0) {
      return;
    } // retrieves the reference to the part name by using the index
    // extracted from the masks image (typical strategy for retrieval)


    var part = self.partsList[index - 1];
    var isVisible = self.hiddenParts.indexOf(part) === -1;
    if (part && isVisible) self.owner.selectPart(part);
    event.stopPropagation();
  });
  back.addEventListener("mousemove", function (event) {
    var preloading = self.element.classList.contains("preloading");
    var animating = self.element.classList.contains("animating");

    if (preloading || animating) {
      return;
    }

    event = ripe.fixEvent(event); // tries to retrieve the layer/part index associated with current
    // mouse coordinates to better act in the mouse move operation, as
    // this may represent a possible highlight operation

    var index = self._getCanvasIndex(this, event.offsetX, event.offsetY); // in case the index that was found is the zero one this is a special
    // position and the associated operation is the removal of the highlight
    // also if the target is being dragged the highlight should be removed


    if (index === 0 || self.down === true) {
      self.lowlight();
      return;
    } // retrieves the reference to the part name by using the index
    // extracted from the masks image (typical strategy for retrieval)


    var part = self.partsList[index - 1];
    var isVisible = self.hiddenParts.indexOf(part) === -1;
    if (part && isVisible) self.highlight(part);else self.lowlight();
  });
  back.addEventListener("dragstart", function (event) {
    event.preventDefault();
  });
  back.addEventListener("dragend", function (event) {
    event.preventDefault();
  }); // verifies if mutation should be "observed" for this visual
  // and in such case registers for the observation of any DOM
  // mutation (eg: attributes) for the configurator element, triggering
  // a new update operation in case that happens

  if (this.mutations) {
    // listens for attribute changes to redraw the configurator
    // if needed, this makes use of the mutation observer, the
    // redraw should be done for width and height style and attributes
    var Observer = typeof MutationObserver !== "undefined" && MutationObserver || typeof WebKitMutationObserver !== "undefined" && WebKitMutationObserver || // eslint-disable-line no-undef
    null;
    this._observer = Observer ? new Observer(function (mutations) {
      for (var index = 0; index < mutations.length; index++) {
        var mutation = mutations[index];
        if (mutation.type === "style") self.resize();
        if (mutation.type === "attributes") self.update();
      }
    }) : null;

    if (this._observer) {
      this._observer.observe(this.element, {
        attributes: true,
        subtree: false,
        characterData: true,
        attributeFilter: ["style", "data-format", "data-size", "data-width", "data-height"]
      });
    }
  } // adds handlers for the touch events so that they get
  // parsed to mouse events for the configurator element,
  // taking into account that there may be a touch handler
  // already defined


  ripe.touchHandler(this.element);
};
/**
 * @ignore
 */


ripe.ConfiguratorPrc.prototype._parseDrag = function () {
  // retrieves the last recorded mouse position
  // and the current one and calculates the
  // drag movement made by the user
  var child = this.element.querySelector("*:first-child");
  var referenceX = this.referenceX;
  var referenceY = this.referenceY;
  var mousePosX = this.mousePosX;
  var mousePosY = this.mousePosY;
  var base = this.base;
  var deltaX = referenceX - mousePosX;
  var deltaY = referenceY - mousePosY;
  var elementWidth = this.element.clientWidth;
  var elementHeight = this.element.clientHeight || child.clientHeight;
  var percentX = deltaX / elementWidth;
  var percentY = deltaY / elementHeight;
  this.percent = percentX;
  var sensitivity = this.element.dataset.sensitivity || this.sensitivity;
  var verticalThreshold = this.element.dataset.verticalThreshold || this.verticalThreshold; // if the drag was vertical then alters the
  // view if it is supported by the product

  var view = this.element.dataset.view;
  var nextView = view;

  if (sensitivity * percentY > verticalThreshold) {
    nextView = view === "top" ? "side" : "bottom";
    this.referenceY = mousePosY;
  } else if (sensitivity * percentY < verticalThreshold * -1) {
    nextView = view === "bottom" ? "side" : "top";
    this.referenceY = mousePosY;
  }

  if (this.frames[nextView] === undefined) {
    nextView = view;
  } // retrieves the current view and its frames
  // and determines which one is the next frame


  var viewFrames = this.frames[nextView];
  var offset = Math.round(sensitivity * percentX * viewFrames / 24);
  var nextPosition = (base - offset) % viewFrames;
  nextPosition = nextPosition >= 0 ? nextPosition : viewFrames + nextPosition; // if the view changes then uses the last
  // position presented in that view, if not
  // then shows the next position according
  // to the drag

  nextPosition = view === nextView ? nextPosition : this._lastFrame[nextView] || 0;
  var nextFrame = ripe.getFrameKey(nextView, nextPosition);
  this.changeFrame(nextFrame);
};
/**
 * Obtains the offset index (from red color) for the provided coordinates
 * and taking into account the aspect ration of the canvas.
 *
 * @param canvas {Canvas} The canvas to be used as reference for the
 * calculus of offset red color index.
 * @param x {Number} The x coordinate within the canvas to obtain index.
 * @param y {Number} The y coordinate within the canvas to obtain index.
 * @returns {Number} The offset index using as reference the main mask
 * of the current configurator.
 */


ripe.ConfiguratorPrc.prototype._getCanvasIndex = function (canvas, x, y) {
  var canvasRealWidth = canvas.getBoundingClientRect().width;
  var mask = this.element.querySelector(".mask");
  var ratio = mask.width && canvasRealWidth && mask.width / canvasRealWidth;
  x = parseInt(x * ratio);
  y = parseInt(y * ratio);
  var maskContext = mask.getContext("2d");
  var pixel = maskContext.getImageData(x, y, 1, 1);
  var r = pixel.data[0];
  var index = parseInt(r);
  return index;
};
/**
 * Builds the signature string for the current internal state
 * allowing a single unique representation of the current frame.
 *
 * This signature should allow dirty control for the configurator.
 *
 * @returns {String} The unique signature for the configurator state.
 */


ripe.ConfiguratorPrc.prototype._buildSignature = function () {
  var dataset = this.element ? this.element.dataset : {};
  var format = dataset.format || this.format;
  var size = dataset.size || this.size;
  var width = size || dataset.width || this.width;
  var height = size || dataset.height || this.height;
  var backgroundColor = dataset.background_color || this.backgroundColor;
  return "".concat(this.owner._getQuery({
    full: false
  }), "&width=").concat(String(width), "&height=").concat(String(height), "&format=").concat(String(format), "&background=").concat(String(backgroundColor));
};

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalePlugin; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);








function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var LocalePlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(LocalePlugin, _RipeCommonsPlugin);

  var _super = _createSuper(LocalePlugin);

  function LocalePlugin(owner) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, LocalePlugin);

    _this = _super.call(this, owner);

    _this._bind();

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(LocalePlugin, [{
    key: "load",
    value: function () {
      var _load = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(LocalePlugin.prototype), "load", this).call(this);

              case 2:
                _context.next = 4;
                return this.owner.getPluginsByCapability("locale-loader");

              case 4:
                this.loaderPlugins = _context.sent;
                _context.next = 7;
                return this.owner.getPluginsByCapability("locale-resolver");

              case 7:
                this.resolverPlugins = _context.sent;
                _context.next = 10;
                return this._loadLocales();

              case 10:
                this.localeMap = _context.sent;
                this.locale = null;
                this.localeD = "en_us";

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "unload",
    value: function () {
      var _unload = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.loaderPlugins = null;
                this.resolverPlugins = null;
                _context2.next = 4;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(LocalePlugin.prototype), "unload", this).call(this);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function unload() {
        return _unload.apply(this, arguments);
      }

      return unload;
    }()
  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsCapability */ "a"]["new"]("helper")];
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      return this.locale;
    }
  }, {
    key: "getLocaleFallback",
    value: function getLocaleFallback() {
      var locales = this.getSupportedLocales();
      if (locales.includes(this.localeD)) return this.localeD;
      if (locales.length > 0) return locales[0];
      return null;
    }
  }, {
    key: "getSupportedLocales",
    value: function getSupportedLocales() {
      return Object.keys(this.localeMap);
    }
  }, {
    key: "getLocaleValue",
    value: function getLocaleValue(key, defaultValue, locale) {
      var fallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      locale = locale || this.locale;
      var localeKeys = this.localeMap[locale] || {};
      if (localeKeys[key] !== undefined) return localeKeys[key];
      if (fallback) return this.getLocaleValue(key, defaultValue, this.localeD, false);
      return defaultValue;
    }
  }, {
    key: "hasLocale",
    value: function hasLocale(key, locale) {
      var keys = this.localeMap[locale] || {};
      return key in keys;
    }
  }, {
    key: "toLocale",
    value: function toLocale(key, defaultValue, locale) {
      var fallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      return this.getLocaleValue(key, defaultValue, locale, fallback);
    }
  }, {
    key: "setLocale",
    value: function () {
      var _setLocale = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee3(locale) {
        var coerce,
            _args3 = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                coerce = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : true;
                if (coerce) locale = this._coerceLocale(locale);
                _context3.next = 4;
                return this.owner.trigger("pre_set_locale", locale);

              case 4:
                this.locale = locale;
                _context3.next = 7;
                return this.owner.trigger("post_set_locale", locale);

              case 7:
                this.owner.trigger("locale_changed", locale);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setLocale(_x) {
        return _setLocale.apply(this, arguments);
      }

      return setLocale;
    }()
  }, {
    key: "setLocaleValue",
    value: function setLocaleValue(key, value, locale) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        event: true
      };
      var localeKeys = this.localeMap[locale] || {};
      localeKeys[key] = value;
      this.localeMap[locale] = localeKeys;
      this.owner.trigger("locale", key, value, locale);
      if (options.event) this.owner.trigger("locale_map_changed");
    }
  }, {
    key: "unsetLocaleValue",
    value: function unsetLocaleValue(key, locale) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        event: true
      };
      var localeKeys = this.localeMap[locale] || {};
      delete localeKeys[key];
      if (options.event) this.owner.trigger("locale_map_changed");
    }
  }, {
    key: "setLocaleMap",
    value: function setLocaleMap(localeMap) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      prefix = prefix.length === 0 || prefix.endsWith(".") ? prefix : "".concat(prefix, ".");

      for (var locale in localeMap) {
        var bundle = localeMap[locale];

        for (var key in bundle) {
          this.setLocaleValue("".concat(prefix).concat(key), bundle[key], locale, {
            event: false
          });
        }
      }

      this.owner.trigger("locale_map_changed");
    }
  }, {
    key: "unsetLocaleMap",
    value: function unsetLocaleMap(localeMap) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
      prefix = prefix.length === 0 || prefix.endsWith(".") ? prefix : "".concat(prefix, ".");

      for (var locale in localeMap) {
        var bundle = localeMap[locale];

        for (var key in bundle) {
          this.unsetLocaleValue("".concat(prefix, ".").concat(key), locale, {
            event: false
          });
        }
      }

      this.owner.trigger("locale_map_changed");
    }
  }, {
    key: "_loadLocales",
    value: function () {
      var _loadLocales2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee4() {
        var locales, _iterator, _step, plugin, localeBundle, locale, bundle;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                locales = {};
                _iterator = _createForOfIteratorHelper(this.loaderPlugins);
                _context4.prev = 2;

                _iterator.s();

              case 4:
                if ((_step = _iterator.n()).done) {
                  _context4.next = 12;
                  break;
                }

                plugin = _step.value;
                _context4.next = 8;
                return plugin.loadLocale();

              case 8:
                localeBundle = _context4.sent;

                for (locale in localeBundle) {
                  bundle = localeBundle[locale];
                  locales[locale] = Object.assign({}, locales[locale], bundle);
                }

              case 10:
                _context4.next = 4;
                break;

              case 12:
                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4["catch"](2);

                _iterator.e(_context4.t0);

              case 17:
                _context4.prev = 17;

                _iterator.f();

                return _context4.finish(17);

              case 20:
                return _context4.abrupt("return", locales);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 14, 17, 20]]);
      }));

      function _loadLocales() {
        return _loadLocales2.apply(this, arguments);
      }

      return _loadLocales;
    }()
  }, {
    key: "_bind",
    value: function _bind() {
      var _this2 = this;

      this.owner.bind("locale_change", /*#__PURE__*/function () {
        var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee5(locale) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this2.setLocale(locale);

                case 2:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "_coerceLocale",
    value: function _coerceLocale(locale) {
      var _iterator2 = _createForOfIteratorHelper(this.getSupportedLocales()),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _locale = _step2.value;
          if (!_locale.startsWith(locale)) continue;
          locale = _locale;
          break;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return locale;
    }
  }]);

  return LocalePlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsPlugin */ "b"]);
LocalePlugin.register();

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DomLocaleLoaderPlugin; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var DomLocaleLoaderPlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(DomLocaleLoaderPlugin, _RipeCommonsPlugin);

  var _super = _createSuper(DomLocaleLoaderPlugin);

  function DomLocaleLoaderPlugin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, DomLocaleLoaderPlugin);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(DomLocaleLoaderPlugin, [{
    key: "load",
    value: function () {
      var _load = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(DomLocaleLoaderPlugin.prototype), "load", this).call(this);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsCapability */ "a"]["new"]("locale-loader")];
    }
  }, {
    key: "loadLocale",
    value: function () {
      var _loadLocale = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee2(options) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                options = options || {};
                return _context2.abrupt("return", this._loadFromDOM(options.targetId));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadLocale(_x) {
        return _loadLocale.apply(this, arguments);
      }

      return loadLocale;
    }()
  }, {
    key: "_loadFromDOM",
    value: function _loadFromDOM(targetId) {
      targetId = targetId || "locale";
      var localeBundle = {};
      var localeE = document.getElementById(targetId);

      if (!localeE) {
        return null;
      }

      var locale = localeE.getAttribute("data-locale");
      var localeKeys = localeE ? JSON.parse(localeE.textContent) : {};
      localeBundle[locale] = localeKeys;
      return localeBundle;
    }
  }]);

  return DomLocaleLoaderPlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsPlugin */ "b"]);
DomLocaleLoaderPlugin.register();

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FileLocaleLoaderPlugin; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);
/* harmony import */ var _bundles_config_en_us__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(248);
var _bundles_config_en_us__WEBPACK_IMPORTED_MODULE_9___namespace = /*#__PURE__*/__webpack_require__.t(248, 1);
/* harmony import */ var _bundles_config_ja_jp__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(249);
var _bundles_config_ja_jp__WEBPACK_IMPORTED_MODULE_10___namespace = /*#__PURE__*/__webpack_require__.t(249, 1);
/* harmony import */ var _bundles_config_zh_cn__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(250);
var _bundles_config_zh_cn__WEBPACK_IMPORTED_MODULE_11___namespace = /*#__PURE__*/__webpack_require__.t(250, 1);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }





var FileLocaleLoaderPlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(FileLocaleLoaderPlugin, _RipeCommonsPlugin);

  var _super = _createSuper(FileLocaleLoaderPlugin);

  function FileLocaleLoaderPlugin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, FileLocaleLoaderPlugin);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(FileLocaleLoaderPlugin, [{
    key: "load",
    value: function () {
      var _load = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_3___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(FileLocaleLoaderPlugin.prototype), "load", this).call(this);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsCapability */ "a"]["new"]("locale-loader")];
    }
  }, {
    key: "loadLocale",
    value: function () {
      var _loadLocale = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee2() {
        var localeBundle;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                localeBundle = {};
                FileLocaleLoaderPlugin.getLocales().forEach(function (locale) {
                  localeBundle[locale.locale] = locale ? locale.content : {};
                });
                return _context2.abrupt("return", localeBundle);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function loadLocale() {
        return _loadLocale.apply(this, arguments);
      }

      return loadLocale;
    }()
  }], [{
    key: "getLocales",
    value:
    /**
     * Loads the complete set of locale bundles from a file based data
     * sourcing structure.
     *
     * @returns {Array} The complete set of locales indexed as object
     * that contain both the contents and the locale type.
     */
    function getLocales() {
      return [{
        name: "config",
        locale: "en_us",
        content: _bundles_config_en_us__WEBPACK_IMPORTED_MODULE_9__
      }, {
        name: "config",
        locale: "ja_jp",
        content: _bundles_config_ja_jp__WEBPACK_IMPORTED_MODULE_10__
      }, {
        name: "config",
        locale: "zh_cn",
        content: _bundles_config_zh_cn__WEBPACK_IMPORTED_MODULE_11__
      }];
    }
  }]);

  return FileLocaleLoaderPlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsPlugin */ "b"]);
FileLocaleLoaderPlugin.register();

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModelLocaleLoaderPlugin; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4);








function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_6___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_5___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


/**
 * Class that contains the plugin implementation responsible for the
 * retrieval of locales for a certain model.
 *
 * Should attach itself to the proper event `ripe` and then "injects"
 * the associated locales in the locale plugin context.
 */

var ModelLocaleLoaderPlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ModelLocaleLoaderPlugin, _RipeCommonsPlugin);

  var _super = _createSuper(ModelLocaleLoaderPlugin);

  function ModelLocaleLoaderPlugin(owner) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_2___default()(this, ModelLocaleLoaderPlugin);

    _this = _super.call(this, owner);

    _this._bind();

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(ModelLocaleLoaderPlugin, [{
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsCapability */ "a"]["new"]("locale-loader")];
    }
  }, {
    key: "loadLocale",
    value: function () {
      var _loadLocale = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", {});

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function loadLocale() {
        return _loadLocale.apply(this, arguments);
      }

      return loadLocale;
    }()
  }, {
    key: "loadModelLocales",
    value: function () {
      var _loadModelLocales = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee2() {
        var brand,
            model,
            localePlugin,
            locales,
            _iterator,
            _step,
            locale,
            _args2 = arguments;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                brand = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : null;
                model = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
                _context2.next = 4;
                return this.owner.getPluginByName("LocalePlugin");

              case 4:
                localePlugin = _context2.sent;
                locales = [localePlugin.getLocale(), localePlugin.getLocaleFallback()];
                _iterator = _createForOfIteratorHelper(new Set(locales));
                _context2.prev = 7;

                _iterator.s();

              case 9:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 15;
                  break;
                }

                locale = _step.value;
                _context2.next = 13;
                return this._loadModelLocale(brand, model, locale);

              case 13:
                _context2.next = 9;
                break;

              case 15:
                _context2.next = 20;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2["catch"](7);

                _iterator.e(_context2.t0);

              case 20:
                _context2.prev = 20;

                _iterator.f();

                return _context2.finish(20);

              case 23:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 17, 20, 23]]);
      }));

      function loadModelLocales() {
        return _loadModelLocales.apply(this, arguments);
      }

      return loadModelLocales;
    }()
  }, {
    key: "loadRipeSdkLocales",
    value: function () {
      var _loadRipeSdkLocales = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee3() {
        var ripeProvider, localePlugin, locales, _iterator2, _step2, locale, bundle, _i, _Object$entries, _Object$entries$_i, key, value;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.owner.getPluginByCapability("ripe-provider");

              case 2:
                ripeProvider = _context3.sent;
                _context3.next = 5;
                return this.owner.getPluginByName("LocalePlugin");

              case 5:
                localePlugin = _context3.sent;
                locales = [localePlugin.getLocale(), localePlugin.getLocaleFallback()];
                _iterator2 = _createForOfIteratorHelper(new Set(locales));
                _context3.prev = 8;

                _iterator2.s();

              case 10:
                if ((_step2 = _iterator2.n()).done) {
                  _context3.next = 24;
                  break;
                }

                locale = _step2.value;
                bundle = ripeProvider.ripe.getBundle(locale);
                _i = 0, _Object$entries = Object.entries(bundle);

              case 14:
                if (!(_i < _Object$entries.length)) {
                  _context3.next = 22;
                  break;
                }

                _Object$entries$_i = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_Object$entries[_i], 2), key = _Object$entries$_i[0], value = _Object$entries$_i[1];

                if (!(key === "_" && value === null)) {
                  _context3.next = 18;
                  break;
                }

                return _context3.abrupt("continue", 19);

              case 18:
                localePlugin.setLocaleValue(key, value, locale, {
                  event: false
                });

              case 19:
                _i++;
                _context3.next = 14;
                break;

              case 22:
                _context3.next = 10;
                break;

              case 24:
                _context3.next = 29;
                break;

              case 26:
                _context3.prev = 26;
                _context3.t0 = _context3["catch"](8);

                _iterator2.e(_context3.t0);

              case 29:
                _context3.prev = 29;

                _iterator2.f();

                return _context3.finish(29);

              case 32:
                this.owner.trigger("locale_map_changed");

              case 33:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 26, 29, 32]]);
      }));

      function loadRipeSdkLocales() {
        return _loadRipeSdkLocales.apply(this, arguments);
      }

      return loadRipeSdkLocales;
    }()
  }, {
    key: "_bind",
    value: function _bind() {
      var _this2 = this;

      this.owner.bind("config", /*#__PURE__*/function () {
        var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee4(config) {
          var brand, name;
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (config) {
                    _context4.next = 2;
                    break;
                  }

                  return _context4.abrupt("return");

                case 2:
                  brand = config.brand, name = config.name;
                  _context4.next = 5;
                  return _this2.loadModelLocales(brand, name);

                case 5:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      this.owner.bind("post_set_locale", /*#__PURE__*/_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee5() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this2.loadModelLocales();

              case 2:
                return _context5.abrupt("return", _context5.sent);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      })));
      this.owner.bind("bundles", /*#__PURE__*/_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee6() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this2.loadRipeSdkLocales();

              case 2:
                return _context6.abrupt("return", _context6.sent);

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      })));
    }
  }, {
    key: "_loadModelLocale",
    value: function () {
      var _loadModelLocale2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.mark(function _callee7() {
        var brand,
            model,
            locale,
            ripeProvider,
            localePlugin,
            currentLocale,
            result,
            key,
            _args7 = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                brand = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : null;
                model = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : null;
                locale = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : null;
                _context7.next = 5;
                return this.owner.getPluginByCapability("ripe-provider");

              case 5:
                ripeProvider = _context7.sent;
                _context7.next = 8;
                return this.owner.getPluginByName("LocalePlugin");

              case 8:
                localePlugin = _context7.sent;
                currentLocale = locale || localePlugin.getLocale();
                brand = brand || ripeProvider.ripe ? ripeProvider.ripe.brand : null;
                model = model || ripeProvider.ripe ? ripeProvider.ripe.model : null;

                if (!(!brand || !model)) {
                  _context7.next = 14;
                  break;
                }

                return _context7.abrupt("return");

              case 14:
                _context7.next = 16;
                return ripeProvider.ripe.getLocaleModelP({
                  brand: brand,
                  model: model,
                  locale: currentLocale
                });

              case 16:
                result = _context7.sent;
                _context7.t0 = _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_7___default.a.keys(result);

              case 18:
                if ((_context7.t1 = _context7.t0()).done) {
                  _context7.next = 25;
                  break;
                }

                key = _context7.t1.value;

                if (!(key === "_" && result[key] === null)) {
                  _context7.next = 22;
                  break;
                }

                return _context7.abrupt("continue", 18);

              case 22:
                localePlugin.setLocaleValue(key, result[key], currentLocale, {
                  event: false
                });
                _context7.next = 18;
                break;

              case 25:
                this.owner.trigger("locale_map_changed");

              case 26:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function _loadModelLocale() {
        return _loadModelLocale2.apply(this, arguments);
      }

      return _loadModelLocale;
    }()
  }]);

  return ModelLocaleLoaderPlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_8__[/* RipeCommonsPlugin */ "b"]);
ModelLocaleLoaderPlugin.register();

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModelLocaleResolverPlugin; });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4);










function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_7___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }


var ModelLocaleResolverPlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(ModelLocaleResolverPlugin, _RipeCommonsPlugin);

  var _super = _createSuper(ModelLocaleResolverPlugin);

  function ModelLocaleResolverPlugin(owner) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_3___default()(this, ModelLocaleResolverPlugin);

    _this = _super.call(this, owner);

    _this._bind();

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_4___default()(ModelLocaleResolverPlugin, [{
    key: "load",
    value: function () {
      var _load = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_9___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_5___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_8___default()(ModelLocaleResolverPlugin.prototype), "load", this).call(this);

              case 2:
                _context.next = 4;
                return this.owner.getPluginByName("LocalePlugin");

              case 4:
                this.localePlugin = _context.sent;
                _context.next = 7;
                return this.owner.getPluginByCapability("ripe-provider");

              case 7:
                this.ripeProvider = _context.sent;

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_10__[/* RipeCommonsCapability */ "a"]["new"]("locale-resolver")];
    }
  }, {
    key: "localeColor",
    value: function localeColor(color) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$part = _ref.part,
          part = _ref$part === void 0 ? null : _ref$part,
          _ref$material = _ref.material,
          material = _ref$material === void 0 ? null : _ref$material,
          _ref$locale = _ref.locale,
          locale = _ref$locale === void 0 ? null : _ref$locale,
          _ref$defaultValue = _ref.defaultValue,
          defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue,
          _ref$prefixes = _ref.prefixes,
          prefixes = _ref$prefixes === void 0 ? [] : _ref$prefixes,
          _ref$suffixes = _ref.suffixes,
          suffixes = _ref$suffixes === void 0 ? [] : _ref$suffixes;

      var ripe = this.ripeProvider.ripe;
      return this.localeModel(color, {
        brand: this.brand,
        model: this.model,
        part: part,
        material: material,
        locale: locale,
        defaultValue: defaultValue,
        prefixes: prefixes,
        suffixes: suffixes,
        localeFunc: function localeFunc() {
          return ripe.localeColor.apply(ripe, arguments);
        }
      });
    }
  }, {
    key: "localeMaterial",
    value: function localeMaterial(material) {
      var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref2$part = _ref2.part,
          part = _ref2$part === void 0 ? null : _ref2$part,
          _ref2$locale = _ref2.locale,
          locale = _ref2$locale === void 0 ? null : _ref2$locale,
          _ref2$defaultValue = _ref2.defaultValue,
          defaultValue = _ref2$defaultValue === void 0 ? null : _ref2$defaultValue,
          _ref2$prefixes = _ref2.prefixes,
          prefixes = _ref2$prefixes === void 0 ? [] : _ref2$prefixes,
          _ref2$suffixes = _ref2.suffixes,
          suffixes = _ref2$suffixes === void 0 ? [] : _ref2$suffixes;

      var ripe = this.ripeProvider.ripe;
      return this.localeModel(material, {
        brand: this.brand,
        model: this.model,
        part: part,
        locale: locale,
        defaultValue: defaultValue,
        prefixes: prefixes,
        suffixes: suffixes,
        localeFunc: function localeFunc() {
          return ripe.localeMaterial.apply(ripe, arguments);
        }
      });
    }
  }, {
    key: "localePart",
    value: function localePart(part) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref3$locale = _ref3.locale,
          locale = _ref3$locale === void 0 ? null : _ref3$locale,
          _ref3$defaultValue = _ref3.defaultValue,
          defaultValue = _ref3$defaultValue === void 0 ? null : _ref3$defaultValue,
          _ref3$prefixes = _ref3.prefixes,
          prefixes = _ref3$prefixes === void 0 ? [] : _ref3$prefixes,
          _ref3$suffixes = _ref3.suffixes,
          suffixes = _ref3$suffixes === void 0 ? [] : _ref3$suffixes;

      var ripe = this.ripeProvider.ripe;
      return this.localeModel(part, {
        brand: this.brand,
        model: this.model,
        locale: locale,
        defaultValue: defaultValue,
        prefixes: prefixes,
        suffixes: suffixes,
        localeFunc: function localeFunc() {
          return ripe.localePart.apply(ripe, arguments);
        }
      });
    }
  }, {
    key: "localeProperty",
    value: function localeProperty(name) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$type = _ref4.type,
          type = _ref4$type === void 0 ? null : _ref4$type,
          _ref4$locale = _ref4.locale,
          locale = _ref4$locale === void 0 ? null : _ref4$locale,
          _ref4$defaultValue = _ref4.defaultValue,
          defaultValue = _ref4$defaultValue === void 0 ? null : _ref4$defaultValue,
          _ref4$prefixes = _ref4.prefixes,
          prefixes = _ref4$prefixes === void 0 ? [] : _ref4$prefixes,
          _ref4$suffixes = _ref4.suffixes,
          suffixes = _ref4$suffixes === void 0 ? [] : _ref4$suffixes;

      var ripe = this.ripeProvider.ripe;
      return this.localeModel(name, {
        brand: this.brand,
        model: this.model,
        type: type,
        locale: locale,
        defaultValue: defaultValue,
        prefixes: prefixes,
        suffixes: suffixes,
        localeFunc: function localeFunc() {
          return ripe.localeProperty.apply(ripe, arguments);
        }
      });
    }
  }, {
    key: "localeModel",
    value: function localeModel(value) {
      var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref5$locale = _ref5.locale,
          locale = _ref5$locale === void 0 ? null : _ref5$locale,
          _ref5$defaultValue = _ref5.defaultValue,
          defaultValue = _ref5$defaultValue === void 0 ? null : _ref5$defaultValue,
          _ref5$localeFunc = _ref5.localeFunc,
          localeFunc = _ref5$localeFunc === void 0 ? null : _ref5$localeFunc,
          options = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_ref5, ["locale", "defaultValue", "localeFunc"]);

      options = Object.assign({
        locale: locale,
        defaultValue: defaultValue,
        localeFunc: localeFunc
      }, options);
      return this._toLocale(value, this.brand, this.model, options);
    }
  }, {
    key: "_bind",
    value: function _bind() {
      var _this2 = this;

      this.owner.bind("config", function (config) {
        var _ref6 = config || {},
            brand = _ref6.brand,
            name = _ref6.name;

        _this2.brand = brand;
        _this2.model = name;
      });
    }
  }, {
    key: "_toLocale",
    value: function _toLocale(value, brand, model) {
      var _ref7 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
          _ref7$locale = _ref7.locale,
          locale = _ref7$locale === void 0 ? null : _ref7$locale,
          _ref7$defaultValue = _ref7.defaultValue,
          defaultValue = _ref7$defaultValue === void 0 ? null : _ref7$defaultValue,
          _ref7$prefix = _ref7.prefix,
          prefix = _ref7$prefix === void 0 ? "builds" : _ref7$prefix,
          _ref7$fallback = _ref7.fallback,
          fallback = _ref7$fallback === void 0 ? false : _ref7$fallback,
          _ref7$compatibility = _ref7.compatibility,
          compatibility = _ref7$compatibility === void 0 ? true : _ref7$compatibility,
          _ref7$hack = _ref7.hack,
          hack = _ref7$hack === void 0 ? false : _ref7$hack,
          _ref7$localeFunc = _ref7.localeFunc,
          localeFunc = _ref7$localeFunc === void 0 ? null : _ref7$localeFunc,
          options = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_ref7, ["locale", "defaultValue", "prefix", "fallback", "compatibility", "hack", "localeFunc"]);

      var ripe = this.ripeProvider.ripe;
      localeFunc = localeFunc || ripe.localeModel;
      var values = Array.isArray(value) ? value : [value];
      var result = localeFunc(value, this.localePlugin, _objectSpread({
        brand: brand,
        model: model,
        locale: locale,
        defaultValue: defaultValue,
        prefix: prefix,
        fallback: fallback,
        compatibility: compatibility,
        hack: hack
      }, options)); // if the localization was successful returns its result

      if (result !== defaultValue) return result; // if the localization was not successful but a default
      // was defined, then returns it

      if (defaultValue !== null) return result; // otherwise run the localization process again using
      // a fallback locale as the base for localization

      var localeFallback = this.localePlugin.getLocaleFallback();

      if (localeFallback !== locale) {
        return this._toLocale(values, brand, model, _objectSpread({
          locale: localeFallback,
          defaultValue: defaultValue,
          prefix: prefix,
          fallback: fallback,
          compatibility: compatibility,
          hack: hack,
          localeFunc: localeFunc
        }, options));
      }

      return values[0];
    }
  }]);

  return ModelLocaleResolverPlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_10__[/* RipeCommonsPlugin */ "b"]);
ModelLocaleResolverPlugin.register();

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _base_personalization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(177);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _base_personalization__WEBPACK_IMPORTED_MODULE_0__["a"]; });



/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BasePersonalizationPlugin; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4);
/* harmony import */ var _base_personalization_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(131);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var BasePersonalizationPlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default()(BasePersonalizationPlugin, _RipeCommonsPlugin);

  var _super = _createSuper(BasePersonalizationPlugin);

  function BasePersonalizationPlugin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, BasePersonalizationPlugin);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(BasePersonalizationPlugin, [{
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_7__[/* RipeCommonsCapability */ "a"]["new"]("component"), _abstract__WEBPACK_IMPORTED_MODULE_7__[/* RipeCommonsCapability */ "a"]["new"]("component-personalization"), _abstract__WEBPACK_IMPORTED_MODULE_7__[/* RipeCommonsCapability */ "a"]["new"]("personalization")];
    }
  }, {
    key: "getComponent",
    value: function () {
      var _getComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _base_personalization_vue__WEBPACK_IMPORTED_MODULE_8__[/* BasePersonalization */ "a"]);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getComponent() {
        return _getComponent.apply(this, arguments);
      }

      return getComponent;
    }()
  }, {
    key: "getPersonalizationComponent",
    value: function () {
      var _getPersonalizationComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _base_personalization_vue__WEBPACK_IMPORTED_MODULE_8__[/* BasePersonalization */ "a"]);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getPersonalizationComponent() {
        return _getPersonalizationComponent.apply(this, arguments);
      }

      return getPersonalizationComponent;
    }()
  }]);

  return BasePersonalizationPlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_7__[/* RipeCommonsPlugin */ "b"]);
BasePersonalizationPlugin.register();

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"initials-images"},_vm._l((_vm.groups),function(group){return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.groupVisible(group)),expression:"groupVisible(group)"}],key:_vm.groupKey(group),ref:"initialsImages",refInFor:true,staticClass:"image initials-image",class:_vm.groupClasses(group),style:(_vm.groupStyle(group)),attrs:{"data-group":group},on:{"click":function () { return _vm.onClick(group); },"load":function () { return _vm.onLoaded(group); }}})}),0)}
var staticRenderFns = []



/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(301);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.groups),function(group){return _c('p',{key:group,ref:"initialsInputs",refInFor:true,staticClass:"initials-input",class:{ active: group === _vm.activeGroup },attrs:{"data-group":group},on:{"click":function () { return _vm.inputSelected(group); }}},[_vm._v("\n        "+_vm._s(_vm.initialsText(group))+"\n    ")])}),_vm._v(" "),_c('div',{staticClass:"initials-labels"},_vm._l((_vm.groups),function(group){return _c('p',{key:group,staticClass:"initials-label",class:{ active: group === _vm.activeGroup },attrs:{"data-group":group},on:{"click":function () { return _vm.inputSelected(group); }}},[_vm._v("\n            "+_vm._s(_vm.groupLabel(group))+"\n        ")])}),0)],2)}
var staticRenderFns = []



/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(303);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reference-personalization"},[_c('initials-images',{attrs:{"brand":_vm.brand,"model":_vm.model,"groups":_vm.groups,"initials-builder":_vm.__initialsBuilder,"image-height":_vm.imageHeight,"image-border-radius":_vm.imageBorderRadius}}),_vm._v(" "),_c('div',{staticClass:"form"},_vm._l((_vm.groups),function(group){return _c('div',{key:group,staticClass:"form-group"},[(_vm.showGroupLabel(group))?_c('p',{staticClass:"subtitle"},[_vm._v("\n                "+_vm._s(_vm.locale("ripe_commons.personalization.group"))+"\n                "+_vm._s(_vm.locale(("ripe_commons.group." + group), _vm.readable(_vm.capitalize(group))))+"\n            ")]):_vm._e(),_vm._v(" "),_vm._l((Object.entries(_vm.properties())),function(ref){
var type = ref[0];
var options = ref[1];
return _c('form-input',{key:type,attrs:{"header":_vm.locale(("ripe_commons.properties." + type), _vm.readable(_vm.capitalize(type))),"header-size":'large'}},[_c('select-ripe',{class:("select-" + type),attrs:{"placeholder":_vm.locale(("ripe_commons.personalization.select." + type)),"options":options,"value":_vm.propertiesData[group][type]},on:{"update:value":function (value) { return _vm.onValueUpdate(value, group, type); }}})],1)}),_vm._v(" "),_c('form-input',{attrs:{"header":_vm.locale('ripe_commons.personalization.initials'),"header-size":'large'}},[_c('input-ripe',{staticClass:"input-initials",attrs:{"placeholder":_vm.locale('ripe_commons.personalization.add_initials'),"value":_vm.initialsText[group]},on:{"update:value":function($event){return _vm.$set(_vm.initialsText, group, $event)}}})],1)],2)}),0)],1)}
var staticRenderFns = []



/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(305);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formInterface", function() { return formInterface; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reference", function() { return reference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "referenceMulti", function() { return referenceMulti; });
/* harmony import */ var _interface__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Interface", function() { return _interface__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony import */ var _reference_vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Reference", function() { return _reference_vue__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var _reference_multi_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(108);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReferenceMulti", function() { return _reference_multi_vue__WEBPACK_IMPORTED_MODULE_2__["a"]; });




var formInterface = _interface__WEBPACK_IMPORTED_MODULE_0__[/* Interface */ "a"];
var reference = _reference_vue__WEBPACK_IMPORTED_MODULE_1__[/* Reference */ "a"];
var referenceMulti = _reference_multi_vue__WEBPACK_IMPORTED_MODULE_2__[/* ReferenceMulti */ "a"];


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reference-size"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.locale("ripe_commons.size.size")))]),_vm._v(" "),_c('div',{staticClass:"size-selector"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.modelGenders && _vm.modelGenders.length > 1),expression:"modelGenders && modelGenders.length > 1"}],staticClass:"genders"},_vm._l((_vm.modelGenders),function(modelGender){return _c('div',{key:modelGender,staticClass:"button button-gender",class:{ active: modelGender === _vm.visibleGender },on:{"click":function($event){return _vm.__changeGender(modelGender)}}},[_vm._v("\n                "+_vm._s(_vm.locale(("ripe_commons.size." + modelGender)))+"\n            ")])}),0),_vm._v(" "),(_vm.sizesLoaded)?_c('div',{staticClass:"sizes-container",class:{ multiple: _vm.modelGenders && _vm.modelGenders.length > 1 }},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.__getAvailableScales(_vm.visibleGender).length > 1),expression:"__getAvailableScales(visibleGender).length > 1"}],staticClass:"scales"},_vm._l((_vm.__getAvailableScales(_vm.visibleGender)),function(modelScale){return _c('div',{key:modelScale,staticClass:"button button-scale",class:{ active: modelScale === _vm.visibleScale },on:{"click":function($event){_vm.scale = modelScale}}},[_vm._v("\n                    "+_vm._s(_vm.locale(("scales." + modelScale)))+"\n                ")])}),0),_vm._v(" "),_vm._l((_vm.__getAvailableScales(_vm.visibleGender)),function(modelScale){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(modelScale === _vm.visibleScale),expression:"modelScale === visibleScale"}],key:modelScale,staticClass:"sizes"},_vm._l((_vm.sizeOptions[_vm.visibleGender][modelScale]),function(sizeObject){return _c('div',{key:sizeObject.native,staticClass:"button button-size",class:{
                        active: _vm.__isSelected(_vm.visibleGender, modelScale, sizeObject.native)
                    },on:{"click":function () { return _vm.__sizeSelected(_vm.visibleGender, modelScale, sizeObject.native); }}},[_vm._v("\n                    "+_vm._s(sizeObject.locale)+"\n                ")])}),0)})],2):_vm._e()])])}
var staticRenderFns = []



/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(307);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _base_size__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(188);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _base_size__WEBPACK_IMPORTED_MODULE_0__["a"]; });



/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseSizePlugin; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4);
/* harmony import */ var _base_size_vue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(102);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }



var BaseSizePlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3___default()(BaseSizePlugin, _RipeCommonsPlugin);

  var _super = _createSuper(BaseSizePlugin);

  function BaseSizePlugin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, BaseSizePlugin);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(BaseSizePlugin, [{
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_7__[/* RipeCommonsCapability */ "a"]["new"]("component"), _abstract__WEBPACK_IMPORTED_MODULE_7__[/* RipeCommonsCapability */ "a"]["new"]("component-size"), _abstract__WEBPACK_IMPORTED_MODULE_7__[/* RipeCommonsCapability */ "a"]["new"]("size")];
    }
  }, {
    key: "getComponent",
    value: function () {
      var _getComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", _base_size_vue__WEBPACK_IMPORTED_MODULE_8__[/* BaseSize */ "a"]);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function getComponent() {
        return _getComponent.apply(this, arguments);
      }

      return getComponent;
    }()
  }, {
    key: "getComponentSize",
    value: function () {
      var _getComponentSize = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee2() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", _base_size_vue__WEBPACK_IMPORTED_MODULE_8__[/* BaseSize */ "a"]);

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function getComponentSize() {
        return _getComponentSize.apply(this, arguments);
      }

      return getComponentSize;
    }()
  }, {
    key: "getSizeComponent",
    value: function () {
      var _getSizeComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.mark(function _callee3() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_6___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", _base_size_vue__WEBPACK_IMPORTED_MODULE_8__[/* BaseSize */ "a"]);

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function getSizeComponent() {
        return _getSizeComponent.apply(this, arguments);
      }

      return getSizeComponent;
    }()
  }]);

  return BaseSizePlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_7__[/* RipeCommonsPlugin */ "b"]);
BaseSizePlugin.register();

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _main__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(190);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _main__WEBPACK_IMPORTED_MODULE_0__["a"]; });



/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RipeCommonsMainPlugin; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33);
/* harmony import */ var _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20);
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var ripe_sdk_src_css_ripe_css__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(308);
/* harmony import */ var ripe_sdk_src_css_ripe_css__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(ripe_sdk_src_css_ripe_css__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(157);
/* harmony import */ var vue_global_events__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(251);
/* harmony import */ var ripe_sdk__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(19);
/* harmony import */ var ripe_sdk__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(ripe_sdk__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var yonius__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(252);
/* harmony import */ var yonius__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(yonius__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _vue__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(17);
/* harmony import */ var _abstract__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(4);













function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_3___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_9___default()(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }









var RipeCommonsMainPlugin = /*#__PURE__*/function (_RipeCommonsPlugin) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_8___default()(RipeCommonsMainPlugin, _RipeCommonsPlugin);

  var _super = _createSuper(RipeCommonsMainPlugin);

  function RipeCommonsMainPlugin() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, RipeCommonsMainPlugin);

    return _super.apply(this, arguments);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(RipeCommonsMainPlugin, [{
    key: "load",
    value: function () {
      var _load = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee2() {
        var _this = this;

        var config;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(RipeCommonsMainPlugin.prototype), "load", this).call(this);

              case 2:
                _context2.next = 4;
                return this.owner.getPluginsByCapability("helper");

              case 4:
                this.helperPlugins = _context2.sent;
                _context2.next = 7;
                return this.owner.getPluginByName("LocalePlugin");

              case 7:
                this.localePlugin = _context2.sent;
                // tries to retrieve the DOM element where the vue app will be
                // mounted, throwing and error if it doesn't exist
                this.appElement = document.getElementById("app");

                if (this.appElement) {
                  _context2.next = 11;
                  break;
                }

                throw new Error("Element #app not found");

              case 11:
                // create a temporary application object with the logging
                // methods so that they can be used temporarily until the
                // final application object is up and running
                this.app = Object.assign({}, _vue__WEBPACK_IMPORTED_MODULE_18__[/* mixins */ "M"].loggingMixin.methods); // initializes the Vue.js reactive data store according to the
                // underlying specification defined by `_getStoreDef`

                _context2.next = 14;
                return this._initStore();

              case 14:
                _context2.next = 16;
                return this._loadOptions();

              case 16:
                _context2.next = 18;
                return this._buildConfig();

              case 18:
                config = _context2.sent;
                // instantiates the RIPE object and its required plugins
                this.restrictionsPlugin = new ripe_sdk__WEBPACK_IMPORTED_MODULE_16__["Ripe"].plugins.RestrictionsPlugin();
                this.syncPlugin = new ripe_sdk__WEBPACK_IMPORTED_MODULE_16__["Ripe"].plugins.SyncPlugin();
                this.ripe = new ripe_sdk__WEBPACK_IMPORTED_MODULE_16__["Ripe"]({
                  init: false
                }); // binds to the necessary events sent through the owner,
                // includes the piping of event from RIPE to Vue.js

                this._bind(); // waits for the complete of the RIPE SDK loading process
                // so that all the necessary components are loaded, notice
                // that both the brand, model, variant and version and unset
                // so that these values can be set latter


                _context2.next = 25;
                return this.ripe.init(_objectSpread(_objectSpread({
                  plugins: [this.restrictionsPlugin, this.syncPlugin]
                }, this.options), {}, {
                  brand: null,
                  model: null,
                  variant: null,
                  version: null
                }));

              case 25:
                _context2.next = 27;
                return this._loadVue();

              case 27:
                _context2.next = 29;
                return this._initVueApp(this.appElement);

              case 29:
                this.app = _context2.sent;
                // runs the setting of the model & configuration according to the currently set
                // options (initial bootstrap operation), handling critical error as expected
                this.setModelConfig(config)["catch"]( /*#__PURE__*/function () {
                  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee(err) {
                    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            _context.next = 2;
                            return _this._handleCritical(err);

                          case 2:
                            return _context.abrupt("return", _context.sent);

                          case 3:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function load() {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "unload",
    value: function () {
      var _unload = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee3() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.helperPlugins = null;
                this.localePlugin = null;
                _context3.next = 4;
                return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_7___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_10___default()(RipeCommonsMainPlugin.prototype), "unload", this).call(this);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function unload() {
        return _unload.apply(this, arguments);
      }

      return unload;
    }()
  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      return [_abstract__WEBPACK_IMPORTED_MODULE_19__[/* RipeCommonsCapability */ "a"]["new"]("start"), _abstract__WEBPACK_IMPORTED_MODULE_19__[/* RipeCommonsCapability */ "a"]["new"]("ripe-provider")];
    }
  }, {
    key: "buildComponent",
    value: function () {
      var _buildComponent = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee4(componentClass, options) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", new DynamicComponent(componentClass, options));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function buildComponent(_x2, _x3) {
        return _buildComponent.apply(this, arguments);
      }

      return buildComponent;
    }()
  }, {
    key: "setModel",
    value: function () {
      var _setModel = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee5() {
        var options,
            safe,
            _args5 = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : null;
                safe = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : true;

                if (!(safe && this.configuring)) {
                  _context5.next = 6;
                  break;
                }

                this.app.logInfo(function () {
                  return "Delaying set model, still configuring...";
                });
                this.pending = options || true;
                return _context5.abrupt("return");

              case 6:
                // in case no options are provided then the options currently
                // set in the instance are used instead
                if (options === null) options = this.options;
                this.configuring = true;
                this.pending = undefined; // creates a copy of the options setting the safe flag with the
                // value that has been set in the operation

                options = Object.assign({
                  safe: safe
                }, options);
                _context5.prev = 10;

                if (options.brand) {
                  _context5.next = 13;
                  break;
                }

                throw Error("No brand defined in context");

              case 13:
                if (options.model) {
                  _context5.next = 15;
                  break;
                }

                throw Error("No model defined in context");

              case 15:
                // prints a small info message about the new model to be set
                this.app.logInfo(function () {
                  return "Setting model ".concat(JSON.stringify(options, null, 2));
                }); // updates the config of the ripe object, this should
                // start the process of loading a specific model

                _context5.next = 18;
                return this.ripe.config(options.brand, options.model, options);

              case 18:
                this.app.$store.commit("error", null);
                _context5.next = 26;
                break;

              case 21:
                _context5.prev = 21;
                _context5.t0 = _context5["catch"](10);
                // in case there's an error the error is set in the store
                // state so that it can be consulted by the components
                this.app.$store.commit("error", _context5.t0 || true); // triggers the error event in the current app indicating
                // that an error error state has been reached in set model

                this.app.$bus.trigger("error", _context5.t0 || true); // on top of the config error being set on the store a proper
                // exception is also thrown indicating the issue

                throw _context5.t0;

              case 26:
                _context5.prev = 26;
                // unset the safe flag for configuration, allowing further configuration
                // to take place, as it's now considered safe
                this.configuring = false; // in case there's a configuration pending (meaning it has been requested
                // in the middle of the previous one) it's now time to set it as the model

                if (this.pending) {
                  this.app.logInfo(function () {
                    return "Processing delayed set model...";
                  });
                  this.setModel(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_2___default()(this.pending) === "object" ? this.pending : null);
                }

                return _context5.finish(26);

              case 30:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[10, 21, 26, 30]]);
      }));

      function setModel() {
        return _setModel.apply(this, arguments);
      }

      return setModel;
    }()
  }, {
    key: "setModelConfig",
    value: function () {
      var _setModelConfig = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee6() {
        var _ref2,
            _ref2$brand,
            brand,
            _ref2$model,
            model,
            _ref2$version,
            version,
            _ref2$query,
            query,
            _ref2$dku,
            dku,
            _ref2$productId,
            productId,
            _ref2$setModel,
            setModel,
            extra,
            config,
            _args6 = arguments;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref2 = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {}, _ref2$brand = _ref2.brand, brand = _ref2$brand === void 0 ? null : _ref2$brand, _ref2$model = _ref2.model, model = _ref2$model === void 0 ? null : _ref2$model, _ref2$version = _ref2.version, version = _ref2$version === void 0 ? null : _ref2$version, _ref2$query = _ref2.query, query = _ref2$query === void 0 ? null : _ref2$query, _ref2$dku = _ref2.dku, dku = _ref2$dku === void 0 ? null : _ref2$dku, _ref2$productId = _ref2.productId, productId = _ref2$productId === void 0 ? null : _ref2$productId, _ref2$setModel = _ref2.setModel, setModel = _ref2$setModel === void 0 ? true : _ref2$setModel, extra = _babel_runtime_helpers_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1___default()(_ref2, ["brand", "model", "version", "query", "dku", "productId", "setModel"]);
                config = {};

                if (!query) {
                  _context6.next = 6;
                  break;
                }

                config = this.ripe._queryToSpec(query);
                _context6.next = 17;
                break;

              case 6:
                if (!dku) {
                  _context6.next = 13;
                  break;
                }

                _context6.next = 9;
                return this.ripe.configDkuP(dku);

              case 9:
                config = _context6.sent;
                config.initialsExtra = config.initials_extra;
                _context6.next = 17;
                break;

              case 13:
                if (!productId) {
                  _context6.next = 17;
                  break;
                }

                _context6.next = 16;
                return this.ripe.configResolveP(productId);

              case 16:
                config = _context6.sent;

              case 17:
                // updates the currently set options with the model configuration
                // provided (base object contains current brand and model)
                this.options = Object.assign({
                  brand: brand,
                  model: model,
                  version: version,
                  parts: {}
                }, extra, config); // in case no model setting is effectively required then return
                // the control flow immediately (only options are changed)

                if (setModel) {
                  _context6.next = 20;
                  break;
                }

                return _context6.abrupt("return");

              case 20:
                _context6.next = 22;
                return this.setModel(this.options);

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function setModelConfig() {
        return _setModelConfig.apply(this, arguments);
      }

      return setModelConfig;
    }()
    /**
     * Updates the options currently set in the RIPE instance to reflect
     * a possible new state provided as parameter.
     *
     * This method provides a safe mechanism that detects changes in the
     * configuration when compared with the current RIPE instance state
     * so that unwanted option setting is avoided.
     *
     * @param {Object} options The new options that are going to be used in the
     * re-configuration of the RIPE instance.
     * @param {Boolean} force If the update on config should be performed even
     * if there are no changed detected in the options.
     */

  }, {
    key: "setRipeOptions",
    value: function () {
      var _setRipeOptions = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee7(options) {
        var _this2 = this;

        var force,
            ripeState,
            changed,
            _args7 = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                force = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : false;
                ripeState = this._getRipeState();
                changed = Object.entries(ripeState).filter(function (_ref3) {
                  var _ref4 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_ref3, 2),
                      key = _ref4[0],
                      value = _ref4[1];

                  switch (key) {
                    case "parts":
                      return options[key] && !_this2.app.equalParts(options[key], value);

                    default:
                      return options[key] !== undefined && options[key] !== value;
                  }
                });

                if (!(changed.length === 0 && !force)) {
                  _context7.next = 5;
                  break;
                }

                return _context7.abrupt("return");

              case 5:
                _context7.next = 7;
                return this.ripe.config(this.ripe.brand, this.ripe.model, _objectSpread({}, options));

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setRipeOptions(_x4) {
        return _setRipeOptions.apply(this, arguments);
      }

      return setRipeOptions;
    }()
  }, {
    key: "_getRipeState",
    value: function _getRipeState() {
      return {
        variant: this.ripe.variant,
        version: this.ripe.version,
        dku: this.ripe.dku,
        url: this.ripe.url,
        webUrl: this.ripe.webUrl,
        parts: this.ripe.parts,
        country: this.ripe.country,
        currency: this.ripe.currency,
        locale: this.ripe.locale,
        flag: this.ripe.flag,
        size: this.ripe.size,
        backgroundColor: this.ripe.backgroundColor,
        guess: this.ripe.guess,
        guessUrl: this.ripe.guessUrl,
        remoteCalls: this.ripe.remoteCalls,
        remoteOnConfig: this.ripe.remoteOnConfig,
        remoteOnPart: this.ripe.remoteOnPart,
        remoteOnInitials: this.ripe.remoteOnInitials,
        noBundles: this.ripe.noBundles,
        useBundles: this.ripe.useBundles,
        noDefaults: this.ripe.noDefaults,
        useDefaults: this.ripe.useDefaults,
        noCombinations: this.ripe.noCombinations,
        useCombinations: this.ripe.useCombinations,
        noPrice: this.ripe.noPrice,
        usePrice: this.ripe.usePrice,
        noDiag: this.ripe.noDiag,
        useDiag: this.ripe.useDiag
      };
    }
  }, {
    key: "_bind",
    value: function _bind() {
      var _this3 = this;

      // listens for the 'set_model' event to change the
      // model accordingly
      this.owner.bind("set_model", this.setModel.bind(this)); // updates the app state when a new model is set
      // changing the internal store values to reflect
      // the newly updated model related values

      this.ripe.bind("post_config", /*#__PURE__*/function () {
        var _ref5 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee8(config) {
          return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _this3.app.logDebug(function () {
                    return "SDK configuration changed: ".concat(JSON.stringify(config, null, 2));
                  });

                  _this3.store.commit("config", config);

                  _this3.store.commit("model", {
                    brand: _this3.ripe.brand,
                    model: _this3.ripe.model,
                    variant: _this3.ripe.options.variant,
                    version: _this3.ripe.options.version,
                    description: _this3.ripe.options.description,
                    product_id: _this3.ripe.options.product_id,
                    dku: _this3.ripe.options.dku,
                    parts: _this3.ripe.parts || {}
                  });

                  _this3.store.commit("format", _this3.ripe.format);

                  _this3.store.commit("resolution", _this3.ripe.size);

                  _this3.store.commit("backgroundColor", _this3.ripe.backgroundColor);

                  _this3.store.commit("ripeOptions", _this3.ripe.options);

                  _this3.store.commit("ripeState", {
                    variant: _this3.ripe.variant,
                    version: _this3.ripe.version,
                    dku: _this3.ripe.dku,
                    url: _this3.ripe.url,
                    webUrl: _this3.ripe.webUrl,
                    parts: _this3.ripe.parts,
                    country: _this3.ripe.country,
                    currency: _this3.ripe.currency,
                    locale: _this3.ripe.locale,
                    flag: _this3.ripe.flag,
                    format: _this3.ripe.format,
                    formatBase: _this3.ripe.formatBase,
                    size: _this3.ripe.size,
                    backgroundColor: _this3.ripe.backgroundColor,
                    guess: _this3.ripe.guess,
                    guessUrl: _this3.ripe.guessUrl,
                    remoteCalls: _this3.ripe.remoteCalls,
                    remoteOnConfig: _this3.ripe.remoteOnConfig,
                    remoteOnPart: _this3.ripe.remoteOnPart,
                    remoteOnInitials: _this3.ripe.remoteOnInitials,
                    noBundles: _this3.ripe.noBundles,
                    useBundles: _this3.ripe.useBundles,
                    noDefaults: _this3.ripe.noDefaults,
                    useDefaults: _this3.ripe.useDefaults,
                    noCombinations: _this3.ripe.noCombinations,
                    useCombinations: _this3.ripe.useCombinations,
                    noPrice: _this3.ripe.noPrice,
                    usePrice: _this3.ripe.usePrice,
                    noDiag: _this3.ripe.noDiag,
                    useDiag: _this3.ripe.useDiag
                  });

                  _this3.store.commit("hasCustomization", _this3.ripe.hasCustomization());

                  _this3.store.commit("hasPersonalization", _this3.ripe.hasPersonalization());

                  _this3.store.commit("hasSize", _this3.ripe.hasSize());

                  _this3.store.commit("hasInitialsRadius", _this3.ripe.hasInitialsRadius()); // clear the initials data, as it is possibly outdated


                  _this3.store.commit("clearInitialsData");

                case 13:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function (_x5) {
          return _ref5.apply(this, arguments);
        };
      }()); // changes some internal structure whenever there's an update
      // on the underlying ripe instance

      this.ripe.bind("post_update", function (options) {
        _this3.app.logDebug(function () {
          return "SDK update: ".concat(JSON.stringify(options, null, 2));
        });
      }); // updates some of the internal store setting whenever there's
      // a change in the internal ripe settings

      this.ripe.bind("settings", function () {
        _this3.app.logDebug(function () {
          return "SDK settings changed";
        });

        _this3.store.commit("format", _this3.ripe.format);

        _this3.store.commit("resolution", _this3.ripe.size);

        _this3.store.commit("backgroundColor", _this3.ripe.backgroundColor);
      }); // listens for parts and prices changes and updates the store

      this.ripe.bind("parts", function (parts) {
        _this3.app.logDebug(function () {
          return "SDK parts changed";
        });

        _this3.store.commit("parts", parts);
      });
      this.ripe.bind("price", function (price) {
        _this3.app.logDebug(function () {
          return "SDK price changed: ".concat(price.total.price_final);
        });

        _this3.store.commit("price", price);
      });
      this.ripe.bind("price_error", function (error) {
        _this3.app.logDebug(function () {
          return "SDK price error: ".concat(error.message);
        });

        _this3.store.commit("price", null);
      }); // forwards the parts events to the global bus

      this.ripe.bind("pre_parts", function () {
        var _this3$owner;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (_this3$owner = _this3.owner).trigger.apply(_this3$owner, ["pre_parts"].concat(args));
      });
      this.ripe.bind("parts", function () {
        var _this3$owner2;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return (_this3$owner2 = _this3.owner).trigger.apply(_this3$owner2, ["parts"].concat(args));
      });
      this.ripe.bind("post_parts", function () {
        var _this3$owner3;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return (_this3$owner3 = _this3.owner).trigger.apply(_this3$owner3, ["post_parts"].concat(args));
      }); // forwards the config events to the global bus

      this.ripe.bind("pre_config", function () {
        var _this3$owner4;

        for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        return (_this3$owner4 = _this3.owner).trigger.apply(_this3$owner4, ["pre_config"].concat(args));
      });
      this.ripe.bind("config", function () {
        var _this3$owner5;

        for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }

        return (_this3$owner5 = _this3.owner).trigger.apply(_this3$owner5, ["config"].concat(args));
      });
      this.ripe.bind("post_config", function () {
        var _this3$owner6;

        for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }

        return (_this3$owner6 = _this3.owner).trigger.apply(_this3$owner6, ["post_config"].concat(args));
      }); // forwards the some other events to the global bus

      this.ripe.bind("selected_part", function () {
        var _this3$owner7;

        for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
          args[_key7] = arguments[_key7];
        }

        return (_this3$owner7 = _this3.owner).trigger.apply(_this3$owner7, ["selected_part"].concat(args));
      });
      this.ripe.bind("choices", function () {
        var _this3$owner8;

        for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
          args[_key8] = arguments[_key8];
        }

        return (_this3$owner8 = _this3.owner).trigger.apply(_this3$owner8, ["choices"].concat(args));
      });
      this.ripe.bind("bundles", function () {
        var _this3$owner9;

        for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
          args[_key9] = arguments[_key9];
        }

        return (_this3$owner9 = _this3.owner).trigger.apply(_this3$owner9, ["bundles"].concat(args));
      });
      this.ripe.bind("auth", function () {
        var _this3$owner10;

        for (var _len10 = arguments.length, args = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
          args[_key10] = arguments[_key10];
        }

        return (_this3$owner10 = _this3.owner).trigger.apply(_this3$owner10, ["auth"].concat(args));
      });
      this.ripe.bind("initials", function () {
        var _this3$owner11;

        for (var _len11 = arguments.length, args = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
          args[_key11] = arguments[_key11];
        }

        return (_this3$owner11 = _this3.owner).trigger.apply(_this3$owner11, ["initials"].concat(args));
      });
      this.ripe.bind("initials_extra", function () {
        var _this3$owner12;

        for (var _len12 = arguments.length, args = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          args[_key12] = arguments[_key12];
        }

        return (_this3$owner12 = _this3.owner).trigger.apply(_this3$owner12, ["initials_extra"].concat(args));
      });
    }
  }, {
    key: "_getExtraComponents",
    value: function _getExtraComponents() {
      return {};
    }
  }, {
    key: "_getStoreDef",
    value: function _getStoreDef() {
      return _vue__WEBPACK_IMPORTED_MODULE_18__[/* store */ "X"];
    }
  }, {
    key: "_installComponents",
    value: function _installComponents(components) {
      for (var _i = 0, _Object$keys = Object.keys(components); _i < _Object$keys.length; _i++) {
        var name = _Object$keys[_i];
        var component = components[name];
        var componentName = component.name ? component.name : name;
        vue__WEBPACK_IMPORTED_MODULE_13___default.a.component(componentName, component);
      }
    }
  }, {
    key: "_loadVue",
    value: function () {
      var _loadVue2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee9() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // register the vue components so that they can initialized
                // from the templates, only after this call can the templates
                // use these components safely
                this._installComponents(_vue__WEBPACK_IMPORTED_MODULE_18__[/* components */ "A"]);

                this._installComponents(this._getExtraComponents()); // registers the store and utils mixins so they are set on
                // all components, this applies directly on component creation


                vue__WEBPACK_IMPORTED_MODULE_13___default.a.mixin(_vue__WEBPACK_IMPORTED_MODULE_18__[/* mixins */ "M"].logicMixin);
                vue__WEBPACK_IMPORTED_MODULE_13___default.a.mixin(_vue__WEBPACK_IMPORTED_MODULE_18__[/* mixins */ "M"].utilsMixin);
                vue__WEBPACK_IMPORTED_MODULE_13___default.a.mixin(_vue__WEBPACK_IMPORTED_MODULE_18__[/* mixins */ "M"].loggingMixin); // initializes the event bus that will be used for
                // UI related communication between the components

                vue__WEBPACK_IMPORTED_MODULE_13___default.a.use(_vue__WEBPACK_IMPORTED_MODULE_18__[/* plugins */ "R"].busPlugin); // adds a reference to the ripe object on the vue
                // components

                vue__WEBPACK_IMPORTED_MODULE_13___default.a.use(_vue__WEBPACK_IMPORTED_MODULE_18__[/* plugins */ "R"].ripePlugin, this.ripe); // initializes the vue plugin that provides an
                // interface between the components and the
                // locale plugin

                vue__WEBPACK_IMPORTED_MODULE_13___default.a.use(_vue__WEBPACK_IMPORTED_MODULE_18__[/* plugins */ "R"].localePlugin, this.localePlugin); // registers the usage of the global events component
                // as this is going to be used by multiple parts

                vue__WEBPACK_IMPORTED_MODULE_13___default.a.component("global-events", vue_global_events__WEBPACK_IMPORTED_MODULE_15__[/* default */ "a"]); // returns the global vue instance so that methods that
                // inherit from this may use the same reference

                return _context9.abrupt("return", vue__WEBPACK_IMPORTED_MODULE_13___default.a);

              case 10:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _loadVue() {
        return _loadVue2.apply(this, arguments);
      }

      return _loadVue;
    }()
  }, {
    key: "_loadOptions",
    value: function () {
      var _loadOptions2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee10() {
        var validate,
            _args10 = arguments;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                validate = _args10.length > 0 && _args10[0] !== undefined ? _args10[0] : true;
                throw new Error("_loadOptions is not implemented.");

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function _loadOptions() {
        return _loadOptions2.apply(this, arguments);
      }

      return _loadOptions;
    }()
  }, {
    key: "_buildConfig",
    value: function () {
      var _buildConfig2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee11() {
        var config, isQuery, isDku, isProductId;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                // allocates space for the object that will hold the target model
                // configuration to be applied to the ripe instance
                config = {}; // in case there's a brand and model defined we should follow the
                // "typical" setting of options according to brand and model

                if (!(this.options.brand && this.options.model)) {
                  _context11.next = 5;
                  break;
                }

                Object.assign(config, {
                  brand: this.options.brand,
                  model: this.options.model,
                  version: this.options.version || null,
                  parts: this.options.parts || {}
                });
                _context11.next = 27;
                break;

              case 5:
                if (!this.options.dku) {
                  _context11.next = 9;
                  break;
                }

                Object.assign(config, {
                  dku: this.options.dku
                });
                _context11.next = 27;
                break;

              case 9:
                if (!this.options.product_id) {
                  _context11.next = 27;
                  break;
                }

                isQuery = this.options.product_id.startsWith("query:");
                isDku = this.options.product_id.startsWith("dku:");
                isProductId = !isQuery && !isDku;

                if (!isQuery) {
                  _context11.next = 17;
                  break;
                }

                Object.assign(config, {
                  query: this.options.product_id.slice(6)
                });
                _context11.next = 26;
                break;

              case 17:
                if (!isDku) {
                  _context11.next = 21;
                  break;
                }

                Object.assign(config, {
                  dku: this.options.product_id.slice(4)
                });
                _context11.next = 26;
                break;

              case 21:
                if (!isProductId) {
                  _context11.next = 25;
                  break;
                }

                Object.assign(config, {
                  productId: this.options.product_id
                });
                _context11.next = 26;
                break;

              case 25:
                throw new Error("No valid product ID structure");

              case 26:
                // avoid including the product ID if it's not a "real"
                // RIPE product ID but just a ripe-commons-pluginus facade
                // for a config (prefixed with xxx: and a string)
                if (!isProductId) delete this.options.product_id;

              case 27:
                return _context11.abrupt("return", config);

              case 28:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function _buildConfig() {
        return _buildConfig2.apply(this, arguments);
      }

      return _buildConfig;
    }()
  }, {
    key: "_initStore",
    value: function () {
      var _initStore2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee12() {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                vue__WEBPACK_IMPORTED_MODULE_13___default.a.use(vuex__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"]);
                this.store = new vuex__WEBPACK_IMPORTED_MODULE_14__[/* default */ "a"].Store(this._getStoreDef());

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function _initStore() {
        return _initStore2.apply(this, arguments);
      }

      return _initStore;
    }()
  }, {
    key: "_initVueApp",
    value: function () {
      var _initVueApp2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee15(element) {
        var self, manager, app;
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                // saves references to the context and to the owner
                // to be used inside the vue app
                self = this;
                manager = this.owner;
                app = new vue__WEBPACK_IMPORTED_MODULE_13___default.a({
                  el: element,
                  provide: function provide() {
                    return {
                      manager: manager
                    };
                  },
                  store: this.store,
                  created: function created() {
                    var _this4 = this;

                    // triggers the refresh of the UI when the
                    // global locale value changes
                    manager.bind("locale", function () {
                      _this4.$bus.trigger("refresh");
                    }); // pipes the (plugin) manager events to the vue bus

                    manager.bind("pre_parts", function () {
                      var _this4$$bus;

                      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
                        args[_key13] = arguments[_key13];
                      }

                      return (_this4$$bus = _this4.$bus).trigger.apply(_this4$$bus, ["pre_parts"].concat(args));
                    });
                    manager.bind("parts", function () {
                      var _this4$$bus2;

                      for (var _len14 = arguments.length, args = new Array(_len14), _key14 = 0; _key14 < _len14; _key14++) {
                        args[_key14] = arguments[_key14];
                      }

                      return (_this4$$bus2 = _this4.$bus).trigger.apply(_this4$$bus2, ["parts"].concat(args));
                    });
                    manager.bind("post_parts", function () {
                      var _this4$$bus3;

                      for (var _len15 = arguments.length, args = new Array(_len15), _key15 = 0; _key15 < _len15; _key15++) {
                        args[_key15] = arguments[_key15];
                      }

                      return (_this4$$bus3 = _this4.$bus).trigger.apply(_this4$$bus3, ["post_parts"].concat(args));
                    });
                    manager.bind("pre_config", function () {
                      var _this4$$bus4;

                      for (var _len16 = arguments.length, args = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
                        args[_key16] = arguments[_key16];
                      }

                      return (_this4$$bus4 = _this4.$bus).trigger.apply(_this4$$bus4, ["pre_config"].concat(args));
                    });
                    manager.bind("config", function () {
                      var _this4$$bus5;

                      for (var _len17 = arguments.length, args = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
                        args[_key17] = arguments[_key17];
                      }

                      return (_this4$$bus5 = _this4.$bus).trigger.apply(_this4$$bus5, ["config"].concat(args));
                    });
                    manager.bind("post_config", function () {
                      var _this4$$bus6;

                      for (var _len18 = arguments.length, args = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
                        args[_key18] = arguments[_key18];
                      }

                      return (_this4$$bus6 = _this4.$bus).trigger.apply(_this4$$bus6, ["post_config"].concat(args));
                    });
                    manager.bind("selected_part", function () {
                      var _this4$$bus7;

                      for (var _len19 = arguments.length, args = new Array(_len19), _key19 = 0; _key19 < _len19; _key19++) {
                        args[_key19] = arguments[_key19];
                      }

                      return (_this4$$bus7 = _this4.$bus).trigger.apply(_this4$$bus7, ["selected_part"].concat(args));
                    });
                    manager.bind("choices", function () {
                      var _this4$$bus8;

                      for (var _len20 = arguments.length, args = new Array(_len20), _key20 = 0; _key20 < _len20; _key20++) {
                        args[_key20] = arguments[_key20];
                      }

                      return (_this4$$bus8 = _this4.$bus).trigger.apply(_this4$$bus8, ["choices"].concat(args));
                    });
                    manager.bind("auth", function () {
                      var _this4$$bus9;

                      for (var _len21 = arguments.length, args = new Array(_len21), _key21 = 0; _key21 < _len21; _key21++) {
                        args[_key21] = arguments[_key21];
                      }

                      return (_this4$$bus9 = _this4.$bus).trigger.apply(_this4$$bus9, ["auth"].concat(args));
                    });
                    manager.bind("initials", function () {
                      var _this4$$bus10;

                      for (var _len22 = arguments.length, args = new Array(_len22), _key22 = 0; _key22 < _len22; _key22++) {
                        args[_key22] = arguments[_key22];
                      }

                      return (_this4$$bus10 = _this4.$bus).trigger.apply(_this4$$bus10, ["initials"].concat(args));
                    });
                    manager.bind("initials_extra", function () {
                      var _this4$$bus11;

                      for (var _len23 = arguments.length, args = new Array(_len23), _key23 = 0; _key23 < _len23; _key23++) {
                        args[_key23] = arguments[_key23];
                      }

                      return (_this4$$bus11 = _this4.$bus).trigger.apply(_this4$$bus11, ["initials_extra"].concat(args));
                    });
                    manager.bind("locale_changed", function () {
                      var _this4$$bus12;

                      for (var _len24 = arguments.length, args = new Array(_len24), _key24 = 0; _key24 < _len24; _key24++) {
                        args[_key24] = arguments[_key24];
                      }

                      return (_this4$$bus12 = _this4.$bus).trigger.apply(_this4$$bus12, ["locale_changed"].concat(args));
                    });
                    manager.bind("locale_map_changed", function () {
                      var _this4$$bus13;

                      for (var _len25 = arguments.length, args = new Array(_len25), _key25 = 0; _key25 < _len25; _key25++) {
                        args[_key25] = arguments[_key25];
                      }

                      return (_this4$$bus13 = _this4.$bus).trigger.apply(_this4$$bus13, ["locale_map_changed"].concat(args));
                    }); // pipes the ripe plugins events to the vue bus, allows
                    // so that UI components can "respond" to changes

                    self.restrictionsPlugin.bind("restrictions", function () {
                      var _this4$$bus14;

                      for (var _len26 = arguments.length, args = new Array(_len26), _key26 = 0; _key26 < _len26; _key26++) {
                        args[_key26] = arguments[_key26];
                      }

                      return (_this4$$bus14 = _this4.$bus).trigger.apply(_this4$$bus14, ["restrictions"].concat(args));
                    });
                    self.syncPlugin.bind("sync", function () {
                      var _this4$$bus15;

                      for (var _len27 = arguments.length, args = new Array(_len27), _key27 = 0; _key27 < _len27; _key27++) {
                        args[_key27] = arguments[_key27];
                      }

                      return (_this4$$bus15 = _this4.$bus).trigger.apply(_this4$$bus15, ["sync"].concat(args));
                    }); // updates the ripe instance when a part or personalization
                    // is changed (imperative/action events)

                    this.$bus.bind("format_change", function (format) {
                      return self.ripe.setFormat(format);
                    });
                    this.$bus.bind("size_change", function (size) {
                      return self.ripe.setSize(size);
                    });
                    this.$bus.bind("background_color_change", function (backgroundColor) {
                      return self.ripe.setBackgroundColor(backgroundColor);
                    });
                    this.$bus.bind("part_change", function (part, material, color) {
                      return self.ripe.setPart(part, material, color);
                    });
                    this.$bus.bind("initials_change", function (initialsExtra) {
                      self.ripe.setInitialsExtra(initialsExtra);
                    });
                    this.$bus.bind("previous_frame", function () {
                      return self.ripe.getChildren("Configurator").forEach(function (c) {
                        return c.previousFrame();
                      });
                    });
                    this.$bus.bind("next_frame", function () {
                      return self.ripe.getChildren("Configurator").forEach(function (c) {
                        return c.nextFrame();
                      });
                    });
                    this.$bus.bind("undo", function () {
                      return self.ripe.undo();
                    });
                    this.$bus.bind("redo", function () {
                      return self.ripe.redo();
                    });
                    this.$bus.bind("start_over", function () {
                      return self.ripe.undoAll();
                    }); // listens for any model change and triggers the
                    // 'model_changed' event on the owner, so that it's
                    // possible to be notified at any level about this
                    // data driven operations

                    this.$store.watch(this.$store.getters.getModelState, function (modelState) {
                      return manager.trigger("model_changed", modelState);
                    }, {
                      deep: true
                    }); // registers a watch operation on the theme
                    // to be used in UI presentation layer

                    this.$store.watch(this.$store.getters.getTheme, function (theme) {
                      return manager.trigger("theme_changed", theme);
                    }); // registers a watch operation on the (image) format field of
                    // the data store so that the change is propagated to the ripe
                    // instance and then to the user interface

                    this.$store.watch(this.$store.getters.getFormat, function (format) {
                      return _this4.$bus.trigger("format_change", format);
                    }); // registers a watch operation on the (image) resolution field of
                    // the data store so that the change is propagated to the ripe
                    // instance and then to the user interface

                    this.$store.watch(this.$store.getters.getResolution, function (resolution) {
                      return _this4.$bus.trigger("size_change", resolution);
                    }); // registers a watch operation on the (image) background color field of
                    // the data store so that the change is propagated to the ripe
                    // instance and then to the user interface

                    this.$store.watch(this.$store.getters.getBackgroundColor, function (backgroundColor) {
                      return _this4.$bus.trigger("background_color_change", backgroundColor);
                    }); // registers a watch operation on all options and state updates
                    // so sync the RIPE instance accordingly

                    this.$store.watch(this.$store.getters.getRipeOptions, /*#__PURE__*/function () {
                      var _ref6 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee13(ripeOptions) {
                        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee13$(_context13) {
                          while (1) {
                            switch (_context13.prev = _context13.next) {
                              case 0:
                                _context13.next = 2;
                                return self.setRipeOptions(ripeOptions);

                              case 2:
                                return _context13.abrupt("return", _context13.sent);

                              case 3:
                              case "end":
                                return _context13.stop();
                            }
                          }
                        }, _callee13);
                      }));

                      return function (_x7) {
                        return _ref6.apply(this, arguments);
                      };
                    }());
                    this.$store.watch(this.$store.getters.getRipeState, /*#__PURE__*/function () {
                      var _ref7 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee14(ripeState) {
                        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee14$(_context14) {
                          while (1) {
                            switch (_context14.prev = _context14.next) {
                              case 0:
                                _context14.next = 2;
                                return self.setRipeOptions(ripeState);

                              case 2:
                                return _context14.abrupt("return", _context14.sent);

                              case 3:
                              case "end":
                                return _context14.stop();
                            }
                          }
                        }, _callee14);
                      }));

                      return function (_x8) {
                        return _ref7.apply(this, arguments);
                      };
                    }()); // register for the change on locale setting from the store
                    // so that the change locale even is triggered allowing the
                    // change of the locale through the application

                    this.$store.watch(function (state) {
                      return state.locale;
                    }, function (locale) {
                      return manager.trigger("locale_change", locale);
                    });
                  }
                });
                app.logInfo(function () {
                  return "RIPE Commons application initializing...";
                });
                return _context15.abrupt("return", app);

              case 5:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function _initVueApp(_x6) {
        return _initVueApp2.apply(this, arguments);
      }

      return _initVueApp;
    }()
  }, {
    key: "_handleCritical",
    value: function () {
      var _handleCritical2 = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.mark(function _callee16(err) {
        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_11___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                alert(err.message ? err.message : String(err));

              case 1:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function _handleCritical(_x9) {
        return _handleCritical2.apply(this, arguments);
      }

      return _handleCritical;
    }()
  }], [{
    key: "_field",
    value:
    /**
     * Static method that retrieve the value of the field for the
     * provided URL or query string, if provided otherwise uses
     * the current URL query for the field retrieval.
     *
     * @param {String} name The name of the query string field to
     * retrieve the value.
     * @param {String/URLSearchParams} url The URL string or the URL
     * search param structure to be used in parsing.
     * @param {Object} fallback The default value to be returned in case it's
     * not possible to find a valid field for the provided name.
     * @param {Boolean} sequence If the returned value should be a sequence or
     * if instead the first element should be returned.
     * @param {String} type The type of the returned value as a string value
     * (eg: int, float, bool, list, tuple), should comply with the Yonius
     * standard set of types.
     * @returns {String} The value for the requested field name.
     */
    function _field(name) {
      var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var sequence = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      query = query || new URLSearchParams(window.location.search);
      var params = query.getAll(name);

      if (params.length === 0) {
        return fallback;
      }

      var castToType = Object(yonius__WEBPACK_IMPORTED_MODULE_17__["_castR"])(type) || function (v) {
        return v;
      };

      if (sequence === null) sequence = params.length > 1;
      return sequence ? params.map(function (p) {
        return castToType(p);
      }) : castToType(params[0]);
    }
  }]);

  return RipeCommonsMainPlugin;
}(_abstract__WEBPACK_IMPORTED_MODULE_19__[/* RipeCommonsPlugin */ "b"]);

var DynamicComponent = /*#__PURE__*/function () {
  function DynamicComponent(componentClass) {
    var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        parent = _ref8.parent,
        props = _ref8.props,
        _ref8$injectionPoint = _ref8.injectionPoint,
        injectionPoint = _ref8$injectionPoint === void 0 ? document.body : _ref8$injectionPoint;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_5___default()(this, DynamicComponent);

    injectionPoint = typeof injectionPoint === "string" ? document.body.querySelector(injectionPoint) : injectionPoint;
    this.componentClass = componentClass;
    this.injectionPoint = injectionPoint;
    this.parent = parent;
    this.props = props;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_6___default()(DynamicComponent, [{
    key: "mount",
    value: function mount() {
      var ExtendedClass = vue__WEBPACK_IMPORTED_MODULE_13___default.a.extend(this.componentClass);
      this.component = new ExtendedClass({
        parent: this.parent,
        propsData: this.props
      });
      this.component.$mount();
      this.element = this.injectionPoint.appendChild(this.component.$el);
    }
  }, {
    key: "unmount",
    value: function unmount() {
      if (this.element) this.element.remove();
      if (this.component) this.component.$destroy();
    }
  }]);

  return DynamicComponent;
}();

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],staticClass:"alert",style:(_vm.style),on:{"click":_vm.onClick}},[_c('global-events',{on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.handleGlobal($event)}}}),_vm._v(" "),_c('div',{staticClass:"alert-content"},[_vm._v("\n            "+_vm._s(_vm.textData)+"\n        ")])],1)])}
var staticRenderFns = []



/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(312);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button",class:_vm.classes,on:{"click":_vm.onClick}},[_c('loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader",attrs:{"loader":"ball-scale-multiple","loader-style":_vm.loaderStyle}}),_vm._v(" "),(!_vm.loading)?_vm._t("default",[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")]):_vm._e()],2)}
var staticRenderFns = []



/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(314);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"button button-no-style button-platforme",class:{ loading: _vm.loading },on:{"click":_vm.click}},[_c('loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"loader",attrs:{"loader":"ball-scale-multiple","loader-style":_vm.loaderStyle}}),_vm._v(" "),(_vm.logo)?_c('span',{staticClass:"button-logo"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"src":__webpack_require__(315)}})]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"button-text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []



/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(317);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icon)?_c('div',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.svgFile)},on:{"click":_vm.onClick}}):_vm._e()}
var staticRenderFns = []



/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 7.786V6h2.056v.857H7.703v.929H7zm0 2.857v2.714h.667v-2.714H7zm0 5.571V18h2.056v-.857h-1.39v-.929H7zM11.278 6h2.11v.857h-2.11V6zm4.333 0v.857h.722v.929H17V6h-1.389zm-4.333 11.143h2.11V18h-2.11v-.857zm5.055 0h-.722V18H17v-1.786h-.667v.929zm0-6.5v2.714H17v-2.714h-.667z\" fill=\"#57626E\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.571 16h-.798a.332.332 0 01-.224-.073.446.446 0 01-.128-.184l-.713-1.931h-3.422l-.713 1.931a.392.392 0 01-.123.179.33.33 0 01-.223.078h-.799l3.05-8h1.043l3.05 8zm-2.15-2.97l-1.198-3.255A6.89 6.89 0 0112 9.027a6.176 6.176 0 01-.23.754l-1.197 3.249h2.848z\" fill=\"#57626E\"/></svg>");

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.23 6.193c.488.254.813.76.874 1.331l.325 3.57c-2.905 1.393-5.953 1.393-8.797 0l.325-3.57c.04-.57.387-1.077.874-1.33.488-.275 1.056-.254 1.544.042a3.213 3.213 0 003.312 0 1.604 1.604 0 011.544-.043z\" fill=\"#57626E\"/><path d=\"M12 13.184c1.748 0 3.494-.443 5.18-1.309 2.439.613 3.82 1.605 3.82 2.767C21 16.817 16.368 18 12 18s-9-1.183-9-3.358c0-1.162 1.381-2.154 3.82-2.767 1.686.866 3.432 1.31 5.18 1.31z\" fill=\"#57626E\"/></svg>");

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 6h.7v12H5V6zm13.3 0v12h.7V6h-.7z\" fill=\"#57626E\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.911 16h.839l-3.203-8h-1.095L8.25 16h.838a.357.357 0 00.235-.078.392.392 0 00.128-.179l.75-1.931h3.593l.748 1.931a.44.44 0 00.135.184.36.36 0 00.234.073zm-2.677-6.225l1.258 3.255h-2.99l1.257-3.25c.082-.2.162-.451.24-.753a6.584 6.584 0 00.235.748z\" fill=\"#57626E\"/></svg>");

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 4.8H7V4h10v.8z\" fill=\"#57626E\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.571 16h-.798a.333.333 0 01-.223-.073.445.445 0 01-.128-.184l-.713-1.931h-3.423l-.713 1.931a.392.392 0 01-.123.179.33.33 0 01-.223.078h-.798l3.05-8h1.043l3.05 8zm-2.15-2.97l-1.197-3.255A6.898 6.898 0 0112 9.027a6.29 6.29 0 01-.229.754l-1.197 3.249h2.847z\" fill=\"#57626E\"/><path d=\"M7 19.2v.8h10v-.8H7z\" fill=\"#57626E\"/></svg>");

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.503 19.95V4.051l6.494 15.897h-6.494zM12.5 4.051c0-1.143 1.493-1.464 1.922-.414l6.495 15.897c.283.694-.202 1.465-.92 1.465h-6.495c-.554 0-1.002-.47-1.002-1.05V4.051z\" fill=\"#57626E\"/><path d=\"M9.577 3.638c.429-1.05 1.922-.729 1.922.414V19.95c0 .58-.448 1.051-1.002 1.051H4.003c-.72 0-1.204-.771-.92-1.465L9.576 3.638z\" fill=\"#57626E\"/></svg>");

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M4.05 13.503h15.898L4.05 19.997v-6.494zM19.949 12.5c1.143 0 1.464 1.493.414 1.922L4.465 20.918C3.77 21.2 3 20.716 3 19.998v-6.495c0-.554.47-1.002 1.05-1.002h15.898z\" fill=\"#57626E\"/><path d=\"M20.362 9.577c1.05.429.729 1.922-.414 1.922H4.05C3.47 11.5 3 11.051 3 10.497V4.003c0-.72.771-1.204 1.465-.92l15.897 6.494z\" fill=\"#57626E\"/></svg>");

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" aria-labelledby=\"ellypsisVerticalIconTitle ellypsisVerticalIconDesc\" stroke=\"#000\" stroke-width=\"3\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M11 12a1 1 0 112 0 1 1 0 01-2 0zm0-6a1 1 0 112 0 1 1 0 01-2 0zm0 12a1 1 0 112 0 1 1 0 01-2 0z\"/></svg>");

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(648);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"image",class:_vm.classes,style:(_vm.style),attrs:{"src":_vm.srcData,"alt":_vm.alt},on:{"load":_vm.onLoad,"click":_vm.onClick,"error":_vm.onError}})}
var staticRenderFns = []



/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(650);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader",class:_vm.loader},_vm._l((_vm.count),function(index){return _c('div',{key:index,style:(_vm.loaderStyle)})}),0)}
var staticRenderFns = []



/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"image",staticClass:"thumbnail",class:{ active: _vm.active, loaded: _vm.loaded },attrs:{"alt":_vm.name,"src":""},on:{"click":_vm.showFrame,"load":_vm.onLoaded}})}
var staticRenderFns = []



/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(654);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ask"},[_c('modal',{ref:"modal",staticClass:"modal",attrs:{"visible":true}},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.titleData))]),_vm._v(" "),_c('div',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.messageHtml)}}),_vm._v(" "),_c('div',{staticClass:"buttons-container"},[_c('div',{staticClass:"buttons"},[(_vm.buttonCancelData)?_c('button-ripe',{staticClass:"button button-color button-ask-cancel",attrs:{"disabled":_vm.loading},on:{"click":_vm.onCancelClick}},[_vm._v("\n                    "+_vm._s(_vm.buttonCancelData)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.buttonConfirmData)?_c('button-ripe',{staticClass:"button button-color button-color-secondary button-ask-confirm",attrs:{"loading":_vm.loading},on:{"click":_vm.onConfirmClick}},[_vm._v("\n                    "+_vm._s(_vm.buttonConfirmData)+"\n                ")]):_vm._e()],1)])])],1)}
var staticRenderFns = []



/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deviceMixin; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);


function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DEVICE_CLASS = "device";
var MOUSE_CLASS = "mouse";
var TOUCH_CLASS = "touch";
var DESKTOP_SIZE_CLASS = "desktop";
var TABLET_SIZE_CLASS = "tablet";
var MOBILE_SIZE_CLASS = "mobile";
var DESKTOP_DEVICE_CLASS = "desktop-device";
var TABLET_DEVICE_CLASS = "tablet-device";
var MOBILE_DEVICE_CLASS = "mobile-device";
var TABLET_WIDTH = 768;
var MOBILE_WIDTH = 420;
var TABLET_DEVICE_REGEX = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i;
var MOBILE_DEVICE_PREFIX_REGEX = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
var MOBILE_DEVICE_REGEX = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i;
var deviceMixin = {
  computed: {
    tabletWidth: function tabletWidth() {
      return this._tabletWidth || TABLET_WIDTH;
    },
    mobileWidth: function mobileWidth() {
      return this._mobileWidth || MOBILE_WIDTH;
    },
    isMobile: function isMobile() {
      return this._isMobileDevice(navigator.userAgent);
    },
    isTablet: function isTablet() {
      return this._isTabletDevice(navigator.userAgent);
    },
    isDevice: function isDevice() {
      return this.isMobile || this.isTablet;
    },
    isDesktop: function isDesktop() {
      return !this.isDevice;
    },
    isTouch: function isTouch() {
      return this.isDevice;
    },
    isMouse: function isMouse() {
      return this.isDesktop;
    },
    isDesktopWidth: function isDesktopWidth() {
      return this.windowWidth > this.tabletWidth;
    },
    isTabletWidth: function isTabletWidth() {
      return this.windowWidth > this.mobileWidth && this.windowWidth <= this.tabletWidth;
    },
    isMobileWidth: function isMobileWidth() {
      return this.windowWidth <= this.mobileWidth;
    }
  },
  data: function data() {
    return {
      userAgent: null,
      windowWidth: null,
      windowHeight: null
    };
  },
  methods: {
    initDevice: function initDevice() {
      this.listenSize();
      this.updateBase();
      this.updateSize();
      this.updateDevice();
    },
    listenSize: function listenSize() {
      var _this = this;

      window.addEventListener("resize", function () {
        return _this.updateSize();
      });
    },
    updateBase: function updateBase() {
      var body = document.body;
      this.$root.$device = this;
      body.classList.add("init");
    },
    updateDevice: function updateDevice() {
      var body = document.body;
      this.userAgent = navigator.userAgent;
      if (this.isMobile) body.classList.add(MOBILE_DEVICE_CLASS);
      if (this.isTablet) body.classList.add(TABLET_DEVICE_CLASS);
      if (this.isDevice) body.classList.add(DEVICE_CLASS);
      if (this.isDesktop) body.classList.add(DESKTOP_DEVICE_CLASS);
      if (this.isTouch) body.classList.add(TOUCH_CLASS);
      if (this.isMouse) body.classList.add(MOUSE_CLASS);
    },
    updateSize: function updateSize() {
      var body = document.body;
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
      body.classList.remove(DESKTOP_SIZE_CLASS);
      body.classList.remove(TABLET_SIZE_CLASS);
      body.classList.remove(MOBILE_SIZE_CLASS);
      if (this.isDesktopWidth) body.classList.add(DESKTOP_SIZE_CLASS);
      if (this.isTabletWidth) body.classList.add(TABLET_SIZE_CLASS);
      if (this.isMobileWidth) body.classList.add(MOBILE_SIZE_CLASS);

      var _iterator = _createForOfIteratorHelper(this.widthBreakpoints || []),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var widthBreakpoint = _step.value;

          var _widthBreakpoint = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(widthBreakpoint, 2),
              name = _widthBreakpoint[0],
              range = _widthBreakpoint[1];

          var minWidth = range[0] || 0;
          var maxWidth = range[1] || 65536;
          body.classList.remove(name);

          if (this.windowWidth >= minWidth && this.windowWidth <= maxWidth) {
            body.classList.add(name);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.heightBreakpoints || []),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var heightBreakpoint = _step2.value;

          var _heightBreakpoint = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(heightBreakpoint, 2),
              _name = _heightBreakpoint[0],
              _range = _heightBreakpoint[1];

          var minHeight = _range[0] || 0;
          var maxHeight = _range[1] || 65536;
          body.classList.remove(_name);

          if (this.windowHeight >= minHeight && this.windowHeight <= maxHeight) {
            body.classList.add(_name);
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    },
    setTabletWidth: function setTabletWidth(width) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._tabletWidth = width;
      if (update) this.updateDevice();
    },
    setMobileWidth: function setMobileWidth(width) {
      var update = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this._mobileWidth = width;
      if (update) this.updateDevice();
    },
    addWidthBreakpoint: function addWidthBreakpoint(name) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      this.widthBreakpoints = this.widthBreakpoints || [];
      this.widthBreakpoints.push([name, range]);
    },
    removeWidthBreakpoint: function removeWidthBreakpoint(name) {
      this.widthBreakpoints = this.widthBreakpoints || [];
      this.widthBreakpoints = this.widthBreakpoints.filter(function (v) {
        return v[0] !== name;
      });
      document.body.classList.remove(name);
    },
    addHeightBreakpoint: function addHeightBreakpoint(name) {
      var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      this.heightBreakpoints = this.heightBreakpoints || [];
      this.heightBreakpoints.push([name, range]);
    },
    removeHeightBreakpoint: function removeHeightBreakpoint(name) {
      this.heightBreakpoints = this.heightBreakpoints || [];
      this.heightBreakpoints = this.heightBreakpoints.filter(function (v) {
        return v[0] !== name;
      });
      document.body.classList.remove(name);
    },
    _isMobileDevice: function _isMobileDevice(data) {
      var prefix = data.substr(0, 4);
      var mobile = MOBILE_DEVICE_REGEX.test(data);
      var mobilePrefix = MOBILE_DEVICE_PREFIX_REGEX.test(prefix);
      var isMobile = mobile || Boolean(mobilePrefix);
      return isMobile;
    },
    _isTabletDevice: function _isTabletDevice(data) {
      var prefix = data.substr(0, 4);
      var tablet = TABLET_DEVICE_REGEX.test(data);
      var tabletPrefix = MOBILE_DEVICE_PREFIX_REGEX.test(prefix);
      var isTablet = tablet || Boolean(tabletPrefix);
      return isTablet && !this._isMobileDevice(data);
    }
  }
};

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return localeMixin; });
var localeMixin = {
  computed: {
    __localeModel: function __localeModel() {
      return this.manager.pluginsName.ModelLocaleResolverPlugin;
    }
  },
  methods: {
    localeModel: function localeModel(part, material, color, options) {
      options = Object.assign({
        part: part,
        material: material
      }, options);

      if (!this.__localeModel) {
        return options.defaultValue || "";
      }

      if (color) {
        return this.__localeModel.localeColor(color, options);
      } else if (material) {
        return this.__localeModel.localeMaterial(material, options);
      } else if (part) {
        return this.__localeModel.localePart(part, options);
      }
    },
    localeModelProperty: function localeModelProperty(name, type, options) {
      options = Object.assign({
        type: type
      }, options);

      if (!this.__localeModel) {
        return options.defaultValue || "";
      }

      return this.__localeModel.localeProperty(name, options);
    },
    localeEngraving: function localeEngraving(engraving) {
      var _this = this;

      var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
      if (!this.config || !this.config.initials) return engraving;

      var _this$$ripe$parseEngr = this.$ripe.parseEngraving(engraving, this.config.initials.properties),
          values = _this$$ripe$parseEngr.values;

      return values.map(function (property) {
        return _this.localeModelProperty(property.name, property.type);
      }).filter(function (localizedProperty) {
        return localizedProperty.length;
      }).join(separator);
    }
  }
};

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modalMixin; });
var modalMixin = {
  data: function data() {
    return {
      modalComponent: null,
      modalOptions: {
        name: "",
        visible: false,
        overlayLeave: true
      }
    };
  },
  mounted: function mounted() {
    // tries to find the first modal component that is a child
    // of the current component (if any)
    this.modalComponent = this.$children.find(function (child) {
      return child.constructor.options.name === "modal";
    }); // in case it was not possible to find a valid modal under
    // the direct children list then an exception is raised as
    // the modal mixin would not work under such conditions

    if (!this.modalComponent) {
      throw Error("No modal component found in component children");
    }

    this.modalComponent.options = this.modalOptions;
    this.modalComponent.$on("hide", this.hideModal);
    this.modalComponent.$on("show", this.showModal);
    this.modalComponent.$on("key_pressed", this.modalKeyPressed);
    this.modalComponent.$on("before_enter", this.modalBeforeEnter);
    this.modalComponent.$on("enter", this.modalEnter);
    this.modalComponent.$on("after_enter", this.modalAfterEnter);
    this.modalComponent.$on("enter_cancelled", this.modalEnterCancelled);
    this.modalComponent.$on("before_leave", this.modalBeforeLeave);
    this.modalComponent.$on("leave", this.modalLeave);
    this.modalComponent.$on("after_leave", this.modalAfterLeave);
    this.modalComponent.$on("leave_cancelled", this.modalLeaveCancelled);
  },
  watch: {
    modalOptions: function modalOptions() {
      this.modalComponent.options = this.modalOptions;
    }
  },
  methods: {
    showModal: function showModal() {
      var show = this.willShowModal.apply(this, arguments);
      if (show !== false) this.modalOptions.visible = true;
    },
    hideModal: function hideModal() {
      var hide = this.willHideModal.apply(this, arguments);
      if (hide !== false) this.modalOptions.visible = false;
    },
    willShowModal: function willShowModal() {
      return true;
    },
    willHideModal: function willHideModal() {
      return true;
    },
    modalShown: function modalShown() {},
    modalHidden: function modalHidden() {},
    modalKeyPressed: function modalKeyPressed(key) {},
    modalBeforeEnter: function modalBeforeEnter() {},
    modalEnter: function modalEnter() {},
    modalAfterEnter: function modalAfterEnter() {
      this.modalShown();
    },
    modalEnterCancelled: function modalEnterCancelled() {},
    modalBeforeLeave: function modalBeforeLeave() {},
    modalLeave: function modalLeave() {},
    modalAfterLeave: function modalAfterLeave() {
      this.modalHidden();
    },
    modalLeaveCancelled: function modalLeaveCancelled() {}
  }
};

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return partMixin; });
var partMixin = {
  methods: {
    isMobile: function isMobile() {
      return this.$root.$device && this.$root.$device.isMobile;
    },
    isTablet: function isTablet() {
      return this.$root.$device && this.$root.$device.isTablet;
    },
    isDevice: function isDevice() {
      return this.$root.$device && this.$root.$device.isDevice;
    },
    isDesktop: function isDesktop() {
      return this.$root.$device && this.$root.$device.isDesktop;
    },
    isTouch: function isTouch() {
      return this.$root.$device && this.$root.$device.isTouch;
    },
    isMouse: function isMouse() {
      return this.$root.$device && this.$root.$device.isMouse;
    },
    isDesktopWidth: function isDesktopWidth() {
      return this.$root.$device && this.$root.$device.isDesktopWidth;
    },
    isTabletWidth: function isTabletWidth() {
      return this.$root.$device && this.$root.$device.isTabletWidth;
    },
    isMobileWidth: function isMobileWidth() {
      return this.$root.$device && this.$root.$device.isMobileWidth;
    }
  }
};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(656);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,_vm._g(_vm._b({tag:"component"},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []



/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"keyboard"},[_c('div',{staticClass:"keyboard-keys"},_vm._l((_vm.parsedKeys),function(row,index){return _c('div',{key:index,staticClass:"keyboard-row"},_vm._l((row),function(key){return _c('div',{key:key.name,staticClass:"keyboard-key",class:[_vm.keyType(key), key.name, { active: _vm.isActive(key) }],on:{"click":function () { return _vm.keyPressed(key); }}},[(_vm.keyType(key) === 'alphanumeric')?_c('span',[_vm._v(_vm._s(key.name))]):_c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.keyImage(key)}}),_vm._v(" "),_c('div',{staticClass:"border"})]),_vm._v(" "),(key.label)?_c('p',{staticClass:"label"},[_vm._v("\n                    "+_vm._s(key.label)+"\n                ")]):_vm._e()])}),0)}),0)])}
var staticRenderFns = []



/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(660);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"after-enter":_vm.afterEnter,"enter-cancelled":_vm.enterCancelled,"before-leave":_vm.beforeLeave,"leave":_vm.leave,"after-leave":_vm.afterLeave,"leave-cancelled":_vm.leaveCancelled}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],class:'modal' + (_vm.name ? ' modal-' + _vm.name : ''),attrs:{"id":_vm.name ? 'modal-' + _vm.name : null}},[_c('global-events',{on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.hide($event)}}}),_vm._v(" "),_c('div',{staticClass:"modal-overlay",on:{"click":function () { return _vm.overlayLeave && _vm.hide(false); }}}),_vm._v(" "),_c('div',{ref:"container",staticClass:"modal-container"},[_c('div',{staticClass:"modal-header"},[_vm._t("header",[_c('div',{staticClass:"button button-close",on:{"click":function () { return _vm.hide(false); }}},[_c('img',{attrs:{"src":__webpack_require__(661)}})])])],2),_vm._v(" "),_c('div',{staticClass:"modal-content"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_vm._t("footer")],2)])],1)])}
var staticRenderFns = []



/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(663);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"restrictions-alert"},[_c('div',{staticClass:"message-restrictions-alert-container"},[_c('div',{staticClass:"message-restrictions-alert",class:{ visible: _vm.visible }},[_c('div',{staticClass:"button-container"},[_c('a',{staticClass:"button button-restrictions-alert",on:{"click":_vm.undo}},[_vm._v("\n                    "+_vm._s(_vm.locale("ripe_commons.restrictions_alert.restrictions_alert"))+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"button button-back",on:{"click":_vm.close}},[_vm._v("\n                    "+_vm._s(_vm.locale("ripe_commons.restrictions_alert.close_button"))+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"message-container"},[_c('span',[_vm._v("\n                    "+_vm._s(_vm.locale("ripe_commons.restrictions_alert.limited"))+"\n                    "+_vm._s(_vm.locale("ripe_commons.restrictions_alert.back"))+"\n                ")])])])])])}
var staticRenderFns = []



/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(665);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab",class:{ active: _vm.active },on:{"click":function () { return _vm.$emit('selected'); }}},[_vm._t("default",[_c('h1',{staticClass:"default"},[_vm._v(_vm._s(_vm.locale(_vm.tab.title)))])])],2)}
var staticRenderFns = []



/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(667);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tabs"},[_c('div',{staticClass:"background"}),_vm._v(" "),_c('div',{staticClass:"tabs-container"},_vm._l((_vm.tabs),function(tab){return _c('tab',{key:tab.id,ref:tab.id,refInFor:true,attrs:{"tab":tab,"active":tab.id === _vm.activeTab},on:{"selected":function () { return _vm.selectTab(tab.id); }}},[_vm._t("default",null,{"tab":tab})],2)}),1)])}
var staticRenderFns = []



/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(669);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"thumbnailsContainer",staticClass:"thumbnails"},_vm._l((_vm.thumbnails),function(thumbnail){return _c('thumbnail',{key:_vm.thumbnailKey(thumbnail),attrs:{"frame":((thumbnail.face) + "-" + (thumbnail.frame)),"name":thumbnail.name,"size":_vm.size,"crop":_vm.crop}})}),1)}
var staticRenderFns = []



/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('initials-images',{ref:"thumbnailsContainer",staticClass:"thumbnails thumbnails-groups",attrs:{"brand":_vm.brand,"model":_vm.model,"active-group":_vm.activeGroup,"groups":_vm.groups,"initials-builder":_vm.__initialsBuilder},on:{"image-selected":_vm.onImageSelected}})}
var staticRenderFns = []



/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(671);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator-container"},[(_vm.loading)?_c('div',{staticClass:"loader-container"},[(_vm.loading)?_vm._t("loader",[_c('loader',{staticClass:"loader",attrs:{"loader":'ball-scale-multiple'}})]):_vm._e()],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"configurator-wrapper",class:{ loading: _vm.loading, 'loading-error': Boolean(_vm.loadingError) }},[_c('div',{ref:"configurator",staticClass:"config"}),_vm._v(" "),(_vm.modelError && !_vm.loadingError)?_c('div',{staticClass:"error"},[_vm._v("\n            Error loading model "+_vm._s(_vm.model)+" from brand "+_vm._s(_vm.brand)),_c('br'),_vm._v("\n            "+_vm._s(_vm.errorMessage ? _vm.errorMessage : "")+"\n        ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"holder",class:{ disappear: _vm.hideHolder }},[_c('div',{staticClass:"holder-label"},[_vm._v("\n                "+_vm._s(_vm.locale("ripe_commons.holder.holder.label"))+"\n            ")]),_vm._v(" "),_c('img',{staticClass:"holder-image",attrs:{"src":__webpack_require__(672)}}),_vm._v(" "),_c('div',{staticClass:"holder-second-label"},[_vm._v("\n                "+_vm._s(_vm.locale("ripe_commons.holder.holder-second-label.label"))+"\n            ")])])])])}
var staticRenderFns = []



/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(674);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hidden),expression:"!hidden"}],staticClass:"personalization",class:[_vm.brand, _vm.model, { disabled: !_vm.enabled }]},[_c('div',{staticClass:"button button-color button-personalization",class:{ disabled: !_vm.enabled },on:{"click":_vm.showModal}},[_c('h3',[_vm._v(_vm._s(_vm.locale("ripe_commons.personalization.personalization")))]),_vm._v(" "),_c('p',{staticClass:"button-text"},[_vm._v("\n            "+_vm._s(_vm.locale(_vm.buttonText))+"\n        ")])]),_vm._v(" "),_c('modal',{ref:"modal"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.enabled),expression:"enabled"}]},[_c('h3',{staticClass:"title"},[_vm._v("\n                "+_vm._s(_vm.locale("ripe_commons.personalization.personalization"))+"\n            ")]),_vm._v(" "),(_vm.form)?_c(_vm.form,{key:_vm.formKey,ref:"form",tag:"component",attrs:{"valid":_vm.valid},on:{"update:valid":function($event){_vm.valid=$event},"changed":_vm.formChanged,"hook:mounted":_vm.formMounted}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"buttons-container"},[_vm._t("buttons",[_c('div',{staticClass:"button button-color button-color-secondary button-cancel",on:{"click":_vm.hideModal}},[_vm._v("\n                        "+_vm._s(_vm.locale("ripe_commons.modal.cancel"))+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"button button-color button-apply",class:_vm.buttonApplyClasses,on:{"click":_vm.apply}},[_vm._v("\n                        "+_vm._s(_vm.locale("ripe_commons.modal.apply"))+"\n                    ")])],null,{ valid: _vm.valid })],2)],1)])],1)}
var staticRenderFns = []



/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(676);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"pickersContainer",staticClass:"pickers",class:{ 'multiple-materials': _vm.multipleMaterials, loading: _vm.loading },attrs:{"data-part":_vm.activePart,"data-material":_vm.activeMaterial,"data-color":_vm.activeColor}},[_c('div',{staticClass:"background"}),_vm._v(" "),_c('div',{staticClass:"parts-wrapper"},[(_vm.enableScrollParts)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollParts),expression:"scrollParts"}],staticClass:"button-scroll button-scroll-left button-scroll-parts button-scroll-parts-left",on:{"click":_vm.slideLeftParts}}):_vm._e(),_vm._v(" "),_c('ul',{ref:"partsPicker",staticClass:"parts-container"},[_vm._t("before-buttons-parts",_vm._l((_vm.beforeButtonsParts),function(button){return _c('li',{key:button.id,staticClass:"part button button-part button-before-buttons-parts",class:_vm.buttonPartsClasses(button),on:{"click":function (event) { return _vm.onButtonPartClick(button.event, event); }}},[_vm._t(("button-before-buttons-parts-" + (button.id)),[_c('p',{staticClass:"label"},[_vm._v("\n                            "+_vm._s(button.label)+"\n                        ")])])],2)})),_vm._v(" "),_vm._l((_vm.filteredOptions),function(materials,part){return _c('li',{key:part,staticClass:"part button button-part",class:{
                    active: _vm.activePart === part,
                    optional: _vm.isOptional(part),
                    selected: _vm.selectedColor(part) && _vm.selectedColor(part).color
                },attrs:{"data-part":part},on:{"click":function () { return _vm.selectPart(part); }}},[_c('p',{staticClass:"label"},[_vm._v("\n                    "+_vm._s(_vm.localeModel(part))+"\n                ")]),_vm._v(" "),(_vm.selectedColor(part) && _vm.selectedColor(part).color)?_c('div',{staticClass:"swatch"},[_c('img',{attrs:{"src":_vm.partSwatch(part)}})]):(_vm.isOptional(part))?_c('p',{staticClass:"no-part"},[_vm._v("\n                    "+_vm._s(_vm.localeModel(part, "no_" + part))+"\n                ")]):_vm._e()])}),_vm._v(" "),_vm._t("after-buttons-parts",_vm._l((_vm.afterButtonsParts),function(button){return _c('li',{key:button.id,staticClass:"part button button-part button-after-buttons-parts",class:_vm.buttonPartsClasses(button),on:{"click":function (event) { return _vm.onButtonPartClick(button.event, event); }}},[_vm._t(("button-after-buttons-parts-" + (button.id)),[_c('p',{staticClass:"label"},[_vm._v("\n                            "+_vm._s(button.label)+"\n                        ")])])],2)})),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.enableScrollParts)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollParts),expression:"scrollParts"}],staticClass:"button-scroll button-scroll-right button-scroll-parts button-scroll-parts-right",on:{"click":_vm.slideRightParts}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"materials-wrapper"},[(_vm.enableScrollMaterials)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollMaterial),expression:"scrollMaterial"}],staticClass:"button-scroll button-scroll-left button-scroll-materials button-scroll-materials-left",on:{"click":_vm.slideLeftMaterials}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"},on:{"after-enter":_vm.onMaterialsChanged,"after-leave":_vm.onMaterialsChanged}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.activePart !== null),expression:"activePart !== null"}],ref:"materialsPicker",staticClass:"materials-container",class:{ hidden: !_vm.multipleMaterials && _vm.activeMaterial !== null }},_vm._l((_vm.materialOptions),function(colors,material){return _c('li',{key:material,staticClass:"material button button-material",class:{ active: _vm.activeMaterial === material },attrs:{"data-material":material,"data-part":_vm.activePart},on:{"click":function () { return _vm.selectMaterial(material); }}},[_c('p',[_vm._v(_vm._s(_vm.localeModel(_vm.activePart, material)))])])}),0)]),_vm._v(" "),(_vm.enableScrollMaterials)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollMaterial),expression:"scrollMaterial"}],staticClass:"button-scroll button-scroll-right button-scroll-materials button-scroll-materials-right",on:{"click":_vm.slideRightMaterials}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"colors-wrapper"},[(_vm.enableScrollColors)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollColor),expression:"scrollColor"}],staticClass:"button-scroll button-scroll-left button-scroll-colors button-scroll-colors-left",on:{"click":_vm.slideLeftColors}}):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeMaterial !== null),expression:"activeMaterial !== null"}],ref:"colorsPicker",staticClass:"colors-container"},[_c('transition-group',{ref:"colorsList",attrs:{"name":"list"},on:{"after-enter":_vm.onColorsAnimationAfterEnter}},_vm._l((_vm.colorOptions),function(colorOption){return _c('li',{key:colorOption.material + ':' + colorOption.color,staticClass:"color button button-color-option",class:{
                            active: _vm.isSelected(colorOption),
                            optional: _vm.isOptional(_vm.activePart),
                            'no-option': colorOption.color.startsWith('no_')
                        },attrs:{"data-index":colorOption.index,"data-material":colorOption.material,"data-part":_vm.activePart,"data-color":colorOption.color},on:{"click":function () { return _vm.onColorClick(colorOption); }}},[_c('div',{staticClass:"swatch"},[(colorOption.color.startsWith('no_') === false)?_c('img',{attrs:{"src":_vm.colorSwatch(colorOption.material, colorOption.color)}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"border"})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.colorOptionText(colorOption)))])])}),0)],1)]),_vm._v(" "),(_vm.enableScrollColors)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollColor),expression:"scrollColor"}],staticClass:"button-scroll button-scroll-right button-scroll-colors button-scroll-colors-right",on:{"click":_vm.slideRightColors}}):_vm._e()],1),_vm._v(" "),_c('restrictions-alert')],1)}
var staticRenderFns = []



/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(678);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"size",class:{ disabled: !_vm.enabled }},[_c('div',{staticClass:"button button-color button-size",class:_vm.buttonClasses,on:{"click":_vm.showModal}},[_c('span',[_vm._v(_vm._s(_vm.buttonText))])]),_vm._v(" "),_c('modal',{ref:"modal"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.enabled),expression:"enabled"}]},[_c(_vm.form,{key:_vm.formKey,ref:"form",tag:"component",attrs:{"active":_vm.active},on:{"update:active":function($event){_vm.active=$event},"changed":_vm.sizeChanged}}),_vm._v(" "),_c('div',{staticClass:"buttons-container"},[_c('button-ripe',{staticClass:"button button-color button-color-secondary button-cancel",on:{"click":_vm.hideModal}},[_vm._v("\n                    "+_vm._s(_vm.locale("ripe_commons.modal.cancel"))+"\n                ")]),_vm._v(" "),_c('button-ripe',{staticClass:"button button-color button-color-secondary button-apply",class:{ invalid: !_vm.allowApply },on:{"click":_vm.apply}},[_c('span',[_vm._v(_vm._s(_vm.locale("ripe_commons.modal.select")))])])],1)],1)])],1)}
var staticRenderFns = []



/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(683);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"global"},[_vm._t("before"),_vm._v(" "),_c('alert'),_vm._v(" "),_c('ask',{attrs:{"global":true}}),_vm._v(" "),_vm._t("after")],2)}
var staticRenderFns = []



/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Money; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

var Money = {};
Money.SYMBOLS = {
  EUR: ["€", 1],
  USD: ["$", -1],
  GBP: ["£", -1],
  BRL: ["R$", -1],
  CAD: ["$", -1],
  AUD: ["$", -1],
  JPY: ["¥", -1],
  RUB: ["₽", 1],
  KRW: ["₩", -1],
  CHF: ["fr.", 1],
  SGD: ["$", -1],
  MXN: ["$", -1],
  DKK: ["kr.", 1],
  SEK: ["kr.", 1],
  PLN: ["zł", 1]
};
Money.DECIMAL_PLACES = {
  EUR: 2,
  USD: 2,
  GBP: 2,
  BRL: 2,
  CAD: 2,
  AUD: 2,
  JPY: 0,
  RUB: 2,
  KRW: 0,
  CHF: 2,
  SGD: 2,
  MXN: 2,
  DKK: 2,
  SEK: 2,
  PLN: 2
};
Money.SEPARATOR = {
  EUR: ",",
  USD: ".",
  GBP: ".",
  BRL: ",",
  CAD: ".",
  AUD: ".",
  JPY: ".",
  RUB: ",",
  KRW: ".",
  CHF: ".",
  SGD: ".",
  MXN: ".",
  DKK: ".",
  SEK: ",",
  PLN: "."
};
Money.THOUSANDS = {
  EUR: " ",
  USD: ",",
  GBP: ",",
  BRL: ".",
  CAD: ",",
  AUD: ",",
  JPY: ",",
  RUB: " ",
  KRW: ",",
  CHF: ",",
  SGD: ",",
  MXN: ",",
  DKK: ",",
  SEK: ".",
  PLN: " "
};

Money._formatCurrency = function (money, currency, useSymbol) {
  var symbol = useSymbol ? Money.SYMBOLS[currency] : null;
  symbol = symbol || [currency, 1];
  var position = symbol[1];
  symbol = symbol[0];
  money = position === 1 ? money + " " + symbol : symbol + " " + money;
  return money;
};

Money.formatMoney = function (value, currency, places, separator, thousands, useSymbol) {
  if (value === null || value === undefined) {
    return "";
  }

  useSymbol = useSymbol === undefined ? true : useSymbol;
  var defaultPlaces = Money.DECIMAL_PLACES[currency];
  var defaultSeparator = Money.SEPARATOR[currency];
  var defaultThousands = Money.THOUSANDS[currency];
  defaultPlaces = defaultPlaces === undefined ? 2 : defaultPlaces;
  defaultSeparator = defaultSeparator === undefined ? "." : defaultSeparator;
  defaultThousands = defaultThousands === undefined ? "," : defaultThousands;
  places = isNaN(parseInt(places)) ? defaultPlaces : places;
  separator = separator === null || separator === undefined ? defaultSeparator : separator;
  thousands = thousands === null || thousands === undefined ? defaultThousands : thousands;
  var signal = value < 0 ? "-" : "";
  var integer = parseInt(Math.abs(+value || 0).toFixed(places)) + "";
  var remaining = integer.length;
  remaining = remaining > 3 ? remaining % 3 : 0;
  var money = signal;
  money += remaining ? integer.substr(0, remaining) + thousands : "";
  money += integer.substr(remaining).replace(/(\d{3})(?=\d)/g, "$1" + thousands);
  money += places ? separator + Math.abs(Math.abs(value) - integer).toFixed(places).slice(2) : "";
  money = currency ? Money._formatCurrency(money, currency, useSymbol) : money;
  return money;
};

vue__WEBPACK_IMPORTED_MODULE_0___default.a.filter("money", function (value, currency, places, separator, thousands, useSymbol) {
  return Money.formatMoney(value, currency, places, separator, thousands, useSymbol);
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return readable; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);

var readable = function readable(value) {
  if (!value) {
    return "";
  }

  value = value.toString();
  return value.split("_").join(" ");
};
vue__WEBPACK_IMPORTED_MODULE_0___default.a.filter("readable", readable);

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return busPlugin; });
/* harmony import */ var pluginus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25);
/* harmony import */ var pluginus__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pluginus__WEBPACK_IMPORTED_MODULE_0__);

var busPlugin = {
  install: function install(Vue) {
    var bus = new pluginus__WEBPACK_IMPORTED_MODULE_0__["Observable"]();
    Object.defineProperty(Vue.prototype, "$bus", {
      value: bus
    });
  }
};

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return localePlugin; });
var localePlugin = {
  install: function install(Vue, localePlugin) {
    var toLocale = function toLocale(value, defaultValue, locale) {
      var fallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      if (!value) return defaultValue || "";
      value = value.toString();
      defaultValue = defaultValue !== undefined ? defaultValue : value;
      return localePlugin.toLocale(value, defaultValue, locale, fallback);
    };

    Vue.mixin({
      data: function data() {
        return {
          currentLocale: null,
          localeMap: null
        };
      },
      computed: {
        locale: function locale() {
          var _this = this;

          return function (value, defaultValue) {
            var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var fallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            var fallbackValue = _this.localeMap && _this.localeMap[locale] ? _this.localeMap[locale][value] : undefined;
            return toLocale(value, defaultValue || fallbackValue, locale || _this.currentLocale, fallback);
          };
        }
      },
      mounted: function mounted() {
        var _this2 = this;

        localePlugin.owner.bind("post_set_locale", function (locale) {
          return _this2.currentLocale = locale;
        });
        localePlugin.owner.bind("locale_map_changed", function () {
          return _this2.localeMap = Object.assign({}, localePlugin.localeMap);
        });
        this.currentLocale = localePlugin.locale;
        this.localeMap = Object.assign({}, localePlugin.localeMap);
      }
    });
    Vue.filter("locale", function (value, defaultValue, locale) {
      var fallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      console.warn("Using 'locale' as a filter has been deprecated, please use it as a function instead.");
      return toLocale(value, defaultValue, locale, fallback);
    });
    Object.defineProperty(Vue.prototype, "$locale", {
      value: localePlugin
    });
  }
};

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ripePlugin; });
var ripePlugin = {
  install: function install(Vue, ripe) {
    Object.defineProperty(Vue.prototype, "$ripe", {
      value: ripe
    });
  }
};

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28);
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _js_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18);





function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


var store = {
  state: {
    ripeUrl: "",
    country: "",
    currency: "",
    locale: "",
    brand: "",
    model: "",
    dku: "",
    productId: "",
    variant: "",
    version: "",
    description: "",
    flag: "",
    format: "",
    resolution: "",
    backgroundColor: "",
    theme: null,
    parts: {},
    config: {},
    defaults: {},
    options: {},
    price: null,
    personalization: {
      initials: "",
      engraving: null,
      initialsExtra: {}
    },
    size: {},

    /**
     * If the size operations are active or if instead
     * they are inactive and no interactive actions
     * are available (eg: only one size available).
     */
    sizeActive: null,
    currentFrame: null,
    error: null,
    hasCustomization: false,
    hasPersonalization: false,
    hasSize: false,
    hasInitialsRadius: false,
    ripeOptions: {},
    ripeState: {},
    initialsGroups: null,
    initialsMinimumCharacters: null,
    initialsMaximumCharacters: null,
    initialsSupportedCharacters: null,
    initialsDataPromise: null
  },
  mutations: {
    ripeUrl: function ripeUrl(state, url) {
      state.ripeUrl = url;
    },
    model: function model(state, _model) {
      state.brand = _model.brand;
      state.model = _model.model;
      state.dku = _model.dku;
      state.productId = _model.product_id;
      state.variant = _model.variant;
      state.version = _model.version;
      state.description = _model.description;
      state.parts = _model.parts;
    },
    flag: function flag(state, _flag) {
      state.flag = _flag;
    },
    format: function format(state, _format) {
      state.format = _format;
    },
    resolution: function resolution(state, _resolution) {
      state.resolution = _resolution;
    },
    backgroundColor: function backgroundColor(state, _backgroundColor) {
      state.backgroundColor = _backgroundColor;
    },
    theme: function theme(state, _theme) {
      state.theme = _theme;
    },
    parts: function parts(state, _parts) {
      state.parts = Object.assign({}, _parts);
    },
    config: function config(state, _config) {
      _config = _config || {};
      var parts = _config.parts || [];
      var defaults = _config.defaults || {};
      var options = {};

      var _iterator = _createForOfIteratorHelper(parts),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var part = _step.value;
          var defaultPart = defaults[part.name] || {};

          if (defaultPart.hidden === true) {
            continue;
          }

          var partM = {};

          var _iterator2 = _createForOfIteratorHelper(part.materials),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var material = _step2.value;
              partM[material.name] = material.colors;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          options[part.name] = partM;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      state.config = _config;
      state.defaults = defaults;
      state.options = options;
      state.sync = _config.sync;
    },
    price: function price(state, _price) {
      state.price = _price;
    },
    personalization: function personalization(state, value) {
      var _initialsFromExtra = Object(_js_util__WEBPACK_IMPORTED_MODULE_4__[/* initialsFromExtra */ "d"])(value.initialsExtra, value.initials, value.engraving),
          initials = _initialsFromExtra.initials,
          engraving = _initialsFromExtra.engraving;

      state.personalization.initials = initials;
      state.personalization.engraving = engraving;
      state.personalization.initialsExtra = Object.assign({}, value.initialsExtra);
    },
    size: function size(state, value) {
      state.size = value;
    },
    sizeActive: function sizeActive(state, value) {
      state.sizeActive = value;
    },
    currency: function currency(state, _currency) {
      state.currency = _currency;
    },
    locale: function locale(state, _locale) {
      state.locale = _locale;
    },
    country: function country(state, _country) {
      state.country = _country;
    },
    orderNumber: function orderNumber(state, _orderNumber) {
      state.orderNumber = _orderNumber;
    },
    currentFrame: function currentFrame(state, _currentFrame) {
      state.currentFrame = _currentFrame;
    },
    error: function error(state, _error) {
      state.error = _error;
    },
    hasCustomization: function hasCustomization(state, _hasCustomization) {
      state.hasCustomization = _hasCustomization;
    },
    hasPersonalization: function hasPersonalization(state, _hasPersonalization) {
      state.hasPersonalization = _hasPersonalization;
    },
    hasSize: function hasSize(state, _hasSize) {
      state.hasSize = _hasSize;
    },
    hasInitialsRadius: function hasInitialsRadius(state, _hasInitialsRadius) {
      state.hasInitialsRadius = _hasInitialsRadius;
    },
    ripeOptions: function ripeOptions(state, _ripeOptions) {
      state.ripeOptions = _ripeOptions;
    },
    ripeState: function ripeState(state, _ripeState) {
      state.ripeState = _ripeState;
    },
    initialsGroups: function initialsGroups(state, _initialsGroups) {
      state.initialsGroups = _initialsGroups;
    },
    initialsMinimumCharacters: function initialsMinimumCharacters(state, _initialsMinimumCharacters) {
      state.initialsMinimumCharacters = _initialsMinimumCharacters;
    },
    initialsMaximumCharacters: function initialsMaximumCharacters(state, _initialsMaximumCharacters) {
      state.initialsMaximumCharacters = _initialsMaximumCharacters;
    },
    initialsSupportedCharacters: function initialsSupportedCharacters(state, _initialsSupportedCharacters) {
      state.initialsSupportedCharacters = _initialsSupportedCharacters;
    },
    clearInitialsData: function clearInitialsData(state) {
      state.initialsGroups = null;
      state.initialsSupportedCharacters = null;
    },
    initialsDataPromise: function initialsDataPromise(state, _initialsDataPromise) {
      state.initialsDataPromise = _initialsDataPromise;
    }
  },
  actions: {
    refreshInitialsData: function refreshInitialsData(_ref) {
      var _arguments = arguments,
          _this = this;

      return _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee5() {
        var state, commit, force, promise, _yield$promise, _yield$promise2, groups, supportedCharacters, minimumCharacters, maximumCharacters;

        return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                state = _ref.state, commit = _ref.commit;
                force = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;

                if (!state.initialsDataPromise) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", state.initialsDataPromise);

              case 4:
                if (!(state.initialsGroups && state.initialsSupportedCharacters && state.initialsMinimumCharacters && state.initialsMaximumCharacters && !force)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return");

              case 6:
                // runs the remote business logic to obtain the multiple
                // target groups available for initials as well as the
                // available characters for personalization, falling back
                // to default values if builds do not support remote
                // business logic (for the `groups` and `supported_characters`
                // "methods"), this is a naive implementation for the scenarios
                // where no server side logic exists for initials (supported_characters)
                promise = Promise.all([_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee() {
                  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.prev = 0;
                          _context.next = 3;
                          return _this._vm.$ripe.runLogicP({
                            method: "groups"
                          });

                        case 3:
                          return _context.abrupt("return", _context.sent);

                        case 6:
                          _context.prev = 6;
                          _context.t0 = _context["catch"](0);
                          return _context.abrupt("return", ["main"]);

                        case 9:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee, null, [[0, 6]]);
                }))(), _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee2() {
                  var supportedCharacters;
                  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          _context2.prev = 0;
                          _context2.next = 3;
                          return _this._vm.$ripe.runLogicP({
                            method: "supported_characters"
                          });

                        case 3:
                          supportedCharacters = _context2.sent;
                          return _context2.abrupt("return", _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_1___default()(supportedCharacters));

                        case 7:
                          _context2.prev = 7;
                          _context2.t0 = _context2["catch"](0);
                          return _context2.abrupt("return", ["abcdefghijklmnopqrstvwxyz"]);

                        case 10:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, null, [[0, 7]]);
                }))(), _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee3() {
                  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.prev = 0;
                          _context3.next = 3;
                          return _this._vm.$ripe.runLogicP({
                            method: "minimum_initials"
                          });

                        case 3:
                          return _context3.abrupt("return", _context3.sent);

                        case 6:
                          _context3.prev = 6;
                          _context3.t0 = _context3["catch"](0);
                          return _context3.abrupt("return", 0);

                        case 9:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3, null, [[0, 6]]);
                }))(), _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.mark(function _callee4() {
                  return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default.a.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          _context4.prev = 0;
                          _context4.next = 3;
                          return _this._vm.$ripe.runLogicP({
                            method: "maximum_initials"
                          });

                        case 3:
                          return _context4.abrupt("return", _context4.sent);

                        case 6:
                          _context4.prev = 6;
                          _context4.t0 = _context4["catch"](0);
                          return _context4.abrupt("return", Infinity);

                        case 9:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4, null, [[0, 6]]);
                }))()]); // stores the ongoing request so we avoid future redundant requests
                // this is critical due to performance reasons

                commit("initialsDataPromise", promise);
                _context5.prev = 8;
                _context5.next = 11;
                return promise;

              case 11:
                _yield$promise = _context5.sent;
                _yield$promise2 = _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_0___default()(_yield$promise, 4);
                groups = _yield$promise2[0];
                supportedCharacters = _yield$promise2[1];
                minimumCharacters = _yield$promise2[2];
                maximumCharacters = _yield$promise2[3];
                commit("initialsGroups", groups);
                commit("initialsSupportedCharacters", supportedCharacters);
                commit("initialsMinimumCharacters", Number(minimumCharacters));
                commit("initialsMaximumCharacters", Number(maximumCharacters));

              case 21:
                _context5.prev = 21;
                // releases the "lock" controlled by the initials data promise, so that
                // future remote requests can go on
                commit("initialsDataPromise", null);
                return _context5.finish(21);

              case 24:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[8,, 21, 24]]);
      }))();
    }
  },
  getters: {
    getParts: function getParts(state) {
      return function () {
        return state.parts;
      };
    },
    getModelState: function getModelState(state) {
      return function () {
        return {
          dku: state.dku,
          product_id: state.productId,
          brand: state.brand,
          model: state.model,
          variant: state.variant,
          version: state.version,
          flag: state.flag,
          format: state.format,
          resolution: state.resolution,
          background_color: state.backgroundColor,
          gender: state.gender,
          scale: state.scale,
          personalization: state.personalization,
          size: state.size,
          parts: state.parts
        };
      };
    },
    getOrderInfo: function getOrderInfo(state) {
      return function () {
        var orderInfo = {
          dku: state.dku,
          product_id: state.productId,
          brand: state.brand,
          model: state.model,
          gender: state.gender,
          scale: state.size.scale,
          size: state.size.size,
          variant: state.variant,
          version: state.version,
          parts: state.parts,
          country: state.country,
          currency: state.currency,
          store: state.store,
          account: state.account,
          customer: state.customerId
        };

        if (state.personalization.initials) {
          orderInfo.engraving = state.personalization.engraving;
          orderInfo.initials = state.personalization.initials;
          orderInfo.initials_extra = state.personalization.initialsExtra;
        }

        return orderInfo;
      };
    },
    getCurrentFrame: function getCurrentFrame(state) {
      return function () {
        return state.currentFrame;
      };
    },
    getConfig: function getConfig(state) {
      return function () {
        return state.config;
      };
    },
    getFormat: function getFormat(state) {
      return function () {
        return state.format;
      };
    },
    getResolution: function getResolution(state) {
      return function () {
        return state.resolution;
      };
    },
    getBackgroundColor: function getBackgroundColor(state) {
      return function () {
        return state.backgroundColor;
      };
    },
    getTheme: function getTheme(state) {
      return function () {
        return state.theme;
      };
    },
    getRipeOptions: function getRipeOptions(state) {
      return function () {
        return state.ripeOptions;
      };
    },
    getRipeState: function getRipeState(state) {
      return function () {
        return state.ripeState;
      };
    },
    priceCurrency: function priceCurrency(state) {
      return state.price && state.price.total ? state.price.total.currency : null;
    },
    priceFinal: function priceFinal(state) {
      return state.price && state.price.total ? state.price.total.price_final : null;
    },
    thumbnails: function thumbnails(state) {
      return state.config ? state.config.thumbnails || [] : [];
    }
  }
};
/* unused harmony default export */ var _unused_webpack_default_export = (store);

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(247);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _base__WEBPACK_IMPORTED_MODULE_0__["c"]; });



/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFavicon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setFavicon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return waitP; });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1__);


var getFavicon = function getFavicon() {
  var link = document.getElementById("favicon");
  return link.href;
};
var setFavicon = function setFavicon(src) {
  var link = document.createElement("link");
  var oldLink = document.getElementById("favicon");
  link.id = "favicon";
  link.rel = "shortcut icon";
  link.href = src;

  if (oldLink) {
    document.head.removeChild(oldLink);
  }

  document.head.appendChild(link);
};
var waitP = /*#__PURE__*/function () {
  var _ref = _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0___default()( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.mark(function _callee(timeout) {
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_1___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Promise(function (resolve) {
              setTimeout(function () {
                return resolve();
              }, timeout);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function waitP(_x) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),
/* 248 */
/***/ (function(module) {

module.exports = JSON.parse("{\"ripe_commons.holder.holder.label\":\"Drag\",\"ripe_commons.holder.holder-second-label.label\":\"3D\",\"ripe_commons.modal.cancel\":\"Cancel\",\"ripe_commons.modal.apply\":\"Apply\",\"ripe_commons.modal.select\":\"Select\",\"ripe_commons.group.main\":\"Main\",\"ripe_commons.group.left\":\"Left\",\"ripe_commons.group.right\":\"Right\",\"ripe_commons.group.front\":\"Front\",\"ripe_commons.group.back\":\"Back\",\"ripe_commons.group.side\":\"Side\",\"ripe_commons.properties.font\":\"Font\",\"ripe_commons.properties.font_size\":\"Font Size\",\"ripe_commons.properties.style\":\"Style\",\"ripe_commons.properties.position\":\"Position\",\"ripe_commons.properties.color\":\"Color\",\"ripe_commons.restrictions_alert.restrictions_alert\":\"Undo\",\"ripe_commons.restrictions_alert.back_button\":\"Back\",\"ripe_commons.restrictions_alert.close_button\":\"Close\",\"ripe_commons.restrictions_alert.limited\":\"This option is limited to specific material or colour combinations.\",\"ripe_commons.restrictions_alert.back\":\"Do you want to go back?\",\"ripe_commons.personalization.personalization\":\"Personalisation\",\"ripe_commons.personalization.add_initials\":\"Add initials\",\"ripe_commons.personalization.group\":\"Group\",\"ripe_commons.personalization.initials\":\"Initials\",\"ripe_commons.personalization.select.style\":\"Select the style\",\"ripe_commons.personalization.select.font\":\"Select the font\",\"ripe_commons.personalization.select.font_size\":\"Select the font size\",\"ripe_commons.personalization.select.position\":\"Select the position\",\"ripe_commons.personalization.select.color\":\"Select the color\",\"ripe_commons.size.size\":\"Size\",\"ripe_commons.size.select_size\":\"Select size\",\"ripe_commons.size.male\":\"Male\",\"ripe_commons.size.female\":\"Female\",\"ripe_commons.size.male.small\":\"M\",\"ripe_commons.size.female.small\":\"F\"}");

/***/ }),
/* 249 */
/***/ (function(module) {

module.exports = JSON.parse("{\"ripe_commons.holder.holder.label\":\"ドラッグ\",\"ripe_commons.holder.holder-second-label.label\":\"3D\",\"ripe_commons.modal.cancel\":\"キャンセル\",\"ripe_commons.modal.apply\":\"申し込み\",\"ripe_commons.modal.select\":\"申し込み\",\"ripe_commons.group.main\":\"メイン\",\"ripe_commons.group.left\":\"左\",\"ripe_commons.group.right\":\"正しい\",\"ripe_commons.group.front\":\"前面\",\"ripe_commons.group.back\":\"バック\",\"ripe_commons.group.side\":\"側\",\"ripe_commons.properties.font\":\"フォント\",\"ripe_commons.properties.font_size\":\"フォントサイズ\",\"ripe_commons.properties.style\":\"スタイル\",\"ripe_commons.properties.position\":\"位置\",\"ripe_commons.properties.color\":\"色\",\"ripe_commons.restrictions_alert.restrictions_alert\":\"元に戻る\",\"ripe_commons.restrictions_alert.back_button\":\"バック\",\"ripe_commons.restrictions_alert.close_button\":\"閉じる\",\"ripe_commons.restrictions_alert.limited\":\"選りすぐりの素材、またはカラーのコンビネーションの限定オプション\",\"ripe_commons.restrictions_alert.back\":\"戻りますか？\",\"ripe_commons.personalization.personalization\":\"パーソナライゼーション\",\"ripe_commons.personalization.add_initials\":\"イニシャルを追加\",\"ripe_commons.personalization.group\":\"グループ\",\"ripe_commons.personalization.initials\":\"イニシャル\",\"ripe_commons.personalization.select.style\":\"スタイルを選択\",\"ripe_commons.personalization.select.font\":\"フォントを選択してください\",\"ripe_commons.personalization.select.font_size\":\"フォントサイズを選択します\",\"ripe_commons.personalization.select.position\":\"位置を選択してください\",\"ripe_commons.personalization.select.color\":\"色を選択してください\",\"ripe_commons.size.size\":\"サイズ\",\"ripe_commons.size.select_size\":\"サイズ\",\"ripe_commons.size.male\":\"男性\",\"ripe_commons.size.female\":\"女性\",\"ripe_commons.size.male.small\":\"男性\",\"ripe_commons.size.female.small\":\"女性\"}");

/***/ }),
/* 250 */
/***/ (function(module) {

module.exports = JSON.parse("{\"ripe_commons.holder.holder.label\":\"拖动\",\"ripe_commons.holder.holder-second-label.label\":\"3D\",\"ripe_commons.modal.cancel\":\"取消\",\"ripe_commons.modal.apply\":\"采用\",\"ripe_commons.modal.select\":\"采用\",\"ripe_commons.group.main\":\"主要\",\"ripe_commons.group.left\":\"左\",\"ripe_commons.group.right\":\"右\",\"ripe_commons.group.front\":\"面前\",\"ripe_commons.group.back\":\"背部\",\"ripe_commons.group.side\":\"侧\",\"ripe_commons.properties.font\":\"字体\",\"ripe_commons.properties.font_size\":\"字体大小\",\"ripe_commons.properties.style\":\"样式\",\"ripe_commons.properties.position\":\"位置\",\"ripe_commons.properties.color\":\"颜色\",\"ripe_commons.restrictions_alert.restrictions_alert\":\"复原\",\"ripe_commons.restrictions_alert.back_button\":\"背部\",\"ripe_commons.restrictions_alert.close_button\":\"关\",\"ripe_commons.restrictions_alert.limited\":\"此选项仅限于特定材料或颜色组合\",\"ripe_commons.restrictions_alert.back\":\"返回上一页?\",\"ripe_commons.personalization.personalization\":\"个性化定制\",\"ripe_commons.personalization.add_initials\":\"专属刻字\",\"ripe_commons.personalization.group\":\"组\",\"ripe_commons.personalization.initials\":\"首字母\",\"ripe_commons.personalization.select.style\":\"选择样式\",\"ripe_commons.personalization.select.font\":\"选择字体\",\"ripe_commons.personalization.select.font_size\":\"选择字体大小\",\"ripe_commons.personalization.select.position\":\"选择职位\",\"ripe_commons.personalization.select.color\":\"选择颜色\",\"ripe_commons.size.size\":\"尺码\",\"ripe_commons.size.select_size\":\"尺码\",\"ripe_commons.size.male\":\"男\",\"ripe_commons.size.female\":\"女\",\"ripe_commons.size.male.small\":\"男\",\"ripe_commons.size.female.small\":\"女\"}");

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * vue-global-events v1.2.1
 * (c) 2020 Damian Dulisz <damian.dulisz@gmail.com>, Eduardo San Martin Morote <posva13@gmail.com>
 * @license MIT
 */

var _isIE;
function isIE () {
  return _isIE == null
    ? (_isIE = /msie|trident/.test(window.navigator.userAgent.toLowerCase()))
    : _isIE
}

var modifiersRE = /^[~!&]*/;
var nonEventNameCharsRE = /\W+/;
var names = {
  '!': 'capture',
  '~': 'once',
  '&': 'passive'
};

function extractEventOptions (eventDescriptor) {
  var ref = eventDescriptor.match(modifiersRE);
  var modifiers = ref[0];

  // IE only supports capture option and it has to be a boolean
  // https://github.com/shentao/vue-global-events/issues/14
  if (isIE()) {
    return modifiers.indexOf('!') > -1
  }

  return modifiers.split('').reduce(function (options, modifier) {
    options[names[modifier]] = true;
    return options
  }, {})
}

var index = {
  name: 'GlobalEvents',
  props: {
    target: {
      type: String,
      default: 'document'
    },
    filter: {
      type: Function,
      default: function (e) { return true; }
    }
  },

  // track keep-alive active state
  data: function () { return ({ isActive: true }); },
  activated: function activated () {
    this.isActive = true;
  },
  deactivated: function deactivated () {
    this.isActive = false;
  },

  render: function (h) { return h(); },

  mounted: function mounted () {
    var this$1 = this;

    this._listeners = Object.create(null);
    Object.keys(this.$listeners).forEach(function (event) {
      var listener = this$1.$listeners[event];
      var handler = function (e) {
        this$1.isActive && this$1.filter(e, listener, event) && listener(e);
      };
      window[this$1.target].addEventListener(
        event.replace(nonEventNameCharsRE, ''),
        handler,
        extractEventOptions(event)
      );
      this$1._listeners[event] = handler;
    });
  },

  beforeDestroy: function beforeDestroy () {
    var this$1 = this;

    for (var event in this$1._listeners) {
      window[this$1.target].removeEventListener(
        event.replace(nonEventNameCharsRE, ''),
        this$1._listeners[event],
        extractEventOptions(event)
      );
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {/**
 * Yonius 0.7.2.
 *
 * Copyright (c) 2008-2021 Hive Solutions Lda.
 *
 * This source code is licensed under the Apache 2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
(function (global, factory) {
     true ? factory(exports) :
    undefined;
}(this, (function (exports) { 'use strict';

    var name = "yonius";
    var version = "0.7.2";

    function _typeof(obj) {
      "@babel/helpers - typeof";

      if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
        _typeof = function (obj) {
          return typeof obj;
        };
      } else {
        _typeof = function (obj) {
          return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
      }

      return _typeof(obj);
    }

    function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
      try {
        var info = gen[key](arg);
        var value = info.value;
      } catch (error) {
        reject(error);
        return;
      }

      if (info.done) {
        resolve(value);
      } else {
        Promise.resolve(value).then(_next, _throw);
      }
    }

    function _asyncToGenerator(fn) {
      return function () {
        var self = this,
            args = arguments;
        return new Promise(function (resolve, reject) {
          var gen = fn.apply(self, args);

          function _next(value) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
          }

          function _throw(err) {
            asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
          }

          _next(undefined);
        });
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    function _createClass(Constructor, protoProps, staticProps) {
      if (protoProps) _defineProperties(Constructor.prototype, protoProps);
      if (staticProps) _defineProperties(Constructor, staticProps);
      return Constructor;
    }

    function _defineProperty(obj, key, value) {
      if (key in obj) {
        Object.defineProperty(obj, key, {
          value: value,
          enumerable: true,
          configurable: true,
          writable: true
        });
      } else {
        obj[key] = value;
      }

      return obj;
    }

    function ownKeys(object, enumerableOnly) {
      var keys = Object.keys(object);

      if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function (sym) {
          return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
      }

      return keys;
    }

    function _objectSpread2(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i] != null ? arguments[i] : {};

        if (i % 2) {
          ownKeys(Object(source), true).forEach(function (key) {
            _defineProperty(target, key, source[key]);
          });
        } else if (Object.getOwnPropertyDescriptors) {
          Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        } else {
          ownKeys(Object(source)).forEach(function (key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
          });
        }
      }

      return target;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          writable: true,
          configurable: true
        }
      });
      if (superClass) _setPrototypeOf(subClass, superClass);
    }

    function _getPrototypeOf(o) {
      _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      };
      return _getPrototypeOf(o);
    }

    function _setPrototypeOf(o, p) {
      _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
      };

      return _setPrototypeOf(o, p);
    }

    function _isNativeReflectConstruct() {
      if (typeof Reflect === "undefined" || !Reflect.construct) return false;
      if (Reflect.construct.sham) return false;
      if (typeof Proxy === "function") return true;

      try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
        return true;
      } catch (e) {
        return false;
      }
    }

    function _construct(Parent, args, Class) {
      if (_isNativeReflectConstruct()) {
        _construct = Reflect.construct;
      } else {
        _construct = function _construct(Parent, args, Class) {
          var a = [null];
          a.push.apply(a, args);
          var Constructor = Function.bind.apply(Parent, a);
          var instance = new Constructor();
          if (Class) _setPrototypeOf(instance, Class.prototype);
          return instance;
        };
      }

      return _construct.apply(null, arguments);
    }

    function _isNativeFunction(fn) {
      return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }

    function _wrapNativeSuper(Class) {
      var _cache = typeof Map === "function" ? new Map() : undefined;

      _wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !_isNativeFunction(Class)) return Class;

        if (typeof Class !== "function") {
          throw new TypeError("Super expression must either be null or a function");
        }

        if (typeof _cache !== "undefined") {
          if (_cache.has(Class)) return _cache.get(Class);

          _cache.set(Class, Wrapper);
        }

        function Wrapper() {
          return _construct(Class, arguments, _getPrototypeOf(this).constructor);
        }

        Wrapper.prototype = Object.create(Class.prototype, {
          constructor: {
            value: Wrapper,
            enumerable: false,
            writable: true,
            configurable: true
          }
        });
        return _setPrototypeOf(Wrapper, Class);
      };

      return _wrapNativeSuper(Class);
    }

    function _assertThisInitialized(self) {
      if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return self;
    }

    function _possibleConstructorReturn(self, call) {
      if (call && (typeof call === "object" || typeof call === "function")) {
        return call;
      }

      return _assertThisInitialized(self);
    }

    function _createSuper(Derived) {
      var hasNativeReflectConstruct = _isNativeReflectConstruct();

      return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;

        if (hasNativeReflectConstruct) {
          var NewTarget = _getPrototypeOf(this).constructor;

          result = Reflect.construct(Super, arguments, NewTarget);
        } else {
          result = Super.apply(this, arguments);
        }

        return _possibleConstructorReturn(this, result);
      };
    }

    function _superPropBase(object, property) {
      while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _getPrototypeOf(object);
        if (object === null) break;
      }

      return object;
    }

    function _get(target, property, receiver) {
      if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
      } else {
        _get = function _get(target, property, receiver) {
          var base = _superPropBase(target, property);

          if (!base) return;
          var desc = Object.getOwnPropertyDescriptor(base, property);

          if (desc.get) {
            return desc.get.call(receiver);
          }

          return desc.value;
        };
      }

      return _get(target, property, receiver || target);
    }

    function _slicedToArray(arr, i) {
      return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
    }

    function _toArray(arr) {
      return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
    }

    function _toConsumableArray(arr) {
      return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }

    function _arrayWithoutHoles(arr) {
      if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }

    function _arrayWithHoles(arr) {
      if (Array.isArray(arr)) return arr;
    }

    function _iterableToArray(iter) {
      if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
    }

    function _iterableToArrayLimit(arr, i) {
      if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"] != null) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    function _unsupportedIterableToArray(o, minLen) {
      if (!o) return;
      if (typeof o === "string") return _arrayLikeToArray(o, minLen);
      var n = Object.prototype.toString.call(o).slice(8, -1);
      if (n === "Object" && o.constructor) n = o.constructor.name;
      if (n === "Map" || n === "Set") return Array.from(o);
      if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }

    function _arrayLikeToArray(arr, len) {
      if (len == null || len > arr.length) len = arr.length;

      for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

      return arr2;
    }

    function _nonIterableSpread() {
      throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    function _nonIterableRest() {
      throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    function _createForOfIteratorHelper(o, allowArrayLike) {
      var it;

      if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
          if (it) o = it;
          var i = 0;

          var F = function () {};

          return {
            s: F,
            n: function () {
              if (i >= o.length) return {
                done: true
              };
              return {
                done: false,
                value: o[i++]
              };
            },
            e: function (e) {
              throw e;
            },
            f: F
          };
        }

        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }

      var normalCompletion = true,
          didErr = false,
          err;
      return {
        s: function () {
          it = o[Symbol.iterator]();
        },
        n: function () {
          var step = it.next();
          normalCompletion = step.done;
          return step;
        },
        e: function (e) {
          didErr = true;
          err = e;
        },
        f: function () {
          try {
            if (!normalCompletion && it.return != null) it.return();
          } finally {
            if (didErr) throw err;
          }
        }
      };
    }

    var Observable = /*#__PURE__*/function () {
      function Observable() {
        _classCallCheck(this, Observable);

        this.callbacks = {};
      }

      _createClass(Observable, [{
        key: "bind",
        value: function bind(event, callback) {
          var callbacks = this.callbacks[event] || [];
          callbacks.push(callback);
          this.callbacks[event] = callbacks;
          return callback;
        }
      }, {
        key: "unbind",
        value: function unbind(event, callback) {
          var callbacks = this.callbacks[event] || [];

          if (!callback) {
            delete this.callbacks[event];
            return;
          }

          var index = callbacks.indexOf(callback);

          if (index === -1) {
            return;
          }

          callbacks.splice(index, 1);
          this.callbacks[event] = callbacks;
        }
      }, {
        key: "trigger",
        value: function trigger(event) {
          var callbacks = this.callbacks[event] || [];
          var results = [];

          var _iterator = _createForOfIteratorHelper(callbacks),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var callback = _step.value;
              var result = callback.apply(this, Array.prototype.slice.call(arguments, 1));
              result !== undefined && result !== null && results.push(result);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return Promise.all(results);
        }
      }]);

      return Observable;
    }();

    var verify = function verify(condition) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var exception = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var kwargs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      if (condition) return;
      message = message || "Verification failed";
      var Exception = exception || Error;
      kwargs = Object.assign({}, kwargs);
      if (message !== null && message !== undefined) kwargs.message = message;
      if (code !== null && message !== undefined) kwargs.code = code;
      var throwable = new Exception(kwargs.message || undefined);
      throwable.kwargs = kwargs;

      for (var _i = 0, _Object$entries = Object.entries(kwargs); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        if (throwable[key] !== undefined) continue;
        throwable[key] = value;
      }

      throw throwable;
    };
    var verifyEqual = function verifyEqual(first, second) {
      var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var code = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var exception = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var kwargs = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      message = message || "Expected ".concat(first, " got ").concat(second);
      return this.verify(first === second, message, code, exception, kwargs);
    };
    var verifyNotEqual = function verifyNotEqual(first, second) {
      var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var code = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var exception = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
      var kwargs = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      message = message || "Expected ".concat(first, " not equal to ").concat(second);
      return this.verify(first !== second, message, code, exception, kwargs);
    };
    var verifyMany = function verifyMany(sequence) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var exception = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var kwargs = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
      sequence.forEach(function (element) {
        verify(element, message, code, exception, kwargs);
      });
    };

    const promises = {};

    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    // resolves . and .. elements in a path array with directory names there
    // must be no slashes, empty elements, or device names (c:\) in the array
    // (so also no leading and trailing slashes - it does not distinguish
    // relative and absolute paths)
    function normalizeArray(parts, allowAboveRoot) {
      // if the path tries to go above the root, `up` ends up > 0
      var up = 0;

      for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];

        if (last === '.') {
          parts.splice(i, 1);
        } else if (last === '..') {
          parts.splice(i, 1);
          up++;
        } else if (up) {
          parts.splice(i, 1);
          up--;
        }
      } // if the path is allowed to go above the root, restore leading ..s


      if (allowAboveRoot) {
        for (; up--; up) {
          parts.unshift('..');
        }
      }

      return parts;
    } // Split a filename into [root, dir, basename, ext], unix version
    // 'root' is just a slash, or nothing.


    var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;

    var splitPath = function splitPath(filename) {
      return splitPathRe.exec(filename).slice(1);
    }; // path.resolve([from ...], to)
    // posix version


    function resolve() {
      var resolvedPath = '',
          resolvedAbsolute = false;

      for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? arguments[i] : '/'; // Skip empty and invalid entries

        if (typeof path !== 'string') {
          throw new TypeError('Arguments to path.resolve must be strings');
        } else if (!path) {
          continue;
        }

        resolvedPath = path + '/' + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
      } // At this point the path should be resolved to a full absolute path, but
      // handle relative paths to be safe (might happen when process.cwd() fails)
      // Normalize the path


      resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function (p) {
        return !!p;
      }), !resolvedAbsolute).join('/');
      return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
    }
    // posix version

    function normalize(path) {
      var isPathAbsolute = isAbsolute(path),
          trailingSlash = substr(path, -1) === '/'; // Normalize the path

      path = normalizeArray(filter(path.split('/'), function (p) {
        return !!p;
      }), !isPathAbsolute).join('/');

      if (!path && !isPathAbsolute) {
        path = '.';
      }

      if (path && trailingSlash) {
        path += '/';
      }

      return (isPathAbsolute ? '/' : '') + path;
    }

    function isAbsolute(path) {
      return path.charAt(0) === '/';
    } // posix version

    function join() {
      var paths = Array.prototype.slice.call(arguments, 0);
      return normalize(filter(paths, function (p, index) {
        if (typeof p !== 'string') {
          throw new TypeError('Arguments to path.join must be strings');
        }

        return p;
      }).join('/'));
    } // path.relative(from, to)
    function dirname(path) {
      var result = splitPath(path),
          root = result[0],
          dir = result[1];

      if (!root && !dir) {
        // No dirname whatsoever
        return '.';
      }

      if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
      }

      return root + dir;
    }

    function filter(xs, f) {
      if (xs.filter) return xs.filter(f);
      var res = [];

      for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
      }

      return res;
    } // String.prototype.substr - negative index don't work in IE8


    var substr = 'ab'.substr(-1) === 'b' ? function (str, start, len) {
      return str.substr(start, len);
    } : function (str, start, len) {
      if (start < 0) start = str.length + start;
      return str.substr(start, len);
    };

    var global$1 = typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};

    var env = {};


    var performance = global$1.performance || {};

    performance.now || performance.mozNow || performance.msNow || performance.oNow || performance.webkitNow || function () {
      return new Date().getTime();
    }; // generate timestamp or delta

    var HOME_DIR = null;
    var pathExists = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(path) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return promises.access(path);

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", false);

              case 8:
                return _context.abrupt("return", true);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 5]]);
      }));

      return function pathExists(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var expandUser = function expandUser(path) {
      if (!path) return path;
      if (path === "~") return _homeDir();
      if (path.slice(0, 2) !== "~/") return path;
      return join(HOME_DIR, path.slice(2));
    };
    var getEnv = function getEnv(name) {
      // eslint-disable-next-line no-undef
      if (typeof Deno !== "undefined") return Deno.env.get(name);
      return env[name];
    };
    var getEnvObject = function getEnvObject() {
      // eslint-disable-next-line no-undef
      if (typeof Deno !== "undefined") return Deno.env.toObject();
      return env;
    };

    var _homeDir = function _homeDir() {
      if (HOME_DIR !== null) return HOME_DIR;
      var isWindows = Boolean(typeof process !== "undefined" && process.platform === "win32");
      HOME_DIR = getEnv(isWindows ? "USERPROFILE" : "HOME") || "/";
      return HOME_DIR;
    };

    var FILE_NAME = "yonius.json";
    var HOME_FILE = "~/.home";
    var IMPORT_NAMES = ["$import", "$include", "$IMPORT", "$INCLUDE"];
    var CASTS = {
      "int": function int(v) {
        return typeof v === "number" ? v : parseInt(v);
      },
      "float": function float(v) {
        return typeof v === "number" ? v : parseFloat(v);
      },
      bool: function bool(v) {
        return typeof v === "boolean" ? v : ["1", "true", "True"].includes(v);
      },
      list: function list(v) {
        return Array.isArray(v) ? v : v.split(";");
      },
      tuple: function tuple(v) {
        return Array.isArray(v) ? v : v.split(";");
      }
    };
    var globals = typeof global === "undefined" ? typeof window === "undefined" ? typeof self === "undefined" ? {} : self : window : global;
    globals.CONFIGS = globals.CONFIGS === undefined ? {} : globals.CONFIGS;
    globals.CONFIG_F = globals.CONFIG_F === undefined ? [] : globals.CONFIG_F;
    globals.HOMES = globals.HOMES === undefined ? [] : globals.HOMES;
    globals.LOADED = globals.LOADED === undefined ? false : globals.LOADED;
    var conf = function conf(name) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var cast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var ctx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var configs = ctx ? ctx.configs : globals.CONFIGS;
      cast = _castR(cast);
      var value = configs[name] === undefined ? fallback : configs[name];
      if (cast && value !== undefined && value !== null) value = cast(value);
      return value;
    };
    var confP = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
        var fallback,
            cast,
            ctx,
            _args = arguments;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fallback = _args.length > 1 && _args[1] !== undefined ? _args[1] : undefined;
                cast = _args.length > 2 && _args[2] !== undefined ? _args[2] : null;
                ctx = _args.length > 3 && _args[3] !== undefined ? _args[3] : null;
                _context.next = 5;
                return load();

              case 5:
                return _context.abrupt("return", conf(name, fallback, cast, ctx));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function confP(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var confS = function confS(name, value) {
      var ctx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var configs = ctx ? ctx.configs : globals.CONFIGS;
      configs[name] = value;
    };
    var load = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var names,
            path,
            encoding,
            force,
            ctx,
            paths,
            homes,
            _iterator,
            _step,
            home,
            _iterator2,
            _step2,
            _path,
            _iterator3,
            _step3,
            name,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                names = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : [FILE_NAME];
                path = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : null;
                encoding = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : "utf-8";
                force = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : false;
                ctx = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : null;

                if (!(globals.LOADED && !force)) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return");

              case 7:
                paths = [];
                _context2.next = 10;
                return getHomes();

              case 10:
                homes = _context2.sent;
                _iterator = _createForOfIteratorHelper(homes);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    home = _step.value;
                    paths = paths.concat([join(home), join(home, ".config")]);
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                paths.push(path);
                _iterator2 = _createForOfIteratorHelper(paths);
                _context2.prev = 15;

                _iterator2.s();

              case 17:
                if ((_step2 = _iterator2.n()).done) {
                  _context2.next = 38;
                  break;
                }

                _path = _step2.value;
                _iterator3 = _createForOfIteratorHelper(names);
                _context2.prev = 20;

                _iterator3.s();

              case 22:
                if ((_step3 = _iterator3.n()).done) {
                  _context2.next = 28;
                  break;
                }

                name = _step3.value;
                _context2.next = 26;
                return loadFile(name, _path, encoding, ctx);

              case 26:
                _context2.next = 22;
                break;

              case 28:
                _context2.next = 33;
                break;

              case 30:
                _context2.prev = 30;
                _context2.t0 = _context2["catch"](20);

                _iterator3.e(_context2.t0);

              case 33:
                _context2.prev = 33;

                _iterator3.f();

                return _context2.finish(33);

              case 36:
                _context2.next = 17;
                break;

              case 38:
                _context2.next = 43;
                break;

              case 40:
                _context2.prev = 40;
                _context2.t1 = _context2["catch"](15);

                _iterator2.e(_context2.t1);

              case 43:
                _context2.prev = 43;

                _iterator2.f();

                return _context2.finish(43);

              case 46:
                _context2.next = 48;
                return loadEnv(ctx);

              case 48:
                globals.LOADED = true;

              case 49:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[15, 40, 43, 46], [20, 30, 33, 36]]);
      }));

      return function load() {
        return _ref2.apply(this, arguments);
      };
    }();
    var loadFile = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var name,
            path,
            encoding,
            ctx,
            configs,
            configF,
            key,
            value,
            exists,
            filePath,
            basePath,
            data,
            dataJ,
            _i,
            _Object$entries,
            _Object$entries$_i,
            _args3 = arguments;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                name = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : FILE_NAME;
                path = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : null;
                encoding = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : "utf-8";
                ctx = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : null;
                configs = ctx ? ctx.configs : globals.CONFIGS;
                configF = ctx ? ctx.configF : globals.CONFIG_F;
                if (path) path = normalize(path);
                if (path) filePath = join(path, name);else filePath = name;
                filePath = resolve(filePath);
                filePath = normalize(filePath);
                basePath = dirname(filePath);
                _context3.next = 13;
                return pathExists(filePath);

              case 13:
                exists = _context3.sent;

                if (exists) {
                  _context3.next = 16;
                  break;
                }

                return _context3.abrupt("return");

              case 16:
                exists = configF.includes(filePath);
                if (exists) configF.splice(configF.indexOf(filePath), 1);
                configF.push(filePath);
                _context3.next = 21;
                return promises.readFile(filePath, {
                  encoding: encoding
                });

              case 21:
                data = _context3.sent;
                dataJ = JSON.parse(data);
                _context3.next = 25;
                return _loadIncludes(basePath, dataJ, encoding);

              case 25:
                _i = 0, _Object$entries = Object.entries(dataJ);

              case 26:
                if (!(_i < _Object$entries.length)) {
                  _context3.next = 36;
                  break;
                }

                _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2);
                key = _Object$entries$_i[0];
                value = _Object$entries$_i[1];

                if (_isValid(key)) {
                  _context3.next = 32;
                  break;
                }

                return _context3.abrupt("continue", 33);

              case 32:
                configs[key] = value;

              case 33:
                _i++;
                _context3.next = 26;
                break;

              case 36:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function loadFile() {
        return _ref3.apply(this, arguments);
      };
    }();
    var loadEnv = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var ctx,
            env,
            configs,
            _args4 = arguments;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                ctx = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : null;
                env = getEnvObject();
                configs = ctx ? ctx.configs : globals.CONFIGS;

                if (!(env === undefined || env === null)) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:
                Object.entries(env).forEach(function (_ref5) {
                  var _ref6 = _slicedToArray(_ref5, 2),
                      key = _ref6[0],
                      value = _ref6[1];

                  configs[key] = value;
                });

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function loadEnv() {
        return _ref4.apply(this, arguments);
      };
    }();
    var getHomes = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var filePath,
            fallback,
            encoding,
            forceDefault,
            env,
            exists,
            data,
            paths,
            _iterator4,
            _step4,
            path,
            _args5 = arguments;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                filePath = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : HOME_FILE;
                fallback = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : "~";
                encoding = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : "utf-8";
                forceDefault = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : false;

                if (!(globals.HOMES.length > 0)) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return", globals.HOMES);

              case 6:
                env = getEnvObject();
                globals.HOMES = env.HOMES === undefined ? null : env.HOMES;
                globals.HOMES = globals.HOMES ? globals.HOMES.split(";") : globals.HOMES;

                if (!(globals.HOMES !== null)) {
                  _context5.next = 11;
                  break;
                }

                return _context5.abrupt("return", globals.HOMES);

              case 11:
                fallback = expandUser(fallback);
                fallback = normalize(fallback);
                globals.HOMES = [fallback];
                filePath = expandUser(filePath);
                filePath = normalize(filePath);
                _context5.next = 18;
                return pathExists(filePath);

              case 18:
                exists = _context5.sent;

                if (exists) {
                  _context5.next = 21;
                  break;
                }

                return _context5.abrupt("return", globals.HOMES);

              case 21:
                if (!forceDefault) globals.HOMES.splice(0, globals.HOMES.length);
                _context5.next = 24;
                return promises.readFile(filePath, {
                  encoding: encoding
                });

              case 24:
                data = _context5.sent;
                data = data.trim();
                paths = data.split(/\r?\n/);
                paths = paths.map(function (v) {
                  return v.trim();
                });
                _iterator4 = _createForOfIteratorHelper(paths);
                _context5.prev = 29;

                _iterator4.s();

              case 31:
                if ((_step4 = _iterator4.n()).done) {
                  _context5.next = 41;
                  break;
                }

                path = _step4.value;
                path = path.trim();

                if (path) {
                  _context5.next = 36;
                  break;
                }

                return _context5.abrupt("continue", 39);

              case 36:
                path = expandUser(path);
                path = normalize(path);
                globals.HOMES.push(path);

              case 39:
                _context5.next = 31;
                break;

              case 41:
                _context5.next = 46;
                break;

              case 43:
                _context5.prev = 43;
                _context5.t0 = _context5["catch"](29);

                _iterator4.e(_context5.t0);

              case 46:
                _context5.prev = 46;

                _iterator4.f();

                return _context5.finish(46);

              case 49:
                return _context5.abrupt("return", globals.HOMES);

              case 50:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, null, [[29, 43, 46, 49]]);
      }));

      return function getHomes() {
        return _ref7.apply(this, arguments);
      };
    }();
    var _castR = function _castR(cast) {
      return CASTS[cast] === undefined ? cast : CASTS[cast];
    };
    var _loadIncludes = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(basePath, config) {
        var encoding,
            includes,
            _iterator5,
            _step5,
            alias,
            _iterator6,
            _step6,
            include,
            _args6 = arguments;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                encoding = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : "utf-8";
                includes = [];
                _iterator5 = _createForOfIteratorHelper(IMPORT_NAMES);

                try {
                  for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                    alias = _step5.value;
                    includes = config[alias] === undefined ? includes : config[alias];
                  }
                } catch (err) {
                  _iterator5.e(err);
                } finally {
                  _iterator5.f();
                }

                if (typeof includes === "string") {
                  includes = includes.split(";");
                }

                _iterator6 = _createForOfIteratorHelper(includes);
                _context6.prev = 6;

                _iterator6.s();

              case 8:
                if ((_step6 = _iterator6.n()).done) {
                  _context6.next = 14;
                  break;
                }

                include = _step6.value;
                _context6.next = 12;
                return loadFile(include, basePath, encoding);

              case 12:
                _context6.next = 8;
                break;

              case 14:
                _context6.next = 19;
                break;

              case 16:
                _context6.prev = 16;
                _context6.t0 = _context6["catch"](6);

                _iterator6.e(_context6.t0);

              case 19:
                _context6.prev = 19;

                _iterator6.f();

                return _context6.finish(19);

              case 22:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, null, [[6, 16, 19, 22]]);
      }));

      return function _loadIncludes(_x2, _x3) {
        return _ref8.apply(this, arguments);
      };
    }();
    var _isValid = function _isValid(key) {
      if (IMPORT_NAMES.includes(key)) return false;
      return true;
    };
    var _isDevel = function _isDevel() {
      return ["DEBUG"].includes(conf("LEVEL", "INFO"));
    };
    var _isSecure = function _isSecure() {
      return conf("SECURE", true, "bool");
    };

    /**
     * The map containing the various attribute alias between the normalized
     * manned and the Yonius manner.
     */
    var ALIAS = {
      context: "find_d",
      filters: "find_d",
      "filters[]": "find_d",
      filter_def: "find_d",
      filter_string: "find_s",
      filter_name: "find_n",
      filter_operator: "find_o",
      insensitive: "find_i",
      order: "sort",
      offset: "skip",
      start_record: "skip",
      number_records: "limit"
    };
    /**
     * The map associating the various find fields with their respective
     * types, note that in case a special conversion operation is required
     * the associated value may represent a conversion function instead.
     */

    var FIND_TYPES = {
      skip: function skip(v) {
        return parseInt(v);
      },
      limit: function limit(v) {
        return Math.max(0, parseInt(v));
      },
      find_s: function find_s(v) {
        return v;
      },
      find_d: function find_d(v) {
        return Array.isArray(v) ? v : [v];
      },
      find_i: function find_i(v) {
        return Boolean(v);
      },
      find_t: function find_t(v) {
        return v;
      },
      find_n: function find_n(v) {
        return v;
      },
      find_o: function find_o(v) {
        return v;
      },
      sort: function sort(v) {
        return _toSort(v);
      },
      meta: function meta(v) {
        return Boolean(v);
      },
      fields: function fields(v) {
        return v;
      }
    };
    /**
     * The map that defines the various default values for a series of
     * find related attributes.
     */

    var FIND_DEFAULTS = {
      limit: 10
    };
    /**
     * The map associating the normalized (text) way of representing sorting
     * with the current infra-structure number way of representing the same
     * information.
     */

    var SORT_MAP = {
      1: 1,
      "-1": -1,
      ascending: 1,
      descending: -1
    };
    var getObject = function getObject() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$alias = options.alias,
          alias = _options$alias === void 0 ? false : _options$alias,
          _options$page = options.page,
          page = _options$page === void 0 ? false : _options$page,
          _options$find = options.find,
          find = _options$find === void 0 ? false : _options$find,
          _options$norm = options.norm,
          norm = _options$norm === void 0 ? true : _options$norm;
      var result = params; // in case the alias flag is set tries to resolve the attribute alias and
      // in case the find types are set converts the find based attributes using
      // the currently defined mapping map

      if (alias) result = _resolveAlias(result);
      if (page) result = _pageTypes(result);

      if (find) {
        result = _findTypes(result);
        result = _findDefaults(result, options);
      } // in case the normalization flag is set runs the normalization of the
      // provided object so that sequences are properly handled as defined in
      // the specification (this allows multiple references)


      if (norm) result = _normParams(result); // returns the constructed object to the caller method this object
      // should be a structured representation of the data in the request

      return result;
    };

    var _resolveAlias = function _resolveAlias(params) {
      var result = {};
      Object.entries(params).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        result[ALIAS[key] || key] = value;
      });
      return result;
    };

    var _pageTypes = function _pageTypes(params) {
      var defaultSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
      var result = Object.assign({}, params);
      var page = parseInt(params.page || 1);
      var size = parseInt(params.size || defaultSize);
      var offset = page - 1;
      result.skip = offset * size;
      result.limit = size;
      var sorter = params.sorter;
      var direction = params.direction || "descending";
      if (sorter) result.sort = "".concat(sorter, ":").concat(direction);
      return result;
    };

    var _toSort = function _toSort(value) {
      var values = value.split(":", 2);
      if (values.length === 1) values.push("descending");

      var _values = _slicedToArray(values, 2),
          name = _values[0],
          direction = _values[1];

      if (name === "default") return null;
      values[1] = SORT_MAP[direction] || 1;
      return [values];
    };

    var _findTypes = function _findTypes(params) {
      var result = {};
      Object.entries(params).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        var converter = FIND_TYPES[key];
        var converted = converter ? converter(value) : value;
        result[key] = converted;
      });
      return result;
    };

    var _findDefaults = function _findDefaults(params) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var result = Object.assign({}, params);
      Object.entries(options).filter(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 1),
            key = _ref6[0];

        return FIND_TYPES[key];
      }).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            value = _ref8[1];

        result[key] = params[key] || value;
      });
      Object.entries(FIND_DEFAULTS).forEach(function (_ref9) {
        var _ref10 = _slicedToArray(_ref9, 2),
            key = _ref10[0],
            value = _ref10[1];

        result[key] = params[key] || value;
      });
      return result;
    };

    var _normParams = function _normParams(params) {
      var result = Object.assign({}, params); // iterates over all the key value association in the object,
      // trying to find the ones that refer sequences so that they
      // may be normalized

      for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
            key = _Object$entries$_i[0],
            value = _Object$entries$_i[1];

        // verifies if the current name references a sequence and
        // if that's not the case continues the loop trying to find
        // any other sequence based value
        if (!key.endsWith("[]")) {
          result[key] = value;
          continue;
        } // removes the extra sequence indication value


        var name = key.substring(0, key.length - 2); // in case the current value is not valid (empty) the object
        // is set with an empty list for the current iteration as this
        // is considered to be the default value

        if (!value) {
          result[name] = [];
          continue;
        } // retrieves the normalized and linearized list of leafs
        // for the current value and ten verifies the size of each
        // of its values and uses it to measure the number of
        // dictionary elements that are going to be contained in
        // the sequence to be "generated", then uses this (size)
        // value to pre-generate the complete set of dictionaries


        var leafs = _leafs(value);

        var _ref11 = leafs[0] || [null, []],
            _ref12 = _slicedToArray(_ref11, 2),
            values = _ref12[1];

        var list = values.map(function (_) {
          return {};
        }); // sets the list of generates dictionaries in the object for
        // the newly normalized name of structure

        result[name] = list; // iterates over the complete set of key value pairs in the
        // leafs list to gather the value into the various objects that
        // are contained in the sequence (normalization process)

        var _iterator = _createForOfIteratorHelper(leafs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
                _name = _step$value[0],
                _value = _step$value[1];

            for (var index; index < list.length; index++) {
              var object = list[index];

              var nameList = _name.split(".");

              _setObject(object, nameList, _value[index]);
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return result;
    };
    /**
     * Retrieves a list containing a series of tuples that each represent a
     * leaf of the current object structure. A leaf is the last element of an
     * object that is not a map, the other intermediary maps are considered to
     * be trunks and should be percolated recursively.
     * This is a recursive function that takes some memory for the construction
     * of the list, and so should be used with the proper care to avoid bottlenecks.
     *
     * @param {Object} params The object for which the leafs list structure is
     * meant to be retrieved.
     * @returns {Array} The list of leaf node tuples for the provided object,
     * as requested for each of the sequences.
     */


    var _leafs = function _leafs(params) {
      // the list that will hold the various leaf nodes "gathered" by
      // the current recursion function
      var result = []; // iterates over all the key and value relations in the object trying
      // to find the leaf nodes (no map nodes) creating a tuple of fqn
      // (fully qualified name) and value

      var _loop = function _loop() {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
            key = _Object$entries2$_i[0],
            value = _Object$entries2$_i[1];

        // retrieves the data type for the current value and validation
        // if it is a object or any other type in case it's an object a
        // new iteration step must be performed retrieving the leafs of
        // the value and then incrementing the name with the current prefix
        if (_typeof(value) === "object") {
          var leafs = _leafs(value).map(function (_ref13) {
            var _ref14 = _slicedToArray(_ref13, 2),
                name = _ref14[0],
                value = _ref14[1];

            return ["".concat(key, ".").concat(name), value];
          });

          result = Array.concat(result, leafs);
        } else {
          // otherwise this is a leaf node and so the leaf tuple node
          // must be constructed with the current value (properly validated
          // for sequence presence)
          result.push([key, Array.isArray(value) ? value : [value]]);
        }
      };

      for (var _i2 = 0, _Object$entries2 = Object.entries(params); _i2 < _Object$entries2.length; _i2++) {
        _loop();
      }

      return result;
    };
    /**
     * Sets a composite value in an object, allowing for dynamic setting of
     * random size key values.
     * This method is useful for situations where one wants to set a value
     * at a randomly defined depth inside an object without having to much
     * work with the creation of the inner dictionaries.
     *
     * @param {Object} object The target object that is going to be
     * changed and set with the target value.
     * @param {Array} nameList The list of names that defined the fully
     * qualified name to be used in the setting of the value
     * for example path.to.end will be a three size list containing each
     * of the partial names.
     * @param {Object} value The value that is going to be set in the
     * defined target of the object.
     */


    var _setObject = function _setObject(object, nameList, value) {
      // retrieves the first name in the names list this is the
      // value that is going to be used for the current iteration
      var _nameList$ = _toArray(nameList[0]),
          name = _nameList$[0],
          tail = _nameList$.slice(1); // in case the length of the current names list has reached
      // one this is the final iteration and so the value is set
      // at the current naming point


      if (nameList.length === 1) {
        object[name] = value;
      } else {
        // otherwise this is a "normal" step and so a new map must
        // be created/retrieved and the iteration step should be
        // performed on this new map as it's set on the current naming
        // place (recursion step)
        var map = object[name] || {};
        object[name] = map;

        _setObject(map, tail, value);
      }
    };

    var MixinBuilder = /*#__PURE__*/function () {
      function MixinBuilder(superclass) {
        _classCallCheck(this, MixinBuilder);

        this.superclass = superclass;
      }

      _createClass(MixinBuilder, [{
        key: "with",
        value: function _with() {
          for (var _len = arguments.length, mixins = new Array(_len), _key = 0; _key < _len; _key++) {
            mixins[_key] = arguments[_key];
          }

          return mixins.reduce(function (c, mixin) {
            return mixin(c);
          }, this.superclass);
        }
      }]);

      return MixinBuilder;
    }();
    var mix = function mix(superclass) {
      return new MixinBuilder(superclass);
    };

    var initMongo = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(mongoose, uri) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mongoose.set("useNewUrlParser", true);
                mongoose.set("useFindAndModify", false);
                mongoose.set("useCreateIndex", true);
                mongoose.set("useUnifiedTopology", true);
                _context.next = 6;
                return mongoose.connect(uri, {
                  useNewUrlParser: true,
                  useUnifiedTopology: true
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function initMongo(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    var destroyMongo = function destroyMongo(mongoose) {
      mongoose.disconnect();
    };

    var equal = function equal(first, second) {
      if (first === second) {
        return true;
      }

      if (typeof_(first) !== typeof_(second)) {
        return false;
      }

      if (isPrimitive(first) && isPrimitive(second)) {
        return first === second;
      }

      if (Object.keys(first).length !== Object.keys(second).length) {
        return false;
      }

      for (var key in first) {
        if (!(key in second)) return false;
        if (!equal(first[key], second[key])) return false;
      }

      return true;
    };
    var isPrimitive = function isPrimitive(object) {
      return object !== Object(object);
    };
    var typeof_ = function typeof_(object) {
      if (object === null) return "null";
      if (Array.isArray(object)) return "array";
      return _typeof(object);
    };

    var matchOperatorsRegex = /[|\\{}()[\]^$+*?.-]/g;
    var escapeStringRegexp = function escapeStringRegexp(string) {
      if (typeof string !== "string") {
        throw new TypeError("Expected a string");
      }

      return string.replace(matchOperatorsRegex, "\\$&");
    };

    /* The default minimum value meaning that this is the
    maximum value that one integer value may have for the
    size rounding operation to be performed */
    var DEFAULT_MINIMUM = 1024;
    /* The default number of places (digits) that are going
    to be used for the string representation in the round
    based conversion of size units to be performed */

    var DEFAULT_PLACES = 3;
    /* The size unit coefficient as an integer value, this is
    going to be used in each of the size steps as divisor */

    var SIZE_UNIT_COEFFICIENT = 1024;
    /* The simplified size units list that contains the complete set of
    units indexed by the depth they represent */

    var SIZE_UNITS_LIST_S = ["B", "K", "M", "G", "T", "P", "E", "Z", "Y"];
    /* The size units list that contains the complete set of
    units indexed by the depth they represent */

    var SIZE_UNITS_LIST = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    var sizeRoundUnit = function sizeRoundUnit(sizeValue) {
      var minimum = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_MINIMUM;
      var places = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_PLACES;
      var reduce = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var space = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var justify = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      var simplified = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var depth = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;

      // in case the current size value is acceptable (less than
      // the minimum) this is the final iteration and the final
      // string representation is going to be created
      if (sizeValue < minimum) {
        // calculates the maximum size of the string that is going
        // to represent the base size value as the number of places
        // plus one (representing the decimal separator character)
        var sizeS = places + 1; // calculates the target number of decimal places taking
        // into account the size (in digits) of the current size
        // value, this may never be a negative number

        var logValue = sizeValue && Math.log10(sizeValue);
        var digits = Math.trunc(logValue) + 1;
        places = places - digits;
        places = places > 0 ? places : 0; // rounds the size value, then converts the rounded
        // size value into a string based representation

        var sizeValueS = sizeValue.toFixed(places); // forces the reduce flag when the depth is zero, meaning
        // that an integer value will never be decimal, this is
        // required to avoid strange results for depth zero

        reduce = reduce || depth === 0; // in case the dot value is not present in the size value
        // string adds it to the end otherwise an issue may occur
        // while removing extra padding characters for reduce

        if (reduce && !sizeValueS.includes(".")) sizeValueS += "."; // strips the value from zero appended to the right and
        // then strips the value also from a possible decimal
        // point value that may be included in it, this is only
        // performed in case the reduce flag is enabled

        if (reduce) sizeValueS = sizeValueS.replace(/0+$/, "");
        if (reduce) sizeValueS = sizeValueS.replace(/\.$/, ""); // in case the justify flag is set runs the justification
        // process on the size value taking into account the maximum
        // size of the associated size string

        if (justify) sizeValueS = _rjust(sizeValueS, sizeS); // retrieves the size unit (string mode) for the current
        // depth according to the provided map

        var sizeUnit;
        if (simplified) sizeUnit = SIZE_UNITS_LIST_S[depth];else sizeUnit = SIZE_UNITS_LIST[depth]; // retrieves the appropriate separator based
        // on the value of the space flag

        var separator = space && " " || ""; // creates the size value string appending the rounded
        // size value string and the size unit and returns it
        // to the caller method as the size value string

        var sizeValueString = sizeValueS + separator + sizeUnit;
        return sizeValueString;
      } // otherwise the value is not acceptable and a new iteration
      // must be ran with one less depth of size value
      else {
          // re-calculates the new size value, increments the depth
          // and runs the size round unit again with the new values
          var newSizeValue = parseFloat(sizeValue) / SIZE_UNIT_COEFFICIENT;
          var newDepth = depth + 1;
          return sizeRoundUnit(newSizeValue, minimum, places, reduce, space, justify, simplified, newDepth);
        }
    };

    var _rjust = function _rjust(str, length) {
      var lengthToFill = length - str.length;
      return lengthToFill <= 0 ? str : " ".repeat(lengthToFill) + str;
    };

    var camelToUnderscore = function camelToUnderscore(value) {
      var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "_";
      if (!value) return value;
      return value.replace(/\.?([A-Z])/g, function (x, y) {
        return separator + y.toLowerCase();
      }).replace(RegExp("^" + separator), "");
    };

    /**
     * Encodes the multiple values as and encoded URI component, the
     * values can be wither defined as an array (order is preserved)
     * or as an object (where sequence order is not preserved).
     *
     * The value of each item can be either a primitive type or a sequence
     * in case it's of sequence the values are going to be encoded as
     * multiple parameters separated by the '&' character.
     *
     * @param {(Array|Object[])} values The values to be encoded as an
     * URI component (like GET params).
     * @returns {String} A string with the query encoded values.
     */

    var urlEncode = function urlEncode(values) {
      // constructs the parts array that is going to
      // store the multiple and values
      var parts = []; // in case the provided value is not an array
      // then assumes it's an object and retrieve entries

      if (!Array.isArray(values)) {
        values = Object.entries(values);
      } // iterates over the complete set of pairs available
      // from the key value pairs to be able to encode them
      // properly, notice that the values themselves can be
      // sequences allowing multiple repetition of key


      values.forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        if (!Array.isArray(value)) {
          value = [value];
        }

        var keyEncoded = encodeURIComponent(key);
        value.forEach(function (_value) {
          if (_value === undefined || _value === null) {
            return;
          }

          var valueEncoded = encodeURIComponent(_value);
          parts.push("".concat(keyEncoded, "=").concat(valueEncoded));
        });
      }); // joins the complete set of parts with the and
      // separator and then returns the final string value

      return parts.join("&");
    };
    var absoluteUrl = function absoluteUrl(path) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "BASE_URL";
      var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var baseUrl = conf(name, fallback);
      if (!baseUrl) return null;
      return "".concat(baseUrl).concat(path);
    };

    var YoniusError = /*#__PURE__*/function (_Error) {
      _inherits(YoniusError, _Error);

      var _super = _createSuper(YoniusError);

      function YoniusError(message) {
        var _this;

        var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

        _classCallCheck(this, YoniusError);

        _this = _super.call(this, message);
        _this.name = _this.constructor.name;
        _this.code = code;
        return _this;
      }

      _createClass(YoniusError, [{
        key: "isClient",
        get: function get() {
          return Math.floor(this.code / 100) === 4;
        }
      }, {
        key: "isServer",
        get: function get() {
          return Math.floor(this.code / 100) === 5;
        }
      }]);

      return YoniusError;
    }( /*#__PURE__*/_wrapNativeSuper(Error));
    var OperationalError = /*#__PURE__*/function (_YoniusError) {
      _inherits(OperationalError, _YoniusError);

      var _super2 = _createSuper(OperationalError);

      function OperationalError() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Operational error";
        var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

        _classCallCheck(this, OperationalError);

        return _super2.call(this, message, code);
      }

      return OperationalError;
    }(YoniusError);
    var NotFoundError = /*#__PURE__*/function (_OperationalError) {
      _inherits(NotFoundError, _OperationalError);

      var _super3 = _createSuper(NotFoundError);

      function NotFoundError() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Not found";
        var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 404;

        _classCallCheck(this, NotFoundError);

        return _super3.call(this, message, code);
      }

      return NotFoundError;
    }(OperationalError);
    var NotImplementedError = /*#__PURE__*/function (_OperationalError2) {
      _inherits(NotImplementedError, _OperationalError2);

      var _super4 = _createSuper(NotImplementedError);

      function NotImplementedError() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Not implemented";
        var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 501;

        _classCallCheck(this, NotImplementedError);

        return _super4.call(this, message, code);
      }

      return NotImplementedError;
    }(OperationalError);
    var ValidationError = /*#__PURE__*/function (_OperationalError3) {
      _inherits(ValidationError, _OperationalError3);

      var _super5 = _createSuper(ValidationError);

      function ValidationError() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Validation of submitted data failed";
        var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;

        _classCallCheck(this, ValidationError);

        return _super5.call(this, message, code);
      }

      return ValidationError;
    }(OperationalError);

    /**
     * The simple regex used to validate
     * if the provided value is a "simple" one meaning
     * that it may be used safely for URL parts
     */

    var SIMPLE_REGEX = /^[\:\.\s\w-]+$/;
    /**
     * The email regex used to validate
     * if the provided value is in fact an email
     */

    var EMAIL_REGEX = /^[\w\d\._%+-]+@[\w\d\.\-]+$/;
    /**
     * The URL regex used to validate
     * if the provided value is in fact an URL/URI
     */

    var URL_REGEX = /^\w+\:\/\/([^@]+\:[^@]+@)?[^\:\/\?#]+(\:\d+)?(\/[^\?#]+)*\/?(\?[^#]*)?(#.*)?$/;
    var eq = function eq(valueC) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be equal to %{1}";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value === valueC) return true;
        throw new ValidationError(message.replace("%{1}", String(valueC)));
      };

      return validation;
    };
    var gt = function gt(valueC) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be greater than %{1}";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value > valueC) return true;
        throw new ValidationError(message.replace("%{1}", String(valueC)));
      };

      return validation;
    };
    var gte = function gte(valueC) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be greater than or equal to %{1}";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value >= valueC) return true;
        throw new ValidationError(message.replace("%{1}", String(valueC)));
      };

      return validation;
    };
    var notEmpty = function notEmpty() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Value is empty";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value.length) return true;
        throw new ValidationError(message);
      };

      return validation;
    };
    var isIn = function isIn(valueC) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Value must be one of: %{1}";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (valueC.includes(value)) return true;
        throw new ValidationError(message.replace("%{1}", valueC.join(", ")));
      };

      return validation;
    };
    var isUpper = function isUpper() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Value contains lower cased characters";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value === "") return true;
        if (value === value.toUpperCase()) return true;
        throw new ValidationError(message);
      };

      return validation;
    };
    var isLower = function isLower() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Value contains upper cased characters";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value === "") return true;
        if (value === value.toLowerCase()) return true;
        throw new ValidationError(message);
      };

      return validation;
    };
    var isSimple = function isSimple() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Value contains invalid characters";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value === "") return true;
        if (value.match(SIMPLE_REGEX)) return true;
        throw new ValidationError(message);
      };

      return validation;
    };
    var isEmail = function isEmail() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Value is not a valid email";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value === "") return true;
        if (value.match(EMAIL_REGEX)) return true;
        throw new ValidationError(message);
      };

      return validation;
    };
    var isUrl = function isUrl() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Value is not a valid URL";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value === "") return true;
        if (value.match(URL_REGEX)) return true;
        throw new ValidationError(message);
      };

      return validation;
    };
    var isRegex = function isRegex(regex) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Value has incorrect format";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value === "") return true;
        if (value.match(new RegExp(regex))) return true;
        throw new ValidationError(message);
      };

      return validation;
    };
    var stringGt = function stringGt(valueC) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be larger than %{1} characters";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value.length > valueC) return true;
        throw new ValidationError(message.replace("%{1}", String(valueC)));
      };

      return validation;
    };
    var stringLt = function stringLt(valueC) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be smaller than %{1} characters";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value.length < valueC) return true;
        throw new ValidationError(message.replace("%{1}", String(valueC)));
      };

      return validation;
    };
    var stringEq = function stringEq(valueC) {
      var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Must be exactly %{1} characters";

      var validation = function validation(value, ctx) {
        if (value === null) return true;
        if (value.length === valueC) return true;
        throw new ValidationError(message.replace("%{1}", String(valueC)));
      };

      return validation;
    };

    var fetch$1 = fetch;

    var AUTH_ERRORS = [401, 403, 440, 499];
    var API = /*#__PURE__*/function (_Observable) {
      _inherits(API, _Observable);

      var _super = _createSuper(API);

      function API() {
        var _this;

        var kwargs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, API);

        _this = _super.call(this);
        _this.kwargs = kwargs;
        return _this;
      }

      _createClass(API, [{
        key: "build",
        value: function () {
          var _build = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(method, url) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function build(_x, _x2) {
            return _build.apply(this, arguments);
          }

          return build;
        }()
      }, {
        key: "authCallback",
        value: function () {
          var _authCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(params, headers) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function authCallback(_x3, _x4) {
            return _authCallback.apply(this, arguments);
          }

          return authCallback;
        }()
      }, {
        key: "get",
        value: function () {
          var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url) {
            var options,
                result,
                _args3 = arguments;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
                    _context3.next = 3;
                    return this.methodBasic("GET", url, options);

                  case 3:
                    result = _context3.sent;
                    return _context3.abrupt("return", result);

                  case 5:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));

          function get(_x5) {
            return _get.apply(this, arguments);
          }

          return get;
        }()
      }, {
        key: "post",
        value: function () {
          var _post = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(url) {
            var options,
                result,
                _args4 = arguments;
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    options = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : {};
                    _context4.next = 3;
                    return this.methodPayload("POST", url, options);

                  case 3:
                    result = _context4.sent;
                    return _context4.abrupt("return", result);

                  case 5:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));

          function post(_x6) {
            return _post.apply(this, arguments);
          }

          return post;
        }()
      }, {
        key: "put",
        value: function () {
          var _put = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(url) {
            var options,
                result,
                _args5 = arguments;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
                    _context5.next = 3;
                    return this.methodPayload("PUT", url, options);

                  case 3:
                    result = _context5.sent;
                    return _context5.abrupt("return", result);

                  case 5:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5, this);
          }));

          function put(_x7) {
            return _put.apply(this, arguments);
          }

          return put;
        }()
      }, {
        key: "delete",
        value: function () {
          var _delete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(url) {
            var options,
                result,
                _args6 = arguments;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    options = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                    _context6.next = 3;
                    return this.methodBasic("DELETE", url, options);

                  case 3:
                    result = _context6.sent;
                    return _context6.abrupt("return", result);

                  case 5:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, this);
          }));

          function _delete(_x8) {
            return _delete2.apply(this, arguments);
          }

          return _delete;
        }()
      }, {
        key: "patch",
        value: function () {
          var _patch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(url) {
            var options,
                result,
                _args7 = arguments;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    options = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
                    _context7.next = 3;
                    return this.methodPayload("PATCH", url, options);

                  case 3:
                    result = _context7.sent;
                    return _context7.abrupt("return", result);

                  case 5:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7, this);
          }));

          function patch(_x9) {
            return _patch.apply(this, arguments);
          }

          return patch;
        }()
      }, {
        key: "options",
        value: function () {
          var _options2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(url) {
            var _options,
                result,
                _args8 = arguments;

            return regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _options = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : {};
                    _context8.next = 3;
                    return this.methodBasic("OPTIONS", url, _options);

                  case 3:
                    result = _context8.sent;
                    return _context8.abrupt("return", result);

                  case 5:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8, this);
          }));

          function options(_x10) {
            return _options2.apply(this, arguments);
          }

          return options;
        }()
      }, {
        key: "methodBasic",
        value: function () {
          var _methodBasic2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(method, url) {
            var options,
                _args9 = arguments;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    options = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : {};
                    options.params = options.params !== undefined ? options.params : {};
                    options.headers = options.headers !== undefined ? options.headers : {};
                    _context9.prev = 3;
                    _context9.next = 6;
                    return this._methodBasic(method, url, options);

                  case 6:
                    return _context9.abrupt("return", _context9.sent);

                  case 9:
                    _context9.prev = 9;
                    _context9.t0 = _context9["catch"](3);

                    if (!AUTH_ERRORS.includes(_context9.t0.code)) {
                      _context9.next = 19;
                      break;
                    }

                    _context9.next = 14;
                    return this.authCallback(options.params, options.headers);

                  case 14:
                    _context9.next = 16;
                    return this._methodBasic(method, url, options);

                  case 16:
                    return _context9.abrupt("return", _context9.sent);

                  case 19:
                    throw _context9.t0;

                  case 20:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9, this, [[3, 9]]);
          }));

          function methodBasic(_x11, _x12) {
            return _methodBasic2.apply(this, arguments);
          }

          return methodBasic;
        }()
      }, {
        key: "methodPayload",
        value: function () {
          var _methodPayload2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(method, url) {
            var options,
                _args10 = arguments;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    options = _args10.length > 2 && _args10[2] !== undefined ? _args10[2] : {};
                    options.params = options.params !== undefined ? options.params : {};
                    options.headers = options.headers !== undefined ? options.headers : {};
                    _context10.prev = 3;
                    _context10.next = 6;
                    return this._methodPayload(method, url, options);

                  case 6:
                    return _context10.abrupt("return", _context10.sent);

                  case 9:
                    _context10.prev = 9;
                    _context10.t0 = _context10["catch"](3);

                    if (!AUTH_ERRORS.includes(_context10.t0.code)) {
                      _context10.next = 19;
                      break;
                    }

                    _context10.next = 14;
                    return this.authCallback(options.params, options.headers);

                  case 14:
                    _context10.next = 16;
                    return this._methodPayload(method, url, options);

                  case 16:
                    return _context10.abrupt("return", _context10.sent);

                  case 19:
                    throw _context10.t0;

                  case 20:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10, this, [[3, 9]]);
          }));

          function methodPayload(_x13, _x14) {
            return _methodPayload2.apply(this, arguments);
          }

          return methodPayload;
        }()
      }, {
        key: "_methodBasic",
        value: function () {
          var _methodBasic3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(method, url) {
            var options,
                params,
                headers,
                kwargs,
                handle,
                query,
                response,
                result,
                _args11 = arguments;
            return regeneratorRuntime.wrap(function _callee11$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                    options = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : {};
                    params = options.params !== undefined ? options.params : {};
                    headers = options.headers !== undefined ? options.headers : {};
                    kwargs = options.kwargs !== undefined ? options.kwargs : {};
                    handle = options.handle !== undefined ? options.handle : true;
                    _context11.next = 7;
                    return this.build(method, url, {
                      params: params,
                      headers: headers,
                      kwargs: kwargs
                    });

                  case 7:
                    query = urlEncode(params || {});
                    if (query) url += url.includes("?") ? "&" + query : "?" + query;
                    _context11.next = 11;
                    return fetch$1(url, {
                      method: method,
                      headers: headers || {}
                    });

                  case 11:
                    response = _context11.sent;

                    if (!handle) {
                      _context11.next = 18;
                      break;
                    }

                    _context11.next = 15;
                    return this._handleResponse(response);

                  case 15:
                    _context11.t0 = _context11.sent;
                    _context11.next = 19;
                    break;

                  case 18:
                    _context11.t0 = response;

                  case 19:
                    result = _context11.t0;
                    return _context11.abrupt("return", result);

                  case 21:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee11, this);
          }));

          function _methodBasic(_x15, _x16) {
            return _methodBasic3.apply(this, arguments);
          }

          return _methodBasic;
        }()
      }, {
        key: "_methodPayload",
        value: function () {
          var _methodPayload3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(method, url) {
            var options,
                params,
                headers,
                data,
                dataJ,
                dataM,
                mime,
                kwargs,
                handle,
                query,
                _this$_encodeMultipar,
                _this$_encodeMultipar2,
                response,
                result,
                _args12 = arguments;

            return regeneratorRuntime.wrap(function _callee12$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                    options = _args12.length > 2 && _args12[2] !== undefined ? _args12[2] : {};
                    params = options.params !== undefined ? options.params : {};
                    headers = options.headers !== undefined ? options.headers : {};
                    data = options.data !== undefined ? options.data : null;
                    dataJ = options.dataJ !== undefined ? options.dataJ : null;
                    dataM = options.dataM !== undefined ? options.dataM : null;
                    mime = options.mime !== undefined ? options.mime : null;
                    kwargs = options.kwargs !== undefined ? options.kwargs : {};
                    handle = options.handle !== undefined ? options.handle : true;
                    _context12.next = 11;
                    return this.build(method, url, {
                      params: params,
                      headers: headers,
                      data: data,
                      dataJ: dataJ,
                      dataM: dataM,
                      mime: mime,
                      kwargs: kwargs
                    });

                  case 11:
                    query = urlEncode(params || {});

                    if (data !== null) {
                      if (query) url += url.includes("?") ? "&" + query : "?" + query;
                    } else if (dataJ !== null) {
                      data = JSON.stringify(dataJ);
                      if (query) url += url.includes("?") ? "&" + query : "?" + query;
                      mime = mime || "application/json";
                    } else if (dataM !== null) {
                      if (query) url += url.includes("?") ? "&" + query : "?" + query;
                      _this$_encodeMultipar = this._encodeMultipart(dataM, mime, true);
                      _this$_encodeMultipar2 = _slicedToArray(_this$_encodeMultipar, 2);
                      mime = _this$_encodeMultipar2[0];
                      data = _this$_encodeMultipar2[1];
                    } else if (query) {
                      data = query;
                      mime = mime || "application/x-www-form-urlencoded";
                    }

                    headers = Object.assign({}, headers);
                    if (mime) headers["Content-Type"] = mime;
                    _context12.next = 17;
                    return fetch$1(url, {
                      method: method,
                      headers: headers || {},
                      body: data
                    });

                  case 17:
                    response = _context12.sent;

                    if (!handle) {
                      _context12.next = 24;
                      break;
                    }

                    _context12.next = 21;
                    return this._handleResponse(response);

                  case 21:
                    _context12.t0 = _context12.sent;
                    _context12.next = 25;
                    break;

                  case 24:
                    _context12.t0 = response;

                  case 25:
                    result = _context12.t0;
                    return _context12.abrupt("return", result);

                  case 27:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee12, this);
          }));

          function _methodPayload(_x17, _x18) {
            return _methodPayload3.apply(this, arguments);
          }

          return _methodPayload;
        }()
      }, {
        key: "_handleResponse",
        value: function () {
          var _handleResponse2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(response) {
            var errorMessage,
                result,
                _args13 = arguments;
            return regeneratorRuntime.wrap(function _callee13$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                    errorMessage = _args13.length > 1 && _args13[1] !== undefined ? _args13[1] : "Problem in request";
                    result = null;

                    if (!(response.headers.get("content-type") && response.headers.get("content-type").toLowerCase().startsWith("application/json"))) {
                      _context13.next = 8;
                      break;
                    }

                    _context13.next = 5;
                    return response.json();

                  case 5:
                    result = _context13.sent;
                    _context13.next = 17;
                    break;

                  case 8:
                    if (!(response.headers.get("content-type") && response.headers.get("content-type").toLowerCase().startsWith("text/"))) {
                      _context13.next = 14;
                      break;
                    }

                    _context13.next = 11;
                    return response.text();

                  case 11:
                    result = _context13.sent;
                    _context13.next = 17;
                    break;

                  case 14:
                    _context13.next = 16;
                    return response.blob();

                  case 16:
                    result = _context13.sent;

                  case 17:
                    verify(response.ok, result.error || errorMessage, response.status || 500);
                    return _context13.abrupt("return", result);

                  case 19:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee13);
          }));

          function _handleResponse(_x19) {
            return _handleResponse2.apply(this, arguments);
          }

          return _handleResponse;
        }()
      }, {
        key: "_encodeMultipart",
        value: function _encodeMultipart(fields) {
          var mime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var doseq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
          mime = mime || "multipart/form-data";

          var boundary = this._createBoundary(fields, undefined, doseq);

          var encoder = new TextEncoder("utf-8");
          var buffer = [];

          for (var _i = 0, _Object$entries = Object.entries(fields); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
                key = _Object$entries$_i[0],
                values = _Object$entries$_i[1];

            var isList = doseq && Array.isArray(values);
            values = isList ? values : [values];

            var _iterator = _createForOfIteratorHelper(values),
                _step;

            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var value = _step.value;
                if (value === null) continue;
                var header = void 0;

                if (_typeof(value) === "object" && !Array.isArray(value) && value.constructor !== Uint8Array) {
                  var headerL = [];
                  var data = null;

                  for (var _i2 = 0, _Object$entries2 = Object.entries(value); _i2 < _Object$entries2.length; _i2++) {
                    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
                        _key = _Object$entries2$_i[0],
                        item = _Object$entries2$_i[1];

                    if (_key === "data") data = item;else headerL.push("".concat(_key, ": ").concat(item));
                  }

                  value = data;
                  header = headerL.join("\r\n");
                } else if (Array.isArray(value)) {
                  var name = null;
                  var contents = null;
                  var contentTypeD = null;

                  if (value.length === 2) {
                    var _value = value;

                    var _value2 = _slicedToArray(_value, 2);

                    name = _value2[0];
                    contents = _value2[1];
                  } else {
                    var _value3 = value;

                    var _value4 = _slicedToArray(_value3, 3);

                    name = _value4[0];
                    contentTypeD = _value4[1];
                    contents = _value4[2];
                  }

                  header = "Content-Disposition: form-data; name=\"".concat(key, "\"; filename=\"").concat(name, "\"");
                  if (contentTypeD) header += "\r\nContent-Type: ".concat(contentTypeD);
                  value = contents;
                } else {
                  header = "Content-Disposition: form-data; name=\"".concat(key, "\"");
                }

                buffer.push(encoder.encode("--" + boundary + "\r\n"));
                buffer.push(encoder.encode(header + "\r\n"));
                buffer.push(encoder.encode("\r\n"));
                buffer.push(value);
                buffer.push(encoder.encode("\r\n"));
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }

          buffer.push(encoder.encode("--" + boundary + "--\r\n"));
          buffer.push(encoder.encode("\r\n"));

          var body = this._joinBuffer(buffer);

          var contentType = "".concat(mime, "; boundary=").concat(boundary);
          return [contentType, body];
        }
      }, {
        key: "_createBoundary",
        value: function _createBoundary(fields) {
          return "Vq2xNWWHbmWYF644q9bC5T2ALtj5CynryArNQRXGYsfm37vwFKMNsqPBrpPeprFs";
        }
      }, {
        key: "_joinBuffer",
        value: function _joinBuffer(bufferArray) {
          var bufferSize = bufferArray.map(function (item) {
            return item.byteLength;
          }).reduce(function (a, v) {
            return a + v;
          }, 0);
          var buffer = new Uint8Array(bufferSize);
          var offset = 0;

          var _iterator2 = _createForOfIteratorHelper(bufferArray),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              buffer.set(item, offset);
              offset += item.byteLength;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          return buffer;
        }
      }]);

      return API;
    }(Observable);

    var OAuthAPI = /*#__PURE__*/function (_API) {
      _inherits(OAuthAPI, _API);

      var _super = _createSuper(OAuthAPI);

      function OAuthAPI() {
        _classCallCheck(this, OAuthAPI);

        return _super.apply(this, arguments);
      }

      return OAuthAPI;
    }(API);

    var OAuth1API = /*#__PURE__*/function (_OAuthAPI) {
      _inherits(OAuth1API, _OAuthAPI);

      var _super = _createSuper(OAuth1API);

      function OAuth1API() {
        _classCallCheck(this, OAuth1API);

        return _super.apply(this, arguments);
      }

      return OAuth1API;
    }(OAuthAPI);

    var OAuth2API = /*#__PURE__*/function (_OAuthAPI) {
      _inherits(OAuth2API, _OAuthAPI);

      var _super = _createSuper(OAuth2API);

      function OAuth2API() {
        var _this;

        var kwargs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, OAuth2API);

        _this = _super.call(this, kwargs);
        _this.accessToken = null;
        return _this;
      }

      _createClass(OAuth2API, [{
        key: "build",
        value: function () {
          var _build = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(method, url) {
            var options,
                params,
                headers,
                kwargs,
                token,
                _args = arguments;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
                    _context.next = 3;
                    return _get(_getPrototypeOf(OAuth2API.prototype), "build", this).call(this, method, url, options);

                  case 3:
                    params = options.params !== undefined ? options.params : {};
                    headers = options.headers !== undefined ? options.headers : {};
                    kwargs = options.kwargs !== undefined ? options.kwargs : {};
                    token = kwargs.token === undefined ? this.tokenDefault : kwargs.token;
                    delete kwargs.token;

                    if (token && this.oauthTypes.includes("param")) {
                      params[this.oauthParam] = this.getAccessToken();
                    }

                    if (token && this.oauthTypes.includes("header")) {
                      headers.Authorization = "Bearer ".concat(this.getAccessToken());
                    }

                  case 10:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function build(_x, _x2) {
            return _build.apply(this, arguments);
          }

          return build;
        }()
      }, {
        key: "getAccessToken",
        value: function getAccessToken() {
          if (this.accessToken) return this.accessToken;
          throw new Error("No access token found must re-authorize");
        }
      }, {
        key: "oauthTypes",
        get: function get() {
          return ["param", "header"];
        }
      }, {
        key: "oauthParam",
        get: function get() {
          return "access_token";
        }
      }, {
        key: "tokenDefault",
        get: function get() {
          return true;
        }
      }]);

      return OAuth2API;
    }(OAuthAPI);

    /**
     * Ensures that the current "session" context contains the
     * requested ACL token as valid.
     *
     * In case the validation fails an exception is raised
     * indicating the auth validation error.
     *
     * @param {String} token The ACL token to ensure permission,
     * the logged user should be allowed to id.
     * @param {Object} ctx The context object to be used in
     * the session basic ACL retrieval, should contain proper
     * injected methods for retrieval (eg: `getAcl`).
     */

    var ensurePermissions = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token, ctx) {
        var acl, tokens;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!ctx.getAcl) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return ctx.getAcl(ctx);

              case 3:
                _context.t0 = _context.sent;
                _context.next = 7;
                break;

              case 6:
                _context.t0 = {};

              case 7:
                acl = _context.t0;
                tokens = toTokensM(acl); // in case the permission validation test is not positive
                // then an exception should be raised indicating the issue

                if (_hasPermission(token, tokens)) {
                  _context.next = 11;
                  break;
                }

                throw new OperationalError("You don't have authorization to access this resource", 401);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function ensurePermissions(_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();
    /**
     * Converts the provided list of token strings separated by dots
     * into a map based representation on an hierarchical structure.
     *
     * @param {Array} tokens A linear array of tokens to convert into
     * an hierarchical representation.
     * @returns {Object} The map containing the hierarchy of tokens
     * for the provided linear string based sequence of tokens.
     */

    var toTokensM = function toTokensM(tokens) {
      var tokensM = {};
      if (tokens === undefined) return tokensM;
      if (tokens === null) return tokensM;
      if (!Array.isArray(tokens)) return tokensM;

      var _iterator = _createForOfIteratorHelper(tokens),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var token = _step.value;
          var tokensC = tokensM;
          var tokenL = token.split(".");
          var head = tokenL.slice(0, tokenL.length - 1);
          var tail = tokenL[tokenL.length - 1];

          var _iterator2 = _createForOfIteratorHelper(head),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var tokenP = _step2.value;
              var current = tokensC[tokenP] || {};
              var isDict = _typeof(current) === "object";
              if (!isDict) current = {
                _: current
              };
              tokensC[tokenP] = current;
              tokensC = current;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          var leaf = tokensC[tail] || null;
          if (leaf && _typeof(leaf) === "object") leaf._ = true;else tokensC[tail] = true;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return tokensM;
    };

    var _hasPermission = function _hasPermission(token) {
      var tokensM = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (!token) return true;
      if (tokensM === undefined || tokensM === null) return false;
      var tokenL = token.split(".");

      var _iterator3 = _createForOfIteratorHelper(tokenL),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var tokenP = _step3.value;
          if (_typeof(tokensM) !== "object") return false;
          if (tokensM["*"]) return true;
          if (tokensM[tokenP] === undefined) return false;
          tokensM = tokensM[tokenP];
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      var isDict = _typeof(tokensM) === "object";
      var result = isDict ? tokensM._ || false : tokensM;
      return Boolean(result);
    };

    var REGISTRY = {};
    var load$1 = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return load();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function load() {
        return _ref.apply(this, arguments);
      };
    }();
    var unload = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function unload() {
        return _ref2.apply(this, arguments);
      };
    }();
    var register = function register(name, value) {
      REGISTRY[name] = value;
    };
    var unregister = function unregister(name) {
      delete REGISTRY[name];
    };
    var request = function request(name) {
      if (REGISTRY[name] === undefined) {
        throw new OperationalError("Name '".concat(name, "' not found in registry"));
      }

      return REGISTRY[name];
    };

    var FileTuple = /*#__PURE__*/function (_Array) {
      _inherits(FileTuple, _Array);

      var _super = _createSuper(FileTuple);

      function FileTuple() {
        _classCallCheck(this, FileTuple);

        return _super.apply(this, arguments);
      }

      _createClass(FileTuple, [{
        key: "name",
        get: function get() {
          return this[0];
        }
      }, {
        key: "mime",
        get: function get() {
          return this[1];
        }
      }, {
        key: "data",
        get: function get() {
          return this[2];
        }
      }], [{
        key: "fromData",
        value: function fromData(data) {
          var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var mime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          var fileTuple = new this(name, mime, data);
          return fileTuple;
        }
      }, {
        key: "fromString",
        value: function fromString(dataString) {
          var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
          var mime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
          var data = new TextEncoder("utf-8").encode(dataString);
          return this.fromData(data, name, mime);
        }
      }]);

      return FileTuple;
    }( /*#__PURE__*/_wrapNativeSuper(Array));

    /**
     * Abstract class definition that defines the interface
     * expected to be implemented by data driven collections
     * in the Yonius context.
     */

    var Collection = /*#__PURE__*/function () {
      function Collection(options) {
        _classCallCheck(this, Collection);

        this.options = options;
      }

      _createClass(Collection, [{
        key: "find",
        value: function () {
          var _find = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(conditions) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    throw new NotImplementedError();

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          function find(_x) {
            return _find.apply(this, arguments);
          }

          return find;
        }()
      }, {
        key: "findOne",
        value: function () {
          var _findOne = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(conditions) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    throw new NotImplementedError();

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          function findOne(_x2) {
            return _findOne.apply(this, arguments);
          }

          return findOne;
        }()
      }, {
        key: "findOneAndUpdate",
        value: function () {
          var _findOneAndUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(conditions, data) {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    throw new NotImplementedError();

                  case 2:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));

          function findOneAndUpdate(_x3, _x4) {
            return _findOneAndUpdate.apply(this, arguments);
          }

          return findOneAndUpdate;
        }()
      }, {
        key: "findOneAndDelete",
        value: function () {
          var _findOneAndDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(conditions) {
            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    throw new NotImplementedError();

                  case 2:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4);
          }));

          function findOneAndDelete(_x5) {
            return _findOneAndDelete.apply(this, arguments);
          }

          return findOneAndDelete;
        }()
      }, {
        key: "create",
        value: function () {
          var _create = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    throw new NotImplementedError();

                  case 2:
                  case "end":
                    return _context5.stop();
                }
              }
            }, _callee5);
          }));

          function create(_x6) {
            return _create.apply(this, arguments);
          }

          return create;
        }()
      }]);

      return Collection;
    }();
    /**
     * Mongo based collection that implements the collection
     * abstract interface applying it to a specific mongodb
     * instance. Most of the interface is already "mongodb
     * oriented", so only a thin layer of adaptation is required.
     */

    var MongoCollection = /*#__PURE__*/function (_Collection) {
      _inherits(MongoCollection, _Collection);

      var _super = _createSuper(MongoCollection);

      function MongoCollection(name, schema) {
        var _this;

        _classCallCheck(this, MongoCollection);

        _this = _super.call(this, name, schema);
        _this._mongoose = _this.constructor.getModel(_this.options.name, _this.options.schema);
        return _this;
      }

      _createClass(MongoCollection, [{
        key: "find",
        value: function () {
          var _find2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(conditions) {
            var projection,
                options,
                model,
                _args6 = arguments;
            return regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    projection = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : {};
                    options = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                    _context6.next = 4;
                    return this._mongoose.find(conditions, projection, options);

                  case 4:
                    model = _context6.sent;
                    return _context6.abrupt("return", model);

                  case 6:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6, this);
          }));

          function find(_x7) {
            return _find2.apply(this, arguments);
          }

          return find;
        }()
      }, {
        key: "findOne",
        value: function () {
          var _findOne2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(conditions) {
            var projection,
                options,
                model,
                _args7 = arguments;
            return regeneratorRuntime.wrap(function _callee7$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    projection = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
                    options = _args7.length > 2 && _args7[2] !== undefined ? _args7[2] : {};
                    model = this._mongoose.findOne(conditions, projection, options);
                    return _context7.abrupt("return", model);

                  case 4:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee7, this);
          }));

          function findOne(_x8) {
            return _findOne2.apply(this, arguments);
          }

          return findOne;
        }()
      }, {
        key: "findOneAndUpdate",
        value: function () {
          var _findOneAndUpdate2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(conditions, data) {
            var options,
                model,
                _args8 = arguments;
            return regeneratorRuntime.wrap(function _callee8$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    options = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : {};
                    _context8.next = 3;
                    return this._mongoose.findOneAndUpdate(conditions, data, _objectSpread2({
                      upsert: true,
                      "new": true
                    }, options));

                  case 3:
                    model = _context8.sent;
                    return _context8.abrupt("return", model);

                  case 5:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee8, this);
          }));

          function findOneAndUpdate(_x9, _x10) {
            return _findOneAndUpdate2.apply(this, arguments);
          }

          return findOneAndUpdate;
        }()
      }, {
        key: "findOneAndDelete",
        value: function () {
          var _findOneAndDelete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(conditions) {
            var options,
                model,
                _args9 = arguments;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    options = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : {};
                    _context9.next = 3;
                    return this._mongoose.findOneAndDelete(conditions, options);

                  case 3:
                    model = _context9.sent;
                    return _context9.abrupt("return", model);

                  case 5:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee9, this);
          }));

          function findOneAndDelete(_x11) {
            return _findOneAndDelete2.apply(this, arguments);
          }

          return findOneAndDelete;
        }()
      }, {
        key: "create",
        value: function () {
          var _create2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(data) {
            var options,
                models,
                _args10 = arguments;
            return regeneratorRuntime.wrap(function _callee10$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    options = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {};
                    _context10.next = 3;
                    return this._mongoose.create([data], options);

                  case 3:
                    models = _context10.sent;
                    return _context10.abrupt("return", models[0]);

                  case 5:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee10, this);
          }));

          function create(_x12) {
            return _create2.apply(this, arguments);
          }

          return create;
        }()
      }], [{
        key: "getModel",
        value: function getModel(name, schema) {
          // verifies if the model is already present in the global
          // cache and if that the case re-uses it
          this._models = this._models || {};
          if (this._models[name]) return this._models[name]; // obtains a reference to the mongoose, that
          // should have been registered by 3rd party

          var mongoose = request("mongoose"); // creates the internal "mongoose" reference to the
          // model by encapsulating its name and schema

          this._models[name] = mongoose.model(name, new mongoose.Schema(schema)); // returns the newly constructor mongoose model to
          // the caller methods

          return this._models[name];
        }
      }]);

      return MongoCollection;
    }(Collection);

    var collection = /*#__PURE__*/Object.freeze({
        __proto__: null,
        Collection: Collection,
        MongoCollection: MongoCollection,
        'default': Collection
    });

    var MEMORY_STORAGE = {};
    var TYPE_DEFAULTS = {
      bytes: null,
      unicode: null,
      "int": null,
      "float": null,
      bool: false,
      list: function list() {
        return [];
      },
      dict: function dict() {
        return {};
      },
      object: function object() {
        return {};
      }
    };
    /**
     * The map that associates the various operators with the boolean
     * values that define if an insensitive base search should be used
     * instead of the "typical" sensitive search.
     */

    var INSENSITIVE = {
      likei: true,
      llikei: true,
      rlikei: true
    };
    /**
     * The map containing the mapping association between the
     * normalized version of the operators and the infra-structure
     * specific value for each of this operations, note that some
     * of the values don't have a valid mapping for this operations
     * the operator must be ignored and not used explicitly.
     */

    var OPERATORS = {
      eq: null,
      equals: null,
      ne: "$ne",
      not_equals: "$ne",
      "in": "$in",
      nin: "$nin",
      not_in: "$nin",
      like: "$regex",
      likei: "$regex",
      llike: "$regex",
      llikei: "$regex",
      rlike: "$regex",
      rlikei: "$regex",
      gt: "$gt",
      greater: "$gt",
      gte: "$gte",
      greater_equal: "$gte",
      lt: "$lt",
      lesser: "$lt",
      lte: "$lte",
      lesser_equal: "$lte",
      "null": null,
      is_null: null,
      not_null: "$ne",
      is_not_null: "$ne",
      contains: "$all"
    };
    /**
     * Map that associates each of the normalized operations with
     * an inline function that together with the data type maps the
     * the base string based value into the target normalized value.
     */

    var VALUE_METHODS = {
      "in": function _in(v, t) {
        return v.split(";").map(t);
      },
      not_in: function not_in(v, t) {
        return v.split(";").map(t);
      },
      like: function like(v, t) {
        return "^.*" + escapeStringRegexp(v) + ".*$";
      },
      likei: function likei(v, t) {
        return "^.*" + escapeStringRegexp(v) + ".*$";
      },
      llike: function llike(v, t) {
        return "^.*" + escapeStringRegexp(v) + "$";
      },
      llikei: function llikei(v, t) {
        return "^.*" + escapeStringRegexp(v) + "$";
      },
      rlike: function rlike(v, t) {
        return "^" + escapeStringRegexp(v) + ".*$";
      },
      rlikei: function rlikei(v, t) {
        return "^" + escapeStringRegexp(v) + ".*$";
      },
      "null": function _null(v, t) {
        return null;
      },
      is_null: function is_null(v, t) {
        return null;
      },
      not_null: function not_null(v, t) {
        return null;
      },
      is_not_null: function is_not_null(v, t) {
        return null;
      },
      contains: function contains(v, t) {
        return v.split(";");
      }
    };
    var Model = /*#__PURE__*/function () {
      function Model() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Model);

        var fill = options.fill === undefined ? true : options.fill;
        if (fill) this.constructor.fill(this);
      }

      _createClass(Model, [{
        key: "validate",
        value: function () {
          var _validate2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var errors;
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    errors = _toConsumableArray(this._validate());

                    if (!errors.length) {
                      _context.next = 3;
                      break;
                    }

                    throw new ValidationError("Invalid model: ".concat(errors.map(function (err) {
                      return String(err);
                    }).join(", ")));

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, this);
          }));

          function validate() {
            return _validate2.apply(this, arguments);
          }

          return validate;
        }()
      }, {
        key: "apply",
        value: function () {
          var _apply = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(model) {
            return regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return this.wrap(model);

                  case 2:
                    return _context2.abrupt("return", this);

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2, this);
          }));

          function apply(_x) {
            return _apply.apply(this, arguments);
          }

          return apply;
        }()
      }, {
        key: "wrap",
        value: function () {
          var _wrap2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(model) {
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return this._wrap(model);

                  case 2:
                    return _context3.abrupt("return", this);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, this);
          }));

          function wrap(_x2) {
            return _wrap2.apply(this, arguments);
          }

          return wrap;
        }()
      }, {
        key: "isNew",
        get: function get() {
          return this._id === undefined;
        }
      }, {
        key: "model",
        get: function get() {
          return this;
        }
      }, {
        key: "jsonV",
        get: function get() {
          return this.model;
        }
      }, {
        key: "string",
        get: function get() {
          return JSON.stringify(this.model);
        }
        /**
         * Wraps the provided model object around the current instance, making
         * sure that all of the elements are compliant with the schema.
         *
         * It should be possible to override the `_wrap` operation to implement
         * a custom "way" of setting data into a model.
         *
         * @param {Object} model The model structure that is going to be used
         * to wrap the current model object, meaning that all of its elements
         * are going to be stored in the current object.
         */

      }, {
        key: "_wrap",
        value: function () {
          var _wrap3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(model) {
            var _i, _Object$keys, key;

            return regeneratorRuntime.wrap(function _callee4$(_context4) {
              while (1) {
                switch (_context4.prev = _context4.next) {
                  case 0:
                    _i = 0, _Object$keys = Object.keys(this.constructor.schema);

                  case 1:
                    if (!(_i < _Object$keys.length)) {
                      _context4.next = 9;
                      break;
                    }

                    key = _Object$keys[_i];

                    if (!(model[key] === undefined)) {
                      _context4.next = 5;
                      break;
                    }

                    return _context4.abrupt("continue", 6);

                  case 5:
                    this[key] = model[key];

                  case 6:
                    _i++;
                    _context4.next = 1;
                    break;

                  case 9:
                    if (model._id !== undefined) this._id = model._id;

                  case 10:
                  case "end":
                    return _context4.stop();
                }
              }
            }, _callee4, this);
          }));

          function _wrap(_x3) {
            return _wrap3.apply(this, arguments);
          }

          return _wrap;
        }()
      }, {
        key: "_validate",
        value: /*#__PURE__*/regeneratorRuntime.mark(function _validate() {
          var _i2, _Object$entries, _Object$entries$_i, name, value, validation, _iterator, _step, callable;

          return regeneratorRuntime.wrap(function _validate$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _i2 = 0, _Object$entries = Object.entries(this.constructor.schema);

                case 1:
                  if (!(_i2 < _Object$entries.length)) {
                    _context5.next = 32;
                    break;
                  }

                  _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), name = _Object$entries$_i[0], value = _Object$entries$_i[1];
                  validation = value.validation || false;

                  if (validation) {
                    _context5.next = 6;
                    break;
                  }

                  return _context5.abrupt("continue", 29);

                case 6:
                  _iterator = _createForOfIteratorHelper(validation);
                  _context5.prev = 7;

                  _iterator.s();

                case 9:
                  if ((_step = _iterator.n()).done) {
                    _context5.next = 21;
                    break;
                  }

                  callable = _step.value;
                  _context5.prev = 11;
                  callable(this[name]);
                  _context5.next = 19;
                  break;

                case 15:
                  _context5.prev = 15;
                  _context5.t0 = _context5["catch"](11);
                  _context5.next = 19;
                  return _context5.t0;

                case 19:
                  _context5.next = 9;
                  break;

                case 21:
                  _context5.next = 26;
                  break;

                case 23:
                  _context5.prev = 23;
                  _context5.t1 = _context5["catch"](7);

                  _iterator.e(_context5.t1);

                case 26:
                  _context5.prev = 26;

                  _iterator.f();

                  return _context5.finish(26);

                case 29:
                  _i2++;
                  _context5.next = 1;
                  break;

                case 32:
                case "end":
                  return _context5.stop();
              }
            }
          }, _validate, this, [[7, 23, 26, 29], [11, 15]]);
        })
      }], [{
        key: "niw",
        value: function niw() {
          return new this();
        }
        /**
         * Fills the current model with the proper values so that
         * no values are unset as this would violate the model definition
         * integrity. This is required when retrieving an object(s) from
         * the data source (as some of them may be incomplete).
         *
         * @param {Object} model The model that is going to have its unset
         * attributes filled with "default" data, in case none is provided
         * all of the attributes will be filled with "default" data.
         * @param {Boolean} safe If the safe mode should be used for the fill
         * operation meaning that under some conditions no unit fill
         * operation is going to be applied (eg: retrieval operations).
         */

      }, {
        key: "fill",
        value: function () {
          var _fill = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            var model,
                safe,
                _i3,
                _Object$entries2,
                _Object$entries2$_i,
                name,
                field,
                _private,
                increment,
                initial,
                type,
                _default,
                _args6 = arguments;

            return regeneratorRuntime.wrap(function _callee5$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    model = _args6.length > 0 && _args6[0] !== undefined ? _args6[0] : {};
                    safe = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : false;
                    _i3 = 0, _Object$entries2 = Object.entries(this.schema);

                  case 3:
                    if (!(_i3 < _Object$entries2.length)) {
                      _context6.next = 19;
                      break;
                    }

                    _Object$entries2$_i = _slicedToArray(_Object$entries2[_i3], 2), name = _Object$entries2$_i[0], field = _Object$entries2$_i[1];

                    if (!(model[name] !== undefined)) {
                      _context6.next = 7;
                      break;
                    }

                    return _context6.abrupt("continue", 16);

                  case 7:
                    if (!["_id"].includes(model[name])) {
                      _context6.next = 9;
                      break;
                    }

                    return _context6.abrupt("continue", 16);

                  case 9:
                    _private = field["private"] === undefined ? false : field["private"];
                    increment = field.increment === undefined ? false : field.increment;

                    if (!(_private && safe)) {
                      _context6.next = 13;
                      break;
                    }

                    return _context6.abrupt("continue", 16);

                  case 13:
                    if (!increment) {
                      _context6.next = 15;
                      break;
                    }

                    return _context6.abrupt("continue", 16);

                  case 15:
                    if (field.initial !== undefined) {
                      initial = field.initial;
                      model[name] = initial;
                    } else {
                      type = field.type || null;
                      _default = typeD(type, null);
                      _default = type._default === undefined ? _default : type._default();
                      model[name] = _default;
                    }

                  case 16:
                    _i3++;
                    _context6.next = 3;
                    break;

                  case 19:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee5, this);
          }));

          function fill() {
            return _fill.apply(this, arguments);
          }

          return fill;
        }()
        /**
         * The name of the data source adapter that is going
         * to be used to handle this model instance.
         *
         * @type {String}
         */

      }, {
        key: "adapter",
        get: function get() {
          return process.env.ADAPTER || "mongo";
        }
      }]);

      return Model;
    }();
    var ModelStore = /*#__PURE__*/function (_Model) {
      _inherits(ModelStore, _Model);

      var _super = _createSuper(ModelStore);

      function ModelStore() {
        _classCallCheck(this, ModelStore);

        return _super.apply(this, arguments);
      }

      _createClass(ModelStore, [{
        key: "save",
        value: function () {
          var _save = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
            var _ref,
                _ref$validate,
                validate,
                _ref$preSave,
                preSave,
                _ref$preCreate,
                preCreate,
                _ref$preUpdate,
                preUpdate,
                _ref$postSave,
                postSave,
                _ref$postCreate,
                postCreate,
                _ref$postUpdate,
                postUpdate,
                _ref$beforeCallbacks,
                beforeCallbacks,
                _ref$afterCallbacks,
                afterCallbacks,
                model,
                _iterator2,
                _step2,
                name,
                exists,
                _iterator3,
                _step3,
                callback,
                isNew,
                conditions,
                _iterator4,
                _step4,
                _callback,
                _args7 = arguments;

            return regeneratorRuntime.wrap(function _callee6$(_context7) {
              while (1) {
                switch (_context7.prev = _context7.next) {
                  case 0:
                    _ref = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : {}, _ref$validate = _ref.validate, validate = _ref$validate === void 0 ? true : _ref$validate, _ref$preSave = _ref.preSave, preSave = _ref$preSave === void 0 ? true : _ref$preSave, _ref$preCreate = _ref.preCreate, preCreate = _ref$preCreate === void 0 ? true : _ref$preCreate, _ref$preUpdate = _ref.preUpdate, preUpdate = _ref$preUpdate === void 0 ? true : _ref$preUpdate, _ref$postSave = _ref.postSave, postSave = _ref$postSave === void 0 ? true : _ref$postSave, _ref$postCreate = _ref.postCreate, postCreate = _ref$postCreate === void 0 ? true : _ref$postCreate, _ref$postUpdate = _ref.postUpdate, postUpdate = _ref$postUpdate === void 0 ? true : _ref$postUpdate, _ref$beforeCallbacks = _ref.beforeCallbacks, beforeCallbacks = _ref$beforeCallbacks === void 0 ? [] : _ref$beforeCallbacks, _ref$afterCallbacks = _ref.afterCallbacks, afterCallbacks = _ref$afterCallbacks === void 0 ? [] : _ref$afterCallbacks;
                    // iterates over each of the fields that are meant to have its value
                    // increment and performs the appropriate operation taking into account
                    // if the value is already populated or not
                    _iterator2 = _createForOfIteratorHelper(this.constructor.increments);
                    _context7.prev = 2;

                    _iterator2.s();

                  case 4:
                    if ((_step2 = _iterator2.n()).done) {
                      _context7.next = 18;
                      break;
                    }

                    name = _step2.value;
                    exists = this.model[name] !== undefined;

                    if (!exists) {
                      _context7.next = 13;
                      break;
                    }

                    _context7.next = 10;
                    return this.constructor._ensureMin(name, this.model[name]);

                  case 10:
                    this.model[name] = _context7.sent;
                    _context7.next = 16;
                    break;

                  case 13:
                    _context7.next = 15;
                    return this.constructor._increment(name);

                  case 15:
                    this.model[name] = _context7.sent;

                  case 16:
                    _context7.next = 4;
                    break;

                  case 18:
                    _context7.next = 23;
                    break;

                  case 20:
                    _context7.prev = 20;
                    _context7.t0 = _context7["catch"](2);

                    _iterator2.e(_context7.t0);

                  case 23:
                    _context7.prev = 23;

                    _iterator2.f();

                    return _context7.finish(23);

                  case 26:
                    if (!validate) {
                      _context7.next = 29;
                      break;
                    }

                    _context7.next = 29;
                    return this.validate();

                  case 29:
                    _context7.next = 31;
                    return this.verify();

                  case 31:
                    if (!preSave) {
                      _context7.next = 34;
                      break;
                    }

                    _context7.next = 34;
                    return this.preSave();

                  case 34:
                    if (!preCreate) {
                      _context7.next = 37;
                      break;
                    }

                    _context7.next = 37;
                    return this.preCreate();

                  case 37:
                    if (!preUpdate) {
                      _context7.next = 40;
                      break;
                    }

                    _context7.next = 40;
                    return this.preUpdate();

                  case 40:
                    // calls the complete set of callbacks that should be called
                    // before the concrete data store save operation
                    _iterator3 = _createForOfIteratorHelper(beforeCallbacks);
                    _context7.prev = 41;

                    _iterator3.s();

                  case 43:
                    if ((_step3 = _iterator3.n()).done) {
                      _context7.next = 49;
                      break;
                    }

                    callback = _step3.value;
                    _context7.next = 47;
                    return callback(this, this.model);

                  case 47:
                    _context7.next = 43;
                    break;

                  case 49:
                    _context7.next = 54;
                    break;

                  case 51:
                    _context7.prev = 51;
                    _context7.t1 = _context7["catch"](41);

                    _iterator3.e(_context7.t1);

                  case 54:
                    _context7.prev = 54;

                    _iterator3.f();

                    return _context7.finish(54);

                  case 57:
                    // verifies if the current model is a new one or if instead
                    // represents an update to a previously stored model and create
                    // or update data accordingly
                    isNew = this._id === undefined;

                    if (!isNew) {
                      _context7.next = 64;
                      break;
                    }

                    _context7.next = 61;
                    return this.constructor.collection.create(this.model);

                  case 61:
                    model = _context7.sent;
                    _context7.next = 69;
                    break;

                  case 64:
                    conditions = {};
                    conditions[this.constructor.idName] = this.identifier;
                    _context7.next = 68;
                    return this.constructor.collection.findOneAndUpdate(conditions, this.model);

                  case 68:
                    model = _context7.sent;

                  case 69:
                    // wraps the model object using the current instance
                    // effectively making the data available for consumers
                    this.wrap(model); // calls the complete set of callbacks that should be called
                    // after the concrete data store save operation

                    _iterator4 = _createForOfIteratorHelper(afterCallbacks);
                    _context7.prev = 71;

                    _iterator4.s();

                  case 73:
                    if ((_step4 = _iterator4.n()).done) {
                      _context7.next = 79;
                      break;
                    }

                    _callback = _step4.value;
                    _context7.next = 77;
                    return _callback(this, this.model);

                  case 77:
                    _context7.next = 73;
                    break;

                  case 79:
                    _context7.next = 84;
                    break;

                  case 81:
                    _context7.prev = 81;
                    _context7.t2 = _context7["catch"](71);

                    _iterator4.e(_context7.t2);

                  case 84:
                    _context7.prev = 84;

                    _iterator4.f();

                    return _context7.finish(84);

                  case 87:
                    if (!postSave) {
                      _context7.next = 90;
                      break;
                    }

                    _context7.next = 90;
                    return this.postSave();

                  case 90:
                    if (!postCreate) {
                      _context7.next = 93;
                      break;
                    }

                    _context7.next = 93;
                    return this.postCreate();

                  case 93:
                    if (!postUpdate) {
                      _context7.next = 96;
                      break;
                    }

                    _context7.next = 96;
                    return this.postUpdate();

                  case 96:
                    return _context7.abrupt("return", this);

                  case 97:
                  case "end":
                    return _context7.stop();
                }
              }
            }, _callee6, this, [[2, 20, 23, 26], [41, 51, 54, 57], [71, 81, 84, 87]]);
          }));

          function save() {
            return _save.apply(this, arguments);
          }

          return save;
        }()
      }, {
        key: "delete",
        value: function () {
          var _delete2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
            var _ref2,
                _ref2$preDelete,
                preDelete,
                _ref2$postDelete,
                postDelete,
                _ref2$beforeCallbacks,
                beforeCallbacks,
                _ref2$afterCallbacks,
                afterCallbacks,
                _iterator5,
                _step5,
                callback,
                conditions,
                _iterator6,
                _step6,
                _callback2,
                _args8 = arguments;

            return regeneratorRuntime.wrap(function _callee7$(_context8) {
              while (1) {
                switch (_context8.prev = _context8.next) {
                  case 0:
                    _ref2 = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {}, _ref2$preDelete = _ref2.preDelete, preDelete = _ref2$preDelete === void 0 ? true : _ref2$preDelete, _ref2$postDelete = _ref2.postDelete, postDelete = _ref2$postDelete === void 0 ? true : _ref2$postDelete, _ref2$beforeCallbacks = _ref2.beforeCallbacks, beforeCallbacks = _ref2$beforeCallbacks === void 0 ? [] : _ref2$beforeCallbacks, _ref2$afterCallbacks = _ref2.afterCallbacks, afterCallbacks = _ref2$afterCallbacks === void 0 ? [] : _ref2$afterCallbacks;

                    if (!preDelete) {
                      _context8.next = 4;
                      break;
                    }

                    _context8.next = 4;
                    return this.preDelete();

                  case 4:
                    // calls the complete set of callbacks that should be called
                    // before the concrete data store delete operation
                    _iterator5 = _createForOfIteratorHelper(beforeCallbacks);
                    _context8.prev = 5;

                    _iterator5.s();

                  case 7:
                    if ((_step5 = _iterator5.n()).done) {
                      _context8.next = 13;
                      break;
                    }

                    callback = _step5.value;
                    _context8.next = 11;
                    return callback(this, this.model);

                  case 11:
                    _context8.next = 7;
                    break;

                  case 13:
                    _context8.next = 18;
                    break;

                  case 15:
                    _context8.prev = 15;
                    _context8.t0 = _context8["catch"](5);

                    _iterator5.e(_context8.t0);

                  case 18:
                    _context8.prev = 18;

                    _iterator5.f();

                    return _context8.finish(18);

                  case 21:
                    conditions = {};
                    conditions[this.constructor.idName] = this.identifier;
                    _context8.next = 25;
                    return this.constructor.collection.findOneAndDelete(conditions);

                  case 25:
                    // calls the complete set of callbacks that should be called
                    // after the concrete data store delete operation
                    _iterator6 = _createForOfIteratorHelper(afterCallbacks);
                    _context8.prev = 26;

                    _iterator6.s();

                  case 28:
                    if ((_step6 = _iterator6.n()).done) {
                      _context8.next = 34;
                      break;
                    }

                    _callback2 = _step6.value;
                    _context8.next = 32;
                    return _callback2(this, this.model);

                  case 32:
                    _context8.next = 28;
                    break;

                  case 34:
                    _context8.next = 39;
                    break;

                  case 36:
                    _context8.prev = 36;
                    _context8.t1 = _context8["catch"](26);

                    _iterator6.e(_context8.t1);

                  case 39:
                    _context8.prev = 39;

                    _iterator6.f();

                    return _context8.finish(39);

                  case 42:
                    if (!postDelete) {
                      _context8.next = 45;
                      break;
                    }

                    _context8.next = 45;
                    return this.postDelete();

                  case 45:
                    return _context8.abrupt("return", this);

                  case 46:
                  case "end":
                    return _context8.stop();
                }
              }
            }, _callee7, this, [[5, 15, 18, 21], [26, 36, 39, 42]]);
          }));

          function _delete() {
            return _delete2.apply(this, arguments);
          }

          return _delete;
        }()
      }, {
        key: "reload",
        value: function () {
          var _reload = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
            var params,
                model,
                _args9 = arguments;
            return regeneratorRuntime.wrap(function _callee8$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    params = _args9.length > 0 && _args9[0] !== undefined ? _args9[0] : {};

                    if (!this.isNew) {
                      _context9.next = 3;
                      break;
                    }

                    throw new OperationalError("Can't reload a new model entity", 412);

                  case 3:
                    _context9.next = 5;
                    return this.constructor.get(_objectSpread2(_objectSpread2({}, params), {}, {
                      _id: this._id
                    }));

                  case 5:
                    model = _context9.sent;
                    return _context9.abrupt("return", model);

                  case 7:
                  case "end":
                    return _context9.stop();
                }
              }
            }, _callee8, this);
          }));

          function reload() {
            return _reload.apply(this, arguments);
          }

          return reload;
        }()
        /**
         * Runs a series of assertions on the current model
         * definition raising assertion errors in case there
         * are issues with the internal structure of it.
         */

      }, {
        key: "verify",
        value: function () {
          var _verify2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
            var _i4, _Object$entries3, _Object$entries3$_i, name, field;

            return regeneratorRuntime.wrap(function _callee9$(_context10) {
              while (1) {
                switch (_context10.prev = _context10.next) {
                  case 0:
                    verify(this.identifier !== undefined && this.identifier !== null, "The identifier must be defined before saving");

                    for (_i4 = 0, _Object$entries3 = Object.entries(this.constructor.schema); _i4 < _Object$entries3.length; _i4++) {
                      _Object$entries3$_i = _slicedToArray(_Object$entries3[_i4], 2), name = _Object$entries3$_i[0], field = _Object$entries3$_i[1];

                      verify(!field.required || ![undefined, null].includes(this[name]), "No value provided for mandatory field '".concat(name, "'"));
                    }

                  case 2:
                  case "end":
                    return _context10.stop();
                }
              }
            }, _callee9, this);
          }));

          function verify$1() {
            return _verify2.apply(this, arguments);
          }

          return verify$1;
        }()
      }, {
        key: "preSave",
        value: function () {
          var _preSave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
            return regeneratorRuntime.wrap(function _callee10$(_context11) {
              while (1) {
                switch (_context11.prev = _context11.next) {
                  case 0:
                  case "end":
                    return _context11.stop();
                }
              }
            }, _callee10);
          }));

          function preSave() {
            return _preSave.apply(this, arguments);
          }

          return preSave;
        }()
      }, {
        key: "preCreate",
        value: function () {
          var _preCreate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
            return regeneratorRuntime.wrap(function _callee11$(_context12) {
              while (1) {
                switch (_context12.prev = _context12.next) {
                  case 0:
                  case "end":
                    return _context12.stop();
                }
              }
            }, _callee11);
          }));

          function preCreate() {
            return _preCreate.apply(this, arguments);
          }

          return preCreate;
        }()
      }, {
        key: "preUpdate",
        value: function () {
          var _preUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
            return regeneratorRuntime.wrap(function _callee12$(_context13) {
              while (1) {
                switch (_context13.prev = _context13.next) {
                  case 0:
                  case "end":
                    return _context13.stop();
                }
              }
            }, _callee12);
          }));

          function preUpdate() {
            return _preUpdate.apply(this, arguments);
          }

          return preUpdate;
        }()
      }, {
        key: "preDelete",
        value: function () {
          var _preDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
            return regeneratorRuntime.wrap(function _callee13$(_context14) {
              while (1) {
                switch (_context14.prev = _context14.next) {
                  case 0:
                  case "end":
                    return _context14.stop();
                }
              }
            }, _callee13);
          }));

          function preDelete() {
            return _preDelete.apply(this, arguments);
          }

          return preDelete;
        }()
      }, {
        key: "postSave",
        value: function () {
          var _postSave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
            return regeneratorRuntime.wrap(function _callee14$(_context15) {
              while (1) {
                switch (_context15.prev = _context15.next) {
                  case 0:
                  case "end":
                    return _context15.stop();
                }
              }
            }, _callee14);
          }));

          function postSave() {
            return _postSave.apply(this, arguments);
          }

          return postSave;
        }()
      }, {
        key: "postCreate",
        value: function () {
          var _postCreate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
            return regeneratorRuntime.wrap(function _callee15$(_context16) {
              while (1) {
                switch (_context16.prev = _context16.next) {
                  case 0:
                  case "end":
                    return _context16.stop();
                }
              }
            }, _callee15);
          }));

          function postCreate() {
            return _postCreate.apply(this, arguments);
          }

          return postCreate;
        }()
      }, {
        key: "postUpdate",
        value: function () {
          var _postUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
            return regeneratorRuntime.wrap(function _callee16$(_context17) {
              while (1) {
                switch (_context17.prev = _context17.next) {
                  case 0:
                  case "end":
                    return _context17.stop();
                }
              }
            }, _callee16);
          }));

          function postUpdate() {
            return _postUpdate.apply(this, arguments);
          }

          return postUpdate;
        }()
      }, {
        key: "postDelete",
        value: function () {
          var _postDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
            return regeneratorRuntime.wrap(function _callee17$(_context18) {
              while (1) {
                switch (_context18.prev = _context18.next) {
                  case 0:
                  case "end":
                    return _context18.stop();
                }
              }
            }, _callee17);
          }));

          function postDelete() {
            return _postDelete.apply(this, arguments);
          }

          return postDelete;
        }()
      }, {
        key: "identifier",
        get: function get() {
          return this[this.constructor.idName];
        }
      }], [{
        key: "_getAttrs",
        value: function _getAttrs(params, attrs) {
          var _attrs = [];
          attrs.forEach(function (_ref3) {
            var _ref4 = _slicedToArray(_ref3, 2),
                attr = _ref4[0],
                value = _ref4[1];

            if (params[attr] === undefined) {
              _attrs.push(value);

              return;
            }

            var _value = params[attr];
            delete params[attr];

            _attrs.push(_value);
          });
          return _attrs;
        }
      }, {
        key: "get",
        value: function () {
          var _get = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
            var params,
                _this$_getAttrs,
                _this$_getAttrs2,
                skip,
                limit,
                sort,
                raiseE,
                sortObject,
                found,
                message,
                model,
                _args19 = arguments;

            return regeneratorRuntime.wrap(function _callee18$(_context19) {
              while (1) {
                switch (_context19.prev = _context19.next) {
                  case 0:
                    params = _args19.length > 0 && _args19[0] !== undefined ? _args19[0] : {};

                    /* eslint-disable no-unused-vars */
                    _this$_getAttrs = this._getAttrs(params, [["fields", null], ["eager", null], ["eagerL", null], ["map", false], ["rules", true], ["meta", false], ["build", true], ["fill", true], ["resolveA", null], ["skip", 0], ["limit", 0], ["sort", null], ["raiseE", true]]), _this$_getAttrs2 = _slicedToArray(_this$_getAttrs, 13), _this$_getAttrs2[0], _this$_getAttrs2[1], _this$_getAttrs2[2], _this$_getAttrs2[3], _this$_getAttrs2[4], _this$_getAttrs2[5], _this$_getAttrs2[6], _this$_getAttrs2[7], _this$_getAttrs2[8], skip = _this$_getAttrs2[9], limit = _this$_getAttrs2[10], sort = _this$_getAttrs2[11], raiseE = _this$_getAttrs2[12];
                    /* eslint-enable no-unused-vars */

                    sortObject = {};

                    if (sort) {
                      sort.forEach(function (_ref5) {
                        var _ref6 = _slicedToArray(_ref5, 2),
                            key = _ref6[0],
                            value = _ref6[1];

                        return sortObject[key] = value;
                      });
                    }

                    _context19.next = 6;
                    return this.collection.findOne(params, this.fields, {
                      skip: skip,
                      limit: limit,
                      sort: sortObject
                    });

                  case 6:
                    found = _context19.sent;

                    if (!(!found && raiseE)) {
                      _context19.next = 10;
                      break;
                    }

                    if (_isDevel()) {
                      message = "".concat(this.name, " not found for ").concat(JSON.stringify(params));
                    } else {
                      message = "".concat(this.name, " not found");
                    }

                    throw new NotFoundError(message);

                  case 10:
                    if (!found) {
                      _context19.next = 16;
                      break;
                    }

                    _context19.next = 13;
                    return new this().wrap(found);

                  case 13:
                    _context19.t0 = _context19.sent;
                    _context19.next = 17;
                    break;

                  case 16:
                    _context19.t0 = found;

                  case 17:
                    model = _context19.t0;
                    return _context19.abrupt("return", model);

                  case 19:
                  case "end":
                    return _context19.stop();
                }
              }
            }, _callee18, this);
          }));

          function get() {
            return _get.apply(this, arguments);
          }

          return get;
        }()
      }, {
        key: "find",
        value: function () {
          var _find = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
            var _this = this;

            var params,
                _this$_getAttrs3,
                _this$_getAttrs4,
                skip,
                limit,
                sort,
                raiseE,
                sortObject,
                found,
                message,
                models,
                _args20 = arguments;

            return regeneratorRuntime.wrap(function _callee19$(_context20) {
              while (1) {
                switch (_context20.prev = _context20.next) {
                  case 0:
                    params = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : {};

                    /* eslint-disable no-unused-vars */
                    _this$_getAttrs3 = this._getAttrs(params, [["fields", null], ["eager", null], ["eagerL", null], ["map", false], ["rules", true], ["meta", false], ["build", true], ["fill", true], ["resolveA", null], ["skip", 0], ["limit", 0], ["sort", null], ["raiseE", false]]), _this$_getAttrs4 = _slicedToArray(_this$_getAttrs3, 13), _this$_getAttrs4[0], _this$_getAttrs4[1], _this$_getAttrs4[2], _this$_getAttrs4[3], _this$_getAttrs4[4], _this$_getAttrs4[5], _this$_getAttrs4[6], _this$_getAttrs4[7], _this$_getAttrs4[8], skip = _this$_getAttrs4[9], limit = _this$_getAttrs4[10], sort = _this$_getAttrs4[11], raiseE = _this$_getAttrs4[12];
                    /* eslint-enable no-unused-vars */

                    this._findS(params);

                    this._findD(params);

                    sortObject = {};

                    if (sort) {
                      sort.forEach(function (_ref7) {
                        var _ref8 = _slicedToArray(_ref7, 2),
                            key = _ref8[0],
                            value = _ref8[1];

                        return sortObject[key] = value;
                      });
                    }

                    _context20.next = 8;
                    return this.collection.find(params, this.fields, {
                      skip: skip,
                      limit: limit,
                      sort: sortObject
                    });

                  case 8:
                    found = _context20.sent;

                    if (!(found.length === 0 && raiseE)) {
                      _context20.next = 12;
                      break;
                    }

                    if (_isDevel()) {
                      message = "".concat(this.name, " not found for ").concat(JSON.stringify(params));
                    } else {
                      message = "".concat(this.name, " not found");
                    }

                    throw new NotFoundError(message);

                  case 12:
                    _context20.next = 14;
                    return Promise.all(found.map(function (v) {
                      return new _this().wrap(v);
                    }));

                  case 14:
                    models = _context20.sent;
                    return _context20.abrupt("return", models);

                  case 16:
                  case "end":
                    return _context20.stop();
                }
              }
            }, _callee19, this);
          }));

          function find() {
            return _find.apply(this, arguments);
          }

          return find;
        }()
      }, {
        key: "_findD",
        value: function _findD(params) {
          // retrieves the find definition into a local variable, then
          // removes the find definition from the named arguments map
          // so that it's not going to be erroneously used by the
          // underlying find infra-structure
          var findD = params.find_d;
          delete params.find_d; // in case the find definition is currently not defined in the
          // named arguments map returns immediately as nothing is
          // meant to be done on this method

          if (!findD) return; // tries to retrieve the value of the operator that is going
          // to be used to "join" the multiple find parts (find values)

          var findO = params.find_o;
          delete params.find_o; // verifies that the data type for the find definition is a
          // valid sequence and in case its not converts it into one
          // so that it may be used in sequence valid logic

          var _findD = Array.isArray(findD) ? findD : [findD]; // iterates over all the filters defined in the filter definition
          // so that they may be used to update the provided arguments with
          // the filter defined in each of their lines


          var _iterator7 = _createForOfIteratorHelper(_findD),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var filter = _step7.value;
              // in case the filter is not valid (unset or invalid) it's going
              // to be ignored as no valid information is present
              if (!filter) continue; // splits the filter string into its three main components
              // the name, operator and value, that are going to be processed
              // as defined by the specification to create the filter

              var result = filter.split(":", 3);
              if (result.length === 2) result.push(null); // unpacks the result into it's thee components name, operator
              // and value to be used in the parsing of the filter

              var _result = _slicedToArray(result, 3),
                  name = _result[0],
                  operator = _result[1],
                  value = _result[2]; // retrieves the definition for the filter attribute and uses
              // it to retrieve it's target data type that is going to be
              // used for the proper conversion, note that in case the base
              // type resolution method exists it's used (recursive resolution)


              var nameDefinition = this.definitionN(name);
              var nameT = nameDefinition._btype || nameDefinition.type || String; // determines if the current filter operation should be performed
              // using a case insensitive based approach to the search, by default
              // all of the operations are considered to be case sensitive

              var insensitive = INSENSITIVE[operator] || false; // retrieves the method that is going to be used for value mapping
              // or conversion based on the current operator and then converts
              // the operator into the domain specific operator

              var valueMethod = VALUE_METHODS[operator];

              var _operator = OPERATORS[operator] === undefined ? operator : OPERATORS[operator]; // in case there's a custom value mapped retrieved uses it to convert
              // the string based value into the target specific value for the query
              // otherwise uses the data type for the search field for value conversion


              var _value = valueMethod ? valueMethod(value, nameT) : nameT(value); // constructs the custom find value using a key and value map value
              // in case the operator is defined otherwise (operator not defined)
              // the value is used directly, then merges this find value into the
              // current set of filters for the provided (keyword) arguments


              var findV = void 0;

              if (_operator) {
                var obj = {};
                obj[_operator] = _value;
                findV = obj;
              } else {
                findV = _value;
              }

              if (insensitive) findV.$options = "-i";

              this._filterMerge(name, findV, params, findO);
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        }
      }, {
        key: "_findS",
        value: function _findS(params) {
          // tries to retrieve the find name value from the provided
          // named arguments defaulting to an unset value otherwise
          var findN = params.find_n;
          delete params.find_n; // retrieves the kind of insensitive strategy that is going
          // to be used for the resolution of regular expressions,
          // this should affect all the filters and so it should be
          // used with some amount of care

          var findI = params.find_i || false;
          delete params.find_i; // retrieves the kind of default operation to be performed
          // this may be either: right, left or both and the default
          // value is both so that the token is matched in case it
          // appears anywhere in the search string

          var findT = params.find_t || "both";
          delete params.find_t; // retrieves the find string into a local variable, then
          // removes the find string from the named arguments map
          // so that it's not going to be erroneously used by the
          // underlying find infra-structure

          var findS = params.find_s;
          delete params.find_s; // in case the find string is currently not defined in the
          // named arguments map returns immediately as nothing is
          // meant to be done on this method

          if (!findS) return; // retrieves the "name" of the attribute that is considered
          // to be the default (representation) for the model in case
          // there's none returns immediately, as it's not possible
          // to proceed with the filter creation

          var defaultName = findN || this["default"]; // TODO DEFAULT WORKS?

          if (!defaultName) return; // constructs the proper right and left parts of the regex
          // that is going to be constructed for the matching of the
          // value, this is achieved by checking the find type

          var right = findT === "right" ? "^" : "";
          var left = findT === "left" ? "$" : ""; // retrieves the definition for the default attribute and uses
          // it to retrieve it's target data type, defaulting to the
          // string type in case none is defined in the schema

          var defaultT = this.definitionN(defaultName).type || String;
          var findV;

          try {
            // in case the target date type for the default field is
            // string the both sides wildcard regex is used for the
            // search
            if (defaultT === String) {
              findV = {
                $regex: right + escapeStringRegexp(findS) + left,
                $options: findI ? "-i" : ""
              };
            } else {
              findV = null;
            }
          } catch (err) {
            // in case there's an error in the conversion for
            // the target type value sets the search value as
            // invalid (not going to be used in filter)
            findV = null;
          }

          if (findV) this._filterMerge(defaultName, findV, params);
        }
      }, {
        key: "fields",
        get: function get() {
          return Object.keys(this.schema);
        }
      }, {
        key: "default",
        get: function get() {
          var defaultEntry = Object.entries(this.schema).find(function (_ref9) {
            var _ref10 = _slicedToArray(_ref9, 2);
                _ref10[0];
                var definition = _ref10[1];

            return definition["default"];
          });
          return defaultEntry ? defaultEntry[0] : null;
        }
      }, {
        key: "definitionN",
        value: function definitionN(name) {
          return this.schema[name] || {};
        }
      }, {
        key: "_filterMerge",
        value: function _filterMerge(name, filter, params) {
          var operator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
          // retrieves a possible previous filter defined for the
          // provided name in case it does exist must concatenate
          // that previous value in a join statement according to
          // the currently defined operator
          var filterP = params[name];

          if (filterP || operator) {
            // defaults the operator for the join of the names to the
            // value and then ensures that the value of the operator
            // is within a valid range of values
            var _operator = operator || "$and";

            verify(["$and", "$or"].includes(_operator)); // retrieves the and references for the current arguments
            // and appends the two filter values (current and previous)
            // then deletes the current name reference in the arguments
            // and updates the name value to the and value


            var filterA = params[_operator] || []; // builds the filter object assigned to the name of the
            // variable and adds to the list of values

            var _filter = {};
            _filter[name] = filter;
            filterA.push(_filter); // in case there's a previous filter also adds it to the
            // list of filter values

            if (filterP) {
              var _filterP = {};
              _filterP[name] = filterP;
              filterA.push(_filterP);
            } // updates the filter reference and updates the operator
            // name (as expected)


            filter = filterA;
            delete params[name];
            name = _operator;
          } // sets the currently defined filter structures in the keyword
          // based arguments map for the currently defined name


          params[name] = filter;
        }
      }, {
        key: "schema",
        get: function get() {
          throw new NotImplementedError();
        }
        /**
         * Safer version of the schema structure that filters
         * some of the field attributes making it suitable to
         * be used by some of the collection adapters.
         */

      }, {
        key: "schemaSafe",
        get: function get() {
          var schema = {};

          for (var _i5 = 0, _Object$entries4 = Object.entries(this.schema); _i5 < _Object$entries4.length; _i5++) {
            var _Object$entries4$_i = _slicedToArray(_Object$entries4[_i5], 2),
                key = _Object$entries4$_i[0],
                value = _Object$entries4$_i[1];

            schema[key] = {
              type: value.type || String,
              index: value.index || false
            };
          }

          return schema;
        }
      }, {
        key: "collection",
        get: function get() {
          if (this._collectionI) return this._collectionI;
          this._collectionI = this._collection(this.dataOptions);
          return this._collectionI;
        }
      }, {
        key: "idName",
        get: function get() {
          return "id";
        }
      }, {
        key: "dataOptions",
        get: function get() {
          return {
            name: this.name,
            schema: this.schemaSafe
          };
        }
      }, {
        key: "increments",
        get: function get() {
          if (this._increments !== undefined) return this._increments;
          var increments = [];

          for (var _i6 = 0, _Object$entries5 = Object.entries(this.schema); _i6 < _Object$entries5.length; _i6++) {
            var _Object$entries5$_i = _slicedToArray(_Object$entries5[_i6], 2),
                name = _Object$entries5$_i[0],
                value = _Object$entries5$_i[1];

            var isIncrement = value.increment || false;
            if (!isIncrement) continue;
            increments.push(name);
          }

          this._increments = increments;
          return increments;
        }
      }, {
        key: "_collection",
        value: function _collection(options) {
          var adapter = this.adapter[0].toUpperCase() + this.adapter.slice(1);
          return new collection[adapter + "Collection"](options);
        }
      }, {
        key: "_increment",
        value: function () {
          var _increment2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(name) {
            var _name, store, result;

            return regeneratorRuntime.wrap(function _callee20$(_context21) {
              while (1) {
                switch (_context21.prev = _context21.next) {
                  case 0:
                    _name = this.name + ":" + name;
                    store = this._collection({
                      name: "counters",
                      schema: {
                        id: {
                          type: String,
                          index: true
                        },
                        seq: {
                          type: Number
                        }
                      }
                    });
                    _context21.next = 4;
                    return store.findOneAndUpdate({
                      id: _name
                    }, {
                      $inc: {
                        seq: 1
                      }
                    }, {
                      "new": true,
                      upsert: true
                    });

                  case 4:
                    result = _context21.sent;
                    _context21.t0 = result;

                    if (_context21.t0) {
                      _context21.next = 10;
                      break;
                    }

                    _context21.next = 9;
                    return store.findOne({
                      id: _name
                    });

                  case 9:
                    _context21.t0 = _context21.sent;

                  case 10:
                    result = _context21.t0;
                    return _context21.abrupt("return", result.seq);

                  case 12:
                  case "end":
                    return _context21.stop();
                }
              }
            }, _callee20, this);
          }));

          function _increment(_x4) {
            return _increment2.apply(this, arguments);
          }

          return _increment;
        }()
      }, {
        key: "_ensureMin",
        value: function () {
          var _ensureMin2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(name, value) {
            var _name, store, result;

            return regeneratorRuntime.wrap(function _callee21$(_context22) {
              while (1) {
                switch (_context22.prev = _context22.next) {
                  case 0:
                    _name = this.name + ":" + name;
                    store = this._collection({
                      name: "counters",
                      schema: {
                        id: {
                          type: String
                        },
                        seq: {
                          type: Number
                        }
                      }
                    });
                    _context22.next = 4;
                    return store.findOneAndUpdate({
                      id: _name
                    }, {
                      $max: {
                        seq: value
                      }
                    }, {
                      "new": true,
                      upsert: true
                    });

                  case 4:
                    result = _context22.sent;
                    _context22.t0 = result;

                    if (_context22.t0) {
                      _context22.next = 10;
                      break;
                    }

                    _context22.next = 9;
                    return store.findOne({
                      id: _name
                    });

                  case 9:
                    _context22.t0 = _context22.sent;

                  case 10:
                    result = _context22.t0;
                    return _context22.abrupt("return", result.seq);

                  case 12:
                  case "end":
                    return _context22.stop();
                }
              }
            }, _callee21, this);
          }));

          function _ensureMin(_x5, _x6) {
            return _ensureMin2.apply(this, arguments);
          }

          return _ensureMin;
        }()
      }]);

      return ModelStore;
    }(Model);
    var ModelMemory = /*#__PURE__*/function (_ModelStore) {
      _inherits(ModelMemory, _ModelStore);

      var _super2 = _createSuper(ModelMemory);

      function ModelMemory() {
        _classCallCheck(this, ModelMemory);

        return _super2.apply(this, arguments);
      }

      _createClass(ModelMemory, null, [{
        key: "adapter",
        get: function get() {
          return "memory";
        }
      }, {
        key: "dataOptions",
        get: function get() {
          return Object.assign(_get(_getPrototypeOf(ModelMemory), "dataOptions", this), {
            storage: this.storage
          });
        }
      }, {
        key: "storage",
        get: function get() {
          return MEMORY_STORAGE[this.name];
        }
      }]);

      return ModelMemory;
    }(ModelStore);
    /**
     * Retrieves the default (initial) value for the a certain
     * provided data type falling back to the provided default
     * value in case it's not possible to retrieve a new valid
     *  default for value for the type.
     *
     * The process of retrieval of the default value to a certain
     * type may include the calling of a lambda function to obtain
     * a new instance of the default value, this avoid the usage
     * of global shared structures for the default values, that
     * could cause extremely confusing situations.
     *
     * @param {Type} type The data type object for which to retrieve its
     * default value.
     * @param {Object} _default The default value to be returned in case it's
     * not possible to retrieve a better one.
     * @returns {Object} The "final" default value for the data type according
     * to the best possible strategy.
     */

    var typeD = function typeD(type) {
      var _default = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (TYPE_DEFAULTS[type] === undefined) return _default;
      _default = TYPE_DEFAULTS[type];
      if (typeof _default !== "function") return _default;
      return _default();
    };

    var ensureExpress = function ensureExpress(token) {
      return function (req, res, next) {
        ensurePermissions(token, req)["catch"](next).then(next);
      };
    };

    var ensureFastify = function ensureFastify(token) {
      return function (req, res, next) {
        ensurePermissions(token, req)["catch"](next).then(next);
      };
    };

    var yoniusRollup = function yoniusRollup() {
      return {
        name: "yonius",
        resolveId: function resolveId(importee) {
          switch (importee) {
            case "fs":
            case "node-fetch":
              return importee;

            default:
              return null;
          }
        },
        load: function load(id) {
          switch (id) {
            case "fs":
              return "export const promises = {};";

            case "node-fetch":
              return "export default fetch;";

            default:
              return null;
          }
        }
      };
    };

    var NAME = name;
    var VERSION = version;

    exports.ALIAS = ALIAS;
    exports.API = API;
    exports.Collection = Collection;
    exports.FIND_DEFAULTS = FIND_DEFAULTS;
    exports.FIND_TYPES = FIND_TYPES;
    exports.FileTuple = FileTuple;
    exports.INSENSITIVE = INSENSITIVE;
    exports.MixinBuilder = MixinBuilder;
    exports.Model = Model;
    exports.ModelMemory = ModelMemory;
    exports.ModelStore = ModelStore;
    exports.MongoCollection = MongoCollection;
    exports.NAME = NAME;
    exports.NotFoundError = NotFoundError;
    exports.NotImplementedError = NotImplementedError;
    exports.OAuth1API = OAuth1API;
    exports.OAuth2API = OAuth2API;
    exports.OAuthAPI = OAuthAPI;
    exports.OPERATORS = OPERATORS;
    exports.Observable = Observable;
    exports.OperationalError = OperationalError;
    exports.SORT_MAP = SORT_MAP;
    exports.VALUE_METHODS = VALUE_METHODS;
    exports.VERSION = VERSION;
    exports.ValidationError = ValidationError;
    exports.YoniusError = YoniusError;
    exports._castR = _castR;
    exports._isDevel = _isDevel;
    exports._isSecure = _isSecure;
    exports._isValid = _isValid;
    exports.absoluteUrl = absoluteUrl;
    exports.camelToUnderscore = camelToUnderscore;
    exports.conf = conf;
    exports.confP = confP;
    exports.confS = confS;
    exports.destroyMongo = destroyMongo;
    exports.ensureExpress = ensureExpress;
    exports.ensureFastify = ensureFastify;
    exports.ensurePermissions = ensurePermissions;
    exports.eq = eq;
    exports.equal = equal;
    exports.escapeStringRegexp = escapeStringRegexp;
    exports.expandUser = expandUser;
    exports.getEnv = getEnv;
    exports.getEnvObject = getEnvObject;
    exports.getObject = getObject;
    exports.globals = globals;
    exports.gt = gt;
    exports.gte = gte;
    exports.initMongo = initMongo;
    exports.isEmail = isEmail;
    exports.isIn = isIn;
    exports.isLower = isLower;
    exports.isPrimitive = isPrimitive;
    exports.isRegex = isRegex;
    exports.isSimple = isSimple;
    exports.isUpper = isUpper;
    exports.isUrl = isUrl;
    exports.load = load$1;
    exports.loadConf = load;
    exports.mix = mix;
    exports.notEmpty = notEmpty;
    exports.pathExists = pathExists;
    exports.register = register;
    exports.request = request;
    exports.sizeRoundUnit = sizeRoundUnit;
    exports.stringEq = stringEq;
    exports.stringGt = stringGt;
    exports.stringLt = stringLt;
    exports.toTokensM = toTokensM;
    exports.typeD = typeD;
    exports.typeof_ = typeof_;
    exports.unload = unload;
    exports.unregister = unregister;
    exports.urlEncode = urlEncode;
    exports.verify = verify;
    exports.verifyEqual = verifyEqual;
    exports.verifyMany = verifyMany;
    exports.verifyNotEqual = verifyNotEqual;
    exports.yoniusRollup = yoniusRollup;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=yonius.umd.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(103), __webpack_require__(310)))

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NAME", function() { return NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony import */ var _package_json__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
var _package_json__WEBPACK_IMPORTED_MODULE_0___namespace = /*#__PURE__*/__webpack_require__.t(130, 1);
/* harmony import */ var _js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RipeCommonsCapability", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RipeCommonsPlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["k"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RipeCommonsMainPlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["j"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalePlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DomLocaleLoaderPlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FileLocaleLoaderPlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelLocaleLoaderPlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ModelLocaleResolverPlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BasePersonalizationPlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseSizePlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "normalize", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["r"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DevicePlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SHOW_LEVEL", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["l"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "logError", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["p"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "logInfo", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["q"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "logDebug", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["o"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "initialsFromExtra", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["n"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UrlChangerPlugin", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["m"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "registerPlugins", function() { return _js__WEBPACK_IMPORTED_MODULE_1__["s"]; });

/* harmony import */ var _vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "install", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["G"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Alert", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonPlatforme", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["h"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["i"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Loader", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["m"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Thumbnail", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["w"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InitialsImages", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["j"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InitialsInputs", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["k"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "personalizationForm", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["P"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sizeForm", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["W"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Ask", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentPlugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Keyboard", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["l"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["n"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RestrictionsAlert", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["s"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["u"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tabs", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["v"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Thumbnails", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["x"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ThumbnailsGroups", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["y"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Configurator", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["f"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Personalization", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["p"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pickers", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["q"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Size", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["t"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Global", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["g"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Money", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["o"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "readable", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["S"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "deviceMixin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["B"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "localeMixin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["I"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "loggingMixin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["K"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "logicMixin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["L"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "modalMixin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["N"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "partMixin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["O"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "utilsMixin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["Z"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "installMixins", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["H"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Plugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["r"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "registerPlugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["T"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "unregisterPlugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["Y"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getPlugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["E"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hasPlugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["F"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "busPlugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["z"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "localePlugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["J"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ripePlugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["U"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "store", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["X"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getFavicon", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["D"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setFavicon", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["V"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "waitP", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["ab"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "components", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["A"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "filters", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["C"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "mixins", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["M"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "plugins", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["R"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "plugin", function() { return _vue__WEBPACK_IMPORTED_MODULE_2__["Q"]; });




var NAME = _package_json__WEBPACK_IMPORTED_MODULE_0__[/* name */ "a"];
var VERSION = _package_json__WEBPACK_IMPORTED_MODULE_0__[/* version */ "b"];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(3);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 255 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 256 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : undefined
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 258 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 259 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 260 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var account = __webpack_require__(262);

var availabilityRule = __webpack_require__(273);

var brand = __webpack_require__(274);

var build = __webpack_require__(275);

var config = __webpack_require__(276);

var countryGroup = __webpack_require__(277);

var factoryRule = __webpack_require__(278);

var justification = __webpack_require__(279);

var letterRule = __webpack_require__(280);

var locale = __webpack_require__(281);

var notifyInfo = __webpack_require__(282);

var oauth = __webpack_require__(283);

var order = __webpack_require__(284);

var priceRule = __webpack_require__(285);

var profile = __webpack_require__(286);

var size = __webpack_require__(287);

var sku = __webpack_require__(288);

Object.assign(module.exports, account);
Object.assign(module.exports, availabilityRule);
Object.assign(module.exports, brand);
Object.assign(module.exports, build);
Object.assign(module.exports, config);
Object.assign(module.exports, countryGroup);
Object.assign(module.exports, factoryRule);
Object.assign(module.exports, justification);
Object.assign(module.exports, letterRule);
Object.assign(module.exports, locale);
Object.assign(module.exports, notifyInfo);
Object.assign(module.exports, oauth);
Object.assign(module.exports, order);
Object.assign(module.exports, priceRule);
Object.assign(module.exports, profile);
Object.assign(module.exports, size);
Object.assign(module.exports, sku);

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Retrieves the complete set of account data to the current session.
 *
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.accountMe = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "accounts/me");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves the complete set of account data to the current session.
 *
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {Promise} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.accountMeP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.accountMe(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(20);

var _regeneratorRuntime = __webpack_require__(0);

var _asyncToGenerator = __webpack_require__(1);

var _slicedToArray = __webpack_require__(5);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16); // eslint-disable-next-line no-redeclare,no-var


  var compat = __webpack_require__(167);

  __webpack_require__(27); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe; // eslint-disable-next-line no-redeclare,no-var

  var fetch = compat.fetch; // eslint-disable-next-line no-redeclare,no-var

  var XMLHttpRequest = compat.XMLHttpRequest;
}
/**
 * @class
 * @classdesc The API class to be instantiated. Implements all the API interfaces.
 * @param {Object} options The options to be used to configure the API client.
 * @returns {Ripe} The newly created RipeAPI object.
 */


ripe.RipeAPI = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  options.cached = typeof options.cached === "undefined" ? false : options.cached;
  options.noBundles = typeof options.noBundles === "undefined" ? true : options.noBundles;
  return new ripe.Ripe(options);
};
/**
 * Runs a simple "ping" operation to validate the connection with the
 * Core server-side.
 *
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.ping = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "ping");
  options = Object.assign(options, {
    url: url,
    method: "GET"
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.pingP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.ping(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Runs the GeoIP resolution process so that it's possible to uncover
 * more geographical information about the current user.
 *
 * @param {String} address The optional address to be used in case the address
 * of the IP request is not desired.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.geoResolve = function (address, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "geo_resolve");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      address: address
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.geoResolveP = function (address, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.geoResolve(address, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves the complete set of session elements to be used, such as:
 * the 'sid ', 'session_id', 'username ', 'name', 'email' and 'tokens'.
 *
 * @param {String} username The username to authenticate.
 * @param {String} password The username's password.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.signin = function (username, password, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "signin");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    params: {
      username: username,
      password: password
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.signinP = function (username, password, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.signin(username, password, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves the complete set of session elements to be used, such as:
 * the 'sid ', 'session_id', 'username ', 'name', 'email' and 'tokens'.
 *
 * This strategy uses the admin back-end for authentication.
 *
 * @param {String} username The username to authenticate.
 * @param {String} password The username's password.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.signinAdmin = function (username, password, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "signin_admin");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    params: {
      username: username,
      password: password
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.signinAdminP = function (username, password, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.signinAdmin(username, password, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves the complete set of session elements to be used, such as:
 * the 'sid ', 'session_id', 'username ', 'name', 'email'.
 *
 * @param {String} token The authentication token.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.signinPid = function (token, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "signin_pid");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    params: {
      token: token
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.signinPidP = function (token, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.signinAdmin(token, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves the price for current customization.
 *
 * @param {Object} options An Object containing customization information that
 * can be used to override the current customization, allowing to set the
 * 'brand', 'model' and 'parts'.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getPrice = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getPriceOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.getPriceP = function (options) {
  var _this6 = this;

  return new Promise(function (resolve, reject) {
    _this6.getPrice(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._cacheURL = function (url, options, callback) {
  var _this7 = this;

  // runs the defaulting operation on the provided options
  // optional parameter (ensures valid object there)
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options; // builds the (base) key value for the provided value
  // from options or used the default one

  var key = options.key || "default"; // creates the full key by adding the base key to the
  // URL value (including query string), this is unique
  // assuming no request payload

  var query = this._buildQuery(options.params || {});

  var fullKey = key + ":" + url + ":" + query; // determines if the current request should be cached, obeys
  // some of the basic rules for that behaviour

  var cached = options.cached;
  cached = typeof cached === "undefined" ? this.options.cached : cached;
  cached = typeof cached === "undefined" ? true : cached;
  cached = cached && !options.force && ["GET"].indexOf(options.method || "GET") !== -1; // determines if the cache entry should be invalidated before
  // making the request, it should only be invalidate in case the
  // the current request is being done with the cached flag

  var invalidate = options.invalidate;
  invalidate = typeof invalidate === "undefined" ? false : invalidate;
  invalidate = cached && invalidate; // initializes the cache object in the current instance
  // in case it does not exists already

  this._cache = this._cache === undefined ? {} : this._cache; // in case the invalidate flag is set then the cache for the
  // current key should be removed (invalidated)

  if (invalidate) delete this._cache[fullKey]; // in case there's already a valid value in cache,
  // retrieves it and calls the callback with the value

  if (this._cache[fullKey] !== undefined && cached) {
    if (callback) callback(this._cache[fullKey], true, null);
    return null;
  } // otherwise runs the "normal" request URL call and
  // sets the result cache key on return


  return this._requestURL(url, options, function (result, isValid, request) {
    if (isValid && cached) {
      _this7._cache[fullKey] = result;
    }

    if (callback) callback(result, isValid, request);
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._requestURL = function (url, options, callback) {
  if (typeof fetch !== "undefined") return this._requestURLFetch(url, options, callback);else return this._requestURLLegacy(url, options, callback);
};
/**
 * @ignore
 */


ripe.Ripe.prototype._requestURLFetch = function (url, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var context = this;
  var method = options.method || "GET";
  var params = options.params || {};
  var headers = options.headers || {};
  var data = options.data || null;
  var dataJ = options.dataJ || null;
  var dataM = options.dataM || null;
  var contentType = options.contentType || null;
  var validCodes = options.validCodes || [200];
  var credentials = options.credentials || "omit";

  var query = this._buildQuery(params);

  var isEmpty = ["GET", "DELETE"].indexOf(method) !== -1;
  var hasQuery = url.indexOf("?") !== -1;
  var separator = hasQuery ? "&" : "?";

  if (isEmpty || data) {
    url += separator + query;
  } else if (dataJ !== null) {
    data = JSON.stringify(dataJ);
    url += separator + query;
    contentType = "application/json";
  } else if (dataM !== null) {
    url += separator + query;

    var _this$_encodeMultipar = this._encodeMultipart(dataM, contentType, true);

    var _this$_encodeMultipar2 = _slicedToArray(_this$_encodeMultipar, 2);

    contentType = _this$_encodeMultipar2[0];
    data = _this$_encodeMultipar2[1];
  } else {
    data = query;
    contentType = "application/x-www-form-urlencoded";
  }

  if (contentType) {
    headers["Content-Type"] = headers["Content-Type"] || contentType;
  }

  var response = fetch(url, {
    method: method,
    headers: headers || {},
    body: data,
    credentials: credentials
  });
  response.then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
      var result, isValid, contentType;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              result = null;
              isValid = validCodes.includes(response.status);
              contentType = response.headers.get("content-type").toLowerCase();
              _context.prev = 3;

              if (!contentType.startsWith("application/json")) {
                _context.next = 10;
                break;
              }

              _context.next = 7;
              return response.json();

            case 7:
              result = _context.sent;
              _context.next = 19;
              break;

            case 10:
              if (!contentType.startsWith("text/")) {
                _context.next = 16;
                break;
              }

              _context.next = 13;
              return response.text();

            case 13:
              result = _context.sent;
              _context.next = 19;
              break;

            case 16:
              _context.next = 18;
              return response.blob();

            case 18:
              result = _context.sent;

            case 19:
              _context.next = 26;
              break;

            case 21:
              _context.prev = 21;
              _context.t0 = _context["catch"](3);
              response.error = response.error || _context.t0;
              callback.call(context, result, isValid, response);
              return _context.abrupt("return");

            case 26:
              if (callback) callback.call(context, result, isValid, response);

            case 27:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 21]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }())["catch"](function (error) {
    response.error = response.error || error;
    if (callback) callback.call(context, null, false, response);
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._requestURLLegacy = function (url, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var context = this;
  var method = options.method || "GET";
  var params = options.params || {};
  var headers = options.headers || {};
  var data = options.data || null;
  var dataJ = options.dataJ || null;
  var dataM = options.dataM || null;
  var contentType = options.contentType || null;
  var timeout = options.timeout || 10000;
  var timeoutConnect = options.timeoutConnect || parseInt(timeout / 2);
  var validCodes = options.validCodes || [200];
  var withCredentials = options.withCredentials || false;

  var query = this._buildQuery(params);

  var isEmpty = ["GET", "DELETE"].indexOf(method) !== -1;
  var hasQuery = url.indexOf("?") !== -1;
  var separator = hasQuery ? "&" : "?";

  if (isEmpty || data) {
    url += separator + query;
  } else if (dataJ !== null) {
    data = JSON.stringify(dataJ);
    url += separator + query;
    contentType = "application/json";
  } else if (dataM !== null) {
    throw new Error("Multipart is not supported using legacy");
  } else {
    data = query;
    contentType = "application/x-www-form-urlencoded";
  }

  var request = new XMLHttpRequest();
  request.timeout = timeoutConnect;
  request.callback = callback;
  request.validCodes = validCodes;
  request.withCredentials = withCredentials;
  request.addEventListener("load", function () {
    var result = null;
    var isValid = this.validCodes.includes(this.status);

    try {
      result = JSON.parse(this.responseText);
    } catch (error) {
      result = this.responseText;
    }

    if (this.callback) this.callback.call(context, result, isValid, this);

    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  });
  request.addEventListener("error", function (error) {
    request.error = request.error || error;
    if (this.callback) this.callback.call(context, null, false, this);

    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  });
  request.addEventListener("loadstart", function () {
    context.trigger("pre_request", request, options);
  });
  request.addEventListener("loadend", function () {
    context.trigger("post_request", request, options);
  });
  request.open(method, url, true);
  request.timeoutHandler = setTimeout(function () {
    if (request.readyState === 4) return;
    request.error = new Error("Timeout on request ".concat(timeout, "ms exceeded"));
    request.abort();
  }, timeout); // in case there's a content type to be set, then sets it according
  // to the inferred or requested content type

  if (contentType) {
    request.setRequestHeader("Content-Type", contentType);
  }

  for (var key in headers) {
    var value = headers[key];
    request.setRequestHeader(key, value);
  }

  if (!options.noEvents) this.trigger("build_request", request, options);

  if (data) {
    request.send(data);
  } else {
    request.send();
  }

  return request;
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getQueryOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!options.noEvents) this.trigger("pre_query_options", options);
  var params = options.params || {};
  options.params = params;
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var variant = options.variant === undefined ? this.variant : options.variant;
  var version = options.version === undefined ? this.version : options.version;
  var frame = options.frame === undefined ? this.frame : options.frame;
  var parts = options.parts === undefined ? this.parts : options.parts;
  var engraving = options.engraving === undefined ? this.engraving : options.engraving;
  var country = options.country === undefined ? this.country : options.country;
  var currency = options.currency === undefined ? this.currency : options.currency;
  var flag = options.flag === undefined ? this.flag : options.flag;
  var full = options.full === undefined ? true : options.full;

  if (brand !== undefined && brand !== null) {
    params.brand = brand;
  }

  if (model !== undefined && model !== null) {
    params.model = model;
  }

  if (variant !== undefined && variant !== null) {
    params.variant = variant;
  }

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  if (frame !== undefined && frame !== null) {
    params.frame = frame;
  }

  if (full && engraving !== undefined && engraving !== null) {
    params.engraving = engraving;
  }

  if (full && country !== undefined && country !== null) {
    params.country = country;
  }

  if (full && currency !== undefined && currency !== null) {
    params.currency = currency;
  }

  if (full && flag !== undefined && flag !== null) {
    params.flag = flag;
  }

  if (parts !== undefined && parts !== null && Object.keys(parts).length > 0) {
    params.p = this._partsMToTriplets(parts);
  }

  if (!options.noEvents) this.trigger("post_query_options", options);
  return options;
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getInitialsOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!options.noEvents) this.trigger("pre_initials_options", options);
  var params = options.params || {};
  options.params = params;
  var initials = options.initials === undefined ? this.initials : options.initials;
  var engraving = options.engraving === undefined ? this.engraving : options.engraving;
  var initialsExtra = options.initialsExtra === undefined ? this.initialsExtra : options.initialsExtra;

  if (initials !== undefined && initials !== null && initials !== "") {
    params.initials = initials;
  }

  if (engraving !== undefined && engraving !== null) {
    params.engraving = engraving;
  }

  if (initialsExtra !== undefined && initialsExtra !== null && Object.keys(initialsExtra).length > 0) {
    params.initials_extra = this._generateExtraS(initialsExtra);
  }

  if (!options.noEvents) this.trigger("post_initials_options", options);
  return options;
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getQuery = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  options = this._getQueryOptions(options);
  return this._buildQuery(options.params);
};
/**
 * @ignore
 * @see {link http://docs.platforme.com/#config-endpoints-price}
 */


ripe.Ripe.prototype._getPriceOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!options.noEvents) this.trigger("pre_price_options", options);
  options = this._getQueryOptions(options);
  var params = options.params || {};
  options.params = params;
  var initials = options.initials === "" ? "$empty" : options.initials;

  if (initials !== undefined && initials !== null) {
    params.initials = initials;
  }

  var url = "".concat(this.url, "config/price");
  options = Object.assign(options, {
    url: url,
    method: "GET"
  });
  if (!options.noEvents) this.trigger("post_price_options", options);
  return options;
};
/**
 * @ignore
 * @see {link http://docs.platforme.com/#render-endpoints-compose}
 */


ripe.Ripe.prototype._getImageOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!options.noEvents) this.trigger("pre_image_options", options);
  options.country = options.country || null;
  options.currency = options.currency || null;
  options.full = options.full === undefined ? false : options.full;
  options = this._getQueryOptions(options);
  var params = options.params || {};
  options.params = params;
  var initials = options.initials === "" ? "$empty" : options.initials;

  if (options.format !== undefined && options.format !== null) {
    params.format = options.format;
  }

  if (options.width !== undefined && options.width !== null) {
    params.width = options.width;
  }

  if (options.height !== undefined && options.height !== null) {
    params.height = options.height;
  }

  if (options.size !== undefined && options.size !== null) {
    params.size = options.size;
  }

  if (options.background !== undefined && options.background !== null) {
    params.background = options.background;
  }

  if (options.crop !== undefined && options.crop !== null) {
    params.crop = options.crop ? "1" : "0";
  }

  if (options.profile !== undefined && options.profile !== null) {
    params.initials_profile = options.profile.join(",");
  }

  if (initials !== undefined && initials !== null) {
    params.initials = initials;
  }

  if (options.rotation !== undefined && options.rotation !== null) {
    params.rotation = options.rotation;
  }

  if (options.flip !== undefined && options.flip !== null) {
    params.flip = options.flip;
  }

  if (options.mirror !== undefined && options.mirror !== null) {
    params.mirror = options.mirror;
  }

  if (options.boundingBox !== undefined && options.boundingBox !== null) {
    params.bounding_box = options.boundingBox;
  }

  if (options.algorithm !== undefined && options.algorithm !== null) {
    params.algorithm = options.algorithm;
  }

  if (options.background !== undefined && options.background !== null) {
    params.background = options.background;
  }

  if (options.engine !== undefined && options.engine !== null) {
    params.engine = options.engine;
  }

  if (options.initialsX !== undefined && options.initialsX !== null) {
    params.initials_x = options.initialsX;
  }

  if (options.initialsY !== undefined && options.initialsY !== null) {
    params.initials_y = options.initialsY;
  }

  if (options.initialsWidth !== undefined && options.initialsWidth !== null) {
    params.initials_width = options.initialsWidth;
  }

  if (options.initialsHeight !== undefined && options.initialsHeight !== null) {
    params.initials_height = options.initialsHeight;
  }

  if (options.initialsViewport !== undefined && options.initialsViewport !== null) {
    params.initials_viewport = options.initialsViewport;
  }

  if (options.initialsColor !== undefined && options.initialsColor !== null) {
    params.initials_color = options.initialsColor;
  }

  if (options.initialsOpacity !== undefined && options.initialsOpacity !== null) {
    params.initials_opacity = options.initialsOpacity;
  }

  if (options.initialsAlign !== undefined && options.initialsAlign !== null) {
    params.initials_align = options.initialsAlign;
  }

  if (options.initialsVertical !== undefined && options.initialsVertical !== null) {
    params.initials_vertical = options.initialsVertical;
  }

  if (options.initialsEmbossing !== undefined && options.initialsEmbossing !== null) {
    params.initials_embossing = options.initialsEmbossing;
  }

  if (options.initialsRotation !== undefined && options.initialsRotation !== null) {
    params.initials_rotation = options.initialsRotation;
  }

  if (options.initialsZindex !== undefined && options.initialsZindex !== null) {
    params.initials_z_index = options.initialsZindex;
  }

  if (options.initialsAlgorithm !== undefined && options.initialsAlgorithm !== null) {
    params.initials_algorithm = options.initialsAlgorithm;
  }

  if (options.initialsBlendColor !== undefined && options.initialsBlendColor !== null) {
    params.initials_blend_color = options.initialsBlendColor;
  }

  if (options.initialsPattern !== undefined && options.initialsPattern !== null) {
    params.initials_pattern = options.initialsPattern;
  }

  if (options.initialsTexture !== undefined && options.initialsTexture !== null) {
    params.initials_texture = options.initialsTexture;
  }

  if (options.initialsExclusion !== undefined && options.initialsExclusion !== null) {
    params.initials_exclusion = options.initialsExclusion;
  }

  if (options.initialsInclusion !== undefined && options.initialsInclusion !== null) {
    params.initials_inclusion = options.initialsInclusion;
  }

  if (options.initialsImageRotation !== undefined && options.initialsImageRotation !== null) {
    params.initials_image_rotation = options.initialsImageRotation;
  }

  if (options.initialsImageFlip !== undefined && options.initialsImageFlip !== null) {
    params.initials_image_flip = options.initialsImageFlip;
  }

  if (options.initialsImageMirror !== undefined && options.initialsImageMirror !== null) {
    params.initials_image_mirror = options.initialsImageMirror;
  }

  if (options.debug !== undefined && options.debug !== null) {
    params.debug = options.debug;
  }

  if (options.fontFamily !== undefined && options.fontFamily !== null) {
    params.font_family = options.fontFamily;
  }

  if (options.fontWeight !== undefined && options.fontWeight !== null) {
    params.font_weight = options.fontWeight;
  }

  if (options.fontSize !== undefined && options.fontSize !== null) {
    params.font_size = options.fontSize;
  }

  if (options.fontSpacing !== undefined && options.fontSpacing !== null) {
    params.font_spacing = options.fontSpacing;
  }

  if (options.fontTrim !== undefined && options.fontTrim !== null) {
    params.font_trim = options.fontTrim;
  }

  if (options.fontMask !== undefined && options.fontMask !== null) {
    params.font_mask = options.fontMask;
  }

  if (options.fontMode !== undefined && options.fontMode !== null) {
    params.font_mode = options.fontMode;
  }

  if (options.lineHeight !== undefined && options.lineHeight !== null) {
    params.line_height = options.lineHeight;
  }

  if (options.lineBreaking !== undefined && options.lineBreaking !== null) {
    params.line_breaking = options.lineBreaking;
  }

  if (options.shadow !== undefined && options.shadow !== null) {
    params.shadow = options.shadow;
  }

  if (options.shadowColor !== undefined && options.shadowColor !== null) {
    params.shadow_color = options.shadowColor;
  }

  if (options.shadowOffset !== undefined && options.shadowOffset !== null) {
    params.shadow_offset = options.shadowOffset;
  }

  if (options.offsets !== undefined && options.offsets !== null) {
    params.offsets = JSON.stringify(options.offsets);
  }

  if (options.curve !== undefined && options.curve !== null) {
    params.curve = JSON.stringify(options.curve);
  }

  var url = "".concat(this.url, "compose");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
  if (!options.noEvents) this.trigger("post_image_options", options);
  return options;
};
/**
 * @ignore
 * @see {link http://docs.platforme.com/#render-endpoints-mask}
 */


ripe.Ripe.prototype._getMaskOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!options.noEvents) this.trigger("pre_mask_options", options);
  options.parts = options.parts || {};
  options.country = options.country || null;
  options.currency = options.currency || null;
  options.full = options.full === undefined ? false : options.full;
  options = this._getQueryOptions(options);
  var params = options.params || {};
  options.params = params;

  if (options.part !== undefined && options.part !== null) {
    params.part = options.part;
  }

  var url = "".concat(this.url, "mask");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
  if (!options.noEvents) this.trigger("post_mask_options", options);
  return options;
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getSwatchOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!options.noEvents) this.trigger("pre_swatch_options", options);
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var params = options.params || {};
  options.params = params;

  if (brand !== undefined && brand !== null) {
    params.brand = brand;
  }

  if (model !== undefined && model !== null) {
    params.model = model;
  }

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  if (options.material !== undefined && options.material !== null) {
    params.material = options.material;
  }

  if (options.color !== undefined && options.color !== null) {
    params.color = options.color;
  }

  if (options.format !== undefined && options.format !== null) {
    params.format = options.format;
  }

  if (options.retina !== undefined && options.retina !== null) {
    params.retina = options.retina ? "1" : "0";
  }

  if (options.variant !== undefined && options.variant !== null) {
    params.variant = options.variant;
  }

  var url = "".concat(this.url, "swatch");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
  if (!options.noEvents) this.trigger("post_swatch_options", options);
  return options;
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getImageURL = function (options) {
  options = this._getImageOptions(options);
  return options.url + "?" + this._buildQuery(options.params);
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getMaskURL = function (options) {
  options = this._getMaskOptions(options);
  return options.url + "?" + this._buildQuery(options.params);
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getSwatchURL = function (options) {
  options = this._getSwatchOptions(options);
  return options.url + "?" + this._buildQuery(options.params);
};
/**
 * Runs the options object building operation meaning that a series
 * of default values are going to be added to the provided options
 * so that it becomes as compatible as possible.
 *
 * If authentication is required the current session identifier is
 * also added to the request.
 *
 * @param {Object} options The HTTP request options object that is
 * going to be completed with default information and session info.
 * @returns {Object} The same options object references that has been
 * provided with the proper default information populated.
 *
 * @ignore
 */


ripe.Ripe.prototype._build = function (options) {
  var url = options.url || "";
  var method = options.method || "GET";
  var params = options.params || {};
  var headers = options.headers || {};
  var auth = options.auth || false;

  if (auth && this.sid !== undefined && this.sid !== null) {
    params.sid = this.sid;
  }

  if (auth && this.key !== undefined && this.key !== null) {
    headers["X-Secret-Key"] = this.key;
  }

  if (auth && (this.sid === undefined || this.sid === null) && (this.key === undefined || this.key === null)) {
    throw new Error("Authorization requested but none is available");
  }

  options.url = url;
  options.method = method;
  options.params = Object.assign({}, this.params, params);
  options.headers = Object.assign({}, this.headers, headers);
  options.auth = auth;
  return options;
};
/**
 * Builds a GET query string from the provided Array or Object parameter.
 *
 * If the provided parameter is an Array order of the GET parameters is
 * preserved, otherwise alphabetical order is going to be used.
 *
 * @param {Object} params The object or array that contains the sequence
 * of parameters for the generated GET query.
 * @returns {String} The GET query string that should contain the complete
 * set of passed arguments (serialization).
 *
 * @ignore
 */


ripe.Ripe.prototype._buildQuery = function (params) {
  var key;
  var value;
  var index;
  var buffer = [];

  if (Array.isArray(params)) {
    for (index = 0; index < params.length; index++) {
      var tuple = params[index];
      key = tuple[0];
      value = tuple.length > 1 ? tuple[1] : "";
      if (value === null || value === undefined) continue;
      key = encodeURIComponent(key);
      value = encodeURIComponent(value);
      buffer.push(key + "=" + value);
    }
  } else {
    var keys = Object.keys(params);
    keys.sort();

    for (index = 0; index < keys.length; index++) {
      key = keys[index];
      value = params[key];
      key = encodeURIComponent(key);

      if (Array.isArray(value)) {
        for (var _index = 0; _index < value.length; _index++) {
          var _value = value[_index];
          if (_value === null || _value === undefined) continue;
          _value = encodeURIComponent(_value);
          buffer.push(key + "=" + _value);
        }
      } else {
        if (value === null || value === undefined) continue;
        value = encodeURIComponent(value);
        buffer.push(key + "=" + value);
      }
    }
  }

  return buffer.join("&");
};
/**
 * Unpacks the provided query string into it's components inside
 * a key, value object for easy usage.
 *
 * This operation is considered to be the opposite of the `_buildQuery`
 * operation.
 *
 * @param {String} The GET query string that is going to be parsed
 * for the creation of the output Object.
 * @returns {Object} The object that contains the key, value information
 * on the query string.
 *
 * @ignore
 */


ripe.Ripe.prototype._unpackQuery = function (query) {
  query = query[0] === "?" ? query.slice(1) : query;
  var parts = query.split("&");
  var options = {};

  for (var index = 0; index < parts.length; index++) {
    var part = parts[index];

    if (part.indexOf("=") === -1) {
      options[decodeURIComponent(part).trim()] = true;
    } else {
      var tuple = part.split("=");
      var key = decodeURIComponent(tuple[0].replace(/\+/g, "%20")).trim();
      var value = decodeURIComponent(tuple[1].replace(/\+/g, "%20")).trim();

      if (options[key] === undefined) {
        options[key] = value;
      } else if (Array.isArray(options[key])) {
        options[key].push(value);
      } else {
        options[key] = [options[key], value];
      }
    }
  }

  return options;
};

ripe.Ripe.prototype._queryToSpec = function (query) {
  var options = this._unpackQuery(query);

  var brand = options.brand || null;
  var model = options.model || null;
  var variant = options.variant || null;
  var version = options.version || null;
  var description = options.description || null;
  var initials = options.initials || null;
  var engraving = options.engraving || null;
  var initialsExtra = options.initials_extra || [];
  var tuples = options.p || [];
  initialsExtra = Array.isArray(initialsExtra) ? initialsExtra : [initialsExtra];
  initialsExtra = this._parseExtraS(initialsExtra);
  tuples = Array.isArray(tuples) ? tuples : [tuples];

  var parts = this._tuplesToParts(tuples);

  var partsM = this._partsToPartsM(parts);

  var spec = {
    brand: brand,
    model: model,
    parts: partsM,
    initials: initials,
    engraving: engraving,
    initials_extra: initialsExtra
  };
  if (variant) spec.variant = variant;
  if (version) spec.version = version;
  if (description) spec.description = description;
  return spec;
};

ripe.Ripe.prototype._specToQuery = function (spec) {
  var queryL = [];
  var brand = spec.brand || null;
  var model = spec.model || null;
  var variant = spec.variant || null;
  var version = spec.version || null;
  var description = spec.description || null;
  var parts = spec.parts || null;
  var initials = spec.initials || null;
  var engraving = spec.engraving || null;
  var initialsExtra = spec.initials_extra || null;
  if (brand) queryL.push("brand=".concat(brand));
  if (model) queryL.push("model=".concat(model));
  if (variant) queryL.push("variant=".concat(variant));
  if (version) queryL.push("version=".concat(version));
  if (description) queryL.push("description=".concat(description));
  if (parts) queryL.push(this._partsMToQuery(parts));
  if (initials) queryL.push("initials=".concat(initials));
  if (engraving) queryL.push("engraving=".concat(engraving));

  if (initialsExtra) {
    var _iterator = _createForOfIteratorHelper(this._generateExtraS(initialsExtra)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var extraS = _step.value;
        queryL.push("initials_extra=".concat(extraS));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return queryL.join("&");
};

ripe.Ripe.prototype._tuplesToParts = function (tuples) {
  var parts = [];

  var _iterator2 = _createForOfIteratorHelper(tuples),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var tuple = _step2.value;

      var _ripe$splitUnescape = ripe.splitUnescape(tuple, ":", 2),
          _ripe$splitUnescape2 = _slicedToArray(_ripe$splitUnescape, 3),
          name = _ripe$splitUnescape2[0],
          material = _ripe$splitUnescape2[1],
          color = _ripe$splitUnescape2[2];

      var part = {
        name: name,
        material: material,
        color: color
      };
      parts.push(part);
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return parts;
};

ripe.Ripe.prototype._partsToPartsM = function (parts) {
  var partsM = {};

  var _iterator3 = _createForOfIteratorHelper(parts),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var part = _step3.value;
      var name = part.name;
      var material = part.material;
      var color = part.color;
      partsM[name] = {
        material: material,
        color: color
      };
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return partsM;
};

ripe.Ripe.prototype._partsMToQuery = function (partsM) {
  var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var queryL = this._partsMToTriplets(partsM, sort).map(function (triplet) {
    return "p=".concat(triplet);
  });

  return queryL.join("&");
};

ripe.Ripe.prototype._partsMToTriplets = function (partsM) {
  var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var triplets = [];
  var names = Object.keys(partsM);
  if (sort) names.sort();

  for (var _i = 0, _names = names; _i < _names.length; _i++) {
    var name = _names[_i];
    var part = partsM[name];
    var _ref2 = [ripe.escape(name, ":"), ripe.escape(part.material, ":"), ripe.escape(part.color, ":")],
        nameE = _ref2[0],
        initialsE = _ref2[1],
        engravingE = _ref2[2];
    triplets.push("".concat(nameE, ":").concat(initialsE, ":").concat(engravingE));
  }

  return triplets;
};

ripe.Ripe.prototype._parseExtraS = function (extraS) {
  var extra = {};

  var _iterator4 = _createForOfIteratorHelper(extraS),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var extraI = _step4.value;

      var _ripe$splitUnescape3 = ripe.splitUnescape(extraI, ":", 2),
          _ripe$splitUnescape4 = _slicedToArray(_ripe$splitUnescape3, 3),
          name = _ripe$splitUnescape4[0],
          initials = _ripe$splitUnescape4[1],
          engraving = _ripe$splitUnescape4[2];

      extra[name] = {
        initials: initials,
        engraving: engraving || null
      };
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return extra;
};

ripe.Ripe.prototype._generateExtraS = function (extra) {
  var sort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var minimize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var extraS = [];
  var names = Object.keys(extra);
  if (sort) names.sort();

  for (var _i2 = 0, _names2 = names; _i2 < _names2.length; _i2++) {
    var name = _names2[_i2];
    var values = extra[name];
    var _ref3 = [values.initials, values.engraving],
        initials = _ref3[0],
        engraving = _ref3[1];
    if (!initials && minimize) continue;
    var _ref4 = [ripe.escape(name, ":"), ripe.escape(initials, ":"), ripe.escape(engraving || "", ":")],
        nameE = _ref4[0],
        initialsE = _ref4[1],
        engravingE = _ref4[2];
    var extraI = "".concat(nameE, ":").concat(initialsE, ":").concat(engravingE);
    extraS.push(extraI);
  }

  return extraS;
};

ripe.Ripe.prototype._encodeMultipart = function (fields) {
  var mime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var doseq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  mime = mime || "multipart/form-data";

  var boundary = this._createBoundary(fields, undefined, doseq);

  var encoder = new TextEncoder("utf-8");
  var buffer = [];

  for (var _i3 = 0, _Object$entries = Object.entries(fields); _i3 < _Object$entries.length; _i3++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i3], 2),
        key = _Object$entries$_i[0],
        values = _Object$entries$_i[1];

    var isList = doseq && Array.isArray(values);
    values = isList ? values : [values];

    var _iterator5 = _createForOfIteratorHelper(values),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var value = _step5.value;
        if (value === null) continue;
        var header = void 0;

        if (_typeof(value) === "object" && !(value instanceof Array) && value.constructor !== Uint8Array) {
          var headerL = [];
          var data = null;

          for (var _i4 = 0, _Object$entries2 = Object.entries(value); _i4 < _Object$entries2.length; _i4++) {
            var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i4], 2),
                _key = _Object$entries2$_i[0],
                item = _Object$entries2$_i[1];

            if (_key === "data") data = item;else headerL.push("".concat(_key, ": ").concat(item));
          }

          value = data;
          header = headerL.join("\r\n");
        } else if (value instanceof Array) {
          var name = null;
          var contents = null;
          var contentTypeD = null;

          if (value.length === 2) {
            var _value2 = value;

            var _value3 = _slicedToArray(_value2, 2);

            name = _value3[0];
            contents = _value3[1];
          } else {
            var _value4 = value;

            var _value5 = _slicedToArray(_value4, 3);

            name = _value5[0];
            contentTypeD = _value5[1];
            contents = _value5[2];
          }

          header = "Content-Disposition: form-data; name=\"".concat(key, "\"; filename=\"").concat(name, "\"");
          if (contentTypeD) header += "\r\nContent-Type: ".concat(contentTypeD);
          value = contents;
        } else {
          header = "Content-Disposition: form-data; name=\"".concat(key, "\"");
        }

        buffer.push(encoder.encode("--" + boundary + "\r\n"));
        buffer.push(encoder.encode(header + "\r\n"));
        buffer.push(encoder.encode("\r\n"));
        buffer.push(value);
        buffer.push(encoder.encode("\r\n"));
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  buffer.push(encoder.encode("--" + boundary + "--\r\n"));
  buffer.push(encoder.encode("\r\n"));

  var body = this._joinBuffer(buffer);

  var contentType = "".concat(mime, "; boundary=").concat(boundary);
  return [contentType, body];
};

ripe.Ripe.prototype._createBoundary = function (fields) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 32;
  var doseq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return "Vq2xNWWHbmWYF644q9bC5T2ALtj5CynryArNQRXGYsfm37vwFKMNsqPBrpPeprFs";
};

ripe.Ripe.prototype._joinBuffer = function (bufferArray) {
  var bufferSize = bufferArray.map(function (item) {
    return item.byteLength;
  }).reduce(function (a, v) {
    return a + v;
  }, 0);
  var buffer = new Uint8Array(bufferSize);
  var offset = 0;

  var _iterator6 = _createForOfIteratorHelper(bufferArray),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var item = _step6.value;
      buffer.set(item, offset);
      offset += item.byteLength;
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return buffer;
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16);

  __webpack_require__(27); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @ignore
 */


ripe.Ripe.prototype.isAuth = function () {
  return Boolean(this.sid);
};
/**
 * @ignore
 */


ripe.Ripe.prototype.isOAuth = function () {
  if (!window.localStorage) {
    return false;
  }

  if (!localStorage.getItem("oauth_token")) {
    return false;
  }

  return true;
};
/**
 * @ignore
 */


ripe.Ripe.prototype.isOAuthCode = function () {
  var query = window.location.search || "";

  var unpacked = this._unpackQuery(query);

  var code = unpacked.code;
  return Boolean(code);
};
/**
 * @ignore
 */


ripe.Ripe.prototype.isOAuthError = function () {
  var query = window.location.search || "";

  var unpacked = this._unpackQuery(query);

  var error = unpacked.error;
  var errorDescription = unpacked.error_description;
  return Boolean(error) && Boolean(errorDescription);
};
/**
 * Checks if a successfully OAuth process has been fulfilled.
 *
 * @returns {Boolean} Boolean representing if an OAuth process has been fulfilled.
 */


ripe.Ripe.prototype.isOAuthPending = function () {
  if (this.isAuth()) {
    return false;
  }

  return this.isOAuth() || this.isOAuthCode() || this.isOAuthError();
};
/**
 * Responsible for the beginning of the (username, password)
 * based authentication process.
 *
 * @param {String} username The username to be authenticated.
 * @param {String} password The username's password.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.auth = function (username, password, options, callback) {
  var _this = this;

  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  this.signin(username, password, options, function (result, isValid, request) {
    _this.sid = result.sid;
    _this.username = result.username;
    _this.tokens = result.tokens;

    _this.trigger("auth");

    if (callback) callback(result, isValid, request);
  });
};
/**
 * Responsible for the beginning of the (username, password)
 * based authentication process.
 *
 * @param {String} username The username to be authenticated.
 * @param {String} password The username's password.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The authentication data.
 */


ripe.Ripe.prototype.authP = function (username, password, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.auth(username, password, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Responsible for the beginning of the (username, password)
 * based authentication process.
 *
 * This method uses the admin back-end instead of the RIPE
 * Core simple authentication system.
 *
 * @param {String} username The username to be authenticated.
 * @param {String} password The username's password.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.authAdmin = function (username, password, options, callback) {
  var _this3 = this;

  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  this.signinAdmin(username, password, options, function (result, isValid, request) {
    if (isValid) {
      _this3.sid = result.sid;
      _this3.username = result.username;
      _this3.tokens = result.tokens;

      _this3.trigger("auth");
    }

    if (callback) callback(result, isValid, request);
  });
};
/**
 * Responsible for the beginning of the (username, password)
 * based authentication process.
 *
 * This method uses the admin back-end instead of the RIPE
 * Core simple authentication system.
 *
 * @param {String} username The username to be authenticated.
 * @param {String} password The username's password.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The authentication data.
 */


ripe.Ripe.prototype.authAdminP = function (username, password, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.authAdmin(username, password, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Responsible for the beginning of the token based authentication process.
 *
 * @param {String} token The authentication token.
 * @param {Object} options An object of options to configure the authentication.
 * @param {Function} callback Function with the result of the authentication.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.authPid = function (token, options, callback) {
  var _this5 = this;

  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  this.signinPid(token, options, function (result, isValid, request) {
    if (isValid) {
      _this5.sid = result.sid;
      _this5.username = result.username;
      _this5.tokens = result.tokens;

      _this5.trigger("auth");
    }

    if (callback) callback(result, isValid, request);
  });
};
/**
 * Responsible for the beginning of the token based authentication process.
 *
 * @param {String} token The authentication token.
 * @param {Object} options An object of options to configure the authentication.
 * @returns {Promise} The authentication data.
 */


ripe.Ripe.prototype.authPidP = function (token, options) {
  var _this6 = this;

  return new Promise(function (resolve, reject) {
    _this6.authPid(token, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Responsible for the beginning of the key based authentication process.
 *
 * This method uses the admin back-end instead of the RIPE
 * Core simple authentication system.
 *
 * @param {String} key The key to authenticate with.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.authKey = function (key, options, callback) {
  var _this7 = this;

  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  this.key = key;
  this.accountMe(options, function (result, isValid, request) {
    if (isValid) _this7.trigger("auth");
    if (callback) callback(result, isValid, request);
  });
};
/**
 * Responsible for the beginning of the key based authentication process.
 *
 * This method uses the admin back-end instead of the RIPE
 * Core simple authentication system.
 *
 * @param {String} key The key to authenticate with.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {Promise} The authenticated account data.
 */


ripe.Ripe.prototype.authKeyP = function (key, options) {
  var _this8 = this;

  return new Promise(function (resolve, reject) {
    _this8.authKey(key, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Responsible for the beginning of the unauth process, triggering the 'unauth' event.
 *
 * @param {Object} options The set of options used for unauth process.
 * @param {Function} callback The callback to be called once session is unauth'ed.
 */


ripe.Ripe.prototype.unauth = function (options, callback) {
  this.sid = null;
  this.username = null;
  this.tokens = null;

  if (window.localStorage) {
    localStorage.removeItem("oauth_token");
    localStorage.removeItem("oauth_scope");
    localStorage.removeItem("oauth_client_id");
    localStorage.removeItem("oauth_client_secret");
    localStorage.removeItem("oauth_redirect_uri");
  }

  this.trigger("unauth");
  if (callback) callback();
};
/**
 * Responsible for the beginning of the OAuth based authentication process
 * may either start the redirection process (in case no valid token is found)
 * or try to revalidate the session with the currently existing tokens or session ID.
 *
 * @param {Object} options The set of options used for the OAuth process, should
 * include client identifier and secret.
 * @param {Function} callback The callback to be called once the logging or the access
 * token retrieval functions are finished.
 * @returns {oauthAccessToken} Either an invalid/unset value or the result of the login operation.
 */


ripe.Ripe.prototype.oauth = function (options, callback) {
  var _this9 = this;

  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = options || {};

  if (!window.localStorage) {
    throw new Error("No support for local storage available");
  }

  if (options.force) {
    this.unauth();
  }

  var query = window.location.search || "";

  var unpacked = this._unpackQuery(query);

  var code = typeof options.code === "undefined" ? unpacked.code : options.code;
  var error = typeof options.error === "undefined" ? unpacked.error : options.error;
  var errorDescription = typeof options.error_description === "undefined" ? unpacked.error_description : options.error_description;

  if (error || errorDescription) {
    throw new Error("OAuth error ".concat(error, " '").concat(errorDescription, "'"));
  }

  var clientId = options.clientId || window.localStorage && localStorage.getItem("oauth_client_id");
  var clientSecret = options.clientSecret || window.localStorage && localStorage.getItem("oauth_client_secret");
  var redirectUri = options.redirectUri || window.localStorage && localStorage.getItem("oauth_redirect_uri");
  var scope = options.scope || (window.localStorage && localStorage.getItem("oauth_scope") || "").split(",") || [];
  var oauthToken = options.oauthToken || window.localStorage && localStorage.getItem("oauth_token");
  scope && window.localStorage && localStorage.setItem("oauth_scope", scope.join(","));

  if (oauthToken && clientId && clientSecret && redirectUri) {
    return this.oauthLogin(oauthToken, options, function (result, isValid, request) {
      if (isValid && result) {
        _this9.sid = result.sid;
        _this9.username = result.username;
        _this9.tokens = result.tokens;

        _this9.trigger("auth");

        if (callback) callback(result, isValid, request);
      } else {
        _this9.oauth({
          clientId: clientId,
          clientSecret: clientSecret,
          redirectUri: redirectUri,
          scope: scope,
          code: null,
          force: true
        }, callback);
      }
    });
  }

  if (code && clientId && clientSecret && redirectUri) {
    return this.oauthAccessToken(code, {
      clientId: clientId,
      clientSecret: clientSecret,
      redirectUri: redirectUri
    }, function (result, isValid) {
      if (isValid && result) {
        window.localStorage && localStorage.setItem("oauth_token", result.access_token);
        result.scope && window.localStorage && localStorage.setItem("oauth_scope", result.scope.join(","));

        _this9.oauth(callback);
      } else {
        _this9.oauth({
          clientId: clientId,
          clientSecret: clientSecret,
          redirectUri: redirectUri,
          scope: scope,
          code: null,
          force: true
        }, callback);
      }
    });
  }

  return this.oauthRedirect(options, callback);
};
/**
 * @ignore
 */


ripe.Ripe.prototype.oauthRedirect = function (options, callback) {
  var location = window.location;
  var currentUrl = location.protocol + "//" + location.host + "/" + location.pathname.split("/")[1];
  var clientId = options.clientId || this.clientId;
  var clientSecret = options.clientSecret || this.clientSecret;
  var redirectUri = options.redirectUri || currentUrl;

  if (window.localStorage) {
    localStorage.setItem("oauth_client_id", clientId);
    localStorage.setItem("oauth_client_secret", clientSecret);
    localStorage.setItem("oauth_redirect_uri", redirectUri);
  }

  var url = this.webUrl + "admin/oauth/authorize";
  var params = {
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: options.responseType || "code",
    scope: (options.scope || []).join(" ")
  };

  var data = this._buildQuery(params);

  url = url + "?" + data;
  document.location = url;
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @class
 * @classdesc An error object for a runtime problem.
 */


ripe.RuntimeError = function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  this.name = "RuntimeError";
  this.error = error;
  this.message = message || "Runtime error (".concat(this.error ? this.error.message : "unknown", ")");
  return this;
};
/**
 * @class
 * @classdesc An error object for an operational problem.
 */


ripe.OperationalError = function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  this.name = "OperationalError";
  this.error = error;
  this.message = message || "Operational error (".concat(this.error ? this.error.message : "unknown", ")");
  return this;
};
/**
 * @class
 * @classdesc An error object for an action exception.
 */


ripe.ActionException = function () {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var error = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var critical = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  this.name = "ActionException";
  this.error = error;
  this.message = message || "Action exception (".concat(this.error ? this.error.message : "unknown", ")");
  this.critical = critical;
  return this;
};
/**
 * @class
 * @classdesc An error object for remote operations.
 */


ripe.RemoteError = function (request) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var result = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var debug = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  this.name = "RemoteError";
  this.request = request;
  this.code = request.status;
  this.status = request.status;
  this.response = request.response;
  this.responseText = request.responseText;
  this.result = result;
  this.resultMessage = result ? result.message : null;
  this.message = message || "Problem in remote operation (".concat(this.code ? this.code : request.error ? request.error.message : this.responseText ? this.responseText : "unknown", ")");

  if (this.resultMessage) {
    this.message += " - ".concat(this.resultMessage);
  }

  if (debug && this.result) {
    this.message += "\n" + JSON.stringify(this.result, null, 2);
  }

  return this;
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var _regeneratorRuntime = __webpack_require__(0);

var _asyncToGenerator = __webpack_require__(1);

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @class
 * @augments Observable
 * @classdesc Class that defines an entity that can be used to interact
 * with the customizer (abstract).
 *
 * @param {Object} owner The owner (customizer instance) for
 * this interactable.
 * @param {Object} options The options to be used to configure the
 * interactable instance to be created.
 */


ripe.Interactable = function (owner) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  ripe.Observable.call(this);
  this.owner = owner;
  this.options = options;
  this.type = this.type || "Interactable";
  this.init();
};

ripe.Interactable.prototype = ripe.build(ripe.Observable.prototype);
ripe.Interactable.prototype.constructor = ripe.Interactable;
/**
 * The initializer of the class, to be called (by the owner)
 * whenever this interactable is going to become active.
 */

ripe.Interactable.prototype.init = function () {
  ripe.Observable.prototype.init.call(this);
};
/**
 * The deinitializer to be called (by the owner) when
 * it should stop responding to updates so that any necessary
 * cleanup operations can be executed.
 */


ripe.Interactable.prototype.deinit = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          this.owner = null;
          ripe.Observable.prototype.deinit.call(this);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this);
}));
/**
 * Updates the current set of options (object) with the partial
 * options object provided as argument.
 *
 * The merge operation between both objects may override the current
 * set of configurations.
 *
 * @param {Object} options Map with the partial set of values to update
 * the currently set options
 */

ripe.Interactable.prototype.updateOptions = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            this.options = Object.assign(this.options, options);

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Callback function to be called when the owner configurator has
 * been changed and some kind of visual update should take place.
 *
 * @param {Object} state The new configuration state.
 * @param {Object} options Set of update options that change the way
 * the update operation is going to be performed.
 */


ripe.Interactable.prototype.update = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(state) {
    var options,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}();

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var _slicedToArray = __webpack_require__(5);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16); // eslint-disable-next-line no-var


  var locales = __webpack_require__(169);

  __webpack_require__(27); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe; // eslint-disable-next-line no-var

  var LOCALES_BASE = locales.LOCALES_BASE;
}
/**
 * Adds a new bundle object to the currently set of registered
 * bundles for the the given locale.
 *
 * This registration operation is global and will affect any user
 * of the RIPE SDK package on the current VM.
 *
 * @param {Object} bundle The locale strings bundle that is going to be
 * globally registered.
 * @param {String} locale The ISO 639-1 based locale identifier in the
 * underscore based form to be used in registration.
 */


ripe.Ripe.prototype.addBundle = function (bundle) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  locale = locale === null ? this.locale : locale;

  var _bundle = LOCALES_BASE[locale] || {};

  LOCALES_BASE[locale] = _bundle;

  for (var _i = 0, _Object$entries = Object.entries(bundle); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    _bundle[key] = value;
  }
};
/**
 * Removes the given set of locale strings from the globally defined
 * locale registry.
 *
 * @param {Object} bundle The locale strings bundle that is going to be
 * globally removed.
 * @param {String} locale The ISO 639-1 based locale identifier in the
 * underscore based form to be used in removal.
 */


ripe.Ripe.prototype.removeBundle = function (bundle) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  locale = locale === null ? this.locale : locale;
  if (LOCALES_BASE[locale] === undefined) return;
  var _bundle = LOCALES_BASE[locale];

  for (var _i2 = 0, _Object$entries2 = Object.entries(bundle); _i2 < _Object$entries2.length; _i2++) {
    var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
        key = _Object$entries2$_i[0],
        value = _Object$entries2$_i[1];

    _bundle[key] = value;
  }
};
/**
 * Retrieves the complete set of locale bundles currently registered
 * in the global Ripe instance.
 *
 * @returns {Object} An object that maps a certain locale string to
 * an object mapping locale keys to translations.
 */


ripe.Ripe.prototype.getBundles = function () {
  return LOCALES_BASE;
};
/**
 * Retrieves the locale bundle according to the provided locale.
 *
 * @param {String} locale The ISO 639-1 compliant string value that
 * describes the locale to obtain the global bundle.
 * @returns {Object} An object that for the provided locale maps a
 * certain locale string to the translation.
 */


ripe.Ripe.prototype.getBundle = function (locale) {
  return LOCALES_BASE[locale] || {};
};
/**
 * Runs a local based localization, meaning that the data source
 * for the locale strings should be already loaded in memory.
 *
 * This means that the process should be immediate and not async.
 *
 * @param {String} value The base value string that is going to be
 * used for the localization process.
 * @param {String} fallback The fallback string (default) to be used
 * in case no localization is possible.
 * @returns {String} The final localized string or the fallback in
 * case localization is not possible.
 */


ripe.Ripe.prototype.localeLocal = function (value) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var fallbackLocale = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "en_us";
  fallback = fallback === null ? value : fallback;
  locale = locale === null ? this.locale : locale;

  if (locale && LOCALES_BASE[locale] !== undefined && LOCALES_BASE[locale][value] !== undefined) {
    return LOCALES_BASE[locale][value];
  }

  if (fallbackLocale && LOCALES_BASE[fallbackLocale] !== undefined && LOCALES_BASE[fallbackLocale][value] !== undefined) {
    return LOCALES_BASE[fallbackLocale][value];
  }

  return fallback;
};
/**
 * Parses the provided normalized engraving string according to the
 * standard `<name>:<type>` format, using the loaded configurations.
 *
 * The provided string may not be normalized but for that situation
 * typical guessing heuristics are going to be applied.
 *
 * @param {String} engraving The engraving string to be parsed.
 * @param {Array} properties If provided overrides the default loaded
 * config initials strategy for the retrieval of properties definition.
 * @returns {Object} Returns an object with values and valuesM.
 * valuesM is a map with (key = type, value = name) entries for each
 * property defined in the engraving, where "type" is the type of
 * the property (e.g. style) and "name" is the value for that property
 * (e.g. gold) as defined in the engraving parameter. values is a
 * list of (type, name) that respects the order of the properties.
 */


ripe.Ripe.prototype.parseEngraving = function (engraving) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  // gathers teh complete set of properties for the initials
  // definitions, to be used in the unpack
  properties = properties || this.loadedConfig.initials.properties;
  var propertyTypes = [];
  var propertyNamesM = {};

  var _iterator = _createForOfIteratorHelper(properties),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var property = _step.value;
      var _type = property.type;
      var _name = property.name;
      propertyNamesM[_name] = _type;
      propertyTypes.push(_type);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  propertyTypes = Array.from(new Set(propertyTypes)).sort(function (a, b) {
    return propertyTypes.indexOf(a) - propertyTypes.indexOf(b);
  });
  var values = [];
  var valuesM = {};
  var parts = engraving.length ? engraving.split(".") : [];

  for (var index = 0; index < parts.length; index++) {
    var part = parts[index];
    var slice = part.split(":", 2);
    var name = slice[0];
    var type = propertyTypes.length > index ? propertyTypes[index] : null;
    type = propertyNamesM[name] || type;
    type = slice.length === 2 ? slice[1] : type;
    values.push({
      name: name,
      type: type
    });
    valuesM[type] = name;
  }

  values = values.sort(function (a, b) {
    var typeAIndex = propertyTypes.includes(a.type) ? propertyTypes.indexOf(a.type) : propertyTypes.length;
    var typeBIndex = propertyTypes.includes(b.type) ? propertyTypes.indexOf(b.type) : propertyTypes.length;
    return typeAIndex - typeBIndex;
  });
  return {
    values: values,
    valuesM: valuesM
  };
};
/**
 * Normalizes the provided engraving (material) value according to the
 * expected standard, producing a sequence of dictionaries containing
 * the resulting property values.
 *
 * @param {String} engraving The engraving to be normalized.
 * @param {Array} properties If provided overrides the default loaded
 * config initials strategy for the retrieval of properties definition.
 * @returns {string} The normalized engraving value.
 */


ripe.Ripe.prototype.normalizeEngraving = function (engraving) {
  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _this$parseEngraving = this.parseEngraving(engraving, properties),
      values = _this$parseEngraving.values;

  return values.map(function (v) {
    return "".concat(v.name, ":").concat(v.type);
  }).join(".");
};
/**
 * Determines if the model currently loaded (in case there's one)
 * has the provided frame available in spec.
 *
 * Notice that this call does not assure that a render is possible
 * it only determines that according to model's spec it should be
 * possible to render such a frame.
 *
 * @param {String} frame The name of the frame to determine "renderability"
 * according to the {face}-{index} format.
 * @returns {Boolean} If it's possible to render such frame for the
 * currently loaded model.
 */


ripe.Ripe.prototype.hasFrame = function (frame) {
  if (!this.loadedConfig) return true;
  if (!frame) return true;
  var frameP = frame.split("-", 2);

  var _ref = frameP.length > 1 ? frameP : [frameP, "0"],
      _ref2 = _slicedToArray(_ref, 2),
      face = _ref2[0],
      index = _ref2[1];

  index = parseInt(index);
  if (!this.loadedConfig.faces_m) return false;
  if (!this.loadedConfig.faces_m[face]) return false;
  if (this.loadedConfig.faces_m[face].frames - 1 < index) return false;
  return true;
};
/**
 * Localizes the given string value taking into account the current
 * brand and model context so that proper prefixes are taking into
 * account for proper build locale usage.
 *
 * @param {String} value The base string value to be used in the localization.
 * @param {Object} owner The localization owner, which should implement the
 * proper localization provider functions. If not provided the default implementation
 * which used the local base values is used instead.
 * @param {Object} options Set of options to control the localization, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'locale' - The ISO-15897 standard locale definition to be used in the
 * localization process.
 *  - 'defaultValue' - The default string value (if any) to be returned in case it's
 * not possible to localize the provided value.
 *  - 'fallback' - If the fallback process should be used, meaning that if the
 * requested locale is not available for the requested model (not part of the
 * list of available locales) the base locale is going to be used instead
 * (fallback process).
 * @returns {String} The final localized string, that takes into account the
 * current model context.
 */


ripe.Ripe.prototype.localeModel = function (value) {
  var _this = this;

  var owner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$brand = _ref3.brand,
      brand = _ref3$brand === void 0 ? null : _ref3$brand,
      _ref3$model = _ref3.model,
      model = _ref3$model === void 0 ? null : _ref3$model,
      _ref3$locale = _ref3.locale,
      locale = _ref3$locale === void 0 ? null : _ref3$locale,
      _ref3$defaultValue = _ref3.defaultValue,
      defaultValue = _ref3$defaultValue === void 0 ? null : _ref3$defaultValue,
      _ref3$fallback = _ref3.fallback,
      fallback = _ref3$fallback === void 0 ? true : _ref3$fallback;

  owner = owner || {
    getLocale: function getLocale() {
      return _this.locale;
    },
    getSupportedLocales: function getSupportedLocales() {
      return Object.keys(LOCALES_BASE);
    },
    hasLocale: function hasLocale(value, locale) {
      return LOCALES_BASE[locale] && Boolean(LOCALES_BASE[locale][value]);
    },
    toLocale: function toLocale(value, defaultValue, locale, fallback) {
      return _this.localeLocal(value, defaultValue, locale, fallback);
    }
  };
  brand = brand === null ? this.brand : brand;
  model = model === null ? this.model : model;
  locale = locale === null ? this.locale : locale;
  return ripe.toLocale(value, brand, model, owner, {
    locale: locale,
    defaultValue: defaultValue,
    fallback: fallback
  });
};
/**
 * Localizes the given part string value.
 *
 * @param {String} color The base string value to be used in the localization.
 * @param {Object} owner The localization owner, which should implement the
 * proper localization provider functions. If not provided the default implementation
 * which used the local base values is used instead.
 * @param {Object} options Set of options to control the localization, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'locale' - The ISO-15897 standard locale definition to be used in the
 * localization process.
 *  - 'defaultValue' - The default string value (if any) to be returned in case it's
 * not possible to localize the provided value.
 *  - 'prefixes' - The list of prefixes that are taking into account for proper build
 * locale usage.
 *  - 'suffixes' - The list of suffixes that are taking into account for proper build
 * locale usage.
 * @returns {String} The final localized string, that takes into account the
 * current model context.
 */


ripe.Ripe.prototype.localePart = function (part) {
  var owner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref4$brand = _ref4.brand,
      brand = _ref4$brand === void 0 ? null : _ref4$brand,
      _ref4$model = _ref4.model,
      model = _ref4$model === void 0 ? null : _ref4$model,
      _ref4$locale = _ref4.locale,
      locale = _ref4$locale === void 0 ? null : _ref4$locale,
      _ref4$defaultValue = _ref4.defaultValue,
      defaultValue = _ref4$defaultValue === void 0 ? null : _ref4$defaultValue,
      _ref4$prefixes = _ref4.prefixes,
      prefixes = _ref4$prefixes === void 0 ? [] : _ref4$prefixes,
      _ref4$suffixes = _ref4.suffixes,
      suffixes = _ref4$suffixes === void 0 ? [] : _ref4$suffixes;

  var value = [];
  value = value.concat(prefixes);
  part && value.push("parts.".concat(part));
  value = value.concat(suffixes);
  return this.localeModel(value, owner, {
    brand: brand,
    model: model,
    locale: locale,
    defaultValue: defaultValue
  });
};
/**
 * Localizes the given material string value.
 *
 * @param {String} color The base string value to be used in the localization.
 * @param {Object} owner The localization owner, which should implement the
 * proper localization provider functions. If not provided the default implementation
 * which used the local base values is used instead.
 * @param {Object} options Set of options to control the localization, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'part' - The name of the part of the model.
 *  - 'locale' - The ISO-15897 standard locale definition to be used in the
 * localization process.
 *  - 'defaultValue' - The default string value (if any) to be returned in case it's
 * not possible to localize the provided value.
 *  - 'prefixes' - The list of prefixes that are taking into account for proper build
 * locale usage.
 *  - 'suffixes' - The list of suffixes that are taking into account for proper build
 * locale usage.
 * @returns {String} The final localized string, that takes into account the
 * current model context.
 */


ripe.Ripe.prototype.localeMaterial = function (material) {
  var owner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref5$brand = _ref5.brand,
      brand = _ref5$brand === void 0 ? null : _ref5$brand,
      _ref5$model = _ref5.model,
      model = _ref5$model === void 0 ? null : _ref5$model,
      _ref5$part = _ref5.part,
      part = _ref5$part === void 0 ? null : _ref5$part,
      _ref5$locale = _ref5.locale,
      locale = _ref5$locale === void 0 ? null : _ref5$locale,
      _ref5$defaultValue = _ref5.defaultValue,
      defaultValue = _ref5$defaultValue === void 0 ? null : _ref5$defaultValue,
      _ref5$prefixes = _ref5.prefixes,
      prefixes = _ref5$prefixes === void 0 ? [] : _ref5$prefixes,
      _ref5$suffixes = _ref5.suffixes,
      suffixes = _ref5$suffixes === void 0 ? [] : _ref5$suffixes;

  var value = [];
  value = value.concat(prefixes);
  part && material && value.push("materials.".concat(part, ".").concat(material));
  material && value.push("materials.".concat(material));
  value = value.concat(suffixes);
  return this.localeModel(value, owner, {
    brand: brand,
    model: model,
    locale: locale,
    defaultValue: defaultValue
  });
};
/**
 * Localizes the given color string value.
 *
 * @param {String} color The base string value to be used in the localization.
 * @param {Object} owner The localization owner, which should implement the
 * proper localization provider functions. If not provided the default implementation
 * which used the local base values is used instead.
 * @param {Object} options Set of options to control the localization, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'part' - The name of the part of the model.
 *  - 'material' - The name of the material of the model.
 *  - 'locale' - The ISO-15897 standard locale definition to be used in the
 * localization process.
 *  - 'defaultValue' - The default string value (if any) to be returned in case it's
 * not possible to localize the provided value.
 *  - 'prefixes' - The list of prefixes that are taking into account for proper build
 * locale usage.
 *  - 'suffixes' - The list of suffixes that are taking into account for proper build
 * locale usage.
 * @returns {String} The final localized string, that takes into account the
 * current model context.
 */


ripe.Ripe.prototype.localeColor = function (color) {
  var owner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref6$brand = _ref6.brand,
      brand = _ref6$brand === void 0 ? null : _ref6$brand,
      _ref6$model = _ref6.model,
      model = _ref6$model === void 0 ? null : _ref6$model,
      _ref6$part = _ref6.part,
      part = _ref6$part === void 0 ? null : _ref6$part,
      _ref6$material = _ref6.material,
      material = _ref6$material === void 0 ? null : _ref6$material,
      _ref6$locale = _ref6.locale,
      locale = _ref6$locale === void 0 ? null : _ref6$locale,
      _ref6$defaultValue = _ref6.defaultValue,
      defaultValue = _ref6$defaultValue === void 0 ? null : _ref6$defaultValue,
      _ref6$prefixes = _ref6.prefixes,
      prefixes = _ref6$prefixes === void 0 ? [] : _ref6$prefixes,
      _ref6$suffixes = _ref6.suffixes,
      suffixes = _ref6$suffixes === void 0 ? [] : _ref6$suffixes;

  var value = [];
  value = value.concat(prefixes);
  part && material && color && value.push("colors.".concat(part, ".").concat(material, ".").concat(color));
  part && color && value.push("colors.".concat(part, ".").concat(color));
  material && color && value.push("colors.".concat(material, ".").concat(color));
  color && value.push("colors.".concat(color));
  value = value.concat(suffixes);
  return this.localeModel(value, owner, {
    brand: brand,
    model: model,
    locale: locale,
    defaultValue: defaultValue
  });
};
/**
 * Localizes the given property string value.
 *
 * @param {String} color The base string value to be used in the localization.
 * @param {Object} owner The localization owner, which should implement the
 * proper localization provider functions. If not provided the default implementation
 * which used the local base values is used instead.
 * @param {Object} options Set of options to control the localization, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'type' - The type of the property.
 *  - 'locale' - The ISO-15897 standard locale definition to be used in the
 * localization process.
 *  - 'defaultValue' - The default string value (if any) to be returned in case it's
 * not possible to localize the provided value.
 *  - 'prefixes' - The list of prefixes that are taking into account for proper build
 * locale usage.
 *  - 'suffixes' - The list of suffixes that are taking into account for proper build
 * locale usage.
 * @returns {String} The final localized string, that takes into account the
 * current model context.
 */


ripe.Ripe.prototype.localeProperty = function (name) {
  var owner = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _ref7 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref7$brand = _ref7.brand,
      brand = _ref7$brand === void 0 ? null : _ref7$brand,
      _ref7$model = _ref7.model,
      model = _ref7$model === void 0 ? null : _ref7$model,
      _ref7$type = _ref7.type,
      type = _ref7$type === void 0 ? null : _ref7$type,
      _ref7$locale = _ref7.locale,
      locale = _ref7$locale === void 0 ? null : _ref7$locale,
      _ref7$defaultValue = _ref7.defaultValue,
      defaultValue = _ref7$defaultValue === void 0 ? null : _ref7$defaultValue,
      _ref7$prefixes = _ref7.prefixes,
      prefixes = _ref7$prefixes === void 0 ? [] : _ref7$prefixes,
      _ref7$suffixes = _ref7.suffixes,
      suffixes = _ref7$suffixes === void 0 ? [] : _ref7$suffixes;

  var value = [];
  value = value.concat(prefixes);
  name && value.push("properties.".concat(name));
  type && name && value.push("properties.".concat(type, ".").concat(name));
  value = value.concat(suffixes);
  return this.localeModel(value, owner, {
    brand: brand,
    model: model,
    locale: locale,
    defaultValue: defaultValue
  });
};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

var LOCALES_BASE = {
  en_us: {
    "hello.world": "hello world"
  }
};

if (true) {
  module.exports = {
    LOCALES_BASE: LOCALES_BASE
  };
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16);

  __webpack_require__(27); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}

ripe.Ripe.prototype.hasTag = function (tag) {
  var tags = this.loadedConfig.tags || [];
  return tags.includes(tag);
};

ripe.Ripe.prototype.hasCustomization = function () {
  return !this.hasTag("no_customization");
};

ripe.Ripe.prototype.hasPersonalization = function () {
  return !this.hasTag("no_initials") && !this.hasTag("no_personalization");
};

ripe.Ripe.prototype.hasSize = function () {
  return !this.hasTag("no_size");
};

ripe.Ripe.prototype.hasInitialsRadius = function () {
  return !this.hasTag("initials_no_radius");
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @ignore
 */


ripe.touchHandler = function (element) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // eslint-disable-next-line no-undef
  if (typeof Mobile !== "undefined" && Mobile.touchHandler) {
    return;
  }

  var SAFE = options.safe === undefined ? true : options.safe;
  var VALID = options.valid || ["DIV", "IMG", "SPAN", "CANVAS"];

  var eventHandler = function eventHandler(event) {
    // retrieves the complete set of touches and uses
    // only the first one for type reference
    var touches = event.changedTouches;
    var first = touches[0];
    var type = ""; // switches over the type of touch event associating
    // the proper equivalent mouse event to each of them

    switch (event.type) {
      case "touchstart":
        type = "mousedown";
        break;

      case "touchmove":
        type = "mousemove";
        break;

      case "touchend":
        type = "mouseup";
        break;

      default:
        return;
    } // verifies if the current event is considered to be valid,
    // this occurs if the target of the type of the target is
    // considered to be valid according to the current rules


    var isValid = VALID.indexOf(first.target.tagName) === -1;

    if (SAFE && isValid) {
      return;
    } // creates the new mouse event that will emulate the
    // touch event that has just been raised, it should
    // be completely equivalent to the original touch


    var mouseEvent = document.createEvent("MouseEvent");
    mouseEvent.initMouseEvent(type, true, true, window, 1, first.screenX, first.screenY, first.clientX, first.clientY, false, false, false, false, 0, null); // dispatches the event to the original target of the
    // touch event (pure emulation)

    first.target.dispatchEvent(mouseEvent);
  };

  element.addEventListener("touchstart", eventHandler, true);
  element.addEventListener("touchmove", eventHandler, true);
  element.addEventListener("touchend", eventHandler, true);
  element.addEventListener("touchcancel", eventHandler, true);
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}

ripe.FileTuple = function () {
  this.push.apply(this, arguments);
};

ripe.FileTuple.prototype = Object.create(Array.prototype);
ripe.FileTuple.prototype.constructor = ripe.FileTuple;

ripe.FileTuple.fromData = function (data) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var mime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var fileTuple = new this(name, mime, data);
  return fileTuple;
};

ripe.FileTuple.fromString = function (dataString) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var mime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var data = new TextEncoder("utf-8").encode(dataString);
  return this.fromData(data, name, mime);
};

ripe.FileTuple.prototype.toString = function () {
  return "[object Array]";
};

ripe.FileTuple.prototype.name = function () {
  return this[0];
};

ripe.FileTuple.prototype.mime = function () {
  return this[1];
};

ripe.FileTuple.prototype.data = function () {
  return this[2];
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(20);

var _regeneratorRuntime = __webpack_require__(0);

var _asyncToGenerator = __webpack_require__(1);

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(16); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Object used to store the information on the global visual
 * animation that are currently running as part of the RIPE
 * environment.
 *
 * Proper garbage collection should be ensure to avoid leak
 * of memory regarding animations.
 */


ripe.animations = {};
/**
 * @ignore
 */

ripe.createElement = function (tagName, className) {
  var element = tagName && document.createElement(tagName);
  element.className = className || "";
  return element;
};
/**
 * @ignore
 */


ripe.animateProperty = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(element, property, initial, _final) {
    var duration,
        raise,
        last,
        promise,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            duration = _args.length > 4 && _args[4] !== undefined ? _args[4] : 1.0;
            raise = _args.length > 5 && _args[5] !== undefined ? _args[5] : true;
            // sets the initial value for the property according to the
            // provided values, notice that the date of the last touch
            // time for the animation is created
            element.style[property] = initial;
            last = new Date();
            promise = new Promise(function (resolve, reject) {
              var frame = function frame(timestamp, err) {
                // in case there's an error coming from the callback calls
                // the promise reject function with the error
                if (err) {
                  reject(err);
                  return;
                } // in case there's an animation id currently defined in the
                // element it should be removed from the global dict (making
                // sure that there's proper garbage collection)


                if (element.dataset.animation_id) {
                  delete ripe.animations[element.dataset.animation_id];
                } // checks how much time has passed since the last animation frame


                var current = new Date();
                var timeDelta = current - last;
                var animationDelta = timeDelta * (_final - initial) / duration; // adjusts the value by the correspondent amount
                // making sure it doesn't surpass the final value

                var value = parseFloat(element.style[property]);
                value += animationDelta;
                value = _final > initial ? Math.min(value, _final) : Math.max(value, _final);
                element.style[property] = value;
                last = current; // checks if the animation has finished and if it is then
                // fires the callback if it's set. Otherwise, requests a
                // new animation frame to proceed with the animation

                var incrementAnimation = _final > initial && value < _final;
                var decrementAnimation = _final < initial && value > _final;

                if (incrementAnimation || decrementAnimation) {
                  // sets the id of the animation frame on the element
                  // so that it can be canceled if necessary
                  var id = requestAnimationFrame(frame);
                  element.dataset.animation_id = id;
                  ripe.animations[element.dataset.animation_id] = {
                    callback: frame,
                    last: last
                  };
                } else {
                  delete element.dataset.animation_id;
                  resolve();
                }
              }; // starts the animation process by running the initial
              // call to the frame animation function


              frame();
            });
            _context.prev = 5;
            _context.next = 8;
            return promise;

          case 8:
            _context.next = 15;
            break;

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](5);

            if (raise) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", false);

          case 14:
            throw _context.t0;

          case 15:
            return _context.abrupt("return", true);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 10]]);
  }));

  return function (_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.cancelAnimation = function (element) {
  if (!element.dataset.animation_id) return;
  var animationId = parseInt(element.dataset.animation_id);
  var info = ripe.animations[animationId];
  cancelAnimationFrame(animationId); // in case there's a callback defined for the current animation
  // then it muse be called with an action exception indicating that
  // the exception has been canceled in the middle of the execution

  if (info.callback) {
    info.callback(null, new ripe.ActionException("Animation canceled"));
  }
};
/**
 * @ignore
 */


ripe.getFrameKey = function (view, position, token) {
  token = token || "-";
  return view + token + position;
};
/**
 * @ignore
 */


ripe.parseFrameKey = function (frame, token) {
  token = token || "-";
  return frame.split(token, 2);
};
/**
 * @ignore
 */


ripe.frameNameHack = function (frame) {
  if (!frame) return "";

  var _frame = ripe.parseFrameKey(frame);

  var view = _frame[0];
  var position = _frame[1];
  position = view === "side" ? position : view;
  return position;
};
/**
 * @ignore
 */


ripe.fixEvent = function (event) {
  if (event.offsetX !== undefined) {
    return event;
  }

  var target = event.target || event.srcElement;
  var rect = target.getBoundingClientRect();

  try {
    event.offsetX = event.clientX - rect.left;
    event.offsetY = event.clientY - rect.top;
  } catch (exception) {
    return event;
  }

  return event;
};
/**
 * @ignore
 */


ripe.clone = function (object) {
  if (object === undefined) {
    return object;
  }

  var objectS = JSON.stringify(object);
  return JSON.parse(objectS);
};
/**
 * @ignore
 */


ripe.equal = function (first, second) {
  if (first === second) {
    return true;
  }

  if (ripe["typeof"](first) !== ripe["typeof"](second)) {
    return false;
  }

  if (ripe.isPrimitive(first) && ripe.isPrimitive(second)) {
    return first === second;
  }

  if (Object.keys(first).length !== Object.keys(second).length) {
    return false;
  }

  for (var key in first) {
    if (!(key in second)) return false;
    if (!ripe.equal(first[key], second[key])) return false;
  }

  return true;
};
/**
 * @ignore
 */


ripe.isPrimitive = function (object) {
  return object !== Object(object);
};
/**
 * @ignore
 */


ripe["typeof"] = function (object) {
  if (object === null) return "null";
  if (Array.isArray(object)) return "array";
  return _typeof(object);
};
/**
 * @ignore
 */


ripe.escape = function (value, _char) {
  var escape = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "\\";
  return value.replace(new RegExp("\\" + escape, "g"), function () {
    return escape + escape;
  }).replace(new RegExp("\\" + _char, "g"), function () {
    return escape + _char;
  });
};
/**
 * @ignore
 */


ripe.unescape = function (value) {
  var escape = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "\\";
  var result = [];
  var iterator = value[Symbol.iterator]();

  var _iterator = _createForOfIteratorHelper(iterator),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _char2 = _step.value;

      if (_char2 === escape) {
        var follow = iterator.next();

        if (!follow.done) {
          result.push(follow.value);
        } else {
          result.push(escape);
        }
      } else {
        result.push(_char2);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result.join("");
};
/**
 * @ignore
 */


ripe.countUnescape = function (value, sub) {
  var escape = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "\\";
  var iterator = value[Symbol.iterator]();
  var count = 0;

  var _iterator2 = _createForOfIteratorHelper(iterator),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _char3 = _step2.value;

      if (_char3 === escape) {
        iterator.next();
      } else if (_char3 === sub) {
        count += 1;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return count;
};
/**
 * @ignore
 */


ripe.splitUnescape = function (value) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var escape = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "\\";
  var unescape = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var result = [];
  var current = [];
  var iterator = value[Symbol.iterator]();
  var count = 0;

  var _iterator3 = _createForOfIteratorHelper(iterator),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _char4 = _step3.value;

      if (_char4 === escape) {
        if (!unescape) current.push(escape);
        var follow = iterator.next();

        if (!follow.done) {
          current.push(follow.value);
        } else if (unescape) {
          current.push(escape);
        }
      } else if (_char4 === delimiter && count !== max) {
        result.push(current.join(""));
        current = [];
        count += 1;
      } else {
        current.push(_char4);
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  result.push(current.join(""));
  return result;
};
/**
 * @ignore
 */


ripe.toLocale = function (value, brand, model, owner) {
  var _ref2 = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
      _ref2$version = _ref2.version,
      version = _ref2$version === void 0 ? null : _ref2$version,
      _ref2$locale = _ref2.locale,
      locale = _ref2$locale === void 0 ? null : _ref2$locale,
      _ref2$defaultValue = _ref2.defaultValue,
      defaultValue = _ref2$defaultValue === void 0 ? null : _ref2$defaultValue,
      _ref2$prefix = _ref2.prefix,
      prefix = _ref2$prefix === void 0 ? "builds" : _ref2$prefix,
      _ref2$fallback = _ref2.fallback,
      fallback = _ref2$fallback === void 0 ? true : _ref2$fallback,
      _ref2$compatibility = _ref2.compatibility,
      compatibility = _ref2$compatibility === void 0 ? true : _ref2$compatibility,
      _ref2$hack = _ref2.hack,
      hack = _ref2$hack === void 0 ? null : _ref2$hack;

  var values = Array.isArray(value) ? value : [value];

  if (values.length === 0) {
    throw new Error("No values present to be localized");
  }

  locale = locale || owner.getLocale();
  var localeB = locale;
  var language = locale.split("_", 1)[0];

  if (hack) {
    value = values[-1].rsplit(".", 1)[-1];
    return owner.toLocale(value, defaultValue, locale, fallback);
  }

  var locales = owner.getSupportedLocales();

  if (locales.includes(localeB)) {
    locale = localeB;
  } else if (locales.includes(language)) {
    locale = language;
  } else if (locales.some(function (l) {
    return l.startsWith("".concat(language, "_"));
  })) {
    locale = locales.filter(function (l) {
      return l.startsWith("".concat(language, "_"));
    })[0];
  } else if (fallback) {
    locale = locales[0];
  }

  var prefixes = ["".concat(brand, ".").concat(model), brand];

  var _iterator4 = _createForOfIteratorHelper(values),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _value3 = _step4.value;

      var _permutations = ripe._permutations(_value3);

      var _iterator7 = _createForOfIteratorHelper(prefixes),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var _prefix = _step7.value;

          var _iterator8 = _createForOfIteratorHelper(_permutations),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _value4 = _step8.value;
              var valueFqn = "".concat(prefix, ".").concat(_prefix, ".").concat(_value4);

              var _hasLocale = owner.hasLocale(valueFqn, locale);

              if (!_hasLocale) {
                continue;
              }

              var _result = owner.toLocale(valueFqn, null, locale, fallback);

              if (_result) {
                return _result;
              }
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }
        }
      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (compatibility) {
    var _iterator5 = _createForOfIteratorHelper(values),
        _step5;

    try {
      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
        var _value2 = _step5.value;

        var permutations = ripe._permutations(_value2);

        var _iterator6 = _createForOfIteratorHelper(permutations),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var _value = _step6.value;
            var hasLocale = owner.hasLocale(_value, locale);

            if (!hasLocale) {
              continue;
            }

            var result = owner.toLocale(_value, null, locale, fallback);

            if (result) {
              return result;
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      }
    } catch (err) {
      _iterator5.e(err);
    } finally {
      _iterator5.f();
    }
  }

  return defaultValue || values[0];
};
/**
 * @ignore
 */


ripe._permutations = function (value) {
  var valueP = value.split(".");
  var permutations = [];

  for (var index = 0; index < valueP.length; index++) {
    permutations.push(valueP.slice(index).join("."));
  }

  return permutations;
};

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Gets the existing availability rules, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getAvailabilityRules = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "availability_rules");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the existing availability rules, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The availability rules list.
 */


ripe.Ripe.prototype.getAvailabilityRulesP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getAvailabilityRules(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Creates an availability rule on RIPE Core.
 *
 * @param {Object} availabilityRule The availability rule data.
 * @param {Object} options An object with options.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.createAvailabilityRule = function (availabilityRule, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "availability_rules");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    auth: true,
    dataJ: availabilityRule
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Creates an availability rule on RIPE Core.
 *
 * @param {Object} availabilityRule The availability rule's data.
 * @param {Object} options An object with options.
 * @returns {Promise} The availability rule's data.
 */


ripe.Ripe.prototype.createAvailabilityRuleP = function (availabilityRule, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.createAvailabilityRule(availabilityRule, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Gets an existing availability rule filtered by ID and according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Number} id The availability rule's ID.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getAvailabilityRule = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "availability_rules/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets an existing availability rule filtered by ID and according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Number} id The availability rule's ID.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The availability rule requested by ID.
 */


ripe.Ripe.prototype.getAvailabilityRuleP = function (id, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.getAvailabilityRule(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Updates an availability rule on RIPE Core.
 *
 * @param {Object} availabilityRule The availability rule's data.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.updateAvailabilityRule = function (availabilityRule, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "availability_rules/").concat(availabilityRule.id);
  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true,
    dataJ: availabilityRule
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Updates an availability rule on RIPE Core.
 *
 * @param {Object} availabilityRule The Availability Rule's data.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The availability rule's data.
 */


ripe.Ripe.prototype.updateAvailabilityRuleP = function (availabilityRule, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.updateAvailabilityRule(availabilityRule, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Deletes an existing availability rule.
 *
 * @param {Number} id The availability rule's ID.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.deleteAvailabilityRule = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "availability_rules/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "DELETE",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Deletes an existing availability rule.
 *
 * @param {Number} id The availability rule's ID.
 * @param {Object} options An object of options to configure the request
 * @returns {Promise} The result of the availability rule's deletion.
 */


ripe.Ripe.prototype.deleteAvailabilityRuleP = function (id, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.deleteAvailabilityRule(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Returns the logo of a brand.
 *
 * @param {Object} options A map with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'variant' - The variant of the logo, that controls semantics of the logo.
 *  - 'format' - The format of the logo image to be retrieved (defaults to 'png').
 *  - 'size' - The size of the logo image.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The brand's logo.
 */


ripe.Ripe.prototype.getLogo = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getLogoOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Returns the logo of a brand.
 *
 * @param {Object} options A map with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'variant' - The variant of the logo, that controls semantics of the logo.
 *  - 'format' - The format of the logo image to be retrieved (defaults to 'png').
 *  - 'size' - The size of the logo image.
 * @returns {Promise} The brand's logo.
 */


ripe.Ripe.prototype.getLogoP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getLogo(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Returns the URL where the logo of a brand can be retrieved.
 *
 * Can be used to allow interactive user agents (browser) to load the
 * image user their own loading infrastructure.
 *
 * @param {Object} options A map with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'variant' - The variant of the logo, that controls semantics of the logo.
 *  - 'format' - The format of the logo image to be retrieved (defaults to 'png').
 * @returns {String} The URL that can be used to retrieve a brand logo.
 */


ripe.Ripe.prototype.getLogoUrl = function (options) {
  options = this._getLogoOptions(options);
  return options.url + "?" + this._buildQuery(options.params);
};
/**
 * Returns the mesh contents for a model.
 *
 * @param {Object} options A map with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'variant' - The variant of the mesh, as defined in the model spec.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The model's mesh.
 */


ripe.Ripe.prototype.getMesh = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getMeshOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Returns the mesh contents for a model.
 *
 * @param {Object} options A map with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'variant' - The variant of the mesh, as defined in the model spec.
 * @returns {XMLHttpRequest} The model's mesh.
 */


ripe.Ripe.prototype.getMeshP = function (options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.getMesh(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Returns the URL where the mesh can be retrieved.
 *
 * This method is useful to allow external mesh loaders to
 * take control of the URL based mesh loading process.
 *
 * @param {Object} options A map with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'variant' - The variant of the mesh, as defined in the model spec.
 * @returns {String} The URL that can be used to retrieve the mesh.
 */


ripe.Ripe.prototype.getMeshUrl = function (options) {
  options = this._getMeshOptions(options);
  return options.url + "?" + this._buildQuery(options.params);
};
/**
 * Returns the configuration information of a specific brand and model.
 * If no model is provided then returns the information of the owner's current model.
 *
 * @param {Object} options A map with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'country' - The country where the model will be provided, some materials/colors might not be available.
 *  - 'flag' - A specific flag that may change the provided materials/colors available.
 *  - 'filter' - If the configuration should be filtered by the country and/or flag (defaults to 'true').
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The model's configuration data.
 */


ripe.Ripe.prototype.getConfig = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getConfigOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Returns the configuration information of a specific brand and model.
 * If no model is provided then returns the information of the owner's current model.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'country' - The country where the model will be provided, some materials/colors might not be available.
 *  - 'flag' - A specific flag that may change the provided materials/colors available.
 *  - 'filter' - If the configuration should be filtered by the country and/or flag (defaults to 'true').
 * @returns {Promise} The model's configuration data.
 */


ripe.Ripe.prototype.getConfigP = function (options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.getConfig(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Returns the default customization of a specific brand or model. If no model is provided
 * then returns the defaults of the owner's current model.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The model's default options.
 */


ripe.Ripe.prototype.getDefaults = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getDefaultsOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, function (result, isValid, request) {
    if (callback) callback(isValid ? result.parts : result, isValid, request);
  });
};
/**
 * Returns the default customization of a specific brand or model.
 * If no model is provided then returns the defaults of the owner's current model.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 * @param {Function} callback Function with the result of the request.
 * @returns {Object} The model's optional parts.
 */


ripe.Ripe.prototype.getOptionals = function (options, callback) {
  return this.getDefaults(options, function (defaults, isValid, request) {
    var optionals = [];

    for (var name in defaults) {
      var part = defaults[name];
      part.optional && optionals.push(name);
    }

    if (callback) callback(optionals, isValid, request);
  });
};
/**
 * Returns the possible customization combinations of a specific brand or model.
 * If no model is provided then returns the defaults of the owner's current model.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The model's total set of combinations.
 */


ripe.Ripe.prototype.getCombinations = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getCombinationsOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, function (result, isValid, request) {
    if (callback) callback(isValid ? result.combinations : result, isValid, request);
  });
};
/**
 * Returns the possible customization combinations of a specific brand or model.
 * If no model is provided then returns the defaults of the owner's current model.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 * @returns {Promise} The model's total set of combinations.
 */


ripe.Ripe.prototype.getCombinationsP = function (options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.getCombinations(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Returns the factory information where a model is made,
 * specifically its name and the estimated production time in days.
 * If no model is provided then returns the defaults of the owner's current model.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The factory information for the provided model.
 */


ripe.Ripe.prototype.getFactory = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getFactoryOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Returns the factory information where a model is made,
 * specifically its name and the estimated production time in days.
 * If no model is provided then returns the defaults of the owner's current model.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 * @param {Function} callback Function with the result of the request.
 * @returns {Promise} The factory information for the provided model.
 */


ripe.Ripe.prototype.getFactoryP = function (options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.getFactory(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Returns the result of the server side validation of model configurations
 * considering a given build's brand, model and version.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The name of the brand to be considered when validating.
 *  - 'model' - The name of the model to be considered when validating.
 *  - 'version' - The target build version to be considered when validating.
 *  - 'parts' - The parts to be validated.
 *  - 'engraving' - The engraving value to be validated.
 *  - 'size' - The size to be validated.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.validateModel = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._validateModelOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Returns the result of the server side validation of model configurations
 * considering a given build's brand, model and version.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The name of the brand to be considered when validating.
 *  - 'model' - The name of the model to be considered when validating.
 *  - 'version' - The target build version to be considered when validating.
 *  - 'parts' - The parts to be validated.
 *  - 'engraving' - The engraving value to be validated.
 *  - 'size' - The size to be validated.
 * @returns {Promise} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.validateModelP = function (options) {
  var _this6 = this;

  return new Promise(function (resolve, reject) {
    _this6.validateModel(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Returns the logic script of a model in the requested format (javascript or python).
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'format' - The format of the logic script ("js" or "py").
 *  - 'method' - The method of the logic module of the model.
 *  - 'args' - The arguments to pass to the method, as an object.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The logic script of the provided model.
 */


ripe.Ripe.prototype.getLogic = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getLogicOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Returns the logic script of a model in the requested format (javascript or python).
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'format' - The format of the logic script ("js" or "py").
 *  - 'method' - The method of the logic module of the model.
 *  - 'args' - The arguments to pass to the method, as an object.
 * @returns {Promise} The logic script of the provided model.
 */


ripe.Ripe.prototype.getLogicP = function (options) {
  var _this7 = this;

  return new Promise(function (resolve, reject) {
    _this7.getLogic(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Returns the result of the execution of the given method for the
 * logic script of a model.
 * Does this by running the provided method on the server side under
 * a proper "sandboxed" environment.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'method' - The method of the logic module of the model.
 *  - 'data' - The arguments to pass to the method.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The result of the logic function of the provided model.
 */


ripe.Ripe.prototype.runLogic = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._runLogicOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Returns the result of the execution of the given method for the
 * logic script of a model.
 * Does this by running the provided method on the server side under
 * a proper "sandboxed" environment.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'version' - The version of the build, defaults to latest.
 *  - 'method' - The method of the logic module of the model.
 *  - 'data' - The arguments to pass to the method.
 * @returns {Promise} The result of the logic function of the provided model.
 */


ripe.Ripe.prototype.runLogicP = function (options) {
  var _this8 = this;

  return new Promise(function (resolve, reject) {
    _this8.runLogic(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Server side callback method to be called for situations where a customization
 * for a model has been started.
 * This method allows the change of the current context of execution based on
 * a server side implementation of the 3DB's business logic.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.onConfig = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._onConfigOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Server side callback method to be called for situations where a customization
 * for a model has been started.
 * This method allows the change of the current context of execution based on
 * a server side implementation of the 3DB's business logic.
 *
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 * @returns {Promise} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.onConfigP = function (options) {
  var _this9 = this;

  return new Promise(function (resolve, reject) {
    _this9.onConfig(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Server side callback method to be called for situations where a customization
 * change was made on a part.
 * This method allows the change of the current context of execution based on
 * a server side implementation of the 3DB's business logic.
 *
 * @param {Object} options An object with options, such as:
 *  - 'name' - The name of the part to be changed.
 *  - 'value' - The value (material and color) of the part to be changed.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.onPart = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._onPartOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Server side callback method to be called for situations where a customization
 * change was made on a part.
 * This method allows the change of the current context of execution based on
 * a server side implementation of the 3DB's business logic.
 *
 * @param {Object} options An object with options, such as:
 *  - 'name' - The name of the part to be changed.
 *  - 'value' - The value (material and color) of the part to be changed.
 * @returns {Promise} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.onPartP = function (options) {
  var _this10 = this;

  return new Promise(function (resolve, reject) {
    _this10.onPart(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Server side callback method to be called for situations where the initials
 * or engraving values were changed.
 * This method allows the change of the current context of execution based on
 * a server side implementation of the 3DB's business logic.
 *
 * @param {Object} options An object with options, such as:
 *  - 'group' - The name of the group that is going to be changed.
 *  - 'value' - The initials value to be changed.
 *  - 'engraving' - The engraving value to be changed.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.onInitials = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._onInitialsOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Server side callback method to be called for situations where the initials
 * or engraving values were changed.
 * This method allows the change of the current context of execution based on
 * a server side implementation of the 3DB's business logic.
 *
 * @param {Object} options An object with options, such as:
 *  - 'group' - The name of the group that is going to be changed.
 *  - 'value' - The initials value to be changed.
 *  - 'engraving' - The engraving value to be changed.
 * @returns {Promise} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.onInitialsP = function (options) {
  var _this11 = this;

  return new Promise(function (resolve, reject) {
    _this11.onInitials(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getLogoOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var version = options.version === undefined ? this.version : options.version;
  var variant = options.variant === undefined ? this.variant : options.variant;
  var format = options.format === undefined ? "png" : options.format;
  var url = "".concat(this.url, "brands/").concat(brand, "/logo.").concat(format);
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  if (variant !== undefined && variant !== null) {
    params.variant = variant;
  }

  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getMeshOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var variant = options.variant === undefined ? this.variant : options.variant;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/mesh");
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  if (variant !== undefined && variant !== null) {
    params.variant = variant;
  }

  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};
/**
 * @see {link https://docs.platforme.com/#brand-endpoints-config-and-spec}
 * @ignore
 */


ripe.Ripe.prototype._getConfigOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var country = options.country === undefined ? this.country : options.country;
  var flag = options.flag === undefined ? this.flag : options.flag;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/config");
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  if (country !== undefined && country !== null) {
    params.country = country;
  }

  if (flag !== undefined && flag !== null) {
    params.flag = flag;
  }

  if (options.filter !== undefined && options.filter !== null) {
    params.filter = options.filter ? "1" : "0";
  }

  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};
/**
 * @see {link https://docs.platforme.com/#brand-endpoints-defaults}
 * @ignore
 */


ripe.Ripe.prototype._getDefaultsOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/defaults");
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getCombinationsOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var useName = options.useName !== undefined && options.useName !== null ? options.useName : false;
  var country = options.country === undefined ? this.country : options.country;
  var flag = options.flag === undefined ? this.flag : options.flag;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/combinations");
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  if (useName !== undefined && useName !== null) {
    params.use_name = useName ? "1" : "0";
  }

  if (country !== undefined && country !== null) {
    params.country = country;
  }

  if (flag !== undefined && flag !== null) {
    params.flag = flag;
  }

  if (options.resolve !== undefined && options.resolve !== null) {
    params.resolve = options.resolve ? "1" : "0";
  }

  if (options.sort !== undefined && options.sort !== null) {
    params.sort = options.sort ? "1" : "0";
  }

  if (options.filter !== undefined && options.filter !== null) {
    params.filter = options.filter ? "1" : "0";
  }

  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};
/**
 * @ignore
 * @see {link http://docs.platforme.com/#product-endpoints-factory}
 */


ripe.Ripe.prototype._getFactoryOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/factory");
  return Object.assign(options, {
    url: url,
    method: "GET"
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._validateModelOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var gender = options.gender === undefined ? null : options.gender;
  var size = options.size === undefined ? null : options.size;
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var queryOptions = options.queryOptions === undefined ? true : options.queryOptions;
  var initialsOptions = options.initialsOptions === undefined ? true : options.initialsOptions;

  if (queryOptions) {
    // obtains the query options taking into account that the brand
    // and the model are not to be included in the parameters as they
    // already part of the base URL structure
    options = this._getQueryOptions(Object.assign(options, {
      brand: null,
      model: null
    }));
  }

  if (initialsOptions) options = this._getInitialsOptions(options);
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/validate"); // "extracts" the parameters from the options, note that these values
  // may have been "manipulated" by the partial get options operations

  var params = options.params || {};

  if (gender !== undefined && gender !== null) {
    params.gender = gender;
  }

  if (size !== undefined && size !== null) {
    params.size = size;
  }

  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getLogicOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var format = options.format === undefined ? this.format : options.format;
  var method = options.method === undefined ? this.method : options.method;
  var args = options.args === undefined ? null : options.args;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/logic");
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  if (format !== undefined && format !== null) {
    params.format = format;
  }

  if (method !== undefined && method !== null) {
    params.method = method;
  }

  if (args !== undefined && args !== null) {
    Object.assign(params, args);
  }

  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._runLogicOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var method = options.method === undefined ? null : options.method;
  var dataJ = options.dataJ === undefined ? null : options.dataJ;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/logic/").concat(method);
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  return Object.assign(options, {
    url: url,
    method: "POST",
    params: params,
    dataJ: dataJ
  });
};
/**
 * @ignore
 * @see {link http://docs.platforme.com/#product-endpoints-on_config}
 */


ripe.Ripe.prototype._onConfigOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var initials = options.initials === undefined ? this.initialsExtra : options.initials;
  var parts = options.parts === undefined ? this.parts : options.parts;
  var choices = options.choices === undefined ? this.choices : options.choices;
  var brandI = options.brand === undefined ? null : options.brand;
  var modelI = options.model === undefined ? null : options.model;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/on_config");
  var ctx = Object.assign({}, this.ctx || {}, {
    brand: brand,
    model: model,
    version: version,
    initials: initials,
    parts: parts,
    choices: choices
  });
  return Object.assign(options, {
    url: url,
    method: "POST",
    dataJ: {
      brand: brandI,
      model: modelI,
      ctx: ctx
    }
  });
};
/**
 * @ignore
 * @see {link http://docs.platforme.com/#product-endpoints-on_part}
 */


ripe.Ripe.prototype._onPartOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var initials = options.initials === undefined ? this.initialsExtra : options.initials;
  var parts = options.parts === undefined ? this.parts : options.parts;
  var choices = options.choices === undefined ? this.choices : options.choices;
  var name = options.name === undefined ? null : options.name;
  var value = options.value === undefined ? null : options.value;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/on_part");
  var ctx = Object.assign({}, this.ctx || {}, {
    brand: brand,
    model: model,
    version: version,
    initials: initials,
    parts: parts,
    choices: choices
  });
  return Object.assign(options, {
    url: url,
    method: "POST",
    dataJ: {
      name: name,
      value: value,
      ctx: ctx
    }
  });
};
/**
 * @ignore
 * @see {link http://docs.platforme.com/#product-endpoints-on_initials}
 */


ripe.Ripe.prototype._onInitialsOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var initials = options.initials === undefined ? this.initialsExtra : options.initials;
  var parts = options.parts === undefined ? this.parts : options.parts;
  var choices = options.choices === undefined ? this.choices : options.choices;
  var group = options.group === undefined ? null : options.group;
  var value = options.value === undefined ? null : options.value;
  var engraving = options.engraving === undefined ? null : options.engraving;
  var url = "".concat(this.url, "brands/").concat(brand, "/models/").concat(model, "/on_initials");
  var ctx = Object.assign({}, this.ctx || {}, {
    brand: brand,
    model: model,
    version: version,
    initials: initials,
    parts: parts,
    choices: choices
  });
  return Object.assign(options, {
    url: url,
    method: "POST",
    dataJ: {
      group: group,
      initials: value,
      engraving: engraving,
      ctx: ctx
    }
  });
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Retrieves the complete list of builds available from the server.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getBuilds = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "builds");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves the complete list of builds available from the server.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The builds list (as a promise).
 */


ripe.Ripe.prototype.getBuildsP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getBuilds(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves the complete list of builds installed and available.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getLocalBuilds = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "builds/local");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves the complete list of builds installed and available.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The builds list (as a promise).
 */


ripe.Ripe.prototype.getLocalBuildsP = function (options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.getLocalBuilds(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves a build's information from the server side by name.
 *
 * @param {String} name The name of the of the build.
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getBuild = function (name, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "builds/").concat(name);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves a build's information from the server side by name.
 *
 * @param {String} name The name of the build.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The build's information (as a promise).
 */


ripe.Ripe.prototype.getBuildP = function (name, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.getBuild(name, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Installs a build on the server from remote repos for the given name.
 *
 * @param {String} name The build's name to be installed.
 * @param {Object} options An object with options, such as:
 *  - 'version' - The version of the build to install, if no version is given,
 * installs the latest one.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.installBuild = function (name, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var version = options.version === undefined ? null : options.version;
  var url = "".concat(this.url, "builds/").concat(name, "/install");
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true,
    params: params
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Installs a build on the server from remote repos for the given name.
 *
 * @param {String} name The build's name to be installed.
 * @param {Object} options An object with options, such as:
 *  - 'version' - The version of the build to install, if no version is given,
 * installs the latest one.
 * @returns {Promise} The build install (as a promise).
 */


ripe.Ripe.prototype.installBuildP = function (name, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.installBuild(name, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Uninstalls a build from the server according to provided values.
 *
 * @param {String} name The name of the build to be uninstalled.
 * @param {Object} options An object with options, such as:
 *  - 'version' - The version of the build to uninstall, if no version is given,
 * uninstalls all builds for the name.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.uninstallBuild = function (name, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var version = options.version === undefined ? null : options.version;
  var url = "".concat(this.url, "builds/").concat(name, "/uninstall");
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true,
    params: params
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Uninstalls a build from the server according to provided values.
 *
 * @param {String} name The name of the build to be uninstalled.
 * @param {Object} options An object with options, such as:
 *  - 'version' - The version of the build to uninstall, if no version is given,
 * uninstalls all builds for the name.
 * @returns {Promise} The build uninstall (as a promise).
 */


ripe.Ripe.prototype.uninstallBuildP = function (name, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.uninstallBuild(name, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Updates a build to the latest version, maintaining the installation of
 * the previous versions.
 *
 * @param {String} name The build's name of the build to update name.
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.updateBuild = function (name, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "builds/").concat(name, "/update");
  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Updates a build to the latest version, maintaining the installation of
 * the previous versions.
 *
 * @param {String} name The build's name of the build to update name.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The build update (as a promise).
 */


ripe.Ripe.prototype.updateBuildP = function (name, options) {
  var _this6 = this;

  return new Promise(function (resolve, reject) {
    _this6.updateBuild(name, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Switches the active version of a build, moving internal references to
 * the newly selected build version.
 *
 * @param {String} name The name of the build to be switched.
 * @param {Object} options An object with options, such as:
 *  - 'version' - The version of the build to activate.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.switchBuild = function (name, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var version = options.version === undefined ? null : options.version;
  var url = "".concat(this.url, "builds/").concat(name, "/switch");
  var params = {};

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true,
    params: params
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Switches the active version of a build, moving internal references to
 * the newly selected build version.
 *
 * @param {String} name The name of the build to be switched.
 * @param {Object} options An object with options, such as:
 *  - 'version' - The version of the build to activate.
 * @returns {Promise} The build switch (as a promise).
 */


ripe.Ripe.prototype.switchBuildP = function (name, options) {
  var _this7 = this;

  return new Promise(function (resolve, reject) {
    _this7.switchBuild(name, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves the build artifacts by name and version and for
 * the requested branch.
 *
 * @param {String} name The name of the build artifacts.
 * @param {String} version The version of the build artifacts.
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getBuildArtifacts = function (name, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var branch = options.branch === undefined ? "master" : options.branch;
  var url = "".concat(this.url, "builds/").concat(name, "/artifacts");
  var params = {};

  if (branch !== undefined && branch !== null) {
    params.branch = branch;
  }

  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true,
    params: params
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves the build artifacts by brand name and version and for
 * the requested branch.
 *
 * @param {String} name The name of the brand of the build artifacts.
 * @param {String} version The version of the build artifacts.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The build artifacts (as a promise).
 */


ripe.Ripe.prototype.getBuildArtifactsP = function (name, options) {
  var _this8 = this;

  return new Promise(function (resolve, reject) {
    _this8.getBuildArtifacts(name, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves the build artifact information by brand name and version.
 *
 * @param {String} name The name of the brand of the build artifact.
 * @param {String} version The version of the build artifact.
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getBuildArtifact = function (name, version, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "builds/").concat(name, "/artifacts/").concat(version);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves the build artifact information by name and version.
 *
 * @param {String} name The name of the build artifact.
 * @param {String} version The version of the build artifact.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The build artifact (as a promise).
 */


ripe.Ripe.prototype.getBuildArtifactP = function (name, version, options) {
  var _this9 = this;

  return new Promise(function (resolve, reject) {
    _this9.getBuildArtifact(name, version, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Installs a build artifact by build name and artifact version.
 *
 * @param {String} name The name of the build associated with the artifact.
 * @param {String} version The version of the build artifact.
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.installArtifact = function (name, version, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "builds/").concat(name, "/artifacts/").concat(version, "/install");
  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Installs a build artifact by build name and artifact version.
 *
 * @param {String} name The name of the build associated with the artifact.
 * @param {String} version The version of the build artifact.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The build install (as a promise).
 */


ripe.Ripe.prototype.installArtifactP = function (name, version, options) {
  var _this10 = this;

  return new Promise(function (resolve, reject) {
    _this10.installArtifact(name, version, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Uninstalls a build artifact by build name and artifact version.
 *
 * @param {String} name The name of the build associated with the artifact.
 * @param {String} version The version of the build artifact.
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.uninstallArtifact = function (name, version, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "builds/").concat(name, "/artifacts/").concat(version, "/uninstall");
  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Uninstalls a build artifact by build name and artifact version.
 *
 * @param {String} name The name of the build associated with the artifact.
 * @param {String} version The version of the build artifact.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The artifact uninstall (as a promise).
 */


ripe.Ripe.prototype.uninstallArtifactP = function (name, version, options) {
  var _this11 = this;

  return new Promise(function (resolve, reject) {
    _this11.uninstallArtifact(name, version, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Switches the active version of a build, changing the active version of
 * the build to the version defined in the request.
 *
 * @param {String} name The name of the build to be switched.
 * @param {String} version The version of the build artifact.
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.switchArtifact = function (name, version, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "builds/").concat(name, "/artifacts/").concat(version, "/switch");
  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Switches the active version of a build, changing the active version of
 * the build to the version defined in the request.
 *
 * @param {String} name The name of the build to be switched.
 * @param {String} version The version of the build artifact.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The build switch (as a promise).
 */


ripe.Ripe.prototype.switchArtifactP = function (name, version, options) {
  var _this12 = this;

  return new Promise(function (resolve, reject) {
    _this12.switchArtifact(name, version, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves the bundle of part, materials and colors translations of a specific brand and model
 * If no model is defined the retrieves the bundle of the owner's current model.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'brand' - The brand of the model.
 * - 'model' - The name of the model.
 * - 'locale' - The locale of the translations.
 * - 'compatibility' - If compatibility mode should be enabled.
 * - 'prefix' - A prefix to prepend to the locale keys (defaults to 'builds').
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getLocaleModel = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getLocaleModelOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves the bundle of part, materials and colors translations of a specific brand and model
 * If no model is defined the retrieves the bundle of the owner's current model.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'brand' - The brand of the model.
 * - 'model' - The name of the model.
 * - 'locale' - The locale of the translations.
 * - 'compatibility' - If compatibility mode should be enabled.
 * - 'prefix' - A prefix to prepend to the locale keys (defaults to 'builds').
 * @returns {Promise} The resolved locale data (as a promise).
 */


ripe.Ripe.prototype.getLocaleModelP = function (options) {
  var _this13 = this;

  return new Promise(function (resolve, reject) {
    _this13.getLocaleModel(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves the default locale keys of a specific brand and model.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'brand' - The brand of the model. If no brand is defined it retrieves the keys of the owner's current brand.
 * - 'model' - The name of the model. If no model is defined it retrieves the keys of the owner's current model.
 * - 'version' - The version of the build. If no version is defined it retrieves the keys of the owner's current version.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getLocaleModelKeys = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getLocaleModelKeysOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves the default locale keys of a specific brand and model.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'brand' - The brand of the model. If no brand is defined it retrieves the keys of the owner's current brand.
 * - 'model' - The name of the model. If no model is defined it retrieves the keys of the owner's current model.
 * - 'version' - The version of the build. If no version is defined it retrieves the keys of the owner's current version.
 * @returns {Promise} The resolved locale data (as a promise).
 */


ripe.Ripe.prototype.getLocaleModelKeysP = function (options) {
  var _this14 = this;

  return new Promise(function (resolve, reject) {
    _this14.getLocaleModelKeys(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * @ignore
 * @see {link http://docs.platforme.com/#build-endpoints-locale}
 */


ripe.Ripe.prototype._getLocaleModelOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var locale = options.locale === undefined || options.locale === null ? this.locale : options.locale;
  var url = "".concat(this.url, "builds/").concat(brand, "/locale/").concat(locale);
  var params = {};

  if (model !== undefined && model !== null) {
    params.model = model;
  }

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  if (options.compatibility !== undefined && options.compatibility !== null) {
    params.compatibility = options.compatibility ? "1" : "0";
  }

  if (options.prefix !== undefined && options.prefix !== null) {
    params.prefix = options.prefix;
  }

  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getLocaleModelKeysOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var version = options.version === undefined ? this.version : options.version;
  var url = "".concat(this.url, "builds/").concat(brand, "/locale/keys");
  var params = {};

  if (model !== undefined && model !== null) {
    params.model = model;
  }

  if (version !== undefined && version !== null) {
    params.version = version;
  }

  return Object.assign(options, {
    url: url,
    method: "GET",
    auth: true,
    params: params
  });
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Gets the global configuration object from the RIPE server (admin endpoint).
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.configGlobal = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "config");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the global configuration object from the RIPE server (admin endpoint).
 *
 * @param {Object} options An object of options to configure the request.
 */


ripe.Ripe.prototype.configGlobalP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.configGlobal(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Resolves the RIPE configuration options (includes DKU) from the provided set
 * of options or in alternative the current Ripe Instance state.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'url' - The base URL.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.configInfo = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getConfigInfoOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Resolves the RIPE configuration options (includes DKU)  from the provided set
 * of options or in alternative the current Ripe Instance state.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'url' - The base URL.
 * @param {Function} callback Function with the result of the request.
 * s {Promise} The model's configuration data.
 */


ripe.Ripe.prototype.configInfoP = function (options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.configInfo(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Resolves the provided DKU value into a more structured set of model, brand,
 * parts, etc. so that it can be used under RIPE.
 *
 * @param {String} dku The DKU identifier to be used in the resolution.
 * @param {Object} options An object of options to configure the request, such as:
 * - 'url' - The base URL.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.configDku = function (dku, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = Object.assign({
    dku: dku,
    queryOptions: false,
    initialsOptions: false
  }, options);
  options = this._getConfigInfoOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Resolves the provided DKU value into a more structured set of mode, brand,
 * parts, etc. so that it can be used under RIPE.
 *
 * @param {String} dku The DKU identifier to be used in the resolution.
 * @param {Object} options An object of options to configure the request, such as:
 * - 'url' - The base URL.
 * @param {Function} callback Function with the result of the request.
 * s {Promise} The model's configuration data.
 */


ripe.Ripe.prototype.configDkuP = function (dku, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.configDku(dku, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Resolves the provided SKU value into a more structured set of model, brand,
 * parts, etc. so that it can be used under RIPE.
 *
 * @param {String} sku The SKU identifier to be used in the resolution.
 * @param {String} domain The domain to be used in the resolution.
 * @param {Object} options An object of options to configure the request, such as:
 * - 'url' - The base URL.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.configSku = function (sku, domain, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = Object.assign({
    sku: sku,
    domain: domain,
    queryOptions: false,
    initialsOptions: false
  }, options);
  options = this._getConfigInfoOptions(options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Resolves the provided SKU value into a more structured set of mode, brand,
 * parts, etc. so that it can be used under RIPE.
 *
 * @param {String} sku The SKU identifier to be used in the resolution.
 * @param {String} domain The domain to be used in the resolution.
 * @param {Object} options An object of options to configure the request, such as:
 * - 'url' - The base URL.
 * @param {Function} callback Function with the result of the request.
 * s {Promise} The model's configuration data.
 */


ripe.Ripe.prototype.configSkuP = function (sku, domain, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.configSku(sku, domain, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Resolves a customization to a mapped SKU.
 *
 * @param {String} domain The SKU domain (falls back to brand value).
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model
 *  - 'model' - The name of the model
 *  - 'variant' - The variant of the model.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'initialsExtra' - The value for the initials extra of the personalized model.
 *  - 'productId' - The product's unique identification.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.configResolveSku = function (domain, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._getConfigSkuOptions(domain, options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Resolves a customization to a mapped SKU.
 *
 * @param {String} domain The SKU domain (falls back to brand value).
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model
 *  - 'model' - The name of the model
 *  - 'variant' - The variant of the model.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'initialsExtra' - The value for the initials extra of the personalized model.
 *  - 'productId' - The product's unique identification.
 * @param {Function} callback Function with the result of the request.
 * @returns {Promise} The model's configuration data.
 */


ripe.Ripe.prototype.configResolveSkuP = function (domain, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.configResolveSku(domain, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Gets the configuration of a product identified by its unique product ID.
 *
 * @param {String} productId The identifier of the product to be resolved.
 * @param {Object} options An object of options to configure the request, such as:
 * - 'url' - The base URL.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.configResolve = function (productId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "config/resolve/").concat(productId);
  options = Object.assign({
    url: url
  }, options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the configuration of a product identified by its unique product ID.
 *
 * @param {String} productId The identifier of the product to be resolved.
 * @param {Object} options An object of options to configure the request, such as:
 * - 'url' - The base URL.
 * s {Promise} The model's configuration data.
 */


ripe.Ripe.prototype.configResolveP = function (productId, options) {
  var _this6 = this;

  return new Promise(function (resolve, reject) {
    _this6.configResolve(productId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getConfigInfoOptions = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sku = options.sku === undefined ? null : options.sku;
  var dku = options.dku === undefined ? null : options.dku;
  var domain = options.domain === undefined ? null : options.domain;
  var size = options.size === undefined ? null : options.size;
  var gender = options.gender === undefined ? null : options.gender;
  var meta = options.meta === undefined ? this.meta : options.meta;

  var _params = options._params === undefined ? this._params : options._params;

  var guess = options.guess === undefined ? this.guess : options.guess;
  var queryOptions = options.queryOptions === undefined ? true : options.queryOptions;
  var initialsOptions = options.initialsOptions === undefined ? true : options.initialsOptions;
  if (queryOptions) options = this._getQueryOptions(options);
  if (initialsOptions) options = this._getInitialsOptions(options);
  var params = options.params || {};
  options.params = params;

  if (sku !== undefined && sku !== null) {
    params.sku = sku;
  }

  if (dku !== undefined && dku !== null) {
    params.dku = dku;
  }

  if (domain !== undefined && domain !== null) {
    params.domain = domain;
  }

  if (size !== undefined && size !== null) {
    params.size = size;
  }

  if (gender !== undefined && gender !== null) {
    params.gender = gender;
  }

  if (meta !== undefined && meta !== null) {
    params.meta = meta;
  }

  if (_params !== undefined && _params !== null) {
    params.params = _params;
  }

  if (guess !== undefined && guess !== null) {
    params.guess = guess ? "1" : "0";
  }

  var url = "".concat(this.url, "config/info");
  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getConfigSkuOptions = function (domain) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var queryOptions = options.queryOptions === undefined ? true : options.queryOptions;
  var initialsOptions = options.initialsOptions === undefined ? true : options.initialsOptions;
  if (queryOptions) options = this._getQueryOptions(options);
  if (initialsOptions) options = this._getInitialsOptions(options);
  var params = options.params || {};
  if (domain) params.domain = domain;
  options.params = params;
  var url = "".concat(this.url, "config/sku");
  return Object.assign(options, {
    url: url,
    method: "GET",
    params: params
  });
};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Gets the existing country groups, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'filters[]' - List of filters that the query will use to, operators such as
 * ('in', 'not_in', 'like', 'contains'), for instance (eg: 'id:eq:42') would filter by the id that equals to 42.
 * - 'sort' - List of arguments to sort the results by and which direction
 * to sort them in (eg: 'id:ascending') would sort by the id attribute in ascending order,
 * while (eg: 'id:descending')] would do it in descending order.
 * - 'skip' - The number of the first record to retrieve from the results.
 * - 'limit' - The number of results to retrieve.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getCountryGroups = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "country_groups");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the existing country groups, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The country group result list.
 */


ripe.Ripe.prototype.getCountryGroupsP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getCountryGroups(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Creates a new country group.
 *
 * @param {Object} countryGroup An object with information needed to create a country group
 * ex:{name: "Europe 1", currency: "EUR", countries: ["Portugal, Spain, France"]}.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.createCountryGroup = function (countryGroup, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "country_groups");
  options = Object.assign(options, {
    url: url,
    auth: true,
    method: "POST",
    dataJ: countryGroup
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Creates a new country group.
 *
 * @param {Object} countryGroup An object with information needed to create a country group
 * ex: {name: "Europe 1", currency: "EUR", countries: ["Portugal, Spain, France"]}.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The country group's data.
 */


ripe.Ripe.prototype.createCountryGroupP = function (countryGroup, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.createCountryGroup(countryGroup, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Gets a country group by its ID.
 *
 * @param {Object} id ID of the intended country group.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getCountryGroup = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "country_groups/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets a country group by its ID.
 *
 * @param {Object} id ID of the intended country group.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The country group requested by ID.
 */


ripe.Ripe.prototype.getCountryGroupP = function (id, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.getCountryGroup(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Updates an existing country group.
 *
 * @param {Object} id ID of the country group to be updated.
 * @param {Object} countryGroup An object with the updated information of the country group.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.updateCountryGroup = function (id, countryGroup, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "country_groups/").concat(id);
  options = Object.assign(options, {
    url: url,
    auth: true,
    method: "PUT",
    dataJ: countryGroup
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Updates an existing country group.
 *
 * @param {Object} id ID of the country group to be updated.
 * @param {Object} countryGroup An object with the updated information of the country group.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The country group's data.
 */


ripe.Ripe.prototype.updateCountryGroupP = function (id, countryGroup, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.updateCountryGroup(id, countryGroup, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Deletes an existing country group.
 *
 * @param {Object} id ID of the country group to be deleted.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.deleteCountryGroup = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "country_groups/").concat(id);
  options = Object.assign(options, {
    url: url,
    auth: true,
    method: "DELETE"
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Deletes an existing country group.
 *
 * @param {Object} id ID of the country group to be deleted.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The result of the country group's deletion.
 */


ripe.Ripe.prototype.deleteCountryGroupP = function (id, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.deleteCountryGroup(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Gets the existing factory rules, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getFactoryRules = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "factory_rules");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the existing factory rules, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The factory rules result list.
 */


ripe.Ripe.prototype.getFactoryRulesP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getFactoryRules(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Creates a factory rule on RIPE Core.
 *
 * @param {Object} factoryRule An object with information needed to create a factory rule.
 * @param {Object} options An object with options.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.createFactoryRule = function (factoryRule, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "factory_rules");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    auth: true,
    dataJ: factoryRule
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Creates a factory rule on RIPE Core.
 *
 * @param {Object} factoryRule An object with information needed to create a factory rule.
 * @param {Object} options An object with options.
 * @returns {Promise} The factory rule's data.
 */


ripe.Ripe.prototype.createFactoryRuleP = function (factoryRule, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.createFactoryRule(factoryRule, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Gets an existing factory rule filtered by ID and according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Number} id The factory rule's ID.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getFactoryRule = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "factory_rules/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets an existing factory rule filtered by ID and according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Number} id The factory rule's ID.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The factory rule requested by ID.
 */


ripe.Ripe.prototype.getFactoryRuleP = function (id, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.getFactoryRule(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Updates a factory rule on RIPE Core.
 *
 * @param {Object} factoryRule An object with information needed to update a factory rule.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.updateFactoryRule = function (factoryRule, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "factory_rules/").concat(factoryRule.id);
  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true,
    dataJ: factoryRule
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Updates a factory rule on RIPE Core.
 *
 * @param {Object} factoryRule An object with information needed to update a factory rule.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The factory rule's data.
 */


ripe.Ripe.prototype.updateFactoryRuleP = function (factoryRule, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.updateFactoryRule(factoryRule, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Deletes an existing factory rule.
 *
 * @param {Number} id The factory rule's ID.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.deleteFactoryRule = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "factory_rules/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "DELETE",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Deletes an existing factory rule.
 *
 * @param {Number} id The factory rule's ID.
 * @param {Object} options An object of options to configure the request
 * @returns {Promise} The result of the factory rule's deletion.
 */


ripe.Ripe.prototype.deleteFactoryRuleP = function (id, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.deleteFactoryRule(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Gets the existing justifications, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'filters[]' - List of filters that the query will use to, operators such as
 * ('in', 'not_in', 'like', 'contains'), for instance (eg: 'id:eq:42') would filter by the id that equals to 42.
 * - 'sort' - List of arguments to sort the results by and which direction
 * to sort them in (eg: 'id:ascending') would sort by the id attribute in ascending order,
 * while (eg: 'id:descending')] would do it in descending order.
 * - 'skip' - The number of the first record to retrieve from the results.
 * - 'limit' - The number of results to retrieve.
 * @param {Function} callback Function with the result of the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getJustifications = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "justifications");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the existing justifications, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The justifications result list.
 */


ripe.Ripe.prototype.getJustificationsP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getJustifications(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Gets the existing justifications filtered by context, according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'filters[]' - List of filters that the query will use to, operators such as
 * ('in', 'not_in', 'like', 'contains'), for instance (eg: 'id:eq:42') would filter by the id that equals to 42.
 * - 'sort' - List of arguments to sort the results by and which direction
 * to sort them in (eg: 'id:ascending') would sort by the id attribute in ascending order,
 * while (eg: 'id:descending')] would do it in descending order.
 * - 'skip' - The number of the first record to retrieve from the results.
 * - 'limit' - The number of results to retrieve.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getJustificationsByContext = function (context, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "justifications/").concat(context);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the existing justifications filtered by context, according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'filters[]' - List of filters that the query will use to, operators such as
 * ('in', 'not_in', 'like', 'contains'), for instance (eg: 'id:eq:42') would filter by the id that equals to 42.
 * - 'sort' - List of arguments to sort the results by and which direction
 * to sort them in (eg: 'id:ascending') would sort by the id attribute in ascending order,
 * while (eg: 'id:descending')] would do it in descending order.
 * - 'skip' - The number of the first record to retrieve from the results.
 * - 'limit' - The number of results to retrieve.
 * @returns {Promise} The justifications result list.
 */


ripe.Ripe.prototype.getJustificationsByContextP = function (context, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.getJustificationsByContext(context, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Gets the existing letter rules, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getLetterRules = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "letter_rules");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the existing letter rules, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The letter rules result list.
 */


ripe.Ripe.prototype.getLetterRulesP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getLetterRules(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Creates a letter rule on RIPE Core.
 *
 * @param {Object} letterRule An object with information needed to create a letter rule.
 * @param {Object} options An object with options.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.createLetterRule = function (letterRule, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "letter_rules");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    auth: true,
    dataJ: letterRule
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Creates a letter rule on RIPE Core.
 *
 * @param {Object} letterRule An object with information needed to create a letter rule.
 * @param {Object} options An object with options.
 * @returns {Promise} The letter rule's data.
 */


ripe.Ripe.prototype.createLetterRuleP = function (letterRule, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.createLetterRule(letterRule, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Gets an existing letter rule filtered by ID and according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Number} id The letter rule's ID.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getLetterRule = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "letter_rules/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets an existing letter rule filtered by ID and according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Number} id The letter rule's ID.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The letter rule requested by ID.
 */


ripe.Ripe.prototype.getLetterRuleP = function (id, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.getLetterRule(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Updates a letter rule on RIPE Core.
 *
 * @param {Object} letterRule An object with information needed to update a letter rule.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.updateLetterRule = function (letterRule, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "letter_rules/").concat(letterRule.id);
  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true,
    dataJ: letterRule
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Updates a letter rule on RIPE Core.
 *
 * @param {Object} letterRule An object with information needed to update a letter rule.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The letter rule's data.
 */


ripe.Ripe.prototype.updateLetterRuleP = function (letterRule, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.updateLetterRule(letterRule, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Deletes an existing letter rule.
 *
 * @param {Number} id The letter rule's ID.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.deleteLetterRule = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "letter_rules/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "DELETE",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Deletes an existing letter rule.
 *
 * @param {Number} id The letter rule's ID.
 * @param {Object} options An object of options to configure the request
 * @returns {Promise} The result of the letter rule's deletion.
 */


ripe.Ripe.prototype.deleteLetterRuleP = function (id, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.deleteLetterRule(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Localizes a value to the provided locale.
 *
 * @param {String} value The value to be localized.
 * @param {String} locale The locale to localize the value to.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.locale_ = function (value, locale, options, callback) {
  return this.localeMultiple(value, locale, options, callback);
};

ripe.Ripe.prototype.localeP = function (value, locale, options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.locale_(value, locale, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Localizes a list of values to the provided locale.
 *
 * @param {String} values The values to be localized.
 * @param {String} locale The locale to localize the value to.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.localeMultiple = function (values, locale, options, callback) {
  values = typeof values === "string" ? [values] : values;
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "locale");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      values: values,
      locale: locale
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.localeMultipleP = function (values, locale, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.localeMultiple(values, locale, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves a bundle of locales for the provided locale value.
 *
 * @param {String} locale The locale string to retrieve the bundle.
 * @param {String} context The inner context for the locale bundle.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.localeBundle = function (locale, context, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "locale/bundle");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      locale: locale,
      context: context
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.localeBundleP = function (locale, context, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.localeBundle(locale, context, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || navigator !== undefined && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Creates a notify info (if required) for the current user, and adds
 * the provided device ID to the list of device ids in the notify info.
 *
 * @param {String} deviceId The device identifier as a plain string
 * to be used in registration.
 * @returns {XMLHttpRequest} The current user's notify info instance.
 */


ripe.Ripe.prototype.createDeviceId = function (deviceId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "notify_infos/device_ids");
  options = Object.assign(options, {
    url: url,
    auth: true,
    method: "POST",
    dataJ: {
      id: deviceId
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Creates a notify info (if required) for the current user, and adds
 * the provided device ID to the list of device ids in the notify info.
 *
 * @param {String} deviceId The device identifier as a plain string
 * to be used in registration.
 * @returns {Promise} The current user's notify info instance.
 */


ripe.Ripe.prototype.createDeviceIdP = function (deviceId, options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.createDeviceId(deviceId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Removes a device ID from the the notify info instance associated
 * with the user in session.
 *
 * @param {String} deviceId The device identifier to be removed.
 * @returns {XMLHttpRequest} The current user's notify info instance.
 */


ripe.Ripe.prototype.removeDeviceId = function (deviceId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "notify_infos/device_ids/").concat(deviceId);
  options = Object.assign(options, {
    url: url,
    auth: true,
    method: "DELETE",
    dataJ: {
      device_id: deviceId
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Removes a device ID from the the notify info instance associated
 * with the user in session.
 *
 * @param {String} deviceId The device identifier to be removed.
 * @returns {Promise} The current user's notify info instance.
 */


ripe.Ripe.prototype.removeDeviceIdP = function (deviceId, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.removeDeviceId(deviceId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Retrieves the complete set of OAuth elements to be used, such as:
 * the access_token, token_type, expires_in, refresh_token, scope and
 * tokens. Notice that both the scope and the tokens are retrieved providing
 * the ability to modify experience taking that into account.
 *
 * @param {String} code The OAuth code.
 * @param {Object} options An object of options to configure the request, such as
 * 'code', 'clientId', 'clientSecret', 'redirectUri' and the 'grantType'.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.oauthAccessToken = function (code, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "admin/oauth/access_token");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    params: {
      code: code,
      client_id: options.clientId || this.clientId,
      client_secret: options.clientSecret || this.clientSecret,
      redirect_uri: options.redirectUri || this.redirectUri,
      grant_type: options.grantType || this.grantType || "authorization_code"
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves the session identifier (SID) for the currently
 * active session, this is going to be used on all requests
 * to refer to the proper session.
 *
 * @param {String} accessToken The access token to be used.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.oauthLogin = function (accessToken, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "admin/oauth/login");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    params: {
      access_token: accessToken
    }
  });
  return this._cacheURL(options.url, options, callback);
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Gets the orders list, optionally filtered by a set of options.
 *
 * @param {Object} options An object of options to configure the query and
 * its results, such as:
 * - 'filters[]' - List of filters that the query will use to, operators such as
 * ('in', 'not_in', 'like', 'likei', 'llike', 'llikei', 'rlike', 'rlikei', 'contains'),
 * (eg: 'number:eq:42') would filter by the 'number' that equals to '42'.
 * - 'sort' - List of arguments to sort the results by and which direction
 * to sort them in (eg: 'id:ascending') would sort by the id attribute in ascending order,
 * while (eg: 'id:descending')] would do it in descending order.
 * - 'skip' - The number of the first record to retrieve from the results.
 * - 'limit' - The number of results to retrieve.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getOrders = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the orders list, optionally filtered by a set of options.
 *
 * @param {Object} options An object of options to configure the request.
 * its results, such as:
 * - 'filters[]' - List of filters that the query will use to, operators such as
 * ('in', 'not_in', 'like', 'contains'), for instance (eg: 'id:eq:42') would filter by the id that equals to 42.
 * - 'sort' - List of arguments to sort the results by and which direction
 * to sort them in (eg: 'id:ascending') would sort by the id attribute in ascending order,
 * while (eg: 'id:descending')] would do it in descending order.
 * - 'skip' - The number of the first record to retrieve from the results.
 * - 'limit' - The number of results to retrieve.
 * @returns {Promise} The orders result list.
 */


ripe.Ripe.prototype.getOrdersP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getOrders(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Gets an order by number.
 *
 * @param {Number} number The number of the order to find by.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getOrder = function (number, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets an order by number.
 *
 * @param {Number} number The number of the order to find by.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The order requested by number.
 */


ripe.Ripe.prototype.getOrderP = function (number, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.getOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Deletes an order by number.
 *
 * @param {Number} number The number of the order to delete.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.deleteOrder = function (number, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number);
  options = Object.assign(options, {
    url: url,
    method: "DELETE",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Deletes an order by number.
 *
 * @param {Number} number The number of the order to delete.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The result of the order deletion.
 */


ripe.Ripe.prototype.deleteOrderP = function (number, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.deleteOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.attachmentsOrder = function (number, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/attachments");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.attachmentsOrderP = function (number, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.attachmentsOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.createAttachmentOrder = function (number, file, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/attachments");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    dataM: {
      file: file
    },
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.createAttachmentOrderP = function (number, file, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.createAttachmentOrder(number, file, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.logOrder = function (number, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/log");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.logOrderP = function (number, options) {
  var _this6 = this;

  return new Promise(function (resolve, reject) {
    _this6.logOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.statesOrder = function (number, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.statesOrderP = function (number, options) {
  var _this7 = this;

  return new Promise(function (resolve, reject) {
    _this7.statesOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.stateOrder = function (number, stateId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states/").concat(stateId);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.stateOrderP = function (number, stateId, options) {
  var _this8 = this;

  return new Promise(function (resolve, reject) {
    _this8.stateOrder(number, stateId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.stateChatOrder = function (number, stateId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states/").concat(stateId, "/chat");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true,
    cached: false
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.stateChatOrderP = function (number, stateId, options) {
  var _this9 = this;

  return new Promise(function (resolve, reject) {
    _this9.stateChatOrder(number, stateId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.stateChatLinesOrder = function (number, stateId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states/").concat(stateId, "/chat/lines");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true,
    cached: false
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.stateChatLinesOrderP = function (number, stateId, options) {
  var _this10 = this;

  return new Promise(function (resolve, reject) {
    _this10.stateChatOrder(number, stateId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.stateChatLinesCountOrder = function (number, stateId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states/").concat(stateId, "/chat/lines/count");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true,
    cached: false
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.stateChatLinesCountOrderP = function (number, stateId, options) {
  var _this11 = this;

  return new Promise(function (resolve, reject) {
    _this11.stateChatLinesCountOrder(number, stateId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.stateChatCreateLineOrder = function (number, stateId, contents, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states/").concat(stateId, "/chat/lines");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    params: {
      contents: contents
    },
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.stateChatCreateLineOrderP = function (number, stateId, contents, options) {
  var _this12 = this;

  return new Promise(function (resolve, reject) {
    _this12.stateChatCreateLineOrder(number, stateId, contents, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.stateAttachmentsOrder = function (number, stateId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states/").concat(stateId, "/attachments");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true,
    cached: false
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.stateAttachmentsOrderP = function (number, stateId, options) {
  var _this13 = this;

  return new Promise(function (resolve, reject) {
    _this13.stateAttachmentsOrder(number, stateId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.stateAttachmentsCountOrder = function (number, stateId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states/").concat(stateId, "/attachments/count");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true,
    cached: false
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.stateAttachmentsCountOrderP = function (number, stateId, options) {
  var _this14 = this;

  return new Promise(function (resolve, reject) {
    _this14.stateAttachmentsCountOrder(number, stateId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.stateCreateAttachmentOrder = function (number, stateId, file, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states/").concat(stateId, "/attachments");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    dataM: {
      file: file
    },
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.stateCreateAttachmentOrderP = function (number, stateId, file, options) {
  var _this15 = this;

  return new Promise(function (resolve, reject) {
    _this15.stateCreateAttachmentOrder(number, stateId, file, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.stateAttachmentOrder = function (number, stateId, attachmentName, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/states/").concat(stateId, "/attachments/").concat(attachmentName);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true,
    cached: false
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.stateAttachmentOrderP = function (number, stateId, attachmentName, options) {
  var _this16 = this;

  return new Promise(function (resolve, reject) {
    _this16.stateAttachmentOrder(number, stateId, attachmentName, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Searches for orders using the filter string and the options that
 * are provided.
 *
 * @param {String} filterString An unstructured string to be used in the
 * orders search operation.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.searchOrders = function (filterString, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/search");
  var params = {};

  if (filterString !== undefined && filterString !== null) {
    params.filter_string = filterString;
  }

  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true,
    params: params
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Searches for orders using the filter string and the options that
 * are provided.
 *
 * @param {String} filterString An unstructured string to be used in the
 * orders search operation.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The result of the order deletion.
 */


ripe.Ripe.prototype.searchOrdersP = function (filterString, options) {
  var _this17 = this;

  return new Promise(function (resolve, reject) {
    _this17.searchOrders(filterString, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Sets the order status to 'create'.
 *
 * @param {Number} number The number of the order to update.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.createOrder = function (number, options, callback) {
  return this.setOrderStatus(number, "create", options, callback);
};

ripe.Ripe.prototype.createOrderP = function (number, options) {
  var _this18 = this;

  return new Promise(function (resolve, reject) {
    _this18.createOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Sets the order status to 'produce'.
 *
 * @param {Number} number The number of the order to update.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.produceOrder = function (number, options, callback) {
  return this.setOrderStatus(number, "produce", options, callback);
};

ripe.Ripe.prototype.produceOrderP = function (number, options) {
  var _this19 = this;

  return new Promise(function (resolve, reject) {
    _this19.produceOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Sets the order status to 'ready'.
 *
 * @param {Number} number The number of the order to update.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.readyOrder = function (number, options, callback) {
  return this.setOrderStatus(number, "ready", options, callback);
};

ripe.Ripe.prototype.readyOrderP = function (number, options) {
  var _this20 = this;

  return new Promise(function (resolve, reject) {
    _this20.readyOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

ripe.Ripe.prototype.sendOrder = function (number, trackingNumber, trackingUrl, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = Object.assign(options, {
    params: {
      tracking_number: trackingNumber,
      tracking_url: trackingUrl
    }
  });
  return this.setOrderStatus(number, "send", options, callback);
};

ripe.Ripe.prototype.sendOrderP = function (number, trackingNumber, trackingUrl, options) {
  var _this21 = this;

  return new Promise(function (resolve, reject) {
    _this21.sendOrder(number, trackingNumber, trackingUrl, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Sets the order status to 'receive'.
 *
 * @param {Number} number The number of the order to update.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.receiveOrder = function (number, options, callback) {
  return this.setOrderStatus(number, "receive", options, callback);
};

ripe.Ripe.prototype.receiveOrderP = function (number, options) {
  var _this22 = this;

  return new Promise(function (resolve, reject) {
    _this22.receiveOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Sets the order status to 'return'.
 *
 * @param {Number} number The number of the order to update.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.returnOrder = function (number, options, callback) {
  return this.setOrderStatus(number, "return", options, callback);
};

ripe.Ripe.prototype.returnOrderP = function (number, options) {
  var _this23 = this;

  return new Promise(function (resolve, reject) {
    _this23.returnOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Sets the order status to 'cancel'.
 *
 * @param {Number} number The number of the order to update.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.cancelOrder = function (number, options, callback) {
  return this.setOrderStatus(number, "cancel", options, callback);
};

ripe.Ripe.prototype.cancelOrderP = function (number, options) {
  var _this24 = this;

  return new Promise(function (resolve, reject) {
    _this24.cancelOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Imports a production order to RIPE Core.
 *
 * @param {Number} ffOrderId The e-commerce order identifier.
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'variant' - The variant of the model.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'initialsExtra' - The value for the initials extra of the personalized model.
 *  - 'gender' - The gender of the customized model.
 *  - 'size' - The native size of the customized model.
 *  - 'pending' - If the production order is to be imported at the pending, so it has to be confirmed.
 *  - 'notify' - Mark order to trigger notification after creation.
 *  - 'productId' - The product's unique identification.
 *  - 'currency' - The 'ISO 4217' currency code in which the order has been sold.
 *  - 'country' - The 'ISO 3166-2' country code where the order has been placed.
 *  - 'meta' - Complementary information to be added, as a key:value list (ie: '['key1:value1', 'key2:value2']).
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.importOrder = function (ffOrderId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._importOrder(ffOrderId, options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Imports a production order to RIPE Core.
 *
 * @param {Number} ffOrderId The e-commerce order identifier.
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'variant' - The variant of the model.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'initialsExtra' - The value for the initials extra of the personalized model.
 *  - 'gender' - The gender of the customized model.
 *  - 'size' - The native size of the customized model.
 *  - 'pending' - If the production order is to be imported at the pending, so it has to be confirmed.
 *  - 'notify' - Mark order to trigger notification after creation.
 *  - 'productId' - The product's unique identification.
 *  - 'currency' - The 'ISO 4217' currency code in which the order has been sold.
 *  - 'country' - The 'ISO 3166-2' country code where the order has been placed.
 *  - 'meta' - Complementary information to be added, as a key:value list (ie: '['key1:value1', 'key2:value2']).
 * @returns {Promise} The production order's data.
 */


ripe.Ripe.prototype.importOrderP = function (ffOrderId, options, callback) {
  var _this25 = this;

  return new Promise(function (resolve, reject) {
    _this25.importOrder(ffOrderId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Setups a pre-customization on RIPE Core.
 *
 * @param {Number} ffId The concrete identifier of the pre-customization,
 * may represent just an entry point for a pre-customized product (used for mapping).
 * @param {Object} options An object with options, such as:
 *  - 'brand' - the brand of the model.
 *  - 'model' - the name of the model.
 *  - 'variant' - the variant of the model.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'gender' - The gender of the customized model.
 *  - 'size' - The native size of the customized model.
 *  - 'product_id' - The product identifier of the base product that is used for pre-customization mapping.
 *  - 'notify' - Mark pre-customization to trigger notification after creation.
 *  - 'meta' - Complementary information to be added, as a key:value list (ie: '['key1:value1', 'key2:value2']).
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.precustomizationOrder = function (ffId, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  options = this._precustomizationOrder(ffId, options);
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Setups a pre-customization on RIPE Core.
 *
 * @param {Number} ffId The concrete identifier of the pre-customization,
 * may represent just an entry point for a pre-customized product (used for mapping).
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'variant' - The variant of the model.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'gender' - The gender of the customized model.
 *  - 'size' - The native size of the customized model.
 *  - 'productId' - The product identifier of the base product that is used for pre-customization mapping.
 *  - 'notify' - Mark pre-customization to trigger notification after creation.
 *  - 'meta' - Complementary information to be added, as a key:value list (ie: '['key1:value1', 'key2:value2']).
 * @returns {Promise} The production order's data.
 */


ripe.Ripe.prototype.precustomizationOrderP = function (ffId, options, callback) {
  var _this26 = this;

  return new Promise(function (resolve, reject) {
    _this26.precustomizationOrder(ffId, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype.setOrderStatus = function (number, status, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/").concat(status);
  options = Object.assign(options, {
    url: url,
    auth: true,
    method: "PUT"
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the order subscription status for the session user.
 *
 * @param {Number} number The number of the order to get the subscription status.
 * @returns {XMLHttpRequest} The order subscription status.
 */


ripe.Ripe.prototype.getOrderSubscription = function (number, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/subscription");
  options = Object.assign(options, {
    url: url,
    auth: true,
    cached: false,
    method: "GET"
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the order subscription status for the session user.
 *
 * @param {Number} number The number of the order to get the subscription status.
 * @returns {Promise} The order subscription status.
 */


ripe.Ripe.prototype.getOrderSubscriptionP = function (number, options) {
  var _this27 = this;

  return new Promise(function (resolve, reject) {
    _this27.getOrderSubscription(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Adds the email of the user in session to subscriber list of an order.
 *
 * @param {Number} number The number of the order to subscribe.
 * @returns {XMLHttpRequest} The order subscription status.
 */


ripe.Ripe.prototype.subscribeOrder = function (number, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/subscription");
  options = Object.assign(options, {
    url: url,
    auth: true,
    method: "PUT"
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Adds the email of the user in session to subscriber list of an order.
 *
 * @param {Number} number The number of the order to subscribe.
 * @returns {Promise} The order subscription status.
 */


ripe.Ripe.prototype.subscribeOrderP = function (number, options) {
  var _this28 = this;

  return new Promise(function (resolve, reject) {
    _this28.subscribeOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Removes email of the user in session from the subscriber list of an order.
 *
 * @param {Number} number The number of the order to unsubscribe.
 * @returns {XMLHttpRequest} The order subscription status.
 */


ripe.Ripe.prototype.unsubscribeOrder = function (number, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/subscription");
  options = Object.assign(options, {
    url: url,
    auth: true,
    method: "DELETE"
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Removes email of the user in session from the subscriber list of an order.
 *
 * @param {Number} number The number of the order to unsubscribe.
 * @returns {Promise} The order subscription status.
 */


ripe.Ripe.prototype.unsubscribeOrderP = function (number, options) {
  var _this29 = this;

  return new Promise(function (resolve, reject) {
    _this29.unsubscribeOrder(number, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getOrderReportURL = function (number, key, options) {
  options = options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/report");
  options = Object.assign(options, {
    url: url,
    params: {
      key: key
    }
  });
  return options.url + "?" + this._buildQuery(options.params);
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getOrderReportPDFURL = function (number, key, options) {
  options = options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/report.pdf");
  options = Object.assign(options, {
    url: url,
    params: {
      key: key
    }
  });
  return options.url + "?" + this._buildQuery(options.params);
};
/**
 * @ignore
 */


ripe.Ripe.prototype._getOrderReportPNGURL = function (number, key, options) {
  options = options === undefined ? {} : options;
  var url = "".concat(this.url, "orders/").concat(number, "/report.png");
  options = Object.assign(options, {
    url: url,
    params: {
      key: key
    }
  });
  return options.url + "?" + this._buildQuery(options.params);
};
/**
 * @ignore
 * @see {link https://docs.platforme.com/#order-endpoints-import}
 */


ripe.Ripe.prototype._importOrder = function (ffOrderId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var type = options.type === undefined ? null : options.type;
  var brand = options.brand === undefined ? this.brand : options.brand;
  var factory = options.factory === undefined ? null : options.factory;
  var model = options.model === undefined ? this.model : options.model;
  var variant = options.variant === undefined ? this.variant : options.variant;
  var parts = options.parts === undefined ? this.parts : options.parts;
  var initials = options.initials === undefined ? this.initials : options.initials;
  var engraving = options.engraving === undefined ? this.engraving : options.engraving;
  var initialsExtra = options.initials_extra === undefined && options.initialsExtra === undefined ? this.initialsExtra : options.initialsExtra || options.initials_extra;
  var gender = options.gender === undefined ? null : options.gender;
  var size = options.size === undefined ? null : options.size;
  var pending = options.pending === undefined ? null : options.pending;
  var notify = options.notify === undefined ? null : options.notify;
  var productId = options.product_id === undefined && options.productId === undefined ? null : options.product_id || options.productId;
  var country = options.country === undefined ? null : options.country;
  var price = options.price === undefined ? null : options.price;
  var currency = options.currency === undefined ? null : options.currency;
  var deliveryTime = options.deliveryTime === undefined ? null : options.deliveryTime;
  var meta = options.meta === undefined ? null : options.meta;
  var description = options.description === undefined ? null : options.description;
  var notes = options.notes === undefined ? null : options.notes;
  var images = options.images === undefined ? null : options.images;
  var url = "".concat(this.url, "orders/import");
  var contents = {
    brand: brand,
    model: model,
    parts: parts,
    size: size
  };
  if (factory) contents.factory = factory;
  if (variant) contents.variant = variant;
  if (productId) contents.product_id = productId;
  if (gender) contents.gender = gender;

  if (Object.keys(initialsExtra).length > 0) {
    contents.initials_extra = initialsExtra;
  } else if (initials && engraving) {
    contents.initials = initials;
    contents.engraving = engraving;
  }

  if (deliveryTime) contents.delivery_time = deliveryTime;
  if (images) contents.images = images;
  if (description) contents.description = description;
  var params = {
    ff_order_id: ffOrderId,
    contents: JSON.stringify(contents)
  };
  if (type) params.type = type;
  if (country) params.country = country;
  if (price) params.price = price;
  if (currency) params.currency = currency;
  if (meta) params.meta = meta;
  if (meta) params.meta = meta;
  if (notes) params.notes = notes;
  if (notify) params.notify = notify;
  if (pending) params.pending = pending;
  return Object.assign(options, {
    url: url,
    method: "POST",
    params: params,
    auth: true
  });
};
/**
 * @ignore
 */


ripe.Ripe.prototype._precustomizationOrder = function (ffId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var brand = options.brand === undefined ? this.brand : options.brand;
  var model = options.model === undefined ? this.model : options.model;
  var variant = options.variant === undefined ? this.variant : options.variant;
  var parts = options.parts === undefined ? this.parts : options.parts;
  var initials = options.initials === undefined ? this.initials : options.initials;
  var engraving = options.engraving === undefined ? this.engraving : options.engraving;
  var initialsExtra = options.initials_extra === undefined && options.initialsExtra === undefined ? this.initialsExtra : options.initialsExtra || options.initials_extra;
  var gender = options.gender === undefined ? null : options.gender;
  var size = options.size === undefined ? null : options.size;
  var productId = options.product_id === undefined && options.productId === undefined ? null : options.product_id || options.productId;
  var meta = options.meta === undefined ? null : options.meta;
  var url = "".concat(this.url, "orders/pre_customization");
  var contents = {
    brand: brand,
    model: model,
    parts: parts,
    size: size,
    product_id: productId
  };
  if (variant) contents.variant = variant;
  if (gender) contents.gender = gender;

  if (Object.keys(initialsExtra).length > 0) {
    contents.initials_extra = initialsExtra;
  } else if (initials && engraving) {
    contents.initials = initials;
    contents.engraving = engraving;
  }

  var params = {
    ff_id: ffId,
    contents: JSON.stringify(contents)
  };
  if (meta) params.meta = meta;
  return Object.assign(options, {
    url: url,
    method: "POST",
    params: params,
    auth: true
  });
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Gets the existing price rules, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getPriceRules = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "price_rules");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the existing price rules, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The price rules list.
 */


ripe.Ripe.prototype.getPriceRulesP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getPriceRules(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Creates a price rule on RIPE Core.
 *
 * @param {Object} priceRule An object with information needed to create a price rule.
 * @param {Object} options An object with options.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.createPriceRule = function (priceRule, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "price_rules");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    auth: true,
    dataJ: priceRule
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Creates a price rule on RIPE Core.
 *
 * @param {Object} priceRule An object with information needed to create a price rule.
 * @param {Object} options An object with options.
 * @returns {Promise} The price rule's data.
 */


ripe.Ripe.prototype.createPriceRuleP = function (priceRule, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.createPriceRule(priceRule, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Gets an existing price rule filtered by ID and according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Number} id The price rule's ID.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getPriceRule = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "price_rules/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets an existing price rule filtered by ID and according to the
 * provided filtering strategy as normalized values.
 *
 * @param {Number} id The price rule's ID.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The price rule requested by ID.
 */


ripe.Ripe.prototype.getPriceRuleP = function (id, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.getPriceRule(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Updates a price rule on RIPE Core.
 *
 * @param {Object} priceRule An object with information needed to update a price rule.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.updatePriceRule = function (priceRule, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "price_rules/").concat(priceRule.id);
  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true,
    dataJ: priceRule
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Updates a price rule on RIPE Core.
 *
 * @param {Object} priceRule An object with information needed to update a price rule.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The price rule's data.
 */


ripe.Ripe.prototype.updatePriceRuleP = function (priceRule, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.updatePriceRule(priceRule, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Deletes an existing price rule.
 *
 * @param {Number} id The price rule's ID.
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.deletePriceRule = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "price_rules/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "DELETE",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Deletes an existing price rule.
 *
 * @param {Number} id The price rule's ID.
 * @param {Object} options An object of options to configure the request
 * @returns {Promise} The result of the price rule's deletion.
 */


ripe.Ripe.prototype.deletePriceRuleP = function (id, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.deletePriceRule(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Retrieve the list of profiles according to the provided options.
 *
 * @param {Object} options An object of options to configure the request
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getProfiles = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "profiles");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieve the list of profiles according to the provided options.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The sequence of profiles for the options.
 */


ripe.Ripe.prototype.getProfilesP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getProfiles(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Retrieves a profile using the name of it as filter reference.
 *
 * @param {String} name The name of the profile to be retrieved.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getProfile = function (name, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "profiles/").concat(name);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Retrieves a profile using the name of it as filter reference.
 *
 * @param {String} name The name of the profile to be retrieved.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The profile requested by name.
 */


ripe.Ripe.prototype.getProfileP = function (name, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.getProfile(name, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Provides a list of all the available size scales.
 * To be used to know what scales are available for size conversions.
 *
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getSizes = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "sizes");
  options = Object.assign(options, {
    url: url,
    method: "GET"
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.getSizesP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getSizes(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Converts a size value from the native scale to the corresponding value
 * in the specified scale.
 * The available scales, genders and sizes can be obtained with the getSizes.
 *
 * @param {String} scale The scale which one wants to convert to.
 * @param {Number} value The value which one wants to convert.
 * @param {String} gender The gender of the scale and value to be converted.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.sizeToNative = function (scale, value, gender, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "sizes/size_to_native");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      scale: scale,
      value: value,
      gender: gender
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.sizeToNativeP = function (scale, value, gender, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.sizeToNative(scale, value, gender, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Converts multiple size values from the native scale to the corresponding
 * values in the specified scales.
 * The available scales, genders and sizes can be obtained with the method getSizes.
 *
 * @param {Array} scales A list of scales to convert to.
 * @param {Array} values A list of values to convert.
 * @param {Array} genders A list of genders corresponding to the values.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.sizeToNativeB = function (scales, values, genders, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var scalesP = [];
  var valuesP = [];
  var gendersP = [];

  for (var index = 0; index < scales.length; index++) {
    scalesP.push(scales[index]);
    valuesP.push(values[index]);
    gendersP.push(genders[index]);
  }

  var url = "".concat(this.url, "sizes/size_to_native_b");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      scales: scalesP,
      values: valuesP,
      genders: gendersP
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.sizeToNativeBP = function (scales, values, genders, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.sizeToNativeB(scales, values, genders, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Converts a size value in the specified scale to the corresponding native size.
 * The available scales, genders and sizes can be obtained with the method getSizes.
 *
 * @param {String} scale The scale which one wants to convert from.
 * @param {Number} value The value which one wants to convert.
 * @param {String} gender The gender of the scale and value to be converted.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.nativeToSize = function (scale, value, gender, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "sizes/native_to_size");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      scale: scale,
      value: value,
      gender: gender
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.nativeToSizeP = function (scale, value, gender, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.nativeToSize(scale, value, gender, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Converts multiple size values to the corresponding native size.
 * The available scales, genders and sizes can be obtained with the method getSizes.
 *
 * @param {Array} scales A list of scales to convert from.
 * @param {Array} values A list of values to convert.
 * @param {Array} genders A list of genders corresponding to the values.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.nativeToSizeB = function (scales, values, genders, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var scalesP = [];
  var valuesP = [];
  var gendersP = [];

  for (var index = 0; index < scales.length; index++) {
    scalesP.push(scales[index]);
    valuesP.push(values[index]);
    gendersP.push(genders[index]);
  }

  var url = "".concat(this.url, "sizes/native_to_size_b");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      scales: scalesP,
      values: valuesP,
      genders: gendersP
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.nativeToSizeBP = function (scales, values, genders, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.nativeToSizeB(scales, values, genders, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Converts a size value in the specified scale to the corresponding localized size.
 * The available scales, genders and sizes can be obtained with the method getSizes.
 *
 * @param {String} scale The scale which one wants to convert from.
 * @param {Number} value The value which one wants to convert.
 * @param {String} gender The gender of the scale and value to be converted.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.sizeToLocale = function (scale, value, gender, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "sizes/size_to_locale");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      scale: scale,
      value: value,
      gender: gender
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.sizeToLocaleP = function (scale, value, gender, options) {
  var _this6 = this;

  return new Promise(function (resolve, reject) {
    _this6.sizeToLocale(scale, value, gender, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Converts multiple size values to the corresponding localized size.
 * The available scales, genders and sizes can be obtained with the method getSizes.
 *
 * @param {Array} scales A list of scales to convert from.
 * @param {Array} values A list of values to convert.
 * @param {Array} genders A list of genders corresponding to the values.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.sizeToLocaleB = function (scales, values, genders, options, callback) {
  scales = typeof scales === "string" ? [scales] : scales;
  values = typeof values === "string" ? [values] : values;
  genders = typeof genders === "string" ? [genders] : genders;
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "sizes/size_to_locale_b");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      scales: scales,
      values: values,
      genders: genders
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.sizeToLocaleBP = function (scales, values, genders, options) {
  var _this7 = this;

  return new Promise(function (resolve, reject) {
    _this7.sizeToLocaleB(scales, values, genders, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Converts a native size value in the specified scale to the corresponding localized size.
 * The available scales, genders and sizes can be obtained with the method getSizes.
 *
 * @param {String} scale The scale which one wants to convert from.
 * @param {Number} value The value which one wants to convert.
 * @param {String} gender The gender of the scale and value to be converted.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.nativeToLocale = function (scale, value, gender, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "sizes/native_to_locale");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      scale: scale,
      value: value,
      gender: gender
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.nativeToLocaleP = function (scale, value, gender, options) {
  var _this8 = this;

  return new Promise(function (resolve, reject) {
    _this8.nativeToLocale(scale, value, gender, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Converts multiple native size values to the corresponding localized size.
 * The available scales, genders and sizes can be obtained with the method getSizes.
 *
 * @param {Array} scales A list of scales to convert from.
 * @param {Array} values A list of values to convert.
 * @param {Array} genders A list of genders corresponding to the values.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.nativeToLocaleB = function (scales, values, genders, options, callback) {
  scales = typeof scales === "string" ? [scales] : scales;
  values = typeof values === "string" ? [values] : values;
  genders = typeof genders === "string" ? [genders] : genders;
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "sizes/native_to_locale_b");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    params: {
      scales: scales,
      values: values,
      genders: genders
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};

ripe.Ripe.prototype.nativeToLocaleBP = function (scales, values, genders, options) {
  var _this9 = this;

  return new Promise(function (resolve, reject) {
    _this9.nativeToLocaleB(scales, values, genders, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * Gets the existing SKUs, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request, such as:
 * - 'filters[]' - List of filters that the query will use to, operators such as
 * ('in', 'not_in', 'like', 'contains'), for instance (eg: 'id:eq:42') would filter by the id that equals to 42.
 * - 'sort' - List of arguments to sort the results by and which direction
 * to sort them in (eg: 'id:ascending') would sort by the id attribute in ascending order,
 * while (eg: 'id:descending')] would do it in descending order.
 * - 'skip' - The number of the first record to retrieve from the results.
 * - 'limit' - The number of results to retrieve.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getSkus = function (options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "skus");
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets the existing SKUs, according to the provided filtering
 * strategy as normalized values.
 *
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The SKUs result list.
 */


ripe.Ripe.prototype.getSkusP = function (options) {
  var _this = this;

  return new Promise(function (resolve, reject) {
    _this.getSkus(options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Creates a SKU on RIPE Core under the defined domain.
 *
 * @param {String} identifier The SKU identifier as a plain string.
 * @param {Object} domain The SKU's domain, within the SKU is going to be defined.
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'variant' - The variant of the model.
 *  - 'version' - The version of the build.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'initialsExtra' - The value for the initials extra of the personalized model.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} Resulting information for the callback execution.
 */


ripe.Ripe.prototype.createSku = function (identifier, domain, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "skus");
  options = Object.assign(options, {
    url: url,
    method: "POST",
    auth: true,
    dataJ: {
      identifier: identifier,
      domain: domain,
      spec: Object.assign({}, options)
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Creates a SKU on RIPE Core under the defined domain.
 *
 * @param {String} identifier The SKU identifier as a plain string.
 * @param {Object} domain The SKU's domain, within the SKU is going to be defined.
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'variant' - The variant of the model.
 *  - 'version' - The version of the build.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'initialsExtra' - The value for the initials extra of the personalized model.
 * @returns {Promise} The SKU's data.
 */


ripe.Ripe.prototype.createSkuP = function (identifier, domain, options) {
  var _this2 = this;

  return new Promise(function (resolve, reject) {
    _this2.createSku(identifier, domain, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Gets a SKU by its ID (not by its identifier).
 *
 * @param {Object} id ID of the intended SKU (not the identifier).
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.getSku = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "skus/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "GET",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Gets a SKU by its ID (not by its identifier).
 *
 * @param {Object} id ID of the intended SKU (not the identifier).
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The SKU request by ID.
 */


ripe.Ripe.prototype.getSkuP = function (id, options) {
  var _this3 = this;

  return new Promise(function (resolve, reject) {
    _this3.getSku(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Updates an existing SKU, according to the provided options.
 *
 * @param {Object} id ID of the SKU to be updated.
 * @param {String} identifier The SKU identifier as a plain string.
 * @param {Object} domain The SKU's domain, within the SKU is going to be defined.
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'variant' - The variant of the model.
 *  - 'version' - The version of the build.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'initialsExtra' - The value for the initials extra of the personalized model.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.updateSku = function (id, identifier, domain, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "skus/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "PUT",
    auth: true,
    dataJ: {
      identifier: identifier,
      domain: domain,
      spec: Object.assign({}, options)
    }
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Updates an existing SKU, according to the provided options.
 *
 * @param {Object} id ID of the SKU to be updated.
 * @param {String} identifier The SKU identifier as a plain string.
 * @param {Object} domain The SKU's domain, within the SKU is going to be defined.
 * @param {Object} options An object with options, such as:
 *  - 'brand' - The brand of the model.
 *  - 'model' - The name of the model.
 *  - 'variant' - The variant of the model.
 *  - 'version' - The version of the build.
 *  - 'parts' - The parts of the customized model.
 *  - 'initials' - The value for the initials of the personalized model.
 *  - 'engraving' - The value for the engraving value of the personalized model.
 *  - 'initialsExtra' - The value for the initials extra of the personalized model.
 * @returns {Promise} The SKU's data.
 */


ripe.Ripe.prototype.updateSkuP = function (id, identifier, domain, options) {
  var _this4 = this;

  return new Promise(function (resolve, reject) {
    _this4.updateSku(id, identifier, domain, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Deletes an existing SKU entity.
 *
 * @param {Object} id ID of the SKU to be deleted.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.deleteSku = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "skus/").concat(id);
  options = Object.assign(options, {
    url: url,
    method: "DELETE",
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Deletes an existing SKU entity.
 *
 * @param {Object} id ID of the SKU to be deleted.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The result of the SKU's deletion.
 */


ripe.Ripe.prototype.deleteSkuP = function (id, options) {
  var _this5 = this;

  return new Promise(function (resolve, reject) {
    _this5.deleteSku(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};
/**
 * Validates a given SKU according to spec and model rules.
 *
 * @param {Object} id ID of the SKU to be validated.
 * @param {Object} options An object of options to configure the request.
 * @param {Function} callback Function with the result of the request.
 * @returns {XMLHttpRequest} The XMLHttpRequest instance of the API request.
 */


ripe.Ripe.prototype.validateSku = function (id, options, callback) {
  callback = typeof options === "function" ? options : callback;
  options = typeof options === "function" || options === undefined ? {} : options;
  var url = "".concat(this.url, "skus/").concat(id, "/validate");
  options = Object.assign(options, {
    url: url,
    auth: true
  });
  options = this._build(options);
  return this._cacheURL(options.url, options, callback);
};
/**
 * Validates a given SKU according to spec and model rules.
 *
 * @param {Object} id ID of the SKU to be validated.
 * @param {Object} options An object of options to configure the request.
 * @returns {Promise} The result of the SKU's validation.
 */


ripe.Ripe.prototype.validateSkuP = function (id, options) {
  var _this6 = this;

  return new Promise(function (resolve, reject) {
    _this6.validateSku(id, options, function (result, isValid, request) {
      isValid ? resolve(result) : reject(new ripe.RemoteError(request, null, result));
    });
  });
};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var base = __webpack_require__(34);

var diag = __webpack_require__(290);

var restrictions = __webpack_require__(291);

var sync = __webpack_require__(292);

Object.assign(module.exports, base);
Object.assign(module.exports, diag);
Object.assign(module.exports, restrictions);
Object.assign(module.exports, sync);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(34); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @class
 * @augments Plugin
 * @classdesc Plugin responsible for adding an 'X-Ripe-Sdk-Version' Header
 * for all RIPE SDK requests for diagnostics purposes rules.
 *
 * @param {Object} options An object with options to configure the plugin.
 */


ripe.Ripe.plugins.DiagPlugin = function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  ripe.Ripe.plugins.Plugin.call(this);
  this.options = options;
  this.preRequestCallback = this._setHeaders.bind(this);
};

ripe.Ripe.plugins.DiagPlugin.prototype = ripe.build(ripe.Ripe.plugins.Plugin.prototype);
ripe.Ripe.plugins.DiagPlugin.prototype.constructor = ripe.Ripe.plugins.DiagPlugin;
/**
 * The Diag Plugin binds the 'build_request' event in order to add
 * the 'X-Ripe-Sdk-Version' header.
 * @param {Ripe} The Ripe instance in use.
 */

ripe.Ripe.plugins.DiagPlugin.prototype.register = function (owner) {
  ripe.Ripe.plugins.Plugin.prototype.register.call(this, owner);
  this.owner.bind("build_request", this.preRequestCallback);
};
/**
 * The unregister to be called (by the owner)
 * the plugins unbinds events and executes
 * any necessary cleanup operation.
 *
 * @param {Ripe} The Ripe instance in use.
 */


ripe.Ripe.plugins.DiagPlugin.prototype.unregister = function (owner) {
  this.options = null;
  this.owner.unbind("build_request", this.preRequestCallback);
  ripe.Ripe.plugins.Plugin.prototype.unregister.call(this, owner);
};
/**
 * @ignore
 */


ripe.Ripe.plugins.DiagPlugin.prototype._setHeaders = function (request) {
  // sets the initial version header that correctly identifies
  // the version of the SDK in use
  request.setRequestHeader("X-Ripe-Sdk-Version", ripe.VERSION); // creates the array that is going to hold the complete set of
  // plugins registered in the owner

  var plugins = []; // iterates over the complete set of plugins registered in the
  // owner to add their names to the plugins list

  for (var index = 0; index < this.owner.plugins.length; index++) {
    var plugin = this.owner.plugins[index];

    var pluginName = this._getPluginName(plugin);

    pluginName && plugins.push(pluginName);
  } // creates the list of plugins (as a string) to be sent to the
  // server side (single element only)


  var pluginsS = plugins.join(", ");
  pluginsS && request.setRequestHeader("X-Ripe-Sdk-Plugins", pluginsS); // in case the brand value is defined in the owner it is also added
  // to the list of headers in the request

  this.owner.brand && request.setRequestHeader("X-Ripe-Sdk-Vendor", this.owner.brand);
};
/**
 * @ignore
 */


ripe.Ripe.plugins.DiagPlugin.prototype._getPluginName = function (plugin) {
  for (var key in ripe.Ripe.plugins) {
    if (plugin.constructor === ripe.Ripe.plugins[key]) {
      return key;
    }
  }

  return null;
};

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(34); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @class
 * @augments Plugin
 * @classdesc Plugin responsible for applying restrictions rules.
 *
 * @param {Object} rules A Map with restrictions rules to be applied.
 * If defined, overrides the rules defined on the model's config.
 * @param {Object} options An object with options to configure the plugin.
 */


ripe.Ripe.plugins.RestrictionsPlugin = function (restrictions) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  ripe.Ripe.plugins.Plugin.call(this);
  this.token = options.token || ":";
  this.restrictions = restrictions;
  this.restrictionsMap = this._buildRestrictionsMap(restrictions);
  this.manual = Boolean(options.manual || restrictions);
  this.auto = !this.manual;
  this.token = options.token || ":";
};

ripe.Ripe.plugins.RestrictionsPlugin.prototype = ripe.build(ripe.Ripe.plugins.Plugin.prototype);
ripe.Ripe.plugins.RestrictionsPlugin.prototype.constructor = ripe.Ripe.plugins.RestrictionsPlugin;
/**
 * The Restrictions Plugin binds the 'post_config' and 'part' events,
 * in order to:
 * - retrieve the model's configuration.
 * - change the necessary parts making them comply with the restrictions rules.
 *
 * @param {Ripe} The Ripe instance in use.
 */

ripe.Ripe.plugins.RestrictionsPlugin.prototype.register = function (owner) {
  var _this = this;

  ripe.Ripe.plugins.Plugin.prototype.register.call(this, owner); // runs the initial configuration, should take into account if
  // a valid configuration is currently loaded

  this._config(); // registers for the config option so that it's possible to change
  // its value according to the newly generated configuration


  this._postConfigBind = this.manual ? null : this.owner.bind("post_config", function () {
    return _this._config();
  }); // binds to the pre parts event so that the parts can be
  // changed so that they comply with the product's restrictions

  this._partBind = this.owner.bind("part", this._applyRestrictions.bind(this));
};
/**
 * The unregister to be called (by the owner)
 * the plugins unbinds events and executes
 * any necessary cleanup operation.
 *
 * @param {Ripe} The Ripe instance in use.
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype.unregister = function (owner) {
  this.partsOptions = null;
  this.options = null;
  this.owner && this.owner.unbind("part", this._partBind);
  this.owner && this.owner.unbind("post_config", this._postConfigBind);
  ripe.Ripe.plugins.Plugin.prototype.unregister.call(this, owner);
};
/**
 * @ignore
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype._config = function () {
  this.restrictions = this.auto && this.owner.loadedConfig ? this.owner.loadedConfig.restrictions : this.restrictions;
  this.restrictionsMap = this._buildRestrictionsMap(this.restrictions);
  this.partsOptions = this.owner.loadedConfig ? this.owner.loadedConfig.parts : {};
  var defaults = this.owner.loadedConfig ? this.owner.loadedConfig.defaults : {};
  var optionals = [];

  for (var name in defaults) {
    var part = defaults[name];
    part.optional && optionals.push(name);
  }

  this.optionals = optionals;
};
/**
 * @ignore
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype._applyRestrictions = function (name, value) {
  // if there are no restrictions defined (map length is zeo)
  // then returns the control flow immediately (nothing to be done)
  if (Object.keys(this.restrictionsMap).length === 0) return; // creates an array with the customization, by copying the
  // current parts environment into a separate array, this is
  // a clone of the original customization to be used latter on

  var customization = [];
  var partsOptions = ripe.clone(this.partsOptions);

  for (var partName in this.owner.parts) {
    if (name !== undefined && name === partName) {
      continue;
    }

    var part = this.owner.parts[partName];
    customization.push({
      name: partName,
      material: part.material,
      color: part.color
    });
  } // if a new part is set it is added at the end so that it
  // has higher priority when solving the restrictions


  var partSet = name !== undefined ? {
    name: name,
    material: value.material,
    color: value.color
  } : null;
  name !== undefined && customization.push(partSet); // obtains the new parts and mutates the original
  // parts map to apply the necessary changes

  var newParts = this._solveRestrictions(partsOptions, this.restrictionsMap, customization);

  var changes = this._applyChanges(newParts); // triggers the restrictions event with the set of changes in the
  // domain and the possible part set that triggered those changes


  this.trigger("restrictions", changes, partSet);
};
/**
 * @ignore
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype._solveRestrictions = function (availableParts, restrictions, customization, solution) {
  // if all the parts are set then a solution has been found
  // and it is returned
  solution = solution || [];

  if (customization.length === 0 && this._isComplete(solution)) {
    return solution;
  } // retrieves a part from the customization and checks if it is
  // being restricted by any of the validated parts, if there is
  // no restriction then adds the part to the solution array and
  // proceeds to the next part


  var newPart = customization.pop();

  if (this._isRestricted(newPart, restrictions, solution) === false) {
    solution.push(newPart);
    return this._solveRestrictions(availableParts, restrictions, customization, solution);
  } // if the part is restricted then tries to retrieve an alternative option,
  // if an alternative is found then adds it to the customization and proceeds
  // with it, otherwise an invalid state was reached and an empty solution
  // is returned, meaning that there is no option for the current customization
  // that would comply with the restrictions


  var newPartOption = this._alternativeFor(newPart, availableParts, true);

  if (newPartOption === null) {
    return [];
  }

  customization.push(newPartOption);
  return this._solveRestrictions(availableParts, restrictions, customization, solution);
};
/**
 * @ignore
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype._applyChanges = function (newParts) {
  var oldParts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (oldParts === null) oldParts = this.owner.parts;
  var changes = [];

  for (var index = 0; index < newParts.length; index++) {
    var newPart = newParts[index];
    var oldPart = oldParts[newPart.name] || {};
    var oldMaterial = oldPart.material || null;
    var oldColor = oldPart.color || null;
    var newMaterial = newPart.material || null;
    var newColor = newPart.color || null; // verifies if a valid change has been made for the current
    // part in iteration if not continues the loop

    if (oldMaterial === newMaterial && oldColor === newColor) {
      continue;
    } // adds a new change description object to the sequence of
    // changes coming from the restrictions


    changes.push({
      from: {
        part: newPart.name,
        material: oldMaterial,
        color: oldColor
      },
      to: {
        part: newPart.name,
        material: newMaterial,
        color: newColor
      }
    });
    var remove = Boolean(newMaterial && newColor) === false;

    if (remove) {
      delete oldParts[newPart.name];
    } else {
      oldPart.material = newMaterial;
      oldPart.color = newColor;
    }
  } // returns the complete set of changes that were
  // computed by comparing the old and the new parts


  return changes;
};
/**
 * @ignore
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype._getRestrictionKey = function (part, material, color, token) {
  token = token || this.token;
  part = part || "";
  material = material || "";
  color = color || "";
  return part + token + material + token + color;
};
/**
 * Maps the restrictions array into a dictionary where restrictions
 * are associated by key with each other for easier use.
 * For example, '[[{ material: "nappa"}, { material: "suede"}]]'
 * turns into '{ "nappa": ["suede"], "suede": ["nappa"] }'.
 *
 * @param {Array} restrictions The array of restrictions defined by an
 * object of incompatible materials/colors.
 * @returns {Object} A map that associates the restricted keys with the
 * array of associated restrictions.
 *
 * @ignore
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype._buildRestrictionsMap = function (restrictions) {
  var restrictionsMap = {}; // in case the restrictions value to be applied is not valid returns
  // the (currently) unset restrictions map immediately

  if (!restrictions) return restrictionsMap; // iterates over the complete set of restrictions in the restrictions
  // list to process them and populate the restrictions map with a single
  // key to "restricted keys" association

  for (var index = 0; index < restrictions.length; index++) {
    // in case the restriction is considered to be a single one
    // then this is a special (all cases excluded one) and must
    // be treated as such (true value set in the map value)
    var restriction = restrictions[index];

    if (restriction.length === 1) {
      var _restriction = restriction[0];

      var key = this._getRestrictionKey(_restriction.part, _restriction.material, _restriction.color);

      restrictionsMap[key] = true;
      continue;
    } // iterates over all the items in the restriction to correctly
    // populate the restrictions map with the restrictive values


    for (var _index = 0; _index < restriction.length; _index++) {
      var item = restriction[_index];
      var material = item.material;
      var color = item.color;

      var materialColorKey = this._getRestrictionKey(null, material, color);

      for (var __index = 0; __index < restriction.length; __index++) {
        var _item = restriction[__index];
        var _material = _item.material;
        var _color = _item.color;

        var _key = this._getRestrictionKey(null, _material, _color);

        if (__index === _index) {
          continue;
        }

        var sequence = restrictionsMap[materialColorKey] || [];
        sequence.push(_key);
        restrictionsMap[materialColorKey] = sequence;
      }
    }
  }

  return restrictionsMap;
};
/**
 * @ignore
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype._isRestricted = function (newPart, restrictions, parts) {
  var name = newPart.name;
  var material = newPart.material;
  var color = newPart.color;

  var partKey = this._getRestrictionKey(name);

  var materialKey = this._getRestrictionKey(null, material, null);

  var colorKey = this._getRestrictionKey(null, null, color);

  var materialColorKey = this._getRestrictionKey(null, material, color);

  var materialRestrictions = restrictions[materialKey];
  var colorRestrictions = restrictions[colorKey];
  var keyRestrictions = restrictions[materialColorKey] || [];
  var restricted = restrictions[partKey] !== undefined;
  restricted |= materialRestrictions === true;
  restricted |= colorRestrictions === true;
  restricted |= keyRestrictions === true;

  if (restricted) {
    return true;
  }

  keyRestrictions = materialRestrictions instanceof Array ? keyRestrictions.concat(materialRestrictions) : keyRestrictions;
  keyRestrictions = colorRestrictions instanceof Array ? keyRestrictions.concat(colorRestrictions) : keyRestrictions;

  for (var index = 0; index < keyRestrictions.length; index++) {
    var restriction = keyRestrictions[index];

    for (var _index = 0; _index < parts.length; _index++) {
      var part = parts[_index];

      if (part.name === name) {
        continue;
      }

      var restrictionKeys = [this._getRestrictionKey(null, part.material), this._getRestrictionKey(null, null, part.color), this._getRestrictionKey(null, part.material, part.color)];

      if (restrictionKeys.indexOf(restriction) !== -1) {
        return true;
      }
    }
  }

  return false;
};
/**
 * @ignore
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype._isComplete = function (parts) {
  // iterates through the parts array and creates
  // an array with the names of the parts for
  // easier searching
  var part = null;
  var partsS = [];

  for (var index = 0; index < parts.length; index++) {
    part = parts[index];
    partsS.push(part.name);
  } // iterates through the part options and checks
  // if all non optional parts are set


  for (var _index2 = 0; _index2 < this.partsOptions.length; _index2++) {
    part = this.partsOptions[_index2];

    if (this.optionals.indexOf(part.name) !== -1) {
      continue;
    }

    if (partsS.indexOf(part.name) === -1) {
      return false;
    }
  }

  return true;
};
/**
 * @ignore
 */


ripe.Ripe.plugins.RestrictionsPlugin.prototype._alternativeFor = function (newPart, availableParts, pop) {
  pop = pop || false;
  var part = null;
  var color = null;
  var colors = null;
  var materialsIndex = null; // finds the index of the part to use it as the starting
  // point of the search for an alternative

  for (var index = 0; index < availableParts.length; index++) {
    var _part = availableParts[index];

    if (_part.name !== newPart.name) {
      continue;
    }

    part = _part;
    var materials = part.materials;

    for (var _index = 0; _index < materials.length; _index++) {
      var material = materials[_index];

      if (material.name !== newPart.material) {
        continue;
      }

      materialsIndex = _index;
      colors = material.colors;
      break;
    }

    break;
  } // tries to retrieve an alternative option, giving
  // priority to the colors of its material


  var indexM = null;

  while (indexM !== materialsIndex) {
    indexM = indexM === null ? materialsIndex : indexM;
    var _material2 = part.materials[indexM];
    colors = _material2.colors;

    for (var _index3 = 0; _index3 < colors.length; _index3++) {
      color = colors[_index3];

      if (indexM === materialsIndex && color === newPart.color) {
        continue;
      } // if pop is set to true then removes the alternative
      // from the available parts list so that it is not
      // used again to avoid infinite loops


      if (pop) {
        colors.splice(_index3, 1);
      }

      var alternative = {
        name: newPart.name,
        material: _material2.name,
        color: color
      };
      return alternative;
    }

    indexM = (indexM + 1) % part.materials.length;
  } // if no alternative is found and this part is
  // optional then the part is removed


  if (this.optionals.indexOf(newPart.name) !== -1) {
    return {
      name: newPart.name,
      material: null,
      color: null
    };
  }

  return null;
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(34); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @class
 * @augments Plugin
 * @classdesc Plugin responsible for applying synchronization rules.
 *
 * @param {Object} rules A Map with synchronization rules to be applied.
 * If defined, overrides the rules defined on the model's config.
 * @param {Object} options An object with options to configure the plugin.
 */


ripe.Ripe.plugins.SyncPlugin = function (rules) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  ripe.Ripe.plugins.Plugin.call(this);
  this.rules = this._normalizeRules(rules);
  this.manual = Boolean(options.manual || rules);
  this.auto = !this.manual;
};

ripe.Ripe.plugins.SyncPlugin.prototype = ripe.build(ripe.Ripe.plugins.Plugin.prototype);
ripe.Ripe.plugins.SyncPlugin.prototype.constructor = ripe.Ripe.plugins.SyncPlugin;
/**
 * The Sync Plugin binds the 'post_config' and 'part' events,
 * in order to:
 * - retrieve the model's configuration.
 * - change the necessary parts making them comply with the syncing rules.
 *
 * @param {Ripe} The Ripe instance in use.
 */

ripe.Ripe.plugins.SyncPlugin.prototype.register = function (owner) {
  var _this = this;

  ripe.Ripe.plugins.Plugin.prototype.register.call(this, owner); // sets the initial set of rules from the owner, in case the
  // auto mode is enabled for the current instance

  this.rules = this.auto && owner.loadedConfig ? this._normalizeRules(owner.loadedConfig.sync) : this.rules; // listens for model changes and if the load config option is
  // set then retrieves the new model's post config, otherwise
  // unregisters itself as its rules are no longer valid

  this._postConfigBind = this.manual ? null : this.owner.bind("post_config", function (config) {
    _this.rules = config ? _this._normalizeRules(config.sync) : {};
  }); // binds to the part event to change the necessary parts
  // so that they comply with the product's sync rules

  this._partBind = this.owner.bind("part", this._applySync.bind(this));
};
/**
 * The unregister to be called (by the owner)
 * the plugins unbinds events and executes
 * any necessary cleanup operation.
 *
 * @param {Ripe} The Ripe instance in use.
 */


ripe.Ripe.plugins.SyncPlugin.prototype.unregister = function (owner) {
  this.owner && this.owner.unbind("part", this._partBind);
  this.owner && this.owner.unbind("post_config", this._postConfigBind);
  ripe.Ripe.plugins.Plugin.prototype.unregister.call(this, owner);
};
/**
 * Traverses the provided rules and transforms string rules
 * into object rules to keep the internal representation
 * of the rules consistent.
 *
 * @param {Array} rules The rules that will be normalized
 * into object rules.
 * @returns {Object} The normalized version of the rules.
 *
 * @ignore
 */


ripe.Ripe.plugins.SyncPlugin.prototype._normalizeRules = function (rules) {
  var _rules = {};

  if (!rules) {
    return _rules;
  }

  for (var ruleName in rules) {
    var rule = rules[ruleName];

    for (var index = 0; index < rule.length; index++) {
      var part = rule[index];

      if (typeof part === "string") {
        part = {
          part: part
        };
        rule[index] = part;
      }
    }

    _rules[ruleName] = rule;
  }

  return _rules;
};
/**
 * Checks if any of the sync rules should apply to the
 * provided part, meaning that the other parts of the rule
 * have to be changed accordingly.
 *
 * @param {String} name The name of the part that may be
 * affected by a rule.
 * @param {Object} value The material and color of the part
 * as a object map.
 *
 * @ignore
 */


ripe.Ripe.plugins.SyncPlugin.prototype._applySync = function (name, value) {
  // iterates over the complete set of rules to determine
  // if any of them should apply to the provided part
  for (var key in this.rules) {
    // if a part was selected and it is part of
    // the rule then its value is used otherwise
    // the first part of the rule is used
    var rule = this.rules[key];
    var firstPart = rule[0];
    name = name || firstPart.part;
    value = value || this.owner.parts[name]; // checks if the part triggers the sync rule
    // and skips to the next rule if it doesn't

    if (this._shouldSync(rule, name, value) === false) {
      continue;
    } // iterates through the parts of the rule and
    // sets their material and color according to
    // the sync rule in case there's a match


    for (var index = 0; index < rule.length; index++) {
      var _part = rule[index]; // in case the current rule definition references the current
      // part in rule deinition, ignores the current loop

      if (_part.part === name) {
        continue;
      } // tries to find the target part configuration an in case
      // no such part is found throws an error


      var target = this.owner.parts[_part.part];

      if (!target) {
        throw new Error("Target part for rule not found '".concat(_part.part, "'"));
      }

      if (_part.color === undefined) {
        target.material = _part.material ? _part.material : value.material;
      }

      target.color = _part.color ? _part.color : value.color;
    }
  }
};
/**
 * Checks if the sync rule contains the provided part
 * meaning that the other parts of the rule have to
 * be changed accordingly.
 *
 * @param {Object} rule The sync rule that will be checked.
 * @param {String} name The name of the part that may be
 * affected by the rule.
 * @param {Object} value The material and color of the part.
 * @returns {Boolean} If the provided rule is valid for the provided
 * part and value (material and color).
 *
 * @ignore
 */


ripe.Ripe.plugins.SyncPlugin.prototype._shouldSync = function (rule, name, value) {
  for (var index = 0; index < rule.length; index++) {
    var rulePart = rule[index];
    var part = rulePart.part;
    var material = rulePart.material;
    var color = rulePart.color;
    var materialSync = !material || material === value.material;
    var colorSync = !color || color === value.color;

    if (part === name && materialSync && colorSync) {
      return true;
    }
  }

  return false;
};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var configurator = __webpack_require__(294);

var configuratorPrc = __webpack_require__(170);

var image = __webpack_require__(298);

var visual = __webpack_require__(104);

Object.assign(module.exports, configurator);
Object.assign(module.exports, configuratorPrc);
Object.assign(module.exports, image);
Object.assign(module.exports, visual);

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9);

  __webpack_require__(170); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}

ripe.Configurator = ripe.ConfiguratorPrc;
ripe.Configurator.prototype = ripe.ConfiguratorPrc.prototype;
ripe.Configurator.prototype.constructor = ripe.Configurator;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(166);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 296 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 297 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var _regeneratorRuntime = __webpack_require__(0);

var _asyncToGenerator = __webpack_require__(1);

if ( true && (typeof window === "undefined" || // eslint-disable-next-line camelcase
typeof __webpack_require__ !== "undefined" || typeof navigator !== "undefined" && navigator.product === "ReactNative")) {
  // eslint-disable-next-line no-redeclare,no-var
  var base = __webpack_require__(9);

  __webpack_require__(104); // eslint-disable-next-line no-redeclare,no-var


  var ripe = base.ripe;
}
/**
 * @class
 * @classdesc Class that reactively updates the image of an img element whenever
 * the state of its owner changes.
 *
 * @param {Ripe} owner The Ripe instance to be shown.
 * @param {Object} element The img element that should be updated.
 * @param {Object} options An object with options to configure the image, such as:
 * - 'showInitials' - A Boolean indicating if the owner's personalization should be shown (defaults to 'true¨).
 * - 'initialsBuilder' - A function that receives the initials and engraving as Strings and the img element that
 * will be used and returns a map with the initials and a profile list.
 * - 'frame' - The Ripe instance frame to display (defaults to '0').
 * - 'size' - The image size in pixels (defaults to '1000').
 * - 'width' - The image width in pixels (defaults to 'null', meaning it will fallback to 'size').
 * - 'height' - The image height in pixels (defaults to 'null', meaning it will fallback to 'size').
 * - 'crop' - A Boolean indicating if it is to crop the image composition.
 */


ripe.Image = function (owner, element, options) {
  this.type = this.type || "Image";
  ripe.Visual.call(this, owner, element, options);
};

ripe.Image.prototype = ripe.build(ripe.Visual.prototype);
ripe.Image.prototype.constructor = ripe.Image;
/**
 * The Image initializer, which is called (by the owner)
 * whenever the Image is going to become active.
 *
 * Sets the various values for the Image taking into
 * owner's default values.
 */

ripe.Image.prototype.init = function () {
  ripe.Visual.prototype.init.call(this);
  this.frame = this.options.frame || null;
  this.format = this.options.format || null;
  this.size = this.options.size || null;
  this.width = this.options.width || null;
  this.height = this.options.height || null;
  this.mutations = this.options.mutations || false;
  this.rotation = this.options.rotation || null;
  this.crop = this.options.crop || null;
  this.flip = this.options.flip || null;
  this.mirror = this.options.mirror || null;
  this.boundingBox = this.options.boundingBox || null;
  this.algorithm = this.options.algorithm || null;
  this.background = this.options.background || null;
  this.engine = this.options.engine || null;
  this.initialsX = this.options.initialsX || null;
  this.initialsY = this.options.initialsY || null;
  this.initialsWidth = this.options.initialsWidth || null;
  this.initialsHeight = this.options.initialsHeight || null;
  this.initialsViewport = this.options.initialsViewport || null;
  this.initialsColor = this.options.initialsColor || null;
  this.initialsOpacity = this.options.initialsOpacity || null;
  this.initialsAlign = this.options.initialsAlign || null;
  this.initialsVertical = this.options.initialsVertical || null;
  this.initialsEmbossing = this.options.initialsEmbossing || null;
  this.initialsRotation = this.options.initialsRotation || null;
  this.initialsZindex = this.options.initialsZindex || null;
  this.initialsAlgorithm = this.options.initialsAlgorithm || null;
  this.initialsBlendColor = this.options.initialsBlendColor || null;
  this.initialsPattern = this.options.initialsPattern || null;
  this.initialsTexture = this.options.initialsTexture || null;
  this.initialsExclusion = this.options.initialsExclusion || null;
  this.initialsInclusion = this.options.initialsInclusion || null;
  this.initialsImageRotation = this.options.initialsImageRotation || null;
  this.initialsImageFlip = this.options.initialsImageFlip || null;
  this.initialsImageMirror = this.options.initialsImageMirror || null;
  this.debug = this.options.debug || null;
  this.fontFamily = this.options.fontFamily || null;
  this.fontWeight = this.options.fontWeight || null;
  this.fontSize = this.options.fontSize || null;
  this.fontSpacing = this.options.fontSpacing || null;
  this.fontTrim = this.options.fontTrim || null;
  this.fontMask = this.options.fontMask || null;
  this.fontMode = this.options.fontMode || null;
  this.lineHeight = this.options.lineHeight || null;
  this.lineBreaking = this.options.lineBreaking || null;
  this.shadow = this.options.shadow || null;
  this.shadowColor = this.options.shadowColor || null;
  this.shadowOffset = this.options.shadowOffset || null;
  this.offsets = this.options.offsets || null;
  this.curve = this.options.curve || null;
  this.showInitials = this.options.showInitials || false;
  this.initialsGroup = this.options.initialsGroup || null;

  this.initialsBuilder = this.options.initialsBuilder || function (initials, engraving, element) {
    return {
      initials: initials || "$empty",
      profile: [engraving]
    };
  };

  this.doubleBuffering = this.options.doubleBuffering === undefined ? true : this.options.doubleBuffering;
  this._observer = null;
  this._url = null;
  this._previousUrl = null;

  this._registerHandlers();
};
/**
 * The Image deinitializer, to be called (by the owner) when
 * it should stop responding to updates so that any necessary
 * cleanup operations can be executed.
 */


ripe.Image.prototype.deinit = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return this.cancel();

        case 2:
          this._unregisterHandlers();

          this._observer = null;
          this.initialsBuilder = null;
          ripe.Visual.prototype.deinit.call(this);

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _callee, this);
}));
/**
 * Updates the Image's current options with the ones provided.
 *
 * @param {Object} options Set of optional parameters to adjust the Image, such as:
 * - 'format' - The format of the image, (eg: png, jpg, svg, etc.).
 * - 'crop' - A Boolean indicating if the resulting image should be cropped.
 * - 'initialsGroup' - The group in which the image initials belongs to.
 * @param {Boolean} update If an update operation should be executed after
 * the options updated operation has been performed.
 */

ripe.Image.prototype.updateOptions = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(options) {
    var update,
        _args2 = arguments;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            update = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : true;
            ripe.Visual.prototype.updateOptions.call(this, options);
            this.frame = options.frame === undefined ? this.frame : options.frame;
            this.format = options.format === undefined ? this.format : options.format;
            this.size = options.size === undefined ? this.size : options.size;
            this.width = options.width === undefined ? this.width : options.width;
            this.height = options.height === undefined ? this.height : options.height;
            this.rotation = options.rotation === undefined ? this.rotation : options.rotation;
            this.crop = options.crop === undefined ? this.crop : options.crop;
            this.flip = options.flip === undefined ? this.flip : options.flip;
            this.mirror = options.mirror === undefined ? this.mirror : options.mirror;
            this.boundingBox = options.boundingBox === undefined ? this.boundingBox : options.boundingBox;
            this.algorithm = options.algorithm === undefined ? this.algorithm : options.algorithm;
            this.background = options.background === undefined ? this.background : options.background;
            this.engine = options.engine === undefined ? this.engine : options.engine;
            this.initialsX = options.initialsX === undefined ? this.initialsX : options.initialsX;
            this.initialsY = options.initialsY === undefined ? this.initialsY : options.initialsY;
            this.initialsWidth = options.initialsWidth === undefined ? this.initialsWidth : options.initialsWidth;
            this.initialsHeight = options.initialsHeight === undefined ? this.initialsHeight : options.initialsHeight;
            this.initialsViewport = options.initialsViewport === undefined ? this.initialsViewport : options.initialsViewport;
            this.initialsColor = options.initialsColor === undefined ? this.initialsColor : options.initialsColor;
            this.initialsOpacity = options.initialsOpacity === undefined ? this.initialsOpacity : options.initialsOpacity;
            this.initialsAlign = options.initialsAlign === undefined ? this.initialsAlign : options.initialsAlign;
            this.initialsVertical = options.initialsVertical === undefined ? this.initialsVertical : options.initialsVertical;
            this.initialsEmbossing = options.initialsEmbossing === undefined ? this.initialsEmbossing : options.initialsEmbossing;
            this.initialsRotation = options.initialsRotation === undefined ? this.initialsRotation : options.initialsRotation;
            this.initialsZindex = options.initialsZindex === undefined ? this.initialsZindex : options.initialsZindex;
            this.initialsAlgorithm = options.initialsAlgorithm === undefined ? this.initialsAlgorithm : options.initialsAlgorithm;
            this.initialsBlendColor = options.initialsBlendColor === undefined ? this.initialsBlendColor : options.initialsBlendColor;
            this.initialsPattern = options.initialsPattern === undefined ? this.initialsPattern : options.initialsPattern;
            this.initialsTexture = options.initialsTexture === undefined ? this.initialsTexture : options.initialsTexture;
            this.initialsExclusion = options.initialsExclusion === undefined ? this.initialsExclusion : options.initialsExclusion;
            this.initialsInclusion = options.initialsInclusion === undefined ? this.initialsInclusion : options.initialsInclusion;
            this.initialsImageRotation = options.initialsImageRotation === undefined ? this.initialsImageRotation : options.initialsImageRotation;
            this.initialsImageFlip = options.initialsImageFlip === undefined ? this.initialsImageFlip : options.initialsImageFlip;
            this.initialsImageMirror = options.initialsImageMirror === undefined ? this.initialsImageMirror : options.initialsImageMirror;
            this.debug = options.debug === undefined ? this.debug : options.debug;
            this.fontFamily = options.fontFamily === undefined ? this.fontFamily : options.fontFamily;
            this.fontWeight = options.fontWeight === undefined ? this.fontWeight : options.fontWeight;
            this.fontSize = options.fontSize === undefined ? this.fontSize : options.fontSize;
            this.fontSpacing = options.fontSpacing === undefined ? this.fontSpacing : options.fontSpacing;
            this.fontTrim = options.fontTrim === undefined ? this.fontTrim : options.fontTrim;
            this.fontMask = options.fontMask === undefined ? this.fontMask : options.fontMask;
            this.fontMode = options.fontMode === undefined ? this.fontMode : options.fontMode;
            this.lineHeight = options.lineHeight === undefined ? this.lineHeight : options.lineHeight;
            this.lineBreaking = options.lineBreaking === undefined ? this.lineBreaking : options.lineBreaking;
            this.shadow = options.shadow === undefined ? this.shadow : options.shadow;
            this.shadowColor = options.shadowColor === undefined ? this.shadowColor : options.shadowColor;
            this.shadowOffset = options.shadowOffset === undefined ? this.shadowOffset : options.shadowOffset;
            this.offsets = options.offsets === undefined ? this.offsets : options.offsets;
            this.curve = options.curve === undefined ? this.curve : options.curve;
            this.initialsGroup = options.initialsGroup === undefined ? this.initialsGroup : options.initialsGroup;
            this.doubleBuffering = options.doubleBuffering === undefined ? this.doubleBuffering : options.doubleBuffering;

            if (!update) {
              _context2.next = 56;
              break;
            }

            _context2.next = 56;
            return this.update();

          case 56:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * This function is called (by the owner) whenever its state changes
 * so that the Image can update itself for the new state.
 *
 * @param {Object} state An object containing the new state of the owner.
 * @param {Object} options Set of optional parameters to adjust the Image.
 * @returns {Boolean} If an effective operation has been performed by the
 * update operation.
 */


ripe.Image.prototype.update = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(state) {
    var _this = this;

    var options,
        frame,
        format,
        size,
        width,
        height,
        rotation,
        crop,
        initialsGroup,
        flip,
        mirror,
        boundingBox,
        algorithm,
        background,
        engine,
        initialsX,
        initialsY,
        initialsWidth,
        initialsHeight,
        initialsViewport,
        initialsColor,
        initialsOpacity,
        initialsAlign,
        initialsVertical,
        initialsEmbossing,
        initialsRotation,
        initialsZindex,
        initialsAlgorithm,
        initialsBlendColor,
        initialsPattern,
        initialsTexture,
        initialsExclusion,
        initialsInclusion,
        initialsImageRotation,
        initialsImageFlip,
        initialsImageMirror,
        debug,
        fontFamily,
        fontWeight,
        fontSize,
        fontSpacing,
        fontTrim,
        fontMask,
        fontMode,
        lineHeight,
        lineBreaking,
        shadow,
        shadowColor,
        shadowOffset,
        offsets,
        curve,
        doubleBuffering,
        _base,
        initialsSpec,
        url,
        result,
        _args3 = arguments;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            options = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};

            if (this.element) {
              _context3.next = 3;
              break;
            }

            return _context3.abrupt("return");

          case 3:
            // gathers the complete set of data values from the element if existent
            // defaulting to the instance one in case their are not defined
            frame = this.element.dataset.frame || this.frame;
            format = this.element.dataset.format || this.format;
            size = this.element.dataset.size || this.size;
            width = this.element.dataset.width || this.width;
            height = this.element.dataset.height || this.height;
            rotation = this.element.dataset.rotation || this.rotation;
            crop = this.element.dataset.crop || this.crop;
            initialsGroup = this.element.dataset.initialsGroup || this.initialsGroup;
            flip = this.element.dataset.flip || this.flip;
            mirror = this.element.dataset.mirror || this.mirror;
            boundingBox = this.element.dataset.boundingBox || this.boundingBox;
            algorithm = this.element.dataset.algorithm || this.algorithm;
            background = this.element.dataset.background || this.background;
            engine = this.element.dataset.engine || this.engine;
            initialsX = this.element.dataset.initialsX || this.initialsX;
            initialsY = this.element.dataset.initialsY || this.initialsY;
            initialsWidth = this.element.dataset.initialsWidth || this.initialsWidth;
            initialsHeight = this.element.dataset.initialsHeight || this.initialsHeight;
            initialsViewport = this.element.dataset.initialsViewport || this.initialsViewport;
            initialsColor = this.element.dataset.initialsColor || this.initialsColor;
            initialsOpacity = this.element.dataset.initialsOpacity || this.initialsOpacity;
            initialsAlign = this.element.dataset.initialsAlign || this.initialsAlign;
            initialsVertical = this.element.dataset.initialsVertical || this.initialsVertical;
            initialsEmbossing = this.element.dataset.initialsEmbossing || this.initialsEmbossing;
            initialsRotation = this.element.dataset.initialsRotation || this.initialsRotation;
            initialsZindex = this.element.dataset.initialsZindex || this.initialsZindex;
            initialsAlgorithm = this.element.dataset.initialsAlgorithm || this.initialsAlgorithm;
            initialsBlendColor = this.element.dataset.initialsBlendColor || this.initialsBlendColor;
            initialsPattern = this.element.dataset.initialsPattern || this.initialsPattern;
            initialsTexture = this.element.dataset.initialsTexture || this.initialsTexture;
            initialsExclusion = this.element.dataset.initialsExclusion || this.initialsExclusion;
            initialsInclusion = this.element.dataset.initialsInclusion || this.initialsInclusion;
            initialsImageRotation = this.element.dataset.initialsImageRotation || this.initialsImageRotation;
            initialsImageFlip = this.element.dataset.initialsImageFlip || this.initialsImageFlip;
            initialsImageMirror = this.element.dataset.initialsImageMirror || this.initialsImageMirror;
            debug = this.element.dataset.debug || this.debug;
            fontFamily = this.element.dataset.fontFamily || this.fontFamily;
            fontWeight = this.element.dataset.fontWeight || this.fontWeight;
            fontSize = this.element.dataset.fontSize || this.fontSize;
            fontSpacing = this.element.dataset.fontSpacing || this.fontSpacing;
            fontTrim = this.element.dataset.fontTrim || this.fontTrim;
            fontMask = this.element.dataset.fontMask || this.fontMask;
            fontMode = this.element.dataset.fontMode || this.fontMode;
            lineHeight = this.element.dataset.lineHeight || this.lineHeight;
            lineBreaking = this.element.dataset.lineBreaking || this.lineBreaking;
            shadow = this.element.dataset.shadow || this.shadow;
            shadowColor = this.element.dataset.shadowColor || this.shadowColor;
            shadowOffset = this.element.dataset.shadowOffset || this.shadowOffset;
            offsets = this.element.dataset.offsets || this.offsets;
            curve = this.element.dataset.curve || this.curve;
            doubleBuffering = this.element.dataset.doubleBuffering || this.doubleBuffering; // in case the state is defined tries to gather the appropriate
            // sate options for both initials and engraving taking into
            // consideration that groups may exist

            if (state !== undefined) {
              _base = initialsGroup ? state.initialsExtra[initialsGroup] || {} : state;
              this.initials = _base.initials || "";
              this.engraving = _base.engraving || null;
            }

            initialsSpec = this.showInitials ? this.initialsBuilder(this.initials, this.engraving, this.element) : {}; // verifies if the model currently loaded in the Ripe Instance can
            // render the frame to be display and if that's not the case "ignores"
            // the current request for update

            if (!(frame && !this.owner.hasFrame(frame))) {
              _context3.next = 59;
              break;
            }

            this.trigger("not_loaded");
            return _context3.abrupt("return", false);

          case 59:
            // builds the URL of the image using the frame hacking approach
            // this should provide us with the new values
            url = this.owner._getImageURL({
              frame: frame,
              format: format,
              size: size,
              width: width,
              height: height,
              rotation: rotation,
              crop: crop,
              initials: initialsSpec.initials,
              profile: initialsSpec.profile,
              flip: flip,
              mirror: mirror,
              boundingBox: boundingBox,
              algorithm: algorithm,
              background: background,
              engine: engine,
              initialsX: initialsX,
              initialsY: initialsY,
              initialsWidth: initialsWidth,
              initialsHeight: initialsHeight,
              initialsViewport: initialsViewport,
              initialsColor: initialsColor,
              initialsOpacity: initialsOpacity,
              initialsAlign: initialsAlign,
              initialsVertical: initialsVertical,
              initialsEmbossing: initialsEmbossing,
              initialsRotation: initialsRotation,
              initialsZindex: initialsZindex,
              initialsAlgorithm: initialsAlgorithm,
              initialsBlendColor: initialsBlendColor,
              initialsPattern: initialsPattern,
              initialsTexture: initialsTexture,
              initialsExclusion: initialsExclusion,
              initialsInclusion: initialsInclusion,
              initialsImageRotation: initialsImageRotation,
              initialsImageFlip: initialsImageFlip,
              initialsImageMirror: initialsImageMirror,
              debug: debug,
              fontFamily: fontFamily,
              fontWeight: fontWeight,
              fontSize: fontSize,
              fontSpacing: fontSpacing,
              fontTrim: fontTrim,
              fontMask: fontMask,
              fontMode: fontMode,
              lineHeight: lineHeight,
              lineBreaking: lineBreaking,
              shadow: shadow,
              shadowColor: shadowColor,
              shadowOffset: shadowOffset,
              offsets: offsets,
              curve: curve
            }); // verifies if the target image URL for the update is already
            // set and if that's the case returns (end of loop)

            if (!(url === this._url)) {
              _context3.next = 63;
              break;
            }

            this.trigger("not_loaded");
            return _context3.abrupt("return", false);

          case 63:
            // saves the previous URL value and then updates the new URL
            // according to the newly requested one
            this._previousUrl = this._url;
            this._url = url; // in case the double buffering mode is active an off-screen
            // image element is created to "cache" the image that is going
            // to be displayed for the current update, this way the typical
            // flickering visual artifact can be avoided

            if (!(doubleBuffering && this._url)) {
              _context3.next = 68;
              break;
            }

            _context3.next = 68;
            return this._doubleBuffer(this._url);

          case 68:
            if (this.element) {
              _context3.next = 70;
              break;
            }

            return _context3.abrupt("return");

          case 70:
            // updates the image DOM element with the values of the image
            // including requested size and URL
            if (width) this.element.width = width;
            if (height) this.element.height = height;
            this.element.src = this._url || ""; // saves the space for the result of the loaded callback that
            // should be a boolean indicating if there's was a visual impact
            // resulting from the loading operation

            result = true;
            _context3.prev = 74;
            _context3.next = 77;
            return new Promise(function (resolve, reject) {
              _this._loadedCallback = resolve;
              _this._errorCallback = reject;
            });

          case 77:
            result = _context3.sent;

          case 78:
            _context3.prev = 78;
            // unsets both of the callbacks as they are no longer required by
            // the promise's underlying logic
            this._loadedCallback = null;
            this._errorCallback = null;
            return _context3.finish(78);

          case 82:
            // in case there's no value returned by the loaded callback then
            // the result is considered valid (proper update)
            if (result === undefined) result = true; // returns a value indicating that if the loading operation
            // as been triggered with success (effective operation)

            return _context3.abrupt("return", result);

          case 84:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, this, [[74,, 78, 82]]);
  }));

  return function (_x2) {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * This function is called (by the owner) whenever the current operation
 * in the child should be canceled this way an Image is not updated.
 *
 * @param {Object} options Set of optional parameters to adjust the Image.
 * @returns {Boolean} If an effective operation has been performed or if
 * instead no cancel logic was executed.
 */


ripe.Image.prototype.cancel = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
  var options,
      _args4 = arguments;
  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          options = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};

          if (this._loadedCallback) {
            _context4.next = 3;
            break;
          }

          return _context4.abrupt("return", false);

        case 3:
          // restores the internal URL state of the image back to
          // the previous one (and updates the element accordingly)
          this._url = this._previousUrl;
          this._previousUrl = null;
          this.element.src = this._url || ""; // calls the loaded callback with the indication that there
          // was a cancel operation for its load

          this._loadedCallback({
            canceled: true
          });

          return _context4.abrupt("return", true);

        case 8:
        case "end":
          return _context4.stop();
      }
    }
  }, _callee4, this);
}));
/**
 * Resizes the Image's DOM element to 'size' pixels, both the
 * width and the height of the image will reflect this value.
 *
 * @param {String} size The number of pixels to resize to.
 */

ripe.Image.prototype.resize = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(size) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            this.size = size;
            _context5.next = 3;
            return this.update();

          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, this);
  }));

  return function (_x3) {
    return _ref5.apply(this, arguments);
  };
}();
/**
 * Updates the frame that the Image is referring to.
 *
 * @param {String} frame The Ripe instance frame to display.
 * @param {Object} options An object with options to configure
 * the setting of the frame.
 */


ripe.Image.prototype.setFrame = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(frame, options) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            this.frame = frame;
            _context6.next = 3;
            return this.update();

          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, this);
  }));

  return function (_x4, _x5) {
    return _ref6.apply(this, arguments);
  };
}();
/**
 * Updates the Image's 'showInitials' flag that indicates
 * if the initials should be display in the image.
 *
 * @param {String} showInitials If the image should display initials.
 */


ripe.Image.prototype.setShowInitials = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(showInitials) {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            this.showInitials = showInitials;
            _context7.next = 3;
            return this.update();

          case 3:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, this);
  }));

  return function (_x6) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * Updates the Image's 'initialsBuilder' function.
 *
 * @param {Function} builder The new 'initialsBuilder' function
 * to be used by the Image.
 * @param {Object} options An object with options to configure
 * the setting of the 'initialsBuilder'.
 */


ripe.Image.prototype.setInitialsBuilder = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(builder, options) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            this.initialsBuilder = builder;
            _context8.next = 3;
            return this.update();

          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function (_x7, _x8) {
    return _ref8.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.Image.prototype._doubleBuffer = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(url) {
    var image;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!(typeof window === "undefined" || !window.document)) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return");

          case 2:
            image = document.createElement("img");
            _context9.prev = 3;
            _context9.next = 6;
            return new Promise(function (resolve, reject) {
              image.addEventListener("load", resolve);
              image.addEventListener("error", reject);
              image.src = url;
            });

          case 6:
            _context9.prev = 6;
            image.remove();
            return _context9.finish(6);

          case 9:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[3,, 6, 9]]);
  }));

  return function (_x9) {
    return _ref9.apply(this, arguments);
  };
}();
/**
 * @ignore
 */


ripe.Image.prototype._registerHandlers = function () {
  var _this2 = this;

  if (!this.element) return; // creates and add both the load and the error listeners
  // for the underlying image element to propagate those events
  // into the current observable context (event normalization)

  this.loadListener = function () {
    return _this2.trigger("loaded");
  };

  this.errorListener = function () {
    return _this2.trigger("error");
  };

  this.element.addEventListener("load", this.loadListener);
  this.element.addEventListener("error", this.errorListener); // registers for both the loaded and error handlers to cast
  // the handlers to the "simpler" callback attributes

  this.loadedHandler = this.bind("loaded", function () {
    if (_this2._loadedCallback) _this2._loadedCallback();
  });
  this.errorHandler = this.bind("error", function () {
    if (_this2._errorCallback) _this2._errorCallback();
  }); // verifies if mutation should be "observed" for this visual
  // and in such case registers for the observation of any DOM
  // mutation (eg: attributes) for the image element, triggering
  // a new update operation in case that happens

  if (this.mutations) {
    var Observer = typeof MutationObserver !== "undefined" && MutationObserver || typeof WebKitMutationObserver !== "undefined" && WebKitMutationObserver || // eslint-disable-line no-undef
    null;
    this._observer = Observer ? new Observer(function (mutations) {
      _this2.update();
    }) : null;

    if (this._observer) {
      this._observer.observe(this.element, {
        attributes: true,
        subtree: false
      });
    }
  }
};
/**
 * @ignore
 */


ripe.Image.prototype._unregisterHandlers = function () {
  if (this.loadListener && this.element) {
    this.element.removeEventListener("load", this.loadListener);
  }

  if (this.errorListener && this.element) {
    this.element.removeEventListener("error", this.errorListener);
  }

  if (this.loadedHandler) this.unbind("loaded", this.loadedHandler);
  if (this.errorHandler) this.unbind("error", this.errorHandler);
  if (this._observer) this._observer.disconnect();
};

/***/ }),
/* 299 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_images_vue_vue_type_style_index_0_id_ddfed566_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(179);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_images_vue_vue_type_style_index_0_id_ddfed566_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_images_vue_vue_type_style_index_0_id_ddfed566_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.initials-image[data-v-ddfed566] {\r\n    font-size: 0px;\n}\n.initials-images .initials-image[data-v-ddfed566] {\r\n    height: 600px;\r\n    user-select: none;\r\n    width: auto;\n}\nbody.mobile .initials-images .initials-image[data-v-ddfed566],\r\nbody.tablet .initials-images .initials-image[data-v-ddfed566] {\r\n    height: auto;\r\n    max-width: 600px;\r\n    width: 100%;\n}\n.initials-images .initials-image.selectable[data-v-ddfed566] {\r\n    cursor: pointer;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_inputs_vue_vue_type_style_index_0_id_54cc77a2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(181);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_inputs_vue_vue_type_style_index_0_id_54cc77a2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_initials_inputs_vue_vue_type_style_index_0_id_54cc77a2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.initials-input[data-v-54cc77a2] {\r\n    border-bottom: 1px solid #d0d0d0;\r\n    font-size: 25px;\r\n    height: 40px;\r\n    letter-spacing: 5px;\r\n    line-height: 40px;\r\n    margin: 0px auto 0px auto;\r\n    text-transform: uppercase;\r\n    transition: border-bottom-color 0.25s ease-in-out;\r\n    vertical-align: top;\r\n    width: 200px;\n}\n.initials-input.active[data-v-54cc77a2] {\r\n    border-bottom: 1px solid #2d2d2d;\n}\n.initials-labels[data-v-54cc77a2] {\r\n    font-size: 0px;\n}\n.initials-labels .initials-label[data-v-54cc77a2] {\r\n    color: #9b9b9b;\r\n    cursor: pointer;\r\n    font-size: 15px;\r\n    margin: 30px 0px 30px 0px;\r\n    user-select: none;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_style_index_0_id_1fd4de22_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(183);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_style_index_0_id_1fd4de22_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_style_index_0_id_1fd4de22_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.reference-personalization[data-v-1fd4de22] {\r\n    max-width: 100%;\r\n    min-width: 600px;\n}\nbody.tablet .reference-personalization[data-v-1fd4de22],\r\nbody.mobile .reference-personalization[data-v-1fd4de22] {\r\n    min-width: 100%;\n}\nbody.tablet .reference-personalization > .initials-images[data-v-1fd4de22],\r\nbody.mobile .reference-personalization > .initials-images[data-v-1fd4de22] {\r\n    display: flex;\n}\n.reference-personalization > .initials-images[data-v-1fd4de22]  .initials-image {\r\n    margin-right: 30px;\n}\nbody.tablet .reference-personalization > .initials-images[data-v-1fd4de22]  .initials-image,\r\nbody.mobile .reference-personalization > .initials-images[data-v-1fd4de22]  .initials-image {\r\n    width: auto;\n}\n.reference-personalization > .initials-images[data-v-1fd4de22]  .initials-image:last-of-type {\r\n    margin-right: 0px;\n}\n.reference-personalization > .form[data-v-1fd4de22] {\r\n    display: flex;\r\n    justify-content: center;\n}\n.reference-personalization > .form > .form-group[data-v-1fd4de22] {\r\n    margin-right: 30px;\r\n    width: 100%;\n}\n.reference-personalization > .form > .form-group[data-v-1fd4de22]:last-of-type {\r\n    margin-right: 0px;\n}\n.reference-personalization > .form > .form-group > .subtitle[data-v-1fd4de22] {\r\n    font-size: 14px;\r\n    margin: 16px 0px 20px 0px;\r\n    text-transform: capitalize;\n}\n.reference-personalization > .form > .form-group > .form-input[data-v-1fd4de22] {\r\n    margin-bottom: 20px;\r\n    text-align: left;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_style_index_0_id_e3301666_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(186);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_style_index_0_id_e3301666_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_reference_vue_vue_type_style_index_0_id_e3301666_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.reference-size > .size-selector[data-v-e3301666] {\r\n    margin-bottom: 40px;\n}\n.reference-size > .size-selector .sizes-container.multiple[data-v-e3301666] {\r\n    border: 1px solid #e9eaee;\r\n    border-bottom-left-radius: 24px;\r\n    border-bottom-right-radius: 24px;\r\n    border-top: 0px;\r\n    padding: 46px 40px 40px 40px;\n}\n.reference-size > .size-selector .genders[data-v-e3301666] {\r\n    border-bottom: 1px solid #e9eaee;\r\n    font-size: 0px;\r\n    height: 70px;\n}\n.reference-size > .size-selector .genders .button.button-gender[data-v-e3301666] {\r\n    background-color: #f5f5f5;\r\n    border: 1px solid transparent;\r\n    border-bottom-color: #e9eaee;\r\n    display: inline-block;\r\n    font-size: 15px;\r\n    height: 55px;\r\n    line-height: 70px;\r\n    text-transform: uppercase;\r\n    vertical-align: bottom;\r\n    width: calc(50% - 2px);\n}\n.reference-size > .size-selector .genders .button.button-gender[data-v-e3301666]:first-child {\r\n    border-top-left-radius: 8px;\n}\n.reference-size > .size-selector .genders .button.button-gender[data-v-e3301666]:last-child {\r\n    border-top-right-radius: 8px;\n}\n.reference-size > .size-selector .genders .button.button-gender.active[data-v-e3301666],\r\n.reference-size > .size-selector .genders .button.button-gender[data-v-e3301666]:active {\r\n    background-color: #ffffff;\r\n    border-color: #e9eaee #e9eaee transparent #e9eaee;\r\n    border-top-left-radius: 8px;\r\n    border-top-right-radius: 8px;\r\n    height: 70px;\r\n    line-height: 100px;\n}\n.reference-size > .size-selector .sizes-container[data-v-e3301666] {\r\n    font-size: 0px;\r\n    padding: 32px 0px 0px 0px;\r\n    position: relative;\r\n    text-align: center;\n}\n.reference-size > .size-selector .sizes-container .scales[data-v-e3301666] {\r\n    font-size: 0px;\n}\n.reference-size > .size-selector .sizes-container .scales .button.button-scale[data-v-e3301666] {\r\n    color: #9299a3;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    font-size: 15px;\r\n    height: 50px;\r\n    letter-spacing: 0.5px;\r\n    margin: 0px 10px 0px 10px;\r\n    min-width: 50px;\r\n    text-transform: uppercase;\n}\n.reference-size > .size-selector .sizes-container .scales .button.button-scale[data-v-e3301666]:last-child {\r\n    margin-right: 0px;\n}\n.reference-size > .size-selector .sizes-container .scales .button.button-scale.active[data-v-e3301666] {\r\n    color: #000000;\r\n    font-weight: 900;\n}\n.reference-size > .size-selector .sizes-container .sizes[data-v-e3301666] {\r\n    display: inline-block;\r\n    font-size: 0px;\r\n    margin-top: 10px;\r\n    max-width: 492px;\r\n    text-align: left;\n}\n.reference-size > .size-selector .sizes-container .sizes.fade-enter[data-v-e3301666],\r\n.reference-size > .size-selector .sizes-container .sizes.fade-enter-active[data-v-e3301666] {\r\n    left: 0px;\r\n    margin: auto auto auto auto;\r\n    margin-top: 10px;\r\n    position: absolute;\r\n    right: 0px;\r\n    transition-delay: 0.25s;\r\n    transition-duration: 0.25s;\n}\n.reference-size > .size-selector .sizes .button.button-size[data-v-e3301666] {\r\n    border: 1px solid #e5e5e5;\r\n    border-radius: 4px 4px 4px 4px;\r\n    box-sizing: border-box;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    font-size: 25px;\r\n    height: 62px;\r\n    line-height: 60px;\r\n    margin: 0px 10px 8px 10px;\r\n    min-width: 60px;\r\n    overflow: hidden;\r\n    padding: 0px 6px 0px 6px;\r\n    text-align: center;\r\n    text-overflow: ellipsis;\r\n    vertical-align: top;\r\n    white-space: nowrap;\n}\n.reference-size > .size-selector .sizes .button.button-size.active[data-v-e3301666],\r\n.reference-size > .size-selector .sizes .button.button-size[data-v-e3301666]:active {\r\n    background-color: #e5e5e5;\n}\n.reference-size > .size-selector .sizes .button.button-size[data-v-e3301666]:last-child {\r\n    margin-right: 0px;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(309);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "@charset \"utf-8\";\r\n\r\n.configurator {\r\n    font-size: 0px;\r\n    user-select: none;\r\n    -o-user-select: none;\r\n    -ms-user-select: none;\r\n    -moz-user-select: none;\r\n    -khtml-user-select: none;\r\n    -webkit-user-select: none;\r\n    white-space: nowrap;\r\n}\r\n\r\n.configurator .area {\r\n    display: inline-block;\r\n}\r\n\r\n.configurator .back {\r\n    display: inline-block;\r\n}\r\n\r\n.configurator .frames-buffer {\r\n    display: none;\r\n}\r\n\r\n.configurator .front-mask {\r\n    display: none;\r\n    opacity: 0.4;\r\n    -o-opacity: 0.4;\r\n    -ms-opacity: 0.4;\r\n    -moz-opacity: 0.4;\r\n    -khtml-opacity: 0.4;\r\n    -webkit-opacity: 0.4;\r\n    pointer-events: none;\r\n    position: relative;\r\n    z-index: 2;\r\n}\r\n\r\n.configurator.highlight > .front-mask.loaded {\r\n    display: inline-block;\r\n}\r\n\r\n.configurator .mask {\r\n    display: none;\r\n}\r\n\r\n.configurator .masks-buffer {\r\n    display: none;\r\n}\r\n\r\n.configurator.fullscreen {\r\n    bottom: 0px;\r\n    left: 0px;\r\n    position: fixed;\r\n    right: 0px;\r\n    top: 0px;\r\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 310 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_alert_vue_vue_type_style_index_0_id_1c850db3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(192);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_alert_vue_vue_type_style_index_0_id_1c850db3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_alert_vue_vue_type_style_index_0_id_1c850db3_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".alert[data-v-1c850db3]{background-color:#151515;box-shadow:0px 0px 16px rgba(45,58,70,.25);box-sizing:border-box;cursor:pointer;display:block;font-size:14px;font-weight:500;left:calc(50% - 153px);line-height:22px;padding:13px 24px 13px 24px;position:fixed;text-align:center;width:306px;z-index:9}body.round .alert[data-v-1c850db3]{border-radius:4px 4px 4px 4px}.alert.fade-leave-active[data-v-1c850db3]{animation:fade-shrink-visibility .5s cubic-bezier(0.645, 0.045, 0.355, 1) forwards}.alert>.alert-content[data-v-1c850db3]{color:#fff}", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_id_b8a271f4_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(194);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_id_b8a271f4_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_button_vue_vue_type_style_index_0_id_b8a271f4_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.button[data-v-b8a271f4] {\r\n    background-color: transparent;\r\n    border: 1px solid #cccccc;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    outline: none;\n}\n.button.button-design-default[data-v-b8a271f4] {\r\n    background-color: #e5e5e5;\r\n    border: none;\r\n    border-radius: 4px 4px 4px 4px;\r\n    color: #000000;\r\n    font-family: \"Roboto\", \"Lato\", \"Open Sans\", arial, sans-serif;\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    letter-spacing: 0.25px;\r\n    min-width: 100px;\r\n    padding: 6px 10px 6px 10px;\n}\n.button.button-alignment-left[data-v-b8a271f4] {\r\n    text-align: left;\n}\n.button.button-alignment-right[data-v-b8a271f4] {\r\n    text-align: right;\n}\n.button[data-v-b8a271f4]:hover {\r\n    border: 1px solid #2d2d2d;\n}\n.button.button-design-default[data-v-b8a271f4]:hover {\r\n    border: none;\n}\n.button[data-v-b8a271f4]:active {\r\n    background-color: #2d2d2d;\r\n    color: #ffffff;\n}\n.button.disabled[data-v-b8a271f4] {\r\n    cursor: default;\r\n    opacity: 0.4;\r\n    pointer-events: none;\n}\n.button.button-design-default[data-v-b8a271f4]:active {\r\n    background-color: #a5a5a5;\r\n    color: #000000;\n}\n.button .loader[data-v-b8a271f4] {\r\n    display: inline-block;\r\n    transform: translateY(-21px);\r\n    width: 32px;\n}\n.button[data-v-b8a271f4]  .loader > div {\r\n    background-color: transparent;\r\n    height: 32px;\r\n    left: 0px;\r\n    width: 32px;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA1OCA4MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+PGRlZnM+PHBhdGggaWQ9ImEiIGQ9Ik0wIC4xODhoNTcuODQ1djc5LjA5OEgweiIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjxwYXRoIGQ9Ik0yMi40OTYuMTg4SDIuODM2QzEuMjcuMTg4IDAgMS42MDggMCAzLjM2djEuMThjMCAxLjcxNSAxLjIyOCAzLjE0IDIuNzU4IDMuMTQyaC4wMjljMTYuMTEgMCAyOC4xMzIgOS40ODkgMzAuMDYzIDM0LjQyNi4xMiAxLjU1LS45MTMgMi45MTMtMi4yOTYgMy4wNjhsLTQuNTE0LjUwMmMtLjM2LjA0LS42MjcuMzg4LS42MTguNzkzLjMxOCAxNS4yMDMtOC4wNzMgMjQuOC0yMi42MzUgMjQuOGgtLjIxQzEuMTQ3IDcxLjI4NSAwIDcyLjYwOCAwIDc0LjIwN3YyLjE0NmMwIDEuNjIgMS4xNzQgMi45MzMgMi42MjEgMi45MzNoMTkuODc1YzE5LjUyMyAwIDM1LjM1LTE3LjcwNyAzNS4zNS0zOS41NSAwLTIxLjg0Mi0xNS44MjctMzkuNTQ4LTM1LjM1LTM5LjU0OCIgZmlsbD0iI0ZGRiIgbWFzaz0idXJsKCNiKSIvPjxwYXRoIGQ9Ik0xMy40NjQgMjQuMjFjMCAyLjkwNy0yLjMxOCA1LjI2NC01LjE3OCA1LjI2NHMtNS4xNzktMi4zNTctNS4xNzktNS4yNjNjMC0yLjkwNyAyLjMxOS01LjI2NCA1LjE3OS01LjI2NCAyLjg2IDAgNS4xNzggMi4zNTcgNS4xNzggNS4yNjRtLTQuODMgMzguOTQ3aC0uNjk3Yy0yLjY2NyAwLTQuODMtMi4wNDgtNC44My00LjU3NFY0MS40MTdjMC0yLjUyNyAyLjE2My00LjU3NSA0LjgzLTQuNTc1aC42OTdjMi42NjggMCA0LjgzIDIuMDQ4IDQuODMgNC41NzV2MTcuMTY3YzAgMi41MjYtMi4xNjIgNC41NzQtNC44MyA0LjU3NCIgZmlsbD0iI0ZGRiIvPjwvZz48L3N2Zz4="

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_button_platforme_vue_vue_type_style_index_0_id_619fdb62_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(196);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_button_platforme_vue_vue_type_style_index_0_id_619fdb62_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_button_platforme_vue_vue_type_style_index_0_id_619fdb62_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".button.button-platforme[data-v-619fdb62]{background-color:#151515;color:#fff;cursor:pointer;display:inline-block;font-size:14px;font-weight:500;height:44px;line-height:44px;text-align:center;transition:opacity .15s ease-in-out,transform .15s ease-in-out;width:320px}.button.button-platforme[data-v-619fdb62]:hover{background-color:#151515;transform:scale(1.025, 1.025)}body.round .button.button-platforme[data-v-619fdb62]{border-radius:4px 4px 4px 4px}.button.button-platforme>span.button-logo[data-v-619fdb62]{background-color:#151515;height:44px;line-height:42px;margin-right:10px;text-align:center;width:44px}.button.button-platforme.loading>span.button-logo[data-v-619fdb62]{opacity:.7}.button.button-platforme>span.button-logo>img[data-v-619fdb62]{height:26px;vertical-align:middle}.button.button-platforme>.loader[data-v-619fdb62]{left:35px;top:32px;width:0px}.button.button-platforme>.loader[data-v-619fdb62] >div{height:40px;width:40px}", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./accessibility-human.svg": 319,
	"./accessibility.svg": 320,
	"./activity.svg": 321,
	"./add-to-list.svg": 322,
	"./add.svg": 323,
	"./alarm.svg": 324,
	"./align-center.svg": 325,
	"./align-left.svg": 326,
	"./align-right.svg": 327,
	"./anchor.svg": 328,
	"./aperture.svg": 329,
	"./apps-alt.svg": 330,
	"./apps.svg": 331,
	"./arrow-down-circle.svg": 332,
	"./arrow-down.svg": 333,
	"./arrow-left-bottom.svg": 334,
	"./arrow-left-circle.svg": 335,
	"./arrow-left-top.svg": 336,
	"./arrow-left.svg": 337,
	"./arrow-right-bottom.svg": 338,
	"./arrow-right-circle.svg": 339,
	"./arrow-right-top.svg": 340,
	"./arrow-right.svg": 341,
	"./arrow-up-circle.svg": 342,
	"./arrow-up.svg": 343,
	"./back-alt.svg": 344,
	"./back-left.svg": 345,
	"./back-right.svg": 346,
	"./back.svg": 347,
	"./bag.svg": 348,
	"./basket.svg": 349,
	"./basketball.svg": 350,
	"./battery-alt.svg": 351,
	"./battery-charging.svg": 352,
	"./battery-full.svg": 353,
	"./battery-low.svg": 354,
	"./battery-medium.svg": 355,
	"./battery.svg": 356,
	"./bell.svg": 357,
	"./bike.svg": 358,
	"./bin.svg": 359,
	"./bluetooth.svg": 360,
	"./bolt.svg": 361,
	"./book-opened.svg": 362,
	"./book.svg": 363,
	"./bookmark.svg": 364,
	"./box-alt.svg": 365,
	"./box-alt2.svg": 366,
	"./box.svg": 367,
	"./brightness.svg": 368,
	"./bug.svg": 369,
	"./calendar-add.svg": 370,
	"./calendar-decline.svg": 371,
	"./calendar-event.svg": 372,
	"./calendar.svg": 373,
	"./camera-rear.svg": 374,
	"./camera.svg": 375,
	"./cancel.svg": 376,
	"./car-alt.svg": 377,
	"./car.svg": 378,
	"./cards.svg": 379,
	"./cart-add.svg": 380,
	"./cart.svg": 381,
	"./celluar.svg": 382,
	"./chart.svg": 383,
	"./chat-add.svg": 384,
	"./chat-alt.svg": 385,
	"./chat-remove.svg": 386,
	"./chat-warning.svg": 387,
	"./chat.svg": 388,
	"./checkbox-intermediate.svg": 389,
	"./checkbox.svg": 390,
	"./chevron-down.svg": 391,
	"./chevron-left.svg": 392,
	"./chevron-right.svg": 393,
	"./chevron-up.svg": 394,
	"./chevrons-down.svg": 395,
	"./chevrons-left.svg": 396,
	"./chevrons-right.svg": 397,
	"./chevrons-up.svg": 398,
	"./circle.svg": 399,
	"./clip.svg": 400,
	"./clipboard.svg": 401,
	"./close.svg": 402,
	"./cloud-crossed.svg": 403,
	"./cloud-upload.svg": 404,
	"./cloud.svg": 405,
	"./code-alt.svg": 406,
	"./code.svg": 407,
	"./coffee.svg": 408,
	"./colours.svg": 409,
	"./component.svg": 410,
	"./contact-book.svg": 411,
	"./contrast.svg": 412,
	"./control-centre.svg": 413,
	"./controls-alt.svg": 414,
	"./controls-vertical-alt.svg": 415,
	"./controls.svg": 416,
	"./copy.svg": 417,
	"./credit-card.svg": 418,
	"./crop.svg": 419,
	"./crossing.svg": 420,
	"./cup.svg": 421,
	"./cursor.svg": 422,
	"./cut.svg": 423,
	"./danger.svg": 424,
	"./dashboard.svg": 425,
	"./delete.svg": 426,
	"./dialpad.svg": 427,
	"./diamond.svg": 428,
	"./direction-left.svg": 429,
	"./direction-right.svg": 430,
	"./directions-left.svg": 431,
	"./directions-right.svg": 432,
	"./disc.svg": 433,
	"./dolar.svg": 434,
	"./download.svg": 435,
	"./drop.svg": 436,
	"./ear.svg": 437,
	"./edit.svg": 438,
	"./ellypsis-vertical.svg": 439,
	"./ellypsis.svg": 440,
	"./entrance.svg": 441,
	"./envelope-alt.svg": 442,
	"./envelope.svg": 443,
	"./error.svg": 444,
	"./exit.svg": 445,
	"./explore.svg": 446,
	"./extension.svg": 447,
	"./extra/font_trimming.svg": 198,
	"./extra/hat.svg": 199,
	"./extra/letter_spacing.svg": 200,
	"./extra/line_height.svg": 201,
	"./extra/mirror_horizontal.svg": 202,
	"./extra/mirror_vertical.svg": 203,
	"./extra/options.svg": 204,
	"./eye-closed.svg": 448,
	"./eye-crossed.svg": 449,
	"./eye.svg": 450,
	"./favourite.svg": 451,
	"./feather.svg": 452,
	"./feed.svg": 453,
	"./file.svg": 454,
	"./film.svg": 455,
	"./filter.svg": 456,
	"./fit.svg": 457,
	"./flag.svg": 458,
	"./flower.svg": 459,
	"./folder-add.svg": 460,
	"./folder-remove.svg": 461,
	"./folder-warning.svg": 462,
	"./folder.svg": 463,
	"./forward.svg": 464,
	"./glasses.svg": 465,
	"./grid-alt.svg": 466,
	"./grid-small.svg": 467,
	"./grid.svg": 468,
	"./hamburger.svg": 469,
	"./happy-face.svg": 470,
	"./hash.svg": 471,
	"./hdr.svg": 472,
	"./headphones.svg": 473,
	"./hearing-disability.svg": 474,
	"./help.svg": 475,
	"./history.svg": 476,
	"./home-alt.svg": 477,
	"./home-alt2.svg": 478,
	"./home.svg": 479,
	"./horn.svg": 480,
	"./hourglass.svg": 481,
	"./image.svg": 482,
	"./inbox-alt.svg": 483,
	"./inbox.svg": 484,
	"./info.svg": 485,
	"./iphone.svg": 486,
	"./justify.svg": 487,
	"./key.svg": 488,
	"./language.svg": 489,
	"./laptop.svg": 490,
	"./layers.svg": 491,
	"./layout-left.svg": 492,
	"./layout-right.svg": 493,
	"./lightbulb.svg": 494,
	"./line-chart.svg": 495,
	"./link.svg": 496,
	"./list-alt.svg": 497,
	"./list-view.svg": 498,
	"./list.svg": 499,
	"./location.svg": 500,
	"./lock-alt-open.svg": 501,
	"./lock-alt.svg": 502,
	"./lock-open.svg": 503,
	"./lock.svg": 504,
	"./map.svg": 505,
	"./marker.svg": 506,
	"./mask.svg": 507,
	"./maximise.svg": 508,
	"./microphone.svg": 509,
	"./minimise.svg": 510,
	"./minus.svg": 511,
	"./moon.svg": 512,
	"./mouse.svg": 513,
	"./music.svg": 514,
	"./mute.svg": 515,
	"./neutral-face.svg": 516,
	"./new.svg": 517,
	"./news.svg": 518,
	"./next-alt.svg": 519,
	"./next.svg": 520,
	"./night-mode.svg": 521,
	"./no-entry.svg": 522,
	"./not-allowed.svg": 523,
	"./notebook.svg": 524,
	"./octagon.svg": 525,
	"./ok-circle.svg": 526,
	"./ok.svg": 527,
	"./origin.svg": 528,
	"./pan.svg": 529,
	"./paperclip.svg": 530,
	"./pause-circle.svg": 531,
	"./pause.svg": 532,
	"./pen.svg": 533,
	"./people.svg": 534,
	"./person-add.svg": 535,
	"./person.svg": 536,
	"./phone.svg": 537,
	"./pie-chart.svg": 538,
	"./pizza.svg": 539,
	"./placeholder.svg": 540,
	"./plane.svg": 541,
	"./play.svg": 542,
	"./plus.svg": 543,
	"./poll.svg": 544,
	"./power.svg": 545,
	"./presentation.svg": 546,
	"./previous-alt.svg": 547,
	"./previous.svg": 548,
	"./print.svg": 549,
	"./qr.svg": 550,
	"./radio-button-selected.svg": 551,
	"./radio-button.svg": 552,
	"./radio.svg": 553,
	"./rain.svg": 554,
	"./rectangle.svg": 555,
	"./redo.svg": 556,
	"./refresh.svg": 557,
	"./remove.svg": 558,
	"./repeat.svg": 559,
	"./restaurant.svg": 560,
	"./return.svg": 561,
	"./retweet.svg": 562,
	"./rocket.svg": 563,
	"./rotate.svg": 564,
	"./rss.svg": 565,
	"./sad-face.svg": 566,
	"./save.svg": 567,
	"./search.svg": 568,
	"./send.svg": 569,
	"./settings.svg": 570,
	"./share-android.svg": 571,
	"./share-ios.svg": 572,
	"./share.svg": 573,
	"./shield.svg": 574,
	"./shift.svg": 575,
	"./shuffle.svg": 576,
	"./sign-language.svg": 577,
	"./signal-alt.svg": 578,
	"./signal.svg": 579,
	"./skull.svg": 580,
	"./smartphone.svg": 581,
	"./snow.svg": 582,
	"./sort-down.svg": 583,
	"./sort-up.svg": 584,
	"./sorting.svg": 585,
	"./sounds.svg": 586,
	"./spam.svg": 587,
	"./stack.svg": 588,
	"./star.svg": 589,
	"./stats-alt.svg": 590,
	"./stats.svg": 591,
	"./sticker.svg": 592,
	"./stop.svg": 593,
	"./stopwatch.svg": 594,
	"./suitcase-alt.svg": 595,
	"./suitcase.svg": 596,
	"./sun-cloud.svg": 597,
	"./sun.svg": 598,
	"./sunset.svg": 599,
	"./support-alt.svg": 600,
	"./support.svg": 601,
	"./swap-horizontal.svg": 602,
	"./swap-vertical.svg": 603,
	"./switch-off.svg": 604,
	"./switch-on.svg": 605,
	"./table-horizontal.svg": 606,
	"./table-vertical.svg": 607,
	"./tag-alt.svg": 608,
	"./tag.svg": 609,
	"./text.svg": 610,
	"./thermometer.svg": 611,
	"./thumb-down.svg": 612,
	"./thumb-up.svg": 613,
	"./thunder.svg": 614,
	"./time.svg": 615,
	"./timer.svg": 616,
	"./tool.svg": 617,
	"./train.svg": 618,
	"./transport.svg": 619,
	"./trending-down.svg": 620,
	"./trending-up.svg": 621,
	"./turn-left.svg": 622,
	"./turn-right.svg": 623,
	"./tv.svg": 624,
	"./typography.svg": 625,
	"./umbrella.svg": 626,
	"./undo.svg": 627,
	"./upload.svg": 628,
	"./user.svg": 629,
	"./verified.svg": 630,
	"./vertical.svg": 631,
	"./video.svg": 632,
	"./voicemail.svg": 633,
	"./volume-loud.svg": 634,
	"./volume-off.svg": 635,
	"./volume-quiet.svg": 636,
	"./walking.svg": 637,
	"./wallpaper.svg": 638,
	"./watch.svg": 639,
	"./wheelchair.svg": 640,
	"./wifi.svg": 641,
	"./window.svg": 642,
	"./wine.svg": 643,
	"./zoom-in.svg": 644,
	"./zoom-out.svg": 645
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 318;

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"accessibilityHumanIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"3\" r=\"1\"/><path d=\"M16 21l-4-8m0 0V7m0 6l-4 8m4-14l6 2m-6-2L6 9\"/></svg>");

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"accessibilityIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M2 16l.8-2M6 16l-.8-2m0 0L4 11l-1.2 3m2.4 0H2.8M20 13l2-3m-2 3l-2-3m2 3v3M8 12l2-2v6m3-4l2-2v6\"/></svg>");

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"activityIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 14h-3l-3-7-5 10-3-6-2 3H3\"/></svg>");

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"addToListIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M6 10h12M6 6h12M6 14h4m4 2h4m-2-2v4M6 18h4\"/></svg>");

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"addIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 12H7m5 5V7\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"alarmIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"13\" r=\"9\"/><path d=\"M12 8v5l3 3m4-14l3 3M2 5l3-3\"/></svg>");

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"alignCenterIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 10h8M6 6h12M6 14h12M8 18h8\"/></svg>");

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"alignLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 10h8M6 6h12M6 14h12M6 18h8\"/></svg>");

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"alignRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10 10h8M6 6h12M6 14h12m-8 4h8\"/></svg>");

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"anchorIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 20V7m-3 3h6\"/><circle cx=\"12\" cy=\"5\" r=\"2\"/><path d=\"M20 14c-1.333 4-4 6-8 6s-6.667-2-8-6\"/></svg>");

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"apertureIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\"/><path d=\"M3 16h11.316M4.036 6.206l5.647 9.78m3.353-13.78l-5.657 9.798m3.585 9.79l5.65-9.787m3.35 5.787L14.31 8M21 7.987H9.718\" stroke-linecap=\"round\"/></svg>");

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"appsAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 5h2v2H5zm6 0h2v2h-2zm6 0h2v2h-2zM5 11h2v2H5zm6 0h2v2h-2zm6 0h2v2h-2zM5 17h2v2H5zm6 0h2v2h-2zm6 0h2v2h-2z\"/></svg>");

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"appsIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"6\" cy=\"6\" r=\"1\"/><circle cx=\"12\" cy=\"6\" r=\"1\"/><circle cx=\"18\" cy=\"6\" r=\"1\"/><circle cx=\"6\" cy=\"12\" r=\"1\"/><circle cx=\"12\" cy=\"12\" r=\"1\"/><circle cx=\"18\" cy=\"12\" r=\"1\"/><circle cx=\"6\" cy=\"18\" r=\"1\"/><circle cx=\"12\" cy=\"18\" r=\"1\"/><circle cx=\"18\" cy=\"18\" r=\"1\"/></svg>");

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"circleArrowDownIconTitle\" fill=\"none\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M15 13.5l-3 3-3-3m3 1.5V7.5\"/><path stroke-linecap=\"round\" d=\"M12 16.5V15v1.5z\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"arrowDownIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 15l6 6 6-6M12 3v17\"/><path stroke-linecap=\"round\" d=\"M12 21v-1\"/></svg>");

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"arrowLeftBottomIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 11v8h8\"/><path stroke-linecap=\"round\" d=\"M5 19l1-1\"/><path d=\"M6 18L19 5\"/></svg>");

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"circleArrowLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10.5 15l-3-3 3-3m6 3H9\"/><path stroke-linecap=\"round\" d=\"M7.5 12H9\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"arrowLeftTopIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 13V5h8\"/><path stroke-linecap=\"round\" d=\"M5 5l1 1\"/><path d=\"M6 6l13 13\"/></svg>");

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"arrowLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M9 6l-6 6 6 6m12-6H4\"/><path stroke-linecap=\"round\" d=\"M3 12h1\"/></svg>");

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"arrowRightBottomIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M19 11v8h-8\"/><path stroke-linecap=\"round\" d=\"M19 19l-1-1\"/><path d=\"M18 18L5 5\"/></svg>");

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"circleArrowRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M13.5 9l3 3-3 3m-6-3H15\"/><path stroke-linecap=\"round\" d=\"M16.5 12H15\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"arrowRightTopIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M19 13V5h-8\"/><path stroke-linecap=\"round\" d=\"M19 5l-1 1\"/><path d=\"M18 6L5 19\"/></svg>");

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"arrowRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M15 18l6-6-6-6M3 12h17\"/><path stroke-linecap=\"round\" d=\"M21 12h-1\"/></svg>");

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"arrowUpIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M9 10.5l3-3 3 3m-3 6V9\"/><path stroke-linecap=\"round\" d=\"M12 7.5V9\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"arrowUpIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18 9l-6-6-6 6m6 12V4\"/><path stroke-linecap=\"round\" d=\"M12 3v1\"/></svg>");

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"backAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M4 12l15-9v18z\"/></svg>");

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"backLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 17v-2c0-4.97 3.806-9 8.5-9s8.5 4.03 8.5 9\"/><path d=\"M8 15l-3 3-3-3\"/></svg>");

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"backRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M19 17v-2c0-4.97-3.806-9-8.5-9S2 10.03 2 15\"/><path d=\"M16 15l3 3 3-3\"/></svg>");

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"backIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M14 14.74L21 19V5l-7 4.26V5L2 12l12 7v-4.26z\"/></svg>");

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"bagIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 7h14v12H5zm3 0a4 4 0 118 0\"/></svg>");

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"basketIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M14 4l6 6-1.372 9H5.372L4 10l6-6\"/><path stroke-linecap=\"round\" d=\"M4 10h16\"/></svg>");

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"basketballIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><g stroke-linecap=\"butt\"><path d=\"M3.005 7.717c3.033-.901 6.993.031 10.24 2.715 3.298 2.725 4.96 6.512 4.58 9.692\"/><path d=\"M10.102 21.8c-.763-2.441-.091-6.186 1.976-9.767 2.06-3.569 4.957-6.019 7.447-6.588M11.442 2c-.18 1.944-.926 4.23-2.217 6.465-1.933 3.35-4.577 5.697-6.824 6.32\"/></g><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"batteryAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M14 3h-4M6 4v17h12V4z\"/></svg>");

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"batteryChargingIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 14v-4m-1-4H4v12h16z\"/><path d=\"M12 9l2 3h-4l2 3\"/></svg>");

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"batteryFullIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 14v-4m-1-4H4v12h16zm-8 8v-4m4 4v-4m-8 4v-4\"/></svg>");

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"batteryLowIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 14v-4m-1-4H4v12h16zM8 14v-4\"/></svg>");

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"batteryMediumIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 14v-4m-1-4H4v12h16zm-8 8v-4m-4 4v-4\"/></svg>");

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"batteryIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 14v-4m-1-4H4v12h16z\"/></svg>");

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"bellIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linejoin=\"round\" d=\"M18 9v5c0 2 .667 3.333 2 4H4c1.333-.667 2-2 2-4V9h0a6 6 0 016-6h0a6 6 0 016 6z\"/><path d=\"M10 18a2 2 0 104 0\"/></svg>");

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"bikeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><circle cx=\"14\" cy=\"6\" r=\"1\"/><path d=\"M12 18v-4l-3-2 3-3 2 2 2 1\"/><circle cx=\"6\" cy=\"17\" r=\"3\"/><circle cx=\"18\" cy=\"17\" r=\"3\"/></svg>");

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"binIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M19 6H5m9-1h-4m-4 5v10c0 .667.333 1 1 1h10c.667 0 1-.333 1-1V10\"/></svg>");

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"bluetoothIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7 17L17 7l-5-5v20l5-5L7 7\"/></svg>");

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"boltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 14l8-11v7h5l-8 11v-7z\"/></svg>");

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"bookOpenedIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 6s-2-2-4-2-5 2-5 2v14s3-2 5-2 4 2 4 2c1.333-1.333 2.667-2 4-2 1.333 0 3 .667 5 2V6c-2-1.333-3.667-2-5-2-1.333 0-2.667.667-4 2z\"/><path stroke-linecap=\"round\" d=\"M12 6v14\"/></svg>");

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"bookIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M19 3v18H8a3 3 0 01-3-3V6a3 3 0 013-3h11z\"/><path d=\"M5 18a3 3 0 013-3h11\"/></svg>");

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"bookmarkIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 6.659v12.927l-5-3.178-5 3.178V6.659C7 5.19 8.12 4 9.5 4h5C15.88 4 17 5.19 17 6.659z\"/></svg>");

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"boxAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M5 9h14v11H5zM4 9h16V5H4z\"/><path d=\"M9 12h6v3H9z\"/></svg>");

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"boxAlt2IconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M5 9h14v11H5zM4 9h16V5H4z\"/></svg>");

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"boxIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 2l9 5v10l-9 5-9-5V7z\"/><path stroke-linecap=\"round\" d=\"M3 7l9 5 9-5m-9 5v10\"/></svg>");

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"brightnessIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M15 6l-3-3-3 3H6v3l-3 3 3 3v3h3l3 3 3-3h3v-3l3-3-3-3V6h-3z\"/><path d=\"M16 12a4 4 0 00-4-4v8a4 4 0 004-4z\"/></svg>");

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"bugIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M15 7a2 2 0 012 2v7.459a2 2 0 01-.853 1.638L12 21l-4.147-2.903A2 2 0 017 16.46V9a2 2 0 012-2 3 3 0 016 0zM4 13h3M3 7l2 2h2m14-2l-2 2h-2M3 19l2-2h2m10 0h2l2 2h0m-4-6h3\"/></svg>");

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"calendarAddIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 5h18v16H3V5zm18 4H3m4-4V3m10 2V3m-2 12H9m3-3v6\"/></svg>");

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"calendarDeclineIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 5h18v16H3V5zm18 4H3m4-4V3m10 2V3m-2 15l-6-6m6 0l-6 6\"/></svg>");

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"calendarEventIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 5h18v16H3V5zm18 4H3m4-4V3m10 2V3\"/><path d=\"M15 15h2v2h-2z\"/></svg>");

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"calendarIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 5h18v16H3V5zm18 4H3m4-4V3m10 2V3\"/></svg>");

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cameraRearIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 12l2-2 2 2m-2 1a4 4 0 004 4m4-4a4 4 0 00-4-4\"/><path stroke-linecap=\"butt\" d=\"M8 12v1m0-3v3m8 0v3\"/><path d=\"M18 14l-2 2-2-2\"/><path d=\"M8 7l.74-1.11A2 2 0 0110.404 5h3.192a2 2 0 011.664.89L16 7h5v13H3V7h5z\"/></svg>");

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cameraIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 7l.74-1.11A2 2 0 0110.404 5h3.192a2 2 0 011.664.89L16 7h5v11H3V7h5z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/></svg>");

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cancelIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M15.536 15.536L8.464 8.464m7.072 0l-7.072 7.072m-3.535 3.535c-3.905-3.905-3.905-10.237 0-14.142 3.905-3.905 10.237-3.905 14.142 0 3.905 3.905 3.905 10.237 0 14.142-3.905 3.905-10.237 3.905-14.142 0z\"/></svg>");

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"carAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M3 12l2-5h2m-4 5H2v5h1m0-5h4m11 0l-2-5h-4m6 5h2a2 2 0 012 2v3h-2m-2-5h-6m-5 5h9M7 7v5m0-5h5m-5 5h5m0 0V7\"/><circle cx=\"5\" cy=\"17\" r=\"2\"/><circle cx=\"18\" cy=\"17\" r=\"2\"/></svg>");

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"carIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M5 11l2-6h10l2 6M5 11h14M5 11v6m14-6v6M5 17v2h1v-2m-1 0h1m13 0v2h-1v-2m1 0h-1M6 17h12\"/><circle cx=\"8\" cy=\"14\" r=\"1\"/><circle cx=\"16\" cy=\"14\" r=\"1\"/></svg>");

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cardsIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 3h13v13H3z\"/><path d=\"M16 8h5v13H8v-5\"/></svg>");

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"cartAddIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21.292 6l-1.346 8.163a1 1 0 01-.986.837H7.043a1 1 0 01-.987-.837L4.85 6.837A1 1 0 003.862 6H2m6 14a1 1 0 100-2 1 1 0 000 2zm10 0a1 1 0 100-2 1 1 0 000 2zM16 8h-6m3-3v6\"/></svg>");

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cartIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 6h15l-1.5 9h-12z\"/><circle cx=\"9\" cy=\"19\" r=\"1\"/><circle cx=\"18\" cy=\"19\" r=\"1\"/><path d=\"M6 6H3\"/></svg>");

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"celluarIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18 7v11m-4-8v8m-4-5v5m-4-2v2\"/></svg>");

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chartIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M2 12v9h4v-9zm16-5v14h4V7zm-8-4v18h4V3z\"/></svg>");

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"chatAddIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 4v13h-8l-6 4v-4H3V4h18zm-6 6H9m3-3v6\"/></svg>");

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chatAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M13 17l-6 4v-4H3V4h18v13h-8z\"/></svg>");

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"chatRemoveIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M15 10H9m12-6v13h-8l-6 4v-4H3V4h18z\"/></svg>");

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"chatWarningIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 7v4m9-7v13h-8l-6 4v-4H3V4h18zm-9 10h0\"/></svg>");

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chatIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8.824 18.588L4 21l.653-4.573C3.006 15.001 2 13.095 2 11c0-4.418 4.477-8 10-8s10 3.582 10 8-4.477 8-10 8c-1.11 0-2.178-.145-3.176-.412z\"/></svg>");

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"checkboxIntermediateIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><rect x=\"21\" y=\"3\" width=\"18\" height=\"18\" rx=\"1\" transform=\"rotate(90 21 3)\"/><path d=\"M16 12H8\"/></svg>");

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"checkboxIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><rect x=\"21\" y=\"3\" width=\"18\" height=\"18\" rx=\"1\" transform=\"rotate(90 21 3)\"/><path d=\"M6.667 12.667L10 16l7.333-7.333\"/></svg>");

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chevronDownIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 10l6 6 6-6\"/></svg>");

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chevronLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M14 18l-6-6 6-6h0\"/></svg>");

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chevronRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10 6l6 6-6 6h0\"/></svg>");

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chevronUpIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 14l6-6 6 6h0\"/></svg>");

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chevronsDownIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7 13l5 5 5-5M7 7l5 5 5-5\"/></svg>");

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chevronsLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M11 17l-5-5 5-5h0m6 10l-5-5 5-5h0\"/></svg>");

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chevronsRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M13 7l5 5-5 5h0M7 7l5 5-5 5h0\"/></svg>");

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"chevronsUpIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7 11l5-5 5 5h0M7 17l5-5 5 5h0\"/></svg>");

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"circleIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"12\" r=\"8\"/></svg>");

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"clipIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7.935 13.78l7.227-7.227a2.253 2.253 0 013.181 0 2.253 2.253 0 010 3.182l-9.942 9.813a3.748 3.748 0 01-5.302 0 3.748 3.748 0 010-5.303l9.835-9.707a5.248 5.248 0 017.423 0 5.248 5.248 0 01.001 7.424l-7.119 7.12\"/></svg>");

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"clipboardIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M15 3h4v18H5V3h4\"/><path d=\"M14 4h-4a1 1 0 110-2h4a1 1 0 010 2z\"/></svg>");

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"closeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6.343 6.343l11.314 11.314m-11.314 0L17.657 6.343\"/></svg>");

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"cloudCrossedIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M13 6a6.002 6.002 0 015.921 5.025A3.5 3.5 0 0118.5 18h-12a4.5 4.5 0 111.21-8.835A5.999 5.999 0 0113 6zM3 21L20 4\"/></svg>");

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cloudUploadIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6.5 18a4.5 4.5 0 111.21-8.835 6.002 6.002 0 0111.21 1.86A3.5 3.5 0 0118.5 18h-12zm5.5-7v4\"/><path d=\"M10 12l2-2 2 2h0\"/></svg>");

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cloudIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6.5 18a4.5 4.5 0 111.21-8.835 6.002 6.002 0 0111.21 1.86A3.5 3.5 0 0118.5 18h-12z\"/></svg>");

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"codeAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M7 8l-4 4 4 4m10 0l4-4-4-4M9 19.5L14.5 5\"/></svg>");

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"codeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M7 8l-4 4 4 4m10 0l4-4-4-4\"/></svg>");

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"coffeeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M5 12h12v5a5 5 0 01-5 5h-2a5 5 0 01-5-5v-5zm12 1h2a2 2 0 012 2v0a2 2 0 01-2 2h-2M9 9s-1-.5-1-2 1-2 1-2m3-2s1 .5 1 2-1 2-1 2\"/></svg>");

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"coloursIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"9\" r=\"5\"/><circle cx=\"9\" cy=\"14\" r=\"5\"/><circle cx=\"15\" cy=\"14\" r=\"5\"/></svg>");

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 34 34\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"componentIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 8.515l2.828 2.828L17 14.172l-2.829-2.829z\"/><path clip-rule=\"evenodd\" d=\"M21.95 13.464l2.828 2.829-2.828 2.828-2.829-2.828 2.829-2.829z\"/><path d=\"M12.05 13.464l2.829 2.828-2.829 2.829-2.828-2.829zm4.95 4.95l2.829 2.828L17 24.071l-2.828-2.829z\"/></svg>");

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"contactBookIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 3v18M20 3v18H6a2 2 0 01-2-2V5a2 2 0 012-2h14z\"/><path d=\"M8 17c0-2 3.333-1.667 4.667-3 .666-.667-1.334-.667-1.334-4 0-2.222.889-3.333 2.667-3.333 1.778 0 2.667 1.111 2.667 3.333 0 3.333-2 3.333-1.334 4C16.667 15.333 20 15 20 17\"/></svg>");

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"contrastIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 3v18H3V3z\"/><path d=\"M21 3L3 21M16 3L3 16m8-13l-8 8m3-8L3 6\" stroke-linecap=\"round\"/></svg>");

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"controlCentreIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M4 6.5A3.5 3.5 0 017.5 3h9A3.5 3.5 0 0120 6.5v0a3.5 3.5 0 01-3.5 3.5h-9A3.5 3.5 0 014 6.5v0zm16 11a3.5 3.5 0 01-3.5 3.5h-9A3.5 3.5 0 014 17.5v0A3.5 3.5 0 017.5 14h9a3.5 3.5 0 013.5 3.5v0z\"/><circle cx=\"16.5\" cy=\"17.5\" r=\"1\"/><circle cx=\"7.5\" cy=\"6.5\" r=\"1\"/></svg>");

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"controlsAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><circle cx=\"9\" cy=\"6\" r=\"2\"/><path d=\"M4 6h3m4 0h9\"/><circle cx=\"9\" cy=\"18\" r=\"2\"/><path d=\"M4 18h3m4 0h9\"/><circle cx=\"15\" cy=\"12\" r=\"2\"/><path d=\"M4 12h9m4 0h3\"/></svg>");

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"controlsVerticalAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><circle cx=\"18\" cy=\"9\" r=\"2\" transform=\"rotate(90 18 9)\"/><path d=\"M18 4v3m0 4v9\"/><circle cx=\"6\" cy=\"9\" r=\"2\" transform=\"rotate(90 6 9)\"/><path d=\"M6 4v3m0 4v9\"/><circle cx=\"12\" cy=\"15\" r=\"2\" transform=\"rotate(90 12 15)\"/><path d=\"M12 4v9m0 4v3\"/></svg>");

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"controlsIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 18V6m-5 12V6M7 18V6M5 8h4m1 8h4m1-4h4\"/></svg>");

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"copyIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 7h12v14H8z\"/><path d=\"M16 3H4v14\"/></svg>");

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"creditCardIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><rect width=\"20\" height=\"14\" x=\"2\" y=\"5\" rx=\"2\"/><path d=\"M2 14h20\"/></svg>");

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cropIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 3v14H3\"/><path d=\"M7 21V7h14\"/></svg>");

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"crossingIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5.715 20.387l8.737-10.89A4 4 0 0117.572 8H21v0\"/><path d=\"M18 4l4 4-4 4M3 8h3.428a4 4 0 013.12 1.497l8.737 10.89\"/><path d=\"M6 12L2 8l4-4\"/></svg>");

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cupIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 2h12v9a6 6 0 11-12 0V2zm1 19h10m-5-4v4M6 5v6H5a3 3 0 110-6h1zm12 6V5h1a3 3 0 010 6h-1z\"/></svg>");

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cursorIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7 20V4l12 12h-7l-5 5z\"/></svg>");

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"cutIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 18l12-9m0 6L3 6\"/><circle cx=\"18\" cy=\"7\" r=\"3\"/><circle cx=\"18\" cy=\"17\" r=\"3\"/></svg>");

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"dangerIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 10v3m0 3h0m.862-11.535l8.252 14.028A1 1 0 0120.252 20H3.748a1 1 0 01-.862-1.507l8.252-14.028a1 1 0 011.724 0z\"/></svg>");

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"dashboardIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M2 2h20v20H2zm9 5h6m-6 5h6m-6 5h6M7 7h0m0 5h0m0 5h0\"/></svg>");

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"deleteIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M20 18H9l-6-6 6-6h11zm-7.886-7.886l3.772 3.772m-3.772 0l3.772-3.772\"/></svg>");

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"dialpadIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"7\" cy=\"5\" r=\"1\"/><circle cx=\"12\" cy=\"5\" r=\"1\"/><circle cx=\"17\" cy=\"5\" r=\"1\"/><circle cx=\"7\" cy=\"10\" r=\"1\"/><circle cx=\"12\" cy=\"10\" r=\"1\"/><circle cx=\"17\" cy=\"10\" r=\"1\"/><circle cx=\"7\" cy=\"15\" r=\"1\"/><circle cx=\"12\" cy=\"15\" r=\"1\"/><circle cx=\"12\" cy=\"20\" r=\"1\"/><circle cx=\"17\" cy=\"15\" r=\"1\"/></svg>");

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"diamondIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M12 20l-9-9m9 9l9-9m-9 9l-4-9m4 9l4-9M3 11l4-6m-4 6h5M7 5l1 6M7 5h5m5 0l4 6m-4-6l-1 6m1-6h-5m9 6h-5m-8 0h8m-8 0l4-6m4 6l-4-6\"/></svg>");

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"directionLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 7h7.167S19 7 19 12.833V21\"/><path d=\"M9 11L5 7l4-4\"/></svg>");

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"directionRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18 7h-7.167S5 7 5 12.833V21\"/><path d=\"M15 11l4-4-4-4\"/></svg>");

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"directionsLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M9 11h3s2 0 2 2.2V15\"/><path d=\"M11 13l-2-2 2-2\"/><path d=\"M12 2l10 10-10 10L2 12z\"/></svg>");

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"directionsRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M15 11h-3s-2 0-2 2.2V15\"/><path d=\"M13 13l2-2-2-2\"/><path d=\"M12 2L2 12l10 10 10-10z\"/></svg>");

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"discIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><circle cx=\"12\" cy=\"12\" r=\"4\"/></svg>");

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"dolarIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 4v2m0 12v2m3.5-12C15.167 6.667 14 6 12 6 9 6 8.5 7.957 8.5 9c0 4.14 7 1.965 7 6 0 1.043-.5 3-3.5 3-2 0-3.167-.667-3.5-2\"/></svg>");

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"downloadIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 3v13m-5-4l5 5 5-5m3 9H4\"/></svg>");

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"dropIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 21c3.314 0 6-2.61 6-6 0-3.333-2-7-6-11-4 4-6 7.667-6 11 0 3.39 2.686 6 6 6z\"/></svg>");

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"earIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 10a7 7 0 0114 0c0 2.872-1.796 5.08-3.5 7-1.433 1.614-2 5-5.5 5a4.978 4.978 0 01-3-1m2-11a3 3 0 115.236 2\"/></svg>");

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"editIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18.414 4.414l1.172 1.172a2 2 0 010 2.828L8 20H4v-4L15.586 4.414a2 2 0 012.828 0zM14 6l4 4\"/></svg>");

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"ellypsisVerticalIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M11 12a1 1 0 112 0 1 1 0 01-2 0zm0-6a1 1 0 112 0 1 1 0 01-2 0zm0 12a1 1 0 112 0 1 1 0 01-2 0z\"/></svg>");

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"ellypsisIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"12\" r=\"1\"/><circle cx=\"6\" cy=\"12\" r=\"1\"/><circle cx=\"18\" cy=\"12\" r=\"1\"/></svg>");

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"entranceIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M11 15l3-3-3-3m-6.5 3H13\"/><path stroke-linecap=\"round\" d=\"M14 12h-1\"/><path d=\"M18 4v16H7V4z\"/></svg>");

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"envelopeAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M2 5h20v14H2z\"/><path stroke-linecap=\"round\" d=\"M2 5l10 9 10-9\"/></svg>");

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"envelopeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M2 5h20v14H2z\"/><path stroke-linecap=\"round\" d=\"M2 5l10 9 10-9M2 19l6.825-7.8M22 19l-6.844-7.822\"/></svg>");

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"errorIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 8v5m0 3h0\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"exitIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18 15l3-3-3-3m-6.5 3H20\"/><path stroke-linecap=\"round\" d=\"M21 12h-1\"/><path d=\"M15 4v16H4V4z\"/></svg>");

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"exploreIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M14.121 14.121L7.05 16.95l2.829-7.071L16.95 7.05z\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"extensionIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M9 4a2 2 0 114 0v2h5v5h2a2 2 0 110 4h-2v5h-5v-2a2 2 0 10-4 0v2H4v-5h2a2 2 0 100-4H4V6h5V4z\"/></svg>");

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"eyeClosedIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M20 9s-.32.667-1 1.514M12 14a8.478 8.478 0 01-4.051-1M12 14a8.478 8.478 0 004.051-1M12 14v3.5M4 9s.354.737 1.106 1.645M7.95 13L5 16m2.949-3c-1.26-.673-2.198-1.577-2.843-2.355M16.051 13l2.449 3m-2.449-3c1.33-.711 2.303-1.68 2.949-2.486m-13.894.13L2 12m17-1.486L22 12\"/></svg>");

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"eyeCrossedIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M22 12s-3 6-10 6-10-6-10-6 3-6 10-6 10 6 10 6z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/><path d=\"M3 21L20 4\"/></svg>");

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"eyeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M22 12s-3 6-10 6-10-6-10-6 3-6 10-6 10 6 10 6z\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/></svg>");

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"favouriteIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 21l-1.45-1.295C5.4 15.125 2 12.103 2 8.395 2 5.374 4.42 3 7.5 3c1.74 0 3.41.795 4.5 2.05A6.037 6.037 0 0116.5 3C19.58 3 22 5.374 22 8.395c0 3.708-3.4 6.73-8.55 11.32L12 21z\"/></svg>");

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"featherIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M5.126 17A15.84 15.84 0 005 19v2m.126-4C6.034 9.869 11.76 4 20 4l-1 4h-3l1 2-2 2h-4l2 2-1 2H8l-2.874 1z\"/></svg>");

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"feedIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"7.5\" cy=\"7.5\" r=\"2.5\"/><path d=\"M22 13H2m16-7h-5m5 3h-5M5 2h14a3 3 0 013 3v17H2V5a3 3 0 013-3z\"/></svg>");

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"fileIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M13 3v6h6\"/><path d=\"M13 3l6 6v12H5V3z\"/></svg>");

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"filmIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M16 10.087l5-1.578v7.997l-4.998-1.578\"/><path d=\"M16 7H3v11h13z\"/></svg>");

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"filterIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10 12.261L4.028 3.972h16L14 12.329V17l-4 3z\"/></svg>");

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"fitIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M6 7v12M18 7v12m3-10v8M3 9v8m3-4h12\"/></svg>");

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"flagIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 20v-5c1.333-1.333 3-2 5-2 3 0 4 2 6 2 1 0 2-.333 3-1V5c-1 .667-2 1-3 1-2 0-3-2-6-2-2 0-3.667.667-5 2v9\"/></svg>");

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"flowerIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M12 22a3 3 0 002.992-2.777 3 3 0 004.23-4.231 3 3 0 00.001-5.984 3 3 0 00-4.231-4.23 3 3 0 00-5.984-.001 3 3 0 00-4.23 4.231 3 3 0 00-.001 5.984 3 3 0 004.231 4.23A3 3 0 0012 22z\"/><path d=\"M12 14a2 2 0 110-4 2 2 0 010 4z\"/></svg>");

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"folderAddIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 5h6l1 2h11v12H3V5zm12 8H9m3-3v6\"/></svg>");

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"folderRemoveIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 5h6l1 2h11v12H3V5zm12 8H9\"/></svg>");

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"folderWarningIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 10v3M3 5h6l1 2h11v12H3V5zm9 11h0\"/></svg>");

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"folderIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 5h6l1 2h11v12H3z\"/></svg>");

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"forwardIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10 14.74L3 19V5l7 4.26V5l12 7-12 7v-4.26z\"/></svg>");

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"glassesIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M14 12c-.597-.667-1.264-1-2-1s-1.403.333-2 1\"/><path d=\"M20 12h2M2 12h2\"/><circle cx=\"7\" cy=\"12\" r=\"3\"/><circle cx=\"17\" cy=\"12\" r=\"3\"/></svg>");

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"gridIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7 3v18M17 3v18m4-4H3M21 7H3\"/></svg>");

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"gridSmallIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 6h4v4H6zm7 0h4v4h-4zm-7 7h4v4H6zm7 0h4v4h-4z\"/></svg>");

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"gridLargeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 3h7v7H3zm11 0h7v7h-7zM3 14h7v7H3zm11 0h7v7h-7z\"/></svg>");

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"hamburgerIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 7h12M6 12h12M6 17h12\"/></svg>");

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"happyFaceIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7.301 14.001C8.073 15.758 9.988 17 12 17c2.002 0 3.913-1.245 4.693-2.994\"/><path stroke-linecap=\"round\" d=\"M9 9h0m6 0h0\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"hashIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M11 3L5 21M19 3l-6 18M3 16h16M5 8h16\"/></svg>");

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"hdrIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18 12h1l2 3\"/><path d=\"M7 9v6m3-6v6h2c1.333 0 2-1 2-3s-.667-3-2-3h-2zm7 6V9h3c.667 0 1 .5 1 1.5s-.333 1.5-1 1.5h-3M7 12H3m0-3v6\"/></svg>");

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"headphonesIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M21 13h-2a2 2 0 00-2 2v2a2 2 0 002 2h0a2 2 0 002-2v-4a9 9 0 00-18 0v4a2 2 0 002 2h0a2 2 0 002-2v-2a2 2 0 00-2-2H3\"/></svg>");

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"hearingDisabilityIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 11.263a6.263 6.263 0 1112.526 0c0 2.57-1.606 4.546-3.131 6.263C14.112 18.971 13.605 22 10.474 22a4.454 4.454 0 01-2.685-.895m1.79-9.842a2.684 2.684 0 114.685 1.79M3 21L21 3\"/></svg>");

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"helpIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 14c0-2 1.576-2.335 2.119-2.876a3 3 0 10-4.952-3.113M12 17h0\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"historyIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M1 12l2 2 2-2m7-5v5l3 3\"/><path d=\"M12 21a9 9 0 10-9-9v1\"/></svg>");

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"homeAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 10.182V22h18V10.182L12 2z\"/><path d=\"M9 14h6v8H9z\"/></svg>");

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"homeAlt2IconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M2 12l3-2.7M22 12l-3-2.7m0 0L12 3 5 9.3m14 0V21H5V9.3\"/></svg>");

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"homeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 10.182V22h18V10.182L12 2z\"/></svg>");

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"hornIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linejoin=\"round\" d=\"M6.5 9H12c2 0 4.333-1.667 7-5v15c-2.667-3.333-5-5-7-5H6.5h0A2.5 2.5 0 014 11.5h0A2.5 2.5 0 016.5 9z\"/><path d=\"M7 14l2 6h4l-2-6zm4-5v5\"/></svg>");

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"hourglassIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16.765 7.821V5a2 2 0 00-2-2h-5.53a2 2 0 00-2 2v2.821L11.415 12l-4.18 4.179V19a2 2 0 002 2h5.53a2 2 0 002-2v-2.821L12.585 12l4.18-4.179z\"/></svg>");

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"imageIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 3h18v18H3z\"/><path stroke-linecap=\"round\" d=\"M3 14l4-4 11 11\"/><circle cx=\"13.5\" cy=\"7.5\" r=\"2.5\"/><path stroke-linecap=\"round\" d=\"M13.5 16.5L21 9\"/></svg>");

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"inboxAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 13h6v3h6v-3h6\"/><path clip-rule=\"evenodd\" d=\"M3 13l2-9h14l2 9v7H3v-7z\"/><path d=\"M7 7h10M6.5 10h11\"/></svg>");

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"inboxIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 10h6v3h6v-3h6\"/><path d=\"M3 10l3-6h12l3 6v10H3V10z\"/></svg>");

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"infoIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 12v3m0-6h0\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"iphoneIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18 3v18a1 1 0 01-1 1H7a1 1 0 01-1-1V3a1 1 0 011-1h10a1 1 0 011 1z\"/><path d=\"M14 2v1h-4V2z\"/></svg>");

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"justifyIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 10h12M6 6h12M6 14h12M6 18h12\"/></svg>");

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"keyIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 16v-4h-9\"/><circle cx=\"7\" cy=\"12\" r=\"4\"/><path d=\"M17 15v-3\"/></svg>");

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"languageIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path stroke-linecap=\"round\" d=\"M12 22c2.667-2.424 4-5.758 4-10s-1.333-7.576-4-10C9.333 4.424 8 7.758 8 12s1.333 7.576 4 10zM2.5 9h19m-19 6h19\"/></svg>");

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"laptopIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M20 7v11H4V7a1 1 0 011-1h14a1 1 0 011 1zM2 18h20M4 17h16\"/></svg>");

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"layersIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M12 4l8 4-8 4-8-4 8-4zm8 8l-8 4-8-4m16 4l-8 4-8-4\"/></svg>");

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"layoutLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 3h18v18H3zm0 5h18M9 8v13\"/></svg>");

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"layoutRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 3h18v18H3zm0 5h18M9 8v13\"/></svg>");

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"lightBulbIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16 12c-.667.667-1 2-1 4v1H9v-1c0-2-.333-3.333-1-4-2.326-2.326-2.586-5.9-.243-8.243a6 6 0 018.486 0C18.586 6.101 18.407 9.593 16 12zm-6 9h4\"/></svg>");

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"lineChartIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 16l5-5\"/><circle cx=\"9\" cy=\"10\" r=\"1\"/><circle cx=\"14\" cy=\"15\" r=\"1\"/><path d=\"M10 11l3 3m2 0l6-6\"/></svg>");

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"linkIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M9 7H7a5 5 0 000 10h2m-1-5h8m-1 5h2a5 5 0 000-10h-2\"/></svg>");

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"listAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 15h14M5 19h14M5 5h14v6H5z\"/></svg>");

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"listViewIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 5h14M5 19h14M5 9h14v6H5z\"/></svg>");

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"listIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10 7h8m-8 5h8m-8 5h8M7 7h0m0 5h0m0 5h0\"/></svg>");

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"locationIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 21c4-4.2 6-8.2 6-12A6 6 0 106 9c0 3.8 2 7.8 6 12z\"/><circle cx=\"12\" cy=\"9\" r=\"1\"/></svg>");

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"lockAltOpenIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7 7.625V7a5 5 0 015-5h0a5 5 0 015 5v4M5 11h14v10H5z\"/><circle cx=\"12\" cy=\"16\" r=\"1\"/></svg>");

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"lockAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 11h14v10H5zm7-8h0a5 5 0 015 5v3H7V8a5 5 0 015-5z\"/><circle cx=\"12\" cy=\"16\" r=\"1\"/></svg>");

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"lockOpenIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7 7.625V7a5 5 0 015-5h0a5 5 0 015 5v4M5 11h14v10H5z\"/></svg>");

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"lockIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 11h14v10H5zm7-8h0a5 5 0 015 5v3H7V8a5 5 0 015-5z\"/></svg>");

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"mapIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M9 19l-6 2V5l6-2 6 2 6-2v15.5L15 21z\"/><path stroke-linecap=\"round\" d=\"M15 5v16M9 3v16\"/></svg>");

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"markerIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path clip-rule=\"evenodd\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\"/><path d=\"M6 20l2-7h8l2 7m-8.5-7l1.53-6.12c.252-1.01 1.688-1.01 1.94 0L14.5 13\"/></svg>");

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"maskIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path clip-rule=\"evenodd\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\"/><path d=\"M8 2.832C11.532 4.375 14 7.9 14 12s-2.468 7.625-6 9.168\"/></svg>");

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"maximiseIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 16v5h-5m-8 0H3v-5M16 3h5v5M3 8V3h5\"/></svg>");

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"microphoneIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 12a5 5 0 01-10 0m5 5v4\"/><rect width=\"4\" height=\"10\" x=\"10\" y=\"4\" rx=\"2\"/></svg>");

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"minimiseIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 3v5H3m18 0h-5V3M3 16h5v5m8 0v-5h5\"/></svg>");

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"minusIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M20 12H4\"/></svg>");

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"moonIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10.424 3a8 8 0 0010.152 10.152A8 8 0 1110.424 3z\"/></svg>");

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"mouseIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M5 10h7m7 0h-7m0 0V2.5M5 9a7 7 0 017-7v0a7 7 0 017 7v6a7 7 0 01-7 7v0a7 7 0 01-7-7V9z\"/></svg>");

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"musicIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M8 18V6l12-3v13\"/><path d=\"M5.947 20.51c-1.468.535-2.946.175-3.302-.804-.356-.978.545-2.205 2.012-2.739 1.468-.534 2.947-.174 3.303.805.356.978-.545 2.204-2.013 2.738zm12-2c-1.468.535-2.946.175-3.302-.804-.356-.978.545-2.205 2.012-2.739 1.468-.534 2.947-.174 3.303.805.356.978-.545 2.204-2.013 2.738z\"/></svg>");

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"muteIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18 10l4 4m-4 0l4-4m-9-5v14l-5-4H3V9h5z\"/><path stroke-linecap=\"round\" d=\"M13 14c1.5-1 1.5-3 0-4\"/></svg>");

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"neutralFaceIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M9 9h0m6 0h0\"/><path d=\"M16 15H8\" opacity=\".9\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"newIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M19 14v8H3V4h10\"/><path d=\"M17.46 4.04a2 2 0 012.83 0l.67.67a2 2 0 010 2.83l-9.374 9.374a2 2 0 01-1.414.586H7.5v-2.672a2 2 0 01.586-1.414L17.46 4.04zm-1.21 1.21l3.5 3.5\"/></svg>");

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"newsIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M22 5v12c0 1.333-.667 2-2 2s-2-.667-2-2V5H2v11c0 2 1 3 3 3h15M6 14h1m4 0h3m-8-4h8\"/></svg>");

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"nextAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M16 4l4 4-4 4\"/><path d=\"M20 8H9.5A5.5 5.5 0 004 13.5v0A5.5 5.5 0 009.5 19H19\"/></svg>");

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"nextIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 11.5L6 18V5zm1 6.5V5\"/></svg>");

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"nightModeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 19a7 7 0 100-14 7 7 0 000 14z\"/><path d=\"M15.899 12.899a4 4 0 01-4.797-4.797A4.002 4.002 0 0012 16c1.9 0 3.49-1.325 3.899-3.101zM12 5V3m0 18v-2m-7-7H2h3zm17 0h-3 3zm-5.05-4.95l2.12-2.12-2.12 2.12zM4.929 19.071L7.05 16.95l-2.12 2.12zM16.95 16.95l2.121 2.121-2.121-2.121zM4.929 4.929L7.05 7.05 4.93 4.93z\"/></svg>");

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"noEntryIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16 3l5 5v8l-5 5H8l-5-5V8l5-5z\"/><path d=\"M7 10h10v4H7z\"/></svg>");

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"notAllowedIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M5 5l14 14\"/></svg>");

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"notebookIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M9 8h5m4-5v18H6a1 1 0 01-1-1V4a1 1 0 011-1h12z\"/><path d=\"M5 19v-1a1 1 0 011-1h12\"/></svg>");

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"octagonIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16 3l5 5v8l-5 5H8l-5-5V8l5-5z\"/></svg>");

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"circleOkIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7 13l3 3 7-7\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"okIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M4 13l5 5L20 7\"/></svg>");

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"originIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path clip-rule=\"evenodd\" d=\"M12 19a7 7 0 100-14 7 7 0 000 14z\"/><path d=\"M12 2v6m0 8v6M2 12h6m8 0h6\"/><circle cx=\"12\" cy=\"12\" r=\"1\"/></svg>");

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"panIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M20 14v3a4 4 0 01-4 4h-5.978A4 4 0 016.8 19.372l-3.456-4.691c-.53-.72-.397-1.73.301-2.29a1.787 1.787 0 012.381.134L8 14.5V13h.004L8 11l.017-4.5a1.5 1.5 0 113 0V11 4.5a1.5 1.5 0 013 0V11 5.5a1.5 1.5 0 013 0V11 7.5a1.5 1.5 0 013 0l-.011 6.5H20z\"/></svg>");

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"paperclipIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7.935 13.78l7.227-7.227a2.253 2.253 0 013.181 0 2.252 2.252 0 010 3.182l-9.942 9.813a3.748 3.748 0 01-5.302 0 3.748 3.748 0 010-5.303l9.835-9.707a5.248 5.248 0 017.423 0 5.248 5.248 0 01.001 7.424l-7.119 7.12\"/></svg>");

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"pauseCircleIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path clip-rule=\"evenodd\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\"/><path clip-rule=\"evenodd\" d=\"M8 8v8h2V8H8zm6 0v8h2V8h-2z\"/></svg>");

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"pauseIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 4h4v16H5zm10 0h4v16h-4z\"/></svg>");

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"penIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M14 17.584A5.001 5.001 0 0017 13c0-4-5-10-5-10S7 9 7 13a5.001 5.001 0 003 4.584V21h4v-3.416zM12 3v8\"/><circle cx=\"12\" cy=\"12\" r=\"1\"/></svg>");

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"peopleIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M1 18c0-2.25 3-2.25 4.5-3.75.75-.75-1.5-.75-1.5-4.5C4 7.25 5 6 7 6s3 1.25 3 3.75c0 3.75-2.25 3.75-1.5 4.5C10 15.75 13 15.75 13 18m-.208-2.273a13.73 13.73 0 001.21-.495c.55-.265 1.082-.566 1.498-.982.75-.75-1.5-.75-1.5-4.5C14 7.25 15 6 17 6s3 1.25 3 3.75c0 3.75-2.25 3.75-1.5 4.5C20 15.75 23 15.75 23 18\"/><path stroke-linecap=\"round\" d=\"M12 16c.366-.124.63-.215.792-.273\"/></svg>");

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"personAddIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M1 18c0-2.25 3-2.25 4.5-3.75.75-.75-1.5-.75-1.5-4.5C4 7.25 5 6 7 6s3 1.25 3 3.75c0 3.75-2.25 3.75-1.5 4.5C10 15.75 13 15.75 13 18m9-7h-8m4-4v8\"/></svg>");

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"personIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M4 20c0-3 4-3 6-5 1-1-2-1-2-6 0-3.333 1.333-5 4-5s4 1.667 4 5c0 5-3 5-2 6 2 2 6 2 6 5\"/></svg>");

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"phoneIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M12.74 18.404l3.158-3.157 5.217 3.638-1.17 1.17a3 3 0 01-2.98.754c-3.23-.965-6.13-2.734-8.703-5.306C5.689 12.93 3.92 10.03 2.956 6.8a3 3 0 01.753-2.98l1.17-1.17 3.639 5.217-3.157 3.157\"/></svg>");

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"pieChartIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path clip-rule=\"evenodd\" d=\"M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z\"/><path d=\"M12 2v10m0 10V12m0 0h10\"/></svg>");

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"pizzaIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M20 17.856a16 16 0 01-16 0L12 4l8 13.856z\"/><path d=\"M20 17.856a16 16 0 01-16 0L12 4l8 13.856z\"/><path d=\"M5.499 15.26A12.941 12.941 0 0012 17c2.368 0 4.589-.633 6.501-1.74\"/><circle cx=\"10\" cy=\"14\" r=\"1\"/><circle cx=\"13\" cy=\"13\" r=\"1\"/><circle cx=\"12\" cy=\"10\" r=\"1\"/></svg>");

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"placeholderIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 3h18v18H3z\"/><path stroke-linecap=\"round\" d=\"M21 21L3 3l18 18zm0-18L3 21 21 3z\"/></svg>");

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"planeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M18.394 4.364L14 7 6 5 5 6l5.5 4.5L8 14H5l-1 1 2.5 1.5 1 1L9 20l1-1v-3l3.5-2.5L18 19l1-1-2-8 2.636-4.394a.906.906 0 00-1.242-1.242z\"/></svg>");

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"playIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M20 12L5 21V3z\"/></svg>");

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"plusIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M20 12H4m8-8v16\"/></svg>");

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"pollIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M4 4v16M4 6h11v4H4m0 0h15v4H4m0 0h8v4H4\"/></svg>");

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"powerIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 2v9m6.364-5.364a9 9 0 11-12.728 0\"/></svg>");

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"presentationIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M6 8h12v7H6zm0-3h6m6 0h-6m0 0V4M6 18h2m10 0h-2m-4 0v3m0-3H8m4 0h4m-8 0l-2 3m10-3l2 3\"/></svg>");

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"previousAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M8 4L4 8l4 4\"/><path d=\"M4 8h10.5a5.5 5.5 0 015.5 5.5v0a5.5 5.5 0 01-5.5 5.5H5\"/></svg>");

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"previousIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M7 11.5L18 18V5zM6 18V5\"/></svg>");

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"printIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 14v7H7v-7zm0-11v6H7V3z\"/><path d=\"M7 18H3V9h18v9h-4\"/></svg>");

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"qrIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M10 3v7H3V3z\"/><path d=\"M7 6H6v1h1zm3 8v7H3v-7z\"/><path d=\"M6 17h1v1H6zm8 3h1v1h-1zm3-3h1v1h-1zm-3-3h1v1h-1zm6 3h1v1h-1zm0-3h1v1h-1zm0 6h1v1h-1zm1-17v7h-7V3z\"/><path d=\"M17 6h1v1h-1z\"/></svg>");

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"radioSelectedIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path clip-rule=\"evenodd\" d=\"M12 18a6 6 0 100-12 6 6 0 000 12z\"/><path clip-rule=\"evenodd\" d=\"M12 14a2 2 0 110-4 2 2 0 010 4z\"/></svg>");

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"radioIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path clip-rule=\"evenodd\" d=\"M12 18a6 6 0 100-12 6 6 0 000 12z\"/></svg>");

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"radioIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5.45 6c-3.267 3.266-3.267 8.734 0 12M8.6 8c-2.133 2.132-2.133 5.868 0 8m9.95 2c3.267-3.266 3.267-8.734 0-12M15.4 16c2.133-2.132 2.133-5.868 0-8\"/><circle cx=\"12\" cy=\"12\" r=\"1\"/></svg>");

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"rainIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16 18l1 3m-4-3l1 3m-4-3l1 3m8.051-3.043C20.5 17.97 22 16.245 22 14.5a3.5 3.5 0 00-3.079-3.475 6.002 6.002 0 00-11.21-1.86A4.504 4.504 0 002 13.5c0 2.311 1.5 4.47 3.986 4.47H7\"/></svg>");

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"rectangleIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 3h18v18H3z\"/></svg>");

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"redoIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16 15h5v-5m-2 3C14 8 6.425 8.725 3 14\"/><path stroke-linecap=\"round\" d=\"M21 15l-2-2\"/></svg>");

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"refreshIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M22 12l-3 3-3-3\"/><path d=\"M11 20a8 8 0 118-8v2\"/></svg>");

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"removeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 12H7\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"repeatIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M2 13.04V11a6 6 0 016-6h13v0\"/><path d=\"M19 2l3 3-3 3m3 1.98v2.04a6 6 0 01-6 6H3v0\"/><path d=\"M5 21l-3-3 3-3\"/></svg>");

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"restaurantIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 4v16m10-8c-2-.667-3-2-3-4s1-3.333 3-4v16-8zM5 4v3a3 3 0 003 3h0a3 3 0 003-3V4\"/></svg>");

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"returnIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M19 8v3a2 2 0 01-2 2H6\"/><path d=\"M8 16l-3-3 3-3\"/></svg>");

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"retweetIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M13 18H6V7\"/><path d=\"M3 9l3-3 3 3m2-3h7v11\"/><path d=\"M21 15l-3 3-3-3\"/></svg>");

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 29 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"rocketIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M12.753 9.924c-.547.362-1.074.782-1.56 1.268-.718.717-.698.756-1.34 1.49m2.9-2.758c3.425-2.267 7.632-2.267 7.632-2.267s0 4.207-2.268 7.632m-5.364-5.365l5.364 5.365m0 0a10.02 10.02 0 01-1.268 1.56c-.717.717-.756.698-1.49 1.339m-9.244-.759c-.372.524-.58.835-.58.835l4.243 4.242s.311-.207.835-.58M6.115 17.43l-3.408-3.408 5.657-2.829 1.49 1.49M6.115 17.43a62.503 62.503 0 013.739-4.747m.759 9.244l3.408 3.409 2.828-5.657-1.49-1.49m-4.746 3.738a62.526 62.526 0 004.747-3.738M5 23c.35-1.418 1-2 1.5-1.5S6.418 22.65 5 23z\"/></svg>");

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"rotateIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M22 12l-3 3-3-3M2 12l3-3 3 3\"/><path d=\"M19.016 14v-1.95A7.05 7.05 0 008 6.22m8.016 11.625A7.05 7.05 0 015 12.015V10\"/><path stroke-linecap=\"round\" d=\"M5 10V9m14 6v-1\"/></svg>");

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"rssIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M6 18h0\"/><path d=\"M10 18a4 4 0 00-4-4m8 4a8 8 0 00-8-8m12 8c0-6.627-5.373-12-12-12\"/></svg>");

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"sadFaceIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M9 9h0m6 0h0\"/><path d=\"M8 16c1.333-.667 2.666-1 3.997-.999 1.335 0 2.67.332 4.003.999\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"saveIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17.293 3.293L21 7v13a1 1 0 01-1 1H4a1 1 0 01-1-1V4a1 1 0 011-1h12.586a1 1 0 01.707.293z\"/><path d=\"M7 13h10v8H7zM8 3h8v5H8z\"/></svg>");

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"searchIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M14.412 14.412L20 20\"/><circle cx=\"10\" cy=\"10\" r=\"6\"/></svg>");

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"sendIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21.368 12.001L3 21.609V14l8-2-8-2.206v-7.4z\"/></svg>");

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"settingsIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5.035 12.705a7.083 7.083 0 010-1.41l-1.83-2.063 2-3.464 2.702.553a6.99 6.99 0 011.222-.707L10 3h4l.871 2.614c.433.195.842.432 1.222.707l2.701-.553 2 3.464-1.83 2.063a7.083 7.083 0 010 1.41l1.83 2.063-2 3.464-2.701-.553a6.99 6.99 0 01-1.222.707L14 21h-4l-.871-2.614a6.993 6.993 0 01-1.222-.707l-2.701.553-2-3.464 1.83-2.063z\"/><circle cx=\"12\" cy=\"12\" r=\"1\"/></svg>");

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"shareAndroidIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16 8l-8 3 8-3zm0 8l-8-3 8 3z\"/><circle cx=\"6\" cy=\"12\" r=\"2\"/><circle cx=\"18\" cy=\"7\" r=\"2\"/><circle cx=\"18\" cy=\"17\" r=\"2\"/></svg>");

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"shareiOSIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 3v12M9 5l3-3 3 3M6 9h12v12H6z\"/></svg>");

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"shareIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 14V6M9 8l3-3 3 3M5 13v5h14v-5\"/></svg>");

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"shieldIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M19 14.737c0 2.386-2.333 4.474-7 6.263-4.667-1.79-7-3.877-7-6.263V5.789C8.136 4.596 10.47 4 12 4c1.53 0 3.864.596 7 1.79v8.947z\"/></svg>");

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"shiftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 21h14H5zm11-9v5H8v-5H3l9-9 9 9h-5z\"/></svg>");

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"shuffleIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 16.04h-3.23c-1.954 0-3.785-1.07-4.909-2.868l-2.064-3.304C9.674 8.07 7.842 7 5.887 7H3\"/><path d=\"M21 7h-3.23c-1.954 0-3.785 1.184-4.909 3.173l-2.064 3.654C9.674 15.817 7.842 17 5.887 17H3\"/><path d=\"M19 4l3 3-3 3m0 3l3 3-3 3\"/></svg>");

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"signLanguageIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10.545 12.322a2.344 2.344 0 00-3.184-.928m3.184 3.184a2.344 2.344 0 01-3.6.636m0 0a2.344 2.344 0 01.416-3.82m-.416 3.82h-.929a1 1 0 00-.707.293l-.596.597a1 1 0 01-1.414 0L1.876 14.68a1 1 0 010-1.414l.815-.814a1 1 0 00.132-.164l2.066-3.19m0 0c.175-1.345 1.256-3.24 2.79-3.869M4.89 9.098l2.472 2.296m-1.57-1.459c.413-.919 2.778-2.848 4.035-2.82m-3.27 3.53c.797-.907 3.001-1.725 4.858-1.209m2.04 3.473a2.344 2.344 0 003.184.927m-3.184-3.184a2.344 2.344 0 013.6-.636m0 0a2.344 2.344 0 01-.416 3.82m.416-3.82h.929a1 1 0 00.707-.293l.596-.596a1 1 0 011.414 0l1.423 1.422a1 1 0 010 1.415l-.815.814a1 1 0 00-.132.164l-2.067 3.19m0 0c-.174 1.345-1.255 3.24-2.79 3.868m2.79-3.867l-2.471-2.297m1.57 1.46c-.413.918-2.778 2.848-4.035 2.82m3.27-3.531c-.797.907-3.001 1.726-4.858 1.21\"/></svg>");

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"signalIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M12 13h0\"/><path d=\"M20.182 19C21.405 17.376 22 15.435 22 13.353 22 7.634 17.523 3 12 3S2 7.634 2 13.353c0 2.052.578 3.966 1.818 5.647\"/><path d=\"M16 16c.702-.812 1-1.782 1-3 0-2.683-2.239-5-5-5s-5 2.317-5 5c0 1.203.289 2.16 1 3\"/></svg>");

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"signalAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18 5C11.373 5 6 10.373 6 17m12-8a8 8 0 00-8 8m8-4a4 4 0 00-4 4\"/></svg>");

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"skullIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M16 17.93a8 8 0 10-8 0V21h8v-3.07z\"/><circle cx=\"8.5\" cy=\"10.5\" r=\"1\"/><circle cx=\"15.5\" cy=\"10.5\" r=\"1\"/><path d=\"M11.5 15l.5-1 .5 1h-1z\"/></svg>");

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"smartphoneIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linejoin=\"round\" d=\"M18 3v18a1 1 0 01-1 1H7a1 1 0 01-1-1V3a1 1 0 011-1h10a1 1 0 011 1z\"/><path d=\"M11 19h2\"/></svg>");

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"snowIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M19.051 17.957C20.5 17.97 22 16.245 22 14.5a3.5 3.5 0 00-3.079-3.475 6.002 6.002 0 00-11.21-1.86A4.504 4.504 0 002 13.5c0 2.311 1.5 4.47 3.986 4.47H7m9 .03h-6m1.5-2.598l3 5.196m.263-5.025l-3.526 4.854\"/></svg>");

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"sortDownIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M11 9h6m-6-4h8m-8 8h4m-5 4l-3 3-3-3M7 5v14\"/></svg>");

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"sortUpIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M11 16h6m-6 4h8m-8-8h4M4 8l3-3 3 3M7 20V6\"/></svg>");

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"sortingIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 8.333l4-4 4 4h0m0 7.334l-4 4-4-4h0\"/></svg>");

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"soundsIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M12 7v10m3-7v4m3-6v8m3-3v-2M9 4v16M6 9v6m-3-2v-2\"/></svg>");

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"spamIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16 3l5 5v8l-5 5H8l-5-5V8l5-5zm-4 5v5m0 3h0\"/></svg>");

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"stackIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10 7h4m-8 5h12M3 17h18\"/></svg>");

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"starIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 17.844l-5.817 3.058 1.111-6.477-4.706-4.587 6.504-.945L12 3l2.908 5.893 6.504.945-4.706 4.587 1.111 6.477z\"/></svg>");

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"statsAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M14 6H8m13 4H8m-4 8V6m14 8H8m2 4H8\"/></svg>");

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"statsIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6 7h9m-9 5h12M6 17h6\"/></svg>");

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"stickerIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 3v8c0 5.523-4.477 10-10 10H3V3h18z\"/><path d=\"M9 21c2.667 0 4-1.333 4-4v-4h4c2.667 0 4-1.333 4-4\"/></svg>");

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"stopIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M5 5h14v14H5z\"/></svg>");

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"stopwatchIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"13\" r=\"8\"/><path d=\"M12 9v4m6-6l2-2m-5-3H9\"/></svg>");

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"suitcaseAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 7h18v12H3z\"/><path d=\"M8 3h8v16H8z\"/></svg>");

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"suitcaseIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 7h18v12H3zm5-4h8v4H8z\"/></svg>");

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"sunCloudIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6.417 18a3.75 3.75 0 111.009-7.363 5.001 5.001 0 019.342 1.55A2.917 2.917 0 0116.417 18h-10z\"/><path stroke-linecap=\"butt\" d=\"M18.034 12.832A4.003 4.003 0 0020.882 9 4 4 0 0013 8.032\"/></svg>");

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"sunIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"12\" r=\"4\"/><path d=\"M12 5V3m0 18v-2m-7-7H2h3zm17 0h-3 3zm-5.05-4.95l2.12-2.12-2.12 2.12zM4.929 19.071L7.05 16.95l-2.12 2.12zm12.02-2.121l2.122 2.121-2.121-2.121zM4.93 4.929L7.05 7.05 4.93 4.93z\"/></svg>");

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"sunsetIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M9.354 17a4 4 0 115.292 0H9.354zM12 7V5m10 12H2h20zM5 14H2h3zm17 0h-3 3zm-5.293-4.172l2.121-2.12-2.12 2.12zm-12-2.12l2.121 2.12-2.12-2.12z\"/></svg>");

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"supportIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M11 8l-1.578-.789A2 2 0 008.528 7h-.7a2 2 0 00-1.414.586l-.828.828A2 2 0 005 9.828v5.102a2 2 0 00.89 1.664l3.867 2.578a2 2 0 002.39-.128L17 15\"/><path d=\"M14.455 12.914a2 2 0 00-2.59-.542l-1.856 1.055a1.523 1.523 0 01-1.83-.248v0a1.523 1.523 0 01.102-2.247l4.163-3.468A2 2 0 0113.724 7h.804a2 2 0 01.894.211l2.472 1.236A2 2 0 0119 10.237v2.743c0 1.924-2.451 2.738-3.602 1.196l-.943-1.262zM1 17V8m0 9V8m22 9V8\"/></svg>");

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"supportIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21 12h-2a2 2 0 00-2 2v2a2 2 0 002 2h0a2 2 0 002-2v-4a9 9 0 00-18 0v4a2 2 0 002 2h0a2 2 0 002-2v-2a2 2 0 00-2-2H3\"/><path d=\"M21 14v4c0 2-.667 3-2 3h-5\"/></svg>");

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"swapHorizontalIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16 4l3 3-3 3M4 7h14M7 20l-3-3 3-3m12 3H5\"/></svg>");

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"swapVerticalIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M4 8l3-3 3 3M7 20V6m13 11l-3 3-3-3m3-12v14\"/></svg>");

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"switchOffIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path clip-rule=\"evenodd\" d=\"M7 14a2 2 0 110-4 2 2 0 010 4z\"/><path d=\"M7 17a5 5 0 01-5-5v0a5 5 0 015-5h9a5 5 0 015 5v0a5 5 0 01-5 5H7z\"/></svg>");

/***/ }),
/* 605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"switchOnIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path clip-rule=\"evenodd\" d=\"M17 10a2 2 0 110 4 2 2 0 010-4z\"/><path d=\"M17 7a5 5 0 015 5v0a5 5 0 01-5 5H8a5 5 0 01-5-5v0a5 5 0 015-5h9z\"/></svg>");

/***/ }),
/* 606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"tableHorizontalIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M22 4v15H2V4h20zm0 5H2m20 5H2m10 5V4\"/></svg>");

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"tableVerticalIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 2h18v20H3zm9 0v20m9-15H3m18 10H3m18-5H3\"/></svg>");

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"tagAltIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"10\" cy=\"12\" r=\"1\"/><path d=\"M8 18l-6-6 6-6h12a2 2 0 012 2v8a2 2 0 01-2 2H8z\"/></svg>");

/***/ }),
/* 609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"tagIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 18l-6-6 6-6h12a2 2 0 012 2v8a2 2 0 01-2 2H8z\"/></svg>");

/***/ }),
/* 610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"textIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M2 18l2.083-5M12 18l-2.083-5m-5.834 0L7 6l2.917 7m-5.834 0h5.834\"/><circle cx=\"18\" cy=\"14\" r=\"4\"/><path d=\"M22 10v8\"/></svg>");

/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"thermometerIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M10 13.535V5a2 2 0 114 0v8.535a4 4 0 11-4 0z\"/></svg>");

/***/ }),
/* 612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"thumbDownIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M16 15.26a2 2 0 01-.481 1.302l-4.791 5.59A1.432 1.432 0 019 22.5a1.29 1.29 0 01-.646-1.56L10 16H5.396a2 2 0 01-1.967-2.358l1.272-7A2 2 0 016.67 5H14a2 2 0 012 2v8.26zm4-.26V6\"/></svg>");

/***/ }),
/* 613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"thumbUpIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 8.74a2 2 0 01.481-1.302l4.791-5.59A1.432 1.432 0 0115 1.5c.574.287.85.952.646 1.56L14 8h4.604a2 2 0 011.967 2.358l-1.272 7A2 2 0 0117.33 19H10a2 2 0 01-2-2V8.74zM4 18V9\"/></svg>");

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"thunderIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M13 15l1 3h-2l1 3\"/><path d=\"M19.051 17.957C20.5 17.97 22 16.245 22 14.5a3.5 3.5 0 00-3.079-3.475 6.002 6.002 0 00-11.21-1.86A4.504 4.504 0 002 13.5c0 2.311 1.5 4.47 3.986 4.47H7\"/></svg>");

/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"timeIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><circle cx=\"12\" cy=\"12\" r=\"10\"/><path d=\"M12 5v7l4 4\"/></svg>");

/***/ }),
/* 616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"timerIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M6.587 4.809A9 9 0 1012 3v4m0 6L8 9\"/></svg>");

/***/ }),
/* 617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"toolIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M9.743 13.743a6 6 0 01-7.158-8.33L6.95 9.778 9.778 6.95 5.413 2.585a6 6 0 018.057 7.885l7.116 7.116a2 2 0 010 2.828l-.672.672a2 2 0 01-2.828 0l-7.343-7.343z\"/></svg>");

/***/ }),
/* 618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"trainIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M6 11V6m0 5v5a1 1 0 001 1h1m-2-6h6M6 6c.667-.667 2-2 6-2s5.333 1.333 6 2M6 6h6m6 0v5m0-5h-6m6 5v5a1 1 0 01-1 1h-1m2-6h-6m-4 6h8m-8 0l-1 3h10l-1-3m-4-6V6\"/><circle cx=\"9\" cy=\"14\" r=\"1\"/><circle cx=\"15\" cy=\"14\" r=\"1\"/></svg>");

/***/ }),
/* 619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"transportIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M4 17H2V7h13v10H8m12 0h2v-4.444L20 9h-5v8h1\"/><circle cx=\"6\" cy=\"17\" r=\"2\"/><circle cx=\"18\" cy=\"17\" r=\"2\"/></svg>");

/***/ }),
/* 620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"trendingDownIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 7l6 6 4-4 7.405 7.405\"/><path stroke-linecap=\"round\" d=\"M20.405 16.405L21 17\"/><path d=\"M21 14v3h-3\"/></svg>");

/***/ }),
/* 621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"trendingUpIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 17l6-6 4 4 7.405-7.405\"/><path stroke-linecap=\"round\" d=\"M20.405 7.595L21 7\"/><path d=\"M21 10V7h-3\"/></svg>");

/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"turnLeftIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M4.715 9h3.347C14.655 9 20 13.098 20 19.387\"/><path d=\"M9 14L4 9l5-5h0\"/></svg>");

/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"turnRightIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3.715 19.387C3.715 13.098 9.06 9 15.653 9H19\"/><path d=\"M15 4l5 5-5 5h0\"/></svg>");

/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"tvIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M20 8v12H4V8z\"/><path stroke-linejoin=\"round\" d=\"M8 4l4 3.917L16 4\"/></svg>");

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"typographyIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M4 8l1-4h7m8 4l-1-4h-7m0 0v16m0 0H8m4 0h4\"/></svg>");

/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"umbrellaIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M22 11c0-4.97-4.477-9-10-9S2 6.03 2 11h20zm-5 8v.5a2.5 2.5 0 11-5 0V12\"/><path stroke-linecap=\"butt\" d=\"M12 12v-1\"/></svg>");

/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"undoIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 15H3v-5m2 3c5-5 12.575-4.275 16 1\"/><path stroke-linecap=\"round\" d=\"M3 15l2-2\"/></svg>");

/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"uploadIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M12 4v13M7 8l5-5 5 5m3 13H4\"/></svg>");

/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"userIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M5.5 19.5c2.333-1 3.833-1.833 4.5-2.5 1-1-2-1-2-6 0-3.333 1.333-5 4-5s4 1.667 4 5c0 5-3 5-2 6 .667.667 2.167 1.5 4.5 2.5\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"verifiedIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M8 12.5l2.5 2.5L16 9.5\"/><path d=\"M12 22a3 3 0 002.757-1.816c.162-.377.699-.6 1.08-.447a3 3 0 003.9-3.9c-.152-.381.07-.918.447-1.08a3 3 0 000-5.514c-.377-.163-.6-.699-.447-1.08a3 3 0 00-3.9-3.9c-.381.152-.918-.07-1.08-.447a3 3 0 00-5.514 0c-.163.377-.699.6-1.08.447a3 3 0 00-3.9 3.9c.152.381-.07.917-.447 1.08a3 3 0 000 5.514c.377.162.6.699.447 1.08a3 3 0 003.9 3.9c.381-.152.917.07 1.08.447A3 3 0 0012 22z\"/></svg>");

/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"verticalIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M17 18V6m-5 12V6M7 18V6\"/></svg>");

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"videoIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M18 12l-9 4.9V7z\"/><circle cx=\"12\" cy=\"12\" r=\"10\"/></svg>");

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"voicemailIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M18 16H6\"/><circle cx=\"6\" cy=\"12\" r=\"4\"/><circle cx=\"18\" cy=\"12\" r=\"4\"/></svg>");

/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"volumeLoudIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M13 5v14l-5-4H3V9h5z\"/><path stroke-linecap=\"round\" d=\"M13 14c1.5-1 1.5-3 0-4\"/><path d=\"M16 16c2.086-2.086 2.086-5.914 0-8m2 11c3.986-3.986 4.008-9.992 0-14\"/></svg>");

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"volumeOffIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M13 5v14l-5-4H3V9h5z\"/><path stroke-linecap=\"round\" d=\"M13 14c1.5-1 1.5-3 0-4\"/></svg>");

/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"volumeQuietIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M13 5v14l-5-4H3V9h5z\"/><path stroke-linecap=\"round\" d=\"M13 14c1.5-1 1.5-3 0-4\"/><path d=\"M16 16c2.086-2.086 2.086-5.914 0-8\"/></svg>");

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"walkingIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><circle cx=\"13\" cy=\"5\" r=\"1\"/><path d=\"M15 20l-1-3-3-3m0 0l1-5m-1 5l-3 6m4-11l3 3 2 1m-5-4l-3 2-1 3\"/></svg>");

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"wallpaperIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><circle cx=\"12\" cy=\"7\" r=\"3\"/><circle cx=\"12\" cy=\"17\" r=\"3\"/><circle cx=\"16.33\" cy=\"9.5\" r=\"3\" transform=\"rotate(60 16.33 9.5)\"/><circle cx=\"7.67\" cy=\"14.5\" r=\"3\" transform=\"rotate(60 7.67 14.5)\"/><circle cx=\"7.67\" cy=\"9.5\" r=\"3\" transform=\"rotate(-60 7.67 9.5)\"/><circle cx=\"16.33\" cy=\"14.5\" r=\"3\" transform=\"rotate(-60 16.33 14.5)\"/></svg>");

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"watchIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path stroke-linecap=\"round\" d=\"M10 7.758V2h5v5.758m0 7.484V22h-5v-6.758\"/><circle cx=\"12.5\" cy=\"11.5\" r=\"4.5\"/></svg>");

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"wheelchairIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M15 17a5 5 0 11-7-4.584\"/><circle cx=\"11\" cy=\"3\" r=\"1\"/><path d=\"M19 21.5l-1.604-6.015A2 2 0 0015.463 14H11V7l6 3\"/></svg>");

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"wifiIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M21.228 11.036c-4.99-4.99-13.081-4.99-18.071 0m14.457 3.614a7.667 7.667 0 00-10.843 0M14 18.264a2.556 2.556 0 00-3.614 0\"/></svg>");

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"windowIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M3 3h18v18H3z\"/><path stroke-linecap=\"round\" d=\"M6 6h0m3 0h0m3 0h0\"/><path d=\"M21 9H3\"/></svg>");

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-labelledby=\"wineIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" color=\"#000\"><path d=\"M12 14a5 5 0 005-5c0-1.929-1.539-5-1.539-5H8.538S7 6.239 7 9a5 5 0 005 5zm0 0v6m0 0H8m4 0h4\"/></svg>");

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"zoomInIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M4 20l5.588-5.588M14 16a6 6 0 110-12 6 6 0 010 12zm2.667-6h-5.334M14 7.333v5.334\"/></svg>");

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 24 24\" aria-labelledby=\"zoomOutIconTitle\" stroke=\"#000\" stroke-width=\"1.5\" stroke-linecap=\"square\" fill=\"none\" color=\"#000\"><path d=\"M14 16a6 6 0 110-12 6 6 0 010 12zm2.667-6h-5.334M4 20l5.588-5.588\"/></svg>");

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./font_trimming.svg": 198,
	"./hat.svg": 199,
	"./letter_spacing.svg": 200,
	"./line_height.svg": 201,
	"./mirror_horizontal.svg": 202,
	"./mirror_vertical.svg": 203,
	"./options.svg": 204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 646;

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_id_54c652ab_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(205);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_id_54c652ab_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_icon_vue_vue_type_style_index_0_id_54c652ab_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.icon[data-v-54c652ab] {\r\n    display: inline-block;\r\n    font-size: 0px;\n}\n.icon[data-v-54c652ab]  svg {\r\n    display: block;\r\n    height: inherit;\r\n    width: inherit;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_image_vue_vue_type_style_index_0_id_6a1fe188_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(207);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_image_vue_vue_type_style_index_0_id_6a1fe188_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_image_vue_vue_type_style_index_0_id_6a1fe188_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "img[data-v-6a1fe188]{opacity:0;transition:opacity .35s ease-out}img.loaded[data-v-6a1fe188]{opacity:1}img.errored.hide-error[data-v-6a1fe188]{display:none}img.no-fade[data-v-6a1fe188]{opacity:1}", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

var api = __webpack_require__(10);
            var content = __webpack_require__(652);

            content = content.__esModule ? content.default : content;

            if (typeof content === 'string') {
              content = [[module.i, content, '']];
            }

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "/**\n *\n * All animations must live in their own file\n * in the animations directory and be included\n * here.\n *\n */\n/**\n * Styles shared by multiple animations\n */\n/**\n * Dots\n */\n@-webkit-keyframes scale {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; }\n  45% {\n    -webkit-transform: scale(0.1);\n            transform: scale(0.1);\n    opacity: 0.7; }\n  80% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; } }\n@keyframes scale {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; }\n  45% {\n    -webkit-transform: scale(0.1);\n            transform: scale(0.1);\n    opacity: 0.7; }\n  80% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; } }\n\n.ball-pulse > div:nth-child(0) {\n  -webkit-animation: scale 0.75s -0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: scale 0.75s -0.36s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08); }\n\n.ball-pulse > div:nth-child(1) {\n  -webkit-animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: scale 0.75s -0.24s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08); }\n\n.ball-pulse > div:nth-child(2) {\n  -webkit-animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: scale 0.75s -0.12s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08); }\n\n.ball-pulse > div:nth-child(3) {\n  -webkit-animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: scale 0.75s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08); }\n\n.ball-pulse > div {\n  background-color: #fff;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block; }\n\n@-webkit-keyframes ball-pulse-sync {\n  33% {\n    -webkit-transform: translateY(10px);\n            transform: translateY(10px); }\n  66% {\n    -webkit-transform: translateY(-10px);\n            transform: translateY(-10px); }\n  100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0); } }\n\n@keyframes ball-pulse-sync {\n  33% {\n    -webkit-transform: translateY(10px);\n            transform: translateY(10px); }\n  66% {\n    -webkit-transform: translateY(-10px);\n            transform: translateY(-10px); }\n  100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0); } }\n\n.ball-pulse-sync > div:nth-child(0) {\n  -webkit-animation: ball-pulse-sync 0.6s -0.21s infinite ease-in-out;\n          animation: ball-pulse-sync 0.6s -0.21s infinite ease-in-out; }\n\n.ball-pulse-sync > div:nth-child(1) {\n  -webkit-animation: ball-pulse-sync 0.6s -0.14s infinite ease-in-out;\n          animation: ball-pulse-sync 0.6s -0.14s infinite ease-in-out; }\n\n.ball-pulse-sync > div:nth-child(2) {\n  -webkit-animation: ball-pulse-sync 0.6s -0.07s infinite ease-in-out;\n          animation: ball-pulse-sync 0.6s -0.07s infinite ease-in-out; }\n\n.ball-pulse-sync > div:nth-child(3) {\n  -webkit-animation: ball-pulse-sync 0.6s 0s infinite ease-in-out;\n          animation: ball-pulse-sync 0.6s 0s infinite ease-in-out; }\n\n.ball-pulse-sync > div {\n  background-color: #fff;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block; }\n\n@-webkit-keyframes ball-scale {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0; } }\n\n@keyframes ball-scale {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0; } }\n\n.ball-scale > div {\n  background-color: #fff;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block;\n  height: 60px;\n  width: 60px;\n  -webkit-animation: ball-scale 1s 0s ease-in-out infinite;\n          animation: ball-scale 1s 0s ease-in-out infinite; }\n\n@keyframes ball-scale {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0; } }\n\n.ball-scale > div {\n  background-color: #fff;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block;\n  height: 60px;\n  width: 60px;\n  -webkit-animation: ball-scale 1s 0s ease-in-out infinite;\n          animation: ball-scale 1s 0s ease-in-out infinite; }\n\n.ball-scale-random {\n  width: 37px;\n  height: 40px; }\n  .ball-scale-random > div {\n    background-color: #fff;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    display: inline-block;\n    height: 30px;\n    width: 30px;\n    -webkit-animation: ball-scale 1s 0s ease-in-out infinite;\n            animation: ball-scale 1s 0s ease-in-out infinite; }\n    .ball-scale-random > div:nth-child(1) {\n      margin-left: -7px;\n      -webkit-animation: ball-scale 1s 0.2s ease-in-out infinite;\n              animation: ball-scale 1s 0.2s ease-in-out infinite; }\n    .ball-scale-random > div:nth-child(3) {\n      margin-left: -2px;\n      margin-top: 9px;\n      -webkit-animation: ball-scale 1s 0.5s ease-in-out infinite;\n              animation: ball-scale 1s 0.5s ease-in-out infinite; }\n\n@-webkit-keyframes rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  50% {\n    -webkit-transform: rotate(180deg);\n            transform: rotate(180deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  50% {\n    -webkit-transform: rotate(180deg);\n            transform: rotate(180deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.ball-rotate {\n  position: relative; }\n  .ball-rotate > div {\n    background-color: #fff;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: relative; }\n    .ball-rotate > div:first-child {\n      -webkit-animation: rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86) infinite;\n              animation: rotate 1s 0s cubic-bezier(0.7, -0.13, 0.22, 0.86) infinite; }\n    .ball-rotate > div:before, .ball-rotate > div:after {\n      background-color: #fff;\n      width: 15px;\n      height: 15px;\n      border-radius: 100%;\n      margin: 2px;\n      content: \"\";\n      position: absolute;\n      opacity: 0.8; }\n    .ball-rotate > div:before {\n      top: 0px;\n      left: -28px; }\n    .ball-rotate > div:after {\n      top: 0px;\n      left: 25px; }\n\n@keyframes rotate {\n  0% {\n    -webkit-transform: rotate(0deg) scale(1);\n            transform: rotate(0deg) scale(1); }\n  50% {\n    -webkit-transform: rotate(180deg) scale(0.6);\n            transform: rotate(180deg) scale(0.6); }\n  100% {\n    -webkit-transform: rotate(360deg) scale(1);\n            transform: rotate(360deg) scale(1); } }\n\n.ball-clip-rotate > div {\n  background-color: #fff;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  border: 2px solid #fff;\n  border-bottom-color: transparent;\n  height: 25px;\n  width: 25px;\n  background: transparent !important;\n  display: inline-block;\n  -webkit-animation: rotate 0.75s 0s linear infinite;\n          animation: rotate 0.75s 0s linear infinite; }\n\n@keyframes rotate {\n  0% {\n    -webkit-transform: rotate(0deg) scale(1);\n            transform: rotate(0deg) scale(1); }\n  50% {\n    -webkit-transform: rotate(180deg) scale(0.6);\n            transform: rotate(180deg) scale(0.6); }\n  100% {\n    -webkit-transform: rotate(360deg) scale(1);\n            transform: rotate(360deg) scale(1); } }\n\n@keyframes scale {\n  30% {\n    -webkit-transform: scale(0.3);\n            transform: scale(0.3); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n.ball-clip-rotate-pulse {\n  position: relative;\n  -webkit-transform: translateY(-15px);\n      -ms-transform: translateY(-15px);\n          transform: translateY(-15px); }\n  .ball-clip-rotate-pulse > div {\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    border-radius: 100%; }\n    .ball-clip-rotate-pulse > div:first-child {\n      background: #fff;\n      height: 16px;\n      width: 16px;\n      top: 7px;\n      left: -7px;\n      -webkit-animation: scale 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n              animation: scale 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite; }\n    .ball-clip-rotate-pulse > div:last-child {\n      position: absolute;\n      border: 2px solid #fff;\n      width: 30px;\n      height: 30px;\n      left: -16px;\n      top: -2px;\n      background: transparent;\n      border: 2px solid;\n      border-color: #fff transparent #fff transparent;\n      -webkit-animation: rotate 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n              animation: rotate 1s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n      -webkit-animation-duration: 1s;\n              animation-duration: 1s; }\n\n@keyframes rotate {\n  0% {\n    -webkit-transform: rotate(0deg) scale(1);\n            transform: rotate(0deg) scale(1); }\n  50% {\n    -webkit-transform: rotate(180deg) scale(0.6);\n            transform: rotate(180deg) scale(0.6); }\n  100% {\n    -webkit-transform: rotate(360deg) scale(1);\n            transform: rotate(360deg) scale(1); } }\n\n.ball-clip-rotate-multiple {\n  position: relative; }\n  .ball-clip-rotate-multiple > div {\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    left: -20px;\n    top: -20px;\n    border: 2px solid #fff;\n    border-bottom-color: transparent;\n    border-top-color: transparent;\n    border-radius: 100%;\n    height: 35px;\n    width: 35px;\n    -webkit-animation: rotate 1s 0s ease-in-out infinite;\n            animation: rotate 1s 0s ease-in-out infinite; }\n    .ball-clip-rotate-multiple > div:last-child {\n      display: inline-block;\n      top: -10px;\n      left: -10px;\n      width: 15px;\n      height: 15px;\n      -webkit-animation-duration: 0.5s;\n              animation-duration: 0.5s;\n      border-color: #fff transparent #fff transparent;\n      -webkit-animation-direction: reverse;\n              animation-direction: reverse; }\n\n@-webkit-keyframes ball-scale-ripple {\n  0% {\n    -webkit-transform: scale(0.1);\n            transform: scale(0.1);\n    opacity: 1; }\n  70% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7; }\n  100% {\n    opacity: 0.0; } }\n\n@keyframes ball-scale-ripple {\n  0% {\n    -webkit-transform: scale(0.1);\n            transform: scale(0.1);\n    opacity: 1; }\n  70% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7; }\n  100% {\n    opacity: 0.0; } }\n\n.ball-scale-ripple > div {\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  height: 50px;\n  width: 50px;\n  border-radius: 100%;\n  border: 2px solid #fff;\n  -webkit-animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n          animation: ball-scale-ripple 1s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8); }\n\n@-webkit-keyframes ball-scale-ripple-multiple {\n  0% {\n    -webkit-transform: scale(0.1);\n            transform: scale(0.1);\n    opacity: 1; }\n  70% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7; }\n  100% {\n    opacity: 0.0; } }\n\n@keyframes ball-scale-ripple-multiple {\n  0% {\n    -webkit-transform: scale(0.1);\n            transform: scale(0.1);\n    opacity: 1; }\n  70% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0.7; }\n  100% {\n    opacity: 0.0; } }\n\n.ball-scale-ripple-multiple {\n  position: relative;\n  -webkit-transform: translateY(-25px);\n      -ms-transform: translateY(-25px);\n          transform: translateY(-25px); }\n  .ball-scale-ripple-multiple > div:nth-child(0) {\n    -webkit-animation-delay: -0.8s;\n            animation-delay: -0.8s; }\n  .ball-scale-ripple-multiple > div:nth-child(1) {\n    -webkit-animation-delay: -0.6s;\n            animation-delay: -0.6s; }\n  .ball-scale-ripple-multiple > div:nth-child(2) {\n    -webkit-animation-delay: -0.4s;\n            animation-delay: -0.4s; }\n  .ball-scale-ripple-multiple > div:nth-child(3) {\n    -webkit-animation-delay: -0.2s;\n            animation-delay: -0.2s; }\n  .ball-scale-ripple-multiple > div {\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    top: -2px;\n    left: -26px;\n    width: 50px;\n    height: 50px;\n    border-radius: 100%;\n    border: 2px solid #fff;\n    -webkit-animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8);\n            animation: ball-scale-ripple-multiple 1.25s 0s infinite cubic-bezier(0.21, 0.53, 0.56, 0.8); }\n\n@-webkit-keyframes ball-beat {\n  50% {\n    opacity: 0.2;\n    -webkit-transform: scale(0.75);\n            transform: scale(0.75); }\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes ball-beat {\n  50% {\n    opacity: 0.2;\n    -webkit-transform: scale(0.75);\n            transform: scale(0.75); }\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n.ball-beat > div {\n  background-color: #fff;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block;\n  -webkit-animation: ball-beat 0.7s 0s infinite linear;\n          animation: ball-beat 0.7s 0s infinite linear; }\n  .ball-beat > div:nth-child(2n-1) {\n    -webkit-animation-delay: -0.35s !important;\n            animation-delay: -0.35s !important; }\n\n@-webkit-keyframes ball-scale-multiple {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    opacity: 0; }\n  5% {\n    opacity: 1; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0; } }\n\n@keyframes ball-scale-multiple {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n    opacity: 0; }\n  5% {\n    opacity: 1; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 0; } }\n\n.ball-scale-multiple {\n  position: relative;\n  -webkit-transform: translateY(-30px);\n      -ms-transform: translateY(-30px);\n          transform: translateY(-30px); }\n  .ball-scale-multiple > div:nth-child(2) {\n    -webkit-animation-delay: -0.4s;\n            animation-delay: -0.4s; }\n  .ball-scale-multiple > div:nth-child(3) {\n    -webkit-animation-delay: -0.2s;\n            animation-delay: -0.2s; }\n  .ball-scale-multiple > div {\n    background-color: #fff;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    left: -30px;\n    top: 0px;\n    opacity: 0;\n    margin: 0;\n    width: 60px;\n    height: 60px;\n    -webkit-animation: ball-scale-multiple 1s 0s linear infinite;\n            animation: ball-scale-multiple 1s 0s linear infinite; }\n\n@-webkit-keyframes ball-triangle-path-1 {\n  33% {\n    -webkit-transform: translate(25px, -50px);\n            transform: translate(25px, -50px); }\n  66% {\n    -webkit-transform: translate(50px, 0px);\n            transform: translate(50px, 0px); }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n            transform: translate(0px, 0px); } }\n\n@keyframes ball-triangle-path-1 {\n  33% {\n    -webkit-transform: translate(25px, -50px);\n            transform: translate(25px, -50px); }\n  66% {\n    -webkit-transform: translate(50px, 0px);\n            transform: translate(50px, 0px); }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n            transform: translate(0px, 0px); } }\n\n@-webkit-keyframes ball-triangle-path-2 {\n  33% {\n    -webkit-transform: translate(25px, 50px);\n            transform: translate(25px, 50px); }\n  66% {\n    -webkit-transform: translate(-25px, 50px);\n            transform: translate(-25px, 50px); }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n            transform: translate(0px, 0px); } }\n\n@keyframes ball-triangle-path-2 {\n  33% {\n    -webkit-transform: translate(25px, 50px);\n            transform: translate(25px, 50px); }\n  66% {\n    -webkit-transform: translate(-25px, 50px);\n            transform: translate(-25px, 50px); }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n            transform: translate(0px, 0px); } }\n\n@-webkit-keyframes ball-triangle-path-3 {\n  33% {\n    -webkit-transform: translate(-50px, 0px);\n            transform: translate(-50px, 0px); }\n  66% {\n    -webkit-transform: translate(-25px, -50px);\n            transform: translate(-25px, -50px); }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n            transform: translate(0px, 0px); } }\n\n@keyframes ball-triangle-path-3 {\n  33% {\n    -webkit-transform: translate(-50px, 0px);\n            transform: translate(-50px, 0px); }\n  66% {\n    -webkit-transform: translate(-25px, -50px);\n            transform: translate(-25px, -50px); }\n  100% {\n    -webkit-transform: translate(0px, 0px);\n            transform: translate(0px, 0px); } }\n\n.ball-triangle-path {\n  position: relative;\n  -webkit-transform: translate(-29.994px, -37.50938px);\n      -ms-transform: translate(-29.994px, -37.50938px);\n          transform: translate(-29.994px, -37.50938px); }\n  .ball-triangle-path > div:nth-child(1) {\n    -webkit-animation-name: ball-triangle-path-1;\n            animation-name: ball-triangle-path-1;\n    -webkit-animation-delay: 0;\n            animation-delay: 0;\n    -webkit-animation-duration: 2s;\n            animation-duration: 2s;\n    -webkit-animation-timing-function: ease-in-out;\n            animation-timing-function: ease-in-out;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite; }\n  .ball-triangle-path > div:nth-child(2) {\n    -webkit-animation-name: ball-triangle-path-2;\n            animation-name: ball-triangle-path-2;\n    -webkit-animation-delay: 0;\n            animation-delay: 0;\n    -webkit-animation-duration: 2s;\n            animation-duration: 2s;\n    -webkit-animation-timing-function: ease-in-out;\n            animation-timing-function: ease-in-out;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite; }\n  .ball-triangle-path > div:nth-child(3) {\n    -webkit-animation-name: ball-triangle-path-3;\n            animation-name: ball-triangle-path-3;\n    -webkit-animation-delay: 0;\n            animation-delay: 0;\n    -webkit-animation-duration: 2s;\n            animation-duration: 2s;\n    -webkit-animation-timing-function: ease-in-out;\n            animation-timing-function: ease-in-out;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite; }\n  .ball-triangle-path > div {\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n    border: 1px solid #fff; }\n    .ball-triangle-path > div:nth-of-type(1) {\n      top: 50px; }\n    .ball-triangle-path > div:nth-of-type(2) {\n      left: 25px; }\n    .ball-triangle-path > div:nth-of-type(3) {\n      top: 50px;\n      left: 50px; }\n\n@-webkit-keyframes ball-pulse-rise-even {\n  0% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1); }\n  25% {\n    -webkit-transform: translateY(-30px);\n            transform: translateY(-30px); }\n  50% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4); }\n  75% {\n    -webkit-transform: translateY(30px);\n            transform: translateY(30px); }\n  100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes ball-pulse-rise-even {\n  0% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1); }\n  25% {\n    -webkit-transform: translateY(-30px);\n            transform: translateY(-30px); }\n  50% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4); }\n  75% {\n    -webkit-transform: translateY(30px);\n            transform: translateY(30px); }\n  100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@-webkit-keyframes ball-pulse-rise-odd {\n  0% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4); }\n  25% {\n    -webkit-transform: translateY(30px);\n            transform: translateY(30px); }\n  50% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1); }\n  75% {\n    -webkit-transform: translateY(-30px);\n            transform: translateY(-30px); }\n  100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n    -webkit-transform: scale(0.75);\n            transform: scale(0.75); } }\n\n@keyframes ball-pulse-rise-odd {\n  0% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4); }\n  25% {\n    -webkit-transform: translateY(30px);\n            transform: translateY(30px); }\n  50% {\n    -webkit-transform: scale(1.1);\n            transform: scale(1.1); }\n  75% {\n    -webkit-transform: translateY(-30px);\n            transform: translateY(-30px); }\n  100% {\n    -webkit-transform: translateY(0);\n            transform: translateY(0);\n    -webkit-transform: scale(0.75);\n            transform: scale(0.75); } }\n\n.ball-pulse-rise > div {\n  background-color: #fff;\n  width: 15px;\n  height: 15px;\n  border-radius: 100%;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block;\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-timing-function: cubic-bezier(0.15, 0.46, 0.9, 0.6);\n          animation-timing-function: cubic-bezier(0.15, 0.46, 0.9, 0.6);\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-delay: 0;\n          animation-delay: 0; }\n  .ball-pulse-rise > div:nth-child(2n) {\n    -webkit-animation-name: ball-pulse-rise-even;\n            animation-name: ball-pulse-rise-even; }\n  .ball-pulse-rise > div:nth-child(2n-1) {\n    -webkit-animation-name: ball-pulse-rise-odd;\n            animation-name: ball-pulse-rise-odd; }\n\n@-webkit-keyframes ball-grid-beat {\n  50% {\n    opacity: 0.7; }\n  100% {\n    opacity: 1; } }\n\n@keyframes ball-grid-beat {\n  50% {\n    opacity: 0.7; }\n  100% {\n    opacity: 1; } }\n\n.ball-grid-beat {\n  width: 57px; }\n  .ball-grid-beat > div:nth-child(1) {\n    -webkit-animation-delay: 0.44s;\n            animation-delay: 0.44s;\n    -webkit-animation-duration: 1.27s;\n            animation-duration: 1.27s; }\n  .ball-grid-beat > div:nth-child(2) {\n    -webkit-animation-delay: 0.2s;\n            animation-delay: 0.2s;\n    -webkit-animation-duration: 1.52s;\n            animation-duration: 1.52s; }\n  .ball-grid-beat > div:nth-child(3) {\n    -webkit-animation-delay: 0.14s;\n            animation-delay: 0.14s;\n    -webkit-animation-duration: 0.61s;\n            animation-duration: 0.61s; }\n  .ball-grid-beat > div:nth-child(4) {\n    -webkit-animation-delay: 0.15s;\n            animation-delay: 0.15s;\n    -webkit-animation-duration: 0.82s;\n            animation-duration: 0.82s; }\n  .ball-grid-beat > div:nth-child(5) {\n    -webkit-animation-delay: -0.01s;\n            animation-delay: -0.01s;\n    -webkit-animation-duration: 1.24s;\n            animation-duration: 1.24s; }\n  .ball-grid-beat > div:nth-child(6) {\n    -webkit-animation-delay: -0.07s;\n            animation-delay: -0.07s;\n    -webkit-animation-duration: 1.35s;\n            animation-duration: 1.35s; }\n  .ball-grid-beat > div:nth-child(7) {\n    -webkit-animation-delay: 0.29s;\n            animation-delay: 0.29s;\n    -webkit-animation-duration: 1.44s;\n            animation-duration: 1.44s; }\n  .ball-grid-beat > div:nth-child(8) {\n    -webkit-animation-delay: 0.63s;\n            animation-delay: 0.63s;\n    -webkit-animation-duration: 1.19s;\n            animation-duration: 1.19s; }\n  .ball-grid-beat > div:nth-child(9) {\n    -webkit-animation-delay: -0.18s;\n            animation-delay: -0.18s;\n    -webkit-animation-duration: 1.48s;\n            animation-duration: 1.48s; }\n  .ball-grid-beat > div {\n    background-color: #fff;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    display: inline-block;\n    float: left;\n    -webkit-animation-name: ball-grid-beat;\n            animation-name: ball-grid-beat;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite;\n    -webkit-animation-delay: 0;\n            animation-delay: 0; }\n\n@-webkit-keyframes ball-grid-pulse {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  50% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    opacity: 0.7; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; } }\n\n@keyframes ball-grid-pulse {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  50% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5);\n    opacity: 0.7; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    opacity: 1; } }\n\n.ball-grid-pulse {\n  width: 57px; }\n  .ball-grid-pulse > div:nth-child(1) {\n    -webkit-animation-delay: 0.58s;\n            animation-delay: 0.58s;\n    -webkit-animation-duration: 0.9s;\n            animation-duration: 0.9s; }\n  .ball-grid-pulse > div:nth-child(2) {\n    -webkit-animation-delay: 0.01s;\n            animation-delay: 0.01s;\n    -webkit-animation-duration: 0.94s;\n            animation-duration: 0.94s; }\n  .ball-grid-pulse > div:nth-child(3) {\n    -webkit-animation-delay: 0.25s;\n            animation-delay: 0.25s;\n    -webkit-animation-duration: 1.43s;\n            animation-duration: 1.43s; }\n  .ball-grid-pulse > div:nth-child(4) {\n    -webkit-animation-delay: -0.03s;\n            animation-delay: -0.03s;\n    -webkit-animation-duration: 0.74s;\n            animation-duration: 0.74s; }\n  .ball-grid-pulse > div:nth-child(5) {\n    -webkit-animation-delay: 0.21s;\n            animation-delay: 0.21s;\n    -webkit-animation-duration: 0.68s;\n            animation-duration: 0.68s; }\n  .ball-grid-pulse > div:nth-child(6) {\n    -webkit-animation-delay: 0.25s;\n            animation-delay: 0.25s;\n    -webkit-animation-duration: 1.17s;\n            animation-duration: 1.17s; }\n  .ball-grid-pulse > div:nth-child(7) {\n    -webkit-animation-delay: 0.46s;\n            animation-delay: 0.46s;\n    -webkit-animation-duration: 1.41s;\n            animation-duration: 1.41s; }\n  .ball-grid-pulse > div:nth-child(8) {\n    -webkit-animation-delay: 0.02s;\n            animation-delay: 0.02s;\n    -webkit-animation-duration: 1.56s;\n            animation-duration: 1.56s; }\n  .ball-grid-pulse > div:nth-child(9) {\n    -webkit-animation-delay: 0.13s;\n            animation-delay: 0.13s;\n    -webkit-animation-duration: 0.78s;\n            animation-duration: 0.78s; }\n  .ball-grid-pulse > div {\n    background-color: #fff;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    display: inline-block;\n    float: left;\n    -webkit-animation-name: ball-grid-pulse;\n            animation-name: ball-grid-pulse;\n    -webkit-animation-iteration-count: infinite;\n            animation-iteration-count: infinite;\n    -webkit-animation-delay: 0;\n            animation-delay: 0; }\n\n@-webkit-keyframes ball-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4); }\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes ball-spin-fade-loader {\n  50% {\n    opacity: 0.3;\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4); }\n  100% {\n    opacity: 1;\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n.ball-spin-fade-loader {\n  position: relative;\n  top: -10px;\n  left: -10px; }\n  .ball-spin-fade-loader > div:nth-child(1) {\n    top: 25px;\n    left: 0;\n    -webkit-animation: ball-spin-fade-loader 1s -0.96s infinite linear;\n            animation: ball-spin-fade-loader 1s -0.96s infinite linear; }\n  .ball-spin-fade-loader > div:nth-child(2) {\n    top: 17.04545px;\n    left: 17.04545px;\n    -webkit-animation: ball-spin-fade-loader 1s -0.84s infinite linear;\n            animation: ball-spin-fade-loader 1s -0.84s infinite linear; }\n  .ball-spin-fade-loader > div:nth-child(3) {\n    top: 0;\n    left: 25px;\n    -webkit-animation: ball-spin-fade-loader 1s -0.72s infinite linear;\n            animation: ball-spin-fade-loader 1s -0.72s infinite linear; }\n  .ball-spin-fade-loader > div:nth-child(4) {\n    top: -17.04545px;\n    left: 17.04545px;\n    -webkit-animation: ball-spin-fade-loader 1s -0.6s infinite linear;\n            animation: ball-spin-fade-loader 1s -0.6s infinite linear; }\n  .ball-spin-fade-loader > div:nth-child(5) {\n    top: -25px;\n    left: 0;\n    -webkit-animation: ball-spin-fade-loader 1s -0.48s infinite linear;\n            animation: ball-spin-fade-loader 1s -0.48s infinite linear; }\n  .ball-spin-fade-loader > div:nth-child(6) {\n    top: -17.04545px;\n    left: -17.04545px;\n    -webkit-animation: ball-spin-fade-loader 1s -0.36s infinite linear;\n            animation: ball-spin-fade-loader 1s -0.36s infinite linear; }\n  .ball-spin-fade-loader > div:nth-child(7) {\n    top: 0;\n    left: -25px;\n    -webkit-animation: ball-spin-fade-loader 1s -0.24s infinite linear;\n            animation: ball-spin-fade-loader 1s -0.24s infinite linear; }\n  .ball-spin-fade-loader > div:nth-child(8) {\n    top: 17.04545px;\n    left: -17.04545px;\n    -webkit-animation: ball-spin-fade-loader 1s -0.12s infinite linear;\n            animation: ball-spin-fade-loader 1s -0.12s infinite linear; }\n  .ball-spin-fade-loader > div {\n    background-color: #fff;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute; }\n\n@-webkit-keyframes ball-spin-loader {\n  75% {\n    opacity: 0.2; }\n  100% {\n    opacity: 1; } }\n\n@keyframes ball-spin-loader {\n  75% {\n    opacity: 0.2; }\n  100% {\n    opacity: 1; } }\n\n.ball-spin-loader {\n  position: relative; }\n  .ball-spin-loader > span:nth-child(1) {\n    top: 45px;\n    left: 0;\n    -webkit-animation: ball-spin-loader 2s 0.9s infinite linear;\n            animation: ball-spin-loader 2s 0.9s infinite linear; }\n  .ball-spin-loader > span:nth-child(2) {\n    top: 30.68182px;\n    left: 30.68182px;\n    -webkit-animation: ball-spin-loader 2s 1.8s infinite linear;\n            animation: ball-spin-loader 2s 1.8s infinite linear; }\n  .ball-spin-loader > span:nth-child(3) {\n    top: 0;\n    left: 45px;\n    -webkit-animation: ball-spin-loader 2s 2.7s infinite linear;\n            animation: ball-spin-loader 2s 2.7s infinite linear; }\n  .ball-spin-loader > span:nth-child(4) {\n    top: -30.68182px;\n    left: 30.68182px;\n    -webkit-animation: ball-spin-loader 2s 3.6s infinite linear;\n            animation: ball-spin-loader 2s 3.6s infinite linear; }\n  .ball-spin-loader > span:nth-child(5) {\n    top: -45px;\n    left: 0;\n    -webkit-animation: ball-spin-loader 2s 4.5s infinite linear;\n            animation: ball-spin-loader 2s 4.5s infinite linear; }\n  .ball-spin-loader > span:nth-child(6) {\n    top: -30.68182px;\n    left: -30.68182px;\n    -webkit-animation: ball-spin-loader 2s 5.4s infinite linear;\n            animation: ball-spin-loader 2s 5.4s infinite linear; }\n  .ball-spin-loader > span:nth-child(7) {\n    top: 0;\n    left: -45px;\n    -webkit-animation: ball-spin-loader 2s 6.3s infinite linear;\n            animation: ball-spin-loader 2s 6.3s infinite linear; }\n  .ball-spin-loader > span:nth-child(8) {\n    top: 30.68182px;\n    left: -30.68182px;\n    -webkit-animation: ball-spin-loader 2s 7.2s infinite linear;\n            animation: ball-spin-loader 2s 7.2s infinite linear; }\n  .ball-spin-loader > div {\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    background: green; }\n\n@-webkit-keyframes ball-zig {\n  33% {\n    -webkit-transform: translate(-15px, -30px);\n            transform: translate(-15px, -30px); }\n  66% {\n    -webkit-transform: translate(15px, -30px);\n            transform: translate(15px, -30px); }\n  100% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); } }\n\n@keyframes ball-zig {\n  33% {\n    -webkit-transform: translate(-15px, -30px);\n            transform: translate(-15px, -30px); }\n  66% {\n    -webkit-transform: translate(15px, -30px);\n            transform: translate(15px, -30px); }\n  100% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); } }\n\n@-webkit-keyframes ball-zag {\n  33% {\n    -webkit-transform: translate(15px, 30px);\n            transform: translate(15px, 30px); }\n  66% {\n    -webkit-transform: translate(-15px, 30px);\n            transform: translate(-15px, 30px); }\n  100% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); } }\n\n@keyframes ball-zag {\n  33% {\n    -webkit-transform: translate(15px, 30px);\n            transform: translate(15px, 30px); }\n  66% {\n    -webkit-transform: translate(-15px, 30px);\n            transform: translate(-15px, 30px); }\n  100% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); } }\n\n.ball-zig-zag {\n  position: relative;\n  -webkit-transform: translate(-15px, -15px);\n      -ms-transform: translate(-15px, -15px);\n          transform: translate(-15px, -15px); }\n  .ball-zig-zag > div {\n    background-color: #fff;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    margin-left: 15px;\n    top: 4px;\n    left: -7px; }\n    .ball-zig-zag > div:first-child {\n      -webkit-animation: ball-zig 0.7s 0s infinite linear;\n              animation: ball-zig 0.7s 0s infinite linear; }\n    .ball-zig-zag > div:last-child {\n      -webkit-animation: ball-zag 0.7s 0s infinite linear;\n              animation: ball-zag 0.7s 0s infinite linear; }\n\n@-webkit-keyframes ball-zig-deflect {\n  17% {\n    -webkit-transform: translate(-15px, -30px);\n            transform: translate(-15px, -30px); }\n  34% {\n    -webkit-transform: translate(15px, -30px);\n            transform: translate(15px, -30px); }\n  50% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  67% {\n    -webkit-transform: translate(15px, -30px);\n            transform: translate(15px, -30px); }\n  84% {\n    -webkit-transform: translate(-15px, -30px);\n            transform: translate(-15px, -30px); }\n  100% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); } }\n\n@keyframes ball-zig-deflect {\n  17% {\n    -webkit-transform: translate(-15px, -30px);\n            transform: translate(-15px, -30px); }\n  34% {\n    -webkit-transform: translate(15px, -30px);\n            transform: translate(15px, -30px); }\n  50% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  67% {\n    -webkit-transform: translate(15px, -30px);\n            transform: translate(15px, -30px); }\n  84% {\n    -webkit-transform: translate(-15px, -30px);\n            transform: translate(-15px, -30px); }\n  100% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); } }\n\n@-webkit-keyframes ball-zag-deflect {\n  17% {\n    -webkit-transform: translate(15px, 30px);\n            transform: translate(15px, 30px); }\n  34% {\n    -webkit-transform: translate(-15px, 30px);\n            transform: translate(-15px, 30px); }\n  50% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  67% {\n    -webkit-transform: translate(-15px, 30px);\n            transform: translate(-15px, 30px); }\n  84% {\n    -webkit-transform: translate(15px, 30px);\n            transform: translate(15px, 30px); }\n  100% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); } }\n\n@keyframes ball-zag-deflect {\n  17% {\n    -webkit-transform: translate(15px, 30px);\n            transform: translate(15px, 30px); }\n  34% {\n    -webkit-transform: translate(-15px, 30px);\n            transform: translate(-15px, 30px); }\n  50% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); }\n  67% {\n    -webkit-transform: translate(-15px, 30px);\n            transform: translate(-15px, 30px); }\n  84% {\n    -webkit-transform: translate(15px, 30px);\n            transform: translate(15px, 30px); }\n  100% {\n    -webkit-transform: translate(0, 0);\n            transform: translate(0, 0); } }\n\n.ball-zig-zag-deflect {\n  position: relative;\n  -webkit-transform: translate(-15px, -15px);\n      -ms-transform: translate(-15px, -15px);\n          transform: translate(-15px, -15px); }\n  .ball-zig-zag-deflect > div {\n    background-color: #fff;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    margin-left: 15px;\n    top: 4px;\n    left: -7px; }\n    .ball-zig-zag-deflect > div:first-child {\n      -webkit-animation: ball-zig-deflect 1.5s 0s infinite linear;\n              animation: ball-zig-deflect 1.5s 0s infinite linear; }\n    .ball-zig-zag-deflect > div:last-child {\n      -webkit-animation: ball-zag-deflect 1.5s 0s infinite linear;\n              animation: ball-zag-deflect 1.5s 0s infinite linear; }\n\n/**\n * Lines\n */\n@-webkit-keyframes line-scale {\n  0% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); }\n  50% {\n    -webkit-transform: scaley(0.4);\n            transform: scaley(0.4); }\n  100% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); } }\n@keyframes line-scale {\n  0% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); }\n  50% {\n    -webkit-transform: scaley(0.4);\n            transform: scaley(0.4); }\n  100% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); } }\n\n.line-scale > div:nth-child(1) {\n  -webkit-animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: line-scale 1s -0.4s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08); }\n\n.line-scale > div:nth-child(2) {\n  -webkit-animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: line-scale 1s -0.3s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08); }\n\n.line-scale > div:nth-child(3) {\n  -webkit-animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: line-scale 1s -0.2s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08); }\n\n.line-scale > div:nth-child(4) {\n  -webkit-animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: line-scale 1s -0.1s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08); }\n\n.line-scale > div:nth-child(5) {\n  -webkit-animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08);\n          animation: line-scale 1s 0s infinite cubic-bezier(0.2, 0.68, 0.18, 1.08); }\n\n.line-scale > div {\n  background-color: #fff;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block; }\n\n@-webkit-keyframes line-scale-party {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  50% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes line-scale-party {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  50% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n.line-scale-party > div:nth-child(1) {\n  -webkit-animation-delay: -0.09s;\n          animation-delay: -0.09s;\n  -webkit-animation-duration: 0.83s;\n          animation-duration: 0.83s; }\n\n.line-scale-party > div:nth-child(2) {\n  -webkit-animation-delay: 0.33s;\n          animation-delay: 0.33s;\n  -webkit-animation-duration: 0.64s;\n          animation-duration: 0.64s; }\n\n.line-scale-party > div:nth-child(3) {\n  -webkit-animation-delay: 0.32s;\n          animation-delay: 0.32s;\n  -webkit-animation-duration: 0.39s;\n          animation-duration: 0.39s; }\n\n.line-scale-party > div:nth-child(4) {\n  -webkit-animation-delay: 0.47s;\n          animation-delay: 0.47s;\n  -webkit-animation-duration: 0.52s;\n          animation-duration: 0.52s; }\n\n.line-scale-party > div {\n  background-color: #fff;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block;\n  -webkit-animation-name: line-scale-party;\n          animation-name: line-scale-party;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n  -webkit-animation-delay: 0;\n          animation-delay: 0; }\n\n@-webkit-keyframes line-scale-pulse-out {\n  0% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); }\n  50% {\n    -webkit-transform: scaley(0.4);\n            transform: scaley(0.4); }\n  100% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); } }\n\n@keyframes line-scale-pulse-out {\n  0% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); }\n  50% {\n    -webkit-transform: scaley(0.4);\n            transform: scaley(0.4); }\n  100% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); } }\n\n.line-scale-pulse-out > div {\n  background-color: #fff;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block;\n  -webkit-animation: line-scale-pulse-out 0.9s -0.6s infinite cubic-bezier(0.85, 0.25, 0.37, 0.85);\n          animation: line-scale-pulse-out 0.9s -0.6s infinite cubic-bezier(0.85, 0.25, 0.37, 0.85); }\n  .line-scale-pulse-out > div:nth-child(2), .line-scale-pulse-out > div:nth-child(4) {\n    -webkit-animation-delay: -0.4s !important;\n            animation-delay: -0.4s !important; }\n  .line-scale-pulse-out > div:nth-child(1), .line-scale-pulse-out > div:nth-child(5) {\n    -webkit-animation-delay: -0.2s !important;\n            animation-delay: -0.2s !important; }\n\n@-webkit-keyframes line-scale-pulse-out-rapid {\n  0% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); }\n  80% {\n    -webkit-transform: scaley(0.3);\n            transform: scaley(0.3); }\n  90% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); } }\n\n@keyframes line-scale-pulse-out-rapid {\n  0% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); }\n  80% {\n    -webkit-transform: scaley(0.3);\n            transform: scaley(0.3); }\n  90% {\n    -webkit-transform: scaley(1);\n            transform: scaley(1); } }\n\n.line-scale-pulse-out-rapid > div {\n  background-color: #fff;\n  width: 4px;\n  height: 35px;\n  border-radius: 2px;\n  margin: 2px;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  display: inline-block;\n  -webkit-animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78);\n          animation: line-scale-pulse-out-rapid 0.9s -0.5s infinite cubic-bezier(0.11, 0.49, 0.38, 0.78); }\n  .line-scale-pulse-out-rapid > div:nth-child(2), .line-scale-pulse-out-rapid > div:nth-child(4) {\n    -webkit-animation-delay: -0.25s !important;\n            animation-delay: -0.25s !important; }\n  .line-scale-pulse-out-rapid > div:nth-child(1), .line-scale-pulse-out-rapid > div:nth-child(5) {\n    -webkit-animation-delay: 0s !important;\n            animation-delay: 0s !important; }\n\n@-webkit-keyframes line-spin-fade-loader {\n  50% {\n    opacity: 0.3; }\n  100% {\n    opacity: 1; } }\n\n@keyframes line-spin-fade-loader {\n  50% {\n    opacity: 0.3; }\n  100% {\n    opacity: 1; } }\n\n.line-spin-fade-loader {\n  position: relative;\n  top: -10px;\n  left: -4px; }\n  .line-spin-fade-loader > div:nth-child(1) {\n    top: 20px;\n    left: 0;\n    -webkit-animation: line-spin-fade-loader 1.2s -0.84s infinite ease-in-out;\n            animation: line-spin-fade-loader 1.2s -0.84s infinite ease-in-out; }\n  .line-spin-fade-loader > div:nth-child(2) {\n    top: 13.63636px;\n    left: 13.63636px;\n    -webkit-transform: rotate(-45deg);\n        -ms-transform: rotate(-45deg);\n            transform: rotate(-45deg);\n    -webkit-animation: line-spin-fade-loader 1.2s -0.72s infinite ease-in-out;\n            animation: line-spin-fade-loader 1.2s -0.72s infinite ease-in-out; }\n  .line-spin-fade-loader > div:nth-child(3) {\n    top: 0;\n    left: 20px;\n    -webkit-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n            transform: rotate(90deg);\n    -webkit-animation: line-spin-fade-loader 1.2s -0.6s infinite ease-in-out;\n            animation: line-spin-fade-loader 1.2s -0.6s infinite ease-in-out; }\n  .line-spin-fade-loader > div:nth-child(4) {\n    top: -13.63636px;\n    left: 13.63636px;\n    -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n    -webkit-animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out;\n            animation: line-spin-fade-loader 1.2s -0.48s infinite ease-in-out; }\n  .line-spin-fade-loader > div:nth-child(5) {\n    top: -20px;\n    left: 0;\n    -webkit-animation: line-spin-fade-loader 1.2s -0.36s infinite ease-in-out;\n            animation: line-spin-fade-loader 1.2s -0.36s infinite ease-in-out; }\n  .line-spin-fade-loader > div:nth-child(6) {\n    top: -13.63636px;\n    left: -13.63636px;\n    -webkit-transform: rotate(-45deg);\n        -ms-transform: rotate(-45deg);\n            transform: rotate(-45deg);\n    -webkit-animation: line-spin-fade-loader 1.2s -0.24s infinite ease-in-out;\n            animation: line-spin-fade-loader 1.2s -0.24s infinite ease-in-out; }\n  .line-spin-fade-loader > div:nth-child(7) {\n    top: 0;\n    left: -20px;\n    -webkit-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n            transform: rotate(90deg);\n    -webkit-animation: line-spin-fade-loader 1.2s -0.12s infinite ease-in-out;\n            animation: line-spin-fade-loader 1.2s -0.12s infinite ease-in-out; }\n  .line-spin-fade-loader > div:nth-child(8) {\n    top: 13.63636px;\n    left: -13.63636px;\n    -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n            transform: rotate(45deg);\n    -webkit-animation: line-spin-fade-loader 1.2s 0s infinite ease-in-out;\n            animation: line-spin-fade-loader 1.2s 0s infinite ease-in-out; }\n  .line-spin-fade-loader > div {\n    background-color: #fff;\n    width: 4px;\n    height: 35px;\n    border-radius: 2px;\n    margin: 2px;\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    position: absolute;\n    width: 5px;\n    height: 15px; }\n\n/**\n * Misc\n */\n@-webkit-keyframes triangle-skew-spin {\n  25% {\n    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(0);\n            transform: perspective(100px) rotateX(180deg) rotateY(0); }\n  50% {\n    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n            transform: perspective(100px) rotateX(180deg) rotateY(180deg); }\n  75% {\n    -webkit-transform: perspective(100px) rotateX(0) rotateY(180deg);\n            transform: perspective(100px) rotateX(0) rotateY(180deg); }\n  100% {\n    -webkit-transform: perspective(100px) rotateX(0) rotateY(0);\n            transform: perspective(100px) rotateX(0) rotateY(0); } }\n@keyframes triangle-skew-spin {\n  25% {\n    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(0);\n            transform: perspective(100px) rotateX(180deg) rotateY(0); }\n  50% {\n    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n            transform: perspective(100px) rotateX(180deg) rotateY(180deg); }\n  75% {\n    -webkit-transform: perspective(100px) rotateX(0) rotateY(180deg);\n            transform: perspective(100px) rotateX(0) rotateY(180deg); }\n  100% {\n    -webkit-transform: perspective(100px) rotateX(0) rotateY(0);\n            transform: perspective(100px) rotateX(0) rotateY(0); } }\n\n.triangle-skew-spin > div {\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  width: 0;\n  height: 0;\n  border-left: 20px solid transparent;\n  border-right: 20px solid transparent;\n  border-bottom: 20px solid #fff;\n  -webkit-animation: triangle-skew-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n          animation: triangle-skew-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite; }\n\n@-webkit-keyframes square-spin {\n  25% {\n    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(0);\n            transform: perspective(100px) rotateX(180deg) rotateY(0); }\n  50% {\n    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n            transform: perspective(100px) rotateX(180deg) rotateY(180deg); }\n  75% {\n    -webkit-transform: perspective(100px) rotateX(0) rotateY(180deg);\n            transform: perspective(100px) rotateX(0) rotateY(180deg); }\n  100% {\n    -webkit-transform: perspective(100px) rotateX(0) rotateY(0);\n            transform: perspective(100px) rotateX(0) rotateY(0); } }\n\n@keyframes square-spin {\n  25% {\n    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(0);\n            transform: perspective(100px) rotateX(180deg) rotateY(0); }\n  50% {\n    -webkit-transform: perspective(100px) rotateX(180deg) rotateY(180deg);\n            transform: perspective(100px) rotateX(180deg) rotateY(180deg); }\n  75% {\n    -webkit-transform: perspective(100px) rotateX(0) rotateY(180deg);\n            transform: perspective(100px) rotateX(0) rotateY(180deg); }\n  100% {\n    -webkit-transform: perspective(100px) rotateX(0) rotateY(0);\n            transform: perspective(100px) rotateX(0) rotateY(0); } }\n\n.square-spin > div {\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n  width: 50px;\n  height: 50px;\n  background: #fff;\n  border: 1px solid red;\n  -webkit-animation: square-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite;\n          animation: square-spin 3s 0s cubic-bezier(0.09, 0.57, 0.49, 0.9) infinite; }\n\n@-webkit-keyframes rotate_pacman_half_up {\n  0% {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg); }\n  50% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); }\n  100% {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg); } }\n\n@keyframes rotate_pacman_half_up {\n  0% {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg); }\n  50% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); }\n  100% {\n    -webkit-transform: rotate(270deg);\n            transform: rotate(270deg); } }\n\n@-webkit-keyframes rotate_pacman_half_down {\n  0% {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg); }\n  50% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg); } }\n\n@keyframes rotate_pacman_half_down {\n  0% {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg); }\n  50% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg); } }\n\n@-webkit-keyframes pacman-balls {\n  75% {\n    opacity: 0.7; }\n  100% {\n    -webkit-transform: translate(-100px, -6.25px);\n            transform: translate(-100px, -6.25px); } }\n\n@keyframes pacman-balls {\n  75% {\n    opacity: 0.7; }\n  100% {\n    -webkit-transform: translate(-100px, -6.25px);\n            transform: translate(-100px, -6.25px); } }\n\n.pacman {\n  position: relative; }\n  .pacman > div:nth-child(2) {\n    -webkit-animation: pacman-balls 1s -0.99s infinite linear;\n            animation: pacman-balls 1s -0.99s infinite linear; }\n  .pacman > div:nth-child(3) {\n    -webkit-animation: pacman-balls 1s -0.66s infinite linear;\n            animation: pacman-balls 1s -0.66s infinite linear; }\n  .pacman > div:nth-child(4) {\n    -webkit-animation: pacman-balls 1s -0.33s infinite linear;\n            animation: pacman-balls 1s -0.33s infinite linear; }\n  .pacman > div:nth-child(5) {\n    -webkit-animation: pacman-balls 1s 0s infinite linear;\n            animation: pacman-balls 1s 0s infinite linear; }\n  .pacman > div:first-of-type {\n    width: 0px;\n    height: 0px;\n    border-right: 25px solid transparent;\n    border-top: 25px solid #fff;\n    border-left: 25px solid #fff;\n    border-bottom: 25px solid #fff;\n    border-radius: 25px;\n    -webkit-animation: rotate_pacman_half_up 0.5s 0s infinite;\n            animation: rotate_pacman_half_up 0.5s 0s infinite;\n    position: relative;\n    left: -30px; }\n  .pacman > div:nth-child(2) {\n    width: 0px;\n    height: 0px;\n    border-right: 25px solid transparent;\n    border-top: 25px solid #fff;\n    border-left: 25px solid #fff;\n    border-bottom: 25px solid #fff;\n    border-radius: 25px;\n    -webkit-animation: rotate_pacman_half_down 0.5s 0s infinite;\n            animation: rotate_pacman_half_down 0.5s 0s infinite;\n    margin-top: -50px;\n    position: relative;\n    left: -30px; }\n  .pacman > div:nth-child(3),\n  .pacman > div:nth-child(4),\n  .pacman > div:nth-child(5),\n  .pacman > div:nth-child(6) {\n    background-color: #fff;\n    width: 15px;\n    height: 15px;\n    border-radius: 100%;\n    margin: 2px;\n    width: 10px;\n    height: 10px;\n    position: absolute;\n    -webkit-transform: translate(0, -6.25px);\n        -ms-transform: translate(0, -6.25px);\n            transform: translate(0, -6.25px);\n    top: 25px;\n    left: 70px; }\n\n@-webkit-keyframes cube-transition {\n  25% {\n    -webkit-transform: translateX(50px) scale(0.5) rotate(-90deg);\n            transform: translateX(50px) scale(0.5) rotate(-90deg); }\n  50% {\n    -webkit-transform: translate(50px, 50px) rotate(-180deg);\n            transform: translate(50px, 50px) rotate(-180deg); }\n  75% {\n    -webkit-transform: translateY(50px) scale(0.5) rotate(-270deg);\n            transform: translateY(50px) scale(0.5) rotate(-270deg); }\n  100% {\n    -webkit-transform: rotate(-360deg);\n            transform: rotate(-360deg); } }\n\n@keyframes cube-transition {\n  25% {\n    -webkit-transform: translateX(50px) scale(0.5) rotate(-90deg);\n            transform: translateX(50px) scale(0.5) rotate(-90deg); }\n  50% {\n    -webkit-transform: translate(50px, 50px) rotate(-180deg);\n            transform: translate(50px, 50px) rotate(-180deg); }\n  75% {\n    -webkit-transform: translateY(50px) scale(0.5) rotate(-270deg);\n            transform: translateY(50px) scale(0.5) rotate(-270deg); }\n  100% {\n    -webkit-transform: rotate(-360deg);\n            transform: rotate(-360deg); } }\n\n.cube-transition {\n  position: relative;\n  -webkit-transform: translate(-25px, -25px);\n      -ms-transform: translate(-25px, -25px);\n          transform: translate(-25px, -25px); }\n  .cube-transition > div {\n    -webkit-animation-fill-mode: both;\n            animation-fill-mode: both;\n    width: 10px;\n    height: 10px;\n    position: absolute;\n    top: -5px;\n    left: -5px;\n    background-color: #fff;\n    -webkit-animation: cube-transition 1.6s 0s infinite ease-in-out;\n            animation: cube-transition 1.6s 0s infinite ease-in-out; }\n    .cube-transition > div:last-child {\n      -webkit-animation-delay: -0.8s;\n              animation-delay: -0.8s; }\n\n@-webkit-keyframes spin-rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  50% {\n    -webkit-transform: rotate(180deg);\n            transform: rotate(180deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes spin-rotate {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  50% {\n    -webkit-transform: rotate(180deg);\n            transform: rotate(180deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.semi-circle-spin {\n  position: relative;\n  width: 35px;\n  height: 35px;\n  overflow: hidden; }\n  .semi-circle-spin > div {\n    position: absolute;\n    border-width: 0px;\n    border-radius: 100%;\n    -webkit-animation: spin-rotate 0.6s 0s infinite linear;\n            animation: spin-rotate 0.6s 0s infinite linear;\n    background-image: -webkit-linear-gradient(transparent 0%, transparent 70%, #fff 30%, #fff 100%);\n    background-image: linear-gradient(transparent 0%, transparent 70%, #fff 30%, #fff 100%);\n    width: 100%;\n    height: 100%; }\n\n@-webkit-keyframes bar-progress {\n  0% {\n    -webkit-transform: scaleY(20%);\n            transform: scaleY(20%);\n    opacity: 1; }\n  25% {\n    -webkit-transform: translateX(6%) scaleY(10%);\n            transform: translateX(6%) scaleY(10%);\n    opacity: 0.7; }\n  50% {\n    -webkit-transform: translateX(20%) scaleY(20%);\n            transform: translateX(20%) scaleY(20%);\n    opacity: 1; }\n  75% {\n    -webkit-transform: translateX(6%) scaleY(10%);\n            transform: translateX(6%) scaleY(10%);\n    opacity: 0.7; }\n  100% {\n    -webkit-transform: scaleY(20%);\n            transform: scaleY(20%);\n    opacity: 1; } }\n\n@keyframes bar-progress {\n  0% {\n    -webkit-transform: scaleY(20%);\n            transform: scaleY(20%);\n    opacity: 1; }\n  25% {\n    -webkit-transform: translateX(6%) scaleY(10%);\n            transform: translateX(6%) scaleY(10%);\n    opacity: 0.7; }\n  50% {\n    -webkit-transform: translateX(20%) scaleY(20%);\n            transform: translateX(20%) scaleY(20%);\n    opacity: 1; }\n  75% {\n    -webkit-transform: translateX(6%) scaleY(10%);\n            transform: translateX(6%) scaleY(10%);\n    opacity: 0.7; }\n  100% {\n    -webkit-transform: scaleY(20%);\n            transform: scaleY(20%);\n    opacity: 1; } }\n\n.bar-progress {\n  width: 30%;\n  height: 12px; }\n  .bar-progress > div {\n    position: relative;\n    width: 20%;\n    height: 12px;\n    border-radius: 10px;\n    background-color: #fff;\n    -webkit-animation: bar-progress 3s cubic-bezier(0.57, 0.1, 0.44, 0.93) infinite;\n            animation: bar-progress 3s cubic-bezier(0.57, 0.1, 0.44, 0.93) infinite;\n    opacity: 1; }\n\n@-webkit-keyframes bar-swing {\n  0% {\n    left: 0; }\n  50% {\n    left: 70%; }\n  100% {\n    left: 0; } }\n\n@keyframes bar-swing {\n  0% {\n    left: 0; }\n  50% {\n    left: 70%; }\n  100% {\n    left: 0; } }\n\n.bar-swing {\n  width: 30%;\n  height: 8px; }\n  .bar-swing > div {\n    position: relative;\n    width: 30%;\n    height: 8px;\n    border-radius: 10px;\n    background-color: #fff;\n    -webkit-animation: bar-swing 1.5s infinite;\n            animation: bar-swing 1.5s infinite; }\n\n@-webkit-keyframes bar-swing-container {\n  0% {\n    left: 0;\n    -webkit-transform: translateX(0);\n            transform: translateX(0); }\n  50% {\n    left: 70%;\n    -webkit-transform: translateX(-4px);\n            transform: translateX(-4px); }\n  100% {\n    left: 0;\n    -webkit-transform: translateX(0);\n            transform: translateX(0); } }\n\n@keyframes bar-swing-container {\n  0% {\n    left: 0;\n    -webkit-transform: translateX(0);\n            transform: translateX(0); }\n  50% {\n    left: 70%;\n    -webkit-transform: translateX(-4px);\n            transform: translateX(-4px); }\n  100% {\n    left: 0;\n    -webkit-transform: translateX(0);\n            transform: translateX(0); } }\n\n.bar-swing-container {\n  width: 20%;\n  height: 8px;\n  position: relative; }\n  .bar-swing-container div:nth-child(1) {\n    position: absolute;\n    width: 100%;\n    background-color: rgba(255, 255, 255, 0.2);\n    height: 12px;\n    border-radius: 10px; }\n  .bar-swing-container div:nth-child(2) {\n    position: absolute;\n    width: 30%;\n    height: 8px;\n    border-radius: 10px;\n    background-color: #fff;\n    -webkit-animation: bar-swing-container 2s cubic-bezier(0.91, 0.35, 0.12, 0.6) infinite;\n            animation: bar-swing-container 2s cubic-bezier(0.91, 0.35, 0.12, 0.6) infinite;\n    margin: 2px 2px 0; }\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnail_vue_vue_type_style_index_0_id_78a6a4ce_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(210);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnail_vue_vue_type_style_index_0_id_78a6a4ce_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnail_vue_vue_type_style_index_0_id_78a6a4ce_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.thumbnail[data-v-78a6a4ce] {\r\n    border: 1px solid #cccccc;\r\n    cursor: pointer;\r\n    display: block;\r\n    height: 70px;\r\n    margin-top: 10px;\r\n    opacity: 0;\r\n    -webkit-transition: opacity 0.3s;\r\n    -moz-transition: opacity 0.3s;\r\n    -ms-transition: opacity 0.3s;\r\n    -o-transition: opacity 0.3s;\r\n    transition: opacity 0.3s;\r\n    width: 70px;\n}\n.thumbnail.loaded[data-v-78a6a4ce] {\r\n    opacity: 0.7;\n}\nbody.desktop .thumbnail[data-v-78a6a4ce]:first-child {\r\n    margin-left: 0px;\r\n    margin-top: 0px;\n}\n.thumbnail[data-v-78a6a4ce]:hover {\r\n    opacity: 1;\n}\n.thumbnail.active[data-v-78a6a4ce] {\r\n    border-color: #000000;\r\n    opacity: 1;\n}\nbody.tablet .thumbnail[data-v-78a6a4ce],\r\nbody.mobile .thumbnail[data-v-78a6a4ce] {\r\n    display: inline-block;\r\n    height: 50px;\r\n    margin: 0px auto 0px 7px;\r\n    width: 50px;\n}\nbody.tablet .thumbnail[data-v-78a6a4ce]:first-child,\r\nbody.mobile .thumbnail[data-v-78a6a4ce]:first-child {\r\n    margin-left: 0px;\r\n    margin-top: 0px;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ask_vue_vue_type_style_index_0_id_619b262f_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(216);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ask_vue_vue_type_style_index_0_id_619b262f_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_ask_vue_vue_type_style_index_0_id_619b262f_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.ask[data-v-619b262f] {\r\n    position: absolute;\r\n    z-index: 11;\n}\n.ask .message[data-v-619b262f] {\r\n    color: #0d0d0d;\r\n    font-size: 15px;\r\n    line-height: 22px;\r\n    margin: 28px 0px 28px 0px;\n}\n.ask .modal[data-v-619b262f]  .modal-container {\r\n    max-width: 100%;\r\n    min-width: 520px;\n}\n.ask .buttons-container[data-v-619b262f] {\r\n    font-size: 0px;\r\n    margin-top: 15px;\n}\n.ask .buttons-container > .buttons > .button[data-v-619b262f] {\r\n    margin: 0px 12px 0px 12px;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./key-backspace.svg": 658
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 657;

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMyIgaGVpZ2h0PSIyOSIgdmlld0JveD0iMCAwIDMzIDI5Ij48cGF0aCBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgZD0iTTMxLjY5MyA3Ljk0M2EuNzg2Ljc4NiAwIDAwLS40NTMtLjEyNUgyMC4wNjlWMS41OTJjMCAuMDg3LS4wMjguMDU4LS4xMzMuMDI1LS4zMzEtLjA5LS41OTctLjA1Ny0uNzU0LjA1NkwxLjEzMiAxNC42NTdsMTcuOTggMTIuOTRjLjIxMy4xMjcuNTc0LjE3Ny43OS4xMS4xNC0uMDQyLjE2Ny0uMDcxLjE2Ny4wMTV2LTYuMjI2aDExLjE3YS43ODYuNzg2IDAgMDAuNDU0LS4xMjRWNy45NDN6bTAgMTMuNDI5Yy4wMS0uMDAyIDAgLjAyNSAwIC4wOHYtLjA4em0wLTEzLjQyOXYtLjA4YzAgLjA1NC4wMS4wODEgMCAuMDh6Ii8+PC9zdmc+"

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_keyboard_vue_vue_type_style_index_0_id_1f741d86_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(219);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_keyboard_vue_vue_type_style_index_0_id_1f741d86_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_keyboard_vue_vue_type_style_index_0_id_1f741d86_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.keyboard[data-v-1f741d86] {\r\n    background-color: #f5f5f5;\r\n    border-radius: 20px 20px 20px 20px;\r\n    margin-bottom: 30px;\r\n    padding: 20px 20px 20px 20px;\r\n    text-align: center;\n}\nbody.tablet .keyboard[data-v-1f741d86],\r\nbody.mobile .keyboard[data-v-1f741d86] {\r\n    border: none;\r\n    padding: 0px;\n}\n.keyboard .keyboard-row[data-v-1f741d86] {\r\n    font-size: 0px;\r\n    margin-bottom: 8px;\n}\n.keyboard .keyboard-row[data-v-1f741d86]:last-child {\r\n    margin-bottom: 0px;\n}\n.keyboard .keyboard-row .keyboard-key[data-v-1f741d86] {\r\n    background-color: #e5e5e5;\r\n    border-radius: 4px 4px 4px 4px;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    font-size: 28px;\r\n    height: 60px;\r\n    margin-right: 8px;\r\n    user-select: none;\r\n    vertical-align: top;\r\n    width: 50px;\n}\nbody.tablet .keyboard .keyboard-row .keyboard-key[data-v-1f741d86] {\r\n    font-size: 20px;\r\n    height: 35px;\r\n    margin-right: 6px;\r\n    width: 35px;\n}\nbody.mobile .keyboard .keyboard-row .keyboard-key[data-v-1f741d86] {\r\n    font-size: 17px;\r\n    height: 30px;\r\n    margin-right: 4px;\r\n    width: 30px;\n}\n.keyboard .keyboard-row .keyboard-key[data-v-1f741d86]:last-child {\r\n    margin-right: 0px;\n}\n.keyboard .keyboard-row .keyboard-key[data-v-1f741d86]:active {\r\n    background-color: #a5a5a5;\n}\n.keyboard .keyboard-row .keyboard-key.alphanumeric[data-v-1f741d86] {\r\n    line-height: 60px;\n}\nbody.tablet .keyboard .keyboard-row .keyboard-key.alphanumeric[data-v-1f741d86] {\r\n    line-height: 35px;\n}\nbody.mobile .keyboard .keyboard-row .keyboard-key.alphanumeric[data-v-1f741d86] {\r\n    line-height: 30px;\n}\nbody.tablet .keyboard .keyboard-row .keyboard-key.special[data-v-1f741d86],\r\nbody.mobile .keyboard .keyboard-row .keyboard-key.special[data-v-1f741d86] {\r\n    box-sizing: border-box;\r\n    padding: 5px 0px 5px 0px;\n}\n.keyboard .keyboard-row .keyboard-key.backspace[data-v-1f741d86] {\r\n    width: 80px;\n}\nbody.tablet .keyboard .keyboard-row .keyboard-key.backspace[data-v-1f741d86],\r\nbody.mobile .keyboard .keyboard-row .keyboard-key.backspace[data-v-1f741d86] {\r\n    width: 40px;\n}\n.keyboard .keyboard-row .keyboard-key .image-container[data-v-1f741d86] {\r\n    height: 100%;\n}\n.keyboard .keyboard-row .keyboard-key img[data-v-1f741d86] {\r\n    height: 100%;\r\n    object-fit: scale-down;\r\n    width: auto;\n}\n.keyboard .keyboard-row .keyboard-key .label[data-v-1f741d86] {\r\n    font-size: 15px;\r\n    margin: 0px 0px 0px 0px;\r\n    text-transform: none;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDI0IDI0IiBhcmlhLWxhYmVsbGVkYnk9ImNsb3NlSWNvblRpdGxlIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgZmlsbD0ibm9uZSIgY29sb3I9IiNmZmYiPjxwYXRoIGQ9Ik02LjM0MyA2LjM0M2wxMS4zMTQgMTEuMzE0bS0xMS4zMTQgMEwxNy42NTcgNi4zNDMiLz48L3N2Zz4="

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_style_index_0_id_16085a82_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(221);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_style_index_0_id_16085a82_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_modal_vue_vue_type_style_index_0_id_16085a82_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.modal[data-v-16085a82] {\r\n    align-items: center;\r\n    bottom: 0px;\r\n    display: flex;\r\n    justify-content: center;\r\n    left: 0px;\r\n    line-height: initial;\r\n    opacity: 1;\r\n    position: fixed;\r\n    right: 0px;\r\n    text-align: center;\r\n    top: 0px;\r\n    transition: opacity 0.125s ease-in-out;\r\n    z-index: 10;\n}\n.modal.fade-enter[data-v-16085a82],\r\n.modal.fade-leave-to[data-v-16085a82] {\r\n    opacity: 0;\n}\n.modal.fade-leave-active[data-v-16085a82] {\r\n    transition-delay: 0.25s;\n}\n.modal.fade-enter-to[data-v-16085a82] {\r\n    opacity: 1;\n}\n.modal > .modal-overlay[data-v-16085a82] {\r\n    background-color: rgba(0, 0, 0, 0.5);\r\n    height: 100%;\r\n    left: 0px;\r\n    position: absolute;\r\n    top: 0px;\r\n    width: 100%;\n}\n.modal > .modal-container[data-v-16085a82] {\r\n    background-color: #ffffff;\r\n    border-radius: 4px 4px 4px 4px;\r\n    box-shadow: 0px 0px 12px #2d2d2d;\r\n    display: inline-block;\r\n    max-height: 95%;\r\n    overflow-y: auto;\r\n    padding: 0px 40px 0px 40px;\r\n    transition: opacity 0.25s ease-out, transform 0.2s ease-out;\r\n    z-index: 1;\n}\nbody.tablet .modal > .modal-container[data-v-16085a82],\r\nbody.mobile .modal > .modal-container[data-v-16085a82] {\r\n    box-sizing: border-box;\r\n    max-height: 98%;\r\n    max-width: 100%;\r\n    padding: 0px 20px 0px 20px;\n}\n.modal.fade-enter > .modal-container[data-v-16085a82] {\r\n    opacity: 0;\r\n    transform: translateY(5%);\n}\n.modal.fade-enter-to > .modal-container[data-v-16085a82] {\r\n    opacity: 1;\r\n    transform: translateY(0%);\n}\n.modal.fade-leave-active > .modal-container[data-v-16085a82] {\r\n    transition: opacity 0.15s ease-out, transform 0.1s ease-out;\n}\n.modal.fade-leave-to > .modal-container[data-v-16085a82] {\r\n    opacity: 0;\r\n    transform: scale(0.97);\n}\n.modal > .modal-container[data-v-16085a82] > :nth-child(2) {\r\n    padding-top: 40px;\n}\nbody.tablet .modal > .modal-container[data-v-16085a82] > :nth-child(2),\r\nbody.mobile .modal > .modal-container[data-v-16085a82] > :nth-child(2) {\r\n    padding-top: 20px;\n}\n.modal > .modal-container[data-v-16085a82] > :last-child {\r\n    padding-bottom: 40px;\n}\nbody.tablet .modal > .modal-container[data-v-16085a82] > :last-child,\r\nbody.mobile .modal > .modal-container[data-v-16085a82] > :last-child {\r\n    padding-bottom: 20px;\n}\n.modal > .modal-container > .modal-header[data-v-16085a82] {\r\n    margin-left: -40px;\r\n    position: fixed;\r\n    z-index: 1;\n}\nbody.tablet .modal > .modal-container > .modal-header[data-v-16085a82],\r\nbody.mobile .modal > .modal-container > .modal-header[data-v-16085a82] {\r\n    margin-left: -20px;\n}\n.modal > .modal-container > .modal-header > .button.button-close[data-v-16085a82] {\r\n    background-color: #000000;\r\n    color: #ffffff;\r\n    cursor: pointer;\r\n    display: none;\r\n    margin: auto;\r\n    padding: 5px 23px 5px 23px;\r\n    text-align: left;\n}\n.modal > .modal-container > .modal-header > .button.button-close > img[data-v-16085a82] {\r\n    height: 25px;\r\n    margin: auto;\r\n    vertical-align: middle;\r\n    width: 25px;\n}\nbody.mobile .modal > .modal-container > .modal-header > .button.button-close img[data-v-16085a82] {\r\n    height: 15px;\r\n    width: 15px;\n}\n.modal > .modal-container > .modal-content[data-v-16085a82]  > .title,\r\n.modal > .modal-container > .modal-content[data-v-16085a82]  > div > .title,\r\n.modal > .modal-container > .modal-content[data-v-16085a82]  > div > div > .title {\r\n    color: #272a2f;\r\n    font-size: 30px;\r\n    font-weight: normal;\r\n    margin: 0px 0px 10px 0px;\n}\nbody.mobile .modal > .modal-container > .modal-content[data-v-16085a82]  > .title,\r\nbody.mobile .modal > .modal-container > .modal-content[data-v-16085a82]  > div > .title,\r\nbody.mobile .modal > .modal-container > .modal-content[data-v-16085a82]  > div > div > .title {\r\n    font-size: 15px;\n}\n.modal > .modal-container > .modal-content[data-v-16085a82]  > .subtitle,\r\n.modal > .modal-container > .modal-content[data-v-16085a82]  > div > .subtitle,\r\n.modal > .modal-container > .modal-content[data-v-16085a82]  > div > div > .subtitle {\r\n    color: #272a2f;\r\n    font-size: 15px;\r\n    margin: 0px 0px 0px 0px;\n}\n.modal > .modal-container > .modal-content[data-v-16085a82]  .buttons-container {\r\n    text-align: right;\n}\n.modal > .modal-container > .modal-content[data-v-16085a82]  .buttons-container > .button {\r\n    display: inline-block;\r\n    font-size: 20px;\r\n    height: 48px;\r\n    line-height: 48px;\r\n    text-align: center;\n}\n.modal > .modal-container > .modal-content[data-v-16085a82]  .buttons-container > .button.button-cancel {\r\n    color: #9b9b9b;\r\n    margin-right: 20px;\r\n    padding: 0px 20px 0px 20px;\r\n    transition: color 0.25s ease-in-out;\n}\n.modal > .modal-container > .modal-content[data-v-16085a82]  .buttons-container > .button.button-cancel:hover,\r\n.modal > .modal-container > .modal-content[data-v-16085a82]  .buttons-container > .button.button-cancel:active {\r\n    color: #000000;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_restrictions_alert_vue_vue_type_style_index_0_id_42620411_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(223);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_restrictions_alert_vue_vue_type_style_index_0_id_42620411_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_restrictions_alert_vue_vue_type_style_index_0_id_42620411_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.restrictions-alert .message-restrictions-alert-container[data-v-42620411] {\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    overflow: hidden;\n}\n.restrictions-alert .message-restrictions-alert-container .message-restrictions-alert[data-v-42620411] {\r\n    align-items: center;\r\n    display: flex;\r\n    flex-direction: row-reverse;\r\n    justify-content: center;\r\n    padding: 10px 20px 10px 30px;\r\n    text-align: left;\r\n    z-index: 2;\n}\nbody.mobile .restrictions-alert .message-restrictions-alert-container .message-restrictions-alert[data-v-42620411],\r\nbody.tablet .restrictions-alert .message-restrictions-alert-container .message-restrictions-alert[data-v-42620411] {\r\n    flex-direction: column-reverse;\r\n    max-width: 70%;\n}\n.restrictions-alert .message-restrictions-alert .button-container[data-v-42620411] {\r\n    display: flex;\r\n    flex-direction: row;\n}\nbody.tablet .restrictions-alert .message-restrictions-alert .button-container[data-v-42620411],\r\nbody.mobile .restrictions-alert .message-restrictions-alert .button-container[data-v-42620411] {\r\n    justify-content: flex-end;\r\n    width: 100%;\n}\n.restrictions-alert .message-restrictions-alert-container .message-restrictions-alert .button[data-v-42620411] {\r\n    align-items: center;\r\n    border: none;\r\n    cursor: pointer;\r\n    display: flex;\r\n    float: right;\r\n    font-weight: 600;\r\n    margin-left: 20px;\r\n    padding: 10px 10px 10px 10px;\r\n    text-decoration: underline;\r\n    user-select: none;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_tab_vue_vue_type_style_index_0_id_ff34e8b0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(225);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_tab_vue_vue_type_style_index_0_id_ff34e8b0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_tab_vue_vue_type_style_index_0_id_ff34e8b0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.tab[data-v-ff34e8b0] {\r\n    background-color: transparent;\r\n    border: 1px solid transparent;\r\n    border-top-left-radius: 8px;\r\n    border-top-right-radius: 8px;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    font-size: 15px;\r\n    height: 100%;\r\n    line-height: 100px;\r\n    padding: 0px 20px 0px 20px;\r\n    transition: background-color 0.125s ease-in-out;\r\n    vertical-align: top;\n}\n.tab.active[data-v-ff34e8b0] {\r\n    background-color: #ffffff;\r\n    border-color: #e9eaee #e9eaee transparent #e9eaee;\n}\n.tab > h1.default[data-v-ff34e8b0] {\r\n    font-size: 15px;\r\n    text-transform: uppercase;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_style_index_0_id_42df1f38_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(227);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_style_index_0_id_42df1f38_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_tabs_vue_vue_type_style_index_0_id_42df1f38_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.tabs[data-v-42df1f38] {\r\n    border-radius: 20px 20px 20px 20px;\r\n    height: 100px;\r\n    position: relative;\n}\n.tabs > .background[data-v-42df1f38] {\r\n    background-color: #f5f5f5;\r\n    border-bottom: 1px solid #e9eaee;\r\n    border-top-left-radius: 8px;\r\n    border-top-right-radius: 8px;\r\n    height: 92%;\r\n    left: 0px;\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 5px;\n}\n.tabs > .tabs-container[data-v-42df1f38] {\r\n    font-size: 0px;\r\n    margin: 0px 0px 0px 0px;\r\n    overflow-x: auto;\r\n    overflow-y: hidden;\r\n    position: relative;\r\n    white-space: nowrap;\n}\n.tabs > .tabs-container[data-v-42df1f38]::-webkit-scrollbar {\r\n    background: transparent;\r\n    height: 0px;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_groups_vue_vue_type_style_index_0_id_02de563a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(230);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_groups_vue_vue_type_style_index_0_id_02de563a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_sass_loader_dist_cjs_js_node_modules_vue_loader_lib_index_js_vue_loader_options_thumbnails_groups_vue_vue_type_style_index_0_id_02de563a_lang_scss_scoped_true___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".thumbnails.thumbnails-groups[data-v-02de563a]  .initials-image{display:block;height:initial}", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 672 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNTQzIiBoZWlnaHQ9Ijc3IiB2aWV3Qm94PSIwIDAgNTQzIDc3Ij48ZGVmcz48ZWxsaXBzZSBpZD0iYiIgY3g9IjEwLjIwOCIgY3k9IjQuMjc4IiByeD0iMTAuMjA4IiByeT0iNC4yNzgiLz48ZWxsaXBzZSBpZD0iZCIgY3g9IjUxMy43OTIiIGN5PSI0LjI3OCIgcng9IjEwLjIwOCIgcnk9IjQuMjc4Ii8+PGZpbHRlciBpZD0iYSIgd2lkdGg9IjI5NS45JSIgaGVpZ2h0PSI1NjcuNSUiIHg9Ii05OCUiIHk9Ii0xMTYuOSUiIGZpbHRlclVuaXRzPSJvYmplY3RCb3VuZGluZ0JveCI+PGZlT2Zmc2V0IGR5PSIxMCIgaW49IlNvdXJjZUFscGhhIiByZXN1bHQ9InNoYWRvd09mZnNldE91dGVyMSIvPjxmZUdhdXNzaWFuQmx1ciBpbj0ic2hhZG93T2Zmc2V0T3V0ZXIxIiByZXN1bHQ9InNoYWRvd0JsdXJPdXRlcjEiIHN0ZERldmlhdGlvbj0iNSIvPjxmZUNvbG9yTWF0cml4IGluPSJzaGFkb3dCbHVyT3V0ZXIxIiB2YWx1ZXM9IjAgMCAwIDAgMC45MDU3MTIxODMgMCAwIDAgMCAwLjkwNTcxMjE4MyAwIDAgMCAwIDAuOTA1NzEyMTgzIDAgMCAwIDEgMCIvPjwvZmlsdGVyPjxmaWx0ZXIgaWQ9ImMiIHdpZHRoPSIyOTUuOSUiIGhlaWdodD0iNTY3LjUlIiB4PSItOTglIiB5PSItMTE2LjklIiBmaWx0ZXJVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giPjxmZU9mZnNldCBkeT0iMTAiIGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiLz48ZmVHYXVzc2lhbkJsdXIgaW49InNoYWRvd09mZnNldE91dGVyMSIgcmVzdWx0PSJzaGFkb3dCbHVyT3V0ZXIxIiBzdGREZXZpYXRpb249IjUiLz48ZmVDb2xvck1hdHJpeCBpbj0ic2hhZG93Qmx1ck91dGVyMSIgdmFsdWVzPSIwIDAgMCAwIDAuOTA1ODgyMzUzIDAgMCAwIDAgMC45MDU4ODIzNTMgMCAwIDAgMCAwLjkwNTg4MjM1MyAwIDAgMCAxIDAiLz48L2ZpbHRlcj48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5KSI+PGVsbGlwc2UgY3g9IjI2MiIgY3k9IjY5LjMiIGZpbGw9IiNFRUVFRUYiIHJ4PSIxNy4wMTMiIHJ5PSI3LjciLz48dXNlIGZpbGw9IiMwMDAiIGZpbHRlcj0idXJsKCNhKSIgeGxpbms6aHJlZj0iI2IiLz48dXNlIGZpbGw9IiNFRUVFRUYiIHhsaW5rOmhyZWY9IiNiIi8+PHVzZSBmaWxsPSIjMDAwIiBmaWx0ZXI9InVybCgjYykiIHhsaW5rOmhyZWY9IiNkIi8+PHVzZSBmaWxsPSIjRUVFRUVGIiB4bGluazpocmVmPSIjZCIvPjxwYXRoIHN0cm9rZT0iI0VFRUVFRiIgc3Ryb2tlLXdpZHRoPSIxLjciIGQ9Ik01MTAuNjQxIDQuOTQyQzQ4Ni42MDIgMjguODk4IDM5Ny42NTggNjkuMyAyNTguNTk3IDY5LjMgMTY1Ljg5IDY5LjMgODIuMDA3IDQ3Ljg0NyA2Ljk1IDQuOTQyIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_configurator_vue_vue_type_style_index_0_id_3b4fbbc5_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(232);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_configurator_vue_vue_type_style_index_0_id_3b4fbbc5_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_configurator_vue_vue_type_style_index_0_id_3b4fbbc5_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.configurator-wrapper[data-v-3b4fbbc5] {\r\n    position: relative;\r\n    text-align: center;\r\n    transition: opacity 0.125s ease-in;\n}\n.configurator-wrapper.loading[data-v-3b4fbbc5] {\r\n    opacity: 0;\n}\n.configurator-wrapper .configurator[data-v-3b4fbbc5] {\r\n    cursor: grab;\n}\n.configurator-wrapper .configurator[data-frames=\"1\"][data-v-3b4fbbc5] {\r\n    cursor: default;\n}\n.configurator-wrapper .configurator.drag[data-v-3b4fbbc5] {\r\n    cursor: grabbing;\n}\n.configurator-wrapper .configurator.drag[data-frames=\"1\"][data-v-3b4fbbc5] {\r\n    cursor: default;\n}\n.configurator-wrapper .configurator.highlight[data-v-3b4fbbc5] {\r\n    cursor: pointer;\n}\n.configurator-wrapper .configurator.loading[data-v-3b4fbbc5],\r\n.configurator-wrapper .configurator.preloading[data-v-3b4fbbc5],\r\n.configurator-wrapper .configurator[data-v-3b4fbbc5]:not(.ready) {\r\n    cursor: progress;\n}\n.configurator-wrapper.loading-error .configurator[data-v-3b4fbbc5] {\r\n    cursor: default;\n}\n.loader-container > *[data-v-3b4fbbc5] {\r\n    left: calc(50%);\r\n    position: absolute;\r\n    top: calc(50%);\n}\n.holder[data-v-3b4fbbc5] {\r\n    bottom: 5px;\r\n    pointer-events: none;\r\n    position: absolute;\r\n    width: 100%;\n}\n.holder.disappear[data-v-3b4fbbc5] {\r\n    opacity: 0;\r\n    transition: opacity 1s ease;\n}\n.holder-image[data-v-3b4fbbc5] {\r\n    height: 77px;\r\n    max-width: 100%;\n}\n.holder-second-label[data-v-3b4fbbc5] {\r\n    color: #afafaf;\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    letter-spacing: 2px;\r\n    text-transform: uppercase;\n}\n.holder-label[data-v-3b4fbbc5] {\r\n    color: #afafaf;\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    letter-spacing: 2px;\r\n    margin-bottom: -55px;\r\n    text-transform: uppercase;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_personalization_vue_vue_type_style_index_0_id_776050ee_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(234);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_personalization_vue_vue_type_style_index_0_id_776050ee_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_personalization_vue_vue_type_style_index_0_id_776050ee_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.personalization[data-v-776050ee] {\r\n    display: inline-block;\r\n    text-align: center;\n}\n.personalization.disabled[data-v-776050ee] {\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n    pointer-events: none;\n}\n.personalization > .button-personalization > .button-text[data-v-776050ee] {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\n}\n.personalization[data-v-776050ee]  .tabs {\r\n    height: 70px;\n}\n.personalization[data-v-776050ee]  .tabs .tab {\r\n    line-height: 54px;\n}\n.personalization[data-v-776050ee]  .keyboard.text {\r\n    padding: 20px 70px 20px 70px;\n}\nbody.tablet .personalization[data-v-776050ee]  .keyboard.text,\r\nbody.mobile .personalization[data-v-776050ee]  .keyboard.text {\r\n    padding: 20px 0px 20px 0px;\n}\n.personalization[data-v-776050ee]  .keyboard.special {\r\n    padding: 40px 40px 44px 40px;\n}\n.personalization[data-v-776050ee]  .keyboard.special .keyboard-row .keyboard-key {\r\n    background-color: transparent;\r\n    display: inline-block;\r\n    height: auto;\r\n    margin-right: 40px;\r\n    user-select: none;\r\n    width: 72px;\n}\n.personalization[data-v-776050ee]  .keyboard.special .keyboard-row .keyboard-key:last-child {\r\n    margin-right: 0px;\n}\n.personalization[data-v-776050ee]  .keyboard.special .keyboard-row .keyboard-key.special .image-container {\r\n    border-radius: 50%;\r\n    height: 64px;\r\n    margin: 0px auto 14px auto;\r\n    overflow: hidden;\r\n    position: relative;\r\n    width: 64px;\n}\n.personalization[data-v-776050ee]  .keyboard.special .keyboard-row .keyboard-key.special .image-container img {\r\n    border-radius: 50%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n    width: 100%;\n}\n.personalization[data-v-776050ee]  .keyboard.special .keyboard-row .keyboard-key.special .image-container .border {\r\n    border: 2px solid #eaeaec;\r\n    border-radius: 50%;\r\n    height: calc(100% - 4px);\r\n    left: 0px;\r\n    position: absolute;\r\n    top: 0px;\r\n    transition: all 0.125s ease-in-out;\r\n    width: calc(100% - 4px);\n}\n.personalization[data-v-776050ee]  .keyboard.special .keyboard-row .keyboard-key.special.active .image-container .border {\r\n    border-color: #ffffff;\r\n    height: calc(100% - 10px);\r\n    left: 3px;\r\n    top: 3px;\r\n    width: calc(100% - 10px);\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_pickers_vue_vue_type_style_index_0_id_096292b2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(236);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_pickers_vue_vue_type_style_index_0_id_096292b2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_pickers_vue_vue_type_style_index_0_id_096292b2_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
var ___CSS_LOADER_GET_URL_IMPORT___ = __webpack_require__(679);
var ___CSS_LOADER_URL_IMPORT_0___ = __webpack_require__(680);
var ___CSS_LOADER_URL_IMPORT_1___ = __webpack_require__(681);
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.i, "\n.pickers > .parts-wrapper[data-v-096292b2] {\r\n    position: relative;\n}\n.pickers .parts-container > .part[data-v-096292b2] {\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    vertical-align: top;\n}\n.pickers .parts-container > .part.button-part.disabled[data-v-096292b2] {\r\n    opacity: 0.4;\r\n    pointer-events: none;\n}\n.pickers .parts-container > .part > .swatch[data-v-096292b2] {\r\n    border-radius: 50% 50% 50% 50%;\r\n    height: 22px;\r\n    overflow: hidden;\r\n    width: 22px;\n}\n.pickers .parts-container > .part > .swatch > img[data-v-096292b2] {\r\n    height: 100%;\r\n    object-fit: cover;\r\n    vertical-align: top;\r\n    width: 100%;\n}\n.pickers .parts-container > .part > .no-part[data-v-096292b2] {\r\n    color: #4d545f;\r\n    line-height: 18px;\r\n    margin: 0px 0px 0px 0px;\n}\n.colors-wrapper[data-v-096292b2] {\r\n    position: relative;\n}\n.pickers .colors-container[data-v-096292b2] {\r\n    padding: 0px 0px 0px 0px;\n}\n.pickers .colors-container > span[data-v-096292b2] {\r\n    display: block;\r\n    height: 100%;\r\n    padding: 0px 20px 0px 20px;\r\n    white-space: nowrap;\n}\n.pickers .colors-container > span[data-v-096292b2]::-webkit-scrollbar {\r\n    background: transparent;\r\n    height: 0px;\n}\n.pickers .colors-container .color[data-v-096292b2] {\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    opacity: 1;\r\n    position: relative;\r\n    transition: opacity 0.1s ease-in-out;\r\n    user-select: none;\r\n    vertical-align: top;\r\n    width: 100px;\n}\n.pickers .materials-wrapper[data-v-096292b2] {\r\n    position: relative;\n}\n.pickers .materials-wrapper .materials-container.hidden[data-v-096292b2] {\r\n    display: none;\n}\n.pickers.multiple-materials .colors-container .color[data-index=\"0\"][data-v-096292b2] {\r\n    border-left: 1px solid #eaeaec;\r\n    box-sizing: border-box;\r\n    margin-left: 18px;\r\n    padding-left: 36px;\r\n    width: 118px;\n}\n.pickers.multiple-materials .colors-container .color[data-index=\"0\"][data-v-096292b2]:first-child {\r\n    border-left-color: transparent;\r\n    margin-left: 0px;\r\n    padding: 0px 0px 0px 0px;\r\n    width: 100px;\n}\n.pickers .colors-container .color.list-enter-active[data-v-096292b2] {\r\n    opacity: 0;\r\n    position: absolute;\n}\n.pickers .colors-container .color.list-leave-active[data-v-096292b2] {\r\n    opacity: 0;\n}\n.pickers .colors-container .color > p[data-v-096292b2] {\r\n    font-size: 14px;\r\n    margin: 100px 0px 0px 0px;\r\n    white-space: normal;\n}\n.pickers.multiple-materials .colors-container .color > p[data-v-096292b2] {\r\n    margin-top: 80px;\n}\n.pickers.multiple-materials .colors-container .color.active > p[data-v-096292b2] {\r\n    font-weight: 600;\n}\n.pickers.multiple-materials .colors-container .color[data-index=\"0\"] > p[data-v-096292b2] {\r\n    margin-left: -18px;\n}\n.pickers.multiple-materials .colors-container .color[data-index=\"0\"]:first-child > p[data-v-096292b2] {\r\n    margin-left: 0px;\n}\n.pickers .colors-container .color > .swatch[data-v-096292b2] {\r\n    border: 2px solid #eaeaec;\r\n    border-radius: 50% 50% 50% 50%;\r\n    height: 58px;\r\n    left: 0px;\r\n    margin: 20px auto 0px auto;\r\n    overflow: hidden;\r\n    padding: 0px 0px 0px 0px;\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 0px;\r\n    transform: scale(1, 1) translateZ(0);\r\n    transition: transform 0.125s ease-in-out, border-width 0.125s ease-in-out;\r\n    width: 58px;\r\n    z-index: 1;\n}\n.pickers.multiple-materials .colors-container .color > .swatch[data-v-096292b2] {\r\n    margin-top: 0px;\n}\n.pickers.multiple-materials .colors-container .color[data-index=\"0\"] > .swatch[data-v-096292b2] {\r\n    left: 18px;\n}\n.pickers.multiple-materials .colors-container .color:first-child > .swatch[data-v-096292b2] {\r\n    left: 0px;\n}\n.pickers .colors-container .color:hover > .swatch[data-v-096292b2],\r\n.pickers .colors-container .color.active > .swatch[data-v-096292b2] {\r\n    border-width: 0px;\r\n    transform: scale(1.13, 1.13);\n}\n.pickers .colors-container .color.active.no-option > .swatch[data-v-096292b2] {\r\n    border-width: 2px;\n}\n.pickers .colors-container .color > .swatch > img[data-v-096292b2] {\r\n    height: 100%;\r\n    object-fit: cover;\r\n    width: 100%;\n}\n.pickers .colors-container .color > .swatch > .border[data-v-096292b2] {\r\n    border: 0px solid #ffffff;\r\n    border-radius: 50% 50% 50% 50%;\r\n    bottom: 3px;\r\n    left: 3px;\r\n    position: absolute;\r\n    right: 3px;\r\n    top: 3px;\r\n    transition: border-width 0.125s ease-in-out;\n}\n.pickers .colors-container .color:hover > .swatch > .border[data-v-096292b2],\r\n.pickers .colors-container .color.active > .swatch > .border[data-v-096292b2] {\r\n    border-width: 4px;\n}\n.button-scroll[data-v-096292b2] {\r\n    cursor: pointer;\r\n    position: absolute;\r\n    width: 40px;\r\n    z-index: 1;\n}\n.button-scroll-right[data-v-096292b2] {\r\n    background: url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") right center no-repeat,\r\n        linear-gradient(to left, #fafafa, rgba(255, 255, 255, 0));\r\n    right: 0px;\r\n    top: 0px;\n}\n.button-scroll-left[data-v-096292b2] {\r\n    background: url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") left center no-repeat,\r\n        linear-gradient(to right, #fafafa, rgba(255, 255, 255, 0));\n}\n.button-scroll-parts[data-v-096292b2] {\r\n    height: 42px;\n}\n.button-scroll-materials[data-v-096292b2] {\r\n    background-color: transparent;\r\n    height: 30px;\n}\n.button-scroll-right.button-scroll-materials[data-v-096292b2] {\r\n    background: linear-gradient(to left, #fafafa, rgba(255, 255, 255, 0)) right center no-repeat;\n}\n.button-scroll-left.button-scroll-materials[data-v-096292b2] {\r\n    background: linear-gradient(to right, #fafafa, rgba(255, 255, 255, 0)) left center no-repeat;\n}\nbody.mobile .button-scroll-materials[data-v-096292b2] {\r\n    height: 65px;\r\n    width: 57px;\n}\n.button-scroll-colors[data-v-096292b2] {\r\n    height: 100px;\n}\n.button-scroll-colors-left[data-v-096292b2] {\r\n    left: 0px;\n}\nbody.tablet .button-scroll-colors[data-v-096292b2],\r\nbody.mobile .button-scroll-colors[data-v-096292b2] {\r\n    height: 100px;\r\n    width: 50px;\n}\n.restrictions_alert .message-restrictions_alert-container .message-restrictions_alert.visible[data-v-096292b2] {\r\n    left: 0px;\r\n    max-width: 55%;\r\n    position: absolute;\r\n    right: 0px;\r\n    top: 90px;\r\n    transform: translateY(0px);\r\n    z-index: 2;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (url, options) {
  if (!options) {
    // eslint-disable-next-line no-param-reassign
    options = {};
  } // eslint-disable-next-line no-underscore-dangle, no-param-reassign


  url = url && url.__esModule ? url.default : url;

  if (typeof url !== 'string') {
    return url;
  } // If url is already wrapped in quotes, remove them


  if (/^['"].*['"]$/.test(url)) {
    // eslint-disable-next-line no-param-reassign
    url = url.slice(1, -1);
  }

  if (options.hash) {
    // eslint-disable-next-line no-param-reassign
    url += options.hash;
  } // Should url be wrapped?
  // See https://drafts.csswg.org/css-values-3/#urls


  if (/["'() \t\n]/.test(url) || options.needQuotes) {
    return "\"".concat(url.replace(/"/g, '\\"').replace(/\n/g, '\\n'), "\"");
  }

  return url;
};

/***/ }),
/* 680 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBhcmlhLWxhYmVsbGVkYnk9ImNoZXZyb25SaWdodEljb25UaXRsZSIgc3Ryb2tlPSJncmF5IiBzdHJva2Utd2lkdGg9IjMiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIGZpbGw9Im5vbmUiIGNvbG9yPSJncmF5Ij48cGF0aCBkPSJNMTAgNmw2IDYtNiA2aDAiLz48L3N2Zz4="

/***/ }),
/* 681 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDI0IDI0IiBhcmlhLWxhYmVsbGVkYnk9ImNoZXZyb25MZWZ0SWNvblRpdGxlIiBzdHJva2U9ImdyYXkiIHN0cm9rZS13aWR0aD0iMyIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgZmlsbD0ibm9uZSIgY29sb3I9ImdyYXkiPjxwYXRoIGQ9Ik0xNCAxOGwtNi02IDYtNmgwIi8+PC9zdmc+"

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_size_vue_vue_type_style_index_0_id_0f4bb5a0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(238);
/* harmony import */ var _node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_size_vue_vue_type_style_index_0_id_0f4bb5a0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_cjs_js_node_modules_css_loader_dist_cjs_js_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_vue_loader_lib_index_js_vue_loader_options_size_vue_vue_type_style_index_0_id_0f4bb5a0_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(11);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, "\n.size.disabled[data-v-0f4bb5a0] {\r\n    background-color: transparent;\r\n    border-color: transparent;\r\n    pointer-events: none;\n}\n.size .modal.modal-size .modal-container[data-v-0f4bb5a0] {\r\n    padding: 40px 80px 40px 80px;\n}\r\n", ""]);
// Exports
module.exports = exports;


/***/ })
/******/ ]);
});
//# sourceMappingURL=ripe-commons-pluginus.min.js.map?625f95ee77a7ded94f22